export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any };
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string };
  /** Multipart upload for files */
  File: { input: any; output: any };
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any };
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: {
    input: Record<string, string | number | boolean | string[] | undefined>;
    output: Record<string, string | number | boolean | string[] | undefined>;
  };
  /** A local date string (i.e., with no associated timezone) in `YYYY-MM-DD` format, e.g. `2020-01-01`. */
  LocalDate: { input: string; output: string };
  /** A local time string (i.e., with no associated timezone) in 24-hr `HH:mm[:ss[.SSS]]` format, e.g. `14:25` or `14:25:06` or `14:25:06.123`. */
  LocalTime: { input: string; output: string };
  /** NestedJSONObject custom scalar type */
  NestedJSONObject: {
    input: Record<
      string,
      | string
      | number
      | boolean
      | string[]
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined
    >;
    output: Record<
      string,
      | string
      | number
      | boolean
      | string[]
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined
    >;
  };
  /** A scalar that supports string, number, boolean, string array, or null */
  Value: { input: any; output: any };
};

export type AiConversationObject = {
  __typename?: "AIConversationObject";
  conversationType: AiConversationType;
  createdAt: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  lastAIMessage?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of AIConversationObject */
export type AiConversationObjectPaginated = {
  __typename?: "AIConversationObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<AiConversationObject>>;
};

export type AiConversationSessionFileObject = {
  __typename?: "AIConversationSessionFileObject";
  file: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
};

export type AiConversationSessionFileSignedUrlPayload = {
  __typename?: "AIConversationSessionFileSignedUrlPayload";
  file: Scalars["String"]["output"];
  key: Scalars["String"]["output"];
  signedUrl: Scalars["String"]["output"];
};

export type AiConversationSessionFilesPayload = {
  __typename?: "AIConversationSessionFilesPayload";
  files: Array<AiConversationSessionFileObject>;
};

export enum AiConversationType {
  DATA_COACH = "DATA_COACH",
  SMS_PARTNER_SELECTION = "SMS_PARTNER_SELECTION",
}

export type AcceptAccessControlInviteInput = {
  code: Scalars["String"]["input"];
};

export type AcceptInvitationForAccessControlPayload = {
  __typename?: "AcceptInvitationForAccessControlPayload";
  targetEntityName?: Maybe<Scalars["String"]["output"]>;
  targetId?: Maybe<Scalars["String"]["output"]>;
  user?: Maybe<UserObject>;
};

export type AccessControlInviteInput = {
  accessRole: AccessRole;
  email?: InputMaybe<Scalars["String"]["input"]>;
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  partyId?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type AccessControlInvitePayload = {
  __typename?: "AccessControlInvitePayload";
  invitation?: Maybe<InvitationObject>;
};

export type AccessControlObject = {
  __typename?: "AccessControlObject";
  accessRole: AccessRole;
  accessUser: UserObject;
  id: Scalars["String"]["output"];
};

/** Paginated results of AccessControlObject */
export type AccessControlObjectPaginated = {
  __typename?: "AccessControlObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<AccessControlObject>>;
};

export type AccessControlsListFilters = {
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  partyId?: InputMaybe<Scalars["String"]["input"]>;
};

export enum AccessRole {
  ADMIN = "ADMIN",
  CO_OWNER = "CO_OWNER",
  MEMBER = "MEMBER",
  OWNER = "OWNER",
  READ_ONLY = "READ_ONLY",
}

export type ActivityObject = {
  __typename?: "ActivityObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  listing?: Maybe<ListingObject>;
  metadata: Scalars["NestedJSONObject"]["output"];
  type: ActivityType;
  user?: Maybe<PublicUserObject>;
};

export enum ActivityType {
  ANNOUNCEMENT = "ANNOUNCEMENT",
  COMPARABLES_UPDATE = "COMPARABLES_UPDATE",
  DOCUMENT_UPDATE = "DOCUMENT_UPDATE",
  LISTING_DOCUMENT_DOWNLOADED = "LISTING_DOCUMENT_DOWNLOADED",
  LISTING_DOCUMENT_VIEWED = "LISTING_DOCUMENT_VIEWED",
  OFFER_SUBMITTED = "OFFER_SUBMITTED",
  PREFERENCE_UPDATE = "PREFERENCE_UPDATE",
  STOREFRONT_USER_SUBSCRIBED = "STOREFRONT_USER_SUBSCRIBED",
  STOREFRONT_USER_UNSUBSCRIBED = "STOREFRONT_USER_UNSUBSCRIBED",
  SYSTEM_UPDATE = "SYSTEM_UPDATE",
}

export type AddInsuranceAgentContactInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  partnerId: Scalars["ID"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddLoanOfficerContactInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  loanOfficerConfig?: InputMaybe<LoanOfficerContactConfigInput>;
  partnerId: Scalars["ID"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddOrUpdateDisclosureContractDocumentsInput = {
  contractDocuments: Array<ContractDocumentFileInput>;
  contractId: Scalars["ID"]["input"];
  shouldDetectFormFields?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AddOrUpdatePreapprovalContractDocumentInput = {
  contractDocument: ContractDocumentFileInput;
  contractId: Scalars["ID"]["input"];
};

export type AddTitleAgentContactInput = {
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  partnerId: Scalars["ID"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type AddressInput = {
  city: Scalars["String"]["input"];
  state: UsState;
  /** e.g. 123 Main St */
  streetAddress: Scalars["String"]["input"];
  unit?: InputMaybe<Scalars["String"]["input"]>;
  zipCode: Scalars["String"]["input"];
};

export type AddressObject = {
  __typename?: "AddressObject";
  city: Scalars["String"]["output"];
  state: UsState;
  /** e.g. 123 Main St */
  streetAddress: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  zipCode: Scalars["String"]["output"];
};

export type AdjustedComp = {
  __typename?: "AdjustedComp";
  address: Scalars["String"]["output"];
  adjustmentReason: Scalars["String"]["output"];
  closePrice: Scalars["Int"]["output"];
  finalAdjustedPrice: Scalars["Int"]["output"];
};

export type AgentContingencyOfferRec = {
  __typename?: "AgentContingencyOfferRec";
  notes?: Maybe<Scalars["String"]["output"]>;
  type: ContingencyType;
  value?: Maybe<Scalars["Boolean"]["output"]>;
};

export type AgentContingencyOfferRecInput = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  type: ContingencyType;
  value?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type AgentKeyTermsOfferRec = {
  __typename?: "AgentKeyTermsOfferRec";
  notes?: Maybe<Scalars["String"]["output"]>;
  type: KeyTermType;
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type AgentKeyTermsOfferRecInput = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  type: KeyTermType;
  value?: InputMaybe<Scalars["Float"]["input"]>;
};

export type AgentObject = {
  __typename?: "AgentObject";
  fullName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  inboundEmail: Scalars["String"]["output"];
  user?: Maybe<UserObject>;
};

export type AgentOfferRecsInput = {
  competitivenessAdjustment?: InputMaybe<CompetitivenessAdjustmentInput>;
  contingencies?: InputMaybe<Array<AgentContingencyOfferRecInput>>;
  keyTerms?: InputMaybe<Array<AgentKeyTermsOfferRecInput>>;
};

export type AgentOfferRecsPayload = {
  __typename?: "AgentOfferRecsPayload";
  competitivenessAdjustment?: Maybe<CompetitivenessAdjustment>;
  contingencies?: Maybe<Array<AgentContingencyOfferRec>>;
  keyTerms?: Maybe<Array<AgentKeyTermsOfferRec>>;
};

export type AgentParticipant = {
  __typename?: "AgentParticipant";
  email?: Maybe<Scalars["String"]["output"]>;
  mlsAgentId?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  officeId?: Maybe<Scalars["String"]["output"]>;
  officeName?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type AgentPerformanceFilters = {
  intervalDays: Scalars["Int"]["input"];
  priceMax: Scalars["Int"]["input"];
  priceMin: Scalars["Int"]["input"];
  zipCodes: Array<Scalars["String"]["input"]>;
};

export type AllListingActivitiesForCurrentUserPayload = {
  __typename?: "AllListingActivitiesForCurrentUserPayload";
  hasNext: Scalars["Boolean"]["output"];
  results: Array<ActivityObject>;
};

export type AllMlSesPayload = {
  __typename?: "AllMLSesPayload";
  mls: Array<MlsObject>;
};

export type AnalyzeForOfferIngestionJobInput = {
  s3Bucket: Scalars["String"]["input"];
  s3Key: Scalars["String"]["input"];
  skipClassifyCache: Scalars["Boolean"]["input"];
};

export type AppEventObject = {
  __typename?: "AppEventObject";
  createdAt: Scalars["DateTime"]["output"];
  doneBy?: Maybe<UserObject>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  offer?: Maybe<OfferObject>;
};

export type AssetFileObject = {
  __typename?: "AssetFileObject";
  file: FileObject;
  id: Scalars["ID"]["output"];
  ordering: Scalars["Int"]["output"];
};

export type AuditEssentialsNotificationsFilters = {
  ingestionFolderUuid: Scalars["ID"]["input"];
  organizationUuid: Scalars["ID"]["input"];
};

export type AuditEssentialsNotificationsObject = {
  __typename?: "AuditEssentialsNotificationsObject";
  aiConversationUuid: Scalars["String"]["output"];
  auditSnapshot: Scalars["JSONObject"]["output"];
  eventType: Scalars["String"]["output"];
  ingestionFolderUuid: Scalars["String"]["output"];
  notificationLogUuid: Scalars["String"]["output"];
  notificationTemplateUuid: Scalars["String"]["output"];
  occurredAt: Scalars["String"]["output"];
  organizationPartnerUuid: Scalars["String"]["output"];
  organizationUuid: Scalars["String"]["output"];
  pausedNotificationLogUuids: Array<Scalars["String"]["output"]>;
  stage: Scalars["String"]["output"];
  twilioConversationSid: Scalars["String"]["output"];
};

export type AutofillAgentCompensationObject = {
  __typename?: "AutofillAgentCompensationObject";
  flatFee?: Maybe<Scalars["Float"]["output"]>;
  isListingFirmPaying?: Maybe<Scalars["Boolean"]["output"]>;
  isSellerPaying?: Maybe<Scalars["Boolean"]["output"]>;
  percentOfGrossSalesPrice?: Maybe<Scalars["Float"]["output"]>;
};

export type AutofillConsumerObject = {
  __typename?: "AutofillConsumerObject";
  email?: Maybe<Scalars["String"]["output"]>;
  entityName?: Maybe<Scalars["String"]["output"]>;
  entityTitle?: Maybe<Scalars["String"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  isEntity?: Maybe<Scalars["Boolean"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type AutofillListingObject = {
  __typename?: "AutofillListingObject";
  streetAddressFull?: Maybe<Scalars["String"]["output"]>;
  zipcode?: Maybe<Scalars["String"]["output"]>;
};

export type AutofillObject = {
  __typename?: "AutofillObject";
  documentVersionField?: Maybe<FieldObject>;
  documents?: Maybe<Array<DocumentCompactObject>>;
  field?: Maybe<FieldObject>;
  formula?: Maybe<Scalars["String"]["output"]>;
  formulaTestCases: Array<FormulaTestCaseObject>;
  formulaVariableFields: Array<VariableFieldObject>;
  helpTextDocumentVersionField?: Maybe<FieldObject>;
  helpTextField?: Maybe<FieldObject>;
  id: Scalars["ID"]["output"];
  optionsDocumentVersionField?: Maybe<FieldObject>;
  optionsField?: Maybe<FieldObject>;
  rule?: Maybe<RuleObject>;
  variableField?: Maybe<VariableFieldObject>;
  variableSources: Array<VariableSource>;
};

export type AutofillSaleObject = {
  __typename?: "AutofillSaleObject";
  assessorParcelNumber?: Maybe<Scalars["String"]["output"]>;
  closedDate?: Maybe<Scalars["String"]["output"]>;
  deedBook?: Maybe<Scalars["String"]["output"]>;
  deedPage?: Maybe<Scalars["String"]["output"]>;
  salePrice?: Maybe<Scalars["Float"]["output"]>;
};

export type BasePagePrediction = {
  __typename?: "BasePagePrediction";
  containment?: Maybe<Scalars["Float"]["output"]>;
  documentCategory?: Maybe<DocumentCategory>;
  documentType?: Maybe<DocumentType>;
  formName: Scalars["String"]["output"];
  formOrVersionMatch?: Maybe<Scalars["JSONObject"]["output"]>;
  humanLabeled?: Maybe<Scalars["Boolean"]["output"]>;
  pageNumber: Scalars["Float"]["output"];
  score: Scalars["Float"]["output"];
  searchRegex?: Maybe<Scalars["String"]["output"]>;
  usState: UsState;
  version?: Maybe<Scalars["String"]["output"]>;
};

export type BasePagePredictionInput = {
  containment?: InputMaybe<Scalars["Float"]["input"]>;
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType?: InputMaybe<DocumentType>;
  formName: Scalars["String"]["input"];
  formOrVersionMatch?: InputMaybe<Scalars["JSONObject"]["input"]>;
  humanLabeled?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageNumber: Scalars["Float"]["input"];
  score: Scalars["Float"]["input"];
  searchRegex?: InputMaybe<Scalars["String"]["input"]>;
  usState: UsState;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type BatchValidationRerunResult = {
  __typename?: "BatchValidationRerunResult";
  message?: Maybe<Scalars["String"]["output"]>;
  queuedCount: Scalars["Int"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type BboxFilterInput = {
  bottomRight: PointInput;
  topLeft: PointInput;
};

export type BizOverviewOfferObject = {
  __typename?: "BizOverviewOfferObject";
  agent?: Maybe<OfferAgentObject>;
  buyerNames: Array<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  property: OfferPropertyObject;
  purchasePrice: Scalars["Float"]["output"];
  status: BusinessOverviewOfferStatus;
};

/** Paginated results of BizOverviewOfferObject */
export type BizOverviewOfferObjectPaginated = {
  __typename?: "BizOverviewOfferObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<BizOverviewOfferObject>>;
};

export type BoundingBoxObject = {
  __typename?: "BoundingBoxObject";
  bottom: Scalars["Float"]["output"];
  left: Scalars["Float"]["output"];
  right: Scalars["Float"]["output"];
  top: Scalars["Float"]["output"];
};

export enum BusinessOverviewMetric {
  OFFERS_ACCEPTED = "OFFERS_ACCEPTED",
  OFFERS_CLOSED = "OFFERS_CLOSED",
  OFFERS_OUT = "OFFERS_OUT",
  OFFER_SCORECARDS = "OFFER_SCORECARDS",
  SIGNED_AGENCY_AGREEMENTS = "SIGNED_AGENCY_AGREEMENTS",
}

export type BusinessOverviewMetricValue = {
  __typename?: "BusinessOverviewMetricValue";
  from: Scalars["LocalDate"]["output"];
  to: Scalars["LocalDate"]["output"];
  value: Scalars["Float"]["output"];
};

export type BusinessOverviewOfferDetailsPayload = {
  __typename?: "BusinessOverviewOfferDetailsPayload";
  /** Offer metadata information */
  metadata: GetOfferMetadataObject;
  offerToPurchaseUrl: Scalars["String"]["output"];
};

export enum BusinessOverviewOfferStatus {
  ACCEPTED = "ACCEPTED",
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
}

export enum BusinessOverviewOfferStatusFilter {
  OFFERS_ACCEPTED = "OFFERS_ACCEPTED",
  OFFERS_OUT = "OFFERS_OUT",
}

export type BusinessOverviewOffersFilterInput = {
  period: BusinessOverviewPeriod;
  /** If not provided, all offers will be returned */
  status?: InputMaybe<BusinessOverviewOfferStatusFilter>;
};

export enum BusinessOverviewPeriod {
  THIS_MONTH = "THIS_MONTH",
  THIS_WEEK = "THIS_WEEK",
}

export type BusinessOverviewStat = {
  __typename?: "BusinessOverviewStat";
  chart: ChartData;
  current: BusinessOverviewMetricValue;
  estimatedDealValue?: Maybe<Scalars["Float"]["output"]>;
  metric: BusinessOverviewMetric;
  previous: BusinessOverviewMetricValue;
};

export type BusinessOverviewStatsInput = {
  period: BusinessOverviewPeriod;
};

export type BusinessOverviewStatsPayload = {
  __typename?: "BusinessOverviewStatsPayload";
  stats: Array<BusinessOverviewStat>;
};

export type BuyerInfoInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  entityName?: InputMaybe<Scalars["String"]["input"]>;
  entityTitle?: InputMaybe<Scalars["String"]["input"]>;
  fullName: Scalars["String"]["input"];
  isEntity?: Scalars["Boolean"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type BuyerOfferAnalysisObject = {
  __typename?: "BuyerOfferAnalysisObject";
  agentNotes?: Maybe<Scalars["String"]["output"]>;
  agentOfferRecs?: Maybe<AgentOfferRecsPayload>;
  buyersAgent?: Maybe<AgentObject>;
  createdAt: Scalars["DateTime"]["output"];
  hideOfferScore?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  indigoOfferRecs?: Maybe<OfferRecsPayload>;
  isShared?: Maybe<Scalars["Boolean"]["output"]>;
  listing?: Maybe<ListingObject>;
  offerScore?: Maybe<OfferScoreResult>;
  party?: Maybe<PartyObject>;
  prevAgentOfferRecs?: Maybe<AgentOfferRecsPayload>;
  title?: Maybe<Scalars["String"]["output"]>;
};

/** Paginated results of BuyerOfferAnalysisObject */
export type BuyerOfferAnalysisObjectofferScorecardsForAgentPaginated = {
  __typename?: "BuyerOfferAnalysisObjectofferScorecardsForAgentPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<BuyerOfferAnalysisObject>>;
};

/** Paginated results of BuyerOfferAnalysisObject */
export type BuyerOfferAnalysisObjectofferScorecardsForOrgPaginated = {
  __typename?: "BuyerOfferAnalysisObjectofferScorecardsForOrgPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<BuyerOfferAnalysisObject>>;
};

export type CandidateDocumentCategory = {
  __typename?: "CandidateDocumentCategory";
  documentCategory: DocumentCategory;
  score: Scalars["Float"]["output"];
};

export type CandidateDocumentCategoryInput = {
  documentCategory: DocumentCategory;
  score: Scalars["Float"]["input"];
};

export type CapturePropertyDetailsInput = {
  address: AddressInput;
  areaSqFt: Scalars["Float"]["input"];
  bathsFull: Scalars["Int"]["input"];
  bathsHalf?: InputMaybe<Scalars["Int"]["input"]>;
  bedrooms: Scalars["Int"]["input"];
  coords: PointInput;
  propertySubtype: MlsListingSubType;
  propertyType: MlsListingType;
  schoolDistrict?: InputMaybe<Scalars["String"]["input"]>;
  subdivision?: InputMaybe<Scalars["String"]["input"]>;
  targetPrice: Scalars["Float"]["input"];
  yearBuilt: Scalars["Int"]["input"];
};

export type CapturePropertyDetailsPayload = {
  __typename?: "CapturePropertyDetailsPayload";
  propertyDetails?: Maybe<PropertyDetailsObject>;
  success: Scalars["Boolean"]["output"];
};

export type ChartCard = {
  __typename?: "ChartCard";
  chart?: Maybe<ChartData>;
  title: Scalars["String"]["output"];
};

export type ChartData = {
  __typename?: "ChartData";
  data: Array<ChartDataPoint>;
  labelUnit: ChartUnit;
  mainMetric: ChartMetric;
  styleConfig: ChartStyleConfig;
  title: Scalars["String"]["output"];
  type: ListingReportChartType;
  valueUnit: ChartUnit;
  verticalReferenceLine?: Maybe<ChartDataPoint>;
};

export type ChartDataPoint = {
  __typename?: "ChartDataPoint";
  label: Scalars["String"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type ChartMetric = {
  __typename?: "ChartMetric";
  description: Scalars["String"]["output"];
  trend?: Maybe<ChartTrend>;
  unit: ChartUnit;
  value?: Maybe<Scalars["Float"]["output"]>;
};

export type ChartStyleConfig = {
  __typename?: "ChartStyleConfig";
  showLegend: Scalars["Boolean"]["output"];
};

export type ChartTrend = {
  __typename?: "ChartTrend";
  period: Scalars["String"]["output"];
  value?: Maybe<Scalars["Float"]["output"]>;
};

export enum ChartUnit {
  DAYS = "DAYS",
  PERCENT = "PERCENT",
  STRING = "STRING",
  USD = "USD",
}

export type CheckDocumentVersionDuplicateInput = {
  documentId: Scalars["ID"]["input"];
  file: Scalars["File"]["input"];
};

export type CheckDocumentVersionDuplicatePayload = {
  __typename?: "CheckDocumentVersionDuplicatePayload";
  duplicates: Array<DocumentVersionDuplicateObject>;
};

export type CheckPermissionInput = {
  args: Scalars["String"]["input"];
  rule: Scalars["String"]["input"];
};

export type CheckSignatureInitialDatasetExistsInput = {
  documentMLId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  pageNumbers: Array<Scalars["Float"]["input"]>;
};

export type CheckSignatureInitialDatasetExistsPayload = {
  __typename?: "CheckSignatureInitialDatasetExistsPayload";
  results: Array<SignatureInitialDatasetExistsPayload>;
};

export enum CheckboxCropImagesDestination {
  TRAIN = "TRAIN",
  VALIDATIONS = "VALIDATIONS",
}

export type CheckboxDatasetFilePayload = {
  __typename?: "CheckboxDatasetFilePayload";
  key: Scalars["String"]["output"];
};

export type CheckboxDatasetFilesPayload = {
  __typename?: "CheckboxDatasetFilesPayload";
  files: Array<CheckboxDatasetFilePayload>;
};

export type CheckboxDatasetSignedUrlsInput = {
  keys: Array<Scalars["String"]["input"]>;
};

export enum ClassificationMethod {
  EMBEDDING = "EMBEDDING",
  LLM = "LLM",
  LLM_EMBEDDING = "LLM_EMBEDDING",
  MODEL = "MODEL",
}

export type ClearOfferGroupTerminationInput = {
  offerGroupId: Scalars["ID"]["input"];
};

export type ClearOfferGroupTerminationPayload = {
  __typename?: "ClearOfferGroupTerminationPayload";
  offerGroup: OfferGroupObject;
};

export type ClientParticipant = {
  __typename?: "ClientParticipant";
  email?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export enum ClientType {
  BUYER = "BUYER",
  SELLER = "SELLER",
}

export enum ColumnVisibility {
  PRIVATE = "PRIVATE",
  PUBLIC = "PUBLIC",
  SHARED = "SHARED",
}

export enum ComparisonType {
  HIGHEST = "HIGHEST",
  LOWEST = "LOWEST",
}

export type CompetitivenessAdjustment = {
  __typename?: "CompetitivenessAdjustment";
  adjustedLevel: CompetitivenessLevel;
  reason: Scalars["String"]["output"];
};

export type CompetitivenessAdjustmentInput = {
  adjustedLevel: CompetitivenessLevel;
  reason: Scalars["String"]["input"];
};

export enum CompetitivenessLevel {
  COMPETITIVE = "COMPETITIVE",
  NOT_COMPETITIVE = "NOT_COMPETITIVE",
  NOT_COMPETITIVE_AT_ALL = "NOT_COMPETITIVE_AT_ALL",
  UNKNOWN = "UNKNOWN",
  VERY_COMPETITIVE = "VERY_COMPETITIVE",
}

export type CompetitivenessMetrics = {
  __typename?: "CompetitivenessMetrics";
  bidAsk: Scalars["Float"]["output"];
  bidAskScore: Scalars["Float"]["output"];
  daysOnMarket: Scalars["Float"]["output"];
  daysOnMarketScore: Scalars["Float"]["output"];
  maxMarketBidAskRatio?: Maybe<Scalars["Float"]["output"]>;
  minMarketBidAskRatio?: Maybe<Scalars["Float"]["output"]>;
  priceAnalysis: PriceAnalysis;
};

export type CompetitivenessScore = {
  __typename?: "CompetitivenessScore";
  comps?: Maybe<Array<MlsListingObject>>;
  error?: Maybe<Scalars["String"]["output"]>;
  metrics: CompetitivenessMetrics;
  rating: CompetitivenessLevel;
  score: Scalars["Float"]["output"];
  usedMlsComps: Scalars["Boolean"]["output"];
};

export type ComplianceGroupMetadataObject = {
  __typename?: "ComplianceGroupMetadataObject";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  transactionStageType?: Maybe<TransactionStageType>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type ComplianceGroupTransactionStageObject = {
  __typename?: "ComplianceGroupTransactionStageObject";
  complianceGroupId: Scalars["String"]["output"];
  complianceGroupName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  organizationUuid: Scalars["ID"]["output"];
  transactionStageType: TransactionStageType;
};

export enum ComplianceKeyTermCategory {
  EXTENSION = "EXTENSION",
}

export type ComplianceKeyTermSectionFieldInput = {
  complianceKeyTermSectionId: Scalars["ID"]["input"];
  fieldsToColumnId: Scalars["ID"]["input"];
  helpText?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  order: Scalars["Int"]["input"];
};

export type ComplianceKeyTermSectionFieldObject = {
  __typename?: "ComplianceKeyTermSectionFieldObject";
  fieldsToColumn: FieldsToColumnObject;
  helpText?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
};

export type ComplianceKeyTermSectionListFilters = {
  category?: InputMaybe<ComplianceKeyTermCategory>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  transactionStageId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ComplianceKeyTermSectionObject = {
  __typename?: "ComplianceKeyTermSectionObject";
  category: ComplianceKeyTermCategory;
  complianceKeyTermSectionFields?: Maybe<
    Array<ComplianceKeyTermSectionFieldObject>
  >;
  description: Scalars["String"]["output"];
  documentSectionType: DocumentSectionType;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  organizationUuid?: Maybe<Scalars["ID"]["output"]>;
  parent?: Maybe<ComplianceKeyTermSectionObject>;
  title: Scalars["String"]["output"];
  transactionStage?: Maybe<TransactionStageObject>;
};

/** Paginated results of ComplianceKeyTermSectionObject */
export type ComplianceKeyTermSectionObjectPaginated = {
  __typename?: "ComplianceKeyTermSectionObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ComplianceKeyTermSectionObject>>;
};

export type ComplianceMessageHistoryObject = {
  __typename?: "ComplianceMessageHistoryObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  ingestionFolder?: Maybe<IngestionFolderObject>;
  messageContent: Scalars["String"]["output"];
  recipientType: ComplianceMessageRecipientType;
  recipientValue: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  workflowRunId: Scalars["String"]["output"];
};

export enum ComplianceMessageRecipientType {
  EMAIL = "EMAIL",
  SMS = "SMS",
}

export type CompsSource = {
  __typename?: "CompsSource";
  type: MarketDataSourceType;
};

export enum ConfidenceLevel {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export type ConsumerObject = {
  __typename?: "ConsumerObject";
  email?: Maybe<Scalars["String"]["output"]>;
  entityName?: Maybe<Scalars["String"]["output"]>;
  entityTitle?: Maybe<Scalars["String"]["output"]>;
  fullName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isEntity: Scalars["Boolean"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  profilePicture?: Maybe<FileObject>;
  user?: Maybe<UserObject>;
};

export type ContactFilters = {
  contactType?: InputMaybe<ContactType>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
};

export type ContactObject = {
  __typename?: "ContactObject";
  contactType: ContactType;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  organization?: Maybe<OrganizationObject>;
  partner?: Maybe<OrganizationPartnerObject>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of ContactObject */
export type ContactObjectContactListPaginatedPaginated = {
  __typename?: "ContactObjectContactListPaginatedPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ContactObject>>;
};

export enum ContactType {
  AGENT = "AGENT",
  CLIENT = "CLIENT",
  INSURANCE_AGENT = "INSURANCE_AGENT",
  LOAN_OFFICER = "LOAN_OFFICER",
  PARTNER_ADMIN = "PARTNER_ADMIN",
  TITLE_AGENT = "TITLE_AGENT",
}

export type Contingency = {
  __typename?: "Contingency";
  context: ContingencyRecommendationContext;
  recommendation: Scalars["Boolean"]["output"];
  type: ContingencyType;
};

export type ContingencyError = {
  __typename?: "ContingencyError";
  reason: Scalars["String"]["output"];
  type: ContingencyType;
};

export type ContingencyRecommendationContext = {
  __typename?: "ContingencyRecommendationContext";
  marketData: MarketDataPercentages;
  source: MarketDataSource;
};

export type ContingencyResult = Contingency | ContingencyError;

export enum ContingencyType {
  APPRAISAL = "APPRAISAL",
  FINANCING = "FINANCING",
  HOME_SALE = "HOME_SALE",
  INSPECTION = "INSPECTION",
}

export enum ContractDocumentExclusion {
  TERMINATED = "TERMINATED",
  WITHDRAWN = "WITHDRAWN",
}

export type ContractDocumentFileInput = {
  documentVersionId?: InputMaybe<Scalars["ID"]["input"]>;
  externalContractDocumentName?: InputMaybe<Scalars["String"]["input"]>;
  externalContractDocumentType?: InputMaybe<ExternalDocumentType>;
  file?: InputMaybe<Scalars["File"]["input"]>;
  fileUrl?: InputMaybe<Scalars["String"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  mappingKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  order: Scalars["Int"]["input"];
};

export type ContractDocumentInput = {
  documentVersionId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  order: Scalars["Int"]["input"];
};

export type ContractDocumentObject = {
  __typename?: "ContractDocumentObject";
  aiIngestionFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  documentAssetFiles?: Maybe<Array<AssetFileObject>>;
  documentCategory?: Maybe<Scalars["String"]["output"]>;
  documentVersion?: Maybe<DocumentVersionObject>;
  exclusions: Array<ContractDocumentExclusion>;
  externalDocumentName?: Maybe<Scalars["String"]["output"]>;
  externalDocumentType?: Maybe<ExternalDocumentType>;
  fields?: Maybe<Array<DocumentVersionFieldObject>>;
  file: FileObject;
  id: Scalars["ID"]["output"];
  ingestionFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  interpretedFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  interpretedFieldValuesExplanation?: Maybe<Scalars["String"]["output"]>;
  mergedFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  order: Scalars["Int"]["output"];
  userDocumentVersion?: Maybe<UserDocumentVersionObject>;
};

export type ContractEmbeddedSignatureRequestPayload = {
  __typename?: "ContractEmbeddedSignatureRequestPayload";
  contract?: Maybe<ContractObject>;
  embeddedSignUrl?: Maybe<Scalars["String"]["output"]>;
  isExpired: Scalars["Boolean"]["output"];
  primaryDocument?: Maybe<DocumentObject>;
  signatureRequest?: Maybe<SignatureRequestObject>;
  signer?: Maybe<SignatureRequestSignerObject>;
};

export type ContractListFilterArgs = {
  ids?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isInternalTest?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContractObject = {
  __typename?: "ContractObject";
  autofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  contractDocuments: Array<ContractDocumentObject>;
  documentML?: Maybe<DocumentMlObject>;
  enabledSecondaryDocumentVersionsFromRules?: Maybe<
    Array<Scalars["String"]["output"]>
  >;
  extractedValues?: Maybe<Array<ExtractedValues>>;
  fieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  id: Scalars["ID"]["output"];
  isUploaded: Scalars["Boolean"]["output"];
  signatureRequests?: Maybe<Array<SignatureRequestObject>>;
  userId: Scalars["ID"]["output"];
  validations?: Maybe<Array<ContractValidationObject>>;
};

/** Paginated results of ContractObject */
export type ContractObjectPaginated = {
  __typename?: "ContractObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ContractObject>>;
};

export type ContractPayload = {
  __typename?: "ContractPayload";
  contract?: Maybe<ContractObject>;
};

export type ContractSignatureFieldsArgs = {
  buyerSignatures?: InputMaybe<Scalars["Boolean"]["input"]>;
  buyersAgentSignatures?: InputMaybe<Scalars["Boolean"]["input"]>;
  contractId: Scalars["ID"]["input"];
  offerId?: InputMaybe<Scalars["ID"]["input"]>;
  partyId?: InputMaybe<Scalars["ID"]["input"]>;
  sellerSignatures?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ContractSignatureFieldsPayload = {
  __typename?: "ContractSignatureFieldsPayload";
  documentVersionFields: Array<PublicDocumentVersionFieldObject>;
  signatureFormFields: Array<SignatureFormFieldObject>;
};

export type ContractSystemCredentialsInput = {
  password: Scalars["String"]["input"];
  username: Scalars["String"]["input"];
};

export type ContractSystemCredentialsObject = {
  __typename?: "ContractSystemCredentialsObject";
  dotloopProfileId?: Maybe<Scalars["String"]["output"]>;
  dotloopTeamName?: Maybe<Scalars["String"]["output"]>;
  hasInvalidCredentials?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  isHourly?: Maybe<Scalars["Boolean"]["output"]>;
  isLive?: Maybe<Scalars["Boolean"]["output"]>;
  isReady: Scalars["Boolean"]["output"];
  type?: Maybe<ContractSystemType>;
  username?: Maybe<Scalars["String"]["output"]>;
};

export enum ContractSystemType {
  BROKERMINT = "BROKERMINT",
  DOCUSIGN = "DOCUSIGN",
  DOTLOOP = "DOTLOOP",
  SKYSLOPE = "SKYSLOPE",
  ZIPFORM = "ZIPFORM",
}

export type ContractValidationObject = {
  __typename?: "ContractValidationObject";
  documentVersionField: DocumentVersionFieldObject;
  field: FieldObject;
  results: Array<RuleValidationObject>;
};

export type ContractVariableValuesInput = {
  contractId: Scalars["ID"]["input"];
  documentVersionUuid?: InputMaybe<Scalars["ID"]["input"]>;
  state?: InputMaybe<UsState>;
  variableSource: VariableSource;
};

export type ContractVariableValuesPayload = {
  __typename?: "ContractVariableValuesPayload";
  contractId?: Maybe<Scalars["ID"]["output"]>;
  contractVariableValues?: Maybe<Scalars["JSONObject"]["output"]>;
  state?: Maybe<UsState>;
  variableSource?: Maybe<VariableSource>;
};

export type CopyComplianceKeyTermSectionsInput = {
  sourceTransactionStageId: Scalars["ID"]["input"];
  targetTransactionStageId: Scalars["ID"]["input"];
};

export type CopyFieldsFromPreviousVersionInput = {
  documentVersionId: Scalars["ID"]["input"];
  previousDocumentVersionId: Scalars["ID"]["input"];
};

export type CopyTransactionRulesInput = {
  ruleIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  sourceTransactionStageId: Scalars["ID"]["input"];
  targetTransactionStageId: Scalars["ID"]["input"];
};

export type CreateAiConversationInput = {
  conversationType?: InputMaybe<AiConversationType>;
  lastAIMessage?: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateAutofillInput = {
  documentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  documentVersionFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  fieldId?: InputMaybe<Scalars["ID"]["input"]>;
  fieldsToColumnId?: InputMaybe<Scalars["ID"]["input"]>;
  formula?: InputMaybe<Scalars["String"]["input"]>;
  formulaTestCases?: Array<FormulaTestCaseInput>;
  formulaVariableFields?: Array<VariableFieldInput>;
  helpTextDocumentVersionFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  helpTextFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  optionsDocumentVersionFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  optionsFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  ruleId?: InputMaybe<Scalars["ID"]["input"]>;
  variableField?: InputMaybe<VariableFieldInput>;
  variableSources: Array<VariableSource>;
};

export type CreateAutofillPayload = {
  __typename?: "CreateAutofillPayload";
  autofill?: Maybe<AutofillObject>;
};

export type CreateBuyerOfferAnalysisForUserInput = {
  listingId: Scalars["String"]["input"];
  partyId?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["String"]["input"];
};

export type CreateBuyerOfferAnalysisInput = {
  listingId: Scalars["String"]["input"];
  partyId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateClassificationEvalFromIngestionDocumentInput = {
  ingestionDocumentId: Scalars["ID"]["input"];
  ingestionFolderId: Scalars["ID"]["input"];
};

export type CreateComplianceKeyTermSectionInput = {
  category: ComplianceKeyTermCategory;
  description: Scalars["String"]["input"];
  documentSectionType: DocumentSectionType;
  order: Scalars["Int"]["input"];
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
  transactionStageId: Scalars["ID"]["input"];
};

export type CreateComplianceKeyTermSectionPayload = {
  __typename?: "CreateComplianceKeyTermSectionPayload";
  complianceKeyTermSection?: Maybe<ComplianceKeyTermSectionObject>;
};

export type CreateContactInput = {
  contactType: ContactType;
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateContractInput = {
  addKeyTermFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  autofillVariableValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  contractDocuments?: InputMaybe<Array<ContractDocumentFileInput>>;
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  fieldValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  secondaryDocumentTypesToAdd?: InputMaybe<Array<DocumentType>>;
  state?: InputMaybe<UsState>;
};

export type CreateDefaultSecondaryDocumentInput = {
  /** ID for the primary document */
  documentId: Scalars["ID"]["input"];
  mappingKey?: InputMaybe<Scalars["String"]["input"]>;
  /** ID for the secondary document */
  secondaryDocumentId: Scalars["ID"]["input"];
};

export type CreateDocumentInput = {
  autoMapDocumentVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  description: Scalars["String"]["input"];
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType: DocumentType;
  documentVersion?: InputMaybe<UpdateDocumentVersionInput>;
  form: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  subsetOfDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  usState: UsState;
};

export type CreateDocumentPayload = {
  __typename?: "CreateDocumentPayload";
  document?: Maybe<DocumentObject>;
};

export type CreateDocumentSectionInput = {
  description: Scalars["String"]["input"];
  documentId: Scalars["ID"]["input"];
  documentSectionCategory: DocumentSectionCategory;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionModuleType?: InputMaybe<DocumentSectionModuleType>;
  documentSectionType: DocumentSectionType;
  order: Scalars["Int"]["input"];
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type CreateDocumentSectionPayload = {
  __typename?: "CreateDocumentSectionPayload";
  documentSection?: Maybe<DocumentSectionObject>;
};

export type CreateDocumentVersionFieldInput = {
  align: FieldAlign;
  displayLabel?: InputMaybe<Scalars["String"]["input"]>;
  documentVersionId: Scalars["ID"]["input"];
  fieldId: Scalars["ID"]["input"];
  fontFamily: Scalars["String"]["input"];
  fontSize: Scalars["String"]["input"];
  height: Scalars["Float"]["input"];
  inputFormat?: InputMaybe<InputFormatInput>;
  label: Scalars["String"]["input"];
  labelField?: InputMaybe<LabelFieldInput>;
  pageNumber: Scalars["Int"]["input"];
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  width: Scalars["Float"]["input"];
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type CreateDocumentVersionFieldsPayload = {
  __typename?: "CreateDocumentVersionFieldsPayload";
  documentVersionFields: Array<DocumentVersionFieldObject>;
};

export type CreateDocumentVersionInput = {
  documentId: Scalars["ID"]["input"];
  file: Scalars["File"]["input"];
  version: Scalars["String"]["input"];
};

export type CreateDocumentVersionPayload = {
  __typename?: "CreateDocumentVersionPayload";
  documentVersion?: Maybe<DocumentVersionObject>;
};

export type CreateEmbeddedSignatureRequestInput = {
  indigoContractId: Scalars["ID"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  partyId: Scalars["ID"]["input"];
  signatureFormFields?: InputMaybe<Array<SignatureFormFieldInput>>;
  subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateEventForOfferInput = {
  doneByUserId?: InputMaybe<Scalars["String"]["input"]>;
  offerId: Scalars["String"]["input"];
  type: EventTypes;
};

export type CreateFallbackContractInput = {
  contractDocuments?: InputMaybe<Array<ContractDocumentFileInput>>;
};

export type CreateFieldInput = {
  aiExtract?: InputMaybe<Scalars["Boolean"]["input"]>;
  aiInterpret?: InputMaybe<Scalars["Boolean"]["input"]>;
  comparisonType?: InputMaybe<ComparisonType>;
  displayLabel?: InputMaybe<Scalars["String"]["input"]>;
  fieldType: FieldType;
  group: Scalars["String"]["input"];
  inputFormat?: InputMaybe<InputFormatInput>;
  isComputed?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
  mappingKey: Scalars["String"]["input"];
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateFieldPayload = {
  __typename?: "CreateFieldPayload";
  field?: Maybe<FieldObject>;
};

export type CreateIndigoContractInput = {
  documentId: Scalars["String"]["input"];
  documentType: DocumentType;
  fieldValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  partyId: Scalars["ID"]["input"];
};

export type CreateIngestionDocumentValidationFeedbackInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contractDocumentUuid: Scalars["String"]["input"];
  feedbackType: FeedbackType;
  ingestionDocumentValidationId: Scalars["ID"]["input"];
  ruleUuid: Scalars["String"]["input"];
};

export type CreateIngestionFolderValidationFeedbackInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  feedbackType: FeedbackType;
  ingestionFolderValidationId: Scalars["ID"]["input"];
};

export type CreateIntegrationClientInput = {
  additionalConfig?: InputMaybe<Scalars["JSONObject"]["input"]>;
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  clientType: IntegrationClientType;
  isActive: Scalars["Boolean"]["input"];
  logoFile?: InputMaybe<Scalars["String"]["input"]>;
  provider: IntegrationProvider;
  redirectUri?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateNotificationTemplateInput = {
  dataToShare?: InputMaybe<Array<Scalars["String"]["input"]>>;
  delayMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  eventType: TransactionStageType;
  hasAssignedPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  isAttachedToPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  messageContent: Scalars["String"]["input"];
  notificationType: NotificationType;
  partnerId: Scalars["ID"]["input"];
  recipients: Array<ContactType>;
  side: TransactionSide;
  title: Scalars["String"]["input"];
};

export type CreateOfferInput = {
  listingId: Scalars["String"]["input"];
  partyId?: InputMaybe<Scalars["ID"]["input"]>;
  source?: InputMaybe<OfferSource>;
};

export type CreateOfferPayload = {
  __typename?: "CreateOfferPayload";
  offer: OfferObject;
};

export type CreateOpenHouseInput = {
  date: Scalars["LocalDate"]["input"];
  endTime: Scalars["LocalTime"]["input"];
  listingId: Scalars["String"]["input"];
  options?: InputMaybe<OpenHouseCrudOptions>;
  startTime: Scalars["LocalTime"]["input"];
};

export type CreateOpenHousePayload = {
  __typename?: "CreateOpenHousePayload";
  openHouse: OpenHouseObject;
};

export type CreateOrUpdateConsumerByPhoneNumberInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
  profilePictureURL?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateOrUpdateDocumentClassificationEvaluationInput = {
  classification?: InputMaybe<Array<DocumentPagePredictionInput>>;
  expectedCategory?: InputMaybe<DocumentCategory>;
  expectedDocumentType?: InputMaybe<DocumentType>;
  expectedUsState?: InputMaybe<UsState>;
  expectedValues?: InputMaybe<Scalars["JSON"]["input"]>;
  file?: InputMaybe<Scalars["File"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type CreateOrUpdateListingAnnouncementInput = {
  bestAndFinalDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  id?: InputMaybe<Scalars["String"]["input"]>;
  listingId: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  type?: InputMaybe<ListingAnnouncementType>;
};

export type CreateOrUpdateListingComparableAdjustmentInput = {
  adjustments: UpdateListingComparableAdjustments;
  listingComparableSetId: Scalars["String"]["input"];
  mlsListingId: Scalars["String"]["input"];
};

export type CreateOrUpdateListingComparableAdjustmentInputV2 = {
  adjustments: UpdateListingComparableAdjustmentsV2;
  listingComparableSetId: Scalars["String"]["input"];
  mlsListingId: Scalars["String"]["input"];
};

export type CreateOrganizationForAgentPayload = {
  __typename?: "CreateOrganizationForAgentPayload";
  organization: OrganizationObject;
  user: UserObject;
};

export type CreateOrganizationForTeamLeadPayload = {
  __typename?: "CreateOrganizationForTeamLeadPayload";
  organization: OrganizationObject;
  user: UserObject;
};

export type CreateOrganizationInput = {
  name: Scalars["String"]["input"];
};

export type CreateOrganizationPartnerInput = {
  emailDomain?: InputMaybe<Scalars["String"]["input"]>;
  logo?: InputMaybe<Scalars["File"]["input"]>;
  name: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  partnerType: PartnerType;
};

export type CreateOrganizationRosterEntryInput = {
  contactId?: InputMaybe<Scalars["ID"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  isContactable?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  organizationId: Scalars["ID"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreatePartyForBuyersAgentInput = {
  cashReserves?: InputMaybe<Scalars["Float"]["input"]>;
  financingType?: InputMaybe<FinancingType>;
  loanAmount?: InputMaybe<Scalars["Float"]["input"]>;
  percentDownPayment?: InputMaybe<Scalars["Float"]["input"]>;
  preapprovalFile?: InputMaybe<Scalars["File"]["input"]>;
  primaryBuyer: BuyerInfoInput;
  secondaryBuyers?: InputMaybe<Array<BuyerInfoInput>>;
};

export type CreateRuleInput = {
  contextForLLMJudge?: InputMaybe<Scalars["String"]["input"]>;
  errorMessageTemplate?: InputMaybe<Scalars["String"]["input"]>;
  focusFieldMappingKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  isReusable?: InputMaybe<Scalars["Boolean"]["input"]>;
  message: Scalars["String"]["input"];
  ruleType: RuleType;
};

export type CreateRulePayload = {
  __typename?: "CreateRulePayload";
  rule?: Maybe<RuleObject>;
};

export type CreateTransactionPipelineInput = {
  clientType: ClientType;
  transactionPropertyType: TransactionPropertyType;
  usState: UsState;
};

export type CropCheckboxImagesInput = {
  destination: CheckboxCropImagesDestination;
  mappingKeys: Array<Scalars["String"]["input"]>;
  /** S3 prefix to read dataset files from. Defaults to checkbox/local-validations. */
  sourcePrefix?: InputMaybe<Scalars["String"]["input"]>;
};

export type DarwinCompanyOfficeMappingObject = {
  __typename?: "DarwinCompanyOfficeMappingObject";
  createdAt: Scalars["DateTime"]["output"];
  darwinCompanyId: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  officeId: Scalars["String"]["output"];
  organizationUuid: Scalars["String"]["output"];
  platform: IngestionPlatform;
  platformProfileId: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

export type DarwinCompanyPreviewSection = {
  __typename?: "DarwinCompanyPreviewSection";
  candidates: Array<DarwinCompanyValue>;
  currentValue?: Maybe<DarwinCompanyValue>;
  proposedValue?: Maybe<DarwinCompanyValue>;
  resolutionStatus: DarwinCompanyResolutionStatus;
};

/** Resolution status for Darwin company selection */
export enum DarwinCompanyResolutionStatus {
  AMBIGUOUS = "AMBIGUOUS",
  RESOLVED = "RESOLVED",
  UNRESOLVED = "UNRESOLVED",
}

export type DarwinCompanyValue = {
  __typename?: "DarwinCompanyValue";
  companyId: Scalars["Int"]["output"];
  companyName?: Maybe<Scalars["String"]["output"]>;
  officeMlsIds: Array<Scalars["String"]["output"]>;
  officeNames: Array<Scalars["String"]["output"]>;
};

export type DarwinEnvironmentInput = {
  /** Optional Darwin company ID override for sync operations. When provided, this company is used instead of runtime company resolution. */
  darwinCompanyIdOverride?: InputMaybe<Scalars["Int"]["input"]>;
  /** Subset of Darwin property details to sync with classification data. */
  propertyDetailsToSync?: InputMaybe<Array<DarwinPropertyDetailField>>;
  /** If true, sync the computed status to Darwin. Defaults to true. Set to false to skip status sync (e.g., if the folder status is not up to date). */
  syncStatus?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** If true, use Darwin sandbox environment (Indigo admins only) */
  useSandbox?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DarwinFeeSyncInput = {
  /** Type of fee to sync */
  feeType: DarwinFeeType;
  /** Full preview data for audit trail (the DarwinSyncFeeField from preview) */
  previewData: Scalars["JSON"]["input"];
};

export type DarwinFeeSyncResult = {
  __typename?: "DarwinFeeSyncResult";
  /** Action taken: 'updated', 'no_change', or 'skipped' */
  action: Scalars["String"]["output"];
  feeType: DarwinFeeType;
  payer?: Maybe<Scalars["String"]["output"]>;
  skipReason?: Maybe<Scalars["String"]["output"]>;
  syncedAmount?: Maybe<Scalars["Float"]["output"]>;
};

/** Types of fees that can be synced to Darwin */
export enum DarwinFeeType {
  TRANSACTION_MANAGEMENT = "TRANSACTION_MANAGEMENT",
}

export type DarwinParticipantLeadSource = {
  __typename?: "DarwinParticipantLeadSource";
  leadGeneratedByName?: Maybe<Scalars["String"]["output"]>;
  leadSourceName?: Maybe<Scalars["String"]["output"]>;
  sourceOfBusiness?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinParticipantsObject = {
  __typename?: "DarwinParticipantsObject";
  buyers: Array<DarwinPersonObject>;
  buyersAgents: Array<DarwinPersonObject>;
  listingAgents: Array<DarwinPersonObject>;
  sellers: Array<DarwinPersonObject>;
  transactionCoordinators: Array<DarwinPersonWithMatchObject>;
};

export type DarwinParticipantsSection = {
  __typename?: "DarwinParticipantsSection";
  leadSource?: Maybe<DarwinParticipantLeadSource>;
};

export type DarwinPersonCandidate = {
  __typename?: "DarwinPersonCandidate";
  confidence: DarwinPersonMatchConfidence;
  matchScore: Scalars["Float"]["output"];
  personId: Scalars["Int"]["output"];
  personName: Scalars["String"]["output"];
};

/** Change types for person sync operations */
export enum DarwinPersonChangeType {
  ATTACH = "ATTACH",
  CLEAR = "CLEAR",
  /** @deprecated Not supported by backend sync; included in preview only to indicate no match found */
  CREATE_AND_ATTACH = "CREATE_AND_ATTACH",
  NO_CHANGE = "NO_CHANGE",
  SWITCH = "SWITCH",
}

/** Confidence levels for person matching */
export enum DarwinPersonMatchConfidence {
  HIGH = "HIGH",
  LOW = "LOW",
  MEDIUM = "MEDIUM",
}

export type DarwinPersonObject = {
  __typename?: "DarwinPersonObject";
  leadGeneratedBy?: Maybe<Scalars["String"]["output"]>;
  leadSource?: Maybe<Scalars["String"]["output"]>;
  personName: Scalars["String"]["output"];
};

export type DarwinPersonWithMatchObject = {
  __typename?: "DarwinPersonWithMatchObject";
  isMatched: Scalars["Boolean"]["output"];
  personName: Scalars["String"]["output"];
};

export type DarwinPropertyClassificationObject = {
  __typename?: "DarwinPropertyClassificationObject";
  classificationId?: Maybe<Scalars["Int"]["output"]>;
  classificationName?: Maybe<Scalars["String"]["output"]>;
  propertyTypeId?: Maybe<Scalars["Int"]["output"]>;
  propertyTypeName?: Maybe<Scalars["String"]["output"]>;
  typeCode?: Maybe<Scalars["String"]["output"]>;
  typeCodeName?: Maybe<Scalars["String"]["output"]>;
};

/** Darwin property classification fields that can be synced */
export enum DarwinPropertyDetailField {
  CLASSIFICATION = "CLASSIFICATION",
  PROPERTY_TYPE = "PROPERTY_TYPE",
  TYPE_CODE = "TYPE_CODE",
}

export enum DarwinPropertyDetailFieldLabel {
  STATUS = "STATUS",
}

export type DarwinPropertyObject = {
  __typename?: "DarwinPropertyObject";
  city?: Maybe<Scalars["String"]["output"]>;
  classificationId?: Maybe<Scalars["Int"]["output"]>;
  classificationName?: Maybe<Scalars["String"]["output"]>;
  cobrokeCommRate?: Maybe<Scalars["Float"]["output"]>;
  cobrokeCommission?: Maybe<Scalars["Float"]["output"]>;
  commissionPrice?: Maybe<Scalars["Float"]["output"]>;
  companyID: Scalars["Int"]["output"];
  companyName?: Maybe<Scalars["String"]["output"]>;
  createdBy?: Maybe<Scalars["String"]["output"]>;
  estimatedClosingDate?: Maybe<Scalars["DateTime"]["output"]>;
  isFlatCommission?: Maybe<Scalars["Boolean"]["output"]>;
  listCommRate?: Maybe<Scalars["Float"]["output"]>;
  listCommission?: Maybe<Scalars["Float"]["output"]>;
  listDate?: Maybe<Scalars["DateTime"]["output"]>;
  listingPrice?: Maybe<Scalars["Float"]["output"]>;
  mlsListing?: Maybe<MlsListingObject>;
  mlsNumber1: Scalars["String"]["output"];
  ourList: Scalars["Boolean"]["output"];
  ourSell: Scalars["Boolean"]["output"];
  participants?: Maybe<DarwinParticipantsObject>;
  pendingDate?: Maybe<Scalars["DateTime"]["output"]>;
  propertyAddress: Scalars["String"]["output"];
  propertyId: Scalars["Int"]["output"];
  propertyTypeId?: Maybe<Scalars["Int"]["output"]>;
  propertyTypeName?: Maybe<Scalars["String"]["output"]>;
  propertyUseId?: Maybe<Scalars["Int"]["output"]>;
  sellCommRate?: Maybe<Scalars["Float"]["output"]>;
  sellCommission?: Maybe<Scalars["Float"]["output"]>;
  sellingPrice?: Maybe<Scalars["Float"]["output"]>;
  state?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  statusId: Scalars["Int"]["output"];
  streetDesignation?: Maybe<Scalars["String"]["output"]>;
  streetDirection?: Maybe<Scalars["String"]["output"]>;
  streetName?: Maybe<Scalars["String"]["output"]>;
  streetNumber?: Maybe<Scalars["String"]["output"]>;
  streetSuffix?: Maybe<Scalars["String"]["output"]>;
  suiteAptNumber?: Maybe<Scalars["String"]["output"]>;
  typeCode?: Maybe<Scalars["String"]["output"]>;
  typeCodeName?: Maybe<Scalars["String"]["output"]>;
  zip?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncFeeCurrentValue = {
  __typename?: "DarwinSyncFeeCurrentValue";
  amount?: Maybe<Scalars["Float"]["output"]>;
};

export type DarwinSyncFeeField = {
  __typename?: "DarwinSyncFeeField";
  currentValue?: Maybe<DarwinSyncFeeCurrentValue>;
  feeType: DarwinFeeType;
  hasChange: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  proposedValue: DarwinSyncFeeProposedValue;
  rowId: Scalars["String"]["output"];
};

export type DarwinSyncFeeProposedValue = {
  __typename?: "DarwinSyncFeeProposedValue";
  amount?: Maybe<Scalars["Float"]["output"]>;
  disabledOptions?: Maybe<SyncPreviewDisabledOptions>;
  disabledReason?: Maybe<Scalars["String"]["output"]>;
  payer?: Maybe<Scalars["String"]["output"]>;
  sourceLabel?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncFeeSection = {
  __typename?: "DarwinSyncFeeSection";
  fields: Array<DarwinSyncFeeField>;
};

export type DarwinSyncKeyTermField = {
  __typename?: "DarwinSyncKeyTermField";
  currentValue?: Maybe<SyncPreviewCurrentValue>;
  darwinFieldKey: Scalars["String"]["output"];
  hasChange: Scalars["Boolean"]["output"];
  keyTerm: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  proposedValue: SyncPreviewProposedValue;
  rowId: Scalars["String"]["output"];
};

export type DarwinSyncKeyTermsSection = {
  __typename?: "DarwinSyncKeyTermsSection";
  fields: Array<DarwinSyncKeyTermField>;
  sectionType: DarwinSyncPreviewSectionType;
};

export type DarwinSyncPersonCurrentValue = {
  __typename?: "DarwinSyncPersonCurrentValue";
  personId?: Maybe<Scalars["Int"]["output"]>;
  personName?: Maybe<Scalars["String"]["output"]>;
  propertyPeopleId?: Maybe<Scalars["Int"]["output"]>;
  side?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncPersonField = {
  __typename?: "DarwinSyncPersonField";
  currentValue?: Maybe<DarwinSyncPersonCurrentValue>;
  hasChange: Scalars["Boolean"]["output"];
  label: Scalars["String"]["output"];
  proposedValue: DarwinSyncPersonProposedValue;
  rowId: Scalars["String"]["output"];
  vendorType?: Maybe<DarwinVendorType>;
};

export type DarwinSyncPersonProposedValue = {
  __typename?: "DarwinSyncPersonProposedValue";
  alternatives?: Maybe<Array<DarwinPersonCandidate>>;
  changeType: DarwinPersonChangeType;
  confidence?: Maybe<DarwinPersonMatchConfidence>;
  disabledOptions?: Maybe<SyncPreviewDisabledOptions>;
  disabledReason?: Maybe<Scalars["String"]["output"]>;
  matchScore?: Maybe<Scalars["Float"]["output"]>;
  matchedPersonId?: Maybe<Scalars["Int"]["output"]>;
  matchedPersonName?: Maybe<Scalars["String"]["output"]>;
  side?: Maybe<Scalars["String"]["output"]>;
  sourceLabel?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncPersonSection = {
  __typename?: "DarwinSyncPersonSection";
  fields: Array<DarwinSyncPersonField>;
  sectionType: DarwinSyncPreviewSectionType;
};

export type DarwinSyncPreviewField = {
  __typename?: "DarwinSyncPreviewField";
  currentValue?: Maybe<SyncPreviewCurrentValue>;
  hasChange: Scalars["Boolean"]["output"];
  label: DarwinPropertyDetailFieldLabel;
  proposedValue: SyncPreviewProposedValue;
  rowId?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncPreviewPayload = {
  __typename?: "DarwinSyncPreviewPayload";
  companySection?: Maybe<DarwinCompanyPreviewSection>;
  feesSection?: Maybe<DarwinSyncFeeSection>;
  generatedAt: Scalars["DateTime"]["output"];
  keyTermsSection?: Maybe<DarwinSyncKeyTermsSection>;
  participantsSection?: Maybe<DarwinParticipantsSection>;
  previewVersion: Scalars["String"]["output"];
  sections: Array<DarwinSyncPreviewSection>;
  vendorsSection?: Maybe<DarwinSyncPersonSection>;
};

export type DarwinSyncPreviewSection = {
  __typename?: "DarwinSyncPreviewSection";
  fields: Array<DarwinSyncPreviewField>;
  sectionType: DarwinSyncPreviewSectionType;
};

export enum DarwinSyncPreviewSectionType {
  KEY_TERMS = "KEY_TERMS",
  PROPERTY_DETAILS = "PROPERTY_DETAILS",
  VENDORS = "VENDORS",
}

export type DarwinSyncRunContextPayload = {
  __typename?: "DarwinSyncRunContextPayload";
  attempt: Scalars["Int"]["output"];
  cause: Scalars["String"]["output"];
  darwinPropertyId?: Maybe<Scalars["Int"]["output"]>;
  externalFolderId: Scalars["String"]["output"];
  ingestionFolderUuid?: Maybe<Scalars["ID"]["output"]>;
  organizationUuid: Scalars["ID"]["output"];
  parentRunId?: Maybe<Scalars["String"]["output"]>;
  source: Scalars["String"]["output"];
  syncRunId: Scalars["String"]["output"];
  transactionSide?: Maybe<Scalars["String"]["output"]>;
  triggerId: Scalars["String"]["output"];
  useSandbox: Scalars["Boolean"]["output"];
};

export type DarwinSyncRunDecisionEntryPayload = {
  __typename?: "DarwinSyncRunDecisionEntryPayload";
  details?: Maybe<Scalars["JSONObject"]["output"]>;
  domain: Scalars["String"]["output"];
  outcome: Scalars["String"]["output"];
  reasonCode?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncRunDecisionTracePayload = {
  __typename?: "DarwinSyncRunDecisionTracePayload";
  decisions: Array<DarwinSyncRunDecisionEntryPayload>;
};

export type DarwinSyncRunInitiatedByUserPayload = {
  __typename?: "DarwinSyncRunInitiatedByUserPayload";
  fullName?: Maybe<Scalars["String"]["output"]>;
  primaryEmail?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["String"]["output"];
};

export type DarwinSyncRunJoinHintsPayload = {
  __typename?: "DarwinSyncRunJoinHintsPayload";
  darwinParticipantIds?: Maybe<Array<Scalars["Int"]["output"]>>;
  darwinPropertyId?: Maybe<Scalars["Int"]["output"]>;
  darwinVendorIds?: Maybe<Array<Scalars["Int"]["output"]>>;
  posthogActorId?: Maybe<Scalars["String"]["output"]>;
  posthogWindowEnd?: Maybe<Scalars["String"]["output"]>;
  posthogWindowStart?: Maybe<Scalars["String"]["output"]>;
  referencedContractDocumentUuids?: Maybe<Array<Scalars["String"]["output"]>>;
  referencedIngestionDocumentUuids?: Maybe<Array<Scalars["String"]["output"]>>;
  sentryWindowEnd?: Maybe<Scalars["String"]["output"]>;
  sentryWindowStart?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncRunOutcomesPayload = {
  __typename?: "DarwinSyncRunOutcomesPayload";
  appliedCount?: Maybe<Scalars["Int"]["output"]>;
  disabledCount?: Maybe<Scalars["Int"]["output"]>;
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  failedCount?: Maybe<Scalars["Int"]["output"]>;
  failingStep?: Maybe<Scalars["String"]["output"]>;
  failureCode?: Maybe<Scalars["String"]["output"]>;
  needsDownstreamJoin?: Maybe<Scalars["Boolean"]["output"]>;
  retryable?: Maybe<Scalars["Boolean"]["output"]>;
  rootCauseCategory?: Maybe<Scalars["String"]["output"]>;
  rootCauseSubcategory?: Maybe<Scalars["String"]["output"]>;
  rowOutcomes?: Maybe<Array<DarwinSyncRunRowOutcomePayload>>;
  selectedCount?: Maybe<Scalars["Int"]["output"]>;
  skipCode?: Maybe<Scalars["String"]["output"]>;
  skippedCount?: Maybe<Scalars["Int"]["output"]>;
  skippedReasonCounts?: Maybe<Scalars["JSONObject"]["output"]>;
  status: DarwinSyncRunStatus;
};

export type DarwinSyncRunRawSummariesPayload = {
  __typename?: "DarwinSyncRunRawSummariesPayload";
  decisionTraceSummaryJson?: Maybe<Scalars["JSONObject"]["output"]>;
  executionSummaryJson?: Maybe<Scalars["JSONObject"]["output"]>;
  joinHintsJson?: Maybe<Scalars["JSONObject"]["output"]>;
  keyTermsSnapshotJson?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
  resultSummaryJson?: Maybe<Scalars["JSONObject"]["output"]>;
  selectionIntentSummaryJson?: Maybe<Scalars["JSONObject"]["output"]>;
  sourceSnapshotSummaryJson?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type DarwinSyncRunRowOutcomePayload = {
  __typename?: "DarwinSyncRunRowOutcomePayload";
  category: Scalars["String"]["output"];
  reasonCode?: Maybe<Scalars["String"]["output"]>;
  rowId: Scalars["String"]["output"];
  status: Scalars["String"]["output"];
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type DarwinSyncRunSelectionIntentPayload = {
  __typename?: "DarwinSyncRunSelectionIntentPayload";
  categoryCounts?: Maybe<Scalars["JSONObject"]["output"]>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type DarwinSyncRunSourceSnapshotPayload = {
  __typename?: "DarwinSyncRunSourceSnapshotPayload";
  newestSourceUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  oldestSourceUpdatedAt?: Maybe<Scalars["String"]["output"]>;
  previewStale?: Maybe<Scalars["Boolean"]["output"]>;
  previewTimestamp?: Maybe<Scalars["String"]["output"]>;
  previewVersion?: Maybe<Scalars["String"]["output"]>;
};

/** Status of a Darwin sync run */
export enum DarwinSyncRunStatus {
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  SKIPPED = "SKIPPED",
  SUCCEEDED = "SUCCEEDED",
  TIMED_OUT = "TIMED_OUT",
}

export type DarwinSyncRunTimelinePayload = {
  __typename?: "DarwinSyncRunTimelinePayload";
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  durationMs?: Maybe<Scalars["Int"]["output"]>;
  startedAt: Scalars["DateTime"]["output"];
  timelineEvents?: Maybe<Array<DarwinSyncTimelineEventPayload>>;
  /** AVAILABLE or UNAVAILABLE */
  timelineStatus: Scalars["String"]["output"];
  timelineUnavailableReason?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type DarwinSyncSelectionAppliedRow = {
  __typename?: "DarwinSyncSelectionAppliedRow";
  category: DarwinSyncSelectionRowCategory;
  label: Scalars["String"]["output"];
  rowId: Scalars["String"]["output"];
};

/** Category of a selected Darwin sync preview row */
export enum DarwinSyncSelectionRowCategory {
  COMPANY = "COMPANY",
  FEE = "FEE",
  KEY_TERM = "KEY_TERM",
  PARTICIPANT = "PARTICIPANT",
  PROPERTY_DETAIL = "PROPERTY_DETAIL",
  STATUS = "STATUS",
  UNKNOWN = "UNKNOWN",
  VENDOR = "VENDOR",
}

export type DarwinSyncSelectionSkippedRow = {
  __typename?: "DarwinSyncSelectionSkippedRow";
  category?: Maybe<DarwinSyncSelectionRowCategory>;
  label?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  rowId: Scalars["String"]["output"];
};

export type DarwinSyncTimelineEventPayload = {
  __typename?: "DarwinSyncTimelineEventPayload";
  eventType: Scalars["String"]["output"];
  payload?: Maybe<Scalars["JSONObject"]["output"]>;
  timestamp: Scalars["String"]["output"];
};

/** Trigger source for Darwin sync execution and audit logging */
export enum DarwinSyncTriggerType {
  AUTOPILOT = "AUTOPILOT",
  MANUAL = "MANUAL",
}

export type DarwinSyncVendorOverrideInput = {
  /** Preview row ID for vendor row (e.g. vendor:LENDER) */
  rowId: Scalars["String"]["input"];
  /** Explicitly selected Darwin person ID for this vendor row (alternative override) */
  selectedPersonId: Scalars["Int"]["input"];
};

export type DarwinVendorSyncInput = {
  /** Full preview data for audit trail (the DarwinSyncPersonField from preview) */
  previewData: Scalars["JSON"]["input"];
  /** User's selected person ID (best match or alternative) */
  selectedPersonId: Scalars["Int"]["input"];
  /** Type of vendor (LENDER or TITLE_COMPANY) */
  vendorType: DarwinVendorType;
};

/** Types of vendors that can be synced to Darwin properties */
export enum DarwinVendorType {
  LENDER = "LENDER",
  TITLE_COMPANY = "TITLE_COMPANY",
}

export type DateRangeFilterInput = {
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type DebugActionExecuteResult = {
  __typename?: "DebugActionExecuteResult";
  message?: Maybe<Scalars["String"]["output"]>;
  postActionSummary?: Maybe<Scalars["JSONObject"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export enum DebugActionKind {
  MARK_UNDELIVERABLE = "MARK_UNDELIVERABLE",
  REQUEUE_LOG = "REQUEUE_LOG",
  RETRY_DELIVERY = "RETRY_DELIVERY",
  UNPARK_PAUSED_LOGS = "UNPARK_PAUSED_LOGS",
}

export type DebugActionPreviewResult = {
  __typename?: "DebugActionPreviewResult";
  actionKind: DebugActionKind;
  currentState?: Maybe<Scalars["JSONObject"]["output"]>;
  previewToken: Scalars["String"]["output"];
  proposedState?: Maybe<Scalars["JSONObject"]["output"]>;
  targetIds: Array<Scalars["String"]["output"]>;
  warnings: Array<Scalars["String"]["output"]>;
};

export type DebugAutofillRendering = {
  __typename?: "DebugAutofillRendering";
  computedAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  renderedBody?: Maybe<Scalars["String"]["output"]>;
  renderedTitle?: Maybe<Scalars["String"]["output"]>;
  templateVariables?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type DebugDelivery = {
  __typename?: "DebugDelivery";
  isDryRunSkipped: Scalars["Boolean"]["output"];
  isNoRecipientSkipped: Scalars["Boolean"]["output"];
  postSanitizationRecipients?: Maybe<Array<DebugRawRecipient>>;
  preSanitizationRecipients?: Maybe<Array<DebugRawRecipient>>;
  workflowId?: Maybe<Scalars["String"]["output"]>;
};

export enum DebugLogDisplayStatus {
  DRY_RUN = "DRY_RUN",
  PAUSED = "PAUSED",
  PENDING = "PENDING",
  QUEUED = "QUEUED",
  SCHEDULED = "SCHEDULED",
  SENT = "SENT",
  UNDELIVERABLE = "UNDELIVERABLE",
}

export type DebugLogIdentity = {
  __typename?: "DebugLogIdentity";
  folderId?: Maybe<Scalars["String"]["output"]>;
  logId: Scalars["Int"]["output"];
  logUuid: Scalars["ID"]["output"];
  notificationKind: NotificationLogKind;
  notificationType?: Maybe<NotificationType>;
  organizationName?: Maybe<Scalars["String"]["output"]>;
  organizationUuid: Scalars["ID"]["output"];
  partnerName?: Maybe<Scalars["String"]["output"]>;
  partnerUuid?: Maybe<Scalars["ID"]["output"]>;
  side?: Maybe<TransactionSide>;
  stage?: Maybe<TransactionStageType>;
  templateTitle?: Maybe<Scalars["String"]["output"]>;
  templateUuid?: Maybe<Scalars["ID"]["output"]>;
};

export type DebugLogLifecycle = {
  __typename?: "DebugLogLifecycle";
  addedToQueueAt?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  displayStatus: DebugLogDisplayStatus;
  isDryRun: Scalars["Boolean"]["output"];
  pausedAt?: Maybe<Scalars["DateTime"]["output"]>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  undeliverableAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type DebugPartnerConfig = {
  __typename?: "DebugPartnerConfig";
  adminContactCount: Scalars["Int"]["output"];
  contactCount: Scalars["Int"]["output"];
  dryRunNotifications: Scalars["Boolean"]["output"];
  isActive: Scalars["Boolean"]["output"];
  partnerName: Scalars["String"]["output"];
  partnerUuid: Scalars["ID"]["output"];
};

export type DebugRawRecipient = {
  __typename?: "DebugRawRecipient";
  contactType?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  fullName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type DebugRecipientContact = {
  __typename?: "DebugRecipientContact";
  contactType: ContactType;
  email?: Maybe<Scalars["String"]["output"]>;
  fullName?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  uuid: Scalars["ID"]["output"];
};

export type DebugRecipientResolution = {
  __typename?: "DebugRecipientResolution";
  agentContactUuid?: Maybe<Scalars["String"]["output"]>;
  isFirstAssignment?: Maybe<Scalars["Boolean"]["output"]>;
  isPaused: Scalars["Boolean"]["output"];
  pauseReason?: Maybe<Scalars["String"]["output"]>;
  requestedRecipientTypes: Array<Scalars["String"]["output"]>;
  resolvedContacts: Array<DebugRecipientContact>;
  resolvedRawRecipients: Array<DebugRawRecipient>;
  rosterUsed?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DebugRoutingDecision = {
  __typename?: "DebugRoutingDecision";
  key: Scalars["String"]["output"];
  outcome: Scalars["String"]["output"];
  reason?: Maybe<Scalars["String"]["output"]>;
};

export type DebugRoutingDecisions = {
  __typename?: "DebugRoutingDecisions";
  decisions: Array<DebugRoutingDecision>;
};

export type DebugStageIntroSource = {
  __typename?: "DebugStageIntroSource";
  allowPartnerContactAssignment: Scalars["Boolean"]["output"];
  existingRelationshipMessageContent?: Maybe<Scalars["String"]["output"]>;
  newRelationshipMessageContent?: Maybe<Scalars["String"]["output"]>;
  side: TransactionSide;
  stage: TransactionStageType;
};

export type DebugTemplateSource = {
  __typename?: "DebugTemplateSource";
  dataToShare?: Maybe<Array<Scalars["String"]["output"]>>;
  delayMinutes?: Maybe<Scalars["Int"]["output"]>;
  eventType?: Maybe<TransactionStageType>;
  hasAssignedPartner?: Maybe<Scalars["Boolean"]["output"]>;
  isAttachedToPartner?: Maybe<Scalars["Boolean"]["output"]>;
  messageContent?: Maybe<Scalars["String"]["output"]>;
  orderIndex?: Maybe<Scalars["Int"]["output"]>;
  recipientTypes?: Maybe<Array<Scalars["String"]["output"]>>;
  side?: Maybe<TransactionSide>;
  status?: Maybe<NotificationTemplateStatus>;
  templateUuid?: Maybe<Scalars["ID"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type DefaultSecondaryDocumentObject = {
  __typename?: "DefaultSecondaryDocumentObject";
  defaultRules?: Maybe<Array<RuleObject>>;
  document: DocumentObject;
  id: Scalars["ID"]["output"];
  mappingKey: Scalars["String"]["output"];
  ordering: Scalars["Int"]["output"];
  secondaryDocument: DocumentObject;
};

export type DefaultSecondaryDocumentPayload = {
  __typename?: "DefaultSecondaryDocumentPayload";
  defaultSecondaryDocument?: Maybe<DefaultSecondaryDocumentObject>;
};

export type DeleteAiConversationInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteAccessControlInput = {
  id: Scalars["String"]["input"];
};

export type DeleteAccessControlPayload = {
  __typename?: "DeleteAccessControlPayload";
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteComplianceKeyTermSectionPayload = {
  __typename?: "DeleteComplianceKeyTermSectionPayload";
  deleted: Scalars["Boolean"]["output"];
};

export type DeleteContractDocumentsDocumentInput = {
  contractDocumentUuid: Scalars["ID"]["input"];
  mappingKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type DeleteContractDocumentsInput = {
  contractDocuments: Array<DeleteContractDocumentsDocumentInput>;
  contractId: Scalars["ID"]["input"];
};

export type DeleteContractSystemCredentialsInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteDefaultSecondaryDocumentInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteDefaultSecondaryDocumentPayload = {
  __typename?: "DeleteDefaultSecondaryDocumentPayload";
  success: Scalars["Boolean"]["output"];
};

export type DeleteDocumentPayload = {
  __typename?: "DeleteDocumentPayload";
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteDocumentSectionPayload = {
  __typename?: "DeleteDocumentSectionPayload";
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteDocumentVersionFieldsPayload = {
  __typename?: "DeleteDocumentVersionFieldsPayload";
  deletedIds: Array<Scalars["ID"]["output"]>;
};

export type DeleteDocumentVersionPayload = {
  __typename?: "DeleteDocumentVersionPayload";
  /** The UUID of the successfully deleted document version. */
  deletedDocumentVersionUuid: Scalars["ID"]["output"];
};

export type DeleteFieldPayload = {
  __typename?: "DeleteFieldPayload";
  id: Scalars["ID"]["output"];
};

export type DeleteIntegrationClientInput = {
  id: Scalars["ID"]["input"];
};

export type DeleteIntegrationConnectionInput = {
  integrationConnectionId: Scalars["ID"]["input"];
};

export type DeleteIntegrationConnectionPayload = {
  __typename?: "DeleteIntegrationConnectionPayload";
  deleted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type DeleteListingDocumentsInput = {
  listingDocumentUploadIds: Array<Scalars["String"]["input"]>;
  listingId: Scalars["String"]["input"];
};

export type DeleteOpenHouseInput = {
  id: Scalars["String"]["input"];
  options?: InputMaybe<OpenHouseCrudOptions>;
};

export type DeleteOpenHousePayload = {
  __typename?: "DeleteOpenHousePayload";
  success: Scalars["Boolean"]["output"];
};

export type DeletePreapprovalContractDocumentInput = {
  contractId: Scalars["ID"]["input"];
};

export type DeleteRulePayload = {
  __typename?: "DeleteRulePayload";
  id: Scalars["ID"]["output"];
};

export enum DocumentCategory {
  AFFILIATED_TITLE_BUSINESS_ARRANGEMENT_DISCLOSURE = "AFFILIATED_TITLE_BUSINESS_ARRANGEMENT_DISCLOSURE",
  APPRAISAL_CONTINGENCY = "APPRAISAL_CONTINGENCY",
  BROKER_COMPENSATION = "BROKER_COMPENSATION",
  BUYER_AGENCY_AGREEMENT = "BUYER_AGENCY_AGREEMENT",
  COUNTER_OFFER = "COUNTER_OFFER",
  COUNTER_OFFER_WITHDRAWAL = "COUNTER_OFFER_WITHDRAWAL",
  FINANCING_CONTINGENCY = "FINANCING_CONTINGENCY",
  FLOOR_PLAN = "FLOOR_PLAN",
  HOME_WARRANTY = "HOME_WARRANTY",
  INSPECTION_CONTINGENCY = "INSPECTION_CONTINGENCY",
  INVOICE = "INVOICE",
  INVOICE_PAYMENT_RECEIPT = "INVOICE_PAYMENT_RECEIPT",
  LEAD_BASED_PAINT = "LEAD_BASED_PAINT",
  LEGAL_DESCRIPTION = "LEGAL_DESCRIPTION",
  LENDER_PREAPPROVAL = "LENDER_PREAPPROVAL",
  LISTING_AGENCY_AGREEMENT = "LISTING_AGENCY_AGREEMENT",
  MLS_SHEET = "MLS_SHEET",
  OFFER_AMENDMENT = "OFFER_AMENDMENT",
  OFFER_TERMINATION = "OFFER_TERMINATION",
  PROPERTY_PURCHASE = "PROPERTY_PURCHASE",
  RENTAL_LISTING_AGREEMENT = "RENTAL_LISTING_AGREEMENT",
  REPAIR = "REPAIR",
  RESIDENTIAL_LEASE_AGREEMENT = "RESIDENTIAL_LEASE_AGREEMENT",
  SELLER_PROPERTY_DISCLOSURE = "SELLER_PROPERTY_DISCLOSURE",
  SEPTIC_PERMIT = "SEPTIC_PERMIT",
  SETTLEMENT_STATEMENT = "SETTLEMENT_STATEMENT",
  TENANT_AGENCY_AGREEMENT = "TENANT_AGENCY_AGREEMENT",
  TITLE_COMMITMENT = "TITLE_COMMITMENT",
  TRANSACTION_INTAKE = "TRANSACTION_INTAKE",
  UNKNOWN = "UNKNOWN",
  WARRANTY_DEED = "WARRANTY_DEED",
}

export type DocumentClassificationEvaluationListFilter = {
  expectedCategory?: InputMaybe<Array<DocumentCategory>>;
  expectedDocumentType?: InputMaybe<Array<DocumentType>>;
  expectedUsState?: InputMaybe<Array<UsState>>;
  id?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type DocumentClassificationEvaluationObject = {
  __typename?: "DocumentClassificationEvaluationObject";
  classification?: Maybe<Array<DocumentPagePrediction>>;
  combinedExtractedValues?: Maybe<Scalars["JSON"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  expectedCategory?: Maybe<DocumentCategory>;
  expectedDocumentType?: Maybe<DocumentType>;
  expectedUsState?: Maybe<UsState>;
  expectedValues?: Maybe<Scalars["JSON"]["output"]>;
  extractedAiValues?: Maybe<Scalars["JSON"]["output"]>;
  extractedValues?: Maybe<Scalars["JSON"]["output"]>;
  file: FileObject;
  filteredOutItems?: Maybe<Array<FilteredOutItemObject>>;
  id: Scalars["ID"]["output"];
  isBlankDocument: Scalars["Boolean"]["output"];
  lastExtractedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lowConfidenceFields?: Maybe<Scalars["JSON"]["output"]>;
  mappedValuesBBox?: Maybe<Scalars["JSON"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of DocumentClassificationEvaluationObject */
export type DocumentClassificationEvaluationObjectPaginated = {
  __typename?: "DocumentClassificationEvaluationObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentClassificationEvaluationObject>>;
};

export type DocumentCompactObject = {
  __typename?: "DocumentCompactObject";
  description: Scalars["String"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  documentType: DocumentType;
  form: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  usState: UsState;
};

export type DocumentEvaluationJobProgressObject = {
  __typename?: "DocumentEvaluationJobProgressObject";
  current?: Maybe<Scalars["Int"]["output"]>;
  evaluationId?: Maybe<Scalars["ID"]["output"]>;
  total?: Maybe<Scalars["Int"]["output"]>;
};

export type DocumentEvaluationJobStatusObject = {
  __typename?: "DocumentEvaluationJobStatusObject";
  isCompleted: Scalars["Boolean"]["output"];
  isFailed: Scalars["Boolean"]["output"];
  isInProgress: Scalars["Boolean"]["output"];
  jobId: Scalars["String"]["output"];
  progress?: Maybe<DocumentEvaluationJobProgressObject>;
  state: Scalars["String"]["output"];
};

export type DocumentGeoObject = {
  __typename?: "DocumentGeoObject";
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type DocumentLlmEvaluationInput = {
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  documentLLMId: Scalars["ID"]["input"];
  expectedOutput?: InputMaybe<Scalars["JSONObject"]["input"]>;
  file?: InputMaybe<Scalars["File"]["input"]>;
};

export type DocumentLlmEvaluationListFilterArgs = {
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  documentLLMId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DocumentLlmEvaluationObject = {
  __typename?: "DocumentLLMEvaluationObject";
  document?: Maybe<DocumentObject>;
  documentLLM: DocumentLlmObject;
  expectedOutput?: Maybe<Scalars["JSONObject"]["output"]>;
  file: FileObject;
  id: Scalars["ID"]["output"];
};

/** Paginated results of DocumentLLMEvaluationObject */
export type DocumentLlmEvaluationObjectPaginated = {
  __typename?: "DocumentLLMEvaluationObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentLlmEvaluationObject>>;
};

export type DocumentLlmExampleInput = {
  documentLLMId: Scalars["ID"]["input"];
  file: Scalars["File"]["input"];
};

export type DocumentLlmExampleListFilterArgs = {
  documentLLMId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DocumentLlmExampleObject = {
  __typename?: "DocumentLLMExampleObject";
  documentLLM: DocumentLlmObject;
  file: FileObject;
  id: Scalars["ID"]["output"];
};

/** Paginated results of DocumentLLMExampleObject */
export type DocumentLlmExampleObjectPaginated = {
  __typename?: "DocumentLLMExampleObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentLlmExampleObject>>;
};

export type DocumentLlmExamplesInput = {
  documentLLMId: Scalars["ID"]["input"];
  files: Array<Scalars["File"]["input"]>;
};

export type DocumentLlmInput = {
  context?: InputMaybe<Scalars["String"]["input"]>;
  documentCategory?: InputMaybe<DocumentCategory>;
  documentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  extractSchema?: InputMaybe<Array<LlmExtractSchemaInput>>;
  pages?: InputMaybe<Array<Scalars["Int"]["input"]>>;
};

export type DocumentLlmListFilterArgs = {
  documentCategory?: InputMaybe<DocumentCategory>;
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
};

export type DocumentLlmMissingKeysPayload = {
  __typename?: "DocumentLLMMissingKeysPayload";
  documentLLMId: Scalars["String"]["output"];
  missingMappingKeys: Array<Scalars["String"]["output"]>;
};

export type DocumentLlmObject = {
  __typename?: "DocumentLLMObject";
  context: Scalars["String"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  documentLLMEvaluations: Array<DocumentLlmEvaluationObject>;
  documents: Array<DocumentObject>;
  examples: Array<DocumentLlmExampleObject>;
  extractSchema: Array<LlmExtractSchemaObject>;
  id: Scalars["ID"]["output"];
  pages: Array<Scalars["Int"]["output"]>;
};

/** Paginated results of DocumentLLMObject */
export type DocumentLlmObjectPaginated = {
  __typename?: "DocumentLLMObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentLlmObject>>;
};

export type DocumentListArgs = {
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType?: InputMaybe<DocumentType>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  usStates?: InputMaybe<Array<UsState>>;
  withActiveDocumentVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  withDocumentSections?: InputMaybe<Array<DocumentSectionCategory>>;
};

export type DocumentMlObject = {
  __typename?: "DocumentMLObject";
  documentClassification: Scalars["JSONObject"]["output"];
  documentFile: FileObject;
  id: Scalars["ID"]["output"];
  pdfFileUrl?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type DocumentObject = {
  __typename?: "DocumentObject";
  activeDocumentVersion: DocumentVersionObject;
  defaultSecondaryDocuments: Array<DefaultSecondaryDocumentObject>;
  description: Scalars["String"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  documentType: DocumentType;
  documentVersions: Array<DocumentVersionObject>;
  form: Scalars["String"]["output"];
  hasUnmappedFields?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  includeInOfferIngestion: Scalars["Boolean"]["output"];
  llmExtraction: Scalars["Boolean"]["output"];
  name: Scalars["String"]["output"];
  subsetOfDocument?: Maybe<DocumentCompactObject>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  usState: UsState;
};

/** Paginated results of DocumentObject */
export type DocumentObjectPaginated = {
  __typename?: "DocumentObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentObject>>;
};

export type DocumentPagePrediction = {
  __typename?: "DocumentPagePrediction";
  alternativeCandidates?: Maybe<Array<BasePagePrediction>>;
  candidateDocumentCategories?: Maybe<Array<CandidateDocumentCategory>>;
  classificationMethod?: Maybe<ClassificationMethod>;
  containment?: Maybe<Scalars["Float"]["output"]>;
  documentCategory?: Maybe<DocumentCategory>;
  documentType?: Maybe<DocumentType>;
  formName: Scalars["String"]["output"];
  formOrVersionMatch?: Maybe<Scalars["JSONObject"]["output"]>;
  humanLabeled?: Maybe<Scalars["Boolean"]["output"]>;
  pageNumber: Scalars["Float"]["output"];
  score: Scalars["Float"]["output"];
  searchRegex?: Maybe<Scalars["String"]["output"]>;
  usState: UsState;
  version?: Maybe<Scalars["String"]["output"]>;
};

export type DocumentPagePredictionInput = {
  alternativeCandidates?: InputMaybe<Array<BasePagePredictionInput>>;
  candidateDocumentCategories?: InputMaybe<
    Array<CandidateDocumentCategoryInput>
  >;
  classificationMethod?: InputMaybe<ClassificationMethod>;
  containment?: InputMaybe<Scalars["Float"]["input"]>;
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType?: InputMaybe<DocumentType>;
  formName: Scalars["String"]["input"];
  formOrVersionMatch?: InputMaybe<Scalars["JSONObject"]["input"]>;
  humanLabeled?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageNumber: Scalars["Float"]["input"];
  score: Scalars["Float"]["input"];
  searchRegex?: InputMaybe<Scalars["String"]["input"]>;
  usState: UsState;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type DocumentPropertyObject = {
  __typename?: "DocumentPropertyObject";
  assessorParcelNumber?: Maybe<Scalars["String"]["output"]>;
  block: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  county: Scalars["String"]["output"];
  countyFips: Scalars["String"]["output"];
  geo?: Maybe<DocumentGeoObject>;
  id: Scalars["ID"]["output"];
  lot: Scalars["String"]["output"];
  msa?: Maybe<Scalars["String"]["output"]>;
  otherLegalDescription: Scalars["String"]["output"];
  parcelId: Scalars["String"]["output"];
  platBook: Scalars["String"]["output"];
  platBookPage: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  state: UsState;
  streetAddress: Scalars["String"]["output"];
  subdivision: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  yearBuilt?: Maybe<Scalars["Int"]["output"]>;
  zipCode: Scalars["String"]["output"];
  zipCodePlus4?: Maybe<Scalars["String"]["output"]>;
};

export enum DocumentSectionCategory {
  OFFER_CARD = "OFFER_CARD",
  OFFER_COMPARISON = "OFFER_COMPARISON",
  OFFER_FLOW = "OFFER_FLOW",
  OTHER = "OTHER",
}

export enum DocumentSectionDisplayType {
  BUYER_SELECT = "BUYER_SELECT",
  DEFAULT = "DEFAULT",
  PROPERTIES_SEARCH = "PROPERTIES_SEARCH",
  TABS = "TABS",
}

export type DocumentSectionFieldInput = {
  documentSectionId: Scalars["ID"]["input"];
  fieldId: Scalars["ID"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isDeleted?: InputMaybe<Scalars["Boolean"]["input"]>;
  order: Scalars["Int"]["input"];
};

export type DocumentSectionFieldObject = {
  __typename?: "DocumentSectionFieldObject";
  field: FieldObject;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
};

export type DocumentSectionListFilters = {
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  documentSectionCategory?: InputMaybe<Scalars["String"]["input"]>;
  documentVersionId?: InputMaybe<Scalars["ID"]["input"]>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  usState?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum DocumentSectionModuleType {
  BUYER = "BUYER",
  BUYERS_AGENT = "BUYERS_AGENT",
  COMMISSIONS = "COMMISSIONS",
  CO_BUYER = "CO_BUYER",
  KEY_TERMS = "KEY_TERMS",
  OTHER_FIELDS = "OTHER_FIELDS",
  POSSESSION_AGREEMENT = "POSSESSION_AGREEMENT",
}

export type DocumentSectionObject = {
  __typename?: "DocumentSectionObject";
  description: Scalars["String"]["output"];
  document?: Maybe<DocumentObject>;
  documentSectionCategory: DocumentSectionCategory;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionFields?: Maybe<Array<DocumentSectionFieldObject>>;
  documentSectionModuleType?: Maybe<DocumentSectionModuleType>;
  documentSectionType: DocumentSectionType;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  parent?: Maybe<DocumentSectionObject>;
  title: Scalars["String"]["output"];
};

/** Paginated results of DocumentSectionObject */
export type DocumentSectionObjectPaginated = {
  __typename?: "DocumentSectionObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentSectionObject>>;
};

export enum DocumentSectionType {
  CONTENT = "CONTENT",
  SECTION = "SECTION",
  SUB_SECTION = "SUB_SECTION",
}

export enum DocumentType {
  ADDENDUM = "ADDENDUM",
  AGENCY_AGREEMENT = "AGENCY_AGREEMENT",
  AGREEMENT = "AGREEMENT",
  AMENDMENT = "AMENDMENT",
  ANCILLARY_DOCUMENT = "ANCILLARY_DOCUMENT",
  CLOSING_DOCUMENT = "CLOSING_DOCUMENT",
  COUNTER_CONTRACT = "COUNTER_CONTRACT",
  LEASE_AGREEMENT = "LEASE_AGREEMENT",
  PROPERTY_PURCHASE_CONTRACT = "PROPERTY_PURCHASE_CONTRACT",
  REFERRAL = "REFERRAL",
  TERMINATION = "TERMINATION",
  UNKNOWN = "UNKNOWN",
}

export type DocumentValidationFieldResult = {
  __typename?: "DocumentValidationFieldResult";
  documentVersionField: DocumentVersionFieldObject;
  field: FieldObject;
  results: Array<GenericRuleValidationObject>;
};

export type DocumentValidationResult = {
  __typename?: "DocumentValidationResult";
  contractDocumentId: Scalars["ID"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  documentForm?: Maybe<Scalars["String"]["output"]>;
  documentName?: Maybe<Scalars["String"]["output"]>;
  documentVersionId: Scalars["ID"]["output"];
  ingestionDocumentId?: Maybe<Scalars["ID"]["output"]>;
  validations: Array<DocumentValidationFieldResult>;
};

export enum DocumentValidationStageSelectionSource {
  COMPLIANCE_GROUP = "COMPLIANCE_GROUP",
  FALLBACK_STAGE = "FALLBACK_STAGE",
  FOLDER_NAME_OVERRIDE = "FOLDER_NAME_OVERRIDE",
}

export enum DocumentVersionAutoMapState {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  QUEUED = "QUEUED",
}

export type DocumentVersionAutoMapStatusObject = {
  __typename?: "DocumentVersionAutoMapStatusObject";
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  failedAt?: Maybe<Scalars["DateTime"]["output"]>;
  queuedAt?: Maybe<Scalars["DateTime"]["output"]>;
  state: DocumentVersionAutoMapState;
};

export type DocumentVersionAutofillValuesPayload = {
  __typename?: "DocumentVersionAutofillValuesPayload";
  autofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  helpTextAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  optionsAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  readOnlyAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type DocumentVersionDetectFormFieldsPayload = {
  __typename?: "DocumentVersionDetectFormFieldsPayload";
  jobId?: Maybe<Scalars["String"]["output"]>;
};

export type DocumentVersionDuplicateObject = {
  __typename?: "DocumentVersionDuplicateObject";
  documentName: Scalars["String"]["output"];
  documentUuid: Scalars["ID"]["output"];
  documentVersionUuid: Scalars["ID"]["output"];
  form: Scalars["String"]["output"];
  pageCount: Scalars["Int"]["output"];
  version: Scalars["String"]["output"];
};

export type DocumentVersionFieldObject = {
  __typename?: "DocumentVersionFieldObject";
  align: FieldAlign;
  autofill?: Maybe<AutofillObject>;
  boundingBox: BoundingBoxObject;
  displayLabel?: Maybe<Scalars["String"]["output"]>;
  field: FieldObject;
  fieldType: FieldType;
  fontFamily: Scalars["String"]["output"];
  fontSize: Scalars["String"]["output"];
  height: Scalars["Float"]["output"];
  helpTextAutofill?: Maybe<AutofillObject>;
  id: Scalars["ID"]["output"];
  inputFormat?: Maybe<InputFormatObject>;
  label: Scalars["String"]["output"];
  labelBoundingBox?: Maybe<BoundingBoxObject>;
  labelField?: Maybe<LabelFieldObject>;
  mappingKey: Scalars["String"]["output"];
  optionsAutofill?: Maybe<AutofillObject>;
  pageNumber: Scalars["Int"]["output"];
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  rules: Array<RuleObject>;
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type DocumentVersionListFilterArgs = {
  autoMapActivitySince?: InputMaybe<Scalars["DateTime"]["input"]>;
  documentId?: InputMaybe<Scalars["ID"]["input"]>;
  documentSectionCategories?: InputMaybe<Array<DocumentSectionCategory>>;
  documentType?: InputMaybe<DocumentType>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  usState?: InputMaybe<UsState>;
};

export type DocumentVersionMissingKey = {
  __typename?: "DocumentVersionMissingKey";
  documentId: Scalars["String"]["output"];
  documentVersionId: Scalars["String"]["output"];
  missingMappingKeys: Array<Scalars["String"]["output"]>;
  searchRegex?: Maybe<Scalars["String"]["output"]>;
  version: Scalars["String"]["output"];
};

export type DocumentVersionObject = {
  __typename?: "DocumentVersionObject";
  autoMapStatus?: Maybe<DocumentVersionAutoMapStatusObject>;
  document: DocumentObject;
  documentVersionFields: Array<DocumentVersionFieldObject>;
  documentVersionFieldsCount?: Maybe<Scalars["Int"]["output"]>;
  file: FileObject;
  hiddenPreviewImages: Array<AssetFileObject>;
  id: Scalars["ID"]["output"];
  mappingKeys: Array<Scalars["String"]["output"]>;
  previewImages: Array<AssetFileObject>;
  searchRegex?: Maybe<Scalars["String"]["output"]>;
  secondaryDocumentVersions: Array<SecondaryDocumentVersionObject>;
  secondaryVersions: Array<DocumentVersionObject>;
  status: DocumentVersionStatus;
  version: Scalars["String"]["output"];
};

/** Paginated results of DocumentVersionObject */
export type DocumentVersionObjectPaginated = {
  __typename?: "DocumentVersionObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<DocumentVersionObject>>;
};

export type DocumentVersionPagePairInput = {
  documentVersionId: Scalars["String"]["input"];
  pageNumber: Scalars["Int"]["input"];
  sourcePageNumber: Scalars["Int"]["input"];
};

export type DocumentVersionPayload = {
  __typename?: "DocumentVersionPayload";
  documentVersion?: Maybe<DocumentVersionObject>;
};

export enum DocumentVersionStatus {
  ACTIVE = "ACTIVE",
  DRAFT = "DRAFT",
  INACTIVE = "INACTIVE",
}

export type DotloopComplianceGroupsFilterInput = {
  profileId: Scalars["ID"]["input"];
};

export type DotloopComplianceGroupsObject = {
  __typename?: "DotloopComplianceGroupsObject";
  active?: Maybe<Scalars["Boolean"]["output"]>;
  complianceStatuses?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
  id?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  parentProfileId?: Maybe<Scalars["String"]["output"]>;
  profileId?: Maybe<Scalars["Int"]["output"]>;
  profileName?: Maybe<Scalars["String"]["output"]>;
  profileType?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
};

export type DotloopFolderComplianceStatusInput = {
  complianceGroupId: Scalars["ID"]["input"];
  complianceStatusId: Scalars["ID"]["input"];
  folderId: Scalars["ID"]["input"];
};

export type EmbeddedSignatureRequestPayload = {
  __typename?: "EmbeddedSignatureRequestPayload";
  embeddedSignUrl: Scalars["String"]["output"];
  indigoContract: IndigoContractObject;
};

export enum ErrorReportCategory {
  DARWIN_SYNC = "DARWIN_SYNC",
  GENERAL = "GENERAL",
}

export type ErrorReportObject = {
  __typename?: "ErrorReportObject";
  category: ErrorReportCategory;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  linearTicketUrl?: Maybe<Scalars["String"]["output"]>;
  metadata?: Maybe<Scalars["JSONObject"]["output"]>;
  userMessage?: Maybe<Scalars["String"]["output"]>;
  userMessageSubmittedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EvaluateFormulaBatchInput = {
  /** The formula to evaluate */
  formula: Scalars["String"]["input"];
  /** Test cases to evaluate */
  testCases: Array<FormulaTestCaseInput>;
  /** Variable definitions for the formula */
  variables: Array<VariableFieldInput>;
};

export type EvaluateFormulaBatchPayload = {
  __typename?: "EvaluateFormulaBatchPayload";
  /** Results for each test case */
  results: Array<EvaluateFormulaResult>;
};

export type EvaluateFormulaInput = {
  /** The formula to evaluate */
  formula: Scalars["String"]["input"];
  /** Values to substitute into the formula variables */
  values: Scalars["JSONObject"]["input"];
  /** Variable definitions for the formula */
  variables: Array<VariableFieldInput>;
};

export type EvaluateFormulaPayload = {
  __typename?: "EvaluateFormulaPayload";
  /** Error message if evaluation failed */
  error?: Maybe<Scalars["String"]["output"]>;
  /** The result of the formula evaluation (can be string, number, boolean, or string array) */
  output?: Maybe<Scalars["Value"]["output"]>;
};

export type EvaluateFormulaResult = {
  __typename?: "EvaluateFormulaResult";
  /** Error message if evaluation failed */
  error?: Maybe<Scalars["String"]["output"]>;
  /** Index of the test case in the input array */
  index: Scalars["Int"]["output"];
  /** The result of the formula evaluation (can be string, number, boolean, or string array) */
  output?: Maybe<Scalars["Value"]["output"]>;
};

export type EventListObject = {
  __typename?: "EventListObject";
  doneAt?: Maybe<Scalars["DateTime"]["output"]>;
  isDone?: Maybe<Scalars["Boolean"]["output"]>;
  label: Scalars["String"]["output"];
  name: EventTypes;
};

export enum EventTypes {
  BUYERS_ALL_SIGNED = "BUYERS_ALL_SIGNED",
  BUYER_SENT_TO = "BUYER_SENT_TO",
  BUYER_SIGNED = "BUYER_SIGNED",
  BUYER_VIEWED = "BUYER_VIEWED",
  LISTING_AGENT_ACCEPTED = "LISTING_AGENT_ACCEPTED",
  LISTING_AGENT_SENT_TO = "LISTING_AGENT_SENT_TO",
  LISTING_AGENT_VIEWED = "LISTING_AGENT_VIEWED",
}

export type EventsForOfferInput = {
  offerId: Scalars["String"]["input"];
};

export type ExternalCreateComplianceMessageHistoryInput = {
  ingestionFolderId: Scalars["ID"]["input"];
  messageContent: Scalars["String"]["input"];
  recipientType: ComplianceMessageRecipientType;
  recipientValue: Scalars["String"]["input"];
  senderUuid: Scalars["String"]["input"];
  workflowRunId: Scalars["String"]["input"];
};

export type ExternalCreateComplianceMessageHistoryPayload = {
  __typename?: "ExternalCreateComplianceMessageHistoryPayload";
  complianceMessageHistory: ComplianceMessageHistoryObject;
};

export type ExternalCreateErrorReportInput = {
  category: ErrorReportCategory;
  ingestionFolderId: Scalars["ID"]["input"];
  userMessage: Scalars["String"]["input"];
};

export type ExternalCreateIngestionDocumentValidationFeedbackInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  contractDocumentUuid: Scalars["String"]["input"];
  feedbackType: FeedbackType;
  ingestionDocumentValidationId: Scalars["ID"]["input"];
  ruleUuid: Scalars["String"]["input"];
};

export type ExternalCreateIngestionFolderValidationFeedbackInput = {
  comment?: InputMaybe<Scalars["String"]["input"]>;
  feedbackType: FeedbackType;
  ingestionFolderValidationId: Scalars["ID"]["input"];
};

export type ExternalCreateOrUpdateIngestionDocumentReviewInput = {
  ingestionDocumentId: Scalars["ID"]["input"];
  reason?: InputMaybe<Scalars["String"]["input"]>;
  reviewId?: InputMaybe<Scalars["ID"]["input"]>;
  status: IngestionDocumentReviewStatus;
  version?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalCreateOrUpdateIngestionDocumentValidationErrorReviewInput =
  {
    contractDocumentUuid?: InputMaybe<Scalars["String"]["input"]>;
    ingestionDocumentId: Scalars["ID"]["input"];
    ingestionDocumentValidationId?: InputMaybe<Scalars["ID"]["input"]>;
    isAddedByUser?: Scalars["Boolean"]["input"];
    isHidden: Scalars["Boolean"]["input"];
    message?: InputMaybe<Scalars["String"]["input"]>;
    pageNumber?: InputMaybe<Scalars["Int"]["input"]>;
    reviewId?: InputMaybe<Scalars["ID"]["input"]>;
    ruleUuid?: InputMaybe<Scalars["String"]["input"]>;
  };

export type ExternalCreateOrUpdateIngestionFolderValidationErrorReviewInput = {
  documentCategory?: InputMaybe<Scalars["String"]["input"]>;
  documentForm?: InputMaybe<Scalars["String"]["input"]>;
  documentName?: InputMaybe<Scalars["String"]["input"]>;
  ingestionFolderValidationId: Scalars["ID"]["input"];
  isAddedByUser?: Scalars["Boolean"]["input"];
  isHidden: Scalars["Boolean"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  reviewId?: InputMaybe<Scalars["ID"]["input"]>;
  ruleUuid?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalDarwinCompanyObject = {
  __typename?: "ExternalDarwinCompanyObject";
  companyId: Scalars["Int"]["output"];
  companyName: Scalars["String"]["output"];
};

export type ExternalDarwinPropertiesPayload = {
  __typename?: "ExternalDarwinPropertiesPayload";
  properties: Array<DarwinPropertyObject>;
};

export type ExternalDarwinPropertyInput = {
  /** Configuration for selecting the Darwin environment. */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExternalDeleteIngestionDocumentValidationErrorReviewInput = {
  reviewId: Scalars["ID"]["input"];
};

export type ExternalDeleteIngestionFolderValidationErrorReviewInput = {
  reviewId: Scalars["ID"]["input"];
};

export enum ExternalDocumentType {
  PREAPPROVAL = "PREAPPROVAL",
  UNKNOWN = "UNKNOWN",
}

export type ExternalGetComplianceMessageHistoryInput = {
  ingestionFolderId: Scalars["ID"]["input"];
};

export type ExternalGetDarwinPropertyClassificationInput = {
  /** Configuration for selecting the Darwin environment. */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Override MLS listing ID to use for classification (MLSListingObject.id, NOT the listingId/MLS number). Required when multiple MLS listings exist for the folder to ensure the correct listing data is used. If not provided, falls back to the first available listing (deprecated behavior). */
  mlsListingIdOverride?: InputMaybe<Scalars["String"]["input"]>;
  propertyId: Scalars["Int"]["input"];
};

export type ExternalGetDarwinSyncPreviewInput = {
  /** Configuration for selecting the Darwin environment. */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Darwin property ID. If not provided, currentValue will be null (creating new property). */
  propertyId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExternalGetDistinctOfficeNamesInput = {
  organizationId: Scalars["ID"]["input"];
};

export type ExternalGetDistinctStatusesInput = {
  organizationId: Scalars["ID"]["input"];
};

export type ExternalGetIngestionDocumentReviewsInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalGetIngestionDocumentValidationErrorReviewsInput = {
  contractDocumentUuid?: InputMaybe<Scalars["String"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentValidationId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId: Scalars["ID"]["input"];
};

export type ExternalGetIngestionDocumentValidationFeedbackInput = {
  ingestionDocumentValidationId: Scalars["ID"]["input"];
};

export type ExternalGetIngestionFolderInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  organizationId: Scalars["ID"]["input"];
};

export type ExternalGetIngestionFolderValidationErrorReviewsInput = {
  ingestionFolderValidationId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalGetIngestionFolderValidationFeedbackInput = {
  ingestionFolderValidationId: Scalars["ID"]["input"];
};

export type ExternalGetMlsListingSelectionInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalGetValidationReportDataInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalIngestionDocumentArgs = {
  externalDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderUuid?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalIngestionDocumentsForFolderInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type ExternalIngestionFolderListForOrganizationInput = {
  agentSearch?: InputMaybe<Scalars["String"]["input"]>;
  createdAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  hasUnsubmittedContractDocs?: InputMaybe<Scalars["Boolean"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  maxDocumentCount?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  office?: InputMaybe<Scalars["String"]["input"]>;
  offices?: InputMaybe<Array<Scalars["String"]["input"]>>;
  organizationId: Scalars["ID"]["input"];
  propertyType?: InputMaybe<TransactionPropertyType>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<TransactionStageType>;
  state?: InputMaybe<UsState>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  transactionSide?: InputMaybe<TransactionSide>;
  updatedAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  updatedAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ExternalIngestionFolderPlatformUrlInput = {
  ingestionFolderId: Scalars["ID"]["input"];
};

export type ExternalKeyTermsObject = {
  __typename?: "ExternalKeyTermsObject";
  columnName: Scalars["String"]["output"];
  fieldType: FieldType;
  id: Scalars["ID"]["output"];
};

export type ExternalSaveDarwinCompanyOfficeMappingInput = {
  darwinCompanyId: Scalars["Int"]["input"];
  officeId: Scalars["String"]["input"];
  organizationUuid: Scalars["ID"]["input"];
  platform: IngestionPlatform;
  platformProfileId: Scalars["String"]["input"];
};

export type ExternalSubmitErrorReportContextInput = {
  errorReportId: Scalars["ID"]["input"];
  userMessage: Scalars["String"]["input"];
};

export type ExternalSubmitValidationReviewsInput = {
  dotloopFolderComplianceStatuses?: InputMaybe<
    Array<DotloopFolderComplianceStatusInput>
  >;
  ingestionFolderId: Scalars["ID"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalSyncDarwinFeesInput = {
  /** Configuration for selecting the Darwin environment */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  /** Darwin property ID to sync fees to */
  darwinPropertyId: Scalars["Int"]["input"];
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Fees to sync (allows multiple fee types in future) */
  fees: Array<DarwinFeeSyncInput>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Timestamp when preview was fetched (for staleness detection) */
  previewTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ExternalSyncDarwinFeesPayload = {
  __typename?: "ExternalSyncDarwinFeesPayload";
  success: Scalars["Boolean"]["output"];
  syncedFees: Array<DarwinFeeSyncResult>;
};

export type ExternalSyncDarwinSelectionInput = {
  /** Configuration for selecting the Darwin environment. */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  /** Darwin property ID to update. Omit to create a new property if selected rows require property sync. */
  darwinPropertyId?: InputMaybe<Scalars["Int"]["input"]>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Override MLS listing ID to use when creating a new Darwin property (MLSListingObject.id). */
  mlsListingIdOverride?: InputMaybe<Scalars["String"]["input"]>;
  /** Legacy participant selector (unsupported by externalSyncDarwinSelection; use participant:* row IDs in selectedRowIds). */
  onlyParticipants?: InputMaybe<Array<ParticipantInput>>;
  /** Timestamp when preview was fetched */
  previewGeneratedAt: Scalars["DateTime"]["input"];
  /** Preview version token for stale detection */
  previewVersion: Scalars["String"]["input"];
  /** Selected preview row IDs to sync (e.g. key_term:..., vendor:..., fee:..., participant:..., property_detail:..., status:STATUS). */
  selectedRowIds: Array<Scalars["String"]["input"]>;
  /** Trigger source for logging and automation readiness. */
  triggerType?: InputMaybe<DarwinSyncTriggerType>;
  /** Optional vendor person overrides keyed by row ID when user selects an alternative match. */
  vendorOverrides?: InputMaybe<Array<DarwinSyncVendorOverrideInput>>;
};

export type ExternalSyncDarwinSelectionPayload = {
  __typename?: "ExternalSyncDarwinSelectionPayload";
  appliedRows: Array<DarwinSyncSelectionAppliedRow>;
  externalEntityId?: Maybe<Scalars["String"]["output"]>;
  skippedRows: Array<DarwinSyncSelectionSkippedRow>;
  success: Scalars["Boolean"]["output"];
};

export type ExternalSyncDarwinVendorsInput = {
  /** Configuration for selecting the Darwin environment */
  darwinEnvironment?: InputMaybe<DarwinEnvironmentInput>;
  /** Darwin property ID to sync vendors to */
  darwinPropertyId: Scalars["Int"]["input"];
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Timestamp when preview was fetched (for staleness detection) */
  previewTimestamp?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Vendors to sync with user selections */
  vendors: Array<DarwinVendorSyncInput>;
};

export type ExternalSyncDarwinVendorsPayload = {
  __typename?: "ExternalSyncDarwinVendorsPayload";
  success: Scalars["Boolean"]["output"];
  syncedVendors: Array<SyncedVendorResult>;
};

export type ExternalSyncEnvironmentInput = {
  darwin?: InputMaybe<DarwinEnvironmentInput>;
};

export type ExternalSyncKeyTermsInput = {
  /** Configuration for selecting environment options per external system. */
  environment?: InputMaybe<ExternalSyncEnvironmentInput>;
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  externalSystemIdentifier?: InputMaybe<Scalars["String"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  /** Override MLS listing ID to use when creating a new Darwin property (MLSListingObject.id, NOT the listingId/MLS number). Required when multiple MLS listings exist for the folder to ensure the correct listing data is synced. Ignored for updates (existing Darwin properties use their associated mlsNumber1). If not provided for creation, falls back to the first available listing (deprecated behavior). */
  mlsListingIdOverride?: InputMaybe<Scalars["String"]["input"]>;
  onlyKeyTerms: KeyTermInputs;
  onlyParticipants?: InputMaybe<Array<ParticipantInput>>;
  toSystem: ExternalSystem;
};

export type ExternalSyncKeyTermsPayload = {
  __typename?: "ExternalSyncKeyTermsPayload";
  externalEntityId?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export enum ExternalSystem {
  DARWIN = "DARWIN",
}

export type ExternalUpdateIngestionDocumentStatusInput = {
  externalDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderUuid?: InputMaybe<Scalars["ID"]["input"]>;
  status: IngestionDocumentReviewStatus;
};

export type ExtractContractInput = {
  file?: InputMaybe<Scalars["File"]["input"]>;
  fileUrl?: InputMaybe<Scalars["String"]["input"]>;
  isInternalTest?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ExtractContractPayload = {
  __typename?: "ExtractContractPayload";
  contract?: Maybe<ContractObject>;
  extracted?: Maybe<Array<ExtractedDocumentValuesPayload>>;
};

export type ExtractPreapprovalInfoInput = {
  file?: InputMaybe<Scalars["File"]["input"]>;
  fileUrl?: InputMaybe<Scalars["String"]["input"]>;
  isInternalTest?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ExtractPreapprovalInfoPayload = {
  __typename?: "ExtractPreapprovalInfoPayload";
  co_buyer?: Maybe<Scalars["String"]["output"]>;
  loan_amount?: Maybe<Scalars["Float"]["output"]>;
  loan_type?: Maybe<Scalars["String"]["output"]>;
  primary_buyer?: Maybe<Scalars["String"]["output"]>;
  purchase_price?: Maybe<Scalars["Float"]["output"]>;
};

export type ExtractedContractBuyerInfo = {
  __typename?: "ExtractedContractBuyerInfo";
  entity?: Maybe<ExtractedContractEntityInfo>;
  fullName: Scalars["String"]["output"];
};

export type ExtractedContractBuyerInfos = {
  __typename?: "ExtractedContractBuyerInfos";
  primary?: Maybe<ExtractedContractBuyerInfo>;
  secondary: Array<ExtractedContractBuyerInfo>;
};

export type ExtractedContractEntityInfo = {
  __typename?: "ExtractedContractEntityInfo";
  name?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ExtractedDocumentValuesPayload = {
  __typename?: "ExtractedDocumentValuesPayload";
  documentType?: Maybe<DocumentType>;
  formName?: Maybe<Scalars["String"]["output"]>;
  /** Matched document/template state for the extracted document. */
  usState?: Maybe<UsState>;
  values?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type ExtractedValues = {
  __typename?: "ExtractedValues";
  mappedValuesBBox?: Maybe<Scalars["JSONObject"]["output"]>;
  repositionedDocumentVersionFields?: Maybe<
    Array<Array<DocumentVersionFieldObject>>
  >;
  signatureInitialsBBox?: Maybe<Scalars["JSONObject"]["output"]>;
  values?: Maybe<Scalars["JSONObject"]["output"]>;
};

export enum FeedbackSource {
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
}

export enum FeedbackType {
  THUMBS_DOWN = "THUMBS_DOWN",
  THUMBS_UP = "THUMBS_UP",
}

export enum FieldAlign {
  CENTER = "CENTER",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export type FieldListFilterArgs = {
  documentVersionId?: InputMaybe<Scalars["ID"]["input"]>;
  fieldType?: InputMaybe<FieldType>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isComputed?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  usState?: InputMaybe<UsState>;
};

export type FieldObject = {
  __typename?: "FieldObject";
  aiExtract?: Maybe<Scalars["Boolean"]["output"]>;
  aiInterpret?: Maybe<Scalars["Boolean"]["output"]>;
  autofill?: Maybe<AutofillObject>;
  comparisonType?: Maybe<ComparisonType>;
  defaultRules?: Maybe<Array<RuleObject>>;
  displayLabel?: Maybe<Scalars["String"]["output"]>;
  fieldType: FieldType;
  group: Scalars["String"]["output"];
  helpTextAutofill?: Maybe<AutofillObject>;
  id: Scalars["ID"]["output"];
  includedDocumentVersions?: Maybe<Array<DocumentVersionObject>>;
  inputFormat?: Maybe<InputFormatObject>;
  isComputed?: Maybe<Scalars["Boolean"]["output"]>;
  isHidden?: Maybe<Scalars["Boolean"]["output"]>;
  label: Scalars["String"]["output"];
  mappingKey: Scalars["String"]["output"];
  optionsAutofill?: Maybe<AutofillObject>;
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
};

/** Paginated results of FieldObject */
export type FieldObjectPaginated = {
  __typename?: "FieldObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<FieldObject>>;
};

export enum FieldType {
  CHECKBOX = "CHECKBOX",
  DATE = "DATE",
  IMAGE = "IMAGE",
  INITIAL = "INITIAL",
  NUMBER = "NUMBER",
  RADIO = "RADIO",
  SELECT = "SELECT",
  SIGNATURE = "SIGNATURE",
  SIGNED_DATE = "SIGNED_DATE",
  TEXT = "TEXT",
  TEXTAREA = "TEXTAREA",
}

export type FieldsToColumnListFilterArgs = {
  documentCategory?: InputMaybe<DocumentCategory>;
};

export type FieldsToColumnObject = {
  __typename?: "FieldsToColumnObject";
  columnName: Scalars["String"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  fieldType: FieldType;
  fields: Array<FieldObject>;
  id: Scalars["ID"]["output"];
  transformAutofill?: Maybe<AutofillObject>;
  visibility: ColumnVisibility;
};

/** Paginated results of FieldsToColumnObject */
export type FieldsToColumnObjectPaginated = {
  __typename?: "FieldsToColumnObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<FieldsToColumnObject>>;
};

export type FileObject = {
  __typename?: "FileObject";
  fileName: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type FileUploadIdInput = {
  customDocumentName?: InputMaybe<Scalars["String"]["input"]>;
  customDocumentType?: InputMaybe<ListingDocumentTypeEnum>;
  file: Scalars["File"]["input"];
  id?: InputMaybe<Scalars["String"]["input"]>;
  listingDocumentTypeId?: InputMaybe<Scalars["String"]["input"]>;
};

/** Reason why an item was filtered out during extraction */
export enum FilterReason {
  INSUFFICIENT_INTERSECTION = "INSUFFICIENT_INTERSECTION",
  LOW_CONFIDENCE = "LOW_CONFIDENCE",
}

export type FilteredOutItemObject = {
  __typename?: "FilteredOutItemObject";
  boundingBox: Scalars["JSON"]["output"];
  confidence?: Maybe<Scalars["Float"]["output"]>;
  fieldType: FieldType;
  filterReason: FilterReason;
  intersectionOverArea?: Maybe<Scalars["Float"]["output"]>;
  mappingKey: Scalars["String"]["output"];
  pageNumber: Scalars["Float"]["output"];
  targetConfidence?: Maybe<Scalars["Float"]["output"]>;
  targetIntersection?: Maybe<Scalars["Float"]["output"]>;
  text: Scalars["String"]["output"];
};

export enum FinancingType {
  CASH = "CASH",
  CONVENTIONAL = "CONVENTIONAL",
  FHA = "FHA",
  OTHER = "OTHER",
  USDA = "USDA",
  VA = "VA",
}

export type FindMlsAgentByMlsIdInput = {
  agentMlsId: Scalars["String"]["input"];
  mlsOSN: Scalars["String"]["input"];
};

export type FindMlsAgentInput = {
  mlsId?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type FindMlsAgentPayload = {
  __typename?: "FindMLSAgentPayload";
  mls?: Maybe<MlsObject>;
  mlsAgent?: Maybe<ResoMemberObject>;
  office?: Maybe<ResoOfficeObject>;
};

export type FindMlsAgentsByNameInput = {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  mlsOSN: Scalars["String"]["input"];
};

export type FindMlsAgentsByPhoneNumberInput = {
  mlsOSNs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  phoneNumber: Scalars["String"]["input"];
};

export type FindMlsListingByAddressInput = {
  addressInput: AddressInput;
  onlyLiveStatuses?: Scalars["Boolean"]["input"];
};

export type FindUserCapturedPropertyDetailsByAddressInput = {
  addressInput: AddressInput;
};

export type FolderMetadata = {
  __typename?: "FolderMetadata";
  folderName: Scalars["String"]["output"];
  folderUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  organizationUuid: Scalars["String"]["output"];
  platform?: Maybe<Scalars["String"]["output"]>;
  stage?: Maybe<TransactionStageType>;
  uuid: Scalars["String"]["output"];
};

export type FolderNameValidationStageKeywordMappingInput = {
  action: FolderNameValidationStageOverrideAction;
  keyword: Scalars["String"]["input"];
  transactionStageType?: InputMaybe<TransactionStageType>;
};

export type FolderNameValidationStageKeywordMappingObject = {
  __typename?: "FolderNameValidationStageKeywordMappingObject";
  action: FolderNameValidationStageOverrideAction;
  keyword: Scalars["String"]["output"];
  transactionStageType?: Maybe<TransactionStageType>;
};

export enum FolderNameValidationStageOverrideAction {
  ASSIGN_STAGE = "ASSIGN_STAGE",
  IGNORE = "IGNORE",
}

export type FolderValidationResult = {
  __typename?: "FolderValidationResult";
  errorCount: Scalars["Int"]["output"];
  folder: FolderMetadata;
  hasRequiredDocumentMissing: Scalars["Boolean"]["output"];
  pipelineValidations: Array<ProductionPipelineValidationResult>;
  warningCount: Scalars["Int"]["output"];
};

export type FollowListingInput = {
  id: Scalars["String"]["input"];
  reason: StorefrontSubscriptionReason;
};

export type FormulaTestCaseInput = {
  expected: Scalars["String"]["input"];
  llmOutput?: InputMaybe<Scalars["Boolean"]["input"]>;
  values: Scalars["JSONObject"]["input"];
};

export type FormulaTestCaseObject = {
  __typename?: "FormulaTestCaseObject";
  expected: Scalars["String"]["output"];
  llmOutput?: Maybe<Scalars["Boolean"]["output"]>;
  values: Scalars["JSONObject"]["output"];
};

export type GenericRuleValidationObject = {
  __typename?: "GenericRuleValidationObject";
  focusFieldMappingKeys?: Maybe<Array<Scalars["String"]["output"]>>;
  hasError: Scalars["Boolean"]["output"];
  hasWarning: Scalars["Boolean"]["output"];
  inputValues?: Maybe<Array<RuleValidationInputValue>>;
  isDisabled: Scalars["Boolean"]["output"];
  isEnabled: Scalars["Boolean"]["output"];
  message: Scalars["String"]["output"];
  output?: Maybe<Scalars["Value"]["output"]>;
  passedRequirement: Scalars["Boolean"]["output"];
  rule: RuleObject;
};

export type GenericRuleValidationResult = {
  __typename?: "GenericRuleValidationResult";
  hasError?: Maybe<Scalars["Boolean"]["output"]>;
  hasWarning?: Maybe<Scalars["Boolean"]["output"]>;
  inputValues?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
  message?: Maybe<Scalars["String"]["output"]>;
  output?: Maybe<Scalars["String"]["output"]>;
  passedRequirement?: Maybe<Scalars["Boolean"]["output"]>;
};

export type GeoObject = {
  __typename?: "GeoObject";
  lat: Scalars["Float"]["output"];
  lng: Scalars["Float"]["output"];
};

export type GeoPointObject = {
  __typename?: "GeoPointObject";
  lat: Scalars["Float"]["output"];
  lon: Scalars["Float"]["output"];
};

export type GetAiConversationSessionFileSignedUrlInput = {
  file: Scalars["String"]["input"];
  threadId: Scalars["ID"]["input"];
};

export type GetBoaByShareLinkTokenInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type GetDocumentVersionInfoInput = {
  file: Scalars["File"]["input"];
};

export type GetDocumentVersionInfoPayload = {
  __typename?: "GetDocumentVersionInfoPayload";
  documentType: DocumentType;
  form: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  searchRegex?: Maybe<Scalars["String"]["output"]>;
  usState: UsState;
  version: Scalars["String"]["output"];
};

export type GetIngestionDocumentValidationErrorReviewsInput = {
  contractDocumentUuid?: InputMaybe<Scalars["String"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentValidationId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId: Scalars["ID"]["input"];
};

export type GetIngestionDocumentValidationFeedbackInput = {
  ingestionDocumentValidationId: Scalars["ID"]["input"];
};

export type GetIngestionFolderValidationErrorReviewsInput = {
  ingestionFolderValidationId: Scalars["ID"]["input"];
};

export type GetIngestionFolderValidationFeedbackInput = {
  ingestionFolderValidationId: Scalars["ID"]["input"];
};

export type GetListingReportByShareLinkTokenInput = {
  filters?: InputMaybe<ReportFiltersInput>;
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["ID"]["input"]>;
  token: Scalars["String"]["input"];
  useIndigoData?: Scalars["Boolean"]["input"];
};

export type GetListingReportPdfInput = {
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GetListingReportShareLinksInput = {
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type GetOfferForBuyersAgentInput = {
  offerId: Scalars["ID"]["input"];
};

export type GetOfferForListingAgentInput = {
  offerId: Scalars["ID"]["input"];
};

export type GetOfferMetadataObject = {
  __typename?: "GetOfferMetadataObject";
  additional_earnest_money_date?: Maybe<Scalars["String"]["output"]>;
  additional_inspection_days: Scalars["Float"]["output"];
  appraisal_contingency: Scalars["String"]["output"];
  buyer_broker_compensation_from_seller: Scalars["Float"]["output"];
  buyer_broker_compensation_from_seller_percent: Scalars["Float"]["output"];
  buyer_name: Scalars["String"]["output"];
  buyer_signed: Scalars["Boolean"]["output"];
  buyer_signed_date?: Maybe<Scalars["String"]["output"]>;
  close_date?: Maybe<Scalars["String"]["output"]>;
  closing_attorney_name: Scalars["String"]["output"];
  co_buyer_name: Scalars["String"]["output"];
  co_seller_name: Scalars["String"]["output"];
  commission_flat: Scalars["Float"]["output"];
  commission_payer: Scalars["String"]["output"];
  commission_percentage: Scalars["Float"]["output"];
  created_at?: Maybe<Scalars["String"]["output"]>;
  deprecated_contingent: Scalars["Boolean"]["output"];
  due_diligence_end_date?: Maybe<Scalars["String"]["output"]>;
  due_diligence_fee: Scalars["Float"]["output"];
  due_diligence_period_in_days: Scalars["Float"]["output"];
  earnest_money_deposit: Scalars["Float"]["output"];
  earnest_money_deposit_date?: Maybe<Scalars["String"]["output"]>;
  earnest_money_deposit_later: Scalars["Float"]["output"];
  earnest_money_deposit_with_offer: Scalars["Float"]["output"];
  earnest_money_paid_to: Scalars["String"]["output"];
  earnest_money_paid_within_timeframe: Scalars["String"]["output"];
  financing_appraisal_deadline?: Maybe<Scalars["String"]["output"]>;
  financing_type: Scalars["String"]["output"];
  further_conditions: Scalars["String"]["output"];
  has_due_diligence_condition: Scalars["Boolean"]["output"];
  has_financing_contingency: Scalars["Boolean"]["output"];
  has_home_sale_contingency: Scalars["Boolean"]["output"];
  hoa_docs_within_days: Scalars["Float"]["output"];
  home_warranty_amount: Scalars["String"]["output"];
  homeowners_insurance_deadline_days: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  indigo_offer_status: Scalars["String"]["output"];
  inspection_period_days: Scalars["String"]["output"];
  is_entity_buyer: Scalars["Boolean"]["output"];
  is_entity_seller: Scalars["Boolean"]["output"];
  listing_agent_broker_name: Scalars["String"]["output"];
  listing_agent_email: Scalars["String"]["output"];
  listing_agent_name: Scalars["String"]["output"];
  loan_approval_deadline_days: Scalars["String"]["output"];
  metadata: Scalars["JSONObject"]["output"];
  metadata_s3_key: Scalars["String"]["output"];
  mls_listing_id: Scalars["String"]["output"];
  mortgage_commitment_date: Scalars["String"]["output"];
  offer_accepted: Scalars["Boolean"]["output"];
  organization_id: Scalars["String"]["output"];
  participants: Scalars["JSONObject"]["output"];
  pending_date?: Maybe<Scalars["String"]["output"]>;
  possession: Scalars["String"]["output"];
  property_city: Scalars["String"]["output"];
  property_full_address: Scalars["String"]["output"];
  property_state: Scalars["String"]["output"];
  property_street_address: Scalars["String"]["output"];
  property_tax_id: Scalars["String"]["output"];
  property_unit: Scalars["String"]["output"];
  property_zip_code: Scalars["String"]["output"];
  purchase_price: Scalars["Float"]["output"];
  seller_concessions: Scalars["Float"]["output"];
  seller_concessions_percent: Scalars["Float"]["output"];
  seller_disclosure_deadline?: Maybe<Scalars["String"]["output"]>;
  seller_name: Scalars["String"]["output"];
  seller_signed: Scalars["Boolean"]["output"];
  seller_signed_date?: Maybe<Scalars["String"]["output"]>;
  selling_agent_broker_name: Scalars["String"]["output"];
  selling_agent_email: Scalars["String"]["output"];
  selling_agent_name: Scalars["String"]["output"];
  survey_ordered_by: Scalars["String"]["output"];
  survey_type: Scalars["String"]["output"];
  team_name: Scalars["String"]["output"];
  termination_fee: Scalars["Float"]["output"];
  title_chosen_by: Scalars["String"]["output"];
  transaction_side: Scalars["String"]["output"];
  updated_at: Scalars["Int"]["output"];
  warranty_ordered_by: Scalars["String"]["output"];
  warranty_paid_by: Scalars["String"]["output"];
};

export type GetOfferRecsInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
};

export type GetOpenHouseGuestbookStatusInput = {
  openHouseId: Scalars["String"]["input"];
};

export type GetOrCreateAgentByPhoneNumberInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  licenses: Array<UserLicenseInput>;
  mlsId: Scalars["String"]["input"];
  phone: Scalars["String"]["input"];
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
  profilePictureURL?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetPropertyDetailsFailed = {
  __typename?: "GetPropertyDetailsFailed";
  error: Scalars["String"]["output"];
};

export type GetPropertyDetailsInput = {
  address: AddressInput;
  coords?: InputMaybe<PointInput>;
};

export type GetPropertyDetailsPayload = {
  __typename?: "GetPropertyDetailsPayload";
  location: Location;
  result: GetPropertyDetailsResult;
};

export type GetPropertyDetailsResult =
  | GetPropertyDetailsFailed
  | GetPropertyDetailsSuccess;

export type GetPropertyDetailsSuccess = {
  __typename?: "GetPropertyDetailsSuccess";
  areaSqFt?: Maybe<Scalars["Float"]["output"]>;
  bathsFull?: Maybe<Scalars["Int"]["output"]>;
  bathsHalf?: Maybe<Scalars["Int"]["output"]>;
  bedrooms?: Maybe<Scalars["Int"]["output"]>;
  propertySubtype?: Maybe<MlsListingSubType>;
  propertyType?: Maybe<MlsListingType>;
  schoolDistrict?: Maybe<Scalars["String"]["output"]>;
  subdivision?: Maybe<Scalars["String"]["output"]>;
  yearBuilt?: Maybe<Scalars["Int"]["output"]>;
};

export type GetSignedUrlsInput = {
  keys: Array<Scalars["String"]["input"]>;
};

export type GetSignedUrlsPayload = {
  __typename?: "GetSignedUrlsPayload";
  urls: Array<SignedUrlPayload>;
};

export type GetUserCapturedPropertyDetailsByTokenInput = {
  propertyDetailsId: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type GetUserInput = {
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
  userName?: InputMaybe<Scalars["String"]["input"]>;
};

export type GuestbookSignerObject = {
  __typename?: "GuestbookSignerObject";
  isSubscribed: Scalars["Boolean"]["output"];
  isWorkingWithAgent?: Maybe<Scalars["Boolean"]["output"]>;
  office?: Maybe<ResoOfficeObject>;
  openHouseId?: Maybe<Scalars["String"]["output"]>;
  signedAt: Scalars["DateTime"]["output"];
  user: UserObject;
};

export type GuestbookSignersObject = {
  __typename?: "GuestbookSignersObject";
  signers: Array<GuestbookSignerObject>;
};

export type HasSignedListingGuestbookObject = {
  __typename?: "HasSignedListingGuestbookObject";
  hasSigned: Scalars["Boolean"]["output"];
};

export type IndigoContractObject = {
  __typename?: "IndigoContractObject";
  contract?: Maybe<ContractObject>;
  contractId: Scalars["String"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  documentType: DocumentType;
  id: Scalars["ID"]["output"];
  party: PartyObject;
};

/** Paginated results of IndigoContractObject */
export type IndigoContractObjectPaginated = {
  __typename?: "IndigoContractObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<IndigoContractObject>>;
};

export type IndigoContractsForCurrentUserFilters = {
  documentType?: InputMaybe<DocumentType>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  partyId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type IndigoOffersMetadata = {
  __typename?: "IndigoOffersMetadata";
  confidence: ConfidenceLevel;
  distanceMiles: Scalars["Float"]["output"];
  timePeriodMonths: Scalars["Float"]["output"];
};

export type IndigoOffersSource = {
  __typename?: "IndigoOffersSource";
  metadata: IndigoOffersMetadata;
  type: MarketDataSourceType;
};

export type IngestionDocumentObject = {
  __typename?: "IngestionDocumentObject";
  complianceGroupId?: Maybe<Scalars["String"]["output"]>;
  complianceGroupMetadata?: Maybe<ComplianceGroupMetadataObject>;
  complianceStatus?: Maybe<Scalars["String"]["output"]>;
  complianceStatusId?: Maybe<Scalars["String"]["output"]>;
  contractDocumentPages?: Maybe<Scalars["JSONObject"]["output"]>;
  contractDocuments: Array<ContractDocumentObject>;
  docPageErrorMessage?: Maybe<Scalars["JSONObject"]["output"]>;
  documentCreatedAt: Scalars["DateTime"]["output"];
  documentId: Scalars["String"]["output"];
  documentML?: Maybe<DocumentMlObject>;
  documentName: Scalars["String"]["output"];
  documentUpdatedAt: Scalars["DateTime"]["output"];
  fields?: Maybe<Scalars["JSONObject"]["output"]>;
  fileUrl?: Maybe<Scalars["String"]["output"]>;
  folderId?: Maybe<Scalars["String"]["output"]>;
  folderName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  ingestionFolder: IngestionFolderObject;
  isArchived: Scalars["Boolean"]["output"];
  isBlank: Scalars["Boolean"]["output"];
  isClassified: Scalars["Boolean"]["output"];
  isValidDocumentMessageForExtraction?: Maybe<Scalars["String"]["output"]>;
  needsReview?: Maybe<Scalars["Boolean"]["output"]>;
  offerGroup?: Maybe<OfferGroupObject>;
  s3Bucket: Scalars["String"]["output"];
  s3Key: Scalars["String"]["output"];
  validationRoutingDebug?: Maybe<IngestionDocumentValidationRoutingDebugObject>;
  version: Scalars["String"]["output"];
  wasAutoApproved: Scalars["Boolean"]["output"];
};

export type IngestionDocumentReviewObject = {
  __typename?: "IngestionDocumentReviewObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  ingestionDocument: IngestionDocumentObject;
  reason?: Maybe<Scalars["String"]["output"]>;
  reviewedAt: Scalars["DateTime"]["output"];
  reviewedByUserUuid: Scalars["ID"]["output"];
  status: IngestionDocumentReviewStatus;
  submission?: Maybe<ValidationReviewSubmissionObject>;
  updatedAt: Scalars["DateTime"]["output"];
  version: Scalars["String"]["output"];
};

export enum IngestionDocumentReviewStatus {
  APPROVED = "APPROVED",
  RETURNED = "RETURNED",
}

export type IngestionDocumentValidationErrorReviewObject = {
  __typename?: "IngestionDocumentValidationErrorReviewObject";
  contractDocumentUuid?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdByUserUuid: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  ingestionDocument?: Maybe<IngestionDocumentObject>;
  ingestionDocumentValidation?: Maybe<IngestionDocumentValidationObject>;
  isAddedByUser: Scalars["Boolean"]["output"];
  isHidden: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  pageNumber?: Maybe<Scalars["Int"]["output"]>;
  ruleUuid?: Maybe<Scalars["String"]["output"]>;
  submission?: Maybe<ValidationReviewSubmissionObject>;
  updatedAt: Scalars["DateTime"]["output"];
  updatedByUserUuid: Scalars["String"]["output"];
  validationIssueGroup?: Maybe<ValidationIssueGroupObject>;
};

export type IngestionDocumentValidationFeedbackObject = {
  __typename?: "IngestionDocumentValidationFeedbackObject";
  comment?: Maybe<Scalars["String"]["output"]>;
  contractDocumentUuid?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdByUserUuid: Scalars["String"]["output"];
  feedbackType: FeedbackType;
  id: Scalars["ID"]["output"];
  ingestionDocumentValidation?: Maybe<IngestionDocumentValidationObject>;
  ruleUuid?: Maybe<Scalars["String"]["output"]>;
  source: FeedbackSource;
  updatedAt: Scalars["DateTime"]["output"];
  updatedByUserUuid: Scalars["String"]["output"];
};

export type IngestionDocumentValidationObject = {
  __typename?: "IngestionDocumentValidationObject";
  aiAnalysis: Array<Scalars["JSONObject"]["output"]>;
  aiErrorCount: Scalars["Int"]["output"];
  aiValidationResults: Array<Scalars["JSONObject"]["output"]>;
  aiWarningCount: Scalars["Int"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  errorCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  ingestionDocument: IngestionDocumentObject;
  isCurrent: Scalars["Boolean"]["output"];
  transactionStage?: Maybe<TransactionStageObject>;
  updatedAt: Scalars["DateTime"]["output"];
  validationResults: Array<Scalars["JSONObject"]["output"]>;
  version: Scalars["String"]["output"];
  warningCount: Scalars["Int"]["output"];
};

export type IngestionDocumentValidationRoutingDebugObject = {
  __typename?: "IngestionDocumentValidationRoutingDebugObject";
  complianceGroupMetadata?: Maybe<ComplianceGroupMetadataObject>;
  isFolderNameOverrideEnabled: Scalars["Boolean"]["output"];
  matchedFolderNameKeywordMapping?: Maybe<FolderNameValidationStageKeywordMappingObject>;
  shouldIgnore: Scalars["Boolean"]["output"];
  source: DocumentValidationStageSelectionSource;
  transactionStageType?: Maybe<TransactionStageType>;
};

export type IngestionFolderCountsByPipelineFilterArgs = {
  organizationUuid: Scalars["ID"]["input"];
};

export type IngestionFolderCountsByPipelineResult = {
  __typename?: "IngestionFolderCountsByPipelineResult";
  pipelineCounts: Array<IngestionFolderPipelineCount>;
};

export type IngestionFolderCountsByStageFilterArgs = {
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  transactionPipelineId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type IngestionFolderCountsByStageResult = {
  __typename?: "IngestionFolderCountsByStageResult";
  stageCounts: Array<IngestionFolderStageCount>;
};

export type IngestionFolderListFilterArgs = {
  activeMlsListingId?: InputMaybe<Scalars["ID"]["input"]>;
  agentSearch?: InputMaybe<Scalars["String"]["input"]>;
  createdAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  folderId?: InputMaybe<Scalars["ID"]["input"]>;
  hasUnsubmittedContractDocs?: InputMaybe<Scalars["Boolean"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  maxDocumentCount?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  normalizedStatus?: InputMaybe<NormalizedTransactionStatus>;
  office?: InputMaybe<Scalars["String"]["input"]>;
  offices?: InputMaybe<Array<Scalars["String"]["input"]>>;
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  platform?: InputMaybe<IngestionPlatform>;
  propertyType?: InputMaybe<TransactionPropertyType>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<TransactionStageType>;
  state?: InputMaybe<UsState>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  transactionPipelineId?: InputMaybe<Scalars["ID"]["input"]>;
  transactionSide?: InputMaybe<TransactionSide>;
  updatedAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  updatedAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type IngestionFolderObject = {
  __typename?: "IngestionFolderObject";
  activeMlsListingId?: Maybe<Scalars["String"]["output"]>;
  aiValidationErrorCount?: Maybe<Scalars["Float"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  dotloopProfileId?: Maybe<Scalars["String"]["output"]>;
  folderCreatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  folderId: Scalars["String"]["output"];
  folderName: Scalars["String"]["output"];
  folderUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  fullyReprocessedAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  ingestionDocuments: Array<IngestionDocumentObject>;
  keyTermColumns?: Maybe<Scalars["JSONObject"]["output"]>;
  keyTerms?: Maybe<Array<KeyTermSection>>;
  metadata: Scalars["JSONObject"]["output"];
  /** @deprecated Use externalGetMLSListingSelection query instead for smarter listing selection */
  mlsListing?: Maybe<MlsListingObject>;
  normalizedFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  normalizedStatus?: Maybe<NormalizedTransactionStatus>;
  offerGroups: Array<OfferGroupObject>;
  organization?: Maybe<OrganizationObject>;
  organizationUuid: Scalars["String"]["output"];
  participants?: Maybe<Participants>;
  platform: IngestionPlatform;
  regularValidationErrorCount?: Maybe<Scalars["Float"]["output"]>;
  stage?: Maybe<TransactionStageType>;
  status: Scalars["String"]["output"];
  syncSnapshot?: Maybe<SyncSnapshotObject>;
  transactionPipeline?: Maybe<TransactionPipelineObject>;
  transactionSide: TransactionSide;
  txPipelineCandidates: Array<TxPipelineCandidateObject>;
  txPipelineMatchedBy?: Maybe<TxPipelineMatchedBy>;
  txPipelineNeedsInvestigationReason: TxPipelineNeedsInvestigationReason;
  txPipelineUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  validationErrorCount?: Maybe<Scalars["Float"]["output"]>;
};

export type IngestionFolderObjectKeyTermsArgs = {
  sortByDatetime?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** Paginated results of IngestionFolderObject */
export type IngestionFolderObjectExternalPaginated = {
  __typename?: "IngestionFolderObjectExternalPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<IngestionFolderObject>>;
};

/** Paginated results of IngestionFolderObject */
export type IngestionFolderObjectInternalPaginated = {
  __typename?: "IngestionFolderObjectInternalPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<IngestionFolderObject>>;
};

/** Paginated results of IngestionFolderObject */
export type IngestionFolderObjectPaginated = {
  __typename?: "IngestionFolderObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<IngestionFolderObject>>;
};

export type IngestionFolderPipelineCount = {
  __typename?: "IngestionFolderPipelineCount";
  count: Scalars["Int"]["output"];
  transactionPipelineId?: Maybe<Scalars["ID"]["output"]>;
};

export type IngestionFolderStageCount = {
  __typename?: "IngestionFolderStageCount";
  count: Scalars["Int"]["output"];
  stage?: Maybe<TransactionStageType>;
};

export type IngestionFolderValidationErrorReviewObject = {
  __typename?: "IngestionFolderValidationErrorReviewObject";
  createdAt: Scalars["DateTime"]["output"];
  createdByUserUuid: Scalars["String"]["output"];
  documentCategory?: Maybe<Scalars["String"]["output"]>;
  documentForm?: Maybe<Scalars["String"]["output"]>;
  documentName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  ingestionFolderValidation?: Maybe<IngestionFolderValidationObject>;
  isAddedByUser: Scalars["Boolean"]["output"];
  isHidden: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  ruleUuid?: Maybe<Scalars["String"]["output"]>;
  submission?: Maybe<ValidationReviewSubmissionObject>;
  updatedAt: Scalars["DateTime"]["output"];
  updatedByUserUuid: Scalars["String"]["output"];
  validationIssueGroup?: Maybe<ValidationIssueGroupObject>;
};

export type IngestionFolderValidationFeedbackObject = {
  __typename?: "IngestionFolderValidationFeedbackObject";
  comment?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  createdByUserUuid: Scalars["String"]["output"];
  feedbackType: FeedbackType;
  id: Scalars["ID"]["output"];
  ingestionFolderValidation?: Maybe<IngestionFolderValidationObject>;
  source: FeedbackSource;
  updatedAt: Scalars["DateTime"]["output"];
  updatedByUserUuid: Scalars["String"]["output"];
};

export type IngestionFolderValidationFiltersInput = {
  createdFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  hasValidationErrors?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Include folders without a transaction pipeline */
  includeNoPipeline?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastUpdatedFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  lastUpdatedTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  organizationIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  transactionPipelineIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  uuids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type IngestionFolderValidationObject = {
  __typename?: "IngestionFolderValidationObject";
  createdAt: Scalars["DateTime"]["output"];
  errorCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  ingestionFolder?: Maybe<IngestionFolderObject>;
  isCurrent: Scalars["Boolean"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
  validatedAt: Scalars["DateTime"]["output"];
  validationResults?: Maybe<Array<Scalars["JSONObject"]["output"]>>;
  version: Scalars["String"]["output"];
};

export type IngestionFolderValidationSearchResponse = {
  __typename?: "IngestionFolderValidationSearchResponse";
  /** If results were capped, this is the limit that was applied. Null if all results returned. */
  cappedToLimit?: Maybe<Scalars["Int"]["output"]>;
  folders: Array<IngestionFolderValidationSearchResult>;
  totalCount: Scalars["Int"]["output"];
};

export type IngestionFolderValidationSearchResult = {
  __typename?: "IngestionFolderValidationSearchResult";
  createdAt: Scalars["DateTime"]["output"];
  folderName: Scalars["String"]["output"];
  lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  lastValidationDate?: Maybe<Scalars["DateTime"]["output"]>;
  metadataFolderId?: Maybe<Scalars["String"]["output"]>;
  normalizedStatus?: Maybe<NormalizedTransactionStatus>;
  organizationId: Scalars["ID"]["output"];
  organizationName: Scalars["String"]["output"];
  platform: Scalars["String"]["output"];
  stage?: Maybe<TransactionStageType>;
  /** Pipeline ID, null if folder has no pipeline */
  transactionPipelineId?: Maybe<Scalars["ID"]["output"]>;
  transactionPipelineName: Scalars["String"]["output"];
  transactionSide?: Maybe<TransactionSide>;
  uuid: Scalars["ID"]["output"];
};

export type IngestionFolderValidationStatusObject = {
  __typename?: "IngestionFolderValidationStatusObject";
  active: Scalars["Int"]["output"];
  delayed: Scalars["Int"]["output"];
  failed: Scalars["Int"]["output"];
  latestValidatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** One of: idle, waiting, active, delayed, completed, failed */
  status: Scalars["String"]["output"];
  total: Scalars["Int"]["output"];
  waiting: Scalars["Int"]["output"];
};

export enum IngestionPlatform {
  BROKERMINT = "BROKERMINT",
  DOCUSIGN = "DOCUSIGN",
  DOTLOOP = "DOTLOOP",
  SKYSLOPE = "SKYSLOPE",
  ZIPFORM = "ZIPFORM",
}

export type InputFormatInput = {
  options: InputFormatOptionsInput;
  type: InputFormatType;
};

export type InputFormatObject = {
  __typename?: "InputFormatObject";
  options: InputFormatOptionsObject;
  type: InputFormatType;
};

export type InputFormatOptionsInput = {
  currencySymbol?: InputMaybe<Scalars["String"]["input"]>;
  formatString?: InputMaybe<Scalars["String"]["input"]>;
  precision?: InputMaybe<Scalars["Float"]["input"]>;
};

export type InputFormatOptionsObject = {
  __typename?: "InputFormatOptionsObject";
  currencySymbol?: Maybe<Scalars["String"]["output"]>;
  formatString?: Maybe<Scalars["String"]["output"]>;
  precision?: Maybe<Scalars["Float"]["output"]>;
};

export enum InputFormatType {
  CURRENCY = "CURRENCY",
  DATE = "DATE",
  NUMBER = "NUMBER",
  PERCENTAGE = "PERCENTAGE",
}

export type InsuranceAgentContactObject = PartnerContactBaseObject & {
  __typename?: "InsuranceAgentContactObject";
  contactType: ContactType;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  partner?: Maybe<OrganizationPartnerObject>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type IntegrationClientObject = {
  __typename?: "IntegrationClientObject";
  clientType: IntegrationClientType;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  logoFile?: Maybe<FileObject>;
  provider: IntegrationProvider;
};

export enum IntegrationClientType {
  API_KEY = "API_KEY",
  OAUTH = "OAUTH",
}

export type IntegrationConnectionObject = {
  __typename?: "IntegrationConnectionObject";
  id: Scalars["ID"]["output"];
  integrationClient?: Maybe<IntegrationClientObject>;
  organization?: Maybe<OrganizationObject>;
  providerAccountName: Scalars["String"]["output"];
  user?: Maybe<PublicUserObject>;
};

export type IntegrationConnectionsForOrganizationInput = {
  organizationId: Scalars["ID"]["input"];
};

export enum IntegrationProvider {
  DARWIN = "DARWIN",
  FUB = "FUB",
}

export type InternalBatchAddUserInput = {
  accessRole: AccessRole;
  clientRowId: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phoneNumber: Scalars["String"]["input"];
};

export type InternalBatchAddUserResult = {
  __typename?: "InternalBatchAddUserResult";
  clientRowId: Scalars["String"]["output"];
  error?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  user?: Maybe<InternalOrgUserObject>;
};

export type InternalBatchAddUsersResult = {
  __typename?: "InternalBatchAddUsersResult";
  failureCount: Scalars["Int"]["output"];
  results: Array<InternalBatchAddUserResult>;
  successCount: Scalars["Int"]["output"];
};

export type InternalBatchAddUsersToOrganizationInput = {
  organizationId: Scalars["ID"]["input"];
  users: Array<InternalBatchAddUserInput>;
};

export type InternalCreateOrganizationInput = {
  name: Scalars["String"]["input"];
  organizationBranchType: OrganizationBranchType;
  organizationType: OrganizationType;
};

export type InternalDarwinSyncRunDetailPayload = {
  __typename?: "InternalDarwinSyncRunDetailPayload";
  context: DarwinSyncRunContextPayload;
  decisionTrace?: Maybe<DarwinSyncRunDecisionTracePayload>;
  initiatedByLabel: Scalars["String"]["output"];
  initiatedByUser?: Maybe<DarwinSyncRunInitiatedByUserPayload>;
  joinHints?: Maybe<DarwinSyncRunJoinHintsPayload>;
  outcomes: DarwinSyncRunOutcomesPayload;
  /** Raw JSONB summaries. Only populated when includeRaw=true. */
  rawSummaries?: Maybe<DarwinSyncRunRawSummariesPayload>;
  selectionIntent?: Maybe<DarwinSyncRunSelectionIntentPayload>;
  sourceSnapshot?: Maybe<DarwinSyncRunSourceSnapshotPayload>;
  syncRunId: Scalars["String"]["output"];
  timeline: DarwinSyncRunTimelinePayload;
};

export type InternalDarwinSyncRunInput = {
  /** Include raw JSONB summaries (admin-only debug reveal). Defaults to false. */
  includeRaw?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** Sync run ID to look up */
  syncRunId: Scalars["String"]["input"];
};

export type InternalDarwinSyncRunListItem = {
  __typename?: "InternalDarwinSyncRunListItem";
  appliedCount?: Maybe<Scalars["Int"]["output"]>;
  cause: Scalars["String"]["output"];
  completedAt?: Maybe<Scalars["DateTime"]["output"]>;
  durationMs?: Maybe<Scalars["Int"]["output"]>;
  failureCode?: Maybe<Scalars["String"]["output"]>;
  folderName?: Maybe<Scalars["String"]["output"]>;
  ingestionFolderUuid?: Maybe<Scalars["ID"]["output"]>;
  initiatedByUserUuid?: Maybe<Scalars["String"]["output"]>;
  needsDownstreamJoin?: Maybe<Scalars["Boolean"]["output"]>;
  organizationUuid: Scalars["ID"]["output"];
  rootCauseCategory?: Maybe<Scalars["String"]["output"]>;
  selectedCount?: Maybe<Scalars["Int"]["output"]>;
  skipCode?: Maybe<Scalars["String"]["output"]>;
  skippedCount?: Maybe<Scalars["Int"]["output"]>;
  source: Scalars["String"]["output"];
  startedAt: Scalars["DateTime"]["output"];
  status: DarwinSyncRunStatus;
  syncRunId: Scalars["String"]["output"];
};

export enum InternalDarwinSyncRunRawField {
  KEY_TERMS_SNAPSHOT_JSON = "KEY_TERMS_SNAPSHOT_JSON",
  RESULT_SUMMARY_JSON = "RESULT_SUMMARY_JSON",
}

export type InternalDarwinSyncRunRawFieldInput = {
  field: InternalDarwinSyncRunRawField;
  syncRunId: Scalars["String"]["input"];
};

export type InternalDarwinSyncRunsInput = {
  /** Filter by ingestion folder UUID */
  ingestionFolderUuid?: InputMaybe<Scalars["ID"]["input"]>;
  /** Maximum number of results (default 50, max 200) */
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  /** Offset for pagination */
  offset?: InputMaybe<Scalars["Int"]["input"]>;
  /** Filter by organization UUID */
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  /** Filter runs started at or after this date */
  startedAtFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter runs started at or before this date */
  startedAtTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  /** Filter by run status */
  status?: InputMaybe<DarwinSyncRunStatus>;
};

export type InternalDarwinSyncRunsPayload = {
  __typename?: "InternalDarwinSyncRunsPayload";
  items: Array<InternalDarwinSyncRunListItem>;
};

export type InternalEssentialsNotificationActionExecuteInput = {
  actionKind: DebugActionKind;
  previewToken: Scalars["String"]["input"];
  targetIds: Array<Scalars["ID"]["input"]>;
};

export type InternalEssentialsNotificationActionPreviewInput = {
  actionKind: DebugActionKind;
  targetIds: Array<Scalars["ID"]["input"]>;
};

export type InternalEssentialsNotificationFolderDebugInput = {
  folderId: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InternalEssentialsNotificationFolderDebugObject = {
  __typename?: "InternalEssentialsNotificationFolderDebugObject";
  candidates: Array<SimulationCandidateResult>;
  excludedTemplates: Array<DebugTemplateSource>;
  folderId: Scalars["String"]["output"];
  organizationUuid: Scalars["ID"]["output"];
  stage?: Maybe<TransactionStageType>;
  transactionSide?: Maybe<TransactionSide>;
};

export type InternalEssentialsNotificationLogDebugObject = {
  __typename?: "InternalEssentialsNotificationLogDebugObject";
  autofillRendering?: Maybe<DebugAutofillRendering>;
  delivery?: Maybe<DebugDelivery>;
  identity: DebugLogIdentity;
  lifecycle: DebugLogLifecycle;
  normalizedFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  partnerConfig?: Maybe<DebugPartnerConfig>;
  rawLog?: Maybe<Scalars["JSONObject"]["output"]>;
  recipientResolution: DebugRecipientResolution;
  routingDecisions: DebugRoutingDecisions;
  stageIntroSource?: Maybe<DebugStageIntroSource>;
  templateSource?: Maybe<DebugTemplateSource>;
};

export type InternalEssentialsNotificationLogItem = {
  __typename?: "InternalEssentialsNotificationLogItem";
  createdAt: Scalars["DateTime"]["output"];
  displayStatus: DebugLogDisplayStatus;
  id: Scalars["ID"]["output"];
  isDryRun: Scalars["Boolean"]["output"];
  logId: Scalars["Int"]["output"];
  logUuid: Scalars["ID"]["output"];
  notificationKind: NotificationLogKind;
  notificationType?: Maybe<NotificationType>;
  partnerName?: Maybe<Scalars["String"]["output"]>;
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

/** Paginated results of InternalEssentialsNotificationLogItem */
export type InternalEssentialsNotificationLogItemPaginated = {
  __typename?: "InternalEssentialsNotificationLogItemPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<InternalEssentialsNotificationLogItem>>;
};

export type InternalGetValidationReportDataInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InternalIngestionDocumentsForFolderInput = {
  externalFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type InternalIngestionFolderListForOrganizationInput = {
  agentSearch?: InputMaybe<Scalars["String"]["input"]>;
  createdAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  createdAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
  hasUnsubmittedContractDocs?: InputMaybe<Scalars["Boolean"]["input"]>;
  ingestionFolderId?: InputMaybe<Scalars["ID"]["input"]>;
  maxDocumentCount?: InputMaybe<Scalars["Int"]["input"]>;
  needsReview?: InputMaybe<Scalars["Boolean"]["input"]>;
  normalizedStatus?: InputMaybe<NormalizedTransactionStatus>;
  office?: InputMaybe<Scalars["String"]["input"]>;
  offices?: InputMaybe<Array<Scalars["String"]["input"]>>;
  organizationId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyType?: InputMaybe<TransactionPropertyType>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  stage?: InputMaybe<TransactionStageType>;
  state?: InputMaybe<UsState>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  statuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
  transactionSide?: InputMaybe<TransactionSide>;
  updatedAtEnd?: InputMaybe<Scalars["DateTime"]["input"]>;
  updatedAtStart?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type InternalIngestionFolderValidationStatusInput = {
  baselineValidatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  ingestionFolderId: Scalars["ID"]["input"];
  startedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type InternalIntegrationClientObject = {
  __typename?: "InternalIntegrationClientObject";
  additionalConfig?: Maybe<Scalars["JSONObject"]["output"]>;
  clientId?: Maybe<Scalars["String"]["output"]>;
  clientType: IntegrationClientType;
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  logoFile?: Maybe<FileObject>;
  provider: IntegrationProvider;
  redirectUri?: Maybe<Scalars["String"]["output"]>;
};

export type InternalIntegrationClientPayload = {
  __typename?: "InternalIntegrationClientPayload";
  integrationClient: InternalIntegrationClientObject;
};

export type InternalOrgUserObject = {
  __typename?: "InternalOrgUserObject";
  accessRole: AccessRole;
  email?: Maybe<Scalars["String"]["output"]>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  lastName?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  roles: Array<Roles>;
  userUuid: Scalars["String"]["output"];
};

/** Paginated results of InternalOrgUserObject */
export type InternalOrgUserObjectPaginated = {
  __typename?: "InternalOrgUserObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<InternalOrgUserObject>>;
};

export type InvitationObject = {
  __typename?: "InvitationObject";
  acceptedAt?: Maybe<Scalars["DateTime"]["output"]>;
  expiresAt: Scalars["DateTime"]["output"];
  id: Scalars["String"]["output"];
  invitee: UserObject;
  inviteeAccessRole?: Maybe<AccessRole>;
  inviter: UserObject;
  notificationMeta?: Maybe<Scalars["JSONObject"]["output"]>;
  revokedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Paginated results of InvitationObject */
export type InvitationObjectPaginated = {
  __typename?: "InvitationObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<InvitationObject>>;
};

export type IsFollowingListingObject = {
  __typename?: "IsFollowingListingObject";
  isFollowingListing: Scalars["Boolean"]["output"];
};

export type JoinOrganizationInput = {
  organizationId: Scalars["ID"]["input"];
};

export type KeyTerm = {
  __typename?: "KeyTerm";
  context: KeyTermRecommendationContext;
  label?: Maybe<Scalars["String"]["output"]>;
  recommendation: Scalars["Float"]["output"];
  type: KeyTermType;
  unit: KeyTermUnit;
};

export type KeyTermCalculatedMetadata = {
  __typename?: "KeyTermCalculatedMetadata";
  contractDocumentId: Scalars["String"]["output"];
  ingestionDocumentId: Scalars["String"]["output"];
};

export type KeyTermError = {
  __typename?: "KeyTermError";
  label?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  sourceType: MarketDataSourceType;
  type: KeyTermType;
  unit: KeyTermUnit;
};

export type KeyTermField = {
  __typename?: "KeyTermField";
  fieldFormat?: Maybe<InputFormatObject>;
  fieldLabel: Scalars["String"]["output"];
  fieldType: Scalars["String"]["output"];
  isEditable: Scalars["Boolean"]["output"];
  /** Normalized column name (keyof NormalizedOfferFieldValues for now) */
  key: Scalars["String"]["output"];
  value?: Maybe<Scalars["Value"]["output"]>;
  values: Array<KeyTermValue>;
};

export type KeyTermInput = {
  term: Scalars["String"]["input"];
};

export type KeyTermInputs = {
  keyTerms: Array<KeyTermInput>;
};

export type KeyTermMetadata =
  | KeyTermCalculatedMetadata
  | KeyTermUserOverrideMetadata;

export type KeyTermRecommendationContext = {
  __typename?: "KeyTermRecommendationContext";
  marketData: MarketDataRange;
  marketDataPercentages?: Maybe<MarketDataPercentages>;
  source: MarketDataSource;
};

export type KeyTermResult = KeyTerm | KeyTermError;

export type KeyTermSection = {
  __typename?: "KeyTermSection";
  children?: Maybe<Array<KeyTermSection>>;
  description: Scalars["String"]["output"];
  fields: Array<KeyTermField>;
  title: Scalars["String"]["output"];
};

export enum KeyTermSourceType {
  CALCULATED = "CALCULATED",
  USER_OVERRIDE = "USER_OVERRIDE",
}

export enum KeyTermType {
  DUE_DILIGENCE = "DUE_DILIGENCE",
  DUE_DILIGENCE_DAYS = "DUE_DILIGENCE_DAYS",
  EARNEST_MONEY = "EARNEST_MONEY",
  OFFER_TO_CLOSE_DAYS = "OFFER_TO_CLOSE_DAYS",
  PURCHASE_PRICE = "PURCHASE_PRICE",
  SELLER_CONCESSIONS = "SELLER_CONCESSIONS",
  TERMINATION_FEE = "TERMINATION_FEE",
}

export enum KeyTermUnit {
  DAYS = "DAYS",
  USD = "USD",
}

export type KeyTermUserOverrideMetadata = {
  __typename?: "KeyTermUserOverrideMetadata";
  overriddenBy: PublicUserObject;
};

export type KeyTermValue = {
  __typename?: "KeyTermValue";
  isCurrent: Scalars["Boolean"]["output"];
  metadata?: Maybe<KeyTermMetadata>;
  source: KeyTermSourceType;
  sourceLabel: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
  validationError?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["Value"]["output"]>;
};

export type LlmExtractSchemaInput = {
  description: Scalars["String"]["input"];
  enumValues?: InputMaybe<Array<Scalars["String"]["input"]>>;
  key: Scalars["String"]["input"];
  outputType?: LlmOutputSchemaType;
};

export type LlmExtractSchemaObject = {
  __typename?: "LLMExtractSchemaObject";
  description: Scalars["String"]["output"];
  enumValues?: Maybe<Array<Scalars["String"]["output"]>>;
  fieldType?: Maybe<FieldType>;
  key: Scalars["String"]["output"];
  outputType: LlmOutputSchemaType;
};

export enum LlmOutputSchemaType {
  ARRAY = "ARRAY",
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  ENUM = "ENUM",
  NUMBER = "NUMBER",
  STRING = "STRING",
}

export type LabelFieldInput = {
  height: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type LabelFieldObject = {
  __typename?: "LabelFieldObject";
  height: Scalars["Float"]["output"];
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export enum LicenseType {
  MLS = "MLS",
  NMLS = "NMLS",
  STATE = "STATE",
}

export type ListAiConversationSessionFilesInput = {
  prefix?: InputMaybe<Scalars["String"]["input"]>;
  threadId: Scalars["ID"]["input"];
};

export type ListAiConversationsInput = {
  conversationType?: InputMaybe<AiConversationType>;
};

export type ListingAgentInfoInput = {
  email: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListingAggDeltaByStatus = {
  __typename?: "ListingAggDeltaByStatus";
  countDifference: Scalars["Float"]["output"];
  status: MlsListingStatus;
  sumListPriceDifference?: Maybe<Scalars["Float"]["output"]>;
};

export type ListingAnnouncementInput = {
  listingId: Scalars["String"]["input"];
};

export type ListingAnnouncementObject = {
  __typename?: "ListingAnnouncementObject";
  bestAndFinalDate?: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  type: ListingAnnouncementType;
};

export enum ListingAnnouncementType {
  BEST_AND_FINAL = "BEST_AND_FINAL",
  GENERAL = "GENERAL",
}

export type ListingComparableAdjustmentsObject = {
  __typename?: "ListingComparableAdjustmentsObject";
  id: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  priceAdjustmentsPerFields?: Maybe<Scalars["JSONObject"]["output"]>;
  totalAdjustmentPrice?: Maybe<Scalars["Float"]["output"]>;
};

export type ListingComparableObject = {
  __typename?: "ListingComparableObject";
  adjustments?: Maybe<ListingComparableAdjustmentsObject>;
  id: Scalars["ID"]["output"];
  mlsListing: MlsListingObject;
  order: Scalars["Float"]["output"];
  source: ListingComparableSetSource;
};

export type ListingComparableSetForAgentInput = {
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ListingComparableSetForBoaTokenInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type ListingComparableSetForBuyerOfferAnalysisInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
};

export type ListingComparableSetForReportTokenInput = {
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["String"]["input"]>;
  token: Scalars["String"]["input"];
};

export type ListingComparableSetInput = {
  listingId: Scalars["String"]["input"];
};

export type ListingComparableSetObject = {
  __typename?: "ListingComparableSetObject";
  agent?: Maybe<AgentObject>;
  agentNotes?: Maybe<Scalars["String"]["output"]>;
  buyerOfferAnalysis?: Maybe<BuyerOfferAnalysisObject>;
  id: Scalars["ID"]["output"];
  listing?: Maybe<ListingObject>;
  listingComparables: Array<ListingComparableObject>;
  propertyDetails?: Maybe<PropertyDetailsObject>;
};

export enum ListingComparableSetSource {
  AGENT = "AGENT",
  SYSTEM = "SYSTEM",
}

export type ListingCountsByStatus = {
  __typename?: "ListingCountsByStatus";
  count: Scalars["Float"]["output"];
  status: MlsListingStatus;
  sumClosePrice?: Maybe<Scalars["Float"]["output"]>;
  sumListPrice?: Maybe<Scalars["Float"]["output"]>;
};

export enum ListingDocumentAction {
  DOWNLOAD = "DOWNLOAD",
  VIEW = "VIEW",
}

export enum ListingDocumentTypeEnum {
  AGENT_NEGOTIATION = "AGENT_NEGOTIATION",
  DISCLOSURE = "DISCLOSURE",
  OTHER = "OTHER",
}

export type ListingDocumentTypeObject = {
  __typename?: "ListingDocumentTypeObject";
  document?: Maybe<DocumentObject>;
  formName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  type: ListingDocumentTypeEnum;
  usState: UsState;
};

export type ListingDocumentTypesInput = {
  usState: UsState;
};

export type ListingDocumentUploadObject = {
  __typename?: "ListingDocumentUploadObject";
  customDocumentName?: Maybe<Scalars["String"]["output"]>;
  customDocumentType?: Maybe<ListingDocumentTypeEnum>;
  file?: Maybe<FileObject>;
  id: Scalars["ID"]["output"];
  listingDocumentType?: Maybe<ListingDocumentTypeObject>;
};

export type ListingDocumentUploadsInput = {
  listingId: Scalars["String"]["input"];
};

export type ListingFollowerObject = {
  __typename?: "ListingFollowerObject";
  followedAt: Scalars["DateTime"]["output"];
  user: UserObject;
};

export type ListingFollowersObject = {
  __typename?: "ListingFollowersObject";
  listingFollowers: Array<ListingFollowerObject>;
};

export type ListingInput = {
  id: Scalars["String"]["input"];
};

export type ListingObject = {
  __typename?: "ListingObject";
  coListingAgent?: Maybe<AgentObject>;
  currentAndUpcomingOpenHouses?: Maybe<Array<PublicOpenHouseObject>>;
  deletedFromRetsFeedAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  followerCount?: Maybe<Scalars["Float"]["output"]>;
  guestbookSignersCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isOwner?: Maybe<Scalars["Boolean"]["output"]>;
  isPremium: Scalars["Boolean"]["output"];
  isSharedListing?: Maybe<Scalars["Boolean"]["output"]>;
  lastActivityDate?: Maybe<Scalars["DateTime"]["output"]>;
  listDate?: Maybe<Scalars["DateTime"]["output"]>;
  listingAgent?: Maybe<AgentObject>;
  listingDocuments: Array<ListingDocumentUploadObject>;
  listingPreferences: Array<PreferenceValueObject>;
  mlsListing?: Maybe<MlsListingObject>;
  offersCountDisplay: Scalars["String"]["output"];
  offersSubmitted?: Maybe<Array<OfferObject>>;
  organizations?: Maybe<Array<OrganizationObject>>;
  priceHistories: Array<ListingPriceHistoryObject>;
  property: PropertyObject;
  setupDetails: StorefrontConfigurationStatusObject;
  status: MlsListingStatus;
  storefrontSetup?: Maybe<StorefrontSetupObject>;
  submittedOffersCount: Scalars["Int"]["output"];
};

/** Paginated results of ListingObject */
export type ListingObjectListingsForOrganizationPaginated = {
  __typename?: "ListingObjectListingsForOrganizationPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ListingObject>>;
};

/** Paginated results of ListingObject */
export type ListingObjectPaginated = {
  __typename?: "ListingObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ListingObject>>;
};

/** Paginated results of ListingObject */
export type ListingObjectPrioritizedListingsForCurrentUserPaginated = {
  __typename?: "ListingObjectPrioritizedListingsForCurrentUserPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<ListingObject>>;
};

export type ListingOpenHousesInput = {
  listingId: Scalars["String"]["input"];
};

export type ListingOpenHousesPayload = {
  __typename?: "ListingOpenHousesPayload";
  results: Array<OpenHouseObject>;
};

export type ListingPriceHistoryObject = {
  __typename?: "ListingPriceHistoryObject";
  addressFull: Scalars["String"]["output"];
  closeDate: Scalars["String"]["output"];
  closePrice: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  listDate: Scalars["String"]["output"];
  listPrice: Scalars["Float"]["output"];
  mlsStatus: Scalars["String"]["output"];
  modified: Scalars["String"]["output"];
};

export type ListingPricingEvaluationInput = {
  identifier: Scalars["ID"]["input"];
  identifierType: PricingEvaluationJobIdentifierType;
};

export type ListingPricingEvaluationObject = {
  __typename?: "ListingPricingEvaluationObject";
  adjustedComps: Array<AdjustedComp>;
  analysis: Scalars["String"]["output"];
};

export enum ListingReportChartType {
  BAR = "BAR",
  LINE = "LINE",
  PIE = "PIE",
}

export type ListingReportInput = {
  filters?: InputMaybe<ReportFiltersInput>;
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["String"]["input"]>;
  useIndigoData?: Scalars["Boolean"]["input"];
};

export type ListingReportPdfResponse = {
  __typename?: "ListingReportPdfResponse";
  file: FileObject;
};

export type ListingReportResponse = {
  __typename?: "ListingReportResponse";
  charts: Array<ChartCard>;
  confidence: ReportConfidence;
  tables: Array<Table>;
};

export type ListingsFilterArgs = {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  search?: InputMaybe<Scalars["String"]["input"]>;
  sharedWithMe?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ListingsForOrganizationFilterArgs = {
  bbox?: InputMaybe<BboxFilterInput>;
  organizationId: Scalars["String"]["input"];
  search?: InputMaybe<Scalars["String"]["input"]>;
  status?: InputMaybe<Array<MlsListingStatus>>;
};

export type LoadPipelineInvestigationReasonsForValidationInput = {
  folderUuids: Array<Scalars["ID"]["input"]>;
};

export type LoadPipelineInvestigationReasonsForValidationResponse = {
  __typename?: "LoadPipelineInvestigationReasonsForValidationResponse";
  failedCount: Scalars["Int"]["output"];
  processedCount: Scalars["Int"]["output"];
  results: Array<PipelineInvestigationReasonResult>;
};

export type LoanOfficerContactConfigInput = {
  calendarSchedulingUrl?: InputMaybe<Scalars["String"]["input"]>;
  preApprovalAppUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type LoanOfficerContactConfigObject = {
  __typename?: "LoanOfficerContactConfigObject";
  calendarSchedulingUrl?: Maybe<Scalars["String"]["output"]>;
  preApprovalAppUrl?: Maybe<Scalars["String"]["output"]>;
};

export type LoanOfficerContactObject = PartnerContactBaseObject & {
  __typename?: "LoanOfficerContactObject";
  contactType: ContactType;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  loanOfficerConfig?: Maybe<LoanOfficerContactConfigObject>;
  partner?: Maybe<OrganizationPartnerObject>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type Location = {
  __typename?: "Location";
  address: AddressObject;
  coords?: Maybe<GeoObject>;
};

export enum LogicalOperator {
  AND = "AND",
  OR = "OR",
}

export type MlQueueJobStatusPayload = {
  __typename?: "MLQueueJobStatusPayload";
  isCompleted?: Maybe<Scalars["Boolean"]["output"]>;
  isFailed?: Maybe<Scalars["Boolean"]["output"]>;
  isInProgress?: Maybe<Scalars["Boolean"]["output"]>;
};

export type MlsListingAddressObject = {
  __typename?: "MLSListingAddressObject";
  city: Scalars["String"]["output"];
  country?: Maybe<Scalars["String"]["output"]>;
  crossStreet?: Maybe<Scalars["String"]["output"]>;
  full: Scalars["String"]["output"];
  postalCode?: Maybe<Scalars["String"]["output"]>;
  state: Scalars["String"]["output"];
  streetName: Scalars["String"]["output"];
  streetNumber?: Maybe<Scalars["Float"]["output"]>;
  streetNumberText: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingAgentObject = {
  __typename?: "MLSListingAgentObject";
  contact?: Maybe<MlsListingContactObject>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** Raw MLS ID of this agent (i.e. from Constellation1) */
  id?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Processed MLS ID of this agent, without the memberIdPrefix */
  mlsId?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingAssociationObject = {
  __typename?: "MLSListingAssociationObject";
  amenities?: Maybe<Scalars["String"]["output"]>;
  fee?: Maybe<Scalars["Float"]["output"]>;
  frequency?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingComplianceObject = {
  __typename?: "MLSListingComplianceObject";
  attributionContact?: Maybe<Scalars["String"]["output"]>;
  buyerAgencyCompensation?: Maybe<Scalars["Float"]["output"]>;
  buyerAgencyCompensationType?: Maybe<Scalars["String"]["output"]>;
  subAgencyCompensation?: Maybe<Scalars["Float"]["output"]>;
  subAgencyCompensationType?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingContactObject = {
  __typename?: "MLSListingContactObject";
  cell?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  office?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingFiltersInput = {
  bbox?: InputMaybe<BboxFilterInput>;
  bedRange?: InputMaybe<MinMaxFilterInput>;
  closedDateRange?: InputMaybe<DateRangeFilterInput>;
  daysOnMarket?: InputMaybe<MinMaxFilterInput>;
  fullBathRange?: InputMaybe<MinMaxFilterInput>;
  halfBathRange?: InputMaybe<MinMaxFilterInput>;
  hasOffers?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasSellerConcessions?: InputMaybe<Scalars["Boolean"]["input"]>;
  loanTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  numSubscribers?: InputMaybe<MinMaxFilterInput>;
  premiumOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  priceRange?: InputMaybe<MinMaxFilterInput>;
  sellerOrBuyerPossession?: InputMaybe<Scalars["String"]["input"]>;
  sqftRange?: InputMaybe<MinMaxFilterInput>;
  statuses?: InputMaybe<Array<MlsListingStatus>>;
};

export type MlsListingGeoObject = {
  __typename?: "MLSListingGeoObject";
  county?: Maybe<Scalars["String"]["output"]>;
  directions?: Maybe<Scalars["String"]["output"]>;
  location: GeoPointObject;
  marketArea?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingInput = {
  id: Scalars["String"]["input"];
};

export type MlsListingMlsObject = {
  __typename?: "MLSListingMLSObject";
  area?: Maybe<Scalars["String"]["output"]>;
  areaMinor?: Maybe<Scalars["String"]["output"]>;
  daysOnMarket?: Maybe<Scalars["Float"]["output"]>;
  disclaimer?: Maybe<Scalars["String"]["output"]>;
  logoUrl?: Maybe<Scalars["String"]["output"]>;
  originalEntryTimestamp?: Maybe<Scalars["String"]["output"]>;
  originatingSystemName?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<MlsListingStatus>;
  statusText: Scalars["String"]["output"];
};

export type MlsListingObject = {
  __typename?: "MLSListingObject";
  /** @deprecated Use deleted_at instead */
  _deletedFromRetsFeed?: Maybe<Scalars["Boolean"]["output"]>;
  address: MlsListingAddressObject;
  addressFull: Scalars["String"]["output"];
  agent?: Maybe<MlsListingAgentObject>;
  association?: Maybe<MlsListingAssociationObject>;
  coAgent?: Maybe<MlsListingAgentObject>;
  compliance?: Maybe<MlsListingComplianceObject>;
  deleted_at?: Maybe<Scalars["String"]["output"]>;
  disclaimer?: Maybe<Scalars["String"]["output"]>;
  geo: MlsListingGeoObject;
  id: Scalars["ID"]["output"];
  internetAddressDisplay?: Maybe<Scalars["Boolean"]["output"]>;
  internetEntireListingDisplay?: Maybe<Scalars["Boolean"]["output"]>;
  leaseTerm?: Maybe<Scalars["String"]["output"]>;
  leaseType?: Maybe<Scalars["String"]["output"]>;
  listDate?: Maybe<Scalars["String"]["output"]>;
  listPrice?: Maybe<Scalars["Float"]["output"]>;
  listingId?: Maybe<Scalars["String"]["output"]>;
  mls?: Maybe<MlsListingMlsObject>;
  mlsId?: Maybe<Scalars["Float"]["output"]>;
  /** @deprecated Use mls.originatingSystemName instead */
  mlsName?: Maybe<Scalars["String"]["output"]>;
  modified?: Maybe<Scalars["String"]["output"]>;
  office?: Maybe<MlsListingOfficeObject>;
  originalListPrice?: Maybe<Scalars["Float"]["output"]>;
  ownership?: Maybe<Scalars["String"]["output"]>;
  photos: Array<Scalars["String"]["output"]>;
  privateRemarks?: Maybe<Scalars["String"]["output"]>;
  property?: Maybe<MlsListingPropertyObject>;
  remarks?: Maybe<Scalars["String"]["output"]>;
  sales?: Maybe<MlsListingSalesObject>;
  school?: Maybe<MlsListingSchoolObject>;
  showingContactName?: Maybe<Scalars["String"]["output"]>;
  showingContactPhone?: Maybe<Scalars["String"]["output"]>;
  showingInstructions?: Maybe<Scalars["String"]["output"]>;
  specialListingConditions?: Maybe<Scalars["String"]["output"]>;
  tax?: Maybe<MlsListingTaxObject>;
  terms?: Maybe<Scalars["String"]["output"]>;
  virtualTourUrl?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingOfficeObject = {
  __typename?: "MLSListingOfficeObject";
  brokerid?: Maybe<Scalars["String"]["output"]>;
  contact?: Maybe<MlsListingContactObject>;
  name?: Maybe<Scalars["String"]["output"]>;
  servingName?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingParkingObject = {
  __typename?: "MLSListingParkingObject";
  description?: Maybe<Scalars["String"]["output"]>;
  leased?: Maybe<Scalars["String"]["output"]>;
  spaces?: Maybe<Scalars["Float"]["output"]>;
};

export type MlsListingPropertyObject = {
  __typename?: "MLSListingPropertyObject";
  accessibility?: Maybe<Scalars["String"]["output"]>;
  acres?: Maybe<Scalars["Float"]["output"]>;
  additionalRooms?: Maybe<Scalars["String"]["output"]>;
  area?: Maybe<Scalars["Float"]["output"]>;
  areaSource?: Maybe<Scalars["String"]["output"]>;
  bathrooms?: Maybe<Scalars["String"]["output"]>;
  bathsFull?: Maybe<Scalars["Float"]["output"]>;
  bathsHalf?: Maybe<Scalars["Float"]["output"]>;
  bathsThreeQuarter?: Maybe<Scalars["Float"]["output"]>;
  bedrooms?: Maybe<Scalars["Float"]["output"]>;
  construction?: Maybe<Scalars["String"]["output"]>;
  cooling?: Maybe<Scalars["String"]["output"]>;
  exteriorFeatures?: Maybe<Scalars["String"]["output"]>;
  fireplaces?: Maybe<Scalars["Float"]["output"]>;
  flooring?: Maybe<Scalars["String"]["output"]>;
  foundation?: Maybe<Scalars["String"]["output"]>;
  garageSpaces?: Maybe<Scalars["Float"]["output"]>;
  heating?: Maybe<Scalars["String"]["output"]>;
  interiorFeatures?: Maybe<Scalars["String"]["output"]>;
  laundryFeatures?: Maybe<Scalars["String"]["output"]>;
  lotDescription?: Maybe<Scalars["String"]["output"]>;
  lotSize?: Maybe<Scalars["String"]["output"]>;
  lotSizeArea?: Maybe<Scalars["Float"]["output"]>;
  lotSizeAreaUnits?: Maybe<Scalars["String"]["output"]>;
  maintenanceExpense?: Maybe<Scalars["Float"]["output"]>;
  occupantName?: Maybe<Scalars["String"]["output"]>;
  occupantType?: Maybe<Scalars["String"]["output"]>;
  ownerName?: Maybe<Scalars["String"]["output"]>;
  parking?: Maybe<MlsListingParkingObject>;
  poolFeatures?: Maybe<Scalars["String"]["output"]>;
  roof?: Maybe<Scalars["String"]["output"]>;
  rooms?: Maybe<Array<MlsListingRoomObject>>;
  stories?: Maybe<Scalars["Float"]["output"]>;
  style?: Maybe<Scalars["String"]["output"]>;
  subType?: Maybe<Scalars["String"]["output"]>;
  subTypeRaw?: Maybe<Scalars["String"]["output"]>;
  subTypeText?: Maybe<Scalars["String"]["output"]>;
  subdivision?: Maybe<Scalars["String"]["output"]>;
  type?: Maybe<MlsListingType>;
  view?: Maybe<Scalars["String"]["output"]>;
  water?: Maybe<Scalars["String"]["output"]>;
  yearBuilt?: Maybe<Scalars["Float"]["output"]>;
};

export type MlsListingRankingFactorsObject = {
  __typename?: "MLSListingRankingFactorsObject";
  /** Score from how many documents reference this listing (0-200) */
  documentRelevanceScore: Scalars["Float"]["output"];
  /** Score from matching org's preferred OSN (0-30) */
  osnPreferenceMatch: Scalars["Float"]["output"];
  /** Score from matching expected property type (0 or 50) */
  propertyTypeMatch: Scalars["Float"]["output"];
  /** Score from list date recency (0-100) */
  recencyScore: Scalars["Float"]["output"];
  /** Score from listing status (Active: 100, Pending: 75, Closed: 25) */
  statusScore: Scalars["Float"]["output"];
};

export type MlsListingRoomObject = {
  __typename?: "MLSListingRoomObject";
  area?: Maybe<Scalars["Float"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  dimensions?: Maybe<Scalars["String"]["output"]>;
  features?: Maybe<Scalars["String"]["output"]>;
  length?: Maybe<Scalars["Float"]["output"]>;
  type?: Maybe<Scalars["String"]["output"]>;
  typeText?: Maybe<Scalars["String"]["output"]>;
  width?: Maybe<Scalars["Float"]["output"]>;
};

export type MlsListingSalesObject = {
  __typename?: "MLSListingSalesObject";
  agent?: Maybe<MlsListingAgentObject>;
  closeDate?: Maybe<Scalars["String"]["output"]>;
  closePrice?: Maybe<Scalars["Float"]["output"]>;
  contractDate?: Maybe<Scalars["String"]["output"]>;
  office?: Maybe<MlsListingOfficeObject>;
};

export type MlsListingSchoolObject = {
  __typename?: "MLSListingSchoolObject";
  district?: Maybe<Scalars["String"]["output"]>;
  elementarySchool?: Maybe<Scalars["String"]["output"]>;
  highSchool?: Maybe<Scalars["String"]["output"]>;
  middleSchool?: Maybe<Scalars["String"]["output"]>;
};

export type MlsListingSelectionPayload = {
  __typename?: "MLSListingSelectionPayload";
  /** True if selection is ambiguous (multiple good matches). UI should prompt user to choose. */
  isAmbiguous: Scalars["Boolean"]["output"];
  /** All selectable listings, scored and ranked. Disqualified listings are excluded. First entry matches selectedListing when not null. */
  rankedListings: Array<RankedMlsListingObject>;
  /** The recommended MLS listing (top-ranked). Null only if rankedListings is empty. When isAmbiguous=true, this is still the system recommendation but UI should prompt user to confirm. */
  selectedListing?: Maybe<MlsListingObject>;
  /** Human-readable explanation of the selection (or why none was selected) */
  selectionReason: Scalars["String"]["output"];
  /** Total number of listings found before filtering/scoring */
  totalListingsFound: Scalars["Int"]["output"];
};

export enum MlsListingStatus {
  Active = "Active",
  ActiveUnderContract = "ActiveUnderContract",
  Canceled = "Canceled",
  Closed = "Closed",
  ComingSoon = "ComingSoon",
  Delete = "Delete",
  DeletedFromFeed = "DeletedFromFeed",
  Expired = "Expired",
  Hold = "Hold",
  Incomplete = "Incomplete",
  Pending = "Pending",
  Withdrawn = "Withdrawn",
}

export enum MlsListingSubType {
  Apartment = "Apartment",
  BoatSlip = "BoatSlip",
  Cabin = "Cabin",
  Condominium = "Condominium",
  DeededParking = "DeededParking",
  Duplex = "Duplex",
  ManufacturedHome = "ManufacturedHome",
  ManufacturedOnLand = "ManufacturedOnLand",
  Quadruplex = "Quadruplex",
  SingleFamilyResidence = "SingleFamilyResidence",
  StockCooperative = "StockCooperative",
  Timeshare = "Timeshare",
  Townhouse = "Townhouse",
  Triplex = "Triplex",
}

export type MlsListingTaxObject = {
  __typename?: "MLSListingTaxObject";
  id?: Maybe<Scalars["String"]["output"]>;
  parcelLetter?: Maybe<Scalars["String"]["output"]>;
  taxAnnualAmount?: Maybe<Scalars["Float"]["output"]>;
  taxYear?: Maybe<Scalars["Float"]["output"]>;
};

export enum MlsListingType {
  CND = "CND",
  CRE = "CRE",
  FRM = "FRM",
  LND = "LND",
  MLF = "MLF",
  RES = "RES",
  RNT = "RNT",
}

export type MlsListingWithListingPayload = {
  __typename?: "MLSListingWithListingPayload";
  listing?: Maybe<PublicListingObject>;
  mlsListing: MlsListingObject;
};

export type MlsObject = {
  __typename?: "MLSObject";
  agentSignUpEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  memberIdPrefix?: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  originatingSystemName?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Use originatingSystemName instead */
  shortName: Scalars["String"]["output"];
  states: Array<UsState>;
  supportedFeatures?: Maybe<Array<ProductFeatures>>;
};

export type MlsSource = {
  __typename?: "MLSSource";
  type: MarketDataSourceType;
};

export type MarketDataPercentages = {
  __typename?: "MarketDataPercentages";
  no: Scalars["Float"]["output"];
  yes: Scalars["Float"]["output"];
};

export type MarketDataRange = {
  __typename?: "MarketDataRange";
  high: Scalars["Float"]["output"];
  low: Scalars["Float"]["output"];
};

export type MarketDataSource = CompsSource | IndigoOffersSource | MlsSource;

export enum MarketDataSourceType {
  COMPS = "COMPS",
  INDIGO_OFFERS = "INDIGO_OFFERS",
  MLS = "MLS",
}

export type MediaObject = {
  __typename?: "MediaObject";
  ImageHeight?: Maybe<Scalars["Float"]["output"]>;
  ImageSizeDescription?: Maybe<Scalars["String"]["output"]>;
  ImageWidth?: Maybe<Scalars["Float"]["output"]>;
  MediaKey?: Maybe<Scalars["String"]["output"]>;
  MediaModificationTimestamp?: Maybe<Scalars["String"]["output"]>;
  MediaURL?: Maybe<Scalars["String"]["output"]>;
};

export type MinMaxFilterInput = {
  max?: InputMaybe<Scalars["Float"]["input"]>;
  min?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Mutation = {
  __typename?: "Mutation";
  acceptAccessControlInvite: AcceptInvitationForAccessControlPayload;
  accessControlInvite: AccessControlInvitePayload;
  addInsuranceAgentContact: OrganizationPartnerContactUnion;
  addLoanOfficerContact: OrganizationPartnerContactUnion;
  addOrUpdateDisclosureContractDocuments: ContractPayload;
  addOrUpdatePreapprovalContractDocument: ContractPayload;
  addTitleAgentContact: OrganizationPartnerContactUnion;
  bulkEvaluateDocumentClassifications: Scalars["String"]["output"];
  calculateOfferScore: BuyerOfferAnalysisObject;
  capturePropertyDetails: CapturePropertyDetailsPayload;
  clearOfferGroupTermination: ClearOfferGroupTerminationPayload;
  copyComplianceKeyTermSections: Scalars["Boolean"]["output"];
  copyFieldsFromPreviousVersion: DocumentVersionPayload;
  copyTransactionRules: Scalars["Boolean"]["output"];
  createAIConversation: AiConversationObject;
  createAutofill?: Maybe<CreateAutofillPayload>;
  createBuyerOfferAnalysis: BuyerOfferAnalysisObject;
  createBuyerOfferAnalysisForUser: BuyerOfferAnalysisObject;
  createClassificationEvalFromIngestionDocument: DocumentClassificationEvaluationObject;
  createComplianceKeyTermSection: CreateComplianceKeyTermSectionPayload;
  createContact: ContactObject;
  createContract?: Maybe<ContractPayload>;
  createDefaultSecondaryDocument?: Maybe<DefaultSecondaryDocumentPayload>;
  createDocument?: Maybe<CreateDocumentPayload>;
  createDocumentLLM?: Maybe<DocumentLlmObject>;
  createDocumentLLMExample?: Maybe<DocumentLlmExampleObject>;
  createDocumentLLMExamples?: Maybe<Array<DocumentLlmExampleObject>>;
  createDocumentSection: CreateDocumentSectionPayload;
  createDocumentVersion?: Maybe<CreateDocumentVersionPayload>;
  createDocumentVersionFields?: Maybe<CreateDocumentVersionFieldsPayload>;
  createEmbeddedSignUrl?: Maybe<Scalars["String"]["output"]>;
  createEmbeddedSignatureRequest?: Maybe<EmbeddedSignatureRequestPayload>;
  createEventForOffer: AppEventObject;
  createFallbackContract?: Maybe<ContractPayload>;
  createField?: Maybe<CreateFieldPayload>;
  createIndigoContract?: Maybe<IndigoContractObject>;
  createIntegrationClient: InternalIntegrationClientPayload;
  createNotificationTemplate: NotificationTemplateObject;
  createOfferForBuyersAgent?: Maybe<CreateOfferPayload>;
  createOfferForUnauthenticatedBuyersAgent?: Maybe<CreateOfferPayload>;
  createOpenHouse: CreateOpenHousePayload;
  createOrUpdateDocumentClassificationEvaluation?: Maybe<DocumentClassificationEvaluationObject>;
  createOrUpdateDocumentLLMEvaluation?: Maybe<DocumentLlmEvaluationObject>;
  createOrUpdateListingAnnouncement?: Maybe<ListingAnnouncementObject>;
  /** @deprecated Use createOrUpdateListingComparableAdjustmentV2 instead */
  createOrUpdateListingComparableAdjustment: ListingComparableObject;
  createOrUpdateListingComparableAdjustmentV2: ListingComparableObject;
  createOrganization: OrganizationObject;
  createOrganizationForAgent: CreateOrganizationForAgentPayload;
  createOrganizationForTeamLead: CreateOrganizationForTeamLeadPayload;
  createOrganizationPartner: OrganizationPartnerObject;
  createOrganizationRosterEntry: OrganizationRosterObject;
  createPartyForBuyersAgent: PartyObject;
  createRule?: Maybe<CreateRulePayload>;
  createTransactionPipeline: TransactionPipelineObject;
  createUserTour: Array<UserTourObject>;
  cropCheckboxImages?: Maybe<Scalars["Boolean"]["output"]>;
  deleteAIConversation: Scalars["Boolean"]["output"];
  deleteAccessControl: DeleteAccessControlPayload;
  deleteComplianceGroupTransactionStage: Scalars["Boolean"]["output"];
  deleteComplianceKeyTermSection: DeleteComplianceKeyTermSectionPayload;
  deleteContact: Scalars["Boolean"]["output"];
  deleteContractDocuments: ContractPayload;
  deleteContractSystemCredentials: Scalars["Boolean"]["output"];
  deleteDefaultSecondaryDocument?: Maybe<DeleteDefaultSecondaryDocumentPayload>;
  deleteDocument?: Maybe<DeleteDocumentPayload>;
  deleteDocumentClassificationEvaluation: Scalars["Boolean"]["output"];
  deleteDocumentLLM: Scalars["Boolean"]["output"];
  deleteDocumentLLMEvaluation: Scalars["Boolean"]["output"];
  deleteDocumentLLMExample: Scalars["Boolean"]["output"];
  deleteDocumentSection: DeleteDocumentSectionPayload;
  deleteDocumentVersion: DeleteDocumentVersionPayload;
  deleteDocumentVersionFields?: Maybe<DeleteDocumentVersionFieldsPayload>;
  deleteField?: Maybe<DeleteFieldPayload>;
  deleteIntegrationClient: Scalars["Boolean"]["output"];
  deleteIntegrationConnection: DeleteIntegrationConnectionPayload;
  deleteListingDocuments?: Maybe<ListingObject>;
  deleteNotificationTemplate: Scalars["Boolean"]["output"];
  deleteOpenHouse: DeleteOpenHousePayload;
  deleteOrganizationPartner: Scalars["Boolean"]["output"];
  deleteOrganizationPartnerStageIntro: Scalars["Boolean"]["output"];
  deleteOrganizationRosterEntry: Scalars["Boolean"]["output"];
  deleteOrganizationRosterPreference: Scalars["Boolean"]["output"];
  deletePreapprovalContractDocument: ContractPayload;
  deleteRule?: Maybe<DeleteRulePayload>;
  deleteTransactionRule?: Maybe<Scalars["Boolean"]["output"]>;
  deleteTransactionStage?: Maybe<Scalars["Boolean"]["output"]>;
  detectFormFields?: Maybe<Array<DocumentVersionFieldObject>>;
  detectFormFieldsForDocumentVersion?: Maybe<DocumentVersionDetectFormFieldsPayload>;
  evaluateDocumentClassification: Scalars["Boolean"]["output"];
  externalCreateComplianceMessageHistory: ExternalCreateComplianceMessageHistoryPayload;
  externalCreateErrorReport: ErrorReportObject;
  externalCreateOrUpdateIngestionDocumentReview: IngestionDocumentReviewObject;
  externalCreateOrUpdateIngestionDocumentValidationErrorReview: IngestionDocumentValidationErrorReviewObject;
  externalCreateOrUpdateIngestionDocumentValidationFeedback: IngestionDocumentValidationFeedbackObject;
  externalCreateOrUpdateIngestionFolderValidationErrorReview: IngestionFolderValidationErrorReviewObject;
  externalCreateOrUpdateIngestionFolderValidationFeedback: IngestionFolderValidationFeedbackObject;
  externalDeleteDarwinCompanyOfficeMapping: Scalars["Boolean"]["output"];
  externalDeleteIngestionDocumentValidationErrorReview: Scalars["Boolean"]["output"];
  externalDeleteIngestionFolderValidationErrorReview: Scalars["Boolean"]["output"];
  externalOverrideKeyTermsForIngestionFolder: OverrideKeyTermsForIngestionFolderPayload;
  externalSaveDarwinCompanyOfficeMapping: DarwinCompanyOfficeMappingObject;
  externalSubmitErrorReportContext: ErrorReportObject;
  externalSubmitValidationReviews: ValidationReviewSubmissionObject;
  externalSyncDarwinFees: ExternalSyncDarwinFeesPayload;
  externalSyncDarwinSelection: ExternalSyncDarwinSelectionPayload;
  externalSyncDarwinVendors: ExternalSyncDarwinVendorsPayload;
  externalSyncKeyTerms: ExternalSyncKeyTermsPayload;
  externalUpdateIngestionDocumentStatus: IngestionDocumentObject;
  extractContract?: Maybe<ExtractContractPayload>;
  extractPreapprovalInfo?: Maybe<ExtractPreapprovalInfoPayload>;
  followListing: IsFollowingListingObject;
  generateListingPackagePdf: FileObject;
  getOrCreateAgentByPhoneNumber?: Maybe<UserObject>;
  getOrCreateConsumerByPhoneNumber?: Maybe<UserObject>;
  internalBatchAddUsersToOrganization: InternalBatchAddUsersResult;
  internalCreateOrUpdateIngestionDocumentValidationFeedback: IngestionDocumentValidationFeedbackObject;
  internalCreateOrUpdateIngestionFolderValidationFeedback: IngestionFolderValidationFeedbackObject;
  internalEssentialsNotificationActionExecute: DebugActionExecuteResult;
  internalEssentialsNotificationActionPreview: DebugActionPreviewResult;
  joinOrganization: Scalars["Boolean"]["output"];
  labelIngestionDocumentClassification: Scalars["Boolean"]["output"];
  previewExtractedFieldsFromEvaluation: Scalars["JSON"]["output"];
  produceStageChangedEvents: ProduceStageChangedEventsPayload;
  publishNotificationTemplates: Array<NotificationTemplateObject>;
  queueAnalyzeForOfferIngestionJob: QueueAnalyzeJobPayload;
  reassignIngestionFolderPipelines: ReassignIngestionFolderPipelinesPayload;
  removeDryRunNotificationLogs: RemoveDryRunNotificationLogsPayload;
  reorderNotificationTemplates: Scalars["Boolean"]["output"];
  resendBOAShareLink: Scalars["ID"]["output"];
  resendListingReportShareLink: Scalars["ID"]["output"];
  revokeBOAShareLink: ShareLinkObject;
  revokeInvitation: Scalars["Boolean"]["output"];
  revokeListingReportShareLink: ShareLinkObject;
  runIngestionDocumentValidationLlmAsJudge: RunIngestionDocumentValidationLlmAsJudgePayload;
  saveCheckboxExportDataset?: Maybe<Scalars["Boolean"]["output"]>;
  saveComplianceGroupTransactionStage: ComplianceGroupTransactionStageObject;
  saveComplianceGroupTransactionStageByType: ComplianceGroupTransactionStageObject;
  saveExtractedFieldsFromEvaluation: Scalars["Boolean"]["output"];
  saveSignatureInitialDataset?: Maybe<Scalars["Boolean"]["output"]>;
  saveSignatureInitialValidations?: Maybe<Scalars["Boolean"]["output"]>;
  sendBOAShareLink: ShareLinkObject;
  sendComplianceSummaryNotification: SendComplianceSummaryNotificationResponse;
  sendListingReportShareLink: ShareLinkObject;
  sendOTPFromInvitationLink?: Maybe<SendOtpFromInvitationLinkPayload>;
  sendSellerInvitation?: Maybe<SendSellerInvitationPayload>;
  sendSignatureRequestToBuyersForOffer?: Maybe<SendSignatureRequestForOfferPayload>;
  sendSignatureRequestToSellersForOffer?: Maybe<SendSignatureRequestForOfferPayload>;
  sendTestNotification: SendTestNotificationResponse;
  setDocumentVersionAsActive?: Maybe<SetDocumentVersionAsActivePayload>;
  shareStorefrontWithBuyer: Scalars["Boolean"]["output"];
  signListingGuestbook: Scalars["Boolean"]["output"];
  signOpenHouseGuestbook: Scalars["Boolean"]["output"];
  /** @deprecated Use signUpAgentV2 instead */
  signUpAgent?: Maybe<SignUpUserPayload>;
  signUpAgentV2?: Maybe<SignUpUserPayload>;
  signUpConsumer?: Maybe<SignUpUserPayload>;
  submitOfferForBuyersAgent?: Maybe<SubmitOfferPayload>;
  submitOfferToNonIndigoListingAgent?: Maybe<SubmitOfferPayload>;
  syncAcroformToDocumentVersionFields?: Maybe<DocumentVersionPayload>;
  syncAllTransactionPipelinesToProduction: SyncTransactionPipelinesPayload;
  syncSecondaryDocumentVersions?: Maybe<DocumentVersionPayload>;
  terminateOfferGroup: TerminateOfferGroupPayload;
  trackListingDocumentAction: TrackListingDocumentActionPayload;
  triggerBatchValidationRerun: BatchValidationRerunResult;
  unfollowListing: IsFollowingListingObject;
  updateAIConversation: AiConversationObject;
  updateAutofill?: Maybe<UpdateAutofillPayload>;
  updateBuyerOfferAnalysis: BuyerOfferAnalysisObject;
  updateCheckboxDataset: UpdateCheckboxDatasetPayload;
  updateComplianceKeyTermSectionFields: UpdateComplianceKeyTermSectionFieldsPayload;
  updateComplianceKeyTermSections: UpdateComplianceKeyTermSectionsPayload;
  updateComplianceKeyTermSectionsOrder: UpdateComplianceKeyTermSectionsPayload;
  updateContact: ContactObject;
  updateContract: ContractPayload;
  updateContractDocumentCustomFields: ContractDocumentObject;
  updateContractDocumentExclusions: UpdateContractDocumentExclusionsPayload;
  updateContractDocuments: ContractPayload;
  updateDefaultSecondaryDocuments?: Maybe<UpdateDefaultSecondaryDocumentsPayload>;
  updateDocument?: Maybe<UpdateDocumentPayload>;
  updateDocumentLLM?: Maybe<DocumentLlmObject>;
  updateDocumentSectionFields: UpdateDocumentSectionFieldsPayload;
  updateDocumentSections: UpdateDocumentSectionsPayload;
  updateDocumentSectionsOrder: UpdateDocumentSectionsPayload;
  updateDocumentVersion?: Maybe<DocumentVersionPayload>;
  updateDocumentVersionFields?: Maybe<UpdateDocumentVersionFieldsPayload>;
  updateField?: Maybe<UpdateFieldPayload>;
  updateIndigoContract?: Maybe<IndigoContractObject>;
  updateIntegrationClient: InternalIntegrationClientPayload;
  updateListingComparableSet: ListingComparableSetObject;
  updateListingComparableSetForAgent: ListingComparableSetObject;
  updateListingComparableSetForBuyerOfferAnalysis: ListingComparableSetObject;
  updateListingPreference: ListingObject;
  updateNotificationTemplate: NotificationTemplateObject;
  updateOfferForBuyersAgent?: Maybe<UpdateOfferPayload>;
  updateOfferWithParty?: Maybe<UpdateOfferPayload>;
  updateOpenHouse: UpdateOpenHousePayload;
  updateOrCreateContractSystemCredentials: OrganizationObject;
  updateOrCreateFieldsToColumn?: Maybe<FieldsToColumnObject>;
  updateOrCreateOrganizationRosterPreference: OrganizationRosterPreferenceObject;
  updateOrCreateTransactionRule?: Maybe<TransactionRuleObject>;
  updateOrCreateTransactionStage?: Maybe<TransactionStageObject>;
  updateOrganizationFolderNameValidationStageOverride: OrganizationFolderNameValidationStageOverrideObject;
  updateOrganizationPartner: OrganizationPartnerObject;
  updateOrganizationRosterEntry: OrganizationRosterObject;
  updateOrganizationValidationSettings: OrganizationValidationSettingsObject;
  updateParentOrganization: OrganizationObject;
  updatePartnerContact: OrganizationPartnerContactUnion;
  updatePartyForBuyersAgent: PartyObject;
  updatePropertyDetails: UpdatePropertyDetailsPayload;
  updateRule?: Maybe<UpdateRulePayload>;
  updateRulesForTransactionRule?: Maybe<TransactionRuleObject>;
  updateSecondaryDocumentVersion: SecondaryDocumentVersionPayload;
  updateSignatureInitialsDataset: UpdateSignatureInitialsDatasetPayload;
  updateSortOrder: Array<TransactionStageObject>;
  updateStorefrontSetup: ListingObject;
  updateTransactionRuleParent?: Maybe<Array<TransactionRuleObject>>;
  updateUser?: Maybe<UpdateUserPayload>;
  updateUserNotificationSettings: UserNotificationSettingsObject;
  updateUserSettings?: Maybe<UpdateUserSettingsPayload>;
  uploadAndExtractAgentNegotiationDocuments?: Maybe<UploadAndExtractAgentNegotiationDocumentsPayload>;
  uploadListingDocument?: Maybe<Array<ListingDocumentUploadObject>>;
  /** @deprecated Use uploadOfferAsListingAgent instead for LAs for less ambiguity */
  uploadOffer?: Maybe<UploadOfferPayload>;
  uploadOfferAsListingAgent?: Maybe<UploadOfferPayload>;
  uploadOfferForBuyersAgent?: Maybe<UploadOfferPayload>;
  uploadOfferForUnauthenticatedBuyersAgent?: Maybe<UploadOfferPayload>;
  upsertOrganizationPartnerStageIntro: OrganizationPartnerStageIntroObject;
  validateTransactionPipeline: ValidateTransactionPipelinePayload;
  validateTransactionRuleOnProduction: ValidateTransactionRuleOnProductionPayload;
  verifyShareLink: VerifyShareLinkPayload;
};

export type MutationAcceptAccessControlInviteArgs = {
  input: AcceptAccessControlInviteInput;
};

export type MutationAccessControlInviteArgs = {
  input: AccessControlInviteInput;
};

export type MutationAddInsuranceAgentContactArgs = {
  input: AddInsuranceAgentContactInput;
};

export type MutationAddLoanOfficerContactArgs = {
  input: AddLoanOfficerContactInput;
};

export type MutationAddOrUpdateDisclosureContractDocumentsArgs = {
  input: AddOrUpdateDisclosureContractDocumentsInput;
};

export type MutationAddOrUpdatePreapprovalContractDocumentArgs = {
  input: AddOrUpdatePreapprovalContractDocumentInput;
};

export type MutationAddTitleAgentContactArgs = {
  input: AddTitleAgentContactInput;
};

export type MutationBulkEvaluateDocumentClassificationsArgs = {
  evaluationIds: Array<Scalars["ID"]["input"]>;
};

export type MutationCalculateOfferScoreArgs = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
};

export type MutationCapturePropertyDetailsArgs = {
  input: CapturePropertyDetailsInput;
};

export type MutationClearOfferGroupTerminationArgs = {
  input: ClearOfferGroupTerminationInput;
};

export type MutationCopyComplianceKeyTermSectionsArgs = {
  input: CopyComplianceKeyTermSectionsInput;
};

export type MutationCopyFieldsFromPreviousVersionArgs = {
  input: CopyFieldsFromPreviousVersionInput;
};

export type MutationCopyTransactionRulesArgs = {
  input: CopyTransactionRulesInput;
};

export type MutationCreateAiConversationArgs = {
  input: CreateAiConversationInput;
};

export type MutationCreateAutofillArgs = {
  input: CreateAutofillInput;
};

export type MutationCreateBuyerOfferAnalysisArgs = {
  input: CreateBuyerOfferAnalysisInput;
};

export type MutationCreateBuyerOfferAnalysisForUserArgs = {
  input: CreateBuyerOfferAnalysisForUserInput;
};

export type MutationCreateClassificationEvalFromIngestionDocumentArgs = {
  input: CreateClassificationEvalFromIngestionDocumentInput;
};

export type MutationCreateComplianceKeyTermSectionArgs = {
  input: CreateComplianceKeyTermSectionInput;
};

export type MutationCreateContactArgs = {
  input: CreateContactInput;
};

export type MutationCreateContractArgs = {
  input?: InputMaybe<CreateContractInput>;
};

export type MutationCreateDefaultSecondaryDocumentArgs = {
  input: CreateDefaultSecondaryDocumentInput;
};

export type MutationCreateDocumentArgs = {
  input: CreateDocumentInput;
};

export type MutationCreateDocumentLlmArgs = {
  input: DocumentLlmInput;
};

export type MutationCreateDocumentLlmExampleArgs = {
  input: DocumentLlmExampleInput;
};

export type MutationCreateDocumentLlmExamplesArgs = {
  input: DocumentLlmExamplesInput;
};

export type MutationCreateDocumentSectionArgs = {
  input: CreateDocumentSectionInput;
};

export type MutationCreateDocumentVersionArgs = {
  input: CreateDocumentVersionInput;
};

export type MutationCreateDocumentVersionFieldsArgs = {
  inputs: Array<CreateDocumentVersionFieldInput>;
};

export type MutationCreateEmbeddedSignUrlArgs = {
  code: Scalars["String"]["input"];
};

export type MutationCreateEmbeddedSignatureRequestArgs = {
  input: CreateEmbeddedSignatureRequestInput;
};

export type MutationCreateEventForOfferArgs = {
  input: CreateEventForOfferInput;
};

export type MutationCreateFallbackContractArgs = {
  input?: InputMaybe<CreateFallbackContractInput>;
};

export type MutationCreateFieldArgs = {
  input: CreateFieldInput;
};

export type MutationCreateIndigoContractArgs = {
  input: CreateIndigoContractInput;
};

export type MutationCreateIntegrationClientArgs = {
  input: CreateIntegrationClientInput;
};

export type MutationCreateNotificationTemplateArgs = {
  input: CreateNotificationTemplateInput;
};

export type MutationCreateOfferForBuyersAgentArgs = {
  input: CreateOfferInput;
};

export type MutationCreateOfferForUnauthenticatedBuyersAgentArgs = {
  input: CreateOfferInput;
};

export type MutationCreateOpenHouseArgs = {
  input: CreateOpenHouseInput;
};

export type MutationCreateOrUpdateDocumentClassificationEvaluationArgs = {
  input: CreateOrUpdateDocumentClassificationEvaluationInput;
};

export type MutationCreateOrUpdateDocumentLlmEvaluationArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  input: DocumentLlmEvaluationInput;
};

export type MutationCreateOrUpdateListingAnnouncementArgs = {
  input: CreateOrUpdateListingAnnouncementInput;
};

export type MutationCreateOrUpdateListingComparableAdjustmentArgs = {
  input: CreateOrUpdateListingComparableAdjustmentInput;
};

export type MutationCreateOrUpdateListingComparableAdjustmentV2Args = {
  input: CreateOrUpdateListingComparableAdjustmentInputV2;
};

export type MutationCreateOrganizationArgs = {
  input: InternalCreateOrganizationInput;
};

export type MutationCreateOrganizationForAgentArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationForTeamLeadArgs = {
  input: CreateOrganizationInput;
};

export type MutationCreateOrganizationPartnerArgs = {
  input: CreateOrganizationPartnerInput;
};

export type MutationCreateOrganizationRosterEntryArgs = {
  input: CreateOrganizationRosterEntryInput;
};

export type MutationCreatePartyForBuyersAgentArgs = {
  input: CreatePartyForBuyersAgentInput;
};

export type MutationCreateRuleArgs = {
  input: CreateRuleInput;
  relationInput: RuleRelationInput;
};

export type MutationCreateTransactionPipelineArgs = {
  input: CreateTransactionPipelineInput;
};

export type MutationCreateUserTourArgs = {
  tourNames: Array<TourType>;
};

export type MutationCropCheckboxImagesArgs = {
  input: CropCheckboxImagesInput;
};

export type MutationDeleteAiConversationArgs = {
  input: DeleteAiConversationInput;
};

export type MutationDeleteAccessControlArgs = {
  input: DeleteAccessControlInput;
};

export type MutationDeleteComplianceGroupTransactionStageArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteComplianceKeyTermSectionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteContactArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteContractDocumentsArgs = {
  input: DeleteContractDocumentsInput;
};

export type MutationDeleteContractSystemCredentialsArgs = {
  input: DeleteContractSystemCredentialsInput;
};

export type MutationDeleteDefaultSecondaryDocumentArgs = {
  input: DeleteDefaultSecondaryDocumentInput;
};

export type MutationDeleteDocumentArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentClassificationEvaluationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentLlmArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentLlmEvaluationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentLlmExampleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentSectionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentVersionArgs = {
  uuid: Scalars["ID"]["input"];
};

export type MutationDeleteDocumentVersionFieldsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type MutationDeleteFieldArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteIntegrationClientArgs = {
  input: DeleteIntegrationClientInput;
};

export type MutationDeleteIntegrationConnectionArgs = {
  input: DeleteIntegrationConnectionInput;
};

export type MutationDeleteListingDocumentsArgs = {
  input: DeleteListingDocumentsInput;
};

export type MutationDeleteNotificationTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOpenHouseArgs = {
  input: DeleteOpenHouseInput;
};

export type MutationDeleteOrganizationPartnerArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOrganizationPartnerStageIntroArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOrganizationRosterEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteOrganizationRosterPreferenceArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeletePreapprovalContractDocumentArgs = {
  input: DeletePreapprovalContractDocumentInput;
};

export type MutationDeleteRuleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteTransactionRuleArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteTransactionStageArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDetectFormFieldsArgs = {
  input: ExtractContractInput;
};

export type MutationDetectFormFieldsForDocumentVersionArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationEvaluateDocumentClassificationArgs = {
  evaluationId: Scalars["ID"]["input"];
};

export type MutationExternalCreateComplianceMessageHistoryArgs = {
  input: ExternalCreateComplianceMessageHistoryInput;
};

export type MutationExternalCreateErrorReportArgs = {
  input: ExternalCreateErrorReportInput;
};

export type MutationExternalCreateOrUpdateIngestionDocumentReviewArgs = {
  input: ExternalCreateOrUpdateIngestionDocumentReviewInput;
};

export type MutationExternalCreateOrUpdateIngestionDocumentValidationErrorReviewArgs =
  {
    input: ExternalCreateOrUpdateIngestionDocumentValidationErrorReviewInput;
  };

export type MutationExternalCreateOrUpdateIngestionDocumentValidationFeedbackArgs =
  {
    input: ExternalCreateIngestionDocumentValidationFeedbackInput;
  };

export type MutationExternalCreateOrUpdateIngestionFolderValidationErrorReviewArgs =
  {
    input: ExternalCreateOrUpdateIngestionFolderValidationErrorReviewInput;
  };

export type MutationExternalCreateOrUpdateIngestionFolderValidationFeedbackArgs =
  {
    input: ExternalCreateIngestionFolderValidationFeedbackInput;
  };

export type MutationExternalDeleteDarwinCompanyOfficeMappingArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationExternalDeleteIngestionDocumentValidationErrorReviewArgs = {
  input: ExternalDeleteIngestionDocumentValidationErrorReviewInput;
};

export type MutationExternalDeleteIngestionFolderValidationErrorReviewArgs = {
  input: ExternalDeleteIngestionFolderValidationErrorReviewInput;
};

export type MutationExternalOverrideKeyTermsForIngestionFolderArgs = {
  input: OverrideKeyTermsForIngestionFolderInput;
};

export type MutationExternalSaveDarwinCompanyOfficeMappingArgs = {
  input: ExternalSaveDarwinCompanyOfficeMappingInput;
};

export type MutationExternalSubmitErrorReportContextArgs = {
  input: ExternalSubmitErrorReportContextInput;
};

export type MutationExternalSubmitValidationReviewsArgs = {
  input: ExternalSubmitValidationReviewsInput;
};

export type MutationExternalSyncDarwinFeesArgs = {
  input: ExternalSyncDarwinFeesInput;
};

export type MutationExternalSyncDarwinSelectionArgs = {
  input: ExternalSyncDarwinSelectionInput;
};

export type MutationExternalSyncDarwinVendorsArgs = {
  input: ExternalSyncDarwinVendorsInput;
};

export type MutationExternalSyncKeyTermsArgs = {
  input: ExternalSyncKeyTermsInput;
};

export type MutationExternalUpdateIngestionDocumentStatusArgs = {
  input: ExternalUpdateIngestionDocumentStatusInput;
};

export type MutationExtractContractArgs = {
  inputs: Array<ExtractContractInput>;
};

export type MutationExtractPreapprovalInfoArgs = {
  input: ExtractPreapprovalInfoInput;
};

export type MutationFollowListingArgs = {
  input: FollowListingInput;
};

export type MutationGenerateListingPackagePdfArgs = {
  input: ListingInput;
};

export type MutationGetOrCreateAgentByPhoneNumberArgs = {
  input: GetOrCreateAgentByPhoneNumberInput;
};

export type MutationGetOrCreateConsumerByPhoneNumberArgs = {
  input: CreateOrUpdateConsumerByPhoneNumberInput;
};

export type MutationInternalBatchAddUsersToOrganizationArgs = {
  input: InternalBatchAddUsersToOrganizationInput;
};

export type MutationInternalCreateOrUpdateIngestionDocumentValidationFeedbackArgs =
  {
    input: CreateIngestionDocumentValidationFeedbackInput;
  };

export type MutationInternalCreateOrUpdateIngestionFolderValidationFeedbackArgs =
  {
    input: CreateIngestionFolderValidationFeedbackInput;
  };

export type MutationInternalEssentialsNotificationActionExecuteArgs = {
  input: InternalEssentialsNotificationActionExecuteInput;
};

export type MutationInternalEssentialsNotificationActionPreviewArgs = {
  input: InternalEssentialsNotificationActionPreviewInput;
};

export type MutationJoinOrganizationArgs = {
  input: JoinOrganizationInput;
};

export type MutationLabelIngestionDocumentClassificationArgs = {
  input: OverrideIngestionDocumentClassificationInput;
};

export type MutationPreviewExtractedFieldsFromEvaluationArgs = {
  evaluationId: Scalars["ID"]["input"];
};

export type MutationProduceStageChangedEventsArgs = {
  input: ProduceStageChangedEventsInput;
};

export type MutationPublishNotificationTemplatesArgs = {
  partnerId: Scalars["ID"]["input"];
};

export type MutationQueueAnalyzeForOfferIngestionJobArgs = {
  input: QueueAnalyzeForOfferIngestionJobInput;
};

export type MutationReassignIngestionFolderPipelinesArgs = {
  input: ReassignIngestionFolderPipelinesInput;
};

export type MutationRemoveDryRunNotificationLogsArgs = {
  input: RemoveDryRunNotificationLogsInput;
};

export type MutationReorderNotificationTemplatesArgs = {
  input: Array<ReorderNotificationTemplateInput>;
};

export type MutationResendBoaShareLinkArgs = {
  token: Scalars["String"]["input"];
};

export type MutationResendListingReportShareLinkArgs = {
  token: Scalars["String"]["input"];
};

export type MutationRevokeBoaShareLinkArgs = {
  input: RevokeBoaShareLinkInput;
};

export type MutationRevokeInvitationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationRevokeListingReportShareLinkArgs = {
  input: RevokeListingReportShareLinkInput;
};

export type MutationRunIngestionDocumentValidationLlmAsJudgeArgs = {
  input: RunIngestionDocumentValidationLlmAsJudgeInput;
};

export type MutationSaveCheckboxExportDatasetArgs = {
  input: SaveCheckboxExportDatasetInput;
};

export type MutationSaveComplianceGroupTransactionStageArgs = {
  input: SaveComplianceGroupTransactionStageInput;
};

export type MutationSaveComplianceGroupTransactionStageByTypeArgs = {
  input: SaveComplianceGroupTransactionStageByTypeInput;
};

export type MutationSaveExtractedFieldsFromEvaluationArgs = {
  evaluationId: Scalars["ID"]["input"];
};

export type MutationSaveSignatureInitialDatasetArgs = {
  input: SaveSignatureInitialDatasetInput;
};

export type MutationSaveSignatureInitialValidationsArgs = {
  input: SaveSignatureInitialDatasetInput;
};

export type MutationSendBoaShareLinkArgs = {
  input: SendBoaShareLinkInput;
};

export type MutationSendComplianceSummaryNotificationArgs = {
  input: SendComplianceSummaryNotificationInput;
};

export type MutationSendListingReportShareLinkArgs = {
  input: SendListingReportShareLinkInput;
};

export type MutationSendOtpFromInvitationLinkArgs = {
  input: SendOtpFromInvitationLinkInput;
};

export type MutationSendSellerInvitationArgs = {
  input: SendSellerInvitationInput;
};

export type MutationSendSignatureRequestToBuyersForOfferArgs = {
  input: SendSignatureRequestToBuyersForOfferInput;
};

export type MutationSendSignatureRequestToSellersForOfferArgs = {
  input: SendSignatureRequestToSellersForOfferInput;
};

export type MutationSendTestNotificationArgs = {
  input: SendTestNotificationInput;
};

export type MutationSetDocumentVersionAsActiveArgs = {
  input: SetDocumentVersionAsActiveInput;
};

export type MutationShareStorefrontWithBuyerArgs = {
  input: ShareStorefrontWithBuyerInput;
};

export type MutationSignListingGuestbookArgs = {
  input: ListingInput;
};

export type MutationSignOpenHouseGuestbookArgs = {
  input: OpenHouseGuestbookInput;
};

export type MutationSignUpAgentArgs = {
  input: SignUpAgentInput;
};

export type MutationSignUpAgentV2Args = {
  input: SignUpAgentV2Input;
};

export type MutationSignUpConsumerArgs = {
  input: SignUpInput;
};

export type MutationSubmitOfferForBuyersAgentArgs = {
  input: SubmitOfferInput;
};

export type MutationSubmitOfferToNonIndigoListingAgentArgs = {
  input: SubmitOfferToNonIndigoListingAgentInput;
};

export type MutationSyncAcroformToDocumentVersionFieldsArgs = {
  input: SyncAcroformToDocumentVersionFieldsInput;
};

export type MutationSyncSecondaryDocumentVersionsArgs = {
  input: SyncSecondaryDocumentVersionsInput;
};

export type MutationTerminateOfferGroupArgs = {
  input: TerminateOfferGroupInput;
};

export type MutationTrackListingDocumentActionArgs = {
  input: TrackListingDocumentActionInput;
};

export type MutationTriggerBatchValidationRerunArgs = {
  folderIds: Array<Scalars["ID"]["input"]>;
  recalculateStage?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type MutationUnfollowListingArgs = {
  input: ListingInput;
};

export type MutationUpdateAiConversationArgs = {
  input: UpdateAiConversationInput;
};

export type MutationUpdateAutofillArgs = {
  input: UpdateAutofillInput;
};

export type MutationUpdateBuyerOfferAnalysisArgs = {
  input: UpdateBuyerOfferAnalysisInput;
};

export type MutationUpdateCheckboxDatasetArgs = {
  input: UpdateCheckboxDatasetInput;
};

export type MutationUpdateComplianceKeyTermSectionFieldsArgs = {
  input: UpdateComplianceKeyTermSectionFieldsInput;
};

export type MutationUpdateComplianceKeyTermSectionsArgs = {
  inputs: Array<UpdateComplianceKeyTermSectionInput>;
};

export type MutationUpdateComplianceKeyTermSectionsOrderArgs = {
  inputs: Array<UpdateComplianceKeyTermSectionsOrderInput>;
};

export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};

export type MutationUpdateContractArgs = {
  input: UpdateContractInput;
};

export type MutationUpdateContractDocumentCustomFieldsArgs = {
  input: UpdateContractDocumentCustomFieldsInput;
};

export type MutationUpdateContractDocumentExclusionsArgs = {
  input: UpdateContractDocumentExclusionsInput;
};

export type MutationUpdateContractDocumentsArgs = {
  input: UpdateContractDocumentsInput;
};

export type MutationUpdateDefaultSecondaryDocumentsArgs = {
  input: Array<UpdateDefaultSecondaryDocumentInput>;
};

export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};

export type MutationUpdateDocumentLlmArgs = {
  id: Scalars["ID"]["input"];
  input: DocumentLlmInput;
};

export type MutationUpdateDocumentSectionFieldsArgs = {
  input: UpdateDocumentSectionFieldsInput;
};

export type MutationUpdateDocumentSectionsArgs = {
  inputs: Array<UpdateDocumentSectionInput>;
};

export type MutationUpdateDocumentSectionsOrderArgs = {
  inputs: Array<UpdateDocumentSectionsOrderInput>;
};

export type MutationUpdateDocumentVersionArgs = {
  id: Scalars["ID"]["input"];
  input: UpdateDocumentVersionInput;
};

export type MutationUpdateDocumentVersionFieldsArgs = {
  inputs: Array<UpdateDocumentVersionFieldInput>;
};

export type MutationUpdateFieldArgs = {
  input: UpdateFieldInput;
};

export type MutationUpdateIndigoContractArgs = {
  input: UpdateIndigoContractInput;
};

export type MutationUpdateIntegrationClientArgs = {
  input: UpdateIntegrationClientInput;
};

export type MutationUpdateListingComparableSetArgs = {
  input: UpdateListingComparableSetInput;
};

export type MutationUpdateListingComparableSetForAgentArgs = {
  input: UpdateListingComparableSetForAgentInput;
};

export type MutationUpdateListingComparableSetForBuyerOfferAnalysisArgs = {
  input: UpdateListingComparableSetForBuyerOfferAnalysisInput;
};

export type MutationUpdateListingPreferenceArgs = {
  input: UpdateListingPreferenceValueInput;
};

export type MutationUpdateNotificationTemplateArgs = {
  input: UpdateNotificationTemplateInput;
};

export type MutationUpdateOfferForBuyersAgentArgs = {
  input: UpdateOfferForBuyersAgentInput;
};

export type MutationUpdateOfferWithPartyArgs = {
  input: UpdateOfferWithPartyInput;
};

export type MutationUpdateOpenHouseArgs = {
  input: UpdateOpenHouseInput;
};

export type MutationUpdateOrCreateContractSystemCredentialsArgs = {
  input: UpdateContractSystemCredentialsInput;
};

export type MutationUpdateOrCreateFieldsToColumnArgs = {
  input: UpdateOrCreateFieldsToColumnInput;
};

export type MutationUpdateOrCreateOrganizationRosterPreferenceArgs = {
  input: UpdateOrCreateOrganizationRosterPreferenceInput;
};

export type MutationUpdateOrCreateTransactionRuleArgs = {
  input: UpdateOrCreateTransactionRuleInput;
};

export type MutationUpdateOrCreateTransactionStageArgs = {
  input: UpdateOrCreateTransactionStageInput;
};

export type MutationUpdateOrganizationFolderNameValidationStageOverrideArgs = {
  input: UpdateOrganizationFolderNameValidationStageOverrideInput;
};

export type MutationUpdateOrganizationPartnerArgs = {
  input: UpdateOrganizationPartnerInput;
};

export type MutationUpdateOrganizationRosterEntryArgs = {
  input: UpdateOrganizationRosterEntryInput;
};

export type MutationUpdateOrganizationValidationSettingsArgs = {
  input: UpdateOrganizationValidationSettingsInput;
};

export type MutationUpdateParentOrganizationArgs = {
  input: UpdateParentOrganizationInput;
};

export type MutationUpdatePartnerContactArgs = {
  input: UpdatePartnerContactInput;
};

export type MutationUpdatePartyForBuyersAgentArgs = {
  input: UpdatePartyForBuyersAgentInput;
};

export type MutationUpdatePropertyDetailsArgs = {
  input: UpdatePropertyDetailsInput;
};

export type MutationUpdateRuleArgs = {
  input: UpdateRuleInput;
};

export type MutationUpdateRulesForTransactionRuleArgs = {
  input: UpdateRulesForTransactionRuleInput;
};

export type MutationUpdateSecondaryDocumentVersionArgs = {
  input: UpdateSecondaryDocumentVersionInput;
};

export type MutationUpdateSignatureInitialsDatasetArgs = {
  input: UpdateSignatureInitialsDatasetInput;
};

export type MutationUpdateSortOrderArgs = {
  inputs: Array<UpdateSortOrderInput>;
};

export type MutationUpdateStorefrontSetupArgs = {
  input: UpdateStorefrontSetupInput;
};

export type MutationUpdateTransactionRuleParentArgs = {
  input: UpdateTransactionRuleParentInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationUpdateUserNotificationSettingsArgs = {
  input: NotificationSettingsInput;
};

export type MutationUpdateUserSettingsArgs = {
  input: UpdateUserSettingsInput;
};

export type MutationUploadAndExtractAgentNegotiationDocumentsArgs = {
  input: UploadListingDocumentInput;
};

export type MutationUploadListingDocumentArgs = {
  input: UploadListingDocumentInput;
};

export type MutationUploadOfferArgs = {
  input: UploadOfferInput;
};

export type MutationUploadOfferAsListingAgentArgs = {
  input: UploadOfferInput;
};

export type MutationUploadOfferForBuyersAgentArgs = {
  input: UploadOfferInput;
};

export type MutationUploadOfferForUnauthenticatedBuyersAgentArgs = {
  input: UploadOfferInput;
};

export type MutationUpsertOrganizationPartnerStageIntroArgs = {
  input: UpsertOrganizationPartnerStageIntroInput;
};

export type MutationValidateTransactionPipelineArgs = {
  input: ValidateTransactionPipelineInput;
};

export type MutationValidateTransactionRuleOnProductionArgs = {
  input: ValidateTransactionRuleOnProductionInput;
};

export type MutationVerifyShareLinkArgs = {
  input: VerifyShareLinkInput;
};

export enum NormalizedTransactionStatus {
  ACTIVE = "ACTIVE",
  CANCELLED = "CANCELLED",
  CLOSED = "CLOSED",
  OTHER = "OTHER",
  PRE_STAGE = "PRE_STAGE",
  PRIVATE_LISTING = "PRIVATE_LISTING",
  UNDER_CONTRACT = "UNDER_CONTRACT",
  UNKNOWN = "UNKNOWN",
}

export type NotificationLogAutofillObject = {
  __typename?: "NotificationLogAutofillObject";
  assignedAgentFirstName?: Maybe<Scalars["String"]["output"]>;
  assignedAgentName?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerCalendarSchedulingUrl?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerEmail?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerFirstName?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerName?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  assignedPartnerPreApprovalAppUrl?: Maybe<Scalars["String"]["output"]>;
  buyerAgentFirstName?: Maybe<Scalars["String"]["output"]>;
  buyersFirstNames?: Maybe<Scalars["String"]["output"]>;
  listingAgentFirstName?: Maybe<Scalars["String"]["output"]>;
  normalizedFieldValues?: Maybe<Scalars["JSONObject"]["output"]>;
  partnerCompanyName?: Maybe<Scalars["String"]["output"]>;
  sellersFirstNames?: Maybe<Scalars["String"]["output"]>;
};

export type NotificationLogFilters = {
  dateFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  dateTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  eventType?: InputMaybe<TransactionStageType>;
  notificationType?: InputMaybe<NotificationType>;
  recipientId?: InputMaybe<Scalars["ID"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type NotificationLogInterface = {
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  messageContent: Scalars["String"]["output"];
  rawRecipients?: Maybe<Array<NotificationUserObject>>;
  recipients: Array<ContactObject>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

export enum NotificationLogKind {
  GLOBAL_INTRO = "GLOBAL_INTRO",
  STAGE_INTRO = "STAGE_INTRO",
  STAGE_TEMPLATE = "STAGE_TEMPLATE",
}

export type NotificationSettingsInput = {
  email: Scalars["Boolean"]["input"];
  sms: Scalars["Boolean"]["input"];
};

export type NotificationTemplateFilters = {
  side?: InputMaybe<TransactionSide>;
  status?: InputMaybe<NotificationTemplateStatus>;
};

export type NotificationTemplateMessageContentTemplates = {
  __typename?: "NotificationTemplateMessageContentTemplates";
  html: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
};

export type NotificationTemplateObject = {
  __typename?: "NotificationTemplateObject";
  createdAt: Scalars["DateTime"]["output"];
  dataToShare: Array<Scalars["String"]["output"]>;
  delayMinutes: Scalars["Int"]["output"];
  eventType: TransactionStageType;
  hasAssignedPartner?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  isAttachedToPartner?: Maybe<Scalars["Boolean"]["output"]>;
  messageContent: Scalars["String"]["output"];
  messageContentTemplates: NotificationTemplateMessageContentTemplates;
  notificationType: NotificationType;
  orderIndex: Scalars["Int"]["output"];
  partner?: Maybe<OrganizationPartnerObject>;
  recipients: Array<ContactType>;
  side?: Maybe<TransactionSide>;
  status: NotificationTemplateStatus;
  title: Scalars["String"]["output"];
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of NotificationTemplateObject */
export type NotificationTemplateObjectNotificationTemplateListPaginatedPaginated =
  {
    __typename?: "NotificationTemplateObjectNotificationTemplateListPaginatedPaginated";
    pageInfo?: Maybe<PageInfoObject>;
    results?: Maybe<Array<NotificationTemplateObject>>;
  };

export enum NotificationTemplateStatus {
  APPROVED = "APPROVED",
  ARCHIVED = "ARCHIVED",
  DRAFT = "DRAFT",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  PUBLISHED = "PUBLISHED",
}

export enum NotificationType {
  EMAIL = "EMAIL",
  TEXT = "TEXT",
}

export type NotificationUserObject = {
  __typename?: "NotificationUserObject";
  contactType?: Maybe<ContactType>;
  email?: Maybe<Scalars["String"]["output"]>;
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type ObservedDotloopOfficeObject = {
  __typename?: "ObservedDotloopOfficeObject";
  officeId: Scalars["String"]["output"];
  officeNameSnapshot?: Maybe<Scalars["String"]["output"]>;
  platformProfileId: Scalars["String"]["output"];
};

export type OfferAgentObject = {
  __typename?: "OfferAgentObject";
  fullName: Scalars["String"]["output"];
  profilePicture?: Maybe<FileObject>;
};

export type OfferAutofillObject = {
  __typename?: "OfferAutofillObject";
  buyer?: Maybe<AutofillConsumerObject>;
  buyerSignatures?: Maybe<Scalars["Boolean"]["output"]>;
  buyersAgent?: Maybe<UserObject>;
  buyersAgentRESOMemberData?: Maybe<ResoMemberObject>;
  buyersAgentRESOOfficeData?: Maybe<ResoOfficeObject>;
  buyersAgentSignatures?: Maybe<Scalars["Boolean"]["output"]>;
  coBuyer?: Maybe<AutofillConsumerObject>;
  coSeller?: Maybe<AutofillConsumerObject>;
  latestSale?: Maybe<AutofillSaleObject>;
  listingAgent?: Maybe<UserObject>;
  listingAgentRESOMemberData?: Maybe<ResoMemberObject>;
  listingAgentRESOOfficeData?: Maybe<ResoOfficeObject>;
  mlsListing?: Maybe<MlsListingObject>;
  offerKeyFields?: Maybe<OfferKeyFieldsObject>;
  partyFinancing?: Maybe<PartyFinancingObject>;
  preference?: Maybe<Scalars["JSONObject"]["output"]>;
  property?: Maybe<PropertyObject>;
  secondaryContractDocuments?: Maybe<Array<SecondaryContractDocumentObject>>;
  selectedMlsListings?: Maybe<Array<MlsListingObject>>;
  seller?: Maybe<AutofillConsumerObject>;
  sellerSignatures?: Maybe<Scalars["Boolean"]["output"]>;
};

export type OfferAutofillValuesPayload = {
  __typename?: "OfferAutofillValuesPayload";
  autofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  helpTextAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  optionsAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
  readOnlyAutofillValues?: Maybe<Scalars["JSONObject"]["output"]>;
};

export type OfferAutofillVariableValuesFromContractPayload = {
  __typename?: "OfferAutofillVariableValuesFromContractPayload";
  extractedBuyerInfos?: Maybe<ExtractedContractBuyerInfos>;
  offerAutofill?: Maybe<OfferAutofillObject>;
};

export type OfferGroupObject = {
  __typename?: "OfferGroupObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  ingestionDocuments: Array<IngestionDocumentObject>;
  partyName?: Maybe<Scalars["String"]["output"]>;
  partyRole?: Maybe<ParticipantRole>;
  terminatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type OfferInfoInput = {
  attachmentName?: InputMaybe<Scalars["String"]["input"]>;
  noteToListingAgent?: InputMaybe<Scalars["String"]["input"]>;
};

export type OfferIngestionAutofillObject = {
  __typename?: "OfferIngestionAutofillObject";
  /** @deprecated This field is not populated. Use mlsListing instead when available. */
  activeMlsListing?: Maybe<MlsListingObject>;
  ingestion: OfferIngestionFolderObject;
  mlsListing?: Maybe<MlsListingObject>;
  property?: Maybe<DocumentPropertyObject>;
};

export type OfferIngestionFolderObject = {
  __typename?: "OfferIngestionFolderObject";
  documentCategories: Array<DocumentCategory>;
  documentFormNames: Array<Scalars["String"]["output"]>;
  metadata: OfferIngestionMetadataObject;
  normalizedStatus?: Maybe<NormalizedTransactionStatus>;
  organizationId: Scalars["String"]["output"];
  stage?: Maybe<TransactionStageType>;
  transactionSide: TransactionSide;
};

export type OfferIngestionMetadataObject = {
  __typename?: "OfferIngestionMetadataObject";
  agent_name?: Maybe<Scalars["String"]["output"]>;
  folder_id?: Maybe<Scalars["String"]["output"]>;
  folder_name?: Maybe<Scalars["String"]["output"]>;
  office_id?: Maybe<Scalars["String"]["output"]>;
  office_name?: Maybe<Scalars["String"]["output"]>;
  participants: OfferIngestionParticipantsObject;
  transaction_closing_date?: Maybe<Scalars["String"]["output"]>;
};

export type OfferIngestionParticipantsObject = {
  __typename?: "OfferIngestionParticipantsObject";
  buyerAgentNames?: Maybe<Array<Scalars["String"]["output"]>>;
  buyerNames?: Maybe<Array<Scalars["String"]["output"]>>;
  listingAgentNames?: Maybe<Array<Scalars["String"]["output"]>>;
  otherTeamMemberNames?: Maybe<Array<Scalars["String"]["output"]>>;
  sellerNames?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type OfferKeyFieldsBuyerObject = {
  __typename?: "OfferKeyFieldsBuyerObject";
  buyerName?: Maybe<Scalars["String"]["output"]>;
  buyerNames?: Maybe<Scalars["String"]["output"]>;
  buyerNamesLine2?: Maybe<Scalars["String"]["output"]>;
  coBuyerName?: Maybe<Scalars["String"]["output"]>;
  entityBuyerName?: Maybe<Scalars["String"]["output"]>;
  entityBuyerPrintName?: Maybe<Scalars["String"]["output"]>;
  entityBuyerTitle?: Maybe<Scalars["String"]["output"]>;
};

export type OfferKeyFieldsObject = {
  __typename?: "OfferKeyFieldsObject";
  agentCompensation?: Maybe<AutofillAgentCompensationObject>;
  buyer?: Maybe<OfferKeyFieldsBuyerObject>;
  buyersAgentName?: Maybe<Scalars["String"]["output"]>;
  buyersAgentOfficeName?: Maybe<Scalars["String"]["output"]>;
  closingDate?: Maybe<Scalars["String"]["output"]>;
  dueDiligenceFee?: Maybe<Scalars["Float"]["output"]>;
  earnestMoneyDeposit?: Maybe<Scalars["Float"]["output"]>;
  financingType?: Maybe<Scalars["String"]["output"]>;
  listing?: Maybe<AutofillListingObject>;
  offerAmount?: Maybe<Scalars["Float"]["output"]>;
};

export type OfferMetricsObject = {
  __typename?: "OfferMetricsObject";
  accepted_bid_ask: Scalars["Float"]["output"];
  accepted_count: Scalars["Int"]["output"];
  accepted_due_diligence_and_deposit: Scalars["Float"]["output"];
  accepted_due_diligence_fee: Scalars["Float"]["output"];
  accepted_earnest_money_deposit: Scalars["Float"]["output"];
  interval_start: Scalars["String"]["output"];
  not_accepted_bid_ask: Scalars["Float"]["output"];
  not_accepted_count: Scalars["Int"]["output"];
  not_accepted_due_diligence_and_deposit: Scalars["Float"]["output"];
  not_accepted_due_diligence_fee: Scalars["Float"]["output"];
  not_accepted_earnest_money_deposit: Scalars["Float"]["output"];
  property_city: Scalars["String"]["output"];
  property_state: Scalars["String"]["output"];
  purchase_price_range: Scalars["String"]["output"];
};

export type OfferObject = {
  __typename?: "OfferObject";
  buyersAgent?: Maybe<AgentObject>;
  contract?: Maybe<ContractObject>;
  contractId: Scalars["String"]["output"];
  events?: Maybe<Array<AppEventObject>>;
  file: FileObject;
  id: Scalars["ID"]["output"];
  isUploaded: Scalars["Boolean"]["output"];
  listing?: Maybe<ListingObject>;
  noteToListingAgent?: Maybe<Scalars["String"]["output"]>;
  party?: Maybe<PartyObject>;
  primaryBuyer?: Maybe<ConsumerObject>;
  secondaryBuyers?: Maybe<Array<ConsumerObject>>;
  source?: Maybe<OfferSource>;
  status: OfferStatus;
  submittedAt?: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** Paginated results of OfferObject */
export type OfferObjectPaginated = {
  __typename?: "OfferObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<OfferObject>>;
};

export type OfferPropertyObject = {
  __typename?: "OfferPropertyObject";
  address: AddressObject;
  coverPhotoUrl?: Maybe<Scalars["String"]["output"]>;
  geo?: Maybe<GeoObject>;
};

export type OfferRecsPayload = {
  __typename?: "OfferRecsPayload";
  competitiveness: CompetitivenessScore;
  contingencies: Array<ContingencyResult>;
  keyTerms: Array<KeyTermResult>;
};

export type OfferScore = {
  __typename?: "OfferScore";
  offerScoreExplanation?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  value: Scalars["Int"]["output"];
};

export type OfferScoreNotCalculated = {
  __typename?: "OfferScoreNotCalculated";
  reason: Scalars["String"]["output"];
};

export type OfferScoreResult = OfferScore | OfferScoreNotCalculated;

export type OfferScorecardsFilterInput = {
  partyUuid?: InputMaybe<Scalars["String"]["input"]>;
  period?: InputMaybe<BusinessOverviewPeriod>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

/** Represents a metric value for offer scorecards with value and delta */
export type OfferScorecardsMetricValue = {
  __typename?: "OfferScorecardsMetricValue";
  /** The change in value compared to the previous week */
  delta: Scalars["Float"]["output"];
  /** The value for the metric this week (Monday as start of week aligned) */
  value: Scalars["Float"]["output"];
};

/** Collection of metrics related to offer scorecards */
export type OfferScorecardsMetrics = {
  __typename?: "OfferScorecardsMetrics";
  averageScore: OfferScorecardsMetricValue;
  created: OfferScorecardsMetricValue;
  shared: OfferScorecardsMetricValue;
};

export enum OfferSource {
  BA_EMAIL_ATTACHMENT = "BA_EMAIL_ATTACHMENT",
  BA_UPLOAD = "BA_UPLOAD",
  BA_WRITE = "BA_WRITE",
  LA_EMAIL_ATTACHMENT = "LA_EMAIL_ATTACHMENT",
  LA_UPLOAD = "LA_UPLOAD",
  OFFER_INGESTION = "OFFER_INGESTION",
  OTHER_SENDER_EMAIL_ATTACHMENT = "OTHER_SENDER_EMAIL_ATTACHMENT",
}

export enum OfferStatus {
  ACCEPTED = "ACCEPTED",
  ACTIVE = "ACTIVE",
  BUYER_SIGNATURE_REQUEST_SENT = "BUYER_SIGNATURE_REQUEST_SENT",
  CANCELED = "CANCELED",
  DECLINED = "DECLINED",
  DRAFT = "DRAFT",
  INGESTED = "INGESTED",
  RESCINDED = "RESCINDED",
  STATUS_UNKNOWN = "STATUS_UNKNOWN",
  SUBMITTED_TO_LISTING_AGENT = "SUBMITTED_TO_LISTING_AGENT",
}

export type OffersByFinancingTypeTableRow = {
  __typename?: "OffersByFinancingTypeTableRow";
  allTypes: TableRowDataValue;
  cash?: Maybe<TableRowDataValue>;
  conventional?: Maybe<TableRowDataValue>;
  fhaVaUsda?: Maybe<TableRowDataValue>;
  other?: Maybe<TableRowDataValue>;
};

export type OffersForCurrentUserFilters = {
  forBuyer?: InputMaybe<Scalars["Boolean"]["input"]>;
  forSeller?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OffersForListingInput = {
  listingId: Scalars["String"]["input"];
  partyId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type OpenHouseCrudOptions = {
  notifyGuestbookSigners: Scalars["Boolean"]["input"];
};

export type OpenHouseGuestbookInput = {
  metadata?: InputMaybe<Scalars["JSON"]["input"]>;
  openHouseId: Scalars["String"]["input"];
  sendNotification?: Scalars["Boolean"]["input"];
  userId: Scalars["String"]["input"];
};

export type OpenHouseInput = {
  id: Scalars["String"]["input"];
};

export type OpenHouseObject = {
  __typename?: "OpenHouseObject";
  date: Scalars["LocalDate"]["output"];
  /** End time in UTC */
  endTime: Scalars["LocalTime"]["output"];
  id: Scalars["ID"]["output"];
  listing: ListingObject;
  numGuestbookSigners: Scalars["Float"]["output"];
  source: OpenHouseSource;
  /** Start time in UTC */
  startTime: Scalars["LocalTime"]["output"];
};

/** Paginated results of OpenHouseObject */
export type OpenHouseObjectPaginated = {
  __typename?: "OpenHouseObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<OpenHouseObject>>;
};

export enum OpenHouseSource {
  CREATED_BY_USER = "CREATED_BY_USER",
  MLS = "MLS",
}

export type OpenHousesFilterArgs = {
  isUpcoming?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrgListingAggDeltaByStatusInput = {
  numberOfDays?: InputMaybe<Scalars["Float"]["input"]>;
  organizationId: Scalars["String"]["input"];
  statuses?: InputMaybe<Array<MlsListingStatus>>;
};

export type OrgListingAggDeltaByStatusPayload = {
  __typename?: "OrgListingAggDeltaByStatusPayload";
  differences: Array<ListingAggDeltaByStatus>;
  organization: OrganizationObject;
};

export type OrgTransactionStatsByZipCodeObject = {
  __typename?: "OrgTransactionStatsByZipCodeObject";
  buy_side_homes_count: Scalars["Int"]["output"];
  buy_side_volume: Scalars["Float"]["output"];
  closed_homes_count: Scalars["Int"]["output"];
  closed_volume: Scalars["Float"]["output"];
  pending_homes_count: Scalars["Int"]["output"];
  pending_volume: Scalars["Float"]["output"];
  sell_side_homes_count: Scalars["Int"]["output"];
  sell_side_volume: Scalars["Float"]["output"];
  total_homes_count: Scalars["Int"]["output"];
  total_volume: Scalars["Float"]["output"];
  unknown_homes_count: Scalars["Int"]["output"];
  zip_code: Scalars["String"]["output"];
};

export enum OrganizationBranchType {
  BRANCH = "BRANCH",
  INDIVIDUAL = "INDIVIDUAL",
  MAIN = "MAIN",
  STAND_ALONE = "STAND_ALONE",
}

export type OrganizationFolderNameValidationStageOverrideObject = {
  __typename?: "OrganizationFolderNameValidationStageOverrideObject";
  isEnabled: Scalars["Boolean"]["output"];
  keywordMappings: Array<FolderNameValidationStageKeywordMappingObject>;
  organizationUuid: Scalars["ID"]["output"];
};

export type OrganizationListingCountsByStatusPayload = {
  __typename?: "OrganizationListingCountsByStatusPayload";
  aggregates: Array<ListingCountsByStatus>;
  organization: OrganizationObject;
};

export type OrganizationObject = {
  __typename?: "OrganizationObject";
  children?: Maybe<Array<OrganizationObject>>;
  contractSystemCredentials?: Maybe<Array<ContractSystemCredentialsObject>>;
  hasDescendants?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  mainMLS?: Maybe<MlsObject>;
  name: Scalars["String"]["output"];
  officeCity?: Maybe<Scalars["String"]["output"]>;
  officeEmail?: Maybe<Scalars["String"]["output"]>;
  officePhoneNumber?: Maybe<Scalars["String"]["output"]>;
  officeState?: Maybe<Scalars["String"]["output"]>;
  officeStreetAddress?: Maybe<Scalars["String"]["output"]>;
  officeZipCode?: Maybe<Scalars["String"]["output"]>;
  organizationBranchType?: Maybe<OrganizationBranchType>;
  organizationType?: Maybe<OrganizationType>;
  parent?: Maybe<OrganizationObject>;
};

export type OrganizationOfficesAndTeamsPayload = {
  __typename?: "OrganizationOfficesAndTeamsPayload";
  offices: Array<OrganizationObject>;
  teams: Array<OrganizationObject>;
};

export type OrganizationPartnerContactUnion =
  | InsuranceAgentContactObject
  | LoanOfficerContactObject
  | TitleAgentContactObject;

export type OrganizationPartnerFilters = {
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type OrganizationPartnerObject = {
  __typename?: "OrganizationPartnerObject";
  adminContacts?: Maybe<Array<ContactObject>>;
  contacts?: Maybe<Array<ContactObject>>;
  createdAt: Scalars["DateTime"]["output"];
  dryRunNotifications: Scalars["Boolean"]["output"];
  emailDomain?: Maybe<Scalars["String"]["output"]>;
  existingRelationshipIntroMessage: Scalars["String"]["output"];
  hasDrafts: Scalars["Boolean"]["output"];
  id: Scalars["ID"]["output"];
  isActive: Scalars["Boolean"]["output"];
  logo?: Maybe<FileObject>;
  name: Scalars["String"]["output"];
  newRelationshipIntroMessage: Scalars["String"]["output"];
  organization?: Maybe<OrganizationObject>;
  partnerType: PartnerType;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of OrganizationPartnerObject */
export type OrganizationPartnerObjectPaginated = {
  __typename?: "OrganizationPartnerObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<OrganizationPartnerObject>>;
};

export type OrganizationPartnerStageIntroObject = {
  __typename?: "OrganizationPartnerStageIntroObject";
  allowPartnerContactAssignment: Scalars["Boolean"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  existingRelationshipMessageContent: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  newRelationshipMessageContent: Scalars["String"]["output"];
  side: TransactionSide;
  stage: TransactionStageType;
  updatedAt: Scalars["DateTime"]["output"];
};

export type OrganizationRosterFilters = {
  isContactable?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationPartnerId?: InputMaybe<Scalars["ID"]["input"]>;
  searchQuery?: InputMaybe<Scalars["String"]["input"]>;
};

export type OrganizationRosterObject = {
  __typename?: "OrganizationRosterObject";
  contact: ContactObject;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  isContactable: Scalars["Boolean"]["output"];
  organization: OrganizationObject;
  preferences: Array<OrganizationRosterPreferenceObject>;
  updatedAt: Scalars["DateTime"]["output"];
};

/** Paginated results of OrganizationRosterObject */
export type OrganizationRosterObjectOrganizationRosterListPaginatedPaginated = {
  __typename?: "OrganizationRosterObjectOrganizationRosterListPaginatedPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<OrganizationRosterObject>>;
};

export type OrganizationRosterPreferenceObject = {
  __typename?: "OrganizationRosterPreferenceObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  partner?: Maybe<OrganizationPartnerObject>;
  partnerContact?: Maybe<ContactObject>;
  partnerType: PartnerType;
  preferenceType: PartnerPreferenceType;
  roster: OrganizationRosterObject;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum OrganizationType {
  BROKERAGE = "BROKERAGE",
  FRANCHISOR = "FRANCHISOR",
  INDIVIDUAL = "INDIVIDUAL",
  TEAM = "TEAM",
}

export type OrganizationValidationSettingsConfiguredOrganizationObject = {
  __typename?: "OrganizationValidationSettingsConfiguredOrganizationObject";
  documentIgnoredRuleIds: Array<Scalars["String"]["output"]>;
  organizationId: Scalars["String"]["output"];
  stageIgnoredRuleIds: Array<Scalars["String"]["output"]>;
};

export type OrganizationValidationSettingsObject = {
  __typename?: "OrganizationValidationSettingsObject";
  configuredOrganizations: Array<OrganizationValidationSettingsConfiguredOrganizationObject>;
  documentIgnoredRuleIds: Array<Scalars["String"]["output"]>;
  stageIgnoredRuleIds: Array<Scalars["String"]["output"]>;
};

export type OverrideIngestionDocumentClassificationInput = {
  documentVersionPagePairs: Array<DocumentVersionPagePairInput>;
  ingestionDocumentId: Scalars["String"]["input"];
};

export type OverrideKeyTermInput = {
  /** keyof NormalizedOfferFieldValues (for now) */
  key: Scalars["String"]["input"];
  /** JSON value to handle string | number | boolean | null (null clears the field) */
  value?: InputMaybe<Scalars["JSON"]["input"]>;
};

export type OverrideKeyTermsForIngestionFolderInput = {
  ingestionFolderUuid: Scalars["ID"]["input"];
  keyTermOverrides: Array<OverrideKeyTermInput>;
};

export type OverrideKeyTermsForIngestionFolderPayload = {
  __typename?: "OverrideKeyTermsForIngestionFolderPayload";
  success: Scalars["Boolean"]["output"];
};

export type PageInfoObject = {
  __typename?: "PageInfoObject";
  hasNextPage: Scalars["Boolean"]["output"];
  hasPrevPage: Scalars["Boolean"]["output"];
  nextCursor?: Maybe<Scalars["String"]["output"]>;
  perPage: Scalars["Int"]["output"];
  prevCursor?: Maybe<Scalars["String"]["output"]>;
  totalCount: Scalars["Int"]["output"];
};

export type ParticipantInput = {
  role: ParticipantRole;
};

export enum ParticipantRole {
  BUYER = "BUYER",
  BUYERS_AGENT = "BUYERS_AGENT",
  LISTING_AGENT = "LISTING_AGENT",
  LOAN_OFFICER = "LOAN_OFFICER",
  OTHER_TEAM_MEMBER = "OTHER_TEAM_MEMBER",
  SELLER = "SELLER",
  TRANSACTION_COORDINATOR = "TRANSACTION_COORDINATOR",
}

export type Participants = {
  __typename?: "Participants";
  buyers: Array<ClientParticipant>;
  buyersAgents: Array<AgentParticipant>;
  listingAgents: Array<AgentParticipant>;
  loanOfficers: Array<ClientParticipant>;
  sellers: Array<ClientParticipant>;
  transactionCoordinators: Array<ClientParticipant>;
};

export type PartnerContactBaseObject = {
  contactType: ContactType;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  partner?: Maybe<OrganizationPartnerObject>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum PartnerPreferenceType {
  ROTATION = "ROTATION",
  SET_PER_TRANSACTION = "SET_PER_TRANSACTION",
  SPECIFIC_CONTACT = "SPECIFIC_CONTACT",
}

export enum PartnerType {
  INSURANCE = "INSURANCE",
  LENDER = "LENDER",
  TITLE = "TITLE",
}

export type PartyAndBuyerInfoInput = {
  id: Scalars["String"]["input"];
};

export type PartyFinancingObject = {
  __typename?: "PartyFinancingObject";
  cashReserves?: Maybe<Scalars["Float"]["output"]>;
  financingType?: Maybe<FinancingType>;
  id: Scalars["ID"]["output"];
  isPreapproveAttached?: Maybe<Scalars["Boolean"]["output"]>;
  loanAmount?: Maybe<Scalars["Float"]["output"]>;
  percentDownPayment?: Maybe<Scalars["Float"]["output"]>;
  preapprovalFile?: Maybe<FileObject>;
};

export type PartyObject = {
  __typename?: "PartyObject";
  buyersAgent?: Maybe<AgentObject>;
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  latestBuyerOfferAnalysis?: Maybe<BuyerOfferAnalysisObject>;
  listingAgent?: Maybe<AgentObject>;
  partyFinancing?: Maybe<PartyFinancingObject>;
  primaryConsumer: ConsumerObject;
  purchaseOffers?: Maybe<Array<OfferObject>>;
  secondaryConsumers: Array<ConsumerObject>;
};

/** Paginated results of PartyObject */
export type PartyObjectPaginated = {
  __typename?: "PartyObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PartyObject>>;
};

export type PerAgentOfferAcceptRateObject = {
  __typename?: "PerAgentOfferAcceptRateObject";
  accepted_offers: Scalars["Int"]["output"];
  agent_name: Scalars["String"]["output"];
  average_bid_ask?: Maybe<Scalars["Float"]["output"]>;
  average_dd_days?: Maybe<Scalars["Float"]["output"]>;
  average_ddf_ratio?: Maybe<Scalars["Float"]["output"]>;
  average_offer_to_close_days: Scalars["Float"]["output"];
  average_purchase_price: Scalars["Float"]["output"];
  average_termination_fee_ratio?: Maybe<Scalars["Float"]["output"]>;
  closed_volume: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  offer_accept_rate?: Maybe<Scalars["Float"]["output"]>;
  pending_volume: Scalars["Float"]["output"];
  submitted_offers: Scalars["Int"]["output"];
  terminated_offers: Scalars["Int"]["output"];
  total_offers: Scalars["Int"]["output"];
  total_volume: Scalars["Float"]["output"];
};

export type PerAgentTransactionStatsObject = {
  __typename?: "PerAgentTransactionStatsObject";
  agent_name: Scalars["String"]["output"];
  buy_side_homes_count: Scalars["Int"]["output"];
  buy_side_volume: Scalars["Float"]["output"];
  closed_homes_count: Scalars["Int"]["output"];
  closed_volume: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  pending_homes_count: Scalars["Int"]["output"];
  pending_volume: Scalars["Float"]["output"];
  sell_side_homes_count: Scalars["Int"]["output"];
  sell_side_volume: Scalars["Float"]["output"];
  terminated_homes_count: Scalars["Int"]["output"];
  total_homes_count: Scalars["Int"]["output"];
  total_volume: Scalars["Float"]["output"];
  unknown_homes_count: Scalars["Int"]["output"];
};

export type PerOfficeOfferAcceptRateObject = {
  __typename?: "PerOfficeOfferAcceptRateObject";
  accepted_offers: Scalars["Int"]["output"];
  average_bid_ask?: Maybe<Scalars["Float"]["output"]>;
  average_dd_days?: Maybe<Scalars["Float"]["output"]>;
  average_ddf_ratio?: Maybe<Scalars["Float"]["output"]>;
  average_offer_to_close_days: Scalars["Float"]["output"];
  average_purchase_price: Scalars["Float"]["output"];
  average_termination_fee_ratio?: Maybe<Scalars["Float"]["output"]>;
  closed_volume: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  offer_accept_rate?: Maybe<Scalars["Float"]["output"]>;
  pending_volume: Scalars["Float"]["output"];
  submitted_offers: Scalars["Int"]["output"];
  terminated_offers: Scalars["Int"]["output"];
  total_offers: Scalars["Int"]["output"];
  total_volume: Scalars["Float"]["output"];
};

export type PerOfficeTransactionStatsObject = {
  __typename?: "PerOfficeTransactionStatsObject";
  buy_side_homes_count: Scalars["Int"]["output"];
  buy_side_volume: Scalars["Float"]["output"];
  closed_homes_count: Scalars["Int"]["output"];
  closed_volume: Scalars["Float"]["output"];
  name: Scalars["String"]["output"];
  pending_homes_count: Scalars["Int"]["output"];
  pending_volume: Scalars["Float"]["output"];
  sell_side_homes_count: Scalars["Int"]["output"];
  sell_side_volume: Scalars["Float"]["output"];
  terminated_homes_count: Scalars["Int"]["output"];
  total_homes_count: Scalars["Int"]["output"];
  total_volume: Scalars["Float"]["output"];
  unknown_homes_count: Scalars["Int"]["output"];
};

export type PermissionObject = {
  __typename?: "PermissionObject";
  isAuthorized: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

export type PipelineContextInput = {
  clientType: ClientType;
  organizationUuid?: InputMaybe<Scalars["String"]["input"]>;
  propertyType: TransactionPropertyType;
  stage: TransactionStageType;
  state: UsState;
};

export type PipelineInvestigationReasonResult = {
  __typename?: "PipelineInvestigationReasonResult";
  failed: Scalars["Boolean"]["output"];
  folderUuid: Scalars["ID"]["output"];
  txPipelineNeedsInvestigationReason?: Maybe<TxPipelineNeedsInvestigationReason>;
};

export type PipelinePreviewResult = {
  __typename?: "PipelinePreviewResult";
  /** All candidate pipelines that matched via DIRECT or RULE */
  candidates: Array<TxPipelineCandidateObject>;
  /** How the current pipeline was assigned to the folder */
  currentMatchedBy?: Maybe<TxPipelineMatchedBy>;
  /** Name of the current pipeline */
  currentPipelineName?: Maybe<Scalars["String"]["output"]>;
  /** UUID of the current pipeline assigned to the folder */
  currentPipelineUuid?: Maybe<Scalars["ID"]["output"]>;
  /** Current stage of the folder */
  currentStage?: Maybe<TransactionStageType>;
  /** Error message if preview failed for this folder */
  error?: Maybe<Scalars["String"]["output"]>;
  /** UUID of the ingestion folder */
  ingestionFolderUuid: Scalars["ID"]["output"];
  /** Reason why this folder needs investigation for pipeline assignment */
  needsInvestigationReason?: Maybe<TxPipelineNeedsInvestigationReason>;
  /** How the proposed pipeline was matched (OVERRIDE if override specified, else DIRECT/RULE) */
  proposedMatchedBy?: Maybe<TxPipelineMatchedBy>;
  /** Name of the proposed pipeline */
  proposedPipelineName?: Maybe<Scalars["String"]["output"]>;
  /** UUID of the proposed pipeline (from override or auto-match). Null if no match found. */
  proposedPipelineUuid?: Maybe<Scalars["ID"]["output"]>;
  /** Stage that would be computed if the proposed pipeline were assigned */
  proposedStage?: Maybe<TransactionStageType>;
};

export type PipelineValidationResult = {
  __typename?: "PipelineValidationResult";
  children?: Maybe<Array<PipelineValidationResult>>;
  contractDocumentId?: Maybe<Scalars["ID"]["output"]>;
  documentCategory?: Maybe<DocumentCategory>;
  documentForm?: Maybe<Scalars["String"]["output"]>;
  documentName?: Maybe<Scalars["String"]["output"]>;
  ingestionDocumentId?: Maybe<Scalars["ID"]["output"]>;
  ingestionDocumentName?: Maybe<Scalars["String"]["output"]>;
  operator?: Maybe<LogicalOperator>;
  requiredDocument?: Maybe<RequiredDocumentResult>;
  results?: Maybe<Array<GenericRuleValidationObject>>;
};

export type PointInput = {
  lat: Scalars["Float"]["input"];
  lon: Scalars["Float"]["input"];
};

export type PreferenceInput = {
  id: Scalars["String"]["input"];
};

export type PreferenceObject = {
  __typename?: "PreferenceObject";
  field?: Maybe<FieldObject>;
  fieldId?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  usStates: Array<UsState>;
  valueType: PreferenceValueType;
};

export type PreferenceValueInput = {
  booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
  dateTimeValue?: InputMaybe<Scalars["DateTime"]["input"]>;
  numberValue?: InputMaybe<Scalars["Float"]["input"]>;
  preference: PreferenceInput;
  stringArray?: InputMaybe<Array<Scalars["String"]["input"]>>;
  stringValue?: InputMaybe<Scalars["String"]["input"]>;
  textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type PreferenceValueObject = {
  __typename?: "PreferenceValueObject";
  booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
  dateTimeValue?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  numberValue?: Maybe<Scalars["Float"]["output"]>;
  preference: PreferenceObject;
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  stringArray?: Maybe<Array<Scalars["String"]["output"]>>;
  stringValue?: Maybe<Scalars["String"]["output"]>;
  textValue?: Maybe<Scalars["String"]["output"]>;
};

export enum PreferenceValueType {
  BOOLEAN = "BOOLEAN",
  DATE = "DATE",
  NUMBER = "NUMBER",
  STRING = "STRING",
  STRING_ARRAY = "STRING_ARRAY",
  TEXT = "TEXT",
}

export type PreferencesInput = {
  usState: UsState;
};

export type PreviewReassignIngestionFolderPipelinesInput = {
  /** Items to preview (max 50) */
  items: Array<ReassignIngestionFolderPipelineItem>;
};

export type PreviewReassignIngestionFolderPipelinesPayload = {
  __typename?: "PreviewReassignIngestionFolderPipelinesPayload";
  results: Array<PipelinePreviewResult>;
};

export type PriceAnalysis = {
  __typename?: "PriceAnalysis";
  avgCompBidAskRatio: Scalars["Float"]["output"];
  isPotentiallyOverpriced: Scalars["Boolean"]["output"];
  isPotentiallyUnderpriced: Scalars["Boolean"]["output"];
  pricePositioning: Scalars["Float"]["output"];
};

export enum PricingEvaluationJobIdentifierType {
  LISTING = "LISTING",
  PROPERTY_DETAILS = "PROPERTY_DETAILS",
}

export type PricingEvaluationJobObject = {
  __typename?: "PricingEvaluationJobObject";
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  evaluation?: Maybe<ListingPricingEvaluationObject>;
  jobId?: Maybe<Scalars["String"]["output"]>;
  processingStep?: Maybe<PricingEvaluationStep>;
  status: PricingEvaluationJobStatus;
};

export enum PricingEvaluationJobStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NOT_FOUND = "NOT_FOUND",
  PROCESSING = "PROCESSING",
}

export type PricingEvaluationJobStatusObject = {
  __typename?: "PricingEvaluationJobStatusObject";
  errorMessage?: Maybe<Scalars["String"]["output"]>;
  jobId?: Maybe<Scalars["String"]["output"]>;
  status: PricingEvaluationJobStatus;
};

export enum PricingEvaluationStep {
  ADJUST = "ADJUST",
  FILTER = "FILTER",
  FINAL_ANALYSIS = "FINAL_ANALYSIS",
  PHOTO_ANALYZE = "PHOTO_ANALYZE",
}

export type ProduceStageChangedEventsInput = {
  /** Organization UUID to produce stage changed events for */
  organizationId: Scalars["ID"]["input"];
};

export type ProduceStageChangedEventsPayload = {
  __typename?: "ProduceStageChangedEventsPayload";
  /** Number of folders whose Kafka event production failed */
  failedCount: Scalars["Int"]["output"];
  /** Number of stage changed Kafka events produced */
  producedCount: Scalars["Int"]["output"];
  /** Whether all requested stage changed Kafka events were produced successfully */
  success: Scalars["Boolean"]["output"];
};

export enum ProductFeatures {
  CONTRACT_WRITING = "CONTRACT_WRITING",
  LISTING_OFFER_DATA = "LISTING_OFFER_DATA",
  MARKET_COMPARISON = "MARKET_COMPARISON",
  OFFER_SCORECARD = "OFFER_SCORECARD",
  PREMIUM_STOREFRONTS = "PREMIUM_STOREFRONTS",
  TEAM = "TEAM",
  TEAM_PERFORMANCE = "TEAM_PERFORMANCE",
}

export type ProductionPipelineValidationResult = {
  __typename?: "ProductionPipelineValidationResult";
  children?: Maybe<Array<ProductionPipelineValidationResult>>;
  contractDocumentId?: Maybe<Scalars["String"]["output"]>;
  documentCategory?: Maybe<DocumentCategory>;
  documentForm?: Maybe<Scalars["String"]["output"]>;
  documentName?: Maybe<Scalars["String"]["output"]>;
  ingestionDocumentId?: Maybe<Scalars["String"]["output"]>;
  ingestionDocumentName?: Maybe<Scalars["String"]["output"]>;
  operator?: Maybe<LogicalOperator>;
  requiredDocument?: Maybe<RequiredDocumentValidationResult>;
  results?: Maybe<Array<GenericRuleValidationResult>>;
};

export type PropertyDetailsObject = {
  __typename?: "PropertyDetailsObject";
  areaSqFt: Scalars["Float"]["output"];
  bathsFull: Scalars["Int"]["output"];
  bathsHalf?: Maybe<Scalars["Int"]["output"]>;
  bedrooms: Scalars["Int"]["output"];
  capturedBy: UserObject;
  city: Scalars["String"]["output"];
  geo: GeoObject;
  id: Scalars["ID"]["output"];
  property?: Maybe<PropertyObject>;
  propertySubtype: MlsListingSubType;
  propertyType: MlsListingType;
  schoolDistrict?: Maybe<Scalars["String"]["output"]>;
  state: UsState;
  streetAddress: Scalars["String"]["output"];
  subdivision?: Maybe<Scalars["String"]["output"]>;
  targetPrice: Scalars["Float"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  yearBuilt: Scalars["Int"]["output"];
  zipCode: Scalars["String"]["output"];
};

export type PropertyLatestSaleObject = {
  __typename?: "PropertyLatestSaleObject";
  assessorParcelNumber?: Maybe<Scalars["String"]["output"]>;
  closedDate?: Maybe<Scalars["String"]["output"]>;
  deedBook?: Maybe<Scalars["String"]["output"]>;
  deedPage?: Maybe<Scalars["String"]["output"]>;
  salePrice?: Maybe<Scalars["Float"]["output"]>;
};

export type PropertyObject = {
  __typename?: "PropertyObject";
  assessorParcelNumber?: Maybe<Scalars["String"]["output"]>;
  block: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  county: Scalars["String"]["output"];
  countyFips: Scalars["String"]["output"];
  geo?: Maybe<GeoObject>;
  id: Scalars["ID"]["output"];
  listings: Array<ListingObject>;
  lot: Scalars["String"]["output"];
  msa?: Maybe<Scalars["String"]["output"]>;
  otherLegalDescription: Scalars["String"]["output"];
  parcelId: Scalars["String"]["output"];
  platBook: Scalars["String"]["output"];
  platBookPage: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  state: UsState;
  streetAddress: Scalars["String"]["output"];
  subdivision: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  yearBuilt?: Maybe<Scalars["Int"]["output"]>;
  zipCode: Scalars["String"]["output"];
  zipCodePlus4?: Maybe<Scalars["String"]["output"]>;
};

export type PublicAgentObject = {
  __typename?: "PublicAgentObject";
  fullName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  inboundEmail: Scalars["String"]["output"];
  user?: Maybe<PublicUserObject>;
};

export type PublicAgentUserListingsInput = {
  filters?: InputMaybe<PublicListingsFilterArgs>;
  userId: Scalars["String"]["input"];
};

export type PublicDefaultSecondaryDocumentObject = {
  __typename?: "PublicDefaultSecondaryDocumentObject";
  id: Scalars["ID"]["output"];
  mappingKey: Scalars["String"]["output"];
  ordering: Scalars["Int"]["output"];
  secondaryDocument: PublicDocumentObject;
};

export type PublicDocumentObject = {
  __typename?: "PublicDocumentObject";
  activeDocumentVersion?: Maybe<PublicDocumentVersionObject>;
  defaultSecondaryDocuments: Array<PublicDefaultSecondaryDocumentObject>;
  description: Scalars["String"]["output"];
  documentCategory?: Maybe<DocumentCategory>;
  documentType: DocumentType;
  form: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  usState: UsState;
};

/** Paginated results of PublicDocumentObject */
export type PublicDocumentObjectPaginated = {
  __typename?: "PublicDocumentObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PublicDocumentObject>>;
};

export type PublicDocumentSectionFieldObject = {
  __typename?: "PublicDocumentSectionFieldObject";
  field: PublicFieldObject;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
};

export type PublicDocumentSectionObject = {
  __typename?: "PublicDocumentSectionObject";
  description: Scalars["String"]["output"];
  document?: Maybe<PublicDocumentObject>;
  documentSectionCategory: DocumentSectionCategory;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionFields?: Maybe<Array<PublicDocumentSectionFieldObject>>;
  documentSectionModuleType?: Maybe<DocumentSectionModuleType>;
  documentSectionType: DocumentSectionType;
  id: Scalars["ID"]["output"];
  order: Scalars["Int"]["output"];
  parent?: Maybe<PublicDocumentSectionObject>;
  title: Scalars["String"]["output"];
};

/** Paginated results of PublicDocumentSectionObject */
export type PublicDocumentSectionObjectPaginated = {
  __typename?: "PublicDocumentSectionObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PublicDocumentSectionObject>>;
};

export type PublicDocumentVersionFieldObject = {
  __typename?: "PublicDocumentVersionFieldObject";
  align: FieldAlign;
  autofill?: Maybe<AutofillObject>;
  boundingBox: BoundingBoxObject;
  displayLabel?: Maybe<Scalars["String"]["output"]>;
  field: PublicFieldObject;
  fieldType: FieldType;
  fontFamily: Scalars["String"]["output"];
  fontSize: Scalars["String"]["output"];
  height: Scalars["Float"]["output"];
  helpTextAutofill?: Maybe<AutofillObject>;
  id: Scalars["ID"]["output"];
  inputFormat?: Maybe<InputFormatObject>;
  label: Scalars["String"]["output"];
  mappingKey: Scalars["String"]["output"];
  optionsAutofill?: Maybe<AutofillObject>;
  pageNumber: Scalars["Int"]["output"];
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type PublicDocumentVersionObject = {
  __typename?: "PublicDocumentVersionObject";
  document: PublicDocumentObject;
  documentVersionFields: Array<PublicDocumentVersionFieldObject>;
  documentVersionFieldsCount?: Maybe<Scalars["Int"]["output"]>;
  hiddenPreviewImages: Array<AssetFileObject>;
  id: Scalars["ID"]["output"];
  mappingKeys: Array<Scalars["String"]["output"]>;
  previewImages: Array<AssetFileObject>;
  secondaryDocumentVersions: Array<PublicSecondaryDocumentVersionObject>;
  secondaryVersions: Array<PublicDocumentVersionObject>;
};

/** Paginated results of PublicDocumentVersionObject */
export type PublicDocumentVersionObjectPaginated = {
  __typename?: "PublicDocumentVersionObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PublicDocumentVersionObject>>;
};

export type PublicFieldObject = {
  __typename?: "PublicFieldObject";
  autofill?: Maybe<AutofillObject>;
  comparisonType?: Maybe<ComparisonType>;
  displayLabel?: Maybe<Scalars["String"]["output"]>;
  fieldType: FieldType;
  group: Scalars["String"]["output"];
  helpTextAutofill?: Maybe<AutofillObject>;
  id: Scalars["ID"]["output"];
  includedDocumentVersions?: Maybe<Array<DocumentVersionObject>>;
  inputFormat?: Maybe<InputFormatObject>;
  isComputed?: Maybe<Scalars["Boolean"]["output"]>;
  isHidden?: Maybe<Scalars["Boolean"]["output"]>;
  label: Scalars["String"]["output"];
  mappingKey: Scalars["String"]["output"];
  optionsAutofill?: Maybe<AutofillObject>;
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PublicListingAnnouncementInput = {
  listingId: Scalars["String"]["input"];
};

export type PublicListingAnnouncementObject = {
  __typename?: "PublicListingAnnouncementObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
};

export type PublicListingComparableObject = {
  __typename?: "PublicListingComparableObject";
  adjustments?: Maybe<ListingComparableAdjustmentsObject>;
  id: Scalars["ID"]["output"];
  mlsListing: MlsListingObject;
  order: Scalars["Float"]["output"];
  source: ListingComparableSetSource;
};

export type PublicListingComparableSetInput = {
  listingId: Scalars["String"]["input"];
};

export type PublicListingComparableSetObject = {
  __typename?: "PublicListingComparableSetObject";
  agent: PublicAgentObject;
  agentNotes?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  listing: PublicListingObject;
  listingComparables: Array<PublicListingComparableObject>;
};

export type PublicListingDocumentTypeObject = {
  __typename?: "PublicListingDocumentTypeObject";
  document?: Maybe<PublicDocumentObject>;
  formName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  type: ListingDocumentTypeEnum;
  usState: UsState;
};

export type PublicListingDocumentTypesInput = {
  usState: UsState;
};

export type PublicListingDocumentUploadObject = {
  __typename?: "PublicListingDocumentUploadObject";
  customDocumentName?: Maybe<Scalars["String"]["output"]>;
  customDocumentType?: Maybe<ListingDocumentTypeEnum>;
  file?: Maybe<FileObject>;
  id: Scalars["ID"]["output"];
  listingDocumentType?: Maybe<PublicListingDocumentTypeObject>;
};

export type PublicListingDocumentUploadsInput = {
  listingId: Scalars["String"]["input"];
};

export type PublicListingInput = {
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  propertySlug?: InputMaybe<Scalars["String"]["input"]>;
};

export type PublicListingObject = {
  __typename?: "PublicListingObject";
  coListingAgent?: Maybe<PublicAgentObject>;
  currentAndUpcomingOpenHouses?: Maybe<Array<PublicOpenHouseObject>>;
  deletedFromRetsFeedAt?: Maybe<Scalars["DateTimeISO"]["output"]>;
  followerCount?: Maybe<Scalars["Float"]["output"]>;
  guestbookSignersCount: Scalars["Int"]["output"];
  id: Scalars["ID"]["output"];
  isPremium: Scalars["Boolean"]["output"];
  listDate?: Maybe<Scalars["DateTime"]["output"]>;
  listingAgent?: Maybe<PublicAgentObject>;
  listingDocuments: Array<PublicListingDocumentUploadObject>;
  listingPreferences: Array<PublicPreferenceValueObject>;
  mlsListing?: Maybe<MlsListingObject>;
  offersCountDisplay: Scalars["String"]["output"];
  priceHistories?: Maybe<Array<ListingPriceHistoryObject>>;
  property: PublicPropertyObject;
  setupDetails: StorefrontConfigurationStatusObject;
  status: MlsListingStatus;
};

/** Paginated results of PublicListingObject */
export type PublicListingObjectAgentUserListingsPaginated = {
  __typename?: "PublicListingObjectAgentUserListingsPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PublicListingObject>>;
};

/** Paginated results of PublicListingObject */
export type PublicListingObjectPaginated = {
  __typename?: "PublicListingObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<PublicListingObject>>;
};

export type PublicListingsFilterArgs = {
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type PublicOpenHouseObject = {
  __typename?: "PublicOpenHouseObject";
  date: Scalars["LocalDate"]["output"];
  /** End time in UTC */
  endTime: Scalars["LocalTime"]["output"];
  id: Scalars["ID"]["output"];
  /** Start time in UTC */
  startTime: Scalars["LocalTime"]["output"];
};

export type PublicPreferenceObject = {
  __typename?: "PublicPreferenceObject";
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  usStates: Array<UsState>;
  valueType: PreferenceValueType;
};

export type PublicPreferenceValueObject = {
  __typename?: "PublicPreferenceValueObject";
  booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
  dateTimeValue?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  numberValue?: Maybe<Scalars["Float"]["output"]>;
  preference: PublicPreferenceObject;
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  stringArray?: Maybe<Array<Scalars["String"]["output"]>>;
  stringValue?: Maybe<Scalars["String"]["output"]>;
  textValue?: Maybe<Scalars["String"]["output"]>;
};

export type PublicPreferencesInput = {
  usState: UsState;
};

export type PublicPropertyObject = {
  __typename?: "PublicPropertyObject";
  assessorParcelNumber?: Maybe<Scalars["String"]["output"]>;
  block: Scalars["String"]["output"];
  city: Scalars["String"]["output"];
  county: Scalars["String"]["output"];
  countyFips: Scalars["String"]["output"];
  geo?: Maybe<GeoObject>;
  id: Scalars["ID"]["output"];
  listings: Array<PublicListingObject>;
  lot: Scalars["String"]["output"];
  msa?: Maybe<Scalars["String"]["output"]>;
  otherLegalDescription: Scalars["String"]["output"];
  parcelId: Scalars["String"]["output"];
  platBook: Scalars["String"]["output"];
  platBookPage: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  state: UsState;
  streetAddress: Scalars["String"]["output"];
  subdivision: Scalars["String"]["output"];
  unit?: Maybe<Scalars["String"]["output"]>;
  yearBuilt?: Maybe<Scalars["Int"]["output"]>;
  zipCode: Scalars["String"]["output"];
  zipCodePlus4?: Maybe<Scalars["String"]["output"]>;
};

export type PublicSecondaryDocumentVersionObject = {
  __typename?: "PublicSecondaryDocumentVersionObject";
  id: Scalars["ID"]["output"];
  ordering: Scalars["Int"]["output"];
  secondaryDocumentVersion: PublicDocumentVersionObject;
};

export type PublicUserObject = {
  __typename?: "PublicUserObject";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  offerCollectionEmail?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  profileBio?: Maybe<Scalars["String"]["output"]>;
  profilePicture?: Maybe<FileObject>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type PublicUserWithLicensesObject = {
  __typename?: "PublicUserWithLicensesObject";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  hasListings?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  licenses?: Maybe<Array<UserLicenseObject>>;
  offerCollectionEmail?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  profileBio?: Maybe<Scalars["String"]["output"]>;
  profilePicture?: Maybe<FileObject>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  accessControlsList?: Maybe<AccessControlObjectPaginated>;
  activeIntegrationClients: Array<IntegrationClientObject>;
  aiConversationSessionFileSignedUrl: AiConversationSessionFileSignedUrlPayload;
  aiConversationSessionFiles: AiConversationSessionFilesPayload;
  aiConversations?: Maybe<AiConversationObjectPaginated>;
  allListingActivitiesForCurrentUser: AllListingActivitiesForCurrentUserPayload;
  allMLSes: AllMlSesPayload;
  auditEssentialsNotifications: Array<AuditEssentialsNotificationsObject>;
  businessOverviewOffers?: Maybe<BizOverviewOfferObjectPaginated>;
  businessOverviewStats: BusinessOverviewStatsPayload;
  buyerClientsForCurrentAgentUser: Array<PartyObject>;
  buyersForCurrentAgentPaginated?: Maybe<PartyObjectPaginated>;
  checkDocumentVersionDuplicate: CheckDocumentVersionDuplicatePayload;
  checkPermission: PermissionObject;
  checkSignatureInitialDatasetExists: CheckSignatureInitialDatasetExistsPayload;
  checkboxDatasetFiles: CheckboxDatasetFilesPayload;
  checkboxDatasetSignedUrls: GetSignedUrlsPayload;
  complianceKeyTermSectionList?: Maybe<ComplianceKeyTermSectionObjectPaginated>;
  contact?: Maybe<ContactObject>;
  contactsList?: Maybe<ContactObjectContactListPaginatedPaginated>;
  contractById: ContractObject;
  contractByIds: Array<ContractObject>;
  contractList?: Maybe<ContractObjectPaginated>;
  contractSignatureFields: ContractSignatureFieldsPayload;
  contractValidations: ContractObject;
  contractVariableValues?: Maybe<Array<ContractVariableValuesPayload>>;
  currentUser?: Maybe<UserObject>;
  documentClassificationEvaluationList?: Maybe<DocumentClassificationEvaluationObjectPaginated>;
  documentEvaluationJobStatus?: Maybe<DocumentEvaluationJobStatusObject>;
  documentLLMEvaluationList?: Maybe<DocumentLlmEvaluationObjectPaginated>;
  documentLLMExampleList?: Maybe<DocumentLlmExampleObjectPaginated>;
  documentLLMList?: Maybe<DocumentLlmObjectPaginated>;
  documentLLMMissingKeys: DocumentLlmMissingKeysPayload;
  documentList?: Maybe<DocumentObjectPaginated>;
  documentSectionList?: Maybe<DocumentSectionObjectPaginated>;
  documentVersionAutofillValues: DocumentVersionAutofillValuesPayload;
  documentVersionList?: Maybe<DocumentVersionObjectPaginated>;
  dotloopComplianceGroups: Array<DotloopComplianceGroupsObject>;
  embeddedSignatureRequest: ContractEmbeddedSignatureRequestPayload;
  /** Evaluate a formula with given variables and values */
  evaluateFormula: EvaluateFormulaPayload;
  /** Evaluate a formula against multiple test cases in batch */
  evaluateFormulaBatch: EvaluateFormulaBatchPayload;
  eventsForOffer: Array<EventListObject>;
  externalDarwinProperties: ExternalDarwinPropertiesPayload;
  externalGetComplianceMessageHistory: Array<ComplianceMessageHistoryObject>;
  externalGetDarwinCompanies: Array<ExternalDarwinCompanyObject>;
  externalGetDarwinCompanyOfficeMappings: Array<DarwinCompanyOfficeMappingObject>;
  externalGetDarwinPropertyClassification?: Maybe<DarwinPropertyClassificationObject>;
  externalGetDarwinSyncPreview: DarwinSyncPreviewPayload;
  externalGetDistinctOfficeNames: Array<Scalars["String"]["output"]>;
  externalGetDistinctStatuses: Array<Scalars["String"]["output"]>;
  externalGetIngestionDocument: IngestionDocumentObject;
  externalGetIngestionDocumentReviews: Array<IngestionDocumentReviewObject>;
  externalGetIngestionDocumentValidationErrorReviews: Array<IngestionDocumentValidationErrorReviewObject>;
  externalGetIngestionDocumentValidationFeedback: Array<IngestionDocumentValidationFeedbackObject>;
  externalGetIngestionFolder: IngestionFolderObject;
  externalGetIngestionFolderValidationErrorReviews: Array<IngestionFolderValidationErrorReviewObject>;
  externalGetIngestionFolderValidationFeedback: Array<IngestionFolderValidationFeedbackObject>;
  externalGetMLSListingSelection: MlsListingSelectionPayload;
  externalGetObservedDotloopOffices: Array<ObservedDotloopOfficeObject>;
  externalGetValidationReportData?: Maybe<ValidationReportDataObject>;
  externalIngestionDocumentsForFolder: Array<IngestionDocumentObject>;
  externalIngestionFolderListForOrganization?: Maybe<IngestionFolderObjectExternalPaginated>;
  externalIngestionFolderPlatformUrl?: Maybe<Scalars["String"]["output"]>;
  externalKeyTermsList: Array<ExternalKeyTermsObject>;
  featuredStorefronts?: Maybe<PublicListingObjectPaginated>;
  fieldList?: Maybe<FieldObjectPaginated>;
  fieldsToColumnList?: Maybe<FieldsToColumnObjectPaginated>;
  /** @deprecated use findMLSAgentsByPhoneNumber or findMLSAgentByMlsId instead, this API is only used for Canopy lookup */
  findMLSAgent: FindMlsAgentPayload;
  findMLSAgentByEmail?: Maybe<FindMlsAgentPayload>;
  findMLSAgentByMlsId: FindMlsAgentPayload;
  findMLSAgentsByName: Array<FindMlsAgentPayload>;
  findMLSAgentsByPhoneNumber: Array<FindMlsAgentPayload>;
  findMLSListingByAddress?: Maybe<MlsListingObject>;
  findUserCapturedPropertyDetailsByAddress?: Maybe<PropertyDetailsObject>;
  followedListings: Array<ListingObject>;
  generateValidationReport?: Maybe<Scalars["String"]["output"]>;
  getBOAByShareLinkToken: BuyerOfferAnalysisObject;
  getBOAShareLinks: Array<ShareLinkObject>;
  getBusinessOverviewOfferDetails: BusinessOverviewOfferDetailsPayload;
  getBuyerOfferAnalysis: BuyerOfferAnalysisObject;
  getComplianceGroupTransactionStages: Array<ComplianceGroupTransactionStageObject>;
  getDocumentVersionField?: Maybe<DocumentVersionFieldObject>;
  getDocumentVersionInfo: GetDocumentVersionInfoPayload;
  getIngestionDocument: IngestionDocumentObject;
  getInviteeDetailByCode?: Maybe<UserObject>;
  getListingPricingEvaluationStatus?: Maybe<PricingEvaluationJobObject>;
  getListingReport: ListingReportResponse;
  getListingReportByShareLinkToken: ListingReportResponse;
  getListingReportPdf: ListingReportPdfResponse;
  getListingReportShareLinks: Array<ShareLinkObject>;
  getOfferForBuyersAgent: OfferObject;
  getOfferForListingAgent: OfferObject;
  getOfferRecs: OfferRecsPayload;
  getOrganizationFolderNameValidationStageOverride: OrganizationFolderNameValidationStageOverrideObject;
  getPropertyDetails: GetPropertyDetailsPayload;
  getPublicUserWithLicenses?: Maybe<PublicUserWithLicensesObject>;
  getSignedUrls: GetSignedUrlsPayload;
  getSingleUserCapturedPropertyDetails: PropertyDetailsObject;
  getUserCapturedPropertyDetails: Array<PropertyDetailsObject>;
  getUserCapturedPropertyDetailsByToken: PropertyDetailsObject;
  getUserTours: Array<UserTourObject>;
  guestbookSigners: GuestbookSignersObject;
  hasSignedListingGuestbook: HasSignedListingGuestbookObject;
  indigoContractsForCurrentUser?: Maybe<IndigoContractObjectPaginated>;
  ingestionDocumentList?: Maybe<Array<IngestionDocumentObject>>;
  ingestionFolderCountsByPipeline: IngestionFolderCountsByPipelineResult;
  ingestionFolderCountsByStage: IngestionFolderCountsByStageResult;
  ingestionFolderList?: Maybe<IngestionFolderObjectPaginated>;
  ingestionFolderPlatformUrl?: Maybe<Scalars["String"]["output"]>;
  initiateListingPricingEvaluation?: Maybe<PricingEvaluationJobStatusObject>;
  integrationClient?: Maybe<InternalIntegrationClientObject>;
  integrationClients: Array<InternalIntegrationClientObject>;
  integrationConnectionsForOrganization: Array<IntegrationConnectionObject>;
  integrationConnectionsForUser: Array<IntegrationConnectionObject>;
  /** Intended for internal machine-to-machine communication. Use contractVariableValues for most use cases. */
  internalContractVariableValues: Array<ContractVariableValuesPayload>;
  internalDarwinSyncRun?: Maybe<InternalDarwinSyncRunDetailPayload>;
  internalDarwinSyncRunRawField?: Maybe<Scalars["JSON"]["output"]>;
  internalDarwinSyncRuns: InternalDarwinSyncRunsPayload;
  internalEssentialsNotificationFolderDebug: InternalEssentialsNotificationFolderDebugObject;
  internalEssentialsNotificationLogDebug: InternalEssentialsNotificationLogDebugObject;
  internalEssentialsNotificationLogs?: Maybe<InternalEssentialsNotificationLogItemPaginated>;
  internalGetIngestionDocumentValidationErrorReviews: Array<IngestionDocumentValidationErrorReviewObject>;
  internalGetIngestionDocumentValidationFeedback: Array<IngestionDocumentValidationFeedbackObject>;
  internalGetIngestionFolderValidationErrorReviews: Array<IngestionFolderValidationErrorReviewObject>;
  internalGetIngestionFolderValidationFeedback: Array<IngestionFolderValidationFeedbackObject>;
  internalGetValidationReportData?: Maybe<ValidationReportDataObject>;
  internalIngestionDocumentsForFolder: Array<IngestionDocumentObject>;
  internalIngestionFolderListForOrganization?: Maybe<IngestionFolderObjectInternalPaginated>;
  internalIngestionFolderValidationStatus: IngestionFolderValidationStatusObject;
  internalOrganizationList: Array<OrganizationObject>;
  internalOrganizationUsers?: Maybe<InternalOrgUserObjectPaginated>;
  internalRulesOverview: RulesOverviewPayload;
  invitationsList?: Maybe<InvitationObjectPaginated>;
  isFollowingListing: IsFollowingListingObject;
  isOpenHouseGuestbookSigned: Scalars["Boolean"]["output"];
  latestUnsubmittedOfferForBuyersAgent?: Maybe<OfferObject>;
  latestUnsubmittedOfferForUnauthenticatedBuyersAgent?: Maybe<OfferObject>;
  listing: ListingObject;
  listingActivities?: Maybe<Array<ActivityObject>>;
  listingAnnouncements: Array<ListingAnnouncementObject>;
  listingAnnouncementsCount: Scalars["Float"]["output"];
  listingAutofillVariableValues: Array<OfferAutofillObject>;
  listingComparableSet?: Maybe<ListingComparableSetObject>;
  listingComparableSetForAgent?: Maybe<ListingComparableSetObject>;
  listingComparableSetForBOAToken?: Maybe<ListingComparableSetObject>;
  listingComparableSetForBuyerOfferAnalysis?: Maybe<ListingComparableSetObject>;
  listingComparableSetForReportToken?: Maybe<ListingComparableSetObject>;
  listingDocumentTypes: Array<ListingDocumentTypeObject>;
  listingDocumentUploads?: Maybe<Array<ListingDocumentUploadObject>>;
  listingFollowers: ListingFollowersObject;
  listingOpenHouses: ListingOpenHousesPayload;
  listingsForCurrentUser?: Maybe<ListingObjectPaginated>;
  listingsForOrganization?: Maybe<ListingObjectListingsForOrganizationPaginated>;
  loadPipelineInvestigationReasonsForValidation: LoadPipelineInvestigationReasonsForValidationResponse;
  mlQueueJobStatus?: Maybe<MlQueueJobStatusPayload>;
  /** Returns notification autofill values. Provide exactly one of notificationLogId or notificationTemplateId. */
  notificationLogAutofillValues: NotificationLogAutofillObject;
  notificationLogAutofillVariablesSchema: Scalars["JSONObject"]["output"];
  notificationTemplate?: Maybe<NotificationTemplateObject>;
  notificationTemplatesList?: Maybe<NotificationTemplateObjectNotificationTemplateListPaginatedPaginated>;
  offerAutofillValues?: Maybe<OfferAutofillValuesPayload>;
  offerAutofillVariableValues: Array<OfferAutofillObject>;
  offerAutofillVariableValuesFromContract: OfferAutofillVariableValuesFromContractPayload;
  offerAutofillVariablesSchema: Scalars["JSONObject"]["output"];
  offerGroups: Array<OfferGroupObject>;
  offerIngestionAutofillVariablesSchema: Scalars["JSONObject"]["output"];
  offerIngestionDocumentAutofillVariablesSchema: Scalars["JSONObject"]["output"];
  offerMetrics: Array<OfferMetricsObject>;
  offerScorecardsForAgent?: Maybe<BuyerOfferAnalysisObjectofferScorecardsForAgentPaginated>;
  offerScorecardsForOrg?: Maybe<BuyerOfferAnalysisObjectofferScorecardsForOrgPaginated>;
  offerScorecardsMetricsForOrg: OfferScorecardsMetrics;
  offersForCurrentUser?: Maybe<OfferObjectPaginated>;
  offersForListing: Array<OfferObject>;
  openHouse: OpenHouseObject;
  openHousesForCurrentUser?: Maybe<OpenHouseObjectPaginated>;
  orgListingAggDeltaByStatus: OrgListingAggDeltaByStatusPayload;
  orgTransactionStatsByZipCode: Array<OrgTransactionStatsByZipCodeObject>;
  organization: OrganizationObject;
  organizationDescendantsTree: OrganizationObject;
  organizationListingAggregatesByStatus: OrganizationListingCountsByStatusPayload;
  organizationOfficesAndTeams: OrganizationOfficesAndTeamsPayload;
  organizationPartner?: Maybe<OrganizationPartnerObject>;
  organizationPartnerStageIntros: Array<OrganizationPartnerStageIntroObject>;
  organizationPartners?: Maybe<OrganizationPartnerObjectPaginated>;
  organizationRosterEntry?: Maybe<OrganizationRosterObject>;
  organizationRosterList?: Maybe<OrganizationRosterObjectOrganizationRosterListPaginatedPaginated>;
  organizationRosterPreference?: Maybe<OrganizationRosterPreferenceObject>;
  organizationRosterPreferences: Array<OrganizationRosterPreferenceObject>;
  organizationValidationSettings: OrganizationValidationSettingsObject;
  organizationsForCurrentUser?: Maybe<Array<OrganizationObject>>;
  partnerContactsList: Array<OrganizationPartnerContactUnion>;
  partyAndBuyerInfo: PartyObject;
  partyAutofillVariableValues: Array<OfferAutofillObject>;
  perAgentOfferAcceptRate: Array<PerAgentOfferAcceptRateObject>;
  perAgentTransactionStats: Array<PerAgentTransactionStatsObject>;
  perOfficeOfferAcceptRate: Array<PerOfficeOfferAcceptRateObject>;
  perOfficeTransactionStats: Array<PerOfficeTransactionStatsObject>;
  preferences: Array<PreferenceObject>;
  previewFieldsToColumn?: Maybe<Scalars["JSONObject"]["output"]>;
  previewReassignIngestionFolderPipelines: PreviewReassignIngestionFolderPipelinesPayload;
  prioritizedListingsForCurrentUser?: Maybe<ListingObjectPrioritizedListingsForCurrentUserPaginated>;
  publicAgentUserListings?: Maybe<PublicListingObjectAgentUserListingsPaginated>;
  publicDocumentList?: Maybe<PublicDocumentObjectPaginated>;
  publicDocumentSectionList?: Maybe<PublicDocumentSectionObjectPaginated>;
  publicDocumentVersionList?: Maybe<PublicDocumentVersionObjectPaginated>;
  publicListing: PublicListingObject;
  publicListingAnnouncements: Array<PublicListingAnnouncementObject>;
  publicListingComparableSet?: Maybe<PublicListingComparableSetObject>;
  publicListingDocumentTypes: Array<PublicListingDocumentTypeObject>;
  publicListingDocumentUploads?: Maybe<
    Array<PublicListingDocumentUploadObject>
  >;
  publicPreferences: Array<PublicPreferenceObject>;
  ruleList?: Maybe<RuleObjectPaginated>;
  ruleMissingKeys?: Maybe<RuleMissingKeysPayload>;
  searchIngestionFoldersForValidation: IngestionFolderValidationSearchResponse;
  searchMlsListingsByAddress: Array<MlsListingObject>;
  searchMlsListingsWithFilters: SearchMlsListingsWithFiltersPayload;
  signatureInitialDatasetFiles: SignatureInitialDatasetFilesPayload;
  signatureInitialsDatasetMetrics: SignatureInitialsDatasetMetricsPayload;
  storefrontActivities: Array<ActivityObject>;
  storefrontActivitiesSummary: Array<StorefrontActivitySummaryObject>;
  /** @deprecated Use storefrontActivitiesSummary instead for more flexibility */
  storefrontActivitySummary: StorefrontActivitySummaryObject;
  syncListingFromMLS: PublicListingObject;
  transactionNotificationLog: TransactionNotificationLogObject;
  transactionNotificationLogs?: Maybe<TransactionNotificationLogObjectPaginated>;
  transactionPipelineList: Array<TransactionPipelineObject>;
  transactionPipelineUsStates?: Maybe<Array<UsState>>;
  transactionRuleMissingKeys?: Maybe<TransactionRuleMissingKeysPayload>;
  userNotificationSettings: UserNotificationSettingsObject;
  zipCodesGeo: Array<ZipCodesGeoObject>;
};

export type QueryAccessControlsListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: AccessControlsListFilters;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryAiConversationSessionFileSignedUrlArgs = {
  input: GetAiConversationSessionFileSignedUrlInput;
};

export type QueryAiConversationSessionFilesArgs = {
  input: ListAiConversationSessionFilesInput;
};

export type QueryAiConversationsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ListAiConversationsInput>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryAllListingActivitiesForCurrentUserArgs = {
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
};

export type QueryAuditEssentialsNotificationsArgs = {
  filters: AuditEssentialsNotificationsFilters;
};

export type QueryBusinessOverviewOffersArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: BusinessOverviewOffersFilterInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryBusinessOverviewStatsArgs = {
  input: BusinessOverviewStatsInput;
};

export type QueryBuyersForCurrentAgentPaginatedArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryCheckDocumentVersionDuplicateArgs = {
  input: CheckDocumentVersionDuplicateInput;
};

export type QueryCheckPermissionArgs = {
  input: CheckPermissionInput;
};

export type QueryCheckSignatureInitialDatasetExistsArgs = {
  input: CheckSignatureInitialDatasetExistsInput;
};

export type QueryCheckboxDatasetSignedUrlsArgs = {
  input: CheckboxDatasetSignedUrlsInput;
};

export type QueryComplianceKeyTermSectionListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ComplianceKeyTermSectionListFilters>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryContactArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryContactsListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ContactFilters>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryContractByIdArgs = {
  id: Scalars["ID"]["input"];
  resolveFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContractByIdsArgs = {
  ids: Array<Scalars["ID"]["input"]>;
  resolveFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContractListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ContractListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
  resolveFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryContractSignatureFieldsArgs = {
  input: ContractSignatureFieldsArgs;
};

export type QueryContractValidationsArgs = {
  autofillVariableValues: Scalars["JSONObject"]["input"];
  contractId: Scalars["ID"]["input"];
  fieldValues: Scalars["JSONObject"]["input"];
};

export type QueryContractVariableValuesArgs = {
  input: Array<ContractVariableValuesInput>;
};

export type QueryDocumentClassificationEvaluationListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<DocumentClassificationEvaluationListFilter>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentEvaluationJobStatusArgs = {
  jobId: Scalars["String"]["input"];
};

export type QueryDocumentLlmEvaluationListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentLlmEvaluationListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentLlmExampleListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentLlmExampleListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentLlmListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentLlmListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentLlmMissingKeysArgs = {
  documentLLMId: Scalars["ID"]["input"];
};

export type QueryDocumentListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentListArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentSectionListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentSectionListFilters>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDocumentVersionAutofillValuesArgs = {
  documentVersionIds: Array<Scalars["ID"]["input"]>;
  fieldValues: Scalars["JSONObject"]["input"];
  variableValues: Scalars["JSONObject"]["input"];
};

export type QueryDocumentVersionListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentVersionListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryDotloopComplianceGroupsArgs = {
  filters: DotloopComplianceGroupsFilterInput;
};

export type QueryEmbeddedSignatureRequestArgs = {
  code: Scalars["String"]["input"];
};

export type QueryEvaluateFormulaArgs = {
  input: EvaluateFormulaInput;
};

export type QueryEvaluateFormulaBatchArgs = {
  input: EvaluateFormulaBatchInput;
};

export type QueryEventsForOfferArgs = {
  input: EventsForOfferInput;
};

export type QueryExternalDarwinPropertiesArgs = {
  input: ExternalDarwinPropertyInput;
};

export type QueryExternalGetComplianceMessageHistoryArgs = {
  input: ExternalGetComplianceMessageHistoryInput;
};

export type QueryExternalGetDarwinCompaniesArgs = {
  organizationUuid: Scalars["ID"]["input"];
  sandbox?: Scalars["Boolean"]["input"];
};

export type QueryExternalGetDarwinCompanyOfficeMappingsArgs = {
  organizationUuid: Scalars["ID"]["input"];
};

export type QueryExternalGetDarwinPropertyClassificationArgs = {
  input: ExternalGetDarwinPropertyClassificationInput;
};

export type QueryExternalGetDarwinSyncPreviewArgs = {
  input: ExternalGetDarwinSyncPreviewInput;
};

export type QueryExternalGetDistinctOfficeNamesArgs = {
  input: ExternalGetDistinctOfficeNamesInput;
};

export type QueryExternalGetDistinctStatusesArgs = {
  input: ExternalGetDistinctStatusesInput;
};

export type QueryExternalGetIngestionDocumentArgs = {
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  input?: InputMaybe<ExternalIngestionDocumentArgs>;
};

export type QueryExternalGetIngestionDocumentReviewsArgs = {
  input: ExternalGetIngestionDocumentReviewsInput;
};

export type QueryExternalGetIngestionDocumentValidationErrorReviewsArgs = {
  input: ExternalGetIngestionDocumentValidationErrorReviewsInput;
};

export type QueryExternalGetIngestionDocumentValidationFeedbackArgs = {
  input: ExternalGetIngestionDocumentValidationFeedbackInput;
};

export type QueryExternalGetIngestionFolderArgs = {
  input: ExternalGetIngestionFolderInput;
};

export type QueryExternalGetIngestionFolderValidationErrorReviewsArgs = {
  input: ExternalGetIngestionFolderValidationErrorReviewsInput;
};

export type QueryExternalGetIngestionFolderValidationFeedbackArgs = {
  input: ExternalGetIngestionFolderValidationFeedbackInput;
};

export type QueryExternalGetMlsListingSelectionArgs = {
  input: ExternalGetMlsListingSelectionInput;
};

export type QueryExternalGetObservedDotloopOfficesArgs = {
  organizationUuid: Scalars["ID"]["input"];
};

export type QueryExternalGetValidationReportDataArgs = {
  input: ExternalGetValidationReportDataInput;
};

export type QueryExternalIngestionDocumentsForFolderArgs = {
  input: ExternalIngestionDocumentsForFolderInput;
};

export type QueryExternalIngestionFolderListForOrganizationArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  input: ExternalIngestionFolderListForOrganizationInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryExternalIngestionFolderPlatformUrlArgs = {
  input: ExternalIngestionFolderPlatformUrlInput;
};

export type QueryFeaturedStorefrontsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryFieldListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<FieldListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryFieldsToColumnListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<FieldsToColumnListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryFindMlsAgentArgs = {
  input: FindMlsAgentInput;
};

export type QueryFindMlsAgentByEmailArgs = {
  email: Scalars["String"]["input"];
};

export type QueryFindMlsAgentByMlsIdArgs = {
  input: FindMlsAgentByMlsIdInput;
};

export type QueryFindMlsAgentsByNameArgs = {
  input: FindMlsAgentsByNameInput;
};

export type QueryFindMlsAgentsByPhoneNumberArgs = {
  input: FindMlsAgentsByPhoneNumberInput;
};

export type QueryFindMlsListingByAddressArgs = {
  input: FindMlsListingByAddressInput;
};

export type QueryFindUserCapturedPropertyDetailsByAddressArgs = {
  input: FindUserCapturedPropertyDetailsByAddressInput;
};

export type QueryGenerateValidationReportArgs = {
  folderUuid: Scalars["String"]["input"];
};

export type QueryGetBoaByShareLinkTokenArgs = {
  input: GetBoaByShareLinkTokenInput;
};

export type QueryGetBoaShareLinksArgs = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
};

export type QueryGetBusinessOverviewOfferDetailsArgs = {
  offerId: Scalars["String"]["input"];
};

export type QueryGetBuyerOfferAnalysisArgs = {
  uuid: Scalars["String"]["input"];
};

export type QueryGetComplianceGroupTransactionStagesArgs = {
  organizationUuid: Scalars["ID"]["input"];
};

export type QueryGetDocumentVersionFieldArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGetDocumentVersionInfoArgs = {
  input: GetDocumentVersionInfoInput;
};

export type QueryGetIngestionDocumentArgs = {
  ingestionDocumentId: Scalars["ID"]["input"];
};

export type QueryGetInviteeDetailByCodeArgs = {
  input: SendOtpFromInvitationLinkInput;
};

export type QueryGetListingPricingEvaluationStatusArgs = {
  input: ListingPricingEvaluationInput;
};

export type QueryGetListingReportArgs = {
  input: ListingReportInput;
};

export type QueryGetListingReportByShareLinkTokenArgs = {
  input: GetListingReportByShareLinkTokenInput;
};

export type QueryGetListingReportPdfArgs = {
  input: GetListingReportPdfInput;
};

export type QueryGetListingReportShareLinksArgs = {
  input: GetListingReportShareLinksInput;
};

export type QueryGetOfferForBuyersAgentArgs = {
  input: GetOfferForBuyersAgentInput;
};

export type QueryGetOfferForListingAgentArgs = {
  input: GetOfferForListingAgentInput;
};

export type QueryGetOfferRecsArgs = {
  input: GetOfferRecsInput;
};

export type QueryGetOrganizationFolderNameValidationStageOverrideArgs = {
  organizationUuid: Scalars["ID"]["input"];
};

export type QueryGetPropertyDetailsArgs = {
  input: GetPropertyDetailsInput;
};

export type QueryGetPublicUserWithLicensesArgs = {
  input: GetUserInput;
};

export type QueryGetSignedUrlsArgs = {
  input: GetSignedUrlsInput;
};

export type QueryGetSingleUserCapturedPropertyDetailsArgs = {
  propertyDetailsId: Scalars["String"]["input"];
};

export type QueryGetUserCapturedPropertyDetailsByTokenArgs = {
  input: GetUserCapturedPropertyDetailsByTokenInput;
};

export type QueryGuestbookSignersArgs = {
  input: ListingInput;
};

export type QueryHasSignedListingGuestbookArgs = {
  input: ListingInput;
};

export type QueryIndigoContractsForCurrentUserArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<IndigoContractsForCurrentUserFilters>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryIngestionDocumentListArgs = {
  ingestionFolderId: Scalars["String"]["input"];
};

export type QueryIngestionFolderCountsByPipelineArgs = {
  filters: IngestionFolderCountsByPipelineFilterArgs;
};

export type QueryIngestionFolderCountsByStageArgs = {
  filters: IngestionFolderCountsByStageFilterArgs;
};

export type QueryIngestionFolderListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: IngestionFolderListFilterArgs;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryIngestionFolderPlatformUrlArgs = {
  folderId: Scalars["String"]["input"];
};

export type QueryInitiateListingPricingEvaluationArgs = {
  input: ListingPricingEvaluationInput;
};

export type QueryIntegrationClientArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryIntegrationConnectionsForOrganizationArgs = {
  input: IntegrationConnectionsForOrganizationInput;
};

export type QueryInternalContractVariableValuesArgs = {
  input: Array<ContractVariableValuesInput>;
};

export type QueryInternalDarwinSyncRunArgs = {
  input: InternalDarwinSyncRunInput;
};

export type QueryInternalDarwinSyncRunRawFieldArgs = {
  input: InternalDarwinSyncRunRawFieldInput;
};

export type QueryInternalDarwinSyncRunsArgs = {
  input: InternalDarwinSyncRunsInput;
};

export type QueryInternalEssentialsNotificationFolderDebugArgs = {
  input: InternalEssentialsNotificationFolderDebugInput;
};

export type QueryInternalEssentialsNotificationLogDebugArgs = {
  logId: Scalars["ID"]["input"];
};

export type QueryInternalEssentialsNotificationLogsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  perPage?: Scalars["Int"]["input"];
};

export type QueryInternalGetIngestionDocumentValidationErrorReviewsArgs = {
  input: GetIngestionDocumentValidationErrorReviewsInput;
};

export type QueryInternalGetIngestionDocumentValidationFeedbackArgs = {
  input: GetIngestionDocumentValidationFeedbackInput;
};

export type QueryInternalGetIngestionFolderValidationErrorReviewsArgs = {
  input: GetIngestionFolderValidationErrorReviewsInput;
};

export type QueryInternalGetIngestionFolderValidationFeedbackArgs = {
  input: GetIngestionFolderValidationFeedbackInput;
};

export type QueryInternalGetValidationReportDataArgs = {
  input: InternalGetValidationReportDataInput;
};

export type QueryInternalIngestionDocumentsForFolderArgs = {
  input: InternalIngestionDocumentsForFolderInput;
};

export type QueryInternalIngestionFolderListForOrganizationArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  input: InternalIngestionFolderListForOrganizationInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryInternalIngestionFolderValidationStatusArgs = {
  input: InternalIngestionFolderValidationStatusInput;
};

export type QueryInternalOrganizationListArgs = {
  prodOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryInternalOrganizationUsersArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryInternalRulesOverviewArgs = {
  filters?: InputMaybe<RulesOverviewFiltersInput>;
};

export type QueryInvitationsListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: AccessControlsListFilters;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryIsFollowingListingArgs = {
  input: ListingInput;
};

export type QueryIsOpenHouseGuestbookSignedArgs = {
  input: GetOpenHouseGuestbookStatusInput;
};

export type QueryLatestUnsubmittedOfferForBuyersAgentArgs = {
  input: OffersForListingInput;
};

export type QueryLatestUnsubmittedOfferForUnauthenticatedBuyersAgentArgs = {
  input: OffersForListingInput;
};

export type QueryListingArgs = {
  input: ListingInput;
};

export type QueryListingActivitiesArgs = {
  input: ListingInput;
};

export type QueryListingAnnouncementsArgs = {
  input: ListingAnnouncementInput;
};

export type QueryListingAnnouncementsCountArgs = {
  input: ListingAnnouncementInput;
};

export type QueryListingAutofillVariableValuesArgs = {
  listingIds: Array<Scalars["ID"]["input"]>;
};

export type QueryListingComparableSetArgs = {
  input: ListingComparableSetInput;
};

export type QueryListingComparableSetForAgentArgs = {
  input: ListingComparableSetForAgentInput;
};

export type QueryListingComparableSetForBoaTokenArgs = {
  input: ListingComparableSetForBoaTokenInput;
};

export type QueryListingComparableSetForBuyerOfferAnalysisArgs = {
  input: ListingComparableSetForBuyerOfferAnalysisInput;
};

export type QueryListingComparableSetForReportTokenArgs = {
  input: ListingComparableSetForReportTokenInput;
};

export type QueryListingDocumentTypesArgs = {
  input: ListingDocumentTypesInput;
};

export type QueryListingDocumentUploadsArgs = {
  input: ListingDocumentUploadsInput;
};

export type QueryListingFollowersArgs = {
  input: ListingInput;
};

export type QueryListingOpenHousesArgs = {
  input: ListingOpenHousesInput;
};

export type QueryListingsForCurrentUserArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<ListingsFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryListingsForOrganizationArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: ListingsForOrganizationFilterArgs;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryLoadPipelineInvestigationReasonsForValidationArgs = {
  input: LoadPipelineInvestigationReasonsForValidationInput;
};

export type QueryMlQueueJobStatusArgs = {
  jobId: Scalars["String"]["input"];
};

export type QueryNotificationLogAutofillValuesArgs = {
  notificationLogId?: InputMaybe<Scalars["ID"]["input"]>;
  notificationTemplateId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryNotificationTemplateArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryNotificationTemplatesListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<NotificationTemplateFilters>;
  orderBy?: Scalars["String"]["input"];
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  perPage?: Scalars["Int"]["input"];
};

export type QueryOfferAutofillValuesArgs = {
  documentVersionIds: Array<Scalars["ID"]["input"]>;
  fieldValues: Scalars["JSONObject"]["input"];
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  offerId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type QueryOfferAutofillVariableValuesArgs = {
  offerIds: Array<Scalars["ID"]["input"]>;
};

export type QueryOfferAutofillVariableValuesFromContractArgs = {
  offerId: Scalars["ID"]["input"];
};

export type QueryOfferAutofillVariablesSchemaArgs = {
  usState: UsState;
};

export type QueryOfferGroupsArgs = {
  ingestionFolderId: Scalars["ID"]["input"];
};

export type QueryOfferScorecardsForAgentArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: OfferScorecardsFilterInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOfferScorecardsForOrgArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters: OfferScorecardsFilterInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOffersForCurrentUserArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OffersForCurrentUserFilters>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOffersForListingArgs = {
  input: OffersForListingInput;
};

export type QueryOpenHouseArgs = {
  input: OpenHouseInput;
};

export type QueryOpenHousesForCurrentUserArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OpenHousesFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOrgListingAggDeltaByStatusArgs = {
  input: OrgListingAggDeltaByStatusInput;
};

export type QueryOrgTransactionStatsByZipCodeArgs = {
  filters: AgentPerformanceFilters;
};

export type QueryOrganizationArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationDescendantsTreeArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationListingAggregatesByStatusArgs = {
  organizationId: Scalars["String"]["input"];
};

export type QueryOrganizationOfficesAndTeamsArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationPartnerArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationPartnerStageIntrosArgs = {
  partnerId: Scalars["ID"]["input"];
  side: TransactionSide;
};

export type QueryOrganizationPartnersArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OrganizationPartnerFilters>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOrganizationRosterEntryArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationRosterListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OrganizationRosterFilters>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryOrganizationRosterPreferenceArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryOrganizationRosterPreferencesArgs = {
  rosterEntryId: Scalars["ID"]["input"];
};

export type QueryOrganizationValidationSettingsArgs = {
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  transactionPipelineId: Scalars["String"]["input"];
  transactionStageId: Scalars["String"]["input"];
};

export type QueryPartnerContactsListArgs = {
  filters: ContactFilters;
};

export type QueryPartyAndBuyerInfoArgs = {
  input: PartyAndBuyerInfoInput;
};

export type QueryPartyAutofillVariableValuesArgs = {
  partyIds: Array<Scalars["ID"]["input"]>;
};

export type QueryPerAgentOfferAcceptRateArgs = {
  filters: AgentPerformanceFilters;
};

export type QueryPerAgentTransactionStatsArgs = {
  filters: AgentPerformanceFilters;
};

export type QueryPerOfficeOfferAcceptRateArgs = {
  filters: AgentPerformanceFilters;
};

export type QueryPerOfficeTransactionStatsArgs = {
  filters: AgentPerformanceFilters;
};

export type QueryPreferencesArgs = {
  input: PreferencesInput;
};

export type QueryPreviewFieldsToColumnArgs = {
  contractId: Scalars["ID"]["input"];
};

export type QueryPreviewReassignIngestionFolderPipelinesArgs = {
  input: PreviewReassignIngestionFolderPipelinesInput;
};

export type QueryPrioritizedListingsForCurrentUserArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryPublicAgentUserListingsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  input: PublicAgentUserListingsInput;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryPublicDocumentListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentListArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryPublicDocumentSectionListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentSectionListFilters>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryPublicDocumentVersionListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<DocumentVersionListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryPublicListingArgs = {
  input: PublicListingInput;
};

export type QueryPublicListingAnnouncementsArgs = {
  input: PublicListingAnnouncementInput;
};

export type QueryPublicListingComparableSetArgs = {
  input: PublicListingComparableSetInput;
};

export type QueryPublicListingDocumentTypesArgs = {
  input: PublicListingDocumentTypesInput;
};

export type QueryPublicListingDocumentUploadsArgs = {
  input: PublicListingDocumentUploadsInput;
};

export type QueryPublicPreferencesArgs = {
  input: PublicPreferencesInput;
};

export type QueryRuleListArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<RuleListFilterArgs>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryRuleMissingKeysArgs = {
  ruleId: Scalars["ID"]["input"];
  transactionRuleId: Scalars["ID"]["input"];
};

export type QuerySearchIngestionFoldersForValidationArgs = {
  filters: IngestionFolderValidationFiltersInput;
};

export type QuerySearchMlsListingsByAddressArgs = {
  input: SearchMlsListingsByAddressInput;
};

export type QuerySearchMlsListingsWithFiltersArgs = {
  input: SearchMlsListingsWithFiltersInput;
};

export type QuerySignatureInitialsDatasetMetricsArgs = {
  input: SignatureInitialsDatasetMetricsInput;
};

export type QueryStorefrontActivitiesArgs = {
  input: StorefrontActivitiesInput;
};

export type QueryStorefrontActivitiesSummaryArgs = {
  input: StorefrontActivitiesSummaryInput;
};

export type QueryStorefrontActivitySummaryArgs = {
  input: StorefrontActivitySummaryInput;
};

export type QuerySyncListingFromMlsArgs = {
  input: MlsListingInput;
};

export type QueryTransactionNotificationLogArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryTransactionNotificationLogsArgs = {
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<NotificationLogFilters>;
  orderBy?: Scalars["String"]["input"];
  organizationId: Scalars["ID"]["input"];
  perPage?: Scalars["Int"]["input"];
};

export type QueryTransactionPipelineListArgs = {
  filters: TransactionPipelineListFilterArgs;
};

export type QueryTransactionRuleMissingKeysArgs = {
  transactionRuleId: Scalars["ID"]["input"];
};

export type QueryZipCodesGeoArgs = {
  filters: ZipCodesGeoFilters;
};

export type QueueAnalyzeForOfferIngestionJobInput = {
  jobs: Array<AnalyzeForOfferIngestionJobInput>;
};

export type QueueAnalyzeJobPayload = {
  __typename?: "QueueAnalyzeJobPayload";
  queuedJobsCount: Scalars["Int"]["output"];
};

export type ResoMemberObject = {
  __typename?: "RESOMemberObject";
  Media?: Maybe<Array<MediaObject>>;
  MemberAOR?: Maybe<Scalars["String"]["output"]>;
  MemberAddress1?: Maybe<Scalars["String"]["output"]>;
  MemberAddress2?: Maybe<Scalars["String"]["output"]>;
  MemberCity?: Maybe<Scalars["String"]["output"]>;
  MemberDirectPhone?: Maybe<Scalars["String"]["output"]>;
  MemberEmail?: Maybe<Scalars["String"]["output"]>;
  MemberFirstName?: Maybe<Scalars["String"]["output"]>;
  MemberFullName?: Maybe<Scalars["String"]["output"]>;
  MemberLastName?: Maybe<Scalars["String"]["output"]>;
  MemberMiddleName?: Maybe<Scalars["String"]["output"]>;
  MemberMlsId?: Maybe<Scalars["String"]["output"]>;
  MemberMlsSecurityClass?: Maybe<Scalars["String"]["output"]>;
  MemberMobilePhone?: Maybe<Scalars["String"]["output"]>;
  MemberNationalAssociationId?: Maybe<Scalars["String"]["output"]>;
  MemberOfficePhone?: Maybe<Scalars["String"]["output"]>;
  MemberPostalCode?: Maybe<Scalars["String"]["output"]>;
  MemberPreferredPhone?: Maybe<Scalars["String"]["output"]>;
  MemberStateOrProvince?: Maybe<Scalars["String"]["output"]>;
  MemberStatus?: Maybe<Scalars["String"]["output"]>;
  OfficeMlsId?: Maybe<Scalars["String"]["output"]>;
  OriginatingSystemName?: Maybe<Scalars["String"]["output"]>;
};

export type ResoOfficeObject = {
  __typename?: "RESOOfficeObject";
  ModificationTimestamp?: Maybe<Scalars["String"]["output"]>;
  OfficeEmail?: Maybe<Scalars["String"]["output"]>;
  OfficeKey?: Maybe<Scalars["String"]["output"]>;
  OfficeMlsId?: Maybe<Scalars["String"]["output"]>;
  OfficeName?: Maybe<Scalars["String"]["output"]>;
  OfficeStatus?: Maybe<Scalars["String"]["output"]>;
  OriginatingSystemName?: Maybe<Scalars["String"]["output"]>;
};

export type RankedMlsListingObject = {
  __typename?: "RankedMLSListingObject";
  /** Reason for disqualification (if any) */
  disqualificationReason?: Maybe<Scalars["String"]["output"]>;
  /** Whether this listing should be excluded from selection */
  disqualified: Scalars["Boolean"]["output"];
  /** The MLS listing */
  listing: MlsListingObject;
  /** Breakdown of scoring factors */
  rankingFactors: MlsListingRankingFactorsObject;
  /** Total combined score (higher = better match) */
  score: Scalars["Float"]["output"];
};

export type ReassignIngestionFolderPipelineItem = {
  /** UUID of the ingestion folder to reassign */
  ingestionFolderUuid: Scalars["ID"]["input"];
  /** Optional pipeline UUID to force assign. If not provided, auto-matching will be used. */
  reassignTxPipelineOverride?: InputMaybe<Scalars["ID"]["input"]>;
  /** Internal-only override behavior. Defaults to SET_PIPELINE when an override UUID is provided, otherwise LEAVE_DEFAULT. */
  reassignTxPipelineOverrideMode?: InputMaybe<ReassignTxPipelineOverrideMode>;
};

export type ReassignIngestionFolderPipelinesInput = {
  /** Items to reassign */
  items: Array<ReassignIngestionFolderPipelineItem>;
};

export type ReassignIngestionFolderPipelinesPayload = {
  __typename?: "ReassignIngestionFolderPipelinesPayload";
  /** Number of items that will be processed */
  itemCount: Scalars["Int"]["output"];
  /** BullMQ job ID for tracking */
  jobId?: Maybe<Scalars["ID"]["output"]>;
  /** Human-readable status message */
  message?: Maybe<Scalars["String"]["output"]>;
  /** Whether the job was successfully queued */
  success: Scalars["Boolean"]["output"];
};

/** Internal-only override behavior for pipeline reassignment */
export enum ReassignTxPipelineOverrideMode {
  CLEAR_PIPELINE = "CLEAR_PIPELINE",
  LEAVE_DEFAULT = "LEAVE_DEFAULT",
  SET_PIPELINE = "SET_PIPELINE",
}

export type RemoveDryRunNotificationLogsInput = {
  /** Organization UUID to remove dry run logs for */
  organizationUuid: Scalars["ID"]["input"];
};

export type RemoveDryRunNotificationLogsPayload = {
  __typename?: "RemoveDryRunNotificationLogsPayload";
  /** Total number of dry run notification logs deleted */
  deletedCount: Scalars["Int"]["output"];
  /** Whether all matching dry run notification logs were deleted before hitting the configured safeguard */
  success: Scalars["Boolean"]["output"];
};

export type ReorderNotificationTemplateInput = {
  id: Scalars["ID"]["input"];
  orderIndex: Scalars["Int"]["input"];
};

export type ReportConfidence = {
  __typename?: "ReportConfidence";
  confidence: ConfidenceLevel;
  maxClosePrice: Scalars["Float"]["output"];
  maxDistanceMiles: Scalars["Float"]["output"];
  maxTimePeriodMonths: Scalars["Float"]["output"];
  minClosePrice: Scalars["Float"]["output"];
  /** @deprecated Use subTypes instead */
  subType?: Maybe<Scalars["String"]["output"]>;
  subTypes?: Maybe<Array<Scalars["String"]["output"]>>;
  zipCode?: Maybe<Scalars["String"]["output"]>;
};

export type ReportFiltersInput = {
  minComps?: Scalars["Int"]["input"];
  months?: Scalars["Float"]["input"];
};

export type RequiredDocumentResult = {
  __typename?: "RequiredDocumentResult";
  isMissing?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

export type RequiredDocumentValidationResult = {
  __typename?: "RequiredDocumentValidationResult";
  isMissing?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
};

export type RevokeBoaShareLinkInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type RevokeListingReportShareLinkInput = {
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["ID"]["input"]>;
  token: Scalars["String"]["input"];
};

export enum Roles {
  ADMIN = "ADMIN",
  AGENT = "AGENT",
  ASSISTANT = "ASSISTANT",
  CONSUMER = "CONSUMER",
  EMPLOYEE = "EMPLOYEE",
  LENDER = "LENDER",
}

export type RuleDefinitionInput = {
  formula: Scalars["String"]["input"];
  formulaVariableFields: Array<VariableFieldInput>;
  message: Scalars["String"]["input"];
  ruleType: RuleType;
};

export type RuleListFilterArgs = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  isReusable?: InputMaybe<Scalars["Boolean"]["input"]>;
  ruleType?: InputMaybe<RuleType>;
  search?: InputMaybe<Scalars["String"]["input"]>;
};

export type RuleMissingKeysPayload = {
  __typename?: "RuleMissingKeysPayload";
  documentVersionsMissingKeys: Array<DocumentVersionMissingKey>;
  ruleId: Scalars["String"]["output"];
};

export type RuleObject = {
  __typename?: "RuleObject";
  autofill?: Maybe<AutofillObject>;
  contextForLLMJudge?: Maybe<Scalars["String"]["output"]>;
  defaultSecondaryDocument?: Maybe<DefaultSecondaryDocumentObject>;
  documentVersionField?: Maybe<DocumentVersionFieldObject>;
  errorMessageTemplate?: Maybe<Scalars["String"]["output"]>;
  field?: Maybe<FieldObject>;
  focusFieldMappingKeys?: Maybe<Array<Scalars["String"]["output"]>>;
  id: Scalars["ID"]["output"];
  message: Scalars["String"]["output"];
  ruleType: RuleType;
  secondaryDocumentVersion?: Maybe<SecondaryDocumentVersionObject>;
};

/** Paginated results of RuleObject */
export type RuleObjectPaginated = {
  __typename?: "RuleObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<RuleObject>>;
};

export type RuleRelationInput = {
  defaultSecondaryDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  documentVersionFieldId?: InputMaybe<Scalars["ID"]["input"]>;
  fieldId?: InputMaybe<Scalars["ID"]["input"]>;
  secondaryDocumentVersionId?: InputMaybe<Scalars["ID"]["input"]>;
};

export enum RuleType {
  DISABLE = "DISABLE",
  ENABLE = "ENABLE",
  ERROR = "ERROR",
  REQUIRED = "REQUIRED",
  WARNING = "WARNING",
}

export type RuleValidationInputValue = {
  __typename?: "RuleValidationInputValue";
  fieldKey: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
  variableSource?: Maybe<VariableSource>;
};

export type RuleValidationInputValueForJudgeInput = {
  fieldKey: Scalars["String"]["input"];
  value: Scalars["String"]["input"];
  variableSource?: InputMaybe<VariableSource>;
};

export type RuleValidationObject = {
  __typename?: "RuleValidationObject";
  inputValue?: Maybe<Scalars["String"]["output"]>;
  message: Scalars["String"]["output"];
  rule: RuleObject;
  validationValue?: Maybe<Scalars["String"]["output"]>;
};

export type RulesOverviewDocumentFieldRuleObject = {
  __typename?: "RulesOverviewDocumentFieldRuleObject";
  documentVersionFieldId: Scalars["ID"]["output"];
  field?: Maybe<FieldObject>;
  mappingKey: Scalars["String"]["output"];
  rule: RuleObject;
};

export type RulesOverviewDocumentFiltersInput = {
  usState?: InputMaybe<UsState>;
};

export type RulesOverviewDocumentRuleGroupObject = {
  __typename?: "RulesOverviewDocumentRuleGroupObject";
  document: DocumentObject;
  fieldRules: Array<RulesOverviewDocumentFieldRuleObject>;
};

export type RulesOverviewFiltersInput = {
  documents?: InputMaybe<RulesOverviewDocumentFiltersInput>;
  pipeline?: InputMaybe<RulesOverviewPipelineFiltersInput>;
};

export type RulesOverviewPayload = {
  __typename?: "RulesOverviewPayload";
  documents: Array<RulesOverviewDocumentRuleGroupObject>;
  pipelines: Array<RulesOverviewPipelineObject>;
};

export type RulesOverviewPipelineFiltersInput = {
  clientType?: InputMaybe<ClientType>;
  stage?: InputMaybe<TransactionStageType>;
  transactionPropertyType?: InputMaybe<TransactionPropertyType>;
  usState?: InputMaybe<UsState>;
};

export type RulesOverviewPipelineObject = {
  __typename?: "RulesOverviewPipelineObject";
  clientType: ClientType;
  stages: Array<RulesOverviewStageObject>;
  transactionPropertyType: TransactionPropertyType;
  usState: UsState;
};

export type RulesOverviewStageObject = {
  __typename?: "RulesOverviewStageObject";
  stage: TransactionStageType;
  stageRequirementRules: Array<RulesOverviewTransactionRuleObject>;
  validationRules: Array<RulesOverviewTransactionRuleObject>;
};

export type RulesOverviewTransactionRuleObject = {
  __typename?: "RulesOverviewTransactionRuleObject";
  children: Array<RulesOverviewTransactionRuleObject>;
  id: Scalars["ID"]["output"];
  isRequiredDocument: Scalars["Boolean"]["output"];
  logicalOperator: LogicalOperator;
  offerIngestionRule?: Maybe<RuleObject>;
  rules: Array<RuleObject>;
  targetDocument?: Maybe<DocumentObject>;
  targetDocumentCategory?: Maybe<DocumentCategory>;
};

export type RunIngestionDocumentValidationLlmAsJudgeInput = {
  contextForLLMJudge?: InputMaybe<Scalars["String"]["input"]>;
  formula: Scalars["String"]["input"];
  inputValues: Array<RuleValidationInputValueForJudgeInput>;
  message: Scalars["String"]["input"];
  ruleType: RuleType;
};

export type RunIngestionDocumentValidationLlmAsJudgePayload = {
  __typename?: "RunIngestionDocumentValidationLlmAsJudgePayload";
  llmAnalysis?: Maybe<Scalars["String"]["output"]>;
  llmOutput: Scalars["Boolean"]["output"];
};

export type SaveCheckboxExportDatasetInput = {
  documentMLId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  pageNumbers: Array<Scalars["Float"]["input"]>;
};

export type SaveComplianceGroupTransactionStageByTypeInput = {
  complianceGroupId: Scalars["String"]["input"];
  complianceGroupName: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  organizationUuid: Scalars["ID"]["input"];
  transactionStageType: TransactionStageType;
};

export type SaveComplianceGroupTransactionStageInput = {
  complianceGroupId: Scalars["String"]["input"];
  complianceGroupName: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  organizationUuid: Scalars["ID"]["input"];
  transactionStageId: Scalars["ID"]["input"];
};

export type SaveSignatureInitialDatasetInput = {
  documentMLId?: InputMaybe<Scalars["ID"]["input"]>;
  ingestionDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  pageNumbers: Array<Scalars["Float"]["input"]>;
};

export type SearchMlsListingsWithFiltersInput = {
  excludeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  filters: MlsListingFiltersInput;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
};

export type SearchMlsListingsWithFiltersPayload = {
  __typename?: "SearchMLSListingsWithFiltersPayload";
  mlsListings: Array<MlsListingWithListingPayload>;
  totalCount: Scalars["Float"]["output"];
};

export type SearchMlsListingsByAddressInput = {
  excludeIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  onlyLiveStatuses?: Scalars["Boolean"]["input"];
  searchString: Scalars["String"]["input"];
};

export type SecondaryContractDocumentObject = {
  __typename?: "SecondaryContractDocumentObject";
  form: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
};

export type SecondaryDocumentVersionObject = {
  __typename?: "SecondaryDocumentVersionObject";
  documentVersion: DocumentVersionObject;
  id: Scalars["ID"]["output"];
  ordering: Scalars["Int"]["output"];
  rules: Array<RuleObject>;
  secondaryDocumentVersion: DocumentVersionObject;
};

export type SecondaryDocumentVersionPayload = {
  __typename?: "SecondaryDocumentVersionPayload";
  secondaryDocumentVersion?: Maybe<SecondaryDocumentVersionObject>;
};

export type SendBoaShareLinkInput = {
  buyerOfferAnalysisId: Scalars["String"]["input"];
  message?: InputMaybe<Scalars["String"]["input"]>;
  recipientEmail?: InputMaybe<Scalars["String"]["input"]>;
  recipientPhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type SendComplianceSummaryNotificationInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  folderName: Scalars["String"]["input"];
  ingestionFolderId?: InputMaybe<Scalars["String"]["input"]>;
  link: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
  organizationId: Scalars["String"]["input"];
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type SendComplianceSummaryNotificationResponse = {
  __typename?: "SendComplianceSummaryNotificationResponse";
  success: Scalars["Boolean"]["output"];
  workflowRunId: Scalars["String"]["output"];
};

export type SendListingReportShareLinkInput = {
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  message?: InputMaybe<Scalars["String"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["ID"]["input"]>;
  recipientEmail?: InputMaybe<Scalars["String"]["input"]>;
  recipientPhoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type SendOtpFromInvitationLinkInput = {
  invitationLink: Scalars["String"]["input"];
};

export type SendOtpFromInvitationLinkPayload = {
  __typename?: "SendOTPFromInvitationLinkPayload";
  agentName: Scalars["String"]["output"];
  invitationId: Scalars["String"]["output"];
  listingId: Scalars["String"]["output"];
  methodId: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  phoneNumberLast4: Scalars["String"]["output"];
};

export type SendSellerInvitationInput = {
  listingId: Scalars["String"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  phoneNumber: Scalars["String"]["input"];
};

export type SendSellerInvitationPayload = {
  __typename?: "SendSellerInvitationPayload";
  invitation?: Maybe<InvitationObject>;
  sellerUser: UserObject;
};

export type SendSignatureRequestForOfferPayload = {
  __typename?: "SendSignatureRequestForOfferPayload";
  offer?: Maybe<OfferObject>;
};

export type SendSignatureRequestToBuyersForOfferInput = {
  message: Scalars["String"]["input"];
  offerId: Scalars["ID"]["input"];
  signatureFormFields?: InputMaybe<Array<SignatureFormFieldInput>>;
};

export type SendSignatureRequestToSellersForOfferInput = {
  message: Scalars["String"]["input"];
  offerId: Scalars["ID"]["input"];
};

export type SendTestNotificationInput = {
  ingestionFolderId: Scalars["ID"]["input"];
  notificationTemplateId: Scalars["ID"]["input"];
  partnerContactId?: InputMaybe<Scalars["ID"]["input"]>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  preferenceType: PartnerPreferenceType;
};

export type SendTestNotificationResponse = {
  __typename?: "SendTestNotificationResponse";
  notificationLogId?: Maybe<Scalars["ID"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type SetDocumentVersionAsActiveInput = {
  id: Scalars["ID"]["input"];
};

export type SetDocumentVersionAsActivePayload = {
  __typename?: "SetDocumentVersionAsActivePayload";
  documentVersion?: Maybe<DocumentVersionObject>;
};

export enum ShareLinkAccessType {
  READ = "READ",
  WRITE = "WRITE",
}

export type ShareLinkObject = {
  __typename?: "ShareLinkObject";
  accessType: ShareLinkAccessType;
  expiresAt?: Maybe<Scalars["DateTime"]["output"]>;
  id: Scalars["ID"]["output"];
  isForPdf: Scalars["Boolean"]["output"];
  recipientEmail?: Maybe<Scalars["String"]["output"]>;
  recipientPhoneNumber?: Maybe<Scalars["String"]["output"]>;
  status: ShareLinkStatus;
  token: Scalars["String"]["output"];
};

export enum ShareLinkStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
}

export type ShareStorefrontWithBuyerInput = {
  listingId: Scalars["String"]["input"];
  recipientEmail?: InputMaybe<Scalars["String"]["input"]>;
  recipientPhone?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignUpAgentInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  licenses: Array<UserLicenseInput>;
  mlsId: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
  profilePictureURL?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignUpAgentV2Input = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  licenses: Array<UserLicenseWithMlsInput>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
  profilePictureURL?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignUpInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
  profilePictureURL?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignUpUserPayload = {
  __typename?: "SignUpUserPayload";
  user?: Maybe<UserObject>;
};

export type SignatureFormFieldInput = {
  documentIndex: Scalars["Float"]["input"];
  height: Scalars["Float"]["input"];
  id: Scalars["String"]["input"];
  isRequired: Scalars["Boolean"]["input"];
  name?: InputMaybe<Scalars["String"]["input"]>;
  page: Scalars["Float"]["input"];
  signerId: Scalars["String"]["input"];
  type: FieldType;
  width: Scalars["Float"]["input"];
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type SignatureFormFieldObject = {
  __typename?: "SignatureFormFieldObject";
  documentIndex: Scalars["Float"]["output"];
  height: Scalars["Float"]["output"];
  id: Scalars["String"]["output"];
  isRequired: Scalars["Boolean"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  page: Scalars["Float"]["output"];
  signerId: Scalars["String"]["output"];
  type: FieldType;
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type SignatureInitialDatasetExistsPayload = {
  __typename?: "SignatureInitialDatasetExistsPayload";
  exists: Scalars["Boolean"]["output"];
  key?: Maybe<Scalars["String"]["output"]>;
  pageNumber: Scalars["Float"]["output"];
};

export type SignatureInitialDatasetFilePayload = {
  __typename?: "SignatureInitialDatasetFilePayload";
  key: Scalars["String"]["output"];
};

export type SignatureInitialDatasetFilesPayload = {
  __typename?: "SignatureInitialDatasetFilesPayload";
  active: Array<SignatureInitialDatasetFilePayload>;
  draft: Array<SignatureInitialDatasetFilePayload>;
  invalid: Array<SignatureInitialDatasetFilePayload>;
  original: Array<SignatureInitialDatasetFilePayload>;
  validations: Array<SignatureInitialDatasetFilePayload>;
};

export type SignatureInitialsDatasetMetricsEntryPayload = {
  __typename?: "SignatureInitialsDatasetMetricsEntryPayload";
  count: Scalars["Float"]["output"];
  formName?: Maybe<Scalars["String"]["output"]>;
  usState?: Maybe<UsState>;
};

export type SignatureInitialsDatasetMetricsInput = {
  draftCount: Scalars["Int"]["input"];
  finalCount: Scalars["Int"]["input"];
};

export type SignatureInitialsDatasetMetricsPayload = {
  __typename?: "SignatureInitialsDatasetMetricsPayload";
  draft: Array<SignatureInitialsDatasetMetricsEntryPayload>;
  final: Array<SignatureInitialsDatasetMetricsEntryPayload>;
};

export enum SignatureProvider {
  DROPBOX_SIGN = "DROPBOX_SIGN",
  INDIGO = "INDIGO",
}

export type SignatureRequestEventObject = {
  __typename?: "SignatureRequestEventObject";
  createdAt: Scalars["DateTime"]["output"];
  eventType: SignatureRequestEventType;
  id: Scalars["ID"]["output"];
};

export enum SignatureRequestEventType {
  CALLBACK_TEST = "CALLBACK_TEST",
  SIGNATURE_REQUEST_ALL_SIGNED = "SIGNATURE_REQUEST_ALL_SIGNED",
  SIGNATURE_REQUEST_CANCELED = "SIGNATURE_REQUEST_CANCELED",
  SIGNATURE_REQUEST_DECLINED = "SIGNATURE_REQUEST_DECLINED",
  SIGNATURE_REQUEST_DESTROYED = "SIGNATURE_REQUEST_DESTROYED",
  SIGNATURE_REQUEST_DOWNLOADABLE = "SIGNATURE_REQUEST_DOWNLOADABLE",
  SIGNATURE_REQUEST_EMAIL_BOUNCE = "SIGNATURE_REQUEST_EMAIL_BOUNCE",
  SIGNATURE_REQUEST_EXPIRED = "SIGNATURE_REQUEST_EXPIRED",
  SIGNATURE_REQUEST_INVALID = "SIGNATURE_REQUEST_INVALID",
  SIGNATURE_REQUEST_PREPARED = "SIGNATURE_REQUEST_PREPARED",
  SIGNATURE_REQUEST_REASSIGNED = "SIGNATURE_REQUEST_REASSIGNED",
  SIGNATURE_REQUEST_REMIND = "SIGNATURE_REQUEST_REMIND",
  SIGNATURE_REQUEST_SENT = "SIGNATURE_REQUEST_SENT",
  SIGNATURE_REQUEST_SIGNED = "SIGNATURE_REQUEST_SIGNED",
  SIGNATURE_REQUEST_VIEWED = "SIGNATURE_REQUEST_VIEWED",
}

export type SignatureRequestObject = {
  __typename?: "SignatureRequestObject";
  allSignedDocument?: Maybe<FileObject>;
  events: Array<SignatureRequestEventObject>;
  externalId: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  provider: SignatureProvider;
  requester?: Maybe<PublicUserObject>;
  requesterEmail: Scalars["String"]["output"];
  requesterName: Scalars["String"]["output"];
  signers: Array<SignatureRequestSignerObject>;
};

export type SignatureRequestSignerObject = {
  __typename?: "SignatureRequestSignerObject";
  fullName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  signedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SignedUrlPayload = {
  __typename?: "SignedUrlPayload";
  key: Scalars["String"]["output"];
  signedUrl: Scalars["String"]["output"];
};

export type SimulationCandidateResult = {
  __typename?: "SimulationCandidateResult";
  autofillRendering?: Maybe<DebugAutofillRendering>;
  outcome: SimulationOutcome;
  reason?: Maybe<Scalars["String"]["output"]>;
  recipientResolution?: Maybe<DebugRecipientResolution>;
  routingDecisions?: Maybe<DebugRoutingDecisions>;
  stageIntroSource?: Maybe<DebugStageIntroSource>;
  templateSource?: Maybe<DebugTemplateSource>;
};

export enum SimulationOutcome {
  WOULD_CREATE_LOG = "WOULD_CREATE_LOG",
  WOULD_DRY_RUN = "WOULD_DRY_RUN",
  WOULD_PAUSE = "WOULD_PAUSE",
  WOULD_QUEUE_JOURNEY = "WOULD_QUEUE_JOURNEY",
  WOULD_SEND_INTRO = "WOULD_SEND_INTRO",
  WOULD_SUPPRESS = "WOULD_SUPPRESS",
}

export type StorefrontActivitiesInput = {
  listingId: Scalars["String"]["input"];
};

export type StorefrontActivitiesSummaryInput = {
  activityTypes: Array<ActivityType>;
  listingId: Scalars["String"]["input"];
};

export type StorefrontActivitySummaryInput = {
  activityType: ActivityType;
  listingId: Scalars["String"]["input"];
};

export type StorefrontActivitySummaryObject = {
  __typename?: "StorefrontActivitySummaryObject";
  activities: Array<ActivityObject>;
  activityType: ActivityType;
  count: Scalars["Int"]["output"];
  users: Array<UserObject>;
};

export type StorefrontConfigurationStatusObject = {
  __typename?: "StorefrontConfigurationStatusObject";
  comparables: Scalars["Boolean"]["output"];
  configuredCount: Scalars["Int"]["output"];
  documents: Scalars["Boolean"]["output"];
  /** @deprecated Use `configuredCount` and `progressTotal` instead. */
  hasSetup?: Maybe<Scalars["Boolean"]["output"]>;
  progressTotal: Scalars["Int"]["output"];
  sellerPreferences: Scalars["Boolean"]["output"];
};

export type StorefrontSetupObject = {
  __typename?: "StorefrontSetupObject";
  continueStep?: Maybe<StorefrontSetupStep>;
  id: Scalars["String"]["output"];
  listingPackage: FileObject;
};

export enum StorefrontSetupStep {
  COMPARABLES = "COMPARABLES",
  DOCUMENTS = "DOCUMENTS",
  SELLER_PREFERENCES = "SELLER_PREFERENCES",
  SHARE = "SHARE",
}

export enum StorefrontSubscriptionReason {
  ACCESS_COMPARABLES = "ACCESS_COMPARABLES",
  ACCESS_LISTING_ACTIVITY = "ACCESS_LISTING_ACTIVITY",
  ACCESS_LISTING_DOCUMENTS = "ACCESS_LISTING_DOCUMENTS",
  ACCESS_SELLER_PREFERENCES = "ACCESS_SELLER_PREFERENCES",
  DEPRECATED_SUBMITTED_OFFER = "DEPRECATED_SUBMITTED_OFFER",
  GET_ALERTS = "GET_ALERTS",
  SIGN_OPEN_HOUSE_GUESTBOOK = "SIGN_OPEN_HOUSE_GUESTBOOK",
  SUBMIT_OFFER = "SUBMIT_OFFER",
}

export type SubmitOfferInput = {
  id: Scalars["String"]["input"];
  noteToListingAgent?: InputMaybe<Scalars["String"]["input"]>;
  skipListingAgentNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type SubmitOfferPayload = {
  __typename?: "SubmitOfferPayload";
  offer?: Maybe<OfferObject>;
};

export type SubmitOfferToNonIndigoListingAgentInput = {
  id: Scalars["String"]["input"];
  listingAgentInfo: ListingAgentInfoInput;
  offerInfo: OfferInfoInput;
};

export type SyncAcroformToDocumentVersionFieldsInput = {
  documentVersionId: Scalars["ID"]["input"];
};

export type SyncPreviewCurrentValue = {
  __typename?: "SyncPreviewCurrentValue";
  value?: Maybe<Scalars["String"]["output"]>;
};

export type SyncPreviewDisabledOptions = {
  __typename?: "SyncPreviewDisabledOptions";
  isDisabled: Scalars["Boolean"]["output"];
  isDisabledByDefault?: Maybe<Scalars["Boolean"]["output"]>;
  isRequired?: Maybe<Scalars["Boolean"]["output"]>;
};

export type SyncPreviewProposedValue = {
  __typename?: "SyncPreviewProposedValue";
  disabledOptions?: Maybe<SyncPreviewDisabledOptions>;
  disabledReason?: Maybe<Scalars["String"]["output"]>;
  sourceLabel?: Maybe<Scalars["String"]["output"]>;
  value?: Maybe<Scalars["String"]["output"]>;
  warningMessage?: Maybe<Scalars["String"]["output"]>;
};

export type SyncSecondaryDocumentVersionsInput = {
  documentVersionId: Scalars["ID"]["input"];
};

export type SyncSnapshotObject = {
  __typename?: "SyncSnapshotObject";
  documentCount: Scalars["Int"]["output"];
  documentVersionHash?: Maybe<Scalars["String"]["output"]>;
  hasSynced: Scalars["Boolean"]["output"];
  lastDocumentUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type SyncTransactionPipelinesPayload = {
  __typename?: "SyncTransactionPipelinesPayload";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
  workflowRunId?: Maybe<Scalars["String"]["output"]>;
};

export type SyncedVendorResult = {
  __typename?: "SyncedVendorResult";
  personId: Scalars["Int"]["output"];
  personName: Scalars["String"]["output"];
  vendorType: DarwinVendorType;
};

export type Table = TableData;

export type TableColumn = {
  __typename?: "TableColumn";
  isHighlighted: Scalars["Boolean"]["output"];
  key: Scalars["String"]["output"];
  summary?: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
};

export type TableData = {
  __typename?: "TableData";
  columns: Array<TableColumn>;
  rows: Array<TableRow>;
  title: Scalars["String"]["output"];
};

export type TableRow = {
  __typename?: "TableRow";
  data?: Maybe<TableRowData>;
  title: Scalars["String"]["output"];
};

export type TableRowData = OffersByFinancingTypeTableRow;

export type TableRowDataValue = {
  __typename?: "TableRowDataValue";
  subValue?: Maybe<Scalars["String"]["output"]>;
  value: Scalars["String"]["output"];
};

export type TerminateOfferGroupInput = {
  offerGroupId: Scalars["ID"]["input"];
  terminatedAt: Scalars["DateTime"]["input"];
};

export type TerminateOfferGroupPayload = {
  __typename?: "TerminateOfferGroupPayload";
  offerGroup: OfferGroupObject;
};

export type TitleAgentContactObject = PartnerContactBaseObject & {
  __typename?: "TitleAgentContactObject";
  contactType: ContactType;
  createdAt: Scalars["DateTime"]["output"];
  email: Scalars["String"]["output"];
  firstName: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  lastName: Scalars["String"]["output"];
  partner?: Maybe<OrganizationPartnerObject>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum TourType {
  BA_STOREFRONT = "BA_STOREFRONT",
  DASHBOARD = "DASHBOARD",
  LA_LISTINGS = "LA_LISTINGS",
  LA_STOREFRONT_SETUP = "LA_STOREFRONT_SETUP",
}

export type TrackListingDocumentActionInput = {
  action: ListingDocumentAction;
  listingDocumentUploadId: Scalars["String"]["input"];
};

export type TrackListingDocumentActionPayload = {
  __typename?: "TrackListingDocumentActionPayload";
  success: Scalars["Boolean"]["output"];
};

export type TransactionNotificationLogObject = NotificationLogInterface & {
  __typename?: "TransactionNotificationLogObject";
  createdAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  messageContent: Scalars["String"]["output"];
  notificationTemplate?: Maybe<NotificationTemplateObject>;
  rawRecipients?: Maybe<Array<NotificationUserObject>>;
  recipients: Array<ContactObject>;
  scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
  sentAt?: Maybe<Scalars["DateTime"]["output"]>;
  title: Scalars["String"]["output"];
};

/** Paginated results of TransactionNotificationLogObject */
export type TransactionNotificationLogObjectPaginated = {
  __typename?: "TransactionNotificationLogObjectPaginated";
  pageInfo?: Maybe<PageInfoObject>;
  results?: Maybe<Array<TransactionNotificationLogObject>>;
};

export type TransactionPipelineListFilterArgs = {
  clientType?: InputMaybe<ClientType>;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  transactionPropertyType?: InputMaybe<TransactionPropertyType>;
  usState?: InputMaybe<UsState>;
};

export type TransactionPipelineObject = {
  __typename?: "TransactionPipelineObject";
  clientType: ClientType;
  id: Scalars["ID"]["output"];
  rule?: Maybe<RuleObject>;
  stages: Array<TransactionStageObject>;
  transactionPropertyType: TransactionPropertyType;
  usState: UsState;
};

export enum TransactionPropertyType {
  COMMERCIAL = "COMMERCIAL",
  LAND = "LAND",
  RENTAL = "RENTAL",
  RESIDENTIAL = "RESIDENTIAL",
}

export type TransactionRuleDefinitionInput = {
  isOfferIngestionRule?: InputMaybe<Scalars["Boolean"]["input"]>;
  isRequiredDocument?: InputMaybe<Scalars["Boolean"]["input"]>;
  logicalOperator: LogicalOperator;
  rules: Array<RuleDefinitionInput>;
  targetDocumentCategory?: InputMaybe<DocumentCategory>;
  targetDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type TransactionRuleMissingKeysPayload = {
  __typename?: "TransactionRuleMissingKeysPayload";
  documentVersionsMissingKeys: Array<DocumentVersionMissingKey>;
  transactionRuleId: Scalars["String"]["output"];
};

export type TransactionRuleObject = {
  __typename?: "TransactionRuleObject";
  children: Array<TransactionRuleObject>;
  id: Scalars["ID"]["output"];
  isRequiredDocument: Scalars["Boolean"]["output"];
  logicalOperator: LogicalOperator;
  offerIngestionRule?: Maybe<RuleObject>;
  organizationUuid?: Maybe<Scalars["String"]["output"]>;
  parent?: Maybe<TransactionRuleObject>;
  rules: Array<RuleObject>;
  stageRequirementTransactionStage?: Maybe<TransactionStageObject>;
  targetDocument?: Maybe<DocumentObject>;
  targetDocumentCategory?: Maybe<DocumentCategory>;
  updatedAt: Scalars["DateTime"]["output"];
  validationTransactionStage?: Maybe<TransactionStageObject>;
};

export enum TransactionSide {
  BUY = "BUY",
  BUY_SELL = "BUY_SELL",
  SELL = "SELL",
  UNKNOWN = "UNKNOWN",
}

export type TransactionStageObject = {
  __typename?: "TransactionStageObject";
  id: Scalars["ID"]["output"];
  sortOrder: Scalars["Int"]["output"];
  stage: TransactionStageType;
  stageRequirementRules?: Maybe<Array<TransactionRuleObject>>;
  transactionPipeline: TransactionPipelineObject;
  validationRules?: Maybe<Array<TransactionRuleObject>>;
};

export enum TransactionStageType {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
  LEAD = "LEAD",
  SIGNED_AGENCY_AGREEMENT = "SIGNED_AGENCY_AGREEMENT",
  SUBMITTED_OFFER = "SUBMITTED_OFFER",
  TERMINATED = "TERMINATED",
  UNDER_CONTRACT = "UNDER_CONTRACT",
}

export type TxPipelineCandidateObject = {
  __typename?: "TxPipelineCandidateObject";
  clientType?: Maybe<Scalars["String"]["output"]>;
  matchedBy: Array<TxPipelineMatchedBy>;
  pipelineName?: Maybe<Scalars["String"]["output"]>;
  pipelineUuid: Scalars["ID"]["output"];
  ruleMatchFormula?: Maybe<Scalars["String"]["output"]>;
  transactionPropertyType?: Maybe<Scalars["String"]["output"]>;
  usState?: Maybe<Scalars["String"]["output"]>;
};

/** How the transaction pipeline was matched to the ingestion folder */
export enum TxPipelineMatchedBy {
  DIRECT = "DIRECT",
  OVERRIDE = "OVERRIDE",
  RENTAL_IN_FOLDER_NAME_OVERRIDE = "RENTAL_IN_FOLDER_NAME_OVERRIDE",
  RULE = "RULE",
}

/** Reason why the transaction pipeline assignment needs investigation */
export enum TxPipelineNeedsInvestigationReason {
  HAS_PIPELINE_ZERO_CANDIDATES = "HAS_PIPELINE_ZERO_CANDIDATES",
  MULTIPLE_CANDIDATES = "MULTIPLE_CANDIDATES",
  NONE = "NONE",
  NOT_IN_CANDIDATES = "NOT_IN_CANDIDATES",
  NO_PIPELINE = "NO_PIPELINE",
  NO_PIPELINES_FOR_TARGET_STATE = "NO_PIPELINES_FOR_TARGET_STATE",
  NO_TARGET_STATE = "NO_TARGET_STATE",
}

export enum UsState {
  AK = "AK",
  AL = "AL",
  AR = "AR",
  AZ = "AZ",
  CA = "CA",
  CO = "CO",
  CT = "CT",
  DC = "DC",
  DE = "DE",
  FL = "FL",
  GA = "GA",
  GLOBAL = "GLOBAL",
  HI = "HI",
  IA = "IA",
  ID = "ID",
  IL = "IL",
  IN = "IN",
  KS = "KS",
  KY = "KY",
  LA = "LA",
  MA = "MA",
  MD = "MD",
  ME = "ME",
  MI = "MI",
  MN = "MN",
  MO = "MO",
  MS = "MS",
  MT = "MT",
  NC = "NC",
  ND = "ND",
  NE = "NE",
  NH = "NH",
  NJ = "NJ",
  NM = "NM",
  NV = "NV",
  NY = "NY",
  OH = "OH",
  OK = "OK",
  OR = "OR",
  PA = "PA",
  RI = "RI",
  SC = "SC",
  SD = "SD",
  TN = "TN",
  TX = "TX",
  UT = "UT",
  VA = "VA",
  VT = "VT",
  WA = "WA",
  WI = "WI",
  WV = "WV",
  WY = "WY",
}

export type UpdateAiConversationInput = {
  id: Scalars["ID"]["input"];
  lastAIMessage?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateAutofillInput = {
  documentIds?: InputMaybe<Array<Scalars["ID"]["input"]>>;
  formula?: InputMaybe<Scalars["String"]["input"]>;
  formulaTestCases?: Array<FormulaTestCaseInput>;
  formulaVariableFields?: Array<VariableFieldInput>;
  id: Scalars["ID"]["input"];
  variableField?: InputMaybe<VariableFieldInput>;
  variableSources: Array<VariableSource>;
};

export type UpdateAutofillPayload = {
  __typename?: "UpdateAutofillPayload";
  autofill?: Maybe<AutofillObject>;
};

export type UpdateBuyerOfferAnalysisInput = {
  agentNotes?: InputMaybe<Scalars["String"]["input"]>;
  agentOfferRecs?: InputMaybe<AgentOfferRecsInput>;
  buyerOfferAnalysisId: Scalars["String"]["input"];
  hideOfferScore?: InputMaybe<Scalars["Boolean"]["input"]>;
  indigoOfferRecs?: InputMaybe<Scalars["JSONObject"]["input"]>;
  offerScore?: InputMaybe<Scalars["JSONObject"]["input"]>;
  partyId?: InputMaybe<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export enum UpdateCheckboxDatasetAction {
  DELETE = "DELETE",
  SAVE = "SAVE",
}

export type UpdateCheckboxDatasetInput = {
  action: UpdateCheckboxDatasetAction;
  /** JSON content, required for save action */
  json?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
};

export type UpdateCheckboxDatasetPayload = {
  __typename?: "UpdateCheckboxDatasetPayload";
  success: Scalars["Boolean"]["output"];
};

export type UpdateComplianceKeyTermSectionFieldsInput = {
  complianceKeyTermSectionFields: Array<ComplianceKeyTermSectionFieldInput>;
};

export type UpdateComplianceKeyTermSectionFieldsPayload = {
  __typename?: "UpdateComplianceKeyTermSectionFieldsPayload";
  complianceKeyTermSectionFields?: Maybe<
    Array<ComplianceKeyTermSectionFieldObject>
  >;
};

export type UpdateComplianceKeyTermSectionInput = {
  category: ComplianceKeyTermCategory;
  description: Scalars["String"]["input"];
  documentSectionType: DocumentSectionType;
  id: Scalars["ID"]["input"];
  order: Scalars["Int"]["input"];
  organizationUuid?: InputMaybe<Scalars["ID"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
  transactionStageId: Scalars["ID"]["input"];
};

export type UpdateComplianceKeyTermSectionsOrderInput = {
  id: Scalars["ID"]["input"];
  order: Scalars["Int"]["input"];
};

export type UpdateComplianceKeyTermSectionsPayload = {
  __typename?: "UpdateComplianceKeyTermSectionsPayload";
  complianceKeyTermSections?: Maybe<Array<ComplianceKeyTermSectionObject>>;
};

export type UpdateContactInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateContractDocumentCustomFieldsInput = {
  contractDocumentUuid: Scalars["ID"]["input"];
  contractUuid: Scalars["ID"]["input"];
  customFields?: InputMaybe<Array<Scalars["JSONObject"]["input"]>>;
};

export type UpdateContractDocumentExclusionsInput = {
  contractDocumentId: Scalars["ID"]["input"];
  exclusions: Array<ContractDocumentExclusion>;
};

export type UpdateContractDocumentExclusionsPayload = {
  __typename?: "UpdateContractDocumentExclusionsPayload";
  contractDocument: ContractDocumentObject;
};

export type UpdateContractDocumentsInput = {
  contractDocuments: Array<ContractDocumentInput>;
  contractId: Scalars["ID"]["input"];
};

export type UpdateContractInput = {
  autofillVariableValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  fieldValues: Scalars["JSONObject"]["input"];
  id: Scalars["ID"]["input"];
};

export type UpdateContractSystemCredentialsInput = {
  credentials?: InputMaybe<ContractSystemCredentialsInput>;
  organizationId: Scalars["ID"]["input"];
  type: Scalars["String"]["input"];
};

export type UpdateDefaultSecondaryDocumentInput = {
  id: Scalars["ID"]["input"];
  mappingKey?: InputMaybe<Scalars["String"]["input"]>;
  ordering: Scalars["Int"]["input"];
};

export type UpdateDefaultSecondaryDocumentsPayload = {
  __typename?: "UpdateDefaultSecondaryDocumentsPayload";
  defaultSecondaryDocuments?: Maybe<Array<DefaultSecondaryDocumentObject>>;
};

export type UpdateDocumentInput = {
  description: Scalars["String"]["input"];
  documentCategory?: InputMaybe<DocumentCategory>;
  documentType: DocumentType;
  form: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  includeInOfferIngestion: Scalars["Boolean"]["input"];
  llmExtraction: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  subsetOfDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  usState: UsState;
};

export type UpdateDocumentPayload = {
  __typename?: "UpdateDocumentPayload";
  document?: Maybe<DocumentObject>;
};

export type UpdateDocumentSectionFieldsInput = {
  documentSectionFields: Array<DocumentSectionFieldInput>;
};

export type UpdateDocumentSectionFieldsPayload = {
  __typename?: "UpdateDocumentSectionFieldsPayload";
  documentSectionFields?: Maybe<Array<DocumentSectionFieldObject>>;
};

export type UpdateDocumentSectionInput = {
  description: Scalars["String"]["input"];
  documentId: Scalars["ID"]["input"];
  documentSectionCategory: DocumentSectionCategory;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionModuleType?: InputMaybe<DocumentSectionModuleType>;
  documentSectionType: DocumentSectionType;
  id: Scalars["ID"]["input"];
  order: Scalars["Int"]["input"];
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  title: Scalars["String"]["input"];
};

export type UpdateDocumentSectionsOrderInput = {
  id: Scalars["ID"]["input"];
  order: Scalars["Int"]["input"];
};

export type UpdateDocumentSectionsPayload = {
  __typename?: "UpdateDocumentSectionsPayload";
  documentSections?: Maybe<Array<DocumentSectionObject>>;
};

export type UpdateDocumentVersionFieldInput = {
  align: FieldAlign;
  displayLabel?: InputMaybe<Scalars["String"]["input"]>;
  fieldId: Scalars["ID"]["input"];
  fontFamily: Scalars["String"]["input"];
  fontSize: Scalars["String"]["input"];
  height: Scalars["Float"]["input"];
  id: Scalars["ID"]["input"];
  inputFormat?: InputMaybe<InputFormatInput>;
  label: Scalars["String"]["input"];
  labelField?: InputMaybe<LabelFieldInput>;
  overrideAutoLabelBoundingBox?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageNumber: Scalars["Int"]["input"];
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  width: Scalars["Float"]["input"];
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type UpdateDocumentVersionFieldsPayload = {
  __typename?: "UpdateDocumentVersionFieldsPayload";
  documentVersionFields: Array<DocumentVersionFieldObject>;
};

export type UpdateDocumentVersionInput = {
  file?: InputMaybe<Scalars["File"]["input"]>;
  searchRegex?: InputMaybe<Scalars["String"]["input"]>;
  version: Scalars["String"]["input"];
};

export type UpdateFieldInput = {
  aiExtract?: InputMaybe<Scalars["Boolean"]["input"]>;
  aiInterpret?: InputMaybe<Scalars["Boolean"]["input"]>;
  comparisonType?: InputMaybe<ComparisonType>;
  displayLabel?: InputMaybe<Scalars["String"]["input"]>;
  fieldType: FieldType;
  group: Scalars["String"]["input"];
  id: Scalars["ID"]["input"];
  inputFormat?: InputMaybe<InputFormatInput>;
  isComputed?: InputMaybe<Scalars["Boolean"]["input"]>;
  isHidden?: InputMaybe<Scalars["Boolean"]["input"]>;
  label: Scalars["String"]["input"];
  mappingKey: Scalars["String"]["input"];
  readOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateFieldPayload = {
  __typename?: "UpdateFieldPayload";
  field?: Maybe<FieldObject>;
};

export type UpdateIndigoContractInput = {
  documentId: Scalars["String"]["input"];
  documentType: DocumentType;
  fieldValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  id: Scalars["ID"]["input"];
  partyId: Scalars["ID"]["input"];
};

export type UpdateIntegrationClientInput = {
  additionalConfig?: InputMaybe<Scalars["JSONObject"]["input"]>;
  clientId?: InputMaybe<Scalars["String"]["input"]>;
  clientSecret?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isActive: Scalars["Boolean"]["input"];
  logoFile?: InputMaybe<Scalars["String"]["input"]>;
  redirectUri?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateListingComparableAdjustments = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  priceAdjustment?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateListingComparableAdjustmentsV2 = {
  notes?: InputMaybe<Scalars["String"]["input"]>;
  priceAdjustmentsPerFields?: InputMaybe<Scalars["JSONObject"]["input"]>;
};

export type UpdateListingComparableInput = {
  mlsListingId: Scalars["String"]["input"];
  order: Scalars["Float"]["input"];
  source?: InputMaybe<ListingComparableSetSource>;
};

export type UpdateListingComparableSetForAgentInput = {
  agentNotes?: InputMaybe<Scalars["String"]["input"]>;
  comparables: Array<UpdateListingComparableInput>;
  listingId?: InputMaybe<Scalars["String"]["input"]>;
  propertyDetailsId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateListingComparableSetForBuyerOfferAnalysisInput = {
  agentNotes?: InputMaybe<Scalars["String"]["input"]>;
  buyerOfferAnalysisId: Scalars["String"]["input"];
  comparables: Array<UpdateListingComparableInput>;
};

export type UpdateListingComparableSetInput = {
  agentNotes?: InputMaybe<Scalars["String"]["input"]>;
  comparables: Array<UpdateListingComparableInput>;
  listingId: Scalars["String"]["input"];
};

export type UpdateListingPreferenceValueInput = {
  listingId: Scalars["String"]["input"];
  preferenceValues: Array<PreferenceValueInput>;
  skipNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateNotificationTemplateInput = {
  dataToShare?: InputMaybe<Array<Scalars["String"]["input"]>>;
  delayMinutes?: InputMaybe<Scalars["Int"]["input"]>;
  hasAssignedPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["ID"]["input"];
  isAttachedToPartner?: InputMaybe<Scalars["Boolean"]["input"]>;
  messageContent?: InputMaybe<Scalars["String"]["input"]>;
  notificationType?: InputMaybe<NotificationType>;
  recipients?: InputMaybe<Array<ContactType>>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateOfferForBuyersAgentInput = {
  fieldValues?: InputMaybe<Scalars["JSONObject"]["input"]>;
  id: Scalars["String"]["input"];
  setCurrentUserInCreatedByField?: InputMaybe<Scalars["Boolean"]["input"]>;
  status?: InputMaybe<OfferStatus>;
};

export type UpdateOfferPayload = {
  __typename?: "UpdateOfferPayload";
  offer?: Maybe<OfferObject>;
};

export type UpdateOfferWithPartyInput = {
  offerUuid: Scalars["ID"]["input"];
  partyUuid: Scalars["ID"]["input"];
};

export type UpdateOpenHouseInput = {
  date: Scalars["LocalDate"]["input"];
  endTime: Scalars["LocalTime"]["input"];
  id: Scalars["String"]["input"];
  options?: InputMaybe<OpenHouseCrudOptions>;
  startTime: Scalars["LocalTime"]["input"];
};

export type UpdateOpenHousePayload = {
  __typename?: "UpdateOpenHousePayload";
  openHouse: OpenHouseObject;
};

export type UpdateOrCreateFieldsToColumnInput = {
  columnName: Scalars["String"]["input"];
  documentCategory: DocumentCategory;
  fieldIds: Array<Scalars["String"]["input"]>;
  fieldType: FieldType;
  id?: InputMaybe<Scalars["ID"]["input"]>;
  visibility: ColumnVisibility;
};

export type UpdateOrCreateOrganizationRosterPreferenceInput = {
  partnerContactId?: InputMaybe<Scalars["ID"]["input"]>;
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  partnerType: PartnerType;
  preferenceType: PartnerPreferenceType;
  rosterEntryId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdateOrCreateTransactionRuleInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  isRequiredDocument?: InputMaybe<Scalars["Boolean"]["input"]>;
  isRule?: InputMaybe<Scalars["Boolean"]["input"]>;
  logicalOperator?: InputMaybe<LogicalOperator>;
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  ruleMessage?: InputMaybe<Scalars["String"]["input"]>;
  stageRequirementTransactionStageId?: InputMaybe<Scalars["ID"]["input"]>;
  targetDocumentCategory?: InputMaybe<DocumentCategory>;
  targetDocumentId?: InputMaybe<Scalars["ID"]["input"]>;
  validationTransactionStageId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdateOrCreateTransactionStageInput = {
  id?: InputMaybe<Scalars["ID"]["input"]>;
  stage: TransactionStageType;
  transactionPipelineId: Scalars["ID"]["input"];
};

export type UpdateOrganizationFolderNameValidationStageOverrideInput = {
  isEnabled: Scalars["Boolean"]["input"];
  keywordMappings?: InputMaybe<
    Array<FolderNameValidationStageKeywordMappingInput>
  >;
  organizationUuid: Scalars["ID"]["input"];
};

export type UpdateOrganizationPartnerInput = {
  dryRunNotifications?: InputMaybe<Scalars["Boolean"]["input"]>;
  emailDomain?: InputMaybe<Scalars["String"]["input"]>;
  existingRelationshipIntroMessage?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  isActive?: InputMaybe<Scalars["Boolean"]["input"]>;
  logo?: InputMaybe<Scalars["File"]["input"]>;
  name?: InputMaybe<Scalars["String"]["input"]>;
  newRelationshipIntroMessage?: InputMaybe<Scalars["String"]["input"]>;
  partnerType?: InputMaybe<PartnerType>;
};

export type UpdateOrganizationRosterEntryInput = {
  id: Scalars["ID"]["input"];
  isContactable?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateOrganizationValidationSettingsInput = {
  documentIgnoredRuleIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  organizationId: Scalars["String"]["input"];
  stageIgnoredRuleIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  transactionPipelineId: Scalars["String"]["input"];
  transactionStageId: Scalars["String"]["input"];
};

export type UpdateParentOrganizationInput = {
  id: Scalars["ID"]["input"];
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
};

export type UpdatePartnerContactInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  id: Scalars["ID"]["input"];
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  loanOfficerConfig?: InputMaybe<LoanOfficerContactConfigInput>;
  phoneNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePartyForBuyersAgentInput = {
  cashReserves?: InputMaybe<Scalars["Float"]["input"]>;
  financingType?: InputMaybe<FinancingType>;
  loanAmount?: InputMaybe<Scalars["Float"]["input"]>;
  partyUuid: Scalars["String"]["input"];
  percentDownPayment?: InputMaybe<Scalars["Float"]["input"]>;
  preapprovalFile?: InputMaybe<Scalars["File"]["input"]>;
  primaryBuyer: BuyerInfoInput;
  secondaryBuyers?: InputMaybe<Array<BuyerInfoInput>>;
};

export type UpdatePropertyDetailsInput = {
  areaSqFt: Scalars["Float"]["input"];
  bathsFull: Scalars["Int"]["input"];
  bathsHalf?: InputMaybe<Scalars["Int"]["input"]>;
  bedrooms: Scalars["Int"]["input"];
  propertyDetailsId: Scalars["String"]["input"];
  propertySubtype: MlsListingSubType;
  propertyType: MlsListingType;
  schoolDistrict?: InputMaybe<Scalars["String"]["input"]>;
  subdivision?: InputMaybe<Scalars["String"]["input"]>;
  targetPrice: Scalars["Float"]["input"];
  yearBuilt: Scalars["Int"]["input"];
};

export type UpdatePropertyDetailsPayload = {
  __typename?: "UpdatePropertyDetailsPayload";
  propertyDetails?: Maybe<PropertyDetailsObject>;
  success: Scalars["Boolean"]["output"];
};

export type UpdateRuleInput = {
  contextForLLMJudge?: InputMaybe<Scalars["String"]["input"]>;
  errorMessageTemplate?: InputMaybe<Scalars["String"]["input"]>;
  focusFieldMappingKeys?: InputMaybe<Array<Scalars["String"]["input"]>>;
  id: Scalars["ID"]["input"];
  isReusable?: InputMaybe<Scalars["Boolean"]["input"]>;
  message: Scalars["String"]["input"];
  ruleType: RuleType;
};

export type UpdateRulePayload = {
  __typename?: "UpdateRulePayload";
  rule?: Maybe<RuleObject>;
};

export type UpdateRulesForTransactionRuleInput = {
  ruleIds: Array<Scalars["ID"]["input"]>;
  transactionPipelineId: Scalars["ID"]["input"];
  transactionRuleId: Scalars["ID"]["input"];
};

export type UpdateSecondaryDocumentVersionInput = {
  id: Scalars["ID"]["input"];
  ordering: Scalars["Int"]["input"];
  secondaryDocumentVersionId: Scalars["ID"]["input"];
};

export enum UpdateSignatureInitialsDatasetAction {
  DELETE = "DELETE",
  MOVE_TO_ACTIVE = "MOVE_TO_ACTIVE",
  MOVE_TO_INVALID = "MOVE_TO_INVALID",
  SAVE = "SAVE",
}

export type UpdateSignatureInitialsDatasetInput = {
  action: UpdateSignatureInitialsDatasetAction;
  /** JSON content, required for save action */
  json?: InputMaybe<Scalars["String"]["input"]>;
  key: Scalars["String"]["input"];
};

export type UpdateSignatureInitialsDatasetPayload = {
  __typename?: "UpdateSignatureInitialsDatasetPayload";
  key?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type UpdateSortOrderInput = {
  id: Scalars["ID"]["input"];
  sortOrder: Scalars["Int"]["input"];
};

export type UpdateStorefrontSetupInput = {
  continueStep?: InputMaybe<StorefrontSetupStep>;
  listingId: Scalars["String"]["input"];
};

export type UpdateTransactionRuleParentInput = {
  parentId?: InputMaybe<Scalars["ID"]["input"]>;
  transactionRuleIds: Array<Scalars["ID"]["input"]>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  licenses?: InputMaybe<Array<UpdateUserLicenseInput>>;
  mlsId?: InputMaybe<Scalars["String"]["input"]>;
  profileBio?: InputMaybe<Scalars["String"]["input"]>;
  profilePicture?: InputMaybe<Scalars["File"]["input"]>;
};

export type UpdateUserLicenseInput = {
  id?: InputMaybe<Scalars["String"]["input"]>;
  licenseNumber: Scalars["String"]["input"];
  licenseType: LicenseType;
  states: Array<UsState>;
};

export type UpdateUserPayload = {
  __typename?: "UpdateUserPayload";
  user?: Maybe<UserObject>;
};

export type UpdateUserSettingsInput = {
  selectedOrganizationId?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateUserSettingsPayload = {
  __typename?: "UpdateUserSettingsPayload";
  user?: Maybe<UserObject>;
};

export type UploadAndExtractAgentNegotiationDocumentsPayload = {
  __typename?: "UploadAndExtractAgentNegotiationDocumentsPayload";
  agentCompensationFields?: Maybe<AutofillAgentCompensationObject>;
  listingDocumentUploads: Array<ListingDocumentUploadObject>;
};

export type UploadListingDocumentInput = {
  files: Array<FileUploadIdInput>;
  listingId: Scalars["String"]["input"];
};

export type UploadOfferInput = {
  files: Array<Scalars["File"]["input"]>;
  listingId: Scalars["String"]["input"];
  /** @deprecated We determine offer source based on the mutation that is called. */
  source?: InputMaybe<OfferSource>;
};

export type UploadOfferPayload = {
  __typename?: "UploadOfferPayload";
  offer?: Maybe<OfferObject>;
};

export type UpsertOrganizationPartnerStageIntroInput = {
  allowPartnerContactAssignment: Scalars["Boolean"]["input"];
  existingRelationshipMessageContent: Scalars["String"]["input"];
  id?: InputMaybe<Scalars["ID"]["input"]>;
  newRelationshipMessageContent: Scalars["String"]["input"];
  partnerId: Scalars["ID"]["input"];
  side: TransactionSide;
  stage: TransactionStageType;
};

export type UserDocumentObject = {
  __typename?: "UserDocumentObject";
  activeDocumentVersion: UserDocumentVersionObject;
  description: Scalars["String"]["output"];
  documentType: DocumentType;
  documentVersions: Array<UserDocumentVersionObject>;
  form: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  usState: UsState;
};

export type UserDocumentVersionFieldObject = {
  __typename?: "UserDocumentVersionFieldObject";
  align: FieldAlign;
  autofill?: Maybe<AutofillObject>;
  boundingBox: BoundingBoxObject;
  displayLabel?: Maybe<Scalars["String"]["output"]>;
  documentVersion: UserDocumentVersionObject;
  field: PublicFieldObject;
  fieldType: FieldType;
  fontFamily: Scalars["String"]["output"];
  fontSize: Scalars["String"]["output"];
  height: Scalars["Float"]["output"];
  helpTextAutofill?: Maybe<AutofillObject>;
  id: Scalars["ID"]["output"];
  inputFormat?: Maybe<InputFormatObject>;
  label: Scalars["String"]["output"];
  mappingKey: Scalars["String"]["output"];
  optionsAutofill?: Maybe<AutofillObject>;
  pageNumber: Scalars["Int"]["output"];
  readOnly?: Maybe<Scalars["Boolean"]["output"]>;
  rules: Array<RuleObject>;
  width: Scalars["Float"]["output"];
  x: Scalars["Float"]["output"];
  y: Scalars["Float"]["output"];
};

export type UserDocumentVersionObject = {
  __typename?: "UserDocumentVersionObject";
  document: UserDocumentObject;
  documentVersionFields: Array<UserDocumentVersionFieldObject>;
  file: FileObject;
  id: Scalars["ID"]["output"];
  version: Scalars["String"]["output"];
};

export type UserLicenseInput = {
  licenseNumber: Scalars["String"]["input"];
  licenseType: LicenseType;
  states: Array<UsState>;
};

export type UserLicenseObject = {
  __typename?: "UserLicenseObject";
  id: Scalars["String"]["output"];
  licenseNumber: Scalars["String"]["output"];
  licenseType: LicenseType;
  mls?: Maybe<MlsObject>;
  states: Array<UsState>;
};

export type UserLicenseWithMlsInput = {
  licenseNumber: Scalars["String"]["input"];
  mlsId: Scalars["String"]["input"];
  states: Array<UsState>;
};

export type UserNotificationSettingsObject = {
  __typename?: "UserNotificationSettingsObject";
  email: Scalars["Boolean"]["output"];
  sms: Scalars["Boolean"]["output"];
};

export type UserObject = {
  __typename?: "UserObject";
  email?: Maybe<Scalars["String"]["output"]>;
  firstName: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  hasListings?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["String"]["output"];
  lastName: Scalars["String"]["output"];
  licenses?: Maybe<Array<UserLicenseObject>>;
  offerCollectionEmail?: Maybe<Scalars["String"]["output"]>;
  phoneNumber: Scalars["String"]["output"];
  profileBio?: Maybe<Scalars["String"]["output"]>;
  profilePicture?: Maybe<FileObject>;
  roles: Array<Roles>;
  settings?: Maybe<UserSettingsObject>;
  tours?: Maybe<Array<UserTourObject>>;
  userName?: Maybe<Scalars["String"]["output"]>;
};

export type UserSettingsObject = {
  __typename?: "UserSettingsObject";
  id: Scalars["String"]["output"];
  selectedOrganization?: Maybe<OrganizationObject>;
};

export type UserTourObject = {
  __typename?: "UserTourObject";
  id: Scalars["String"]["output"];
  tourName: TourType;
};

export type ValidateTransactionPipelineInput = {
  clientType?: InputMaybe<ClientType>;
  ingestionFolderId: Scalars["ID"]["input"];
  stage: TransactionStageType;
  transactionPipelineId?: InputMaybe<Scalars["ID"]["input"]>;
  transactionPropertyType?: InputMaybe<TransactionPropertyType>;
  usState?: InputMaybe<UsState>;
};

export type ValidateTransactionPipelinePayload = {
  __typename?: "ValidateTransactionPipelinePayload";
  documentValidations: Array<DocumentValidationResult>;
  pipelineValidations?: Maybe<Array<PipelineValidationResult>>;
};

export type ValidateTransactionRuleOnProductionInput = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  pipelineContext: PipelineContextInput;
  transactionRule: TransactionRuleDefinitionInput;
};

export type ValidateTransactionRuleOnProductionPayload = {
  __typename?: "ValidateTransactionRuleOnProductionPayload";
  error?: Maybe<Scalars["String"]["output"]>;
  results: Array<FolderValidationResult>;
  success: Scalars["Boolean"]["output"];
  summary: ValidationSummary;
};

export type ValidationIssueGroupObject = {
  __typename?: "ValidationIssueGroupObject";
  activeReviewCount: Scalars["Int"]["output"];
  documentCategory?: Maybe<Scalars["String"]["output"]>;
  documentForm?: Maybe<Scalars["String"]["output"]>;
  documentName?: Maybe<Scalars["String"]["output"]>;
  firstSeenAt: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  kind: Scalars["String"]["output"];
  lastSeenAt: Scalars["DateTime"]["output"];
  linearIssueId?: Maybe<Scalars["String"]["output"]>;
  linearTicketUrl?: Maybe<Scalars["String"]["output"]>;
  normalizedMessage: Scalars["String"]["output"];
  normalizedStatus?: Maybe<NormalizedTransactionStatus>;
  platform: Scalars["String"]["output"];
  primaryForm?: Maybe<Scalars["String"]["output"]>;
  ruleUuid?: Maybe<Scalars["String"]["output"]>;
  status: Scalars["String"]["output"];
  totalReviewCount: Scalars["Int"]["output"];
  uniqueFolderCount: Scalars["Int"]["output"];
  uniqueOrgCount: Scalars["Int"]["output"];
  uniqueUserCount: Scalars["Int"]["output"];
};

export type ValidationReportDataObject = {
  __typename?: "ValidationReportDataObject";
  autofillData?: Maybe<OfferIngestionAutofillObject>;
  /** current validation for each validated ingestion document in the folder */
  documentValidations: Array<IngestionDocumentValidationObject>;
  folderValidation?: Maybe<IngestionFolderValidationObject>;
  /** @deprecated BLO-2669: This does not include overriden key term values */
  keyTerms?: Maybe<Scalars["JSONObject"]["output"]>;
  property?: Maybe<DocumentPropertyObject>;
};

export type ValidationReviewSubmissionObject = {
  __typename?: "ValidationReviewSubmissionObject";
  createdAt: Scalars["DateTime"]["output"];
  documentErrorCount?: Maybe<Scalars["Int"]["output"]>;
  folderErrorCount?: Maybe<Scalars["Int"]["output"]>;
  hiddenErrorCount?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["ID"]["output"];
  ingestionFolder?: Maybe<IngestionFolderObject>;
  submittedAt: Scalars["DateTime"]["output"];
  submittedByUserUuid: Scalars["String"]["output"];
  totalErrorCount?: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Scalars["DateTime"]["output"];
};

export type ValidationSummary = {
  __typename?: "ValidationSummary";
  foldersWithErrors: Scalars["Int"]["output"];
  foldersWithMissingRequiredDocs: Scalars["Int"]["output"];
  foldersWithWarnings: Scalars["Int"]["output"];
  totalErrors: Scalars["Int"]["output"];
  totalFoldersTested: Scalars["Int"]["output"];
  totalWarnings: Scalars["Int"]["output"];
};

export enum VariableDataType {
  BOOLEAN = "BOOLEAN",
  CHILDREN = "CHILDREN",
  DATE = "DATE",
  LIST = "LIST",
  NUMBER = "NUMBER",
  TEXT = "TEXT",
}

export type VariableFieldInput = {
  key: Scalars["String"]["input"];
  source: VariableSource;
  type: VariableDataType;
};

export type VariableFieldObject = {
  __typename?: "VariableFieldObject";
  key: Scalars["String"]["output"];
  source: VariableSource;
  type: VariableDataType;
};

export enum VariableSource {
  DOCUMENT = "DOCUMENT",
  FIELD = "FIELD",
  INDIGO_OFFER = "INDIGO_OFFER",
  OFFER_INGESTION = "OFFER_INGESTION",
  OFFER_INGESTION_DOCUMENT = "OFFER_INGESTION_DOCUMENT",
  SELF = "SELF",
  SIGNATURE_GROUP = "SIGNATURE_GROUP",
}

export type VerifyShareLinkInput = {
  token: Scalars["String"]["input"];
};

export type VerifyShareLinkPayload = {
  __typename?: "VerifyShareLinkPayload";
  accessType: ShareLinkAccessType;
  isExpired: Scalars["Boolean"]["output"];
  isForPdf: Scalars["Boolean"]["output"];
  isValid: Scalars["Boolean"]["output"];
  sharedBy?: Maybe<PublicUserObject>;
};

export type ZipCodesGeoFilters = {
  city?: InputMaybe<Array<Scalars["String"]["input"]>>;
  state?: InputMaybe<Array<UsState>>;
  zipCodes?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ZipCodesGeoObject = {
  __typename?: "ZipCodesGeoObject";
  city: Scalars["String"]["output"];
  county_codes: Array<Scalars["String"]["output"]>;
  county_names: Array<Scalars["String"]["output"]>;
  geo_point: Array<Scalars["Float"]["output"]>;
  geo_shape: Array<Array<Array<Array<Scalars["Float"]["output"]>>>>;
  us_state_codes: Array<Scalars["String"]["output"]>;
  us_states: Array<Scalars["String"]["output"]>;
  year: Scalars["Int"]["output"];
  zip_code: Scalars["String"]["output"];
  zip_code_type: Scalars["String"]["output"];
};

export const GraphqlNamedOperations = {
  Query: {
    EvaluateFormula: "EvaluateFormula" as const,
    EvaluateFormulaBatch: "EvaluateFormulaBatch" as const,
    fieldsToColumnList: "fieldsToColumnList" as const,
    checkDocumentVersionDuplicate: "checkDocumentVersionDuplicate" as const,
    checkSignatureInitialDatasetExists:
      "checkSignatureInitialDatasetExists" as const,
    checkboxDatasetFiles: "checkboxDatasetFiles" as const,
    checkboxDatasetSignedUrls: "checkboxDatasetSignedUrls" as const,
    complianceKeyTermSectionList: "complianceKeyTermSectionList" as const,
    contractById: "contractById" as const,
    ContractFieldValues: "ContractFieldValues" as const,
    contractList: "contractList" as const,
    contractSignatureFields: "contractSignatureFields" as const,
    contractValidations: "contractValidations" as const,
    contractVariableValues: "contractVariableValues" as const,
    DocumentClassificationEvaluationList:
      "DocumentClassificationEvaluationList" as const,
    DocumentEvaluationJobStatus: "DocumentEvaluationJobStatus" as const,
    DocumentLLMEvaluationList: "DocumentLLMEvaluationList" as const,
    DocumentLLMList: "DocumentLLMList" as const,
    DocumentLLMMissingKeys: "DocumentLLMMissingKeys" as const,
    documentList: "documentList" as const,
    documentListForOfferFlow: "documentListForOfferFlow" as const,
    documentSectionList: "documentSectionList" as const,
    documentSectionListForOfferFlow: "documentSectionListForOfferFlow" as const,
    documentVersionAutofillValues: "documentVersionAutofillValues" as const,
    documentVersionList: "documentVersionList" as const,
    documentVersionListForOfferFlow: "documentVersionListForOfferFlow" as const,
    dotloopComplianceGroups: "dotloopComplianceGroups" as const,
    embeddedSignatureRequest: "embeddedSignatureRequest" as const,
    ExternalDarwinProperties: "ExternalDarwinProperties" as const,
    ExternalDarwinProperty: "ExternalDarwinProperty" as const,
    externalGetComplianceMessageHistory:
      "externalGetComplianceMessageHistory" as const,
    externalGetDarwinCompanies: "externalGetDarwinCompanies" as const,
    externalGetDarwinCompanyOfficeMappings:
      "externalGetDarwinCompanyOfficeMappings" as const,
    externalGetDarwinPropertyClassification:
      "externalGetDarwinPropertyClassification" as const,
    externalGetDarwinSyncPreview: "externalGetDarwinSyncPreview" as const,
    externalGetMLSListingSelection: "externalGetMLSListingSelection" as const,
    externalGetObservedDotloopOffices:
      "externalGetObservedDotloopOffices" as const,
    externalKeyTermsList: "externalKeyTermsList" as const,
    fieldList: "fieldList" as const,
    GenerateValidationReport: "GenerateValidationReport" as const,
    getComplianceGroupTransactionStages:
      "getComplianceGroupTransactionStages" as const,
    getDocumentVersionField: "getDocumentVersionField" as const,
    getDocumentVersionInfo: "getDocumentVersionInfo" as const,
    getOrganizationFolderNameValidationStageOverride:
      "getOrganizationFolderNameValidationStageOverride" as const,
    getSignedUrls: "getSignedUrls" as const,
    ingestionDocumentListWithFields: "ingestionDocumentListWithFields" as const,
    ingestionFolderCountsByPipeline: "ingestionFolderCountsByPipeline" as const,
    ingestionFolderCountsByStage: "ingestionFolderCountsByStage" as const,
    ingestionFolderList: "ingestionFolderList" as const,
    ingestionFolderListForEssentials:
      "ingestionFolderListForEssentials" as const,
    IngestionFolderListForOrganizationPipelineView:
      "IngestionFolderListForOrganizationPipelineView" as const,
    ingestionFolderPlatformUrl: "ingestionFolderPlatformUrl" as const,
    internalContractVariableValues: "internalContractVariableValues" as const,
    internalDarwinSyncRun: "internalDarwinSyncRun" as const,
    internalDarwinSyncRuns: "internalDarwinSyncRuns" as const,
    internalGetIngestionDocumentValidationErrorReviews:
      "internalGetIngestionDocumentValidationErrorReviews" as const,
    InternalGetIngestionDocumentValidationFeedback:
      "InternalGetIngestionDocumentValidationFeedback" as const,
    InternalGetIngestionFolderDetail:
      "InternalGetIngestionFolderDetail" as const,
    internalGetIngestionFolderValidationErrorReviews:
      "internalGetIngestionFolderValidationErrorReviews" as const,
    InternalGetIngestionFolderValidationFeedback:
      "InternalGetIngestionFolderValidationFeedback" as const,
    InternalGetValidationReportData: "InternalGetValidationReportData" as const,
    InternalIngestionDocumentsForFolder:
      "InternalIngestionDocumentsForFolder" as const,
    InternalIngestionFolderListForOrganization:
      "InternalIngestionFolderListForOrganization" as const,
    internalIngestionFolderValidationStatus:
      "internalIngestionFolderValidationStatus" as const,
    internalOrganizationList: "internalOrganizationList" as const,
    internalRulesOverview: "internalRulesOverview" as const,
    LoadPipelineInvestigationReasonsForValidation:
      "LoadPipelineInvestigationReasonsForValidation" as const,
    mlQueueJobStatus: "mlQueueJobStatus" as const,
    offerIngestionAutofillVariablesSchema:
      "offerIngestionAutofillVariablesSchema" as const,
    offerIngestionDocumentAutofillVariablesSchema:
      "offerIngestionDocumentAutofillVariablesSchema" as const,
    organizationValidationSettings: "organizationValidationSettings" as const,
    previewFieldsToColumn: "previewFieldsToColumn" as const,
    PreviewReassignIngestionFolderPipelines:
      "PreviewReassignIngestionFolderPipelines" as const,
    ruleList: "ruleList" as const,
    RuleMissingKeys: "RuleMissingKeys" as const,
    SearchIngestionFoldersForValidation:
      "SearchIngestionFoldersForValidation" as const,
    signatureInitialDatasetFiles: "signatureInitialDatasetFiles" as const,
    signatureInitialsDatasetMetrics: "signatureInitialsDatasetMetrics" as const,
    transactionPipelineList: "transactionPipelineList" as const,
    transactionPipelineUsStates: "transactionPipelineUsStates" as const,
    TransactionRuleMissingKeys: "TransactionRuleMissingKeys" as const,
    accessControlsList: "accessControlsList" as const,
    activeIntegrationClients: "activeIntegrationClients" as const,
    aiConversationSessionFileSignedUrl:
      "aiConversationSessionFileSignedUrl" as const,
    aiConversationSessionFiles: "aiConversationSessionFiles" as const,
    aiConversations: "aiConversations" as const,
    allListingActivitiesForCurrentUser:
      "allListingActivitiesForCurrentUser" as const,
    allMLSes: "allMLSes" as const,
    auditEssentialsNotifications: "auditEssentialsNotifications" as const,
    offerAutofillVariablesSchema: "offerAutofillVariablesSchema" as const,
    offerAutofillVariableValues: "offerAutofillVariableValues" as const,
    listingAutofillVariableValues: "listingAutofillVariableValues" as const,
    offerAutofillValuesFromContract: "offerAutofillValuesFromContract" as const,
    businessOverviewOffers: "businessOverviewOffers" as const,
    BusinessOverviewStats: "BusinessOverviewStats" as const,
    BuyerClientsForCurrentAgentUser: "BuyerClientsForCurrentAgentUser" as const,
    BuyersForCurrentAgentPaginated: "BuyersForCurrentAgentPaginated" as const,
    checkPermission: "checkPermission" as const,
    currentUser: "currentUser" as const,
    EventsForOffer: "EventsForOffer" as const,
    ExternalGetDistinctOfficeNames: "ExternalGetDistinctOfficeNames" as const,
    ExternalGetDistinctStatuses: "ExternalGetDistinctStatuses" as const,
    externalGetIngestionDocument: "externalGetIngestionDocument" as const,
    ExternalGetIngestionDocumentValidationFeedback:
      "ExternalGetIngestionDocumentValidationFeedback" as const,
    externalGetIngestionFolder: "externalGetIngestionFolder" as const,
    ExternalGetIngestionFolderValidationFeedback:
      "ExternalGetIngestionFolderValidationFeedback" as const,
    externalGetValidationReportData: "externalGetValidationReportData" as const,
    ExternalIngestionDocumentsForFolder:
      "ExternalIngestionDocumentsForFolder" as const,
    ExternalIngestionFolderListForOrganization:
      "ExternalIngestionFolderListForOrganization" as const,
    externalIngestionFolderPlatformUrl:
      "externalIngestionFolderPlatformUrl" as const,
    findMLSAgent: "findMLSAgent" as const,
    findMLSAgentByEmail: "findMLSAgentByEmail" as const,
    findMLSAgentByMlsId: "findMLSAgentByMlsId" as const,
    findMLSAgentsByName: "findMLSAgentsByName" as const,
    findMLSAgentsByPhoneNumber: "findMLSAgentsByPhoneNumber" as const,
    findMLSListingByAddress: "findMLSListingByAddress" as const,
    findUserCapturedPropertyDetailsByAddress:
      "findUserCapturedPropertyDetailsByAddress" as const,
    FollowedListings: "FollowedListings" as const,
    GetBOAByShareLinkToken: "GetBOAByShareLinkToken" as const,
    getBOAShareLinks: "getBOAShareLinks" as const,
    getBusinessOverviewOfferDetails: "getBusinessOverviewOfferDetails" as const,
    GetBuyerOfferAnalysis: "GetBuyerOfferAnalysis" as const,
    getIngestionDocumentReviews: "getIngestionDocumentReviews" as const,
    getIngestionDocumentValidationErrorReviews:
      "getIngestionDocumentValidationErrorReviews" as const,
    getIngestionFolderValidationErrorReviews:
      "getIngestionFolderValidationErrorReviews" as const,
    GetInviteeDetailByCode: "GetInviteeDetailByCode" as const,
    getListingPricingEvaluationStatus:
      "getListingPricingEvaluationStatus" as const,
    getListingReport: "getListingReport" as const,
    getListingReportByShareLinkToken:
      "getListingReportByShareLinkToken" as const,
    getListingReportPdf: "getListingReportPdf" as const,
    getListingReportShareLinks: "getListingReportShareLinks" as const,
    getOfferForBuyersAgent: "getOfferForBuyersAgent" as const,
    getOfferForListingAgent: "getOfferForListingAgent" as const,
    GetOfferRecs: "GetOfferRecs" as const,
    getOfferScorecardsForAgent: "getOfferScorecardsForAgent" as const,
    getOfferScorecardsForOrg: "getOfferScorecardsForOrg" as const,
    getOfferScorecardsMetricsForOrg: "getOfferScorecardsMetricsForOrg" as const,
    getPropertyDetails: "getPropertyDetails" as const,
    getSingleUserCapturedPropertyDetails:
      "getSingleUserCapturedPropertyDetails" as const,
    getUserCapturedPropertyDetails: "getUserCapturedPropertyDetails" as const,
    getUserCapturedPropertyDetailsByToken:
      "getUserCapturedPropertyDetailsByToken" as const,
    GetUserTours: "GetUserTours" as const,
    HasSignedListingGuestbook: "HasSignedListingGuestbook" as const,
    indigoContractsForCurrentUser: "indigoContractsForCurrentUser" as const,
    initiateListingPricingEvaluation:
      "initiateListingPricingEvaluation" as const,
    integrationConnectionsForOrganization:
      "integrationConnectionsForOrganization" as const,
    internalEssentialsNotificationFolderDebug:
      "internalEssentialsNotificationFolderDebug" as const,
    internalEssentialsNotificationLogDebug:
      "internalEssentialsNotificationLogDebug" as const,
    internalEssentialsNotificationLogs:
      "internalEssentialsNotificationLogs" as const,
    internalGetIngestionDocument: "internalGetIngestionDocument" as const,
    internalOrganizationUsers: "internalOrganizationUsers" as const,
    invitationsList: "invitationsList" as const,
    IsFollowingListing: "IsFollowingListing" as const,
    IsOpenHouseGuestBookSigned: "IsOpenHouseGuestBookSigned" as const,
    latestUnsubmittedOfferForBuyersAgent:
      "latestUnsubmittedOfferForBuyersAgent" as const,
    Listing: "Listing" as const,
    ListingActivities: "ListingActivities" as const,
    ListingAndOffers: "ListingAndOffers" as const,
    listingAnnouncements: "listingAnnouncements" as const,
    listingAnnouncementsCount: "listingAnnouncementsCount" as const,
    listingComparableSet: "listingComparableSet" as const,
    listingComparableSetForAgent: "listingComparableSetForAgent" as const,
    listingComparableSetForBOAToken: "listingComparableSetForBOAToken" as const,
    listingComparableSetForBuyerOfferAnalysis:
      "listingComparableSetForBuyerOfferAnalysis" as const,
    listingComparableSetForReportToken:
      "listingComparableSetForReportToken" as const,
    listingDocumentTypes: "listingDocumentTypes" as const,
    listingDocumentUploads: "listingDocumentUploads" as const,
    ListingFollowers: "ListingFollowers" as const,
    ListingforMLSListing: "ListingforMLSListing" as const,
    ListingOpenHouses: "ListingOpenHouses" as const,
    ListingsForCurrentUser: "ListingsForCurrentUser" as const,
    ListingsForOrganization: "ListingsForOrganization" as const,
    notificationLogAutofillVariablesSchema:
      "notificationLogAutofillVariablesSchema" as const,
    notificationLogAutofillValues: "notificationLogAutofillValues" as const,
    GetUserNotificationSettings: "GetUserNotificationSettings" as const,
    NotificationTemplate: "NotificationTemplate" as const,
    NotificationTemplatesList: "NotificationTemplatesList" as const,
    offerAutofillValues: "offerAutofillValues" as const,
    offerMetrics: "offerMetrics" as const,
    offersForCurentUser: "offersForCurentUser" as const,
    OpenHousesForCurrentUser: "OpenHousesForCurrentUser" as const,
    OpenHouse: "OpenHouse" as const,
    OrgListingAggDeltaByStatus: "OrgListingAggDeltaByStatus" as const,
    orgTransactionStatsByZipCode: "orgTransactionStatsByZipCode" as const,
    organizationCrawlerInfo: "organizationCrawlerInfo" as const,
    OrganizationListingAggregatesByStatus:
      "OrganizationListingAggregatesByStatus" as const,
    OrganizationOfficesAndTeams: "OrganizationOfficesAndTeams" as const,
    OrganizationPartnerStageIntros: "OrganizationPartnerStageIntros" as const,
    OrganizationPartners: "OrganizationPartners" as const,
    OrganizationRosterList: "OrganizationRosterList" as const,
    organizationsForCurrentUser: "organizationsForCurrentUser" as const,
    PartnerContactsList: "PartnerContactsList" as const,
    PartyAndBuyerInfo: "PartyAndBuyerInfo" as const,
    partyVariableValues: "partyVariableValues" as const,
    perAgentOfferAcceptRate: "perAgentOfferAcceptRate" as const,
    perAgentTransactionStats: "perAgentTransactionStats" as const,
    perOfficeOfferAcceptRate: "perOfficeOfferAcceptRate" as const,
    perOfficeTransactionStats: "perOfficeTransactionStats" as const,
    Preferences: "Preferences" as const,
    PrioritizedListingsForCurrentUser:
      "PrioritizedListingsForCurrentUser" as const,
    publicFeaturedStorefronts: "publicFeaturedStorefronts" as const,
    PublicListing: "PublicListing" as const,
    publicListingAnnouncements: "publicListingAnnouncements" as const,
    publicListingComparableSet: "publicListingComparableSet" as const,
    publicListingDocumentTypes: "publicListingDocumentTypes" as const,
    publicListingDocumentUploads: "publicListingDocumentUploads" as const,
    PublicPreferences: "PublicPreferences" as const,
    PublicAgentUserListings: "PublicAgentUserListings" as const,
    PublicUserWithLicenses: "PublicUserWithLicenses" as const,
    SearchMlsListingsByAddress: "SearchMlsListingsByAddress" as const,
    SearchMlsListingsWithFilters: "SearchMlsListingsWithFilters" as const,
    StorefrontActivities: "StorefrontActivities" as const,
    StorefrontActivitiesSummary: "StorefrontActivitiesSummary" as const,
    StorefrontDocViewsSummary: "StorefrontDocViewsSummary" as const,
    GuestbookSigners: "GuestbookSigners" as const,
    transactionNotificationLog: "transactionNotificationLog" as const,
    transactionNotificationLogs: "transactionNotificationLogs" as const,
    zipCodesGeo: "zipCodesGeo" as const,
  },
  Mutation: {
    AddOrUpdateDisclosureContractDocuments:
      "AddOrUpdateDisclosureContractDocuments" as const,
    AddOrUpdatePreapprovalContractDocument:
      "AddOrUpdatePreapprovalContractDocument" as const,
    copyComplianceKeyTermSections: "copyComplianceKeyTermSections" as const,
    copyFieldsFromPreviousVersion: "copyFieldsFromPreviousVersion" as const,
    copyTransactionRules: "copyTransactionRules" as const,
    createAutofill: "createAutofill" as const,
    createClassificationEvalFromIngestionDocument:
      "createClassificationEvalFromIngestionDocument" as const,
    createComplianceKeyTermSection: "createComplianceKeyTermSection" as const,
    createContract: "createContract" as const,
    createDefaultSecondaryDocument: "createDefaultSecondaryDocument" as const,
    createDocument: "createDocument" as const,
    CreateDocumentLLM: "CreateDocumentLLM" as const,
    CreateDocumentLLMExample: "CreateDocumentLLMExample" as const,
    CreateDocumentLLMExamples: "CreateDocumentLLMExamples" as const,
    createDocumentSection: "createDocumentSection" as const,
    createDocumentVersion: "createDocumentVersion" as const,
    createDocumentVersionFields: "createDocumentVersionFields" as const,
    createEmbeddedSignUrl: "createEmbeddedSignUrl" as const,
    createFallbackContract: "createFallbackContract" as const,
    createField: "createField" as const,
    CreateOrUpdateDocumentClassificationEvaluation:
      "CreateOrUpdateDocumentClassificationEvaluation" as const,
    DeleteDocumentClassificationEvaluation:
      "DeleteDocumentClassificationEvaluation" as const,
    EvaluateDocumentClassification: "EvaluateDocumentClassification" as const,
    PreviewExtractedFieldsFromEvaluation:
      "PreviewExtractedFieldsFromEvaluation" as const,
    SaveExtractedFieldsFromEvaluation:
      "SaveExtractedFieldsFromEvaluation" as const,
    BulkEvaluateDocumentClassifications:
      "BulkEvaluateDocumentClassifications" as const,
    CreateOrUpdateDocumentLLMEvaluation:
      "CreateOrUpdateDocumentLLMEvaluation" as const,
    createRule: "createRule" as const,
    createTransactionPipeline: "createTransactionPipeline" as const,
    CropCheckboxImages: "CropCheckboxImages" as const,
    deleteComplianceGroupTransactionStage:
      "deleteComplianceGroupTransactionStage" as const,
    deleteComplianceKeyTermSection: "deleteComplianceKeyTermSection" as const,
    DeleteContractDocuments: "DeleteContractDocuments" as const,
    deleteDefaultSecondaryDocument: "deleteDefaultSecondaryDocument" as const,
    deleteDocument: "deleteDocument" as const,
    DeleteDocumentLLM: "DeleteDocumentLLM" as const,
    DeleteDocumentLLMEvaluation: "DeleteDocumentLLMEvaluation" as const,
    DeleteDocumentLLMExample: "DeleteDocumentLLMExample" as const,
    deleteDocumentSection: "deleteDocumentSection" as const,
    deleteDocumentVersion: "deleteDocumentVersion" as const,
    deleteDocumentVersionFields: "deleteDocumentVersionFields" as const,
    deleteField: "deleteField" as const,
    deletePreapprovalContractDocument:
      "deletePreapprovalContractDocument" as const,
    deleteRule: "deleteRule" as const,
    deleteTransactionRule: "deleteTransactionRule" as const,
    deleteTransactionStage: "deleteTransactionStage" as const,
    detectFormFields: "detectFormFields" as const,
    detectFormFieldsForDocumentVersion:
      "detectFormFieldsForDocumentVersion" as const,
    externalCreateComplianceMessageHistory:
      "externalCreateComplianceMessageHistory" as const,
    ExternalCreateErrorReport: "ExternalCreateErrorReport" as const,
    externalDeleteDarwinCompanyOfficeMapping:
      "externalDeleteDarwinCompanyOfficeMapping" as const,
    ExternalOverrideKeyTermsForIngestionFolder:
      "ExternalOverrideKeyTermsForIngestionFolder" as const,
    externalSaveDarwinCompanyOfficeMapping:
      "externalSaveDarwinCompanyOfficeMapping" as const,
    ExternalSubmitErrorReportContext:
      "ExternalSubmitErrorReportContext" as const,
    externalSyncDarwinFees: "externalSyncDarwinFees" as const,
    ExternalSyncDarwinSelection: "ExternalSyncDarwinSelection" as const,
    ExternalSyncDarwinVendors: "ExternalSyncDarwinVendors" as const,
    ExternalUpdateIngestionDocumentStatus:
      "ExternalUpdateIngestionDocumentStatus" as const,
    extractContract: "extractContract" as const,
    extractPreapprovalInfo: "extractPreapprovalInfo" as const,
    InternalCreateOrUpdateIngestionDocumentValidationFeedback:
      "InternalCreateOrUpdateIngestionDocumentValidationFeedback" as const,
    InternalCreateOrUpdateIngestionFolderValidationFeedback:
      "InternalCreateOrUpdateIngestionFolderValidationFeedback" as const,
    LabelIngestionDocumentClassification:
      "LabelIngestionDocumentClassification" as const,
    produceStageChangedEvents: "produceStageChangedEvents" as const,
    ReassignIngestionFolderPipelines:
      "ReassignIngestionFolderPipelines" as const,
    RunIngestionDocumentValidationLlmAsJudge:
      "RunIngestionDocumentValidationLlmAsJudge" as const,
    SaveCheckboxExportDataset: "SaveCheckboxExportDataset" as const,
    saveComplianceGroupTransactionStageByType:
      "saveComplianceGroupTransactionStageByType" as const,
    SaveSignatureInitialDataset: "SaveSignatureInitialDataset" as const,
    SaveSignatureInitialValidations: "SaveSignatureInitialValidations" as const,
    setDocumentVersionAsActive: "setDocumentVersionAsActive" as const,
    syncAcroformToDocumentVersionFields:
      "syncAcroformToDocumentVersionFields" as const,
    syncSecondaryDocumentVersions: "syncSecondaryDocumentVersions" as const,
    syncAllTransactionPipelinesToProduction:
      "syncAllTransactionPipelinesToProduction" as const,
    TriggerBatchValidationRerun: "TriggerBatchValidationRerun" as const,
    updateAutofill: "updateAutofill" as const,
    UpdateCheckboxDataset: "UpdateCheckboxDataset" as const,
    updateComplianceKeyTermSectionFields:
      "updateComplianceKeyTermSectionFields" as const,
    updateComplianceKeyTermSections: "updateComplianceKeyTermSections" as const,
    updateComplianceKeyTermSectionsOrder:
      "updateComplianceKeyTermSectionsOrder" as const,
    updateContract: "updateContract" as const,
    UpdateContractDocumentCustomFields:
      "UpdateContractDocumentCustomFields" as const,
    updateContractDocuments: "updateContractDocuments" as const,
    updateDefaultSecondaryDocuments: "updateDefaultSecondaryDocuments" as const,
    updateDocument: "updateDocument" as const,
    UpdateDocumentLLM: "UpdateDocumentLLM" as const,
    updateDocumentSectionFields: "updateDocumentSectionFields" as const,
    updateDocumentSections: "updateDocumentSections" as const,
    updateDocumentSectionsOrder: "updateDocumentSectionsOrder" as const,
    updateDocumentVersion: "updateDocumentVersion" as const,
    updateDocumentVersionFields: "updateDocumentVersionFields" as const,
    updateField: "updateField" as const,
    updateOrCreateFieldsToColumn: "updateOrCreateFieldsToColumn" as const,
    updateOrCreateTransactionRule: "updateOrCreateTransactionRule" as const,
    updateOrCreateTransactionStage: "updateOrCreateTransactionStage" as const,
    updateOrganizationFolderNameValidationStageOverride:
      "updateOrganizationFolderNameValidationStageOverride" as const,
    updateOrganizationValidationSettings:
      "updateOrganizationValidationSettings" as const,
    updateRule: "updateRule" as const,
    UpdateRulesForTransactionRule: "UpdateRulesForTransactionRule" as const,
    updateSecondaryDocumentVersion: "updateSecondaryDocumentVersion" as const,
    UpdateSignatureInitialsDataset: "UpdateSignatureInitialsDataset" as const,
    updateSortOrder: "updateSortOrder" as const,
    updateTransactionRuleParent: "updateTransactionRuleParent" as const,
    ValidateTransactionPipeline: "ValidateTransactionPipeline" as const,
    validateTransactionRuleOnProduction:
      "validateTransactionRuleOnProduction" as const,
    UpdateOfferWithParty: "UpdateOfferWithParty" as const,
    acceptAccessControlInvite: "acceptAccessControlInvite" as const,
    accessControlInvite: "accessControlInvite" as const,
    calculateOfferScore: "calculateOfferScore" as const,
    capturePropertyDetails: "capturePropertyDetails" as const,
    CreateContact: "CreateContact" as const,
    UpdateContact: "UpdateContact" as const,
    createAIConversation: "createAIConversation" as const,
    CreateBuyerOfferAnalysis: "CreateBuyerOfferAnalysis" as const,
    CreateBuyerOfferAnalysisForUser: "CreateBuyerOfferAnalysisForUser" as const,
    createEmbeddedSignatureRequest: "createEmbeddedSignatureRequest" as const,
    CreateEventForOffer: "CreateEventForOffer" as const,
    createIndigoContract: "createIndigoContract" as const,
    CreateNotificationTemplate: "CreateNotificationTemplate" as const,
    createOffer: "createOffer" as const,
    createOrUpdateIngestionDocumentReview:
      "createOrUpdateIngestionDocumentReview" as const,
    createOrUpdateIngestionDocumentValidationErrorReview:
      "createOrUpdateIngestionDocumentValidationErrorReview" as const,
    createOrUpdateIngestionFolderValidationErrorReview:
      "createOrUpdateIngestionFolderValidationErrorReview" as const,
    createOrUpdateListingAnnouncement:
      "createOrUpdateListingAnnouncement" as const,
    createOrUpdateListingComparableAdjustment:
      "createOrUpdateListingComparableAdjustment" as const,
    createOrUpdateListingComparableAdjustmentV2:
      "createOrUpdateListingComparableAdjustmentV2" as const,
    createOrganizationForAgent: "createOrganizationForAgent" as const,
    createOrganizationForTeamLead: "createOrganizationForTeamLead" as const,
    CreatePartyForBuyersAgent: "CreatePartyForBuyersAgent" as const,
    createUserTour: "createUserTour" as const,
    deleteAIConversation: "deleteAIConversation" as const,
    deleteAccessControl: "deleteAccessControl" as const,
    deleteContractSystemCredentials: "deleteContractSystemCredentials" as const,
    deleteIngestionDocumentValidationErrorReview:
      "deleteIngestionDocumentValidationErrorReview" as const,
    deleteIngestionFolderValidationErrorReview:
      "deleteIngestionFolderValidationErrorReview" as const,
    deleteIntegrationConnection: "deleteIntegrationConnection" as const,
    deleteListingDocuments: "deleteListingDocuments" as const,
    DeleteNotificationTemplate: "DeleteNotificationTemplate" as const,
    ExternalCreateOrUpdateIngestionDocumentValidationFeedback:
      "ExternalCreateOrUpdateIngestionDocumentValidationFeedback" as const,
    ExternalCreateOrUpdateIngestionFolderValidationFeedback:
      "ExternalCreateOrUpdateIngestionFolderValidationFeedback" as const,
    ExternalSubmitValidationReviews: "ExternalSubmitValidationReviews" as const,
    ExternalSyncKeyTerms: "ExternalSyncKeyTerms" as const,
    followListing: "followListing" as const,
    GenerateListingPackagePdf: "GenerateListingPackagePdf" as const,
    GetOrCreateAgentByPhoneNumber: "GetOrCreateAgentByPhoneNumber" as const,
    GetOrCreateConsumerByPhoneNumber:
      "GetOrCreateConsumerByPhoneNumber" as const,
    internalBatchAddUsersToOrganization:
      "internalBatchAddUsersToOrganization" as const,
    internalEssentialsNotificationActionExecute:
      "internalEssentialsNotificationActionExecute" as const,
    internalEssentialsNotificationActionPreview:
      "internalEssentialsNotificationActionPreview" as const,
    joinOrganization: "joinOrganization" as const,
    UpdateUserNotificationSettings: "UpdateUserNotificationSettings" as const,
    CreateOpenHouse: "CreateOpenHouse" as const,
    UpdateOpenHouse: "UpdateOpenHouse" as const,
    DeleteOpenHouse: "DeleteOpenHouse" as const,
    CreateOrganizationPartner: "CreateOrganizationPartner" as const,
    UpdateOrganizationPartner: "UpdateOrganizationPartner" as const,
    UpsertOrganizationPartnerStageIntro:
      "UpsertOrganizationPartnerStageIntro" as const,
    DeleteOrganizationPartnerStageIntro:
      "DeleteOrganizationPartnerStageIntro" as const,
    UpdateOrCreateOrganizationRosterPreference:
      "UpdateOrCreateOrganizationRosterPreference" as const,
    UpdateOrganizationRosterEntry: "UpdateOrganizationRosterEntry" as const,
    CreateOrganizationRosterEntry: "CreateOrganizationRosterEntry" as const,
    AddLoanOfficerContact: "AddLoanOfficerContact" as const,
    AddTitleAgentContact: "AddTitleAgentContact" as const,
    AddInsuranceAgentContact: "AddInsuranceAgentContact" as const,
    UpdatePartnerContact: "UpdatePartnerContact" as const,
    DeleteContact: "DeleteContact" as const,
    PublishNotificationTemplates: "PublishNotificationTemplates" as const,
    QueueAnalyzeForOfferIngestionJob:
      "QueueAnalyzeForOfferIngestionJob" as const,
    removeDryRunNotificationLogs: "removeDryRunNotificationLogs" as const,
    ReorderNotificationTemplates: "ReorderNotificationTemplates" as const,
    ResendBOAShareLink: "ResendBOAShareLink" as const,
    resendListingReportShareLink: "resendListingReportShareLink" as const,
    RevokeBOAShareLink: "RevokeBOAShareLink" as const,
    revokeInvitation: "revokeInvitation" as const,
    revokeListingReportShareLink: "revokeListingReportShareLink" as const,
    sendBOAShareLink: "sendBOAShareLink" as const,
    SendComplianceSummaryNotification:
      "SendComplianceSummaryNotification" as const,
    sendListingReportShareLink: "sendListingReportShareLink" as const,
    sendOTPFromInvitationLink: "sendOTPFromInvitationLink" as const,
    sendSellerInvitation: "sendSellerInvitation" as const,
    sendSignatureRequestToBuyersForOffer:
      "sendSignatureRequestToBuyersForOffer" as const,
    SendTestNotification: "SendTestNotification" as const,
    ShareStorefrontWithBuyer: "ShareStorefrontWithBuyer" as const,
    signListingGuestbook: "signListingGuestbook" as const,
    SignOpenHouseGuestbook: "SignOpenHouseGuestbook" as const,
    SignUpConsumer: "SignUpConsumer" as const,
    signUpAgent: "signUpAgent" as const,
    signUpAgentV2: "signUpAgentV2" as const,
    submitOfferForBuyersAgent: "submitOfferForBuyersAgent" as const,
    SubmitOfferToNonIndigoListingAgent:
      "SubmitOfferToNonIndigoListingAgent" as const,
    trackListingDocumentAction: "trackListingDocumentAction" as const,
    unfollowListing: "unfollowListing" as const,
    updateAIConversation: "updateAIConversation" as const,
    UpdateBuyerOfferAnalysis: "UpdateBuyerOfferAnalysis" as const,
    updateIndigoContract: "updateIndigoContract" as const,
    updateListingComparableSet: "updateListingComparableSet" as const,
    updateListingComparableSetForAgent:
      "updateListingComparableSetForAgent" as const,
    UpdateListingComparableSetForBuyerOfferAnalysis:
      "UpdateListingComparableSetForBuyerOfferAnalysis" as const,
    updateListingPreference: "updateListingPreference" as const,
    UpdateNotificationTemplate: "UpdateNotificationTemplate" as const,
    updateOfferForBuyersAgent: "updateOfferForBuyersAgent" as const,
    updateOrCreateContractSystemCredentials:
      "updateOrCreateContractSystemCredentials" as const,
    UpdatePartyForBuyersAgent: "UpdatePartyForBuyersAgent" as const,
    updatePropertyDetails: "updatePropertyDetails" as const,
    UpdateStorefrontSetup: "UpdateStorefrontSetup" as const,
    updateUser: "updateUser" as const,
    updateUserSettings: "updateUserSettings" as const,
    uploadAndExtractAgentNegotiationDocuments:
      "uploadAndExtractAgentNegotiationDocuments" as const,
    uploadListingDocument: "uploadListingDocument" as const,
    uploadOfferAsListingAgent: "uploadOfferAsListingAgent" as const,
    uploadOfferForBuyersAgent: "uploadOfferForBuyersAgent" as const,
    VerifyShareLink: "VerifyShareLink" as const,
  },
  Fragment: {
    VariableField: "VariableField" as const,
    Autofill: "Autofill" as const,
    ComplianceKeyTermSectionField: "ComplianceKeyTermSectionField" as const,
    ComplianceKeyTermSection: "ComplianceKeyTermSection" as const,
    ContractDetail: "ContractDetail" as const,
    ContractDocumentForContract: "ContractDocumentForContract" as const,
    ContractValidation: "ContractValidation" as const,
    DefaultSecondaryDocument: "DefaultSecondaryDocument" as const,
    Document: "Document" as const,
    DocumentAssetFile: "DocumentAssetFile" as const,
    DocumentClassificationEvaluation:
      "DocumentClassificationEvaluation" as const,
    ClassificationAlternativeCandidate:
      "ClassificationAlternativeCandidate" as const,
    ExtractSchema: "ExtractSchema" as const,
    DocumentLLM: "DocumentLLM" as const,
    DocumentLLMEvaluation: "DocumentLLMEvaluation" as const,
    DocumentLLMExample: "DocumentLLMExample" as const,
    DocumentSection: "DocumentSection" as const,
    DocumentVersion: "DocumentVersion" as const,
    DocumentVersionField: "DocumentVersionField" as const,
    PublicDocumentVersionField: "PublicDocumentVersionField" as const,
    Field: "Field" as const,
    PublicField: "PublicField" as const,
    FieldDetail: "FieldDetail" as const,
    FieldsToColumn: "FieldsToColumn" as const,
    IngestionDocument: "IngestionDocument" as const,
    IngestionDocumentWithContracts: "IngestionDocumentWithContracts" as const,
    IngestionFolder: "IngestionFolder" as const,
    InternalIngestionFolderListRow: "InternalIngestionFolderListRow" as const,
    MLSListingSelectionInfo: "MLSListingSelectionInfo" as const,
    OrganizationFolderNameValidationStageOverride:
      "OrganizationFolderNameValidationStageOverride" as const,
    PageInfo: "PageInfo" as const,
    Rule: "Rule" as const,
    GenericRuleValidation: "GenericRuleValidation" as const,
    SecondaryDocumentVersion: "SecondaryDocumentVersion" as const,
    SignatureFormField: "SignatureFormField" as const,
    SignatureRequest: "SignatureRequest" as const,
    TransactionPipeline: "TransactionPipeline" as const,
    RuleCompact: "RuleCompact" as const,
    TransactionRule: "TransactionRule" as const,
    TransactionStage: "TransactionStage" as const,
    InputFormat: "InputFormat" as const,
    BoundingBox: "BoundingBox" as const,
    DetectFormFields: "DetectFormFields" as const,
    ExtractContractMutation: "ExtractContractMutation" as const,
    DocumentValidationResult: "DocumentValidationResult" as const,
    PipelineValidationResult: "PipelineValidationResult" as const,
    ComplianceKeyTermSectionList: "ComplianceKeyTermSectionList" as const,
    ContractFieldValues: "ContractFieldValues" as const,
    DocumentList: "DocumentList" as const,
    PublicDocumentForOfferFlow: "PublicDocumentForOfferFlow" as const,
    DocumentForOfferFlow: "DocumentForOfferFlow" as const,
    DocumentSectionList: "DocumentSectionList" as const,
    DocumentSectionListForOfferFlowField:
      "DocumentSectionListForOfferFlowField" as const,
    DocumentSectionListForOfferFlow: "DocumentSectionListForOfferFlow" as const,
    DocumentVersionListField: "DocumentVersionListField" as const,
    DocumentVersionList: "DocumentVersionList" as const,
    PublicDocumentVersionForOfferFlow:
      "PublicDocumentVersionForOfferFlow" as const,
    DocumentVersionForOfferFlow: "DocumentVersionForOfferFlow" as const,
    EmbeddedSignatureRequestSecondaryDocument:
      "EmbeddedSignatureRequestSecondaryDocument" as const,
    EmbeddedSignatureRequest: "EmbeddedSignatureRequest" as const,
    ExternalDarwinPropertyFields: "ExternalDarwinPropertyFields" as const,
    IngestionFolderList: "IngestionFolderList" as const,
    IngestionFolderListForEssentials:
      "IngestionFolderListForEssentials" as const,
    IngestionFolderForPipelineView: "IngestionFolderForPipelineView" as const,
    RulesOverviewRule: "RulesOverviewRule" as const,
    TransactionPipelineList: "TransactionPipelineList" as const,
    AIConversation: "AIConversation" as const,
    AccessControl: "AccessControl" as const,
    Activity: "Activity" as const,
    AppEvent: "AppEvent" as const,
    BusinessOverviewStat: "BusinessOverviewStat" as const,
    BizOverviewOffer: "BizOverviewOffer" as const,
    GetOfferMetadata: "GetOfferMetadata" as const,
    AgentContingencyOfferRec: "AgentContingencyOfferRec" as const,
    AgentKeyTermsOfferRec: "AgentKeyTermsOfferRec" as const,
    CompetitivenessAdjustment: "CompetitivenessAdjustment" as const,
    AgentOfferRecs: "AgentOfferRecs" as const,
    BuyerOfferAnalysis: "BuyerOfferAnalysis" as const,
    TeamLeadOfferScorecardRow: "TeamLeadOfferScorecardRow" as const,
    Consumer: "Consumer" as const,
    Contact: "Contact" as const,
    ContractDocument: "ContractDocument" as const,
    ExternalIngestionFolderListRow: "ExternalIngestionFolderListRow" as const,
    GuestbookSigner: "GuestbookSigner" as const,
    IngestionDocumentReview: "IngestionDocumentReview" as const,
    DebugLogIdentity: "DebugLogIdentity" as const,
    DebugLogLifecycle: "DebugLogLifecycle" as const,
    DebugTemplateSource: "DebugTemplateSource" as const,
    DebugStageIntroSource: "DebugStageIntroSource" as const,
    DebugPartnerConfig: "DebugPartnerConfig" as const,
    DebugRecipientContact: "DebugRecipientContact" as const,
    DebugRawRecipient: "DebugRawRecipient" as const,
    DebugRecipientResolution: "DebugRecipientResolution" as const,
    DebugRoutingDecision: "DebugRoutingDecision" as const,
    DebugRoutingDecisions: "DebugRoutingDecisions" as const,
    DebugAutofillRendering: "DebugAutofillRendering" as const,
    DebugDelivery: "DebugDelivery" as const,
    InternalEssentialsNotificationLogDebug:
      "InternalEssentialsNotificationLogDebug" as const,
    SimulationCandidateResult: "SimulationCandidateResult" as const,
    InternalEssentialsNotificationLogItem:
      "InternalEssentialsNotificationLogItem" as const,
    Invitation: "Invitation" as const,
    Listing: "Listing" as const,
    ListingStatus: "ListingStatus" as const,
    ListingAnnouncement: "ListingAnnouncement" as const,
    ListingComparableAdjustments: "ListingComparableAdjustments" as const,
    ListingComparable: "ListingComparable" as const,
    ListingComparableSet: "ListingComparableSet" as const,
    ListingDocumentUpload: "ListingDocumentUpload" as const,
    ListingDocumentType: "ListingDocumentType" as const,
    ListingDocumentTypeWithDocuments:
      "ListingDocumentTypeWithDocuments" as const,
    ListingFollower: "ListingFollower" as const,
    ChartTrend: "ChartTrend" as const,
    ChartMetric: "ChartMetric" as const,
    ChartDataPoint: "ChartDataPoint" as const,
    ChartData: "ChartData" as const,
    ChartCard: "ChartCard" as const,
    TableColumn: "TableColumn" as const,
    OffersByFinancingTypeTableRow: "OffersByFinancingTypeTableRow" as const,
    TableRow: "TableRow" as const,
    TableData: "TableData" as const,
    ReportConfidence: "ReportConfidence" as const,
    ListingReportResponse: "ListingReportResponse" as const,
    NotificationTemplate: "NotificationTemplate" as const,
    NotificationTemplateDetails: "NotificationTemplateDetails" as const,
    NotificationTemplateListItem: "NotificationTemplateListItem" as const,
    Offer: "Offer" as const,
    IndigoOffersSource: "IndigoOffersSource" as const,
    CompsSource: "CompsSource" as const,
    MLSSource: "MLSSource" as const,
    MarketDataSource: "MarketDataSource" as const,
    KeyTerm: "KeyTerm" as const,
    KeyTermError: "KeyTermError" as const,
    KeyTermResult: "KeyTermResult" as const,
    ContingencyError: "ContingencyError" as const,
    Contingency: "Contingency" as const,
    ContingencyResult: "ContingencyResult" as const,
    PriceAnalysis: "PriceAnalysis" as const,
    CompetitivenessMetrics: "CompetitivenessMetrics" as const,
    CompetitivenessScore: "CompetitivenessScore" as const,
    OfferScore: "OfferScore" as const,
    OfferScoreResult: "OfferScoreResult" as const,
    OfferRecs: "OfferRecs" as const,
    OrganizationPartnerItem: "OrganizationPartnerItem" as const,
    OrganizationPartnerStageIntroItem:
      "OrganizationPartnerStageIntroItem" as const,
    OrganizationRosterItem: "OrganizationRosterItem" as const,
    PartnerContactBase: "PartnerContactBase" as const,
    PartnerContact: "PartnerContact" as const,
    Party: "Party" as const,
    PreferenceValue: "PreferenceValue" as const,
    Preference: "Preference" as const,
    Property: "Property" as const,
    GetPropertyDetailsSuccess: "GetPropertyDetailsSuccess" as const,
    GetPropertyDetailsFailed: "GetPropertyDetailsFailed" as const,
    GetPropertyDetailsResult: "GetPropertyDetailsResult" as const,
    Address: "Address" as const,
    Geo: "Geo" as const,
    Location: "Location" as const,
    PropertyDetails: "PropertyDetails" as const,
    RESOMember: "RESOMember" as const,
    RESOOffice: "RESOOffice" as const,
    ShareLink: "ShareLink" as const,
    StorefrontActivitySummary: "StorefrontActivitySummary" as const,
    TransactionNotificationLog: "TransactionNotificationLog" as const,
    User: "User" as const,
    UserSettings: "UserSettings" as const,
    ValidationReviewSubmission: "ValidationReviewSubmission" as const,
    MLSListingContact: "MLSListingContact" as const,
    MLSListingAgentObject: "MLSListingAgentObject" as const,
    MLSListingProperty: "MLSListingProperty" as const,
    MLSListingMLS: "MLSListingMLS" as const,
    MLSListingAssociation: "MLSListingAssociation" as const,
    MLSListingCompliance: "MLSListingCompliance" as const,
    MLSListingAddress: "MLSListingAddress" as const,
    MLSListingSales: "MLSListingSales" as const,
    MLSListingGeo: "MLSListingGeo" as const,
    MLSListingOffice: "MLSListingOffice" as const,
    MLSListingSearchResult: "MLSListingSearchResult" as const,
    MLSListing: "MLSListing" as const,
    OpenHouseCard: "OpenHouseCard" as const,
    PublicOpenHouse: "PublicOpenHouse" as const,
    PublicListing: "PublicListing" as const,
    PublicListingPriceHistory: "PublicListingPriceHistory" as const,
    PublicListingStatus: "PublicListingStatus" as const,
    PublicListingAnnouncement: "PublicListingAnnouncement" as const,
    PublicListingComparable: "PublicListingComparable" as const,
    PublicListingComparableSet: "PublicListingComparableSet" as const,
    PublicListingDocumentUpload: "PublicListingDocumentUpload" as const,
    PublicListingDocumentType: "PublicListingDocumentType" as const,
    PublicListingDocumentTypeWithDocuments:
      "PublicListingDocumentTypeWithDocuments" as const,
    PublicPreferenceValue: "PublicPreferenceValue" as const,
    PublicPreference: "PublicPreference" as const,
    PublicStorefrontConfigurationStatusObject:
      "PublicStorefrontConfigurationStatusObject" as const,
    PublicUser: "PublicUser" as const,
    PublicUserListing: "PublicUserListing" as const,
    PublicUserWithLicenses: "PublicUserWithLicenses" as const,
    ActiveIntegrationClient: "ActiveIntegrationClient" as const,
    MLSObjectForAllMLSes: "MLSObjectForAllMLSes" as const,
    AuditEssentialsNotification: "AuditEssentialsNotification" as const,
    AutofillConsumer: "AutofillConsumer" as const,
    CurrentUser: "CurrentUser" as const,
    FindMLSAgent: "FindMLSAgent" as const,
    ListingPricingEvaluation: "ListingPricingEvaluation" as const,
    IndigoContractsForCurrentUser: "IndigoContractsForCurrentUser" as const,
    OfferContract: "OfferContract" as const,
    OffersForListing: "OffersForListing" as const,
    ListingForOrganization: "ListingForOrganization" as const,
    OffersForCurrentUser: "OffersForCurrentUser" as const,
    OpenHouseForCurrentUser: "OpenHouseForCurrentUser" as const,
    OrganizationCrawlerInfo: "OrganizationCrawlerInfo" as const,
    Organization: "Organization" as const,
    PerAgentOfferAcceptRate: "PerAgentOfferAcceptRate" as const,
    PerAgentTransactionStats: "PerAgentTransactionStats" as const,
    PerOfficeOfferAcceptRate: "PerOfficeOfferAcceptRate" as const,
    PerOfficeTransactionStats: "PerOfficeTransactionStats" as const,
    PrioritizedListing: "PrioritizedListing" as const,
    PublicFeaturedStorefront: "PublicFeaturedStorefront" as const,
    ListingForSearchMlsListing: "ListingForSearchMlsListing" as const,
    IngestionFolderProperty: "IngestionFolderProperty" as const,
    IngestionFolderAutofillData: "IngestionFolderAutofillData" as const,
    IngestionDocumentValidation: "IngestionDocumentValidation" as const,
    IngestionFolderValidation: "IngestionFolderValidation" as const,
    KeyTermField: "KeyTermField" as const,
    KeyTermChildSection: "KeyTermChildSection" as const,
    KeyTermsSection: "KeyTermsSection" as const,
    ExternalValidationReportData: "ExternalValidationReportData" as const,
    ExternalIngestionDocument: "ExternalIngestionDocument" as const,
    ExternalIngestionFolderMLSListing:
      "ExternalIngestionFolderMLSListing" as const,
    AgentParticipant: "AgentParticipant" as const,
    ClientParticipant: "ClientParticipant" as const,
    Participants: "Participants" as const,
    ExternalIngestionFolder: "ExternalIngestionFolder" as const,
    GetIngestionDocument: "GetIngestionDocument" as const,
    InternalValidationReportData: "InternalValidationReportData" as const,
    InternalIngestionDocument: "InternalIngestionDocument" as const,
    InternalGetIngestionDocument: "InternalGetIngestionDocument" as const,
    InternalIngestionFolder: "InternalIngestionFolder" as const,
    IngestionDocumentValidationErrorReview:
      "IngestionDocumentValidationErrorReview" as const,
    IngestionFolderValidationErrorReview:
      "IngestionFolderValidationErrorReview" as const,
    IngestionFolderValidationFeedback:
      "IngestionFolderValidationFeedback" as const,
    IngestionDocumentValidationFeedback:
      "IngestionDocumentValidationFeedback" as const,
  },
};
export type EvaluateFormulaQueryVariables = Exact<{
  input: EvaluateFormulaInput;
}>;

export type EvaluateFormulaQuery = {
  __typename?: "Query";
  evaluateFormula: {
    __typename?: "EvaluateFormulaPayload";
    output?: any | undefined;
    error?: string | undefined;
  };
};

export type EvaluateFormulaBatchQueryVariables = Exact<{
  input: EvaluateFormulaBatchInput;
}>;

export type EvaluateFormulaBatchQuery = {
  __typename?: "Query";
  evaluateFormulaBatch: {
    __typename?: "EvaluateFormulaBatchPayload";
    results: Array<{
      __typename?: "EvaluateFormulaResult";
      index: number;
      output?: any | undefined;
      error?: string | undefined;
    }>;
  };
};

export type VariableFieldFragment = {
  __typename?: "VariableFieldObject";
  key: string;
  type: VariableDataType;
  source: VariableSource;
};

export type AutofillFragment = {
  __typename?: "AutofillObject";
  id: string;
  variableSources: Array<VariableSource>;
  formula?: string | undefined;
  variableField?:
    | {
        __typename?: "VariableFieldObject";
        key: string;
        type: VariableDataType;
        source: VariableSource;
      }
    | undefined;
  formulaVariableFields: Array<{
    __typename?: "VariableFieldObject";
    key: string;
    type: VariableDataType;
    source: VariableSource;
  }>;
  formulaTestCases: Array<{
    __typename?: "FormulaTestCaseObject";
    values: Record<string, string | number | boolean | string[] | undefined>;
    expected: string;
    llmOutput?: boolean | undefined;
  }>;
  documents?:
    | Array<{
        __typename?: "DocumentCompactObject";
        id: string;
        name: string;
        description: string;
        documentCategory?: DocumentCategory | undefined;
        documentType: DocumentType;
        form: string;
        usState: UsState;
      }>
    | undefined;
};

export type ComplianceKeyTermSectionFieldFragment = {
  __typename?: "ComplianceKeyTermSectionFieldObject";
  id: string;
  order: number;
  helpText?: string | undefined;
  fieldsToColumn: {
    __typename?: "FieldsToColumnObject";
    id: string;
    columnName: string;
    visibility: ColumnVisibility;
    fieldType: FieldType;
    documentCategory?: DocumentCategory | undefined;
    fields: Array<{
      __typename?: "FieldObject";
      id: string;
      group: string;
      label: string;
      displayLabel?: string | undefined;
      mappingKey: string;
      fieldType: FieldType;
      isComputed?: boolean | undefined;
      isHidden?: boolean | undefined;
      readOnly?: boolean | undefined;
      aiExtract?: boolean | undefined;
      aiInterpret?: boolean | undefined;
      comparisonType?: ComparisonType | undefined;
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
    }>;
    transformAutofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          variableSources: Array<VariableSource>;
          formula?: string | undefined;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }
            | undefined;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            type: VariableDataType;
            source: VariableSource;
          }>;
          formulaTestCases: Array<{
            __typename?: "FormulaTestCaseObject";
            values: Record<
              string,
              string | number | boolean | string[] | undefined
            >;
            expected: string;
            llmOutput?: boolean | undefined;
          }>;
          documents?:
            | Array<{
                __typename?: "DocumentCompactObject";
                id: string;
                name: string;
                description: string;
                documentCategory?: DocumentCategory | undefined;
                documentType: DocumentType;
                form: string;
                usState: UsState;
              }>
            | undefined;
        }
      | undefined;
  };
};

export type ComplianceKeyTermSectionFragment = {
  __typename?: "ComplianceKeyTermSectionObject";
  id: string;
  title: string;
  description: string;
  order: number;
  documentSectionType: DocumentSectionType;
  category: ComplianceKeyTermCategory;
  organizationUuid?: string | undefined;
  complianceKeyTermSectionFields?:
    | Array<{
        __typename?: "ComplianceKeyTermSectionFieldObject";
        id: string;
        order: number;
        helpText?: string | undefined;
        fieldsToColumn: {
          __typename?: "FieldsToColumnObject";
          id: string;
          columnName: string;
          visibility: ColumnVisibility;
          fieldType: FieldType;
          documentCategory?: DocumentCategory | undefined;
          fields: Array<{
            __typename?: "FieldObject";
            id: string;
            group: string;
            label: string;
            displayLabel?: string | undefined;
            mappingKey: string;
            fieldType: FieldType;
            isComputed?: boolean | undefined;
            isHidden?: boolean | undefined;
            readOnly?: boolean | undefined;
            aiExtract?: boolean | undefined;
            aiInterpret?: boolean | undefined;
            comparisonType?: ComparisonType | undefined;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
          }>;
          transformAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        };
      }>
    | undefined;
};

export type ContractDetailFragment = {
  __typename?: "ContractObject";
  id: string;
  fieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  signatureRequests?:
    | Array<{
        __typename?: "SignatureRequestObject";
        id: string;
        provider: SignatureProvider;
        externalId: string;
        allSignedDocument?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
  extractedValues?:
    | Array<{
        __typename?: "ExtractedValues";
        values?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        mappedValuesBBox?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        signatureInitialsBBox?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        repositionedDocumentVersionFields?:
          | Array<
              Array<{
                __typename?: "DocumentVersionFieldObject";
                id: string;
                align: FieldAlign;
                pageNumber: number;
                fontFamily: string;
                fontSize: string;
                label: string;
                readOnly?: boolean | undefined;
                width: number;
                height: number;
                x: number;
                y: number;
                mappingKey: string;
                fieldType: FieldType;
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  group: string;
                  label: string;
                  displayLabel?: string | undefined;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  aiExtract?: boolean | undefined;
                  aiInterpret?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                boundingBox: {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                };
                labelBoundingBox?:
                  | {
                      __typename?: "BoundingBoxObject";
                      left: number;
                      top: number;
                      right: number;
                      bottom: number;
                    }
                  | undefined;
                labelField?:
                  | {
                      __typename?: "LabelFieldObject";
                      height: number;
                      width: number;
                      x: number;
                      y: number;
                    }
                  | undefined;
              }>
            >
          | undefined;
      }>
    | undefined;
  documentML?:
    | {
        __typename?: "DocumentMLObject";
        id: string;
        pdfFileUrl?: string | undefined;
        documentClassification: Record<
          string,
          string | number | boolean | string[] | undefined
        >;
        documentFile: {
          __typename?: "FileObject";
          fileName: string;
          url: string;
        };
      }
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    order: number;
    externalDocumentName?: string | undefined;
    externalDocumentType?: ExternalDocumentType | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          document: {
            __typename?: "DocumentObject";
            id: string;
            form: string;
            name: string;
            documentType: DocumentType;
          };
          file?: { __typename?: "FileObject"; fileName: string; url: string };
          documentVersionFields?: Array<{
            __typename?: "DocumentVersionFieldObject";
            id: string;
            align: FieldAlign;
            pageNumber: number;
            fontFamily: string;
            fontSize: string;
            label: string;
            readOnly?: boolean | undefined;
            width: number;
            height: number;
            x: number;
            y: number;
            mappingKey: string;
            fieldType: FieldType;
            autofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  variableSources: Array<VariableSource>;
                  formula?: string | undefined;
                  variableField?:
                    | {
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }
                    | undefined;
                  formulaVariableFields: Array<{
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }>;
                  formulaTestCases: Array<{
                    __typename?: "FormulaTestCaseObject";
                    values: Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >;
                    expected: string;
                    llmOutput?: boolean | undefined;
                  }>;
                  documents?:
                    | Array<{
                        __typename?: "DocumentCompactObject";
                        id: string;
                        name: string;
                        description: string;
                        documentCategory?: DocumentCategory | undefined;
                        documentType: DocumentType;
                        form: string;
                        usState: UsState;
                      }>
                    | undefined;
                }
              | undefined;
            rules?: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              errorMessageTemplate?: string | undefined;
              focusFieldMappingKeys?: Array<string> | undefined;
              contextForLLMJudge?: string | undefined;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }>;
            field: {
              __typename?: "FieldObject";
              readOnly?: boolean | undefined;
              id: string;
              group: string;
              label: string;
              displayLabel?: string | undefined;
              mappingKey: string;
              fieldType: FieldType;
              isComputed?: boolean | undefined;
              isHidden?: boolean | undefined;
              aiExtract?: boolean | undefined;
              aiInterpret?: boolean | undefined;
              comparisonType?: ComparisonType | undefined;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    errorMessageTemplate?: string | undefined;
                    focusFieldMappingKeys?: Array<string> | undefined;
                    contextForLLMJudge?: string | undefined;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
            };
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
            boundingBox: {
              __typename?: "BoundingBoxObject";
              left: number;
              top: number;
              right: number;
              bottom: number;
            };
            labelBoundingBox?:
              | {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                }
              | undefined;
            labelField?:
              | {
                  __typename?: "LabelFieldObject";
                  height: number;
                  width: number;
                  x: number;
                  y: number;
                }
              | undefined;
          }>;
        }
      | undefined;
  }>;
};

export type ContractDocumentForContractFragment = {
  __typename?: "ContractDocumentObject";
  id: string;
  order: number;
  externalDocumentType?: ExternalDocumentType | undefined;
  externalDocumentName?: string | undefined;
  documentVersion?:
    | {
        __typename?: "DocumentVersionObject";
        id: string;
        mappingKeys: Array<string>;
        version: string;
        document: {
          __typename?: "DocumentObject";
          id: string;
          name: string;
          form: string;
          documentType: DocumentType;
        };
      }
    | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
};

export type ContractValidationFragment = {
  __typename?: "ContractValidationObject";
  field: {
    __typename?: "FieldObject";
    id: string;
    mappingKey: string;
    fieldType: FieldType;
    label: string;
    displayLabel?: string | undefined;
    group: string;
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
  };
  documentVersionField: {
    __typename?: "DocumentVersionFieldObject";
    id: string;
    mappingKey: string;
    fieldType: FieldType;
    label: string;
    displayLabel?: string | undefined;
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
  };
  results: Array<{
    __typename?: "RuleValidationObject";
    inputValue?: string | undefined;
    message: string;
    validationValue?: string | undefined;
    rule: { __typename?: "RuleObject"; id: string; ruleType: RuleType };
  }>;
};

export type DefaultSecondaryDocumentFragment = {
  __typename?: "DefaultSecondaryDocumentObject";
  id: string;
  ordering: number;
  mappingKey: string;
  defaultRules?:
    | Array<{
        __typename?: "RuleObject";
        id: string;
        message: string;
        errorMessageTemplate?: string | undefined;
        focusFieldMappingKeys?: Array<string> | undefined;
        contextForLLMJudge?: string | undefined;
        ruleType: RuleType;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      }>
    | undefined;
  secondaryDocument: {
    __typename?: "DocumentObject";
    id: string;
    documentType: DocumentType;
    form: string;
    name: string;
    usState: UsState;
  };
};

export type DocumentFragment = {
  __typename?: "DocumentObject";
  id: string;
  documentType: DocumentType;
  documentCategory?: DocumentCategory | undefined;
  name: string;
  description: string;
  form: string;
  usState: UsState;
  includeInOfferIngestion: boolean;
  llmExtraction: boolean;
  updatedAt?: any | undefined;
};

export type DocumentAssetFileFragment = {
  __typename?: "AssetFileObject";
  id: string;
  ordering: number;
  file: { __typename?: "FileObject"; url: string };
};

export type DocumentClassificationEvaluationFragment = {
  __typename?: "DocumentClassificationEvaluationObject";
  id: string;
  createdAt: any;
  updatedAt: any;
  expectedCategory?: DocumentCategory | undefined;
  expectedDocumentType?: DocumentType | undefined;
  expectedUsState?: UsState | undefined;
  expectedValues?: any | undefined;
  extractedValues?: any | undefined;
  extractedAiValues?: any | undefined;
  combinedExtractedValues?: any | undefined;
  mappedValuesBBox?: any | undefined;
  isBlankDocument: boolean;
  lowConfidenceFields?: any | undefined;
  lastExtractedAt?: any | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  filteredOutItems?:
    | Array<{
        __typename?: "FilteredOutItemObject";
        text: string;
        mappingKey: string;
        pageNumber: number;
        boundingBox: any;
        fieldType: FieldType;
        filterReason: FilterReason;
        confidence?: number | undefined;
        targetConfidence?: number | undefined;
        intersectionOverArea?: number | undefined;
        targetIntersection?: number | undefined;
      }>
    | undefined;
  classification?:
    | Array<{
        __typename?: "DocumentPagePrediction";
        pageNumber: number;
        formName: string;
        version?: string | undefined;
        searchRegex?: string | undefined;
        humanLabeled?: boolean | undefined;
        usState: UsState;
        documentCategory?: DocumentCategory | undefined;
        documentType?: DocumentType | undefined;
        score: number;
        containment?: number | undefined;
        classificationMethod?: ClassificationMethod | undefined;
        formOrVersionMatch?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        alternativeCandidates?:
          | Array<{
              __typename?: "BasePagePrediction";
              formName: string;
              usState: UsState;
              version?: string | undefined;
              searchRegex?: string | undefined;
              documentCategory?: DocumentCategory | undefined;
              documentType?: DocumentType | undefined;
              score: number;
              humanLabeled?: boolean | undefined;
              pageNumber: number;
              containment?: number | undefined;
              formOrVersionMatch?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
            }>
          | undefined;
        candidateDocumentCategories?:
          | Array<{
              __typename?: "CandidateDocumentCategory";
              documentCategory: DocumentCategory;
              score: number;
            }>
          | undefined;
      }>
    | undefined;
};

export type ClassificationAlternativeCandidateFragment = {
  __typename?: "BasePagePrediction";
  formName: string;
  usState: UsState;
  version?: string | undefined;
  searchRegex?: string | undefined;
  documentCategory?: DocumentCategory | undefined;
  documentType?: DocumentType | undefined;
  score: number;
  humanLabeled?: boolean | undefined;
  pageNumber: number;
  containment?: number | undefined;
  formOrVersionMatch?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
};

export type ExtractSchemaFragment = {
  __typename?: "LLMExtractSchemaObject";
  key: string;
  description: string;
  outputType: LlmOutputSchemaType;
  enumValues?: Array<string> | undefined;
  fieldType?: FieldType | undefined;
};

export type DocumentLlmFragment = {
  __typename?: "DocumentLLMObject";
  id: string;
  documentCategory?: DocumentCategory | undefined;
  context?: string;
  pages?: Array<number>;
  extractSchema?: Array<{
    __typename?: "LLMExtractSchemaObject";
    key: string;
    description: string;
    outputType: LlmOutputSchemaType;
    enumValues?: Array<string> | undefined;
    fieldType?: FieldType | undefined;
  }>;
  documents: Array<{
    __typename?: "DocumentObject";
    id: string;
    name: string;
    form: string;
    usState: UsState;
    documentType: DocumentType;
  }>;
  examples?: Array<{
    __typename?: "DocumentLLMExampleObject";
    id: string;
    file: { __typename?: "FileObject"; fileName: string; url: string };
  }>;
};

export type DocumentLlmEvaluationFragment = {
  __typename?: "DocumentLLMEvaluationObject";
  id: string;
  expectedOutput?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  document?:
    | { __typename?: "DocumentObject"; id: string; name: string; form: string }
    | undefined;
  documentLLM: { __typename?: "DocumentLLMObject"; id: string };
};

export type DocumentLlmExampleFragment = {
  __typename?: "DocumentLLMExampleObject";
  id: string;
  file: { __typename?: "FileObject"; fileName: string; url: string };
};

export type DocumentSectionFragment = {
  __typename?: "DocumentSectionObject";
  id: string;
  description: string;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionType: DocumentSectionType;
  documentSectionCategory: DocumentSectionCategory;
  documentSectionModuleType?: DocumentSectionModuleType | undefined;
  title: string;
  order: number;
  documentSectionFields?:
    | Array<{
        __typename?: "DocumentSectionFieldObject";
        id: string;
        order: number;
        field: {
          __typename?: "FieldObject";
          id: string;
          group: string;
          label: string;
          displayLabel?: string | undefined;
          mappingKey: string;
          fieldType: FieldType;
          isComputed?: boolean | undefined;
          isHidden?: boolean | undefined;
          readOnly?: boolean | undefined;
          aiExtract?: boolean | undefined;
          aiInterpret?: boolean | undefined;
          comparisonType?: ComparisonType | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          optionsAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          helpTextAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          defaultRules?:
            | Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                errorMessageTemplate?: string | undefined;
                focusFieldMappingKeys?: Array<string> | undefined;
                contextForLLMJudge?: string | undefined;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
              }>
            | undefined;
        };
      }>
    | undefined;
};

export type DocumentVersionFragment = {
  __typename?: "DocumentVersionObject";
  id: string;
  status: DocumentVersionStatus;
  searchRegex?: string | undefined;
  version: string;
  file: { __typename?: "FileObject"; fileName: string; url: string };
};

export type DocumentVersionFieldFragment = {
  __typename?: "DocumentVersionFieldObject";
  id: string;
  align: FieldAlign;
  pageNumber: number;
  fontFamily: string;
  fontSize: string;
  label: string;
  readOnly?: boolean | undefined;
  width: number;
  height: number;
  x: number;
  y: number;
  mappingKey: string;
  fieldType: FieldType;
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  boundingBox: {
    __typename?: "BoundingBoxObject";
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
  labelBoundingBox?:
    | {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      }
    | undefined;
  labelField?:
    | {
        __typename?: "LabelFieldObject";
        height: number;
        width: number;
        x: number;
        y: number;
      }
    | undefined;
};

export type PublicDocumentVersionFieldFragment = {
  __typename?: "PublicDocumentVersionFieldObject";
  id: string;
  align: FieldAlign;
  pageNumber: number;
  fontFamily: string;
  fontSize: string;
  label: string;
  readOnly?: boolean | undefined;
  width: number;
  height: number;
  x: number;
  y: number;
  mappingKey: string;
  fieldType: FieldType;
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  boundingBox: {
    __typename?: "BoundingBoxObject";
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
};

export type FieldFragment = {
  __typename?: "FieldObject";
  id: string;
  group: string;
  label: string;
  displayLabel?: string | undefined;
  mappingKey: string;
  fieldType: FieldType;
  isComputed?: boolean | undefined;
  isHidden?: boolean | undefined;
  readOnly?: boolean | undefined;
  aiExtract?: boolean | undefined;
  aiInterpret?: boolean | undefined;
  comparisonType?: ComparisonType | undefined;
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
};

export type PublicFieldFragment = {
  __typename?: "PublicFieldObject";
  id: string;
  group: string;
  label: string;
  mappingKey: string;
  fieldType: FieldType;
  isComputed?: boolean | undefined;
  isHidden?: boolean | undefined;
  readOnly?: boolean | undefined;
  comparisonType?: ComparisonType | undefined;
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  autofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          source: VariableSource;
          type: VariableDataType;
        }>;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              source: VariableSource;
              type: VariableDataType;
            }
          | undefined;
      }
    | undefined;
};

export type FieldDetailFragment = {
  __typename?: "FieldObject";
  id: string;
  autofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
  optionsAutofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
  helpTextAutofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
  defaultRules?:
    | Array<{
        __typename?: "RuleObject";
        id: string;
        message: string;
        errorMessageTemplate?: string | undefined;
        focusFieldMappingKeys?: Array<string> | undefined;
        contextForLLMJudge?: string | undefined;
        ruleType: RuleType;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export type FieldsToColumnFragment = {
  __typename?: "FieldsToColumnObject";
  id: string;
  columnName: string;
  visibility: ColumnVisibility;
  fieldType: FieldType;
  documentCategory?: DocumentCategory | undefined;
  fields: Array<{
    __typename?: "FieldObject";
    id: string;
    group: string;
    label: string;
    displayLabel?: string | undefined;
    mappingKey: string;
    fieldType: FieldType;
    isComputed?: boolean | undefined;
    isHidden?: boolean | undefined;
    readOnly?: boolean | undefined;
    aiExtract?: boolean | undefined;
    aiInterpret?: boolean | undefined;
    comparisonType?: ComparisonType | undefined;
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
  }>;
  transformAutofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
};

export type IngestionDocumentFragment = {
  __typename?: "IngestionDocumentObject";
  id: string;
  documentId: string;
  documentName: string;
  documentCreatedAt: any;
  documentUpdatedAt: any;
  isBlank: boolean;
  s3Bucket: string;
  s3Key: string;
  fileUrl?: string | undefined;
};

export type IngestionDocumentWithContractsFragment = {
  __typename?: "IngestionDocumentObject";
  fields?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  contractDocumentPages?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  id: string;
  documentId: string;
  documentName: string;
  documentCreatedAt: any;
  documentUpdatedAt: any;
  isBlank: boolean;
  s3Bucket: string;
  s3Key: string;
  fileUrl?: string | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    order: number;
    externalDocumentType?: ExternalDocumentType | undefined;
    externalDocumentName?: string | undefined;
    documentCategory?: string | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          version: string;
          document: {
            __typename?: "DocumentObject";
            id: string;
            name: string;
            form: string;
            documentType: DocumentType;
          };
        }
      | undefined;
  }>;
};

export type IngestionFolderFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  platform: IngestionPlatform;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  activeMlsListingId?: string | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  createdAt: any;
  organization?:
    | { __typename?: "OrganizationObject"; id: string; name: string }
    | undefined;
};

export type InternalIngestionFolderListRowFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  folderUpdatedAt?: any | undefined;
  keyTermColumns?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  regularValidationErrorCount?: number | undefined;
  aiValidationErrorCount?: number | undefined;
  txPipelineNeedsInvestigationReason: TxPipelineNeedsInvestigationReason;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
      }
    | undefined;
};

export type MlsListingSelectionInfoFragment = {
  __typename?: "MLSListingObject";
  addressFull: string;
  listDate?: string | undefined;
  listPrice?: number | undefined;
  id: string;
  mlsId?: number | undefined;
  listingId?: string | undefined;
  mls?:
    | {
        __typename?: "MLSListingMLSObject";
        originatingSystemName?: string | undefined;
        statusText: string;
        logoUrl?: string | undefined;
      }
    | undefined;
  address: {
    __typename?: "MLSListingAddressObject";
    full: string;
    unit?: string | undefined;
    city: string;
    state: string;
    postalCode?: string | undefined;
  };
  property?:
    | {
        __typename?: "MLSListingPropertyObject";
        type?: MlsListingType | undefined;
        subType?: string | undefined;
        subTypeText?: string | undefined;
      }
    | undefined;
};

export type OrganizationFolderNameValidationStageOverrideFragment = {
  __typename?: "OrganizationFolderNameValidationStageOverrideObject";
  organizationUuid: string;
  isEnabled: boolean;
  keywordMappings: Array<{
    __typename?: "FolderNameValidationStageKeywordMappingObject";
    keyword: string;
    action: FolderNameValidationStageOverrideAction;
    transactionStageType?: TransactionStageType | undefined;
  }>;
};

export type PageInfoFragment = {
  __typename?: "PageInfoObject";
  totalCount: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
  nextCursor?: string | undefined;
  prevCursor?: string | undefined;
};

export type RuleFragment = {
  __typename?: "RuleObject";
  id: string;
  message: string;
  errorMessageTemplate?: string | undefined;
  focusFieldMappingKeys?: Array<string> | undefined;
  contextForLLMJudge?: string | undefined;
  ruleType: RuleType;
  autofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
};

export type GenericRuleValidationFragment = {
  __typename?: "GenericRuleValidationObject";
  message: string;
  focusFieldMappingKeys?: Array<string> | undefined;
  isEnabled: boolean;
  isDisabled: boolean;
  hasError: boolean;
  hasWarning: boolean;
  passedRequirement: boolean;
  output?: any | undefined;
  rule: {
    __typename?: "RuleObject";
    id: string;
    message: string;
    errorMessageTemplate?: string | undefined;
    focusFieldMappingKeys?: Array<string> | undefined;
    contextForLLMJudge?: string | undefined;
    ruleType: RuleType;
    autofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          variableSources: Array<VariableSource>;
          formula?: string | undefined;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }
            | undefined;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            type: VariableDataType;
            source: VariableSource;
          }>;
          formulaTestCases: Array<{
            __typename?: "FormulaTestCaseObject";
            values: Record<
              string,
              string | number | boolean | string[] | undefined
            >;
            expected: string;
            llmOutput?: boolean | undefined;
          }>;
          documents?:
            | Array<{
                __typename?: "DocumentCompactObject";
                id: string;
                name: string;
                description: string;
                documentCategory?: DocumentCategory | undefined;
                documentType: DocumentType;
                form: string;
                usState: UsState;
              }>
            | undefined;
        }
      | undefined;
  };
  inputValues?:
    | Array<{
        __typename?: "RuleValidationInputValue";
        value: string;
        fieldKey: string;
        variableSource?: VariableSource | undefined;
      }>
    | undefined;
};

export type SecondaryDocumentVersionFragment = {
  __typename?: "SecondaryDocumentVersionObject";
  id: string;
  ordering: number;
  rules: Array<{
    __typename?: "RuleObject";
    id: string;
    message: string;
    errorMessageTemplate?: string | undefined;
    focusFieldMappingKeys?: Array<string> | undefined;
    contextForLLMJudge?: string | undefined;
    ruleType: RuleType;
    autofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          variableSources: Array<VariableSource>;
          formula?: string | undefined;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }
            | undefined;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            type: VariableDataType;
            source: VariableSource;
          }>;
          formulaTestCases: Array<{
            __typename?: "FormulaTestCaseObject";
            values: Record<
              string,
              string | number | boolean | string[] | undefined
            >;
            expected: string;
            llmOutput?: boolean | undefined;
          }>;
          documents?:
            | Array<{
                __typename?: "DocumentCompactObject";
                id: string;
                name: string;
                description: string;
                documentCategory?: DocumentCategory | undefined;
                documentType: DocumentType;
                form: string;
                usState: UsState;
              }>
            | undefined;
        }
      | undefined;
  }>;
  secondaryDocumentVersion: {
    __typename?: "DocumentVersionObject";
    id: string;
    version: string;
    status: DocumentVersionStatus;
    searchRegex?: string | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    document: {
      __typename?: "DocumentObject";
      id: string;
      documentType: DocumentType;
      documentCategory?: DocumentCategory | undefined;
      name: string;
      description: string;
      form: string;
      usState: UsState;
      includeInOfferIngestion: boolean;
      llmExtraction: boolean;
      updatedAt?: any | undefined;
    };
  };
};

export type SignatureFormFieldFragment = {
  __typename?: "SignatureFormFieldObject";
  id: string;
  documentIndex: number;
  x: number;
  y: number;
  height: number;
  isRequired: boolean;
  name?: string | undefined;
  page: number;
  signerId: string;
  type: FieldType;
  width: number;
};

export type SignatureRequestFragment = {
  __typename?: "SignatureRequestObject";
  id: string;
  provider: SignatureProvider;
  externalId: string;
  allSignedDocument?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
};

export type TransactionPipelineFragment = {
  __typename?: "TransactionPipelineObject";
  id: string;
  clientType: ClientType;
  usState: UsState;
  transactionPropertyType: TransactionPropertyType;
};

export type RuleCompactFragment = {
  __typename?: "RuleObject";
  id: string;
  message: string;
  ruleType: RuleType;
};

export type TransactionRuleFragment = {
  __typename?: "TransactionRuleObject";
  id: string;
  organizationUuid?: string | undefined;
  targetDocumentCategory?: DocumentCategory | undefined;
  isRequiredDocument: boolean;
  logicalOperator: LogicalOperator;
  updatedAt: any;
  targetDocument?:
    | {
        __typename?: "DocumentObject";
        id: string;
        documentType: DocumentType;
        documentCategory?: DocumentCategory | undefined;
        name: string;
        description: string;
        form: string;
        usState: UsState;
        includeInOfferIngestion: boolean;
        llmExtraction: boolean;
        updatedAt?: any | undefined;
      }
    | undefined;
  parent?: { __typename?: "TransactionRuleObject"; id: string } | undefined;
  offerIngestionRule?:
    | {
        __typename?: "RuleObject";
        id: string;
        message: string;
        ruleType: RuleType;
      }
    | undefined;
  children: Array<{
    __typename?: "TransactionRuleObject";
    organizationUuid?: string | undefined;
    id: string;
    targetDocumentCategory?: DocumentCategory | undefined;
    logicalOperator: LogicalOperator;
    updatedAt: any;
    isRequiredDocument: boolean;
    offerIngestionRule?:
      | {
          __typename?: "RuleObject";
          id: string;
          message: string;
          ruleType: RuleType;
        }
      | undefined;
    parent?: { __typename?: "TransactionRuleObject"; id: string } | undefined;
    targetDocument?:
      | {
          __typename?: "DocumentObject";
          id: string;
          documentType: DocumentType;
          documentCategory?: DocumentCategory | undefined;
          name: string;
          description: string;
          form: string;
          usState: UsState;
          includeInOfferIngestion: boolean;
          llmExtraction: boolean;
          updatedAt?: any | undefined;
        }
      | undefined;
    rules: Array<{
      __typename?: "RuleObject";
      id: string;
      message: string;
      ruleType: RuleType;
    }>;
  }>;
  rules: Array<{
    __typename?: "RuleObject";
    id: string;
    message: string;
    ruleType: RuleType;
  }>;
};

export type TransactionStageFragment = {
  __typename?: "TransactionStageObject";
  id: string;
  stage: TransactionStageType;
  sortOrder: number;
};

export type FieldsToColumnListQueryVariables = Exact<{
  filters?: InputMaybe<FieldsToColumnListFilterArgs>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type FieldsToColumnListQuery = {
  __typename?: "Query";
  fieldsToColumnList?:
    | {
        __typename?: "FieldsToColumnObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "FieldsToColumnObject";
              id: string;
              columnName: string;
              visibility: ColumnVisibility;
              fieldType: FieldType;
              documentCategory?: DocumentCategory | undefined;
              fields: Array<{
                __typename?: "FieldObject";
                id: string;
                group: string;
                label: string;
                displayLabel?: string | undefined;
                mappingKey: string;
                fieldType: FieldType;
                isComputed?: boolean | undefined;
                isHidden?: boolean | undefined;
                readOnly?: boolean | undefined;
                aiExtract?: boolean | undefined;
                aiInterpret?: boolean | undefined;
                comparisonType?: ComparisonType | undefined;
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
              }>;
              transformAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type InputFormatFragment = {
  __typename?: "InputFormatObject";
  type: InputFormatType;
  options: {
    __typename?: "InputFormatOptionsObject";
    precision?: number | undefined;
    formatString?: string | undefined;
    currencySymbol?: string | undefined;
  };
};

export type BoundingBoxFragment = {
  __typename?: "BoundingBoxObject";
  left: number;
  top: number;
  right: number;
  bottom: number;
};

export type AddOrUpdateDisclosureContractDocumentsMutationVariables = Exact<{
  input: AddOrUpdateDisclosureContractDocumentsInput;
}>;

export type AddOrUpdateDisclosureContractDocumentsMutation = {
  __typename?: "Mutation";
  addOrUpdateDisclosureContractDocuments: {
    __typename?: "ContractPayload";
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            order: number;
            externalDocumentType?: ExternalDocumentType | undefined;
            externalDocumentName?: string | undefined;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  mappingKeys: Array<string>;
                  version: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
          }>;
        }
      | undefined;
  };
};

export type AddOrUpdatePreapprovalContractDocumentMutationVariables = Exact<{
  input: AddOrUpdatePreapprovalContractDocumentInput;
}>;

export type AddOrUpdatePreapprovalContractDocumentMutation = {
  __typename?: "Mutation";
  addOrUpdatePreapprovalContractDocument: {
    __typename?: "ContractPayload";
    contract?: { __typename?: "ContractObject"; id: string } | undefined;
  };
};

export type CopyComplianceKeyTermSectionsMutationVariables = Exact<{
  input: CopyComplianceKeyTermSectionsInput;
}>;

export type CopyComplianceKeyTermSectionsMutation = {
  __typename?: "Mutation";
  copyComplianceKeyTermSections: boolean;
};

export type CopyFieldsFromPreviousVersionMutationVariables = Exact<{
  input: CopyFieldsFromPreviousVersionInput;
}>;

export type CopyFieldsFromPreviousVersionMutation = {
  __typename?: "Mutation";
  copyFieldsFromPreviousVersion: {
    __typename?: "DocumentVersionPayload";
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          documentVersionFieldsCount?: number | undefined;
          id: string;
          status: DocumentVersionStatus;
          searchRegex?: string | undefined;
          version: string;
          documentVersionFields: Array<{
            __typename?: "DocumentVersionFieldObject";
            id: string;
            align: FieldAlign;
            pageNumber: number;
            fontFamily: string;
            fontSize: string;
            label: string;
            readOnly?: boolean | undefined;
            width: number;
            height: number;
            x: number;
            y: number;
            mappingKey: string;
            fieldType: FieldType;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
            boundingBox: {
              __typename?: "BoundingBoxObject";
              left: number;
              top: number;
              right: number;
              bottom: number;
            };
            labelBoundingBox?:
              | {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                }
              | undefined;
            labelField?:
              | {
                  __typename?: "LabelFieldObject";
                  height: number;
                  width: number;
                  x: number;
                  y: number;
                }
              | undefined;
          }>;
          file: { __typename?: "FileObject"; fileName: string; url: string };
        }
      | undefined;
  };
};

export type CopyTransactionRulesMutationVariables = Exact<{
  input: CopyTransactionRulesInput;
}>;

export type CopyTransactionRulesMutation = {
  __typename?: "Mutation";
  copyTransactionRules: boolean;
};

export type CreateAutofillMutationVariables = Exact<{
  input: CreateAutofillInput;
}>;

export type CreateAutofillMutation = {
  __typename?: "Mutation";
  createAutofill?:
    | {
        __typename?: "CreateAutofillPayload";
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              field?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              rule?:
                | {
                    __typename?: "RuleObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              optionsField?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              helpTextField?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              documentVersionField?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              optionsDocumentVersionField?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              helpTextDocumentVersionField?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type CreateClassificationEvalFromIngestionDocumentMutationVariables =
  Exact<{
    input: CreateClassificationEvalFromIngestionDocumentInput;
  }>;

export type CreateClassificationEvalFromIngestionDocumentMutation = {
  __typename?: "Mutation";
  createClassificationEvalFromIngestionDocument: {
    __typename?: "DocumentClassificationEvaluationObject";
    id: string;
    expectedCategory?: DocumentCategory | undefined;
    expectedDocumentType?: DocumentType | undefined;
    expectedUsState?: UsState | undefined;
    expectedValues?: any | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    classification?:
      | Array<{
          __typename?: "DocumentPagePrediction";
          formName: string;
          documentCategory?: DocumentCategory | undefined;
          documentType?: DocumentType | undefined;
          usState: UsState;
          score: number;
          pageNumber: number;
          classificationMethod?: ClassificationMethod | undefined;
        }>
      | undefined;
  };
};

export type CreateComplianceKeyTermSectionMutationVariables = Exact<{
  input: CreateComplianceKeyTermSectionInput;
}>;

export type CreateComplianceKeyTermSectionMutation = {
  __typename?: "Mutation";
  createComplianceKeyTermSection: {
    __typename?: "CreateComplianceKeyTermSectionPayload";
    complianceKeyTermSection?:
      | {
          __typename?: "ComplianceKeyTermSectionObject";
          id: string;
          title: string;
          description: string;
          order: number;
          documentSectionType: DocumentSectionType;
          category: ComplianceKeyTermCategory;
          organizationUuid?: string | undefined;
          parent?:
            | {
                __typename?: "ComplianceKeyTermSectionObject";
                id: string;
                title: string;
                description: string;
              }
            | undefined;
          complianceKeyTermSectionFields?:
            | Array<{
                __typename?: "ComplianceKeyTermSectionFieldObject";
                id: string;
                order: number;
                helpText?: string | undefined;
                fieldsToColumn: {
                  __typename?: "FieldsToColumnObject";
                  id: string;
                  columnName: string;
                  visibility: ColumnVisibility;
                  fieldType: FieldType;
                  documentCategory?: DocumentCategory | undefined;
                  fields: Array<{
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                  }>;
                  transformAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                };
              }>
            | undefined;
        }
      | undefined;
  };
};

export type CreateContractMutationVariables = Exact<{
  input?: InputMaybe<CreateContractInput>;
}>;

export type CreateContractMutation = {
  __typename?: "Mutation";
  createContract?:
    | {
        __typename?: "ContractPayload";
        contract?: { __typename?: "ContractObject"; id: string } | undefined;
      }
    | undefined;
};

export type CreateDefaultSecondaryDocumentMutationVariables = Exact<{
  input: CreateDefaultSecondaryDocumentInput;
}>;

export type CreateDefaultSecondaryDocumentMutation = {
  __typename?: "Mutation";
  createDefaultSecondaryDocument?:
    | {
        __typename?: "DefaultSecondaryDocumentPayload";
        defaultSecondaryDocument?:
          | {
              __typename?: "DefaultSecondaryDocumentObject";
              id: string;
              document: {
                __typename?: "DocumentObject";
                id: string;
                defaultSecondaryDocuments: Array<{
                  __typename?: "DefaultSecondaryDocumentObject";
                  id: string;
                  ordering: number;
                  mappingKey: string;
                  defaultRules?:
                    | Array<{
                        __typename?: "RuleObject";
                        id: string;
                        message: string;
                        errorMessageTemplate?: string | undefined;
                        focusFieldMappingKeys?: Array<string> | undefined;
                        contextForLLMJudge?: string | undefined;
                        ruleType: RuleType;
                        autofill?:
                          | {
                              __typename?: "AutofillObject";
                              id: string;
                              variableSources: Array<VariableSource>;
                              formula?: string | undefined;
                              variableField?:
                                | {
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }
                                | undefined;
                              formulaVariableFields: Array<{
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }>;
                              formulaTestCases: Array<{
                                __typename?: "FormulaTestCaseObject";
                                values: Record<
                                  string,
                                  | string
                                  | number
                                  | boolean
                                  | string[]
                                  | undefined
                                >;
                                expected: string;
                                llmOutput?: boolean | undefined;
                              }>;
                              documents?:
                                | Array<{
                                    __typename?: "DocumentCompactObject";
                                    id: string;
                                    name: string;
                                    description: string;
                                    documentCategory?:
                                      | DocumentCategory
                                      | undefined;
                                    documentType: DocumentType;
                                    form: string;
                                    usState: UsState;
                                  }>
                                | undefined;
                            }
                          | undefined;
                      }>
                    | undefined;
                  secondaryDocument: {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                    form: string;
                    name: string;
                    usState: UsState;
                  };
                }>;
              };
            }
          | undefined;
      }
    | undefined;
};

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;

export type CreateDocumentMutation = {
  __typename?: "Mutation";
  createDocument?:
    | {
        __typename?: "CreateDocumentPayload";
        document?:
          | {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              description: string;
              form: string;
              usState: UsState;
              includeInOfferIngestion: boolean;
              llmExtraction: boolean;
              updatedAt?: any | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type CreateDocumentLlmMutationVariables = Exact<{
  input: DocumentLlmInput;
  isDetail?: Scalars["Boolean"]["input"];
}>;

export type CreateDocumentLlmMutation = {
  __typename?: "Mutation";
  createDocumentLLM?:
    | {
        __typename?: "DocumentLLMObject";
        id: string;
        documentCategory?: DocumentCategory | undefined;
        context?: string;
        pages?: Array<number>;
        extractSchema?: Array<{
          __typename?: "LLMExtractSchemaObject";
          key: string;
          description: string;
          outputType: LlmOutputSchemaType;
          enumValues?: Array<string> | undefined;
          fieldType?: FieldType | undefined;
        }>;
        documents: Array<{
          __typename?: "DocumentObject";
          id: string;
          name: string;
          form: string;
          usState: UsState;
          documentType: DocumentType;
        }>;
        examples?: Array<{
          __typename?: "DocumentLLMExampleObject";
          id: string;
          file: { __typename?: "FileObject"; fileName: string; url: string };
        }>;
      }
    | undefined;
};

export type CreateDocumentLlmExampleMutationVariables = Exact<{
  input: DocumentLlmExampleInput;
}>;

export type CreateDocumentLlmExampleMutation = {
  __typename?: "Mutation";
  createDocumentLLMExample?:
    | {
        __typename?: "DocumentLLMExampleObject";
        id: string;
        file: { __typename?: "FileObject"; fileName: string; url: string };
        documentLLM: { __typename?: "DocumentLLMObject"; id: string };
      }
    | undefined;
};

export type CreateDocumentLlmExamplesMutationVariables = Exact<{
  input: DocumentLlmExamplesInput;
}>;

export type CreateDocumentLlmExamplesMutation = {
  __typename?: "Mutation";
  createDocumentLLMExamples?:
    | Array<{
        __typename?: "DocumentLLMExampleObject";
        id: string;
        file: { __typename?: "FileObject"; fileName: string; url: string };
        documentLLM: { __typename?: "DocumentLLMObject"; id: string };
      }>
    | undefined;
};

export type CreateDocumentSectionMutationVariables = Exact<{
  input: CreateDocumentSectionInput;
}>;

export type CreateDocumentSectionMutation = {
  __typename?: "Mutation";
  createDocumentSection: {
    __typename?: "CreateDocumentSectionPayload";
    documentSection?:
      | {
          __typename?: "DocumentSectionObject";
          id: string;
          description: string;
          documentSectionDisplayType: DocumentSectionDisplayType;
          documentSectionType: DocumentSectionType;
          documentSectionCategory: DocumentSectionCategory;
          documentSectionModuleType?: DocumentSectionModuleType | undefined;
          title: string;
          order: number;
          parent?:
            | {
                __typename?: "DocumentSectionObject";
                id: string;
                description: string;
              }
            | undefined;
          documentSectionFields?:
            | Array<{
                __typename?: "DocumentSectionFieldObject";
                id: string;
                order: number;
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  group: string;
                  label: string;
                  displayLabel?: string | undefined;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  aiExtract?: boolean | undefined;
                  aiInterpret?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  optionsAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  helpTextAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  defaultRules?:
                    | Array<{
                        __typename?: "RuleObject";
                        id: string;
                        message: string;
                        errorMessageTemplate?: string | undefined;
                        focusFieldMappingKeys?: Array<string> | undefined;
                        contextForLLMJudge?: string | undefined;
                        ruleType: RuleType;
                        autofill?:
                          | {
                              __typename?: "AutofillObject";
                              id: string;
                              variableSources: Array<VariableSource>;
                              formula?: string | undefined;
                              variableField?:
                                | {
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }
                                | undefined;
                              formulaVariableFields: Array<{
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }>;
                              formulaTestCases: Array<{
                                __typename?: "FormulaTestCaseObject";
                                values: Record<
                                  string,
                                  | string
                                  | number
                                  | boolean
                                  | string[]
                                  | undefined
                                >;
                                expected: string;
                                llmOutput?: boolean | undefined;
                              }>;
                              documents?:
                                | Array<{
                                    __typename?: "DocumentCompactObject";
                                    id: string;
                                    name: string;
                                    description: string;
                                    documentCategory?:
                                      | DocumentCategory
                                      | undefined;
                                    documentType: DocumentType;
                                    form: string;
                                    usState: UsState;
                                  }>
                                | undefined;
                            }
                          | undefined;
                      }>
                    | undefined;
                };
              }>
            | undefined;
        }
      | undefined;
  };
};

export type CreateDocumentVersionMutationVariables = Exact<{
  input: CreateDocumentVersionInput;
}>;

export type CreateDocumentVersionMutation = {
  __typename?: "Mutation";
  createDocumentVersion?:
    | {
        __typename?: "CreateDocumentVersionPayload";
        documentVersion?:
          | {
              __typename?: "DocumentVersionObject";
              id: string;
              status: DocumentVersionStatus;
              searchRegex?: string | undefined;
              version: string;
              document: {
                __typename?: "DocumentObject";
                id: string;
                documentVersions: Array<{
                  __typename?: "DocumentVersionObject";
                  id: string;
                }>;
              };
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
      }
    | undefined;
};

export type CreateDocumentVersionFieldsMutationVariables = Exact<{
  inputs:
    | Array<CreateDocumentVersionFieldInput>
    | CreateDocumentVersionFieldInput;
}>;

export type CreateDocumentVersionFieldsMutation = {
  __typename?: "Mutation";
  createDocumentVersionFields?:
    | {
        __typename?: "CreateDocumentVersionFieldsPayload";
        documentVersionFields: Array<{
          __typename?: "DocumentVersionFieldObject";
          id: string;
          align: FieldAlign;
          pageNumber: number;
          fontFamily: string;
          fontSize: string;
          label: string;
          readOnly?: boolean | undefined;
          width: number;
          height: number;
          x: number;
          y: number;
          mappingKey: string;
          fieldType: FieldType;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          boundingBox: {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          };
          labelBoundingBox?:
            | {
                __typename?: "BoundingBoxObject";
                left: number;
                top: number;
                right: number;
                bottom: number;
              }
            | undefined;
          labelField?:
            | {
                __typename?: "LabelFieldObject";
                height: number;
                width: number;
                x: number;
                y: number;
              }
            | undefined;
        }>;
      }
    | undefined;
};

export type CreateEmbeddedSignUrlMutationVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type CreateEmbeddedSignUrlMutation = {
  __typename?: "Mutation";
  createEmbeddedSignUrl?: string | undefined;
};

export type CreateFallbackContractMutationVariables = Exact<{
  input: CreateFallbackContractInput;
}>;

export type CreateFallbackContractMutation = {
  __typename?: "Mutation";
  createFallbackContract?:
    | {
        __typename?: "ContractPayload";
        contract?: { __typename?: "ContractObject"; id: string } | undefined;
      }
    | undefined;
};

export type CreateFieldMutationVariables = Exact<{
  input: CreateFieldInput;
}>;

export type CreateFieldMutation = {
  __typename?: "Mutation";
  createField?:
    | {
        __typename?: "CreateFieldPayload";
        field?:
          | {
              __typename?: "FieldObject";
              id: string;
              group: string;
              label: string;
              displayLabel?: string | undefined;
              mappingKey: string;
              fieldType: FieldType;
              isComputed?: boolean | undefined;
              isHidden?: boolean | undefined;
              readOnly?: boolean | undefined;
              aiExtract?: boolean | undefined;
              aiInterpret?: boolean | undefined;
              comparisonType?: ComparisonType | undefined;
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              optionsAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              helpTextAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    errorMessageTemplate?: string | undefined;
                    focusFieldMappingKeys?: Array<string> | undefined;
                    contextForLLMJudge?: string | undefined;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type CreateOrUpdateDocumentClassificationEvaluationMutationVariables =
  Exact<{
    input: CreateOrUpdateDocumentClassificationEvaluationInput;
  }>;

export type CreateOrUpdateDocumentClassificationEvaluationMutation = {
  __typename?: "Mutation";
  createOrUpdateDocumentClassificationEvaluation?:
    | {
        __typename?: "DocumentClassificationEvaluationObject";
        id: string;
        createdAt: any;
        updatedAt: any;
        expectedCategory?: DocumentCategory | undefined;
        expectedDocumentType?: DocumentType | undefined;
        expectedUsState?: UsState | undefined;
        expectedValues?: any | undefined;
        extractedValues?: any | undefined;
        extractedAiValues?: any | undefined;
        combinedExtractedValues?: any | undefined;
        mappedValuesBBox?: any | undefined;
        isBlankDocument: boolean;
        lowConfidenceFields?: any | undefined;
        lastExtractedAt?: any | undefined;
        file: { __typename?: "FileObject"; fileName: string; url: string };
        filteredOutItems?:
          | Array<{
              __typename?: "FilteredOutItemObject";
              text: string;
              mappingKey: string;
              pageNumber: number;
              boundingBox: any;
              fieldType: FieldType;
              filterReason: FilterReason;
              confidence?: number | undefined;
              targetConfidence?: number | undefined;
              intersectionOverArea?: number | undefined;
              targetIntersection?: number | undefined;
            }>
          | undefined;
        classification?:
          | Array<{
              __typename?: "DocumentPagePrediction";
              pageNumber: number;
              formName: string;
              version?: string | undefined;
              searchRegex?: string | undefined;
              humanLabeled?: boolean | undefined;
              usState: UsState;
              documentCategory?: DocumentCategory | undefined;
              documentType?: DocumentType | undefined;
              score: number;
              containment?: number | undefined;
              classificationMethod?: ClassificationMethod | undefined;
              formOrVersionMatch?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              alternativeCandidates?:
                | Array<{
                    __typename?: "BasePagePrediction";
                    formName: string;
                    usState: UsState;
                    version?: string | undefined;
                    searchRegex?: string | undefined;
                    documentCategory?: DocumentCategory | undefined;
                    documentType?: DocumentType | undefined;
                    score: number;
                    humanLabeled?: boolean | undefined;
                    pageNumber: number;
                    containment?: number | undefined;
                    formOrVersionMatch?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                  }>
                | undefined;
              candidateDocumentCategories?:
                | Array<{
                    __typename?: "CandidateDocumentCategory";
                    documentCategory: DocumentCategory;
                    score: number;
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type DeleteDocumentClassificationEvaluationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentClassificationEvaluationMutation = {
  __typename?: "Mutation";
  deleteDocumentClassificationEvaluation: boolean;
};

export type EvaluateDocumentClassificationMutationVariables = Exact<{
  evaluationId: Scalars["ID"]["input"];
}>;

export type EvaluateDocumentClassificationMutation = {
  __typename?: "Mutation";
  evaluateDocumentClassification: boolean;
};

export type PreviewExtractedFieldsFromEvaluationMutationVariables = Exact<{
  evaluationId: Scalars["ID"]["input"];
}>;

export type PreviewExtractedFieldsFromEvaluationMutation = {
  __typename?: "Mutation";
  previewExtractedFieldsFromEvaluation: any;
};

export type SaveExtractedFieldsFromEvaluationMutationVariables = Exact<{
  evaluationId: Scalars["ID"]["input"];
}>;

export type SaveExtractedFieldsFromEvaluationMutation = {
  __typename?: "Mutation";
  saveExtractedFieldsFromEvaluation: boolean;
};

export type BulkEvaluateDocumentClassificationsMutationVariables = Exact<{
  evaluationIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type BulkEvaluateDocumentClassificationsMutation = {
  __typename?: "Mutation";
  bulkEvaluateDocumentClassifications: string;
};

export type CreateOrUpdateDocumentLlmEvaluationMutationVariables = Exact<{
  input: DocumentLlmEvaluationInput;
  id?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type CreateOrUpdateDocumentLlmEvaluationMutation = {
  __typename?: "Mutation";
  createOrUpdateDocumentLLMEvaluation?:
    | {
        __typename?: "DocumentLLMEvaluationObject";
        id: string;
        documentLLM: {
          __typename?: "DocumentLLMObject";
          id: string;
          documentLLMEvaluations: Array<{
            __typename?: "DocumentLLMEvaluationObject";
            id: string;
            expectedOutput?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
            document?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  name: string;
                  form: string;
                }
              | undefined;
            documentLLM: { __typename?: "DocumentLLMObject"; id: string };
          }>;
        };
        document?:
          | {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              usState: UsState;
              form: string;
            }
          | undefined;
      }
    | undefined;
};

export type CreateRuleMutationVariables = Exact<{
  input: CreateRuleInput;
  relationInput: RuleRelationInput;
}>;

export type CreateRuleMutation = {
  __typename?: "Mutation";
  createRule?:
    | {
        __typename?: "CreateRulePayload";
        rule?:
          | {
              __typename?: "RuleObject";
              id: string;
              message: string;
              errorMessageTemplate?: string | undefined;
              focusFieldMappingKeys?: Array<string> | undefined;
              contextForLLMJudge?: string | undefined;
              ruleType: RuleType;
              field?:
                | {
                    __typename?: "FieldObject";
                    id: string;
                    defaultRules?:
                      | Array<{
                          __typename?: "RuleObject";
                          id: string;
                          message: string;
                          errorMessageTemplate?: string | undefined;
                          focusFieldMappingKeys?: Array<string> | undefined;
                          contextForLLMJudge?: string | undefined;
                          ruleType: RuleType;
                          autofill?:
                            | {
                                __typename?: "AutofillObject";
                                id: string;
                                variableSources: Array<VariableSource>;
                                formula?: string | undefined;
                                variableField?:
                                  | {
                                      __typename?: "VariableFieldObject";
                                      key: string;
                                      type: VariableDataType;
                                      source: VariableSource;
                                    }
                                  | undefined;
                                formulaVariableFields: Array<{
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }>;
                                formulaTestCases: Array<{
                                  __typename?: "FormulaTestCaseObject";
                                  values: Record<
                                    string,
                                    | string
                                    | number
                                    | boolean
                                    | string[]
                                    | undefined
                                  >;
                                  expected: string;
                                  llmOutput?: boolean | undefined;
                                }>;
                                documents?:
                                  | Array<{
                                      __typename?: "DocumentCompactObject";
                                      id: string;
                                      name: string;
                                      description: string;
                                      documentCategory?:
                                        | DocumentCategory
                                        | undefined;
                                      documentType: DocumentType;
                                      form: string;
                                      usState: UsState;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
              documentVersionField?:
                | {
                    __typename?: "DocumentVersionFieldObject";
                    id: string;
                    rules: Array<{
                      __typename?: "RuleObject";
                      id: string;
                      message: string;
                      errorMessageTemplate?: string | undefined;
                      focusFieldMappingKeys?: Array<string> | undefined;
                      contextForLLMJudge?: string | undefined;
                      ruleType: RuleType;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }>;
                  }
                | undefined;
              defaultSecondaryDocument?:
                | {
                    __typename?: "DefaultSecondaryDocumentObject";
                    id: string;
                    defaultRules?:
                      | Array<{
                          __typename?: "RuleObject";
                          id: string;
                          message: string;
                          errorMessageTemplate?: string | undefined;
                          focusFieldMappingKeys?: Array<string> | undefined;
                          contextForLLMJudge?: string | undefined;
                          ruleType: RuleType;
                          autofill?:
                            | {
                                __typename?: "AutofillObject";
                                id: string;
                                variableSources: Array<VariableSource>;
                                formula?: string | undefined;
                                variableField?:
                                  | {
                                      __typename?: "VariableFieldObject";
                                      key: string;
                                      type: VariableDataType;
                                      source: VariableSource;
                                    }
                                  | undefined;
                                formulaVariableFields: Array<{
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }>;
                                formulaTestCases: Array<{
                                  __typename?: "FormulaTestCaseObject";
                                  values: Record<
                                    string,
                                    | string
                                    | number
                                    | boolean
                                    | string[]
                                    | undefined
                                  >;
                                  expected: string;
                                  llmOutput?: boolean | undefined;
                                }>;
                                documents?:
                                  | Array<{
                                      __typename?: "DocumentCompactObject";
                                      id: string;
                                      name: string;
                                      description: string;
                                      documentCategory?:
                                        | DocumentCategory
                                        | undefined;
                                      documentType: DocumentType;
                                      form: string;
                                      usState: UsState;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
              secondaryDocumentVersion?:
                | {
                    __typename?: "SecondaryDocumentVersionObject";
                    id: string;
                    rules: Array<{
                      __typename?: "RuleObject";
                      id: string;
                      message: string;
                      errorMessageTemplate?: string | undefined;
                      focusFieldMappingKeys?: Array<string> | undefined;
                      contextForLLMJudge?: string | undefined;
                      ruleType: RuleType;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }>;
                  }
                | undefined;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type CreateTransactionPipelineMutationVariables = Exact<{
  input: CreateTransactionPipelineInput;
}>;

export type CreateTransactionPipelineMutation = {
  __typename?: "Mutation";
  createTransactionPipeline: {
    __typename?: "TransactionPipelineObject";
    id: string;
    clientType: ClientType;
    usState: UsState;
    transactionPropertyType: TransactionPropertyType;
  };
};

export type CropCheckboxImagesMutationVariables = Exact<{
  input: CropCheckboxImagesInput;
}>;

export type CropCheckboxImagesMutation = {
  __typename?: "Mutation";
  cropCheckboxImages?: boolean | undefined;
};

export type DeleteComplianceGroupTransactionStageMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteComplianceGroupTransactionStageMutation = {
  __typename?: "Mutation";
  deleteComplianceGroupTransactionStage: boolean;
};

export type DeleteComplianceKeyTermSectionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteComplianceKeyTermSectionMutation = {
  __typename?: "Mutation";
  deleteComplianceKeyTermSection: {
    __typename?: "DeleteComplianceKeyTermSectionPayload";
    deleted: boolean;
  };
};

export type DeleteContractDocumentsMutationVariables = Exact<{
  input: DeleteContractDocumentsInput;
}>;

export type DeleteContractDocumentsMutation = {
  __typename?: "Mutation";
  deleteContractDocuments: {
    __typename?: "ContractPayload";
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            order: number;
            externalDocumentType?: ExternalDocumentType | undefined;
            externalDocumentName?: string | undefined;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  mappingKeys: Array<string>;
                  version: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
          }>;
        }
      | undefined;
  };
};

export type DeleteDefaultSecondaryDocumentMutationVariables = Exact<{
  input: DeleteDefaultSecondaryDocumentInput;
}>;

export type DeleteDefaultSecondaryDocumentMutation = {
  __typename?: "Mutation";
  deleteDefaultSecondaryDocument?:
    | { __typename?: "DeleteDefaultSecondaryDocumentPayload"; success: boolean }
    | undefined;
};

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentMutation = {
  __typename?: "Mutation";
  deleteDocument?:
    | { __typename?: "DeleteDocumentPayload"; deleted?: boolean | undefined }
    | undefined;
};

export type DeleteDocumentLlmMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentLlmMutation = {
  __typename?: "Mutation";
  deleteDocumentLLM: boolean;
};

export type DeleteDocumentLlmEvaluationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentLlmEvaluationMutation = {
  __typename?: "Mutation";
  deleteDocumentLLMEvaluation: boolean;
};

export type DeleteDocumentLlmExampleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentLlmExampleMutation = {
  __typename?: "Mutation";
  deleteDocumentLLMExample: boolean;
};

export type DeleteDocumentSectionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteDocumentSectionMutation = {
  __typename?: "Mutation";
  deleteDocumentSection: {
    __typename?: "DeleteDocumentSectionPayload";
    deleted?: boolean | undefined;
  };
};

export type DeleteDocumentVersionMutationVariables = Exact<{
  uuid: Scalars["ID"]["input"];
}>;

export type DeleteDocumentVersionMutation = {
  __typename?: "Mutation";
  deleteDocumentVersion: {
    __typename?: "DeleteDocumentVersionPayload";
    deletedDocumentVersionUuid: string;
  };
};

export type DeleteDocumentVersionFieldsMutationVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type DeleteDocumentVersionFieldsMutation = {
  __typename?: "Mutation";
  deleteDocumentVersionFields?:
    | {
        __typename?: "DeleteDocumentVersionFieldsPayload";
        deletedIds: Array<string>;
      }
    | undefined;
};

export type DeleteFieldMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteFieldMutation = {
  __typename?: "Mutation";
  deleteField?: { __typename?: "DeleteFieldPayload"; id: string } | undefined;
};

export type DeletePreapprovalContractDocumentMutationVariables = Exact<{
  input: DeletePreapprovalContractDocumentInput;
}>;

export type DeletePreapprovalContractDocumentMutation = {
  __typename?: "Mutation";
  deletePreapprovalContractDocument: {
    __typename?: "ContractPayload";
    contract?: { __typename?: "ContractObject"; id: string } | undefined;
  };
};

export type DeleteRuleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteRuleMutation = {
  __typename?: "Mutation";
  deleteRule?: { __typename?: "DeleteRulePayload"; id: string } | undefined;
};

export type DeleteTransactionRuleMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteTransactionRuleMutation = {
  __typename?: "Mutation";
  deleteTransactionRule?: boolean | undefined;
};

export type DeleteTransactionStageMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteTransactionStageMutation = {
  __typename?: "Mutation";
  deleteTransactionStage?: boolean | undefined;
};

export type DetectFormFieldsFragment = {
  __typename?: "DocumentVersionFieldObject";
  id: string;
  align: FieldAlign;
  pageNumber: number;
  fontFamily: string;
  fontSize: string;
  label: string;
  readOnly?: boolean | undefined;
  width: number;
  height: number;
  x: number;
  y: number;
  mappingKey: string;
  fieldType: FieldType;
  field: {
    __typename?: "FieldObject";
    id: string;
    fieldType: FieldType;
    mappingKey: string;
    label: string;
  };
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  boundingBox: {
    __typename?: "BoundingBoxObject";
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
  labelBoundingBox?:
    | {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      }
    | undefined;
  labelField?:
    | {
        __typename?: "LabelFieldObject";
        height: number;
        width: number;
        x: number;
        y: number;
      }
    | undefined;
};

export type DetectFormFieldsMutationVariables = Exact<{
  input: ExtractContractInput;
}>;

export type DetectFormFieldsMutation = {
  __typename?: "Mutation";
  detectFormFields?:
    | Array<{
        __typename?: "DocumentVersionFieldObject";
        id: string;
        align: FieldAlign;
        pageNumber: number;
        fontFamily: string;
        fontSize: string;
        label: string;
        readOnly?: boolean | undefined;
        width: number;
        height: number;
        x: number;
        y: number;
        mappingKey: string;
        fieldType: FieldType;
        field: {
          __typename?: "FieldObject";
          id: string;
          fieldType: FieldType;
          mappingKey: string;
          label: string;
        };
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
        boundingBox: {
          __typename?: "BoundingBoxObject";
          left: number;
          top: number;
          right: number;
          bottom: number;
        };
        labelBoundingBox?:
          | {
              __typename?: "BoundingBoxObject";
              left: number;
              top: number;
              right: number;
              bottom: number;
            }
          | undefined;
        labelField?:
          | {
              __typename?: "LabelFieldObject";
              height: number;
              width: number;
              x: number;
              y: number;
            }
          | undefined;
      }>
    | undefined;
};

export type DetectFormFieldsForDocumentVersionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DetectFormFieldsForDocumentVersionMutation = {
  __typename?: "Mutation";
  detectFormFieldsForDocumentVersion?:
    | {
        __typename?: "DocumentVersionDetectFormFieldsPayload";
        jobId?: string | undefined;
      }
    | undefined;
};

export type ExternalCreateComplianceMessageHistoryMutationVariables = Exact<{
  input: ExternalCreateComplianceMessageHistoryInput;
}>;

export type ExternalCreateComplianceMessageHistoryMutation = {
  __typename?: "Mutation";
  externalCreateComplianceMessageHistory: {
    __typename?: "ExternalCreateComplianceMessageHistoryPayload";
    complianceMessageHistory: {
      __typename?: "ComplianceMessageHistoryObject";
      id: string;
      recipientType: ComplianceMessageRecipientType;
      recipientValue: string;
      messageContent: string;
      workflowRunId: string;
      createdAt: any;
      updatedAt: any;
    };
  };
};

export type ExternalCreateErrorReportMutationVariables = Exact<{
  input: ExternalCreateErrorReportInput;
}>;

export type ExternalCreateErrorReportMutation = {
  __typename?: "Mutation";
  externalCreateErrorReport: {
    __typename?: "ErrorReportObject";
    id: string;
    category: ErrorReportCategory;
    metadata?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    linearTicketUrl?: string | undefined;
    userMessage?: string | undefined;
    userMessageSubmittedAt?: any | undefined;
    createdAt: any;
  };
};

export type ExternalDeleteDarwinCompanyOfficeMappingMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type ExternalDeleteDarwinCompanyOfficeMappingMutation = {
  __typename?: "Mutation";
  externalDeleteDarwinCompanyOfficeMapping: boolean;
};

export type ExternalOverrideKeyTermsForIngestionFolderMutationVariables =
  Exact<{
    input: OverrideKeyTermsForIngestionFolderInput;
  }>;

export type ExternalOverrideKeyTermsForIngestionFolderMutation = {
  __typename?: "Mutation";
  externalOverrideKeyTermsForIngestionFolder: {
    __typename?: "OverrideKeyTermsForIngestionFolderPayload";
    success: boolean;
  };
};

export type ExternalSaveDarwinCompanyOfficeMappingMutationVariables = Exact<{
  input: ExternalSaveDarwinCompanyOfficeMappingInput;
}>;

export type ExternalSaveDarwinCompanyOfficeMappingMutation = {
  __typename?: "Mutation";
  externalSaveDarwinCompanyOfficeMapping: {
    __typename?: "DarwinCompanyOfficeMappingObject";
    id: string;
    organizationUuid: string;
    platform: IngestionPlatform;
    platformProfileId: string;
    officeId: string;
    darwinCompanyId: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type ExternalSubmitErrorReportContextMutationVariables = Exact<{
  input: ExternalSubmitErrorReportContextInput;
}>;

export type ExternalSubmitErrorReportContextMutation = {
  __typename?: "Mutation";
  externalSubmitErrorReportContext: {
    __typename?: "ErrorReportObject";
    id: string;
    category: ErrorReportCategory;
    metadata?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    linearTicketUrl?: string | undefined;
    userMessage?: string | undefined;
    userMessageSubmittedAt?: any | undefined;
    createdAt: any;
  };
};

export type ExternalSyncDarwinFeesMutationVariables = Exact<{
  input: ExternalSyncDarwinFeesInput;
}>;

export type ExternalSyncDarwinFeesMutation = {
  __typename?: "Mutation";
  externalSyncDarwinFees: {
    __typename?: "ExternalSyncDarwinFeesPayload";
    success: boolean;
    syncedFees: Array<{
      __typename?: "DarwinFeeSyncResult";
      feeType: DarwinFeeType;
      syncedAmount?: number | undefined;
      payer?: string | undefined;
      action: string;
      skipReason?: string | undefined;
    }>;
  };
};

export type ExternalSyncDarwinSelectionMutationVariables = Exact<{
  input: ExternalSyncDarwinSelectionInput;
}>;

export type ExternalSyncDarwinSelectionMutation = {
  __typename?: "Mutation";
  externalSyncDarwinSelection: {
    __typename?: "ExternalSyncDarwinSelectionPayload";
    success: boolean;
    externalEntityId?: string | undefined;
    appliedRows: Array<{
      __typename?: "DarwinSyncSelectionAppliedRow";
      rowId: string;
      category: DarwinSyncSelectionRowCategory;
      label: string;
    }>;
    skippedRows: Array<{
      __typename?: "DarwinSyncSelectionSkippedRow";
      rowId: string;
      category?: DarwinSyncSelectionRowCategory | undefined;
      label?: string | undefined;
      reason: string;
    }>;
  };
};

export type ExternalSyncDarwinVendorsMutationVariables = Exact<{
  input: ExternalSyncDarwinVendorsInput;
}>;

export type ExternalSyncDarwinVendorsMutation = {
  __typename?: "Mutation";
  externalSyncDarwinVendors: {
    __typename?: "ExternalSyncDarwinVendorsPayload";
    success: boolean;
    syncedVendors: Array<{
      __typename?: "SyncedVendorResult";
      vendorType: DarwinVendorType;
      personId: number;
      personName: string;
    }>;
  };
};

export type ExternalUpdateIngestionDocumentStatusMutationVariables = Exact<{
  input: ExternalUpdateIngestionDocumentStatusInput;
}>;

export type ExternalUpdateIngestionDocumentStatusMutation = {
  __typename?: "Mutation";
  externalUpdateIngestionDocumentStatus: {
    __typename?: "IngestionDocumentObject";
    id: string;
    needsReview?: boolean | undefined;
    complianceStatus?: string | undefined;
  };
};

export type ExtractContractMutationFragment = {
  __typename?: "ExtractContractPayload";
  contract?:
    | {
        __typename?: "ContractObject";
        id: string;
        fieldValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        contractDocuments: Array<{
          __typename?: "ContractDocumentObject";
          id: string;
          documentVersion?:
            | { __typename?: "DocumentVersionObject"; id: string }
            | undefined;
        }>;
      }
    | undefined;
  extracted?:
    | Array<{
        __typename?: "ExtractedDocumentValuesPayload";
        formName?: string | undefined;
        documentType?: DocumentType | undefined;
        usState?: UsState | undefined;
        values?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }>
    | undefined;
};

export type ExtractContractMutationVariables = Exact<{
  input: Array<ExtractContractInput> | ExtractContractInput;
}>;

export type ExtractContractMutation = {
  __typename?: "Mutation";
  extractContract?:
    | {
        __typename?: "ExtractContractPayload";
        contract?:
          | {
              __typename?: "ContractObject";
              id: string;
              fieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              contractDocuments: Array<{
                __typename?: "ContractDocumentObject";
                id: string;
                documentVersion?:
                  | { __typename?: "DocumentVersionObject"; id: string }
                  | undefined;
              }>;
            }
          | undefined;
        extracted?:
          | Array<{
              __typename?: "ExtractedDocumentValuesPayload";
              formName?: string | undefined;
              documentType?: DocumentType | undefined;
              usState?: UsState | undefined;
              values?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type ExtractPreapprovalInfoMutationVariables = Exact<{
  input: ExtractPreapprovalInfoInput;
}>;

export type ExtractPreapprovalInfoMutation = {
  __typename?: "Mutation";
  extractPreapprovalInfo?:
    | {
        __typename?: "ExtractPreapprovalInfoPayload";
        primary_buyer?: string | undefined;
        co_buyer?: string | undefined;
        loan_type?: string | undefined;
        loan_amount?: number | undefined;
        purchase_price?: number | undefined;
      }
    | undefined;
};

export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables =
  Exact<{
    input: CreateIngestionDocumentValidationFeedbackInput;
  }>;

export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation =
  {
    __typename?: "Mutation";
    internalCreateOrUpdateIngestionDocumentValidationFeedback: {
      __typename?: "IngestionDocumentValidationFeedbackObject";
      id: string;
      feedbackType: FeedbackType;
      source: FeedbackSource;
      comment?: string | undefined;
      createdByUserUuid: string;
      updatedByUserUuid: string;
      createdAt: any;
      updatedAt: any;
      ruleUuid?: string | undefined;
      contractDocumentUuid?: string | undefined;
      ingestionDocumentValidation?:
        | { __typename?: "IngestionDocumentValidationObject"; id: string }
        | undefined;
    };
  };

export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables =
  Exact<{
    input: CreateIngestionFolderValidationFeedbackInput;
  }>;

export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation = {
  __typename?: "Mutation";
  internalCreateOrUpdateIngestionFolderValidationFeedback: {
    __typename?: "IngestionFolderValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ingestionFolderValidation?:
      | { __typename?: "IngestionFolderValidationObject"; id: string }
      | undefined;
  };
};

export type LabelIngestionDocumentClassificationMutationVariables = Exact<{
  input: OverrideIngestionDocumentClassificationInput;
}>;

export type LabelIngestionDocumentClassificationMutation = {
  __typename?: "Mutation";
  labelIngestionDocumentClassification: boolean;
};

export type ProduceStageChangedEventsMutationVariables = Exact<{
  input: ProduceStageChangedEventsInput;
}>;

export type ProduceStageChangedEventsMutation = {
  __typename?: "Mutation";
  produceStageChangedEvents: {
    __typename?: "ProduceStageChangedEventsPayload";
    producedCount: number;
    failedCount: number;
    success: boolean;
  };
};

export type ReassignIngestionFolderPipelinesMutationVariables = Exact<{
  input: ReassignIngestionFolderPipelinesInput;
}>;

export type ReassignIngestionFolderPipelinesMutation = {
  __typename?: "Mutation";
  reassignIngestionFolderPipelines: {
    __typename?: "ReassignIngestionFolderPipelinesPayload";
    success: boolean;
    jobId?: string | undefined;
    itemCount: number;
    message?: string | undefined;
  };
};

export type RunIngestionDocumentValidationLlmAsJudgeMutationVariables = Exact<{
  input: RunIngestionDocumentValidationLlmAsJudgeInput;
}>;

export type RunIngestionDocumentValidationLlmAsJudgeMutation = {
  __typename?: "Mutation";
  runIngestionDocumentValidationLlmAsJudge: {
    __typename?: "RunIngestionDocumentValidationLlmAsJudgePayload";
    llmAnalysis?: string | undefined;
    llmOutput: boolean;
  };
};

export type SaveCheckboxExportDatasetMutationVariables = Exact<{
  input: SaveCheckboxExportDatasetInput;
}>;

export type SaveCheckboxExportDatasetMutation = {
  __typename?: "Mutation";
  saveCheckboxExportDataset?: boolean | undefined;
};

export type SaveComplianceGroupTransactionStageByTypeMutationVariables = Exact<{
  input: SaveComplianceGroupTransactionStageByTypeInput;
}>;

export type SaveComplianceGroupTransactionStageByTypeMutation = {
  __typename?: "Mutation";
  saveComplianceGroupTransactionStageByType: {
    __typename?: "ComplianceGroupTransactionStageObject";
    id: string;
    organizationUuid: string;
    complianceGroupId: string;
    complianceGroupName: string;
    transactionStageType: TransactionStageType;
  };
};

export type SaveSignatureInitialDatasetMutationVariables = Exact<{
  input: SaveSignatureInitialDatasetInput;
}>;

export type SaveSignatureInitialDatasetMutation = {
  __typename?: "Mutation";
  saveSignatureInitialDataset?: boolean | undefined;
};

export type SaveSignatureInitialValidationsMutationVariables = Exact<{
  input: SaveSignatureInitialDatasetInput;
}>;

export type SaveSignatureInitialValidationsMutation = {
  __typename?: "Mutation";
  saveSignatureInitialValidations?: boolean | undefined;
};

export type SetDocumentVersionAsActiveMutationVariables = Exact<{
  input: SetDocumentVersionAsActiveInput;
}>;

export type SetDocumentVersionAsActiveMutation = {
  __typename?: "Mutation";
  setDocumentVersionAsActive?:
    | {
        __typename?: "SetDocumentVersionAsActivePayload";
        documentVersion?:
          | {
              __typename?: "DocumentVersionObject";
              id: string;
              document: {
                __typename?: "DocumentObject";
                id: string;
                documentVersions: Array<{
                  __typename?: "DocumentVersionObject";
                  id: string;
                  status: DocumentVersionStatus;
                }>;
              };
            }
          | undefined;
      }
    | undefined;
};

export type SyncAcroformToDocumentVersionFieldsMutationVariables = Exact<{
  input: SyncAcroformToDocumentVersionFieldsInput;
}>;

export type SyncAcroformToDocumentVersionFieldsMutation = {
  __typename?: "Mutation";
  syncAcroformToDocumentVersionFields?:
    | {
        __typename?: "DocumentVersionPayload";
        documentVersion?:
          | {
              __typename?: "DocumentVersionObject";
              id: string;
              documentVersionFieldsCount?: number | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type SyncSecondaryDocumentVersionsMutationVariables = Exact<{
  input: SyncSecondaryDocumentVersionsInput;
}>;

export type SyncSecondaryDocumentVersionsMutation = {
  __typename?: "Mutation";
  syncSecondaryDocumentVersions?:
    | {
        __typename?: "DocumentVersionPayload";
        documentVersion?:
          | {
              __typename?: "DocumentVersionObject";
              id: string;
              secondaryDocumentVersions: Array<{
                __typename?: "SecondaryDocumentVersionObject";
                id: string;
                ordering: number;
                rules: Array<{
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  errorMessageTemplate?: string | undefined;
                  focusFieldMappingKeys?: Array<string> | undefined;
                  contextForLLMJudge?: string | undefined;
                  ruleType: RuleType;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                }>;
                secondaryDocumentVersion: {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  version: string;
                  status: DocumentVersionStatus;
                  searchRegex?: string | undefined;
                  file: {
                    __typename?: "FileObject";
                    fileName: string;
                    url: string;
                  };
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                    name: string;
                    description: string;
                    form: string;
                    usState: UsState;
                    includeInOfferIngestion: boolean;
                    llmExtraction: boolean;
                    updatedAt?: any | undefined;
                  };
                };
              }>;
            }
          | undefined;
      }
    | undefined;
};

export type SyncAllTransactionPipelinesToProductionMutationVariables = Exact<{
  [key: string]: never;
}>;

export type SyncAllTransactionPipelinesToProductionMutation = {
  __typename?: "Mutation";
  syncAllTransactionPipelinesToProduction: {
    __typename?: "SyncTransactionPipelinesPayload";
    success: boolean;
    message?: string | undefined;
    workflowRunId?: string | undefined;
  };
};

export type TriggerBatchValidationRerunMutationVariables = Exact<{
  folderIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  recalculateStage?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type TriggerBatchValidationRerunMutation = {
  __typename?: "Mutation";
  triggerBatchValidationRerun: {
    __typename?: "BatchValidationRerunResult";
    success: boolean;
    queuedCount: number;
    message?: string | undefined;
  };
};

export type UpdateAutofillMutationVariables = Exact<{
  input: UpdateAutofillInput;
}>;

export type UpdateAutofillMutation = {
  __typename?: "Mutation";
  updateAutofill?:
    | {
        __typename?: "UpdateAutofillPayload";
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateCheckboxDatasetMutationVariables = Exact<{
  input: UpdateCheckboxDatasetInput;
}>;

export type UpdateCheckboxDatasetMutation = {
  __typename?: "Mutation";
  updateCheckboxDataset: {
    __typename?: "UpdateCheckboxDatasetPayload";
    success: boolean;
  };
};

export type UpdateComplianceKeyTermSectionFieldsMutationVariables = Exact<{
  input: UpdateComplianceKeyTermSectionFieldsInput;
}>;

export type UpdateComplianceKeyTermSectionFieldsMutation = {
  __typename?: "Mutation";
  updateComplianceKeyTermSectionFields: {
    __typename?: "UpdateComplianceKeyTermSectionFieldsPayload";
    complianceKeyTermSectionFields?:
      | Array<{
          __typename?: "ComplianceKeyTermSectionFieldObject";
          id: string;
          order: number;
          helpText?: string | undefined;
          fieldsToColumn: {
            __typename?: "FieldsToColumnObject";
            id: string;
            columnName: string;
            visibility: ColumnVisibility;
            fieldType: FieldType;
            documentCategory?: DocumentCategory | undefined;
            fields: Array<{
              __typename?: "FieldObject";
              id: string;
              group: string;
              label: string;
              displayLabel?: string | undefined;
              mappingKey: string;
              fieldType: FieldType;
              isComputed?: boolean | undefined;
              isHidden?: boolean | undefined;
              readOnly?: boolean | undefined;
              aiExtract?: boolean | undefined;
              aiInterpret?: boolean | undefined;
              comparisonType?: ComparisonType | undefined;
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
            }>;
            transformAutofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  variableSources: Array<VariableSource>;
                  formula?: string | undefined;
                  variableField?:
                    | {
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }
                    | undefined;
                  formulaVariableFields: Array<{
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }>;
                  formulaTestCases: Array<{
                    __typename?: "FormulaTestCaseObject";
                    values: Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >;
                    expected: string;
                    llmOutput?: boolean | undefined;
                  }>;
                  documents?:
                    | Array<{
                        __typename?: "DocumentCompactObject";
                        id: string;
                        name: string;
                        description: string;
                        documentCategory?: DocumentCategory | undefined;
                        documentType: DocumentType;
                        form: string;
                        usState: UsState;
                      }>
                    | undefined;
                }
              | undefined;
          };
        }>
      | undefined;
  };
};

export type UpdateComplianceKeyTermSectionsMutationVariables = Exact<{
  inputs:
    | Array<UpdateComplianceKeyTermSectionInput>
    | UpdateComplianceKeyTermSectionInput;
}>;

export type UpdateComplianceKeyTermSectionsMutation = {
  __typename?: "Mutation";
  updateComplianceKeyTermSections: {
    __typename?: "UpdateComplianceKeyTermSectionsPayload";
    complianceKeyTermSections?:
      | Array<{
          __typename?: "ComplianceKeyTermSectionObject";
          id: string;
          title: string;
          description: string;
          order: number;
          documentSectionType: DocumentSectionType;
          category: ComplianceKeyTermCategory;
          organizationUuid?: string | undefined;
          parent?:
            | {
                __typename?: "ComplianceKeyTermSectionObject";
                id: string;
                title: string;
                description: string;
              }
            | undefined;
          complianceKeyTermSectionFields?:
            | Array<{
                __typename?: "ComplianceKeyTermSectionFieldObject";
                id: string;
                order: number;
                helpText?: string | undefined;
                fieldsToColumn: {
                  __typename?: "FieldsToColumnObject";
                  id: string;
                  columnName: string;
                  visibility: ColumnVisibility;
                  fieldType: FieldType;
                  documentCategory?: DocumentCategory | undefined;
                  fields: Array<{
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                  }>;
                  transformAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                };
              }>
            | undefined;
        }>
      | undefined;
  };
};

export type UpdateComplianceKeyTermSectionsOrderMutationVariables = Exact<{
  inputs:
    | Array<UpdateComplianceKeyTermSectionsOrderInput>
    | UpdateComplianceKeyTermSectionsOrderInput;
}>;

export type UpdateComplianceKeyTermSectionsOrderMutation = {
  __typename?: "Mutation";
  updateComplianceKeyTermSectionsOrder: {
    __typename?: "UpdateComplianceKeyTermSectionsPayload";
    complianceKeyTermSections?:
      | Array<{
          __typename?: "ComplianceKeyTermSectionObject";
          id: string;
          title: string;
          description: string;
          order: number;
          documentSectionType: DocumentSectionType;
          category: ComplianceKeyTermCategory;
          organizationUuid?: string | undefined;
          parent?:
            | {
                __typename?: "ComplianceKeyTermSectionObject";
                id: string;
                title: string;
                description: string;
              }
            | undefined;
          complianceKeyTermSectionFields?:
            | Array<{
                __typename?: "ComplianceKeyTermSectionFieldObject";
                id: string;
                order: number;
                helpText?: string | undefined;
                fieldsToColumn: {
                  __typename?: "FieldsToColumnObject";
                  id: string;
                  columnName: string;
                  visibility: ColumnVisibility;
                  fieldType: FieldType;
                  documentCategory?: DocumentCategory | undefined;
                  fields: Array<{
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                  }>;
                  transformAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                };
              }>
            | undefined;
        }>
      | undefined;
  };
};

export type UpdateContractMutationVariables = Exact<{
  input: UpdateContractInput;
}>;

export type UpdateContractMutation = {
  __typename?: "Mutation";
  updateContract: {
    __typename?: "ContractPayload";
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
        }
      | undefined;
  };
};

export type UpdateContractDocumentCustomFieldsMutationVariables = Exact<{
  input: UpdateContractDocumentCustomFieldsInput;
}>;

export type UpdateContractDocumentCustomFieldsMutation = {
  __typename?: "Mutation";
  updateContractDocumentCustomFields: {
    __typename?: "ContractDocumentObject";
    id: string;
    fields?:
      | Array<{
          __typename?: "DocumentVersionFieldObject";
          id: string;
          align: FieldAlign;
          pageNumber: number;
          fontFamily: string;
          fontSize: string;
          label: string;
          readOnly?: boolean | undefined;
          width: number;
          height: number;
          x: number;
          y: number;
          mappingKey: string;
          fieldType: FieldType;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          boundingBox: {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          };
          labelBoundingBox?:
            | {
                __typename?: "BoundingBoxObject";
                left: number;
                top: number;
                right: number;
                bottom: number;
              }
            | undefined;
          labelField?:
            | {
                __typename?: "LabelFieldObject";
                height: number;
                width: number;
                x: number;
                y: number;
              }
            | undefined;
        }>
      | undefined;
  };
};

export type UpdateContractDocumentsMutationVariables = Exact<{
  input: UpdateContractDocumentsInput;
}>;

export type UpdateContractDocumentsMutation = {
  __typename?: "Mutation";
  updateContractDocuments: {
    __typename?: "ContractPayload";
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            order: number;
            externalDocumentType?: ExternalDocumentType | undefined;
            externalDocumentName?: string | undefined;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  mappingKeys: Array<string>;
                  version: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
          }>;
        }
      | undefined;
  };
};

export type UpdateDefaultSecondaryDocumentsMutationVariables = Exact<{
  input:
    | Array<UpdateDefaultSecondaryDocumentInput>
    | UpdateDefaultSecondaryDocumentInput;
}>;

export type UpdateDefaultSecondaryDocumentsMutation = {
  __typename?: "Mutation";
  updateDefaultSecondaryDocuments?:
    | {
        __typename?: "UpdateDefaultSecondaryDocumentsPayload";
        defaultSecondaryDocuments?:
          | Array<{
              __typename?: "DefaultSecondaryDocumentObject";
              id: string;
              ordering: number;
              mappingKey: string;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    errorMessageTemplate?: string | undefined;
                    focusFieldMappingKeys?: Array<string> | undefined;
                    contextForLLMJudge?: string | undefined;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
              secondaryDocument: {
                __typename?: "DocumentObject";
                id: string;
                documentType: DocumentType;
                form: string;
                name: string;
                usState: UsState;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;

export type UpdateDocumentMutation = {
  __typename?: "Mutation";
  updateDocument?:
    | {
        __typename?: "UpdateDocumentPayload";
        document?:
          | {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              description: string;
              form: string;
              usState: UsState;
              includeInOfferIngestion: boolean;
              llmExtraction: boolean;
              updatedAt?: any | undefined;
              subsetOfDocument?:
                | {
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    form: string;
                    usState: UsState;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateDocumentLlmMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: DocumentLlmInput;
  isDetail?: Scalars["Boolean"]["input"];
}>;

export type UpdateDocumentLlmMutation = {
  __typename?: "Mutation";
  updateDocumentLLM?:
    | {
        __typename?: "DocumentLLMObject";
        id: string;
        documentCategory?: DocumentCategory | undefined;
        context?: string;
        pages?: Array<number>;
        extractSchema?: Array<{
          __typename?: "LLMExtractSchemaObject";
          key: string;
          description: string;
          outputType: LlmOutputSchemaType;
          enumValues?: Array<string> | undefined;
          fieldType?: FieldType | undefined;
        }>;
        documents: Array<{
          __typename?: "DocumentObject";
          id: string;
          name: string;
          form: string;
          usState: UsState;
          documentType: DocumentType;
        }>;
        examples?: Array<{
          __typename?: "DocumentLLMExampleObject";
          id: string;
          file: { __typename?: "FileObject"; fileName: string; url: string };
        }>;
      }
    | undefined;
};

export type UpdateDocumentSectionFieldsMutationVariables = Exact<{
  input: UpdateDocumentSectionFieldsInput;
}>;

export type UpdateDocumentSectionFieldsMutation = {
  __typename?: "Mutation";
  updateDocumentSectionFields: {
    __typename?: "UpdateDocumentSectionFieldsPayload";
    documentSectionFields?:
      | Array<{ __typename?: "DocumentSectionFieldObject"; id: string }>
      | undefined;
  };
};

export type UpdateDocumentSectionsMutationVariables = Exact<{
  inputs: Array<UpdateDocumentSectionInput> | UpdateDocumentSectionInput;
}>;

export type UpdateDocumentSectionsMutation = {
  __typename?: "Mutation";
  updateDocumentSections: {
    __typename?: "UpdateDocumentSectionsPayload";
    documentSections?:
      | Array<{
          __typename?: "DocumentSectionObject";
          id: string;
          description: string;
          documentSectionDisplayType: DocumentSectionDisplayType;
          documentSectionType: DocumentSectionType;
          documentSectionCategory: DocumentSectionCategory;
          documentSectionModuleType?: DocumentSectionModuleType | undefined;
          title: string;
          order: number;
          parent?:
            | {
                __typename?: "DocumentSectionObject";
                id: string;
                description: string;
              }
            | undefined;
          documentSectionFields?:
            | Array<{
                __typename?: "DocumentSectionFieldObject";
                id: string;
                order: number;
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  group: string;
                  label: string;
                  displayLabel?: string | undefined;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  aiExtract?: boolean | undefined;
                  aiInterpret?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  optionsAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  helpTextAutofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  defaultRules?:
                    | Array<{
                        __typename?: "RuleObject";
                        id: string;
                        message: string;
                        errorMessageTemplate?: string | undefined;
                        focusFieldMappingKeys?: Array<string> | undefined;
                        contextForLLMJudge?: string | undefined;
                        ruleType: RuleType;
                        autofill?:
                          | {
                              __typename?: "AutofillObject";
                              id: string;
                              variableSources: Array<VariableSource>;
                              formula?: string | undefined;
                              variableField?:
                                | {
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }
                                | undefined;
                              formulaVariableFields: Array<{
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }>;
                              formulaTestCases: Array<{
                                __typename?: "FormulaTestCaseObject";
                                values: Record<
                                  string,
                                  | string
                                  | number
                                  | boolean
                                  | string[]
                                  | undefined
                                >;
                                expected: string;
                                llmOutput?: boolean | undefined;
                              }>;
                              documents?:
                                | Array<{
                                    __typename?: "DocumentCompactObject";
                                    id: string;
                                    name: string;
                                    description: string;
                                    documentCategory?:
                                      | DocumentCategory
                                      | undefined;
                                    documentType: DocumentType;
                                    form: string;
                                    usState: UsState;
                                  }>
                                | undefined;
                            }
                          | undefined;
                      }>
                    | undefined;
                };
              }>
            | undefined;
        }>
      | undefined;
  };
};

export type UpdateDocumentSectionsOrderMutationVariables = Exact<{
  inputs:
    | Array<UpdateDocumentSectionsOrderInput>
    | UpdateDocumentSectionsOrderInput;
}>;

export type UpdateDocumentSectionsOrderMutation = {
  __typename?: "Mutation";
  updateDocumentSectionsOrder: {
    __typename?: "UpdateDocumentSectionsPayload";
    documentSections?:
      | Array<{ __typename?: "DocumentSectionObject"; id: string }>
      | undefined;
  };
};

export type UpdateDocumentVersionMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  input: UpdateDocumentVersionInput;
}>;

export type UpdateDocumentVersionMutation = {
  __typename?: "Mutation";
  updateDocumentVersion?:
    | {
        __typename?: "DocumentVersionPayload";
        documentVersion?:
          | {
              __typename?: "DocumentVersionObject";
              id: string;
              version: string;
              searchRegex?: string | undefined;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
      }
    | undefined;
};

export type UpdateDocumentVersionFieldsMutationVariables = Exact<{
  inputs:
    | Array<UpdateDocumentVersionFieldInput>
    | UpdateDocumentVersionFieldInput;
}>;

export type UpdateDocumentVersionFieldsMutation = {
  __typename?: "Mutation";
  updateDocumentVersionFields?:
    | {
        __typename?: "UpdateDocumentVersionFieldsPayload";
        documentVersionFields: Array<{
          __typename?: "DocumentVersionFieldObject";
          id: string;
          align: FieldAlign;
          pageNumber: number;
          fontFamily: string;
          fontSize: string;
          label: string;
          readOnly?: boolean | undefined;
          width: number;
          height: number;
          x: number;
          y: number;
          mappingKey: string;
          fieldType: FieldType;
          field: {
            __typename?: "FieldObject";
            id: string;
            group: string;
            label: string;
            displayLabel?: string | undefined;
            mappingKey: string;
            fieldType: FieldType;
            isComputed?: boolean | undefined;
            isHidden?: boolean | undefined;
            readOnly?: boolean | undefined;
            aiExtract?: boolean | undefined;
            aiInterpret?: boolean | undefined;
            comparisonType?: ComparisonType | undefined;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
          };
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          boundingBox: {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          };
          labelBoundingBox?:
            | {
                __typename?: "BoundingBoxObject";
                left: number;
                top: number;
                right: number;
                bottom: number;
              }
            | undefined;
          labelField?:
            | {
                __typename?: "LabelFieldObject";
                height: number;
                width: number;
                x: number;
                y: number;
              }
            | undefined;
        }>;
      }
    | undefined;
};

export type UpdateFieldMutationVariables = Exact<{
  input: UpdateFieldInput;
}>;

export type UpdateFieldMutation = {
  __typename?: "Mutation";
  updateField?:
    | {
        __typename?: "UpdateFieldPayload";
        field?:
          | {
              __typename?: "FieldObject";
              id: string;
              group: string;
              label: string;
              displayLabel?: string | undefined;
              mappingKey: string;
              fieldType: FieldType;
              isComputed?: boolean | undefined;
              isHidden?: boolean | undefined;
              readOnly?: boolean | undefined;
              aiExtract?: boolean | undefined;
              aiInterpret?: boolean | undefined;
              comparisonType?: ComparisonType | undefined;
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              optionsAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              helpTextAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    errorMessageTemplate?: string | undefined;
                    focusFieldMappingKeys?: Array<string> | undefined;
                    contextForLLMJudge?: string | undefined;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateOrCreateFieldsToColumnMutationVariables = Exact<{
  input: UpdateOrCreateFieldsToColumnInput;
}>;

export type UpdateOrCreateFieldsToColumnMutation = {
  __typename?: "Mutation";
  updateOrCreateFieldsToColumn?:
    | {
        __typename?: "FieldsToColumnObject";
        id: string;
        columnName: string;
        visibility: ColumnVisibility;
        fieldType: FieldType;
        documentCategory?: DocumentCategory | undefined;
        fields: Array<{
          __typename?: "FieldObject";
          id: string;
          group: string;
          label: string;
          displayLabel?: string | undefined;
          mappingKey: string;
          fieldType: FieldType;
          isComputed?: boolean | undefined;
          isHidden?: boolean | undefined;
          readOnly?: boolean | undefined;
          aiExtract?: boolean | undefined;
          aiInterpret?: boolean | undefined;
          comparisonType?: ComparisonType | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
        }>;
        transformAutofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateOrCreateTransactionRuleMutationVariables = Exact<{
  input: UpdateOrCreateTransactionRuleInput;
}>;

export type UpdateOrCreateTransactionRuleMutation = {
  __typename?: "Mutation";
  updateOrCreateTransactionRule?:
    | {
        __typename?: "TransactionRuleObject";
        id: string;
        targetDocumentCategory?: DocumentCategory | undefined;
        isRequiredDocument: boolean;
        targetDocument?:
          | {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              documentCategory?: DocumentCategory | undefined;
            }
          | undefined;
        stageRequirementTransactionStage?:
          | {
              __typename?: "TransactionStageObject";
              id: string;
              stage: TransactionStageType;
              sortOrder: number;
            }
          | undefined;
        validationTransactionStage?:
          | {
              __typename?: "TransactionStageObject";
              id: string;
              stage: TransactionStageType;
              sortOrder: number;
            }
          | undefined;
        rules: Array<{
          __typename?: "RuleObject";
          id: string;
          message: string;
          ruleType: RuleType;
        }>;
      }
    | undefined;
};

export type UpdateOrCreateTransactionStageMutationVariables = Exact<{
  input: UpdateOrCreateTransactionStageInput;
}>;

export type UpdateOrCreateTransactionStageMutation = {
  __typename?: "Mutation";
  updateOrCreateTransactionStage?:
    | {
        __typename?: "TransactionStageObject";
        id: string;
        stage: TransactionStageType;
        sortOrder: number;
        transactionPipeline: {
          __typename?: "TransactionPipelineObject";
          id: string;
          clientType: ClientType;
          usState: UsState;
          transactionPropertyType: TransactionPropertyType;
        };
      }
    | undefined;
};

export type UpdateOrganizationFolderNameValidationStageOverrideMutationVariables =
  Exact<{
    input: UpdateOrganizationFolderNameValidationStageOverrideInput;
  }>;

export type UpdateOrganizationFolderNameValidationStageOverrideMutation = {
  __typename?: "Mutation";
  updateOrganizationFolderNameValidationStageOverride: {
    __typename?: "OrganizationFolderNameValidationStageOverrideObject";
    organizationUuid: string;
    isEnabled: boolean;
    keywordMappings: Array<{
      __typename?: "FolderNameValidationStageKeywordMappingObject";
      keyword: string;
      action: FolderNameValidationStageOverrideAction;
      transactionStageType?: TransactionStageType | undefined;
    }>;
  };
};

export type UpdateOrganizationValidationSettingsMutationVariables = Exact<{
  input: UpdateOrganizationValidationSettingsInput;
}>;

export type UpdateOrganizationValidationSettingsMutation = {
  __typename?: "Mutation";
  updateOrganizationValidationSettings: {
    __typename?: "OrganizationValidationSettingsObject";
    stageIgnoredRuleIds: Array<string>;
    documentIgnoredRuleIds: Array<string>;
  };
};

export type UpdateRuleMutationVariables = Exact<{
  input: UpdateRuleInput;
}>;

export type UpdateRuleMutation = {
  __typename?: "Mutation";
  updateRule?:
    | {
        __typename?: "UpdateRulePayload";
        rule?:
          | {
              __typename?: "RuleObject";
              id: string;
              message: string;
              errorMessageTemplate?: string | undefined;
              focusFieldMappingKeys?: Array<string> | undefined;
              contextForLLMJudge?: string | undefined;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateRulesForTransactionRuleMutationVariables = Exact<{
  input: UpdateRulesForTransactionRuleInput;
}>;

export type UpdateRulesForTransactionRuleMutation = {
  __typename?: "Mutation";
  updateRulesForTransactionRule?:
    | {
        __typename?: "TransactionRuleObject";
        id: string;
        rules: Array<{
          __typename?: "RuleObject";
          id: string;
          message: string;
          ruleType: RuleType;
        }>;
      }
    | undefined;
};

export type UpdateSecondaryDocumentVersionMutationVariables = Exact<{
  input: UpdateSecondaryDocumentVersionInput;
}>;

export type UpdateSecondaryDocumentVersionMutation = {
  __typename?: "Mutation";
  updateSecondaryDocumentVersion: {
    __typename?: "SecondaryDocumentVersionPayload";
    secondaryDocumentVersion?:
      | {
          __typename?: "SecondaryDocumentVersionObject";
          id: string;
          ordering: number;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            errorMessageTemplate?: string | undefined;
            focusFieldMappingKeys?: Array<string> | undefined;
            contextForLLMJudge?: string | undefined;
            ruleType: RuleType;
            autofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  variableSources: Array<VariableSource>;
                  formula?: string | undefined;
                  variableField?:
                    | {
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }
                    | undefined;
                  formulaVariableFields: Array<{
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }>;
                  formulaTestCases: Array<{
                    __typename?: "FormulaTestCaseObject";
                    values: Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >;
                    expected: string;
                    llmOutput?: boolean | undefined;
                  }>;
                  documents?:
                    | Array<{
                        __typename?: "DocumentCompactObject";
                        id: string;
                        name: string;
                        description: string;
                        documentCategory?: DocumentCategory | undefined;
                        documentType: DocumentType;
                        form: string;
                        usState: UsState;
                      }>
                    | undefined;
                }
              | undefined;
          }>;
          secondaryDocumentVersion: {
            __typename?: "DocumentVersionObject";
            id: string;
            version: string;
            status: DocumentVersionStatus;
            searchRegex?: string | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
            document: {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              description: string;
              form: string;
              usState: UsState;
              includeInOfferIngestion: boolean;
              llmExtraction: boolean;
              updatedAt?: any | undefined;
            };
          };
        }
      | undefined;
  };
};

export type UpdateSignatureInitialsDatasetMutationVariables = Exact<{
  input: UpdateSignatureInitialsDatasetInput;
}>;

export type UpdateSignatureInitialsDatasetMutation = {
  __typename?: "Mutation";
  updateSignatureInitialsDataset: {
    __typename?: "UpdateSignatureInitialsDatasetPayload";
    success: boolean;
    key?: string | undefined;
  };
};

export type UpdateSortOrderMutationVariables = Exact<{
  inputs: Array<UpdateSortOrderInput> | UpdateSortOrderInput;
}>;

export type UpdateSortOrderMutation = {
  __typename?: "Mutation";
  updateSortOrder: Array<{
    __typename?: "TransactionStageObject";
    id: string;
    stage: TransactionStageType;
    sortOrder: number;
    transactionPipeline: {
      __typename?: "TransactionPipelineObject";
      id: string;
      clientType: ClientType;
      usState: UsState;
      transactionPropertyType: TransactionPropertyType;
    };
  }>;
};

export type UpdateTransactionRuleParentMutationVariables = Exact<{
  input: UpdateTransactionRuleParentInput;
}>;

export type UpdateTransactionRuleParentMutation = {
  __typename?: "Mutation";
  updateTransactionRuleParent?:
    | Array<{
        __typename?: "TransactionRuleObject";
        id: string;
        organizationUuid?: string | undefined;
        targetDocumentCategory?: DocumentCategory | undefined;
        isRequiredDocument: boolean;
        logicalOperator: LogicalOperator;
        updatedAt: any;
        targetDocument?:
          | {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              description: string;
              form: string;
              usState: UsState;
              includeInOfferIngestion: boolean;
              llmExtraction: boolean;
              updatedAt?: any | undefined;
            }
          | undefined;
        parent?:
          | { __typename?: "TransactionRuleObject"; id: string }
          | undefined;
        offerIngestionRule?:
          | {
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }
          | undefined;
        children: Array<{
          __typename?: "TransactionRuleObject";
          organizationUuid?: string | undefined;
          id: string;
          targetDocumentCategory?: DocumentCategory | undefined;
          logicalOperator: LogicalOperator;
          updatedAt: any;
          isRequiredDocument: boolean;
          offerIngestionRule?:
            | {
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }
            | undefined;
          parent?:
            | { __typename?: "TransactionRuleObject"; id: string }
            | undefined;
          targetDocument?:
            | {
                __typename?: "DocumentObject";
                id: string;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
                name: string;
                description: string;
                form: string;
                usState: UsState;
                includeInOfferIngestion: boolean;
                llmExtraction: boolean;
                updatedAt?: any | undefined;
              }
            | undefined;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            ruleType: RuleType;
          }>;
        }>;
        rules: Array<{
          __typename?: "RuleObject";
          id: string;
          message: string;
          ruleType: RuleType;
        }>;
      }>
    | undefined;
};

export type ValidateTransactionPipelineMutationVariables = Exact<{
  input: ValidateTransactionPipelineInput;
}>;

export type ValidateTransactionPipelineMutation = {
  __typename?: "Mutation";
  validateTransactionPipeline: {
    __typename?: "ValidateTransactionPipelinePayload";
    documentValidations: Array<{
      __typename?: "DocumentValidationResult";
      contractDocumentId: string;
      documentVersionId: string;
      documentName?: string | undefined;
      documentForm?: string | undefined;
      documentCategory?: DocumentCategory | undefined;
      ingestionDocumentId?: string | undefined;
      validations: Array<{
        __typename?: "DocumentValidationFieldResult";
        field: {
          __typename?: "FieldObject";
          id: string;
          label: string;
          mappingKey: string;
          fieldType: FieldType;
          displayLabel?: string | undefined;
        };
        documentVersionField: {
          __typename?: "DocumentVersionFieldObject";
          id: string;
          fieldType: FieldType;
          displayLabel?: string | undefined;
          label: string;
          mappingKey: string;
          pageNumber: number;
          x: number;
          y: number;
          width: number;
          height: number;
        };
        results: Array<{
          __typename?: "GenericRuleValidationObject";
          message: string;
          focusFieldMappingKeys?: Array<string> | undefined;
          isEnabled: boolean;
          isDisabled: boolean;
          hasError: boolean;
          hasWarning: boolean;
          passedRequirement: boolean;
          output?: any | undefined;
          rule: {
            __typename?: "RuleObject";
            id: string;
            message: string;
            errorMessageTemplate?: string | undefined;
            focusFieldMappingKeys?: Array<string> | undefined;
            contextForLLMJudge?: string | undefined;
            ruleType: RuleType;
            autofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  variableSources: Array<VariableSource>;
                  formula?: string | undefined;
                  variableField?:
                    | {
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }
                    | undefined;
                  formulaVariableFields: Array<{
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }>;
                  formulaTestCases: Array<{
                    __typename?: "FormulaTestCaseObject";
                    values: Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >;
                    expected: string;
                    llmOutput?: boolean | undefined;
                  }>;
                  documents?:
                    | Array<{
                        __typename?: "DocumentCompactObject";
                        id: string;
                        name: string;
                        description: string;
                        documentCategory?: DocumentCategory | undefined;
                        documentType: DocumentType;
                        form: string;
                        usState: UsState;
                      }>
                    | undefined;
                }
              | undefined;
          };
          inputValues?:
            | Array<{
                __typename?: "RuleValidationInputValue";
                value: string;
                fieldKey: string;
                variableSource?: VariableSource | undefined;
              }>
            | undefined;
        }>;
      }>;
    }>;
    pipelineValidations?:
      | Array<{
          __typename?: "PipelineValidationResult";
          contractDocumentId?: string | undefined;
          documentCategory?: DocumentCategory | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          operator?: LogicalOperator | undefined;
          children?:
            | Array<{
                __typename?: "PipelineValidationResult";
                contractDocumentId?: string | undefined;
                documentCategory?: DocumentCategory | undefined;
                documentForm?: string | undefined;
                documentName?: string | undefined;
                operator?: LogicalOperator | undefined;
                results?:
                  | Array<{
                      __typename?: "GenericRuleValidationObject";
                      message: string;
                      focusFieldMappingKeys?: Array<string> | undefined;
                      isEnabled: boolean;
                      isDisabled: boolean;
                      hasError: boolean;
                      hasWarning: boolean;
                      passedRequirement: boolean;
                      output?: any | undefined;
                      rule: {
                        __typename?: "RuleObject";
                        id: string;
                        message: string;
                        errorMessageTemplate?: string | undefined;
                        focusFieldMappingKeys?: Array<string> | undefined;
                        contextForLLMJudge?: string | undefined;
                        ruleType: RuleType;
                        autofill?:
                          | {
                              __typename?: "AutofillObject";
                              id: string;
                              variableSources: Array<VariableSource>;
                              formula?: string | undefined;
                              variableField?:
                                | {
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }
                                | undefined;
                              formulaVariableFields: Array<{
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }>;
                              formulaTestCases: Array<{
                                __typename?: "FormulaTestCaseObject";
                                values: Record<
                                  string,
                                  | string
                                  | number
                                  | boolean
                                  | string[]
                                  | undefined
                                >;
                                expected: string;
                                llmOutput?: boolean | undefined;
                              }>;
                              documents?:
                                | Array<{
                                    __typename?: "DocumentCompactObject";
                                    id: string;
                                    name: string;
                                    description: string;
                                    documentCategory?:
                                      | DocumentCategory
                                      | undefined;
                                    documentType: DocumentType;
                                    form: string;
                                    usState: UsState;
                                  }>
                                | undefined;
                            }
                          | undefined;
                      };
                      inputValues?:
                        | Array<{
                            __typename?: "RuleValidationInputValue";
                            value: string;
                            fieldKey: string;
                            variableSource?: VariableSource | undefined;
                          }>
                        | undefined;
                    }>
                  | undefined;
                requiredDocument?:
                  | {
                      __typename?: "RequiredDocumentResult";
                      isRequired: boolean;
                      isMissing?: boolean | undefined;
                      message?: string | undefined;
                    }
                  | undefined;
              }>
            | undefined;
          results?:
            | Array<{
                __typename?: "GenericRuleValidationObject";
                message: string;
                focusFieldMappingKeys?: Array<string> | undefined;
                isEnabled: boolean;
                isDisabled: boolean;
                hasError: boolean;
                hasWarning: boolean;
                passedRequirement: boolean;
                output?: any | undefined;
                rule: {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  errorMessageTemplate?: string | undefined;
                  focusFieldMappingKeys?: Array<string> | undefined;
                  contextForLLMJudge?: string | undefined;
                  ruleType: RuleType;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                };
                inputValues?:
                  | Array<{
                      __typename?: "RuleValidationInputValue";
                      value: string;
                      fieldKey: string;
                      variableSource?: VariableSource | undefined;
                    }>
                  | undefined;
              }>
            | undefined;
          requiredDocument?:
            | {
                __typename?: "RequiredDocumentResult";
                isRequired: boolean;
                isMissing?: boolean | undefined;
                message?: string | undefined;
              }
            | undefined;
        }>
      | undefined;
  };
};

export type DocumentValidationResultFragment = {
  __typename?: "DocumentValidationResult";
  contractDocumentId: string;
  documentVersionId: string;
  documentName?: string | undefined;
  documentForm?: string | undefined;
  documentCategory?: DocumentCategory | undefined;
  ingestionDocumentId?: string | undefined;
  validations: Array<{
    __typename?: "DocumentValidationFieldResult";
    field: {
      __typename?: "FieldObject";
      id: string;
      label: string;
      mappingKey: string;
      fieldType: FieldType;
      displayLabel?: string | undefined;
    };
    documentVersionField: {
      __typename?: "DocumentVersionFieldObject";
      id: string;
      fieldType: FieldType;
      displayLabel?: string | undefined;
      label: string;
      mappingKey: string;
      pageNumber: number;
      x: number;
      y: number;
      width: number;
      height: number;
    };
    results: Array<{
      __typename?: "GenericRuleValidationObject";
      message: string;
      focusFieldMappingKeys?: Array<string> | undefined;
      isEnabled: boolean;
      isDisabled: boolean;
      hasError: boolean;
      hasWarning: boolean;
      passedRequirement: boolean;
      output?: any | undefined;
      rule: {
        __typename?: "RuleObject";
        id: string;
        message: string;
        errorMessageTemplate?: string | undefined;
        focusFieldMappingKeys?: Array<string> | undefined;
        contextForLLMJudge?: string | undefined;
        ruleType: RuleType;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      };
      inputValues?:
        | Array<{
            __typename?: "RuleValidationInputValue";
            value: string;
            fieldKey: string;
            variableSource?: VariableSource | undefined;
          }>
        | undefined;
    }>;
  }>;
};

export type PipelineValidationResultFragment = {
  __typename?: "PipelineValidationResult";
  contractDocumentId?: string | undefined;
  documentCategory?: DocumentCategory | undefined;
  documentForm?: string | undefined;
  documentName?: string | undefined;
  operator?: LogicalOperator | undefined;
  children?:
    | Array<{
        __typename?: "PipelineValidationResult";
        contractDocumentId?: string | undefined;
        documentCategory?: DocumentCategory | undefined;
        documentForm?: string | undefined;
        documentName?: string | undefined;
        operator?: LogicalOperator | undefined;
        results?:
          | Array<{
              __typename?: "GenericRuleValidationObject";
              message: string;
              focusFieldMappingKeys?: Array<string> | undefined;
              isEnabled: boolean;
              isDisabled: boolean;
              hasError: boolean;
              hasWarning: boolean;
              passedRequirement: boolean;
              output?: any | undefined;
              rule: {
                __typename?: "RuleObject";
                id: string;
                message: string;
                errorMessageTemplate?: string | undefined;
                focusFieldMappingKeys?: Array<string> | undefined;
                contextForLLMJudge?: string | undefined;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
              };
              inputValues?:
                | Array<{
                    __typename?: "RuleValidationInputValue";
                    value: string;
                    fieldKey: string;
                    variableSource?: VariableSource | undefined;
                  }>
                | undefined;
            }>
          | undefined;
        requiredDocument?:
          | {
              __typename?: "RequiredDocumentResult";
              isRequired: boolean;
              isMissing?: boolean | undefined;
              message?: string | undefined;
            }
          | undefined;
      }>
    | undefined;
  results?:
    | Array<{
        __typename?: "GenericRuleValidationObject";
        message: string;
        focusFieldMappingKeys?: Array<string> | undefined;
        isEnabled: boolean;
        isDisabled: boolean;
        hasError: boolean;
        hasWarning: boolean;
        passedRequirement: boolean;
        output?: any | undefined;
        rule: {
          __typename?: "RuleObject";
          id: string;
          message: string;
          errorMessageTemplate?: string | undefined;
          focusFieldMappingKeys?: Array<string> | undefined;
          contextForLLMJudge?: string | undefined;
          ruleType: RuleType;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        };
        inputValues?:
          | Array<{
              __typename?: "RuleValidationInputValue";
              value: string;
              fieldKey: string;
              variableSource?: VariableSource | undefined;
            }>
          | undefined;
      }>
    | undefined;
  requiredDocument?:
    | {
        __typename?: "RequiredDocumentResult";
        isRequired: boolean;
        isMissing?: boolean | undefined;
        message?: string | undefined;
      }
    | undefined;
};

export type ValidateTransactionRuleOnProductionMutationVariables = Exact<{
  input: ValidateTransactionRuleOnProductionInput;
}>;

export type ValidateTransactionRuleOnProductionMutation = {
  __typename?: "Mutation";
  validateTransactionRuleOnProduction: {
    __typename?: "ValidateTransactionRuleOnProductionPayload";
    success: boolean;
    error?: string | undefined;
    summary: {
      __typename?: "ValidationSummary";
      totalFoldersTested: number;
      foldersWithErrors: number;
      foldersWithWarnings: number;
      foldersWithMissingRequiredDocs: number;
      totalErrors: number;
      totalWarnings: number;
    };
    results: Array<{
      __typename?: "FolderValidationResult";
      errorCount: number;
      warningCount: number;
      hasRequiredDocumentMissing: boolean;
      folder: {
        __typename?: "FolderMetadata";
        uuid: string;
        folderName: string;
        organizationUuid: string;
        stage?: TransactionStageType | undefined;
        platform?: string | undefined;
        folderUpdatedAt?: any | undefined;
      };
      pipelineValidations: Array<{
        __typename?: "ProductionPipelineValidationResult";
        operator?: LogicalOperator | undefined;
        contractDocumentId?: string | undefined;
        ingestionDocumentId?: string | undefined;
        ingestionDocumentName?: string | undefined;
        documentName?: string | undefined;
        documentForm?: string | undefined;
        documentCategory?: DocumentCategory | undefined;
        results?:
          | Array<{
              __typename?: "GenericRuleValidationResult";
              message?: string | undefined;
              output?: string | undefined;
              hasError?: boolean | undefined;
              hasWarning?: boolean | undefined;
              passedRequirement?: boolean | undefined;
              inputValues?:
                | Array<
                    Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  >
                | undefined;
            }>
          | undefined;
        children?:
          | Array<{
              __typename?: "ProductionPipelineValidationResult";
              operator?: LogicalOperator | undefined;
              results?:
                | Array<{
                    __typename?: "GenericRuleValidationResult";
                    message?: string | undefined;
                    output?: string | undefined;
                    hasError?: boolean | undefined;
                    hasWarning?: boolean | undefined;
                    passedRequirement?: boolean | undefined;
                    inputValues?:
                      | Array<
                          Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >
                        >
                      | undefined;
                  }>
                | undefined;
            }>
          | undefined;
        requiredDocument?:
          | {
              __typename?: "RequiredDocumentValidationResult";
              isRequired: boolean;
              isMissing?: boolean | undefined;
              message?: string | undefined;
            }
          | undefined;
      }>;
    }>;
  };
};

export type CheckDocumentVersionDuplicateQueryVariables = Exact<{
  input: CheckDocumentVersionDuplicateInput;
}>;

export type CheckDocumentVersionDuplicateQuery = {
  __typename?: "Query";
  checkDocumentVersionDuplicate: {
    __typename?: "CheckDocumentVersionDuplicatePayload";
    duplicates: Array<{
      __typename?: "DocumentVersionDuplicateObject";
      documentUuid: string;
      documentVersionUuid: string;
      documentName: string;
      version: string;
      form: string;
      pageCount: number;
    }>;
  };
};

export type CheckSignatureInitialDatasetExistsQueryVariables = Exact<{
  input: CheckSignatureInitialDatasetExistsInput;
}>;

export type CheckSignatureInitialDatasetExistsQuery = {
  __typename?: "Query";
  checkSignatureInitialDatasetExists: {
    __typename?: "CheckSignatureInitialDatasetExistsPayload";
    results: Array<{
      __typename?: "SignatureInitialDatasetExistsPayload";
      pageNumber: number;
      exists: boolean;
      key?: string | undefined;
    }>;
  };
};

export type CheckboxDatasetFilesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type CheckboxDatasetFilesQuery = {
  __typename?: "Query";
  checkboxDatasetFiles: {
    __typename?: "CheckboxDatasetFilesPayload";
    files: Array<{ __typename?: "CheckboxDatasetFilePayload"; key: string }>;
  };
};

export type CheckboxDatasetSignedUrlsQueryVariables = Exact<{
  input: CheckboxDatasetSignedUrlsInput;
}>;

export type CheckboxDatasetSignedUrlsQuery = {
  __typename?: "Query";
  checkboxDatasetSignedUrls: {
    __typename?: "GetSignedUrlsPayload";
    urls: Array<{
      __typename?: "SignedUrlPayload";
      key: string;
      signedUrl: string;
    }>;
  };
};

export type ComplianceKeyTermSectionListFragment = {
  __typename?: "ComplianceKeyTermSectionObject";
  id: string;
  title: string;
  description: string;
  order: number;
  documentSectionType: DocumentSectionType;
  category: ComplianceKeyTermCategory;
  organizationUuid?: string | undefined;
  parent?:
    | {
        __typename?: "ComplianceKeyTermSectionObject";
        id: string;
        title: string;
        description: string;
      }
    | undefined;
  complianceKeyTermSectionFields?:
    | Array<{
        __typename?: "ComplianceKeyTermSectionFieldObject";
        id: string;
        order: number;
        helpText?: string | undefined;
        fieldsToColumn: {
          __typename?: "FieldsToColumnObject";
          id: string;
          columnName: string;
          visibility: ColumnVisibility;
          fieldType: FieldType;
          documentCategory?: DocumentCategory | undefined;
          fields: Array<{
            __typename?: "FieldObject";
            id: string;
            group: string;
            label: string;
            displayLabel?: string | undefined;
            mappingKey: string;
            fieldType: FieldType;
            isComputed?: boolean | undefined;
            isHidden?: boolean | undefined;
            readOnly?: boolean | undefined;
            aiExtract?: boolean | undefined;
            aiInterpret?: boolean | undefined;
            comparisonType?: ComparisonType | undefined;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
          }>;
          transformAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        };
      }>
    | undefined;
};

export type ComplianceKeyTermSectionListQueryVariables = Exact<{
  filters?: InputMaybe<ComplianceKeyTermSectionListFilters>;
}>;

export type ComplianceKeyTermSectionListQuery = {
  __typename?: "Query";
  complianceKeyTermSectionList?:
    | {
        __typename?: "ComplianceKeyTermSectionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "ComplianceKeyTermSectionObject";
              id: string;
              title: string;
              description: string;
              order: number;
              documentSectionType: DocumentSectionType;
              category: ComplianceKeyTermCategory;
              organizationUuid?: string | undefined;
              parent?:
                | {
                    __typename?: "ComplianceKeyTermSectionObject";
                    id: string;
                    title: string;
                    description: string;
                  }
                | undefined;
              complianceKeyTermSectionFields?:
                | Array<{
                    __typename?: "ComplianceKeyTermSectionFieldObject";
                    id: string;
                    order: number;
                    helpText?: string | undefined;
                    fieldsToColumn: {
                      __typename?: "FieldsToColumnObject";
                      id: string;
                      columnName: string;
                      visibility: ColumnVisibility;
                      fieldType: FieldType;
                      documentCategory?: DocumentCategory | undefined;
                      fields: Array<{
                        __typename?: "FieldObject";
                        id: string;
                        group: string;
                        label: string;
                        displayLabel?: string | undefined;
                        mappingKey: string;
                        fieldType: FieldType;
                        isComputed?: boolean | undefined;
                        isHidden?: boolean | undefined;
                        readOnly?: boolean | undefined;
                        aiExtract?: boolean | undefined;
                        aiInterpret?: boolean | undefined;
                        comparisonType?: ComparisonType | undefined;
                        inputFormat?:
                          | {
                              __typename?: "InputFormatObject";
                              type: InputFormatType;
                              options: {
                                __typename?: "InputFormatOptionsObject";
                                precision?: number | undefined;
                                formatString?: string | undefined;
                                currencySymbol?: string | undefined;
                              };
                            }
                          | undefined;
                      }>;
                      transformAutofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                    };
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type ContractByIdQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
  resolveFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  documentML?: InputMaybe<Scalars["Boolean"]["input"]>;
  documentVersionFields?: InputMaybe<Scalars["Boolean"]["input"]>;
  extractedValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  documentVersionFile?: InputMaybe<Scalars["Boolean"]["input"]>;
  autofill?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ContractByIdQuery = {
  __typename?: "Query";
  contractById: {
    __typename?: "ContractObject";
    id: string;
    fieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    signatureRequests?:
      | Array<{
          __typename?: "SignatureRequestObject";
          id: string;
          provider: SignatureProvider;
          externalId: string;
          allSignedDocument?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>
      | undefined;
    extractedValues?:
      | Array<{
          __typename?: "ExtractedValues";
          values?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          mappedValuesBBox?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          signatureInitialsBBox?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          repositionedDocumentVersionFields?:
            | Array<
                Array<{
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  field: {
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                  };
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                  labelBoundingBox?:
                    | {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      }
                    | undefined;
                  labelField?:
                    | {
                        __typename?: "LabelFieldObject";
                        height: number;
                        width: number;
                        x: number;
                        y: number;
                      }
                    | undefined;
                }>
              >
            | undefined;
        }>
      | undefined;
    documentML?:
      | {
          __typename?: "DocumentMLObject";
          id: string;
          pdfFileUrl?: string | undefined;
          documentClassification: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          documentFile: {
            __typename?: "FileObject";
            fileName: string;
            url: string;
          };
        }
      | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      order: number;
      externalDocumentName?: string | undefined;
      externalDocumentType?: ExternalDocumentType | undefined;
      file: { __typename?: "FileObject"; fileName: string; url: string };
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            document: {
              __typename?: "DocumentObject";
              id: string;
              form: string;
              name: string;
              documentType: DocumentType;
            };
            file?: { __typename?: "FileObject"; fileName: string; url: string };
            documentVersionFields?: Array<{
              __typename?: "DocumentVersionFieldObject";
              id: string;
              align: FieldAlign;
              pageNumber: number;
              fontFamily: string;
              fontSize: string;
              label: string;
              readOnly?: boolean | undefined;
              width: number;
              height: number;
              x: number;
              y: number;
              mappingKey: string;
              fieldType: FieldType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              rules?: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                errorMessageTemplate?: string | undefined;
                focusFieldMappingKeys?: Array<string> | undefined;
                contextForLLMJudge?: string | undefined;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
              }>;
              field: {
                __typename?: "FieldObject";
                readOnly?: boolean | undefined;
                id: string;
                group: string;
                label: string;
                displayLabel?: string | undefined;
                mappingKey: string;
                fieldType: FieldType;
                isComputed?: boolean | undefined;
                isHidden?: boolean | undefined;
                aiExtract?: boolean | undefined;
                aiInterpret?: boolean | undefined;
                comparisonType?: ComparisonType | undefined;
                defaultRules?:
                  | Array<{
                      __typename?: "RuleObject";
                      id: string;
                      message: string;
                      errorMessageTemplate?: string | undefined;
                      focusFieldMappingKeys?: Array<string> | undefined;
                      contextForLLMJudge?: string | undefined;
                      ruleType: RuleType;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }>
                  | undefined;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
              };
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
              boundingBox: {
                __typename?: "BoundingBoxObject";
                left: number;
                top: number;
                right: number;
                bottom: number;
              };
              labelBoundingBox?:
                | {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  }
                | undefined;
              labelField?:
                | {
                    __typename?: "LabelFieldObject";
                    height: number;
                    width: number;
                    x: number;
                    y: number;
                  }
                | undefined;
            }>;
          }
        | undefined;
    }>;
  };
};

export type ContractFieldValuesFragment = {
  __typename?: "ContractObject";
  id: string;
  fieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
};

export type ContractFieldValuesQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  resolveFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ContractFieldValuesQuery = {
  __typename?: "Query";
  contractByIds: Array<{
    __typename?: "ContractObject";
    id: string;
    fieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
  }>;
};

export type ContractListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  filters?: InputMaybe<ContractListFilterArgs>;
  extractedValues?: Scalars["Boolean"]["input"];
  documentML?: Scalars["Boolean"]["input"];
  documentVersionFields?: Scalars["Boolean"]["input"];
  documentVersionFile?: Scalars["Boolean"]["input"];
  autofill?: Scalars["Boolean"]["input"];
}>;

export type ContractListQuery = {
  __typename?: "Query";
  contractList?:
    | {
        __typename?: "ContractObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "ContractObject";
              id: string;
              fieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              signatureRequests?:
                | Array<{
                    __typename?: "SignatureRequestObject";
                    id: string;
                    provider: SignatureProvider;
                    externalId: string;
                    allSignedDocument?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }>
                | undefined;
              extractedValues?:
                | Array<{
                    __typename?: "ExtractedValues";
                    values?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    mappedValuesBBox?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    signatureInitialsBBox?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    repositionedDocumentVersionFields?:
                      | Array<
                          Array<{
                            __typename?: "DocumentVersionFieldObject";
                            id: string;
                            align: FieldAlign;
                            pageNumber: number;
                            fontFamily: string;
                            fontSize: string;
                            label: string;
                            readOnly?: boolean | undefined;
                            width: number;
                            height: number;
                            x: number;
                            y: number;
                            mappingKey: string;
                            fieldType: FieldType;
                            field: {
                              __typename?: "FieldObject";
                              id: string;
                              group: string;
                              label: string;
                              displayLabel?: string | undefined;
                              mappingKey: string;
                              fieldType: FieldType;
                              isComputed?: boolean | undefined;
                              isHidden?: boolean | undefined;
                              readOnly?: boolean | undefined;
                              aiExtract?: boolean | undefined;
                              aiInterpret?: boolean | undefined;
                              comparisonType?: ComparisonType | undefined;
                              inputFormat?:
                                | {
                                    __typename?: "InputFormatObject";
                                    type: InputFormatType;
                                    options: {
                                      __typename?: "InputFormatOptionsObject";
                                      precision?: number | undefined;
                                      formatString?: string | undefined;
                                      currencySymbol?: string | undefined;
                                    };
                                  }
                                | undefined;
                            };
                            inputFormat?:
                              | {
                                  __typename?: "InputFormatObject";
                                  type: InputFormatType;
                                  options: {
                                    __typename?: "InputFormatOptionsObject";
                                    precision?: number | undefined;
                                    formatString?: string | undefined;
                                    currencySymbol?: string | undefined;
                                  };
                                }
                              | undefined;
                            boundingBox: {
                              __typename?: "BoundingBoxObject";
                              left: number;
                              top: number;
                              right: number;
                              bottom: number;
                            };
                            labelBoundingBox?:
                              | {
                                  __typename?: "BoundingBoxObject";
                                  left: number;
                                  top: number;
                                  right: number;
                                  bottom: number;
                                }
                              | undefined;
                            labelField?:
                              | {
                                  __typename?: "LabelFieldObject";
                                  height: number;
                                  width: number;
                                  x: number;
                                  y: number;
                                }
                              | undefined;
                          }>
                        >
                      | undefined;
                  }>
                | undefined;
              documentML?:
                | {
                    __typename?: "DocumentMLObject";
                    id: string;
                    pdfFileUrl?: string | undefined;
                    documentClassification: Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >;
                    documentFile: {
                      __typename?: "FileObject";
                      fileName: string;
                      url: string;
                    };
                  }
                | undefined;
              contractDocuments: Array<{
                __typename?: "ContractDocumentObject";
                id: string;
                order: number;
                externalDocumentName?: string | undefined;
                externalDocumentType?: ExternalDocumentType | undefined;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
                documentVersion?:
                  | {
                      __typename?: "DocumentVersionObject";
                      id: string;
                      document: {
                        __typename?: "DocumentObject";
                        id: string;
                        form: string;
                        name: string;
                        documentType: DocumentType;
                      };
                      file?: {
                        __typename?: "FileObject";
                        fileName: string;
                        url: string;
                      };
                      documentVersionFields?: Array<{
                        __typename?: "DocumentVersionFieldObject";
                        id: string;
                        align: FieldAlign;
                        pageNumber: number;
                        fontFamily: string;
                        fontSize: string;
                        label: string;
                        readOnly?: boolean | undefined;
                        width: number;
                        height: number;
                        x: number;
                        y: number;
                        mappingKey: string;
                        fieldType: FieldType;
                        autofill?:
                          | {
                              __typename?: "AutofillObject";
                              id: string;
                              variableSources: Array<VariableSource>;
                              formula?: string | undefined;
                              variableField?:
                                | {
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }
                                | undefined;
                              formulaVariableFields: Array<{
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }>;
                              formulaTestCases: Array<{
                                __typename?: "FormulaTestCaseObject";
                                values: Record<
                                  string,
                                  | string
                                  | number
                                  | boolean
                                  | string[]
                                  | undefined
                                >;
                                expected: string;
                                llmOutput?: boolean | undefined;
                              }>;
                              documents?:
                                | Array<{
                                    __typename?: "DocumentCompactObject";
                                    id: string;
                                    name: string;
                                    description: string;
                                    documentCategory?:
                                      | DocumentCategory
                                      | undefined;
                                    documentType: DocumentType;
                                    form: string;
                                    usState: UsState;
                                  }>
                                | undefined;
                            }
                          | undefined;
                        rules?: Array<{
                          __typename?: "RuleObject";
                          id: string;
                          message: string;
                          errorMessageTemplate?: string | undefined;
                          focusFieldMappingKeys?: Array<string> | undefined;
                          contextForLLMJudge?: string | undefined;
                          ruleType: RuleType;
                          autofill?:
                            | {
                                __typename?: "AutofillObject";
                                id: string;
                                variableSources: Array<VariableSource>;
                                formula?: string | undefined;
                                variableField?:
                                  | {
                                      __typename?: "VariableFieldObject";
                                      key: string;
                                      type: VariableDataType;
                                      source: VariableSource;
                                    }
                                  | undefined;
                                formulaVariableFields: Array<{
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }>;
                                formulaTestCases: Array<{
                                  __typename?: "FormulaTestCaseObject";
                                  values: Record<
                                    string,
                                    | string
                                    | number
                                    | boolean
                                    | string[]
                                    | undefined
                                  >;
                                  expected: string;
                                  llmOutput?: boolean | undefined;
                                }>;
                                documents?:
                                  | Array<{
                                      __typename?: "DocumentCompactObject";
                                      id: string;
                                      name: string;
                                      description: string;
                                      documentCategory?:
                                        | DocumentCategory
                                        | undefined;
                                      documentType: DocumentType;
                                      form: string;
                                      usState: UsState;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }>;
                        field: {
                          __typename?: "FieldObject";
                          readOnly?: boolean | undefined;
                          id: string;
                          group: string;
                          label: string;
                          displayLabel?: string | undefined;
                          mappingKey: string;
                          fieldType: FieldType;
                          isComputed?: boolean | undefined;
                          isHidden?: boolean | undefined;
                          aiExtract?: boolean | undefined;
                          aiInterpret?: boolean | undefined;
                          comparisonType?: ComparisonType | undefined;
                          defaultRules?:
                            | Array<{
                                __typename?: "RuleObject";
                                id: string;
                                message: string;
                                errorMessageTemplate?: string | undefined;
                                focusFieldMappingKeys?:
                                  | Array<string>
                                  | undefined;
                                contextForLLMJudge?: string | undefined;
                                ruleType: RuleType;
                                autofill?:
                                  | {
                                      __typename?: "AutofillObject";
                                      id: string;
                                      variableSources: Array<VariableSource>;
                                      formula?: string | undefined;
                                      variableField?:
                                        | {
                                            __typename?: "VariableFieldObject";
                                            key: string;
                                            type: VariableDataType;
                                            source: VariableSource;
                                          }
                                        | undefined;
                                      formulaVariableFields: Array<{
                                        __typename?: "VariableFieldObject";
                                        key: string;
                                        type: VariableDataType;
                                        source: VariableSource;
                                      }>;
                                      formulaTestCases: Array<{
                                        __typename?: "FormulaTestCaseObject";
                                        values: Record<
                                          string,
                                          | string
                                          | number
                                          | boolean
                                          | string[]
                                          | undefined
                                        >;
                                        expected: string;
                                        llmOutput?: boolean | undefined;
                                      }>;
                                      documents?:
                                        | Array<{
                                            __typename?: "DocumentCompactObject";
                                            id: string;
                                            name: string;
                                            description: string;
                                            documentCategory?:
                                              | DocumentCategory
                                              | undefined;
                                            documentType: DocumentType;
                                            form: string;
                                            usState: UsState;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }>
                            | undefined;
                          autofill?:
                            | {
                                __typename?: "AutofillObject";
                                id: string;
                                variableSources: Array<VariableSource>;
                                formula?: string | undefined;
                                variableField?:
                                  | {
                                      __typename?: "VariableFieldObject";
                                      key: string;
                                      type: VariableDataType;
                                      source: VariableSource;
                                    }
                                  | undefined;
                                formulaVariableFields: Array<{
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }>;
                                formulaTestCases: Array<{
                                  __typename?: "FormulaTestCaseObject";
                                  values: Record<
                                    string,
                                    | string
                                    | number
                                    | boolean
                                    | string[]
                                    | undefined
                                  >;
                                  expected: string;
                                  llmOutput?: boolean | undefined;
                                }>;
                                documents?:
                                  | Array<{
                                      __typename?: "DocumentCompactObject";
                                      id: string;
                                      name: string;
                                      description: string;
                                      documentCategory?:
                                        | DocumentCategory
                                        | undefined;
                                      documentType: DocumentType;
                                      form: string;
                                      usState: UsState;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                          inputFormat?:
                            | {
                                __typename?: "InputFormatObject";
                                type: InputFormatType;
                                options: {
                                  __typename?: "InputFormatOptionsObject";
                                  precision?: number | undefined;
                                  formatString?: string | undefined;
                                  currencySymbol?: string | undefined;
                                };
                              }
                            | undefined;
                        };
                        inputFormat?:
                          | {
                              __typename?: "InputFormatObject";
                              type: InputFormatType;
                              options: {
                                __typename?: "InputFormatOptionsObject";
                                precision?: number | undefined;
                                formatString?: string | undefined;
                                currencySymbol?: string | undefined;
                              };
                            }
                          | undefined;
                        boundingBox: {
                          __typename?: "BoundingBoxObject";
                          left: number;
                          top: number;
                          right: number;
                          bottom: number;
                        };
                        labelBoundingBox?:
                          | {
                              __typename?: "BoundingBoxObject";
                              left: number;
                              top: number;
                              right: number;
                              bottom: number;
                            }
                          | undefined;
                        labelField?:
                          | {
                              __typename?: "LabelFieldObject";
                              height: number;
                              width: number;
                              x: number;
                              y: number;
                            }
                          | undefined;
                      }>;
                    }
                  | undefined;
              }>;
            }>
          | undefined;
      }
    | undefined;
};

export type ContractSignatureFieldsQueryVariables = Exact<{
  args: ContractSignatureFieldsArgs;
}>;

export type ContractSignatureFieldsQuery = {
  __typename?: "Query";
  contractSignatureFields: {
    __typename?: "ContractSignatureFieldsPayload";
    documentVersionFields: Array<{
      __typename?: "PublicDocumentVersionFieldObject";
      id: string;
      align: FieldAlign;
      pageNumber: number;
      fontFamily: string;
      fontSize: string;
      label: string;
      readOnly?: boolean | undefined;
      width: number;
      height: number;
      x: number;
      y: number;
      mappingKey: string;
      fieldType: FieldType;
      field: {
        __typename?: "PublicFieldObject";
        id: string;
        label: string;
        group: string;
        mappingKey: string;
        fieldType: FieldType;
        isComputed?: boolean | undefined;
        isHidden?: boolean | undefined;
        readOnly?: boolean | undefined;
      };
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
      boundingBox: {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      };
    }>;
    signatureFormFields: Array<{
      __typename?: "SignatureFormFieldObject";
      id: string;
      documentIndex: number;
      x: number;
      y: number;
      height: number;
      isRequired: boolean;
      name?: string | undefined;
      page: number;
      signerId: string;
      type: FieldType;
      width: number;
    }>;
  };
};

export type ContractValidationsQueryVariables = Exact<{
  autofillVariableValues: Scalars["JSONObject"]["input"];
  contractId: Scalars["ID"]["input"];
  fieldValues: Scalars["JSONObject"]["input"];
}>;

export type ContractValidationsQuery = {
  __typename?: "Query";
  contractValidations: {
    __typename?: "ContractObject";
    id: string;
    validations?:
      | Array<{
          __typename?: "ContractValidationObject";
          field: {
            __typename?: "FieldObject";
            id: string;
            mappingKey: string;
            fieldType: FieldType;
            label: string;
            displayLabel?: string | undefined;
            group: string;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
          };
          documentVersionField: {
            __typename?: "DocumentVersionFieldObject";
            id: string;
            mappingKey: string;
            fieldType: FieldType;
            label: string;
            displayLabel?: string | undefined;
            inputFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
          };
          results: Array<{
            __typename?: "RuleValidationObject";
            inputValue?: string | undefined;
            message: string;
            validationValue?: string | undefined;
            rule: { __typename?: "RuleObject"; id: string; ruleType: RuleType };
          }>;
        }>
      | undefined;
  };
};

export type ContractVariableValuesQueryVariables = Exact<{
  input: Array<ContractVariableValuesInput> | ContractVariableValuesInput;
}>;

export type ContractVariableValuesQuery = {
  __typename?: "Query";
  contractVariableValues?:
    | Array<{
        __typename?: "ContractVariableValuesPayload";
        contractId?: string | undefined;
        contractVariableValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        variableSource?: VariableSource | undefined;
        state?: UsState | undefined;
      }>
    | undefined;
};

export type DocumentClassificationEvaluationListQueryVariables = Exact<{
  filter?: InputMaybe<DocumentClassificationEvaluationListFilter>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DocumentClassificationEvaluationListQuery = {
  __typename?: "Query";
  documentClassificationEvaluationList?:
    | {
        __typename?: "DocumentClassificationEvaluationObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentClassificationEvaluationObject";
              id: string;
              createdAt: any;
              updatedAt: any;
              expectedCategory?: DocumentCategory | undefined;
              expectedDocumentType?: DocumentType | undefined;
              expectedUsState?: UsState | undefined;
              expectedValues?: any | undefined;
              extractedValues?: any | undefined;
              extractedAiValues?: any | undefined;
              combinedExtractedValues?: any | undefined;
              mappedValuesBBox?: any | undefined;
              isBlankDocument: boolean;
              lowConfidenceFields?: any | undefined;
              lastExtractedAt?: any | undefined;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
              filteredOutItems?:
                | Array<{
                    __typename?: "FilteredOutItemObject";
                    text: string;
                    mappingKey: string;
                    pageNumber: number;
                    boundingBox: any;
                    fieldType: FieldType;
                    filterReason: FilterReason;
                    confidence?: number | undefined;
                    targetConfidence?: number | undefined;
                    intersectionOverArea?: number | undefined;
                    targetIntersection?: number | undefined;
                  }>
                | undefined;
              classification?:
                | Array<{
                    __typename?: "DocumentPagePrediction";
                    pageNumber: number;
                    formName: string;
                    version?: string | undefined;
                    searchRegex?: string | undefined;
                    humanLabeled?: boolean | undefined;
                    usState: UsState;
                    documentCategory?: DocumentCategory | undefined;
                    documentType?: DocumentType | undefined;
                    score: number;
                    containment?: number | undefined;
                    classificationMethod?: ClassificationMethod | undefined;
                    formOrVersionMatch?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    alternativeCandidates?:
                      | Array<{
                          __typename?: "BasePagePrediction";
                          formName: string;
                          usState: UsState;
                          version?: string | undefined;
                          searchRegex?: string | undefined;
                          documentCategory?: DocumentCategory | undefined;
                          documentType?: DocumentType | undefined;
                          score: number;
                          humanLabeled?: boolean | undefined;
                          pageNumber: number;
                          containment?: number | undefined;
                          formOrVersionMatch?:
                            | Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >
                            | undefined;
                        }>
                      | undefined;
                    candidateDocumentCategories?:
                      | Array<{
                          __typename?: "CandidateDocumentCategory";
                          documentCategory: DocumentCategory;
                          score: number;
                        }>
                      | undefined;
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentEvaluationJobStatusQueryVariables = Exact<{
  jobId: Scalars["String"]["input"];
}>;

export type DocumentEvaluationJobStatusQuery = {
  __typename?: "Query";
  documentEvaluationJobStatus?:
    | {
        __typename?: "DocumentEvaluationJobStatusObject";
        jobId: string;
        state: string;
        isFailed: boolean;
        isCompleted: boolean;
        isInProgress: boolean;
        progress?:
          | {
              __typename?: "DocumentEvaluationJobProgressObject";
              current?: number | undefined;
              total?: number | undefined;
              evaluationId?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type DocumentLlmEvaluationListQueryVariables = Exact<{
  filters?: InputMaybe<DocumentLlmEvaluationListFilterArgs>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type DocumentLlmEvaluationListQuery = {
  __typename?: "Query";
  documentLLMEvaluationList?:
    | {
        __typename?: "DocumentLLMEvaluationObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentLLMEvaluationObject";
              id: string;
              expectedOutput?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              document?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    usState: UsState;
                    form: string;
                  }
                | undefined;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
              documentLLM: { __typename?: "DocumentLLMObject"; id: string };
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentLlmListQueryVariables = Exact<{
  filters?: InputMaybe<DocumentLlmListFilterArgs>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  isDetail?: Scalars["Boolean"]["input"];
}>;

export type DocumentLlmListQuery = {
  __typename?: "Query";
  documentLLMList?:
    | {
        __typename?: "DocumentLLMObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentLLMObject";
              id: string;
              documentCategory?: DocumentCategory | undefined;
              context?: string;
              pages?: Array<number>;
              extractSchema?: Array<{
                __typename?: "LLMExtractSchemaObject";
                key: string;
                description: string;
                outputType: LlmOutputSchemaType;
                enumValues?: Array<string> | undefined;
                fieldType?: FieldType | undefined;
              }>;
              documents: Array<{
                __typename?: "DocumentObject";
                id: string;
                name: string;
                form: string;
                usState: UsState;
                documentType: DocumentType;
              }>;
              examples?: Array<{
                __typename?: "DocumentLLMExampleObject";
                id: string;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              }>;
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentLlmMissingKeysQueryVariables = Exact<{
  documentLLMId: Scalars["ID"]["input"];
}>;

export type DocumentLlmMissingKeysQuery = {
  __typename?: "Query";
  documentLLMMissingKeys: {
    __typename?: "DocumentLLMMissingKeysPayload";
    documentLLMId: string;
    missingMappingKeys: Array<string>;
  };
};

export type DocumentListFragment = {
  __typename?: "DocumentObject";
  hasUnmappedFields?: boolean | undefined;
  id: string;
  documentType: DocumentType;
  documentCategory?: DocumentCategory | undefined;
  name: string;
  description: string;
  form: string;
  usState: UsState;
  includeInOfferIngestion: boolean;
  llmExtraction: boolean;
  updatedAt?: any | undefined;
  subsetOfDocument?:
    | {
        __typename?: "DocumentCompactObject";
        id: string;
        name: string;
        form: string;
        usState: UsState;
      }
    | undefined;
  documentVersions?: Array<{
    __typename?: "DocumentVersionObject";
    documentVersionFieldsCount?: number | undefined;
    id: string;
    status: DocumentVersionStatus;
    searchRegex?: string | undefined;
    version: string;
    autoMapStatus?:
      | {
          __typename?: "DocumentVersionAutoMapStatusObject";
          state: DocumentVersionAutoMapState;
          queuedAt?: any | undefined;
          completedAt?: any | undefined;
          failedAt?: any | undefined;
        }
      | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
  }>;
  defaultSecondaryDocuments?: Array<{
    __typename?: "DefaultSecondaryDocumentObject";
    id: string;
    ordering: number;
    mappingKey: string;
    defaultRules?:
      | Array<{
          __typename?: "RuleObject";
          id: string;
          message: string;
          errorMessageTemplate?: string | undefined;
          focusFieldMappingKeys?: Array<string> | undefined;
          contextForLLMJudge?: string | undefined;
          ruleType: RuleType;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        }>
      | undefined;
    secondaryDocument: {
      __typename?: "DocumentObject";
      id: string;
      documentType: DocumentType;
      form: string;
      name: string;
      usState: UsState;
    };
  }>;
  activeDocumentVersion?: {
    __typename?: "DocumentVersionObject";
    id: string;
    status: DocumentVersionStatus;
    searchRegex?: string | undefined;
    version: string;
    documentVersionFields: Array<{
      __typename?: "DocumentVersionFieldObject";
      id: string;
      align: FieldAlign;
      pageNumber: number;
      fontFamily: string;
      fontSize: string;
      label: string;
      readOnly?: boolean | undefined;
      width: number;
      height: number;
      x: number;
      y: number;
      mappingKey: string;
      fieldType: FieldType;
      field: {
        __typename?: "FieldObject";
        id: string;
        group: string;
        label: string;
        displayLabel?: string | undefined;
        mappingKey: string;
        fieldType: FieldType;
        isComputed?: boolean | undefined;
        isHidden?: boolean | undefined;
        readOnly?: boolean | undefined;
        aiExtract?: boolean | undefined;
        aiInterpret?: boolean | undefined;
        comparisonType?: ComparisonType | undefined;
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        optionsAutofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        helpTextAutofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        defaultRules?:
          | Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              errorMessageTemplate?: string | undefined;
              focusFieldMappingKeys?: Array<string> | undefined;
              contextForLLMJudge?: string | undefined;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      };
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
      boundingBox: {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      };
      labelBoundingBox?:
        | {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          }
        | undefined;
      labelField?:
        | {
            __typename?: "LabelFieldObject";
            height: number;
            width: number;
            x: number;
            y: number;
          }
        | undefined;
    }>;
    file: { __typename?: "FileObject"; fileName: string; url: string };
  };
};

export type DocumentListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: DocumentListArgs;
  includeDocumentVersions?: Scalars["Boolean"]["input"];
  includeDefaultSecondaryDocuments?: Scalars["Boolean"]["input"];
  includeActiveDocumentVersion?: Scalars["Boolean"]["input"];
  includeSubsetOfDocument?: Scalars["Boolean"]["input"];
}>;

export type DocumentListQuery = {
  __typename?: "Query";
  documentList?:
    | {
        __typename?: "DocumentObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentObject";
              hasUnmappedFields?: boolean | undefined;
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              description: string;
              form: string;
              usState: UsState;
              includeInOfferIngestion: boolean;
              llmExtraction: boolean;
              updatedAt?: any | undefined;
              subsetOfDocument?:
                | {
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    form: string;
                    usState: UsState;
                  }
                | undefined;
              documentVersions?: Array<{
                __typename?: "DocumentVersionObject";
                documentVersionFieldsCount?: number | undefined;
                id: string;
                status: DocumentVersionStatus;
                searchRegex?: string | undefined;
                version: string;
                autoMapStatus?:
                  | {
                      __typename?: "DocumentVersionAutoMapStatusObject";
                      state: DocumentVersionAutoMapState;
                      queuedAt?: any | undefined;
                      completedAt?: any | undefined;
                      failedAt?: any | undefined;
                    }
                  | undefined;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              }>;
              defaultSecondaryDocuments?: Array<{
                __typename?: "DefaultSecondaryDocumentObject";
                id: string;
                ordering: number;
                mappingKey: string;
                defaultRules?:
                  | Array<{
                      __typename?: "RuleObject";
                      id: string;
                      message: string;
                      errorMessageTemplate?: string | undefined;
                      focusFieldMappingKeys?: Array<string> | undefined;
                      contextForLLMJudge?: string | undefined;
                      ruleType: RuleType;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }>
                  | undefined;
                secondaryDocument: {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                  form: string;
                  name: string;
                  usState: UsState;
                };
              }>;
              activeDocumentVersion?: {
                __typename?: "DocumentVersionObject";
                id: string;
                status: DocumentVersionStatus;
                searchRegex?: string | undefined;
                version: string;
                documentVersionFields: Array<{
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  field: {
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                    optionsAutofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                    helpTextAutofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                    defaultRules?:
                      | Array<{
                          __typename?: "RuleObject";
                          id: string;
                          message: string;
                          errorMessageTemplate?: string | undefined;
                          focusFieldMappingKeys?: Array<string> | undefined;
                          contextForLLMJudge?: string | undefined;
                          ruleType: RuleType;
                          autofill?:
                            | {
                                __typename?: "AutofillObject";
                                id: string;
                                variableSources: Array<VariableSource>;
                                formula?: string | undefined;
                                variableField?:
                                  | {
                                      __typename?: "VariableFieldObject";
                                      key: string;
                                      type: VariableDataType;
                                      source: VariableSource;
                                    }
                                  | undefined;
                                formulaVariableFields: Array<{
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }>;
                                formulaTestCases: Array<{
                                  __typename?: "FormulaTestCaseObject";
                                  values: Record<
                                    string,
                                    | string
                                    | number
                                    | boolean
                                    | string[]
                                    | undefined
                                  >;
                                  expected: string;
                                  llmOutput?: boolean | undefined;
                                }>;
                                documents?:
                                  | Array<{
                                      __typename?: "DocumentCompactObject";
                                      id: string;
                                      name: string;
                                      description: string;
                                      documentCategory?:
                                        | DocumentCategory
                                        | undefined;
                                      documentType: DocumentType;
                                      form: string;
                                      usState: UsState;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }>
                      | undefined;
                  };
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                  labelBoundingBox?:
                    | {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      }
                    | undefined;
                  labelField?:
                    | {
                        __typename?: "LabelFieldObject";
                        height: number;
                        width: number;
                        x: number;
                        y: number;
                      }
                    | undefined;
                }>;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              };
            }>
          | undefined;
      }
    | undefined;
};

export type PublicDocumentForOfferFlowFragment = {
  __typename?: "PublicDocumentObject";
  id: string;
  description: string;
  form: string;
  name: string;
  documentType: DocumentType;
  defaultSecondaryDocuments?: Array<{
    __typename?: "PublicDefaultSecondaryDocumentObject";
    id: string;
    mappingKey: string;
    ordering: number;
    secondaryDocument: {
      __typename?: "PublicDocumentObject";
      id: string;
      name: string;
      form: string;
      activeDocumentVersion?:
        | { __typename?: "PublicDocumentVersionObject"; id: string }
        | undefined;
    };
  }>;
  activeDocumentVersion?:
    | {
        __typename?: "PublicDocumentVersionObject";
        id: string;
        previewImages: Array<{
          __typename?: "AssetFileObject";
          id: string;
          ordering: number;
          file: { __typename?: "FileObject"; url: string };
        }>;
      }
    | undefined;
};

export type DocumentForOfferFlowFragment = {
  __typename?: "DocumentObject";
  id: string;
  description: string;
  form: string;
  name: string;
  documentType: DocumentType;
  defaultSecondaryDocuments?: Array<{
    __typename?: "DefaultSecondaryDocumentObject";
    id: string;
    mappingKey: string;
    ordering: number;
    secondaryDocument: {
      __typename?: "DocumentObject";
      id: string;
      name: string;
      form: string;
    };
  }>;
  activeDocumentVersion?: {
    __typename?: "DocumentVersionObject";
    id: string;
    previewImages: Array<{
      __typename?: "AssetFileObject";
      id: string;
      ordering: number;
      file: { __typename?: "FileObject"; url: string };
    }>;
  };
};

export type DocumentListForOfferFlowQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: DocumentListArgs;
  isAgentVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  activeDocumentVersion?: InputMaybe<Scalars["Boolean"]["input"]>;
  defaultSecondaryDocuments?: Scalars["Boolean"]["input"];
}>;

export type DocumentListForOfferFlowQuery = {
  __typename?: "Query";
  publicDocumentList?:
    | {
        __typename?: "PublicDocumentObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PublicDocumentObject";
              id: string;
              description: string;
              form: string;
              name: string;
              documentType: DocumentType;
              defaultSecondaryDocuments?: Array<{
                __typename?: "PublicDefaultSecondaryDocumentObject";
                id: string;
                mappingKey: string;
                ordering: number;
                secondaryDocument: {
                  __typename?: "PublicDocumentObject";
                  id: string;
                  name: string;
                  form: string;
                  activeDocumentVersion?:
                    | { __typename?: "PublicDocumentVersionObject"; id: string }
                    | undefined;
                };
              }>;
              activeDocumentVersion?:
                | {
                    __typename?: "PublicDocumentVersionObject";
                    id: string;
                    previewImages: Array<{
                      __typename?: "AssetFileObject";
                      id: string;
                      ordering: number;
                      file: { __typename?: "FileObject"; url: string };
                    }>;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
  documentList?:
    | {
        __typename?: "DocumentObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentObject";
              id: string;
              description: string;
              form: string;
              name: string;
              documentType: DocumentType;
              defaultSecondaryDocuments?: Array<{
                __typename?: "DefaultSecondaryDocumentObject";
                id: string;
                mappingKey: string;
                ordering: number;
                secondaryDocument: {
                  __typename?: "DocumentObject";
                  id: string;
                  name: string;
                  form: string;
                };
              }>;
              activeDocumentVersion?: {
                __typename?: "DocumentVersionObject";
                id: string;
                previewImages: Array<{
                  __typename?: "AssetFileObject";
                  id: string;
                  ordering: number;
                  file: { __typename?: "FileObject"; url: string };
                }>;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentSectionListFragment = {
  __typename?: "DocumentSectionObject";
  id: string;
  description: string;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionType: DocumentSectionType;
  documentSectionCategory: DocumentSectionCategory;
  documentSectionModuleType?: DocumentSectionModuleType | undefined;
  title: string;
  order: number;
  parent?:
    | { __typename?: "DocumentSectionObject"; id: string; description: string }
    | undefined;
  documentSectionFields?:
    | Array<{
        __typename?: "DocumentSectionFieldObject";
        id: string;
        order: number;
        field: {
          __typename?: "FieldObject";
          id: string;
          group: string;
          label: string;
          displayLabel?: string | undefined;
          mappingKey: string;
          fieldType: FieldType;
          isComputed?: boolean | undefined;
          isHidden?: boolean | undefined;
          readOnly?: boolean | undefined;
          aiExtract?: boolean | undefined;
          aiInterpret?: boolean | undefined;
          comparisonType?: ComparisonType | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          optionsAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          helpTextAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          defaultRules?:
            | Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                errorMessageTemplate?: string | undefined;
                focusFieldMappingKeys?: Array<string> | undefined;
                contextForLLMJudge?: string | undefined;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
              }>
            | undefined;
        };
      }>
    | undefined;
};

export type DocumentSectionListQueryVariables = Exact<{
  filters?: InputMaybe<DocumentSectionListFilters>;
}>;

export type DocumentSectionListQuery = {
  __typename?: "Query";
  documentSectionList?:
    | {
        __typename?: "DocumentSectionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentSectionObject";
              id: string;
              description: string;
              documentSectionDisplayType: DocumentSectionDisplayType;
              documentSectionType: DocumentSectionType;
              documentSectionCategory: DocumentSectionCategory;
              documentSectionModuleType?: DocumentSectionModuleType | undefined;
              title: string;
              order: number;
              parent?:
                | {
                    __typename?: "DocumentSectionObject";
                    id: string;
                    description: string;
                  }
                | undefined;
              documentSectionFields?:
                | Array<{
                    __typename?: "DocumentSectionFieldObject";
                    id: string;
                    order: number;
                    field: {
                      __typename?: "FieldObject";
                      id: string;
                      group: string;
                      label: string;
                      displayLabel?: string | undefined;
                      mappingKey: string;
                      fieldType: FieldType;
                      isComputed?: boolean | undefined;
                      isHidden?: boolean | undefined;
                      readOnly?: boolean | undefined;
                      aiExtract?: boolean | undefined;
                      aiInterpret?: boolean | undefined;
                      comparisonType?: ComparisonType | undefined;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                      optionsAutofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                      helpTextAutofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            variableSources: Array<VariableSource>;
                            formula?: string | undefined;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  type: VariableDataType;
                                  source: VariableSource;
                                }
                              | undefined;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }>;
                            formulaTestCases: Array<{
                              __typename?: "FormulaTestCaseObject";
                              values: Record<
                                string,
                                string | number | boolean | string[] | undefined
                              >;
                              expected: string;
                              llmOutput?: boolean | undefined;
                            }>;
                            documents?:
                              | Array<{
                                  __typename?: "DocumentCompactObject";
                                  id: string;
                                  name: string;
                                  description: string;
                                  documentCategory?:
                                    | DocumentCategory
                                    | undefined;
                                  documentType: DocumentType;
                                  form: string;
                                  usState: UsState;
                                }>
                              | undefined;
                          }
                        | undefined;
                      defaultRules?:
                        | Array<{
                            __typename?: "RuleObject";
                            id: string;
                            message: string;
                            errorMessageTemplate?: string | undefined;
                            focusFieldMappingKeys?: Array<string> | undefined;
                            contextForLLMJudge?: string | undefined;
                            ruleType: RuleType;
                            autofill?:
                              | {
                                  __typename?: "AutofillObject";
                                  id: string;
                                  variableSources: Array<VariableSource>;
                                  formula?: string | undefined;
                                  variableField?:
                                    | {
                                        __typename?: "VariableFieldObject";
                                        key: string;
                                        type: VariableDataType;
                                        source: VariableSource;
                                      }
                                    | undefined;
                                  formulaVariableFields: Array<{
                                    __typename?: "VariableFieldObject";
                                    key: string;
                                    type: VariableDataType;
                                    source: VariableSource;
                                  }>;
                                  formulaTestCases: Array<{
                                    __typename?: "FormulaTestCaseObject";
                                    values: Record<
                                      string,
                                      | string
                                      | number
                                      | boolean
                                      | string[]
                                      | undefined
                                    >;
                                    expected: string;
                                    llmOutput?: boolean | undefined;
                                  }>;
                                  documents?:
                                    | Array<{
                                        __typename?: "DocumentCompactObject";
                                        id: string;
                                        name: string;
                                        description: string;
                                        documentCategory?:
                                          | DocumentCategory
                                          | undefined;
                                        documentType: DocumentType;
                                        form: string;
                                        usState: UsState;
                                      }>
                                    | undefined;
                                }
                              | undefined;
                          }>
                        | undefined;
                    };
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentSectionListForOfferFlowFieldFragment = {
  __typename?: "PublicDocumentSectionFieldObject";
  id: string;
  order: number;
  field: {
    __typename?: "PublicFieldObject";
    id: string;
    group: string;
    label: string;
    mappingKey: string;
    fieldType: FieldType;
    isComputed?: boolean | undefined;
    isHidden?: boolean | undefined;
    readOnly?: boolean | undefined;
    comparisonType?: ComparisonType | undefined;
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    autofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            source: VariableSource;
            type: VariableDataType;
          }>;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                source: VariableSource;
                type: VariableDataType;
              }
            | undefined;
        }
      | undefined;
  };
};

export type DocumentSectionListForOfferFlowFragment = {
  __typename?: "PublicDocumentSectionObject";
  id: string;
  title: string;
  description: string;
  documentSectionType: DocumentSectionType;
  documentSectionDisplayType: DocumentSectionDisplayType;
  documentSectionCategory: DocumentSectionCategory;
  documentSectionModuleType?: DocumentSectionModuleType | undefined;
  order: number;
  document?:
    | { __typename?: "PublicDocumentObject"; id: string; usState: UsState }
    | undefined;
  parent?:
    | {
        __typename?: "PublicDocumentSectionObject";
        id: string;
        description: string;
      }
    | undefined;
  documentSectionFields?:
    | Array<{
        __typename?: "PublicDocumentSectionFieldObject";
        id: string;
        order: number;
        field: {
          __typename?: "PublicFieldObject";
          id: string;
          group: string;
          label: string;
          mappingKey: string;
          fieldType: FieldType;
          isComputed?: boolean | undefined;
          isHidden?: boolean | undefined;
          readOnly?: boolean | undefined;
          comparisonType?: ComparisonType | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  source: VariableSource;
                  type: VariableDataType;
                }>;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      source: VariableSource;
                      type: VariableDataType;
                    }
                  | undefined;
              }
            | undefined;
        };
      }>
    | undefined;
};

export type DocumentSectionListForOfferFlowQueryVariables = Exact<{
  filters?: InputMaybe<DocumentSectionListFilters>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type DocumentSectionListForOfferFlowQuery = {
  __typename?: "Query";
  publicDocumentSectionList?:
    | {
        __typename?: "PublicDocumentSectionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PublicDocumentSectionObject";
              id: string;
              title: string;
              description: string;
              documentSectionType: DocumentSectionType;
              documentSectionDisplayType: DocumentSectionDisplayType;
              documentSectionCategory: DocumentSectionCategory;
              documentSectionModuleType?: DocumentSectionModuleType | undefined;
              order: number;
              document?:
                | {
                    __typename?: "PublicDocumentObject";
                    id: string;
                    usState: UsState;
                  }
                | undefined;
              parent?:
                | {
                    __typename?: "PublicDocumentSectionObject";
                    id: string;
                    description: string;
                  }
                | undefined;
              documentSectionFields?:
                | Array<{
                    __typename?: "PublicDocumentSectionFieldObject";
                    id: string;
                    order: number;
                    field: {
                      __typename?: "PublicFieldObject";
                      id: string;
                      group: string;
                      label: string;
                      mappingKey: string;
                      fieldType: FieldType;
                      isComputed?: boolean | undefined;
                      isHidden?: boolean | undefined;
                      readOnly?: boolean | undefined;
                      comparisonType?: ComparisonType | undefined;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                      autofill?:
                        | {
                            __typename?: "AutofillObject";
                            id: string;
                            formulaVariableFields: Array<{
                              __typename?: "VariableFieldObject";
                              key: string;
                              source: VariableSource;
                              type: VariableDataType;
                            }>;
                            variableField?:
                              | {
                                  __typename?: "VariableFieldObject";
                                  key: string;
                                  source: VariableSource;
                                  type: VariableDataType;
                                }
                              | undefined;
                          }
                        | undefined;
                    };
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type DocumentVersionAutofillValuesQueryVariables = Exact<{
  variableValues: Scalars["JSONObject"]["input"];
  documentVersionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  fieldValues: Scalars["JSONObject"]["input"];
}>;

export type DocumentVersionAutofillValuesQuery = {
  __typename?: "Query";
  documentVersionAutofillValues: {
    __typename?: "DocumentVersionAutofillValuesPayload";
    readOnlyAutofillValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    autofillValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    optionsAutofillValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    helpTextAutofillValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
  };
};

export type DocumentVersionListFieldFragment = {
  __typename?: "DocumentVersionFieldObject";
  id: string;
  align: FieldAlign;
  pageNumber: number;
  fontFamily: string;
  fontSize: string;
  label: string;
  readOnly?: boolean | undefined;
  width: number;
  height: number;
  x: number;
  y: number;
  mappingKey: string;
  fieldType: FieldType;
  autofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        variableSources: Array<VariableSource>;
        formula?: string | undefined;
        variableField?:
          | {
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }
          | undefined;
        formulaVariableFields: Array<{
          __typename?: "VariableFieldObject";
          key: string;
          type: VariableDataType;
          source: VariableSource;
        }>;
        formulaTestCases: Array<{
          __typename?: "FormulaTestCaseObject";
          values: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          expected: string;
          llmOutput?: boolean | undefined;
        }>;
        documents?:
          | Array<{
              __typename?: "DocumentCompactObject";
              id: string;
              name: string;
              description: string;
              documentCategory?: DocumentCategory | undefined;
              documentType: DocumentType;
              form: string;
              usState: UsState;
            }>
          | undefined;
      }
    | undefined;
  field: {
    __typename?: "FieldObject";
    id: string;
    group: string;
    label: string;
    displayLabel?: string | undefined;
    mappingKey: string;
    fieldType: FieldType;
    isComputed?: boolean | undefined;
    isHidden?: boolean | undefined;
    readOnly?: boolean | undefined;
    aiExtract?: boolean | undefined;
    aiInterpret?: boolean | undefined;
    comparisonType?: ComparisonType | undefined;
    autofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          variableSources: Array<VariableSource>;
          formula?: string | undefined;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }
            | undefined;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            type: VariableDataType;
            source: VariableSource;
          }>;
          formulaTestCases: Array<{
            __typename?: "FormulaTestCaseObject";
            values: Record<
              string,
              string | number | boolean | string[] | undefined
            >;
            expected: string;
            llmOutput?: boolean | undefined;
          }>;
          documents?:
            | Array<{
                __typename?: "DocumentCompactObject";
                id: string;
                name: string;
                description: string;
                documentCategory?: DocumentCategory | undefined;
                documentType: DocumentType;
                form: string;
                usState: UsState;
              }>
            | undefined;
        }
      | undefined;
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
  };
  inputFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  boundingBox: {
    __typename?: "BoundingBoxObject";
    left: number;
    top: number;
    right: number;
    bottom: number;
  };
  labelBoundingBox?:
    | {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      }
    | undefined;
  labelField?:
    | {
        __typename?: "LabelFieldObject";
        height: number;
        width: number;
        x: number;
        y: number;
      }
    | undefined;
};

export type DocumentVersionListFragment = {
  __typename?: "DocumentVersionObject";
  id: string;
  status: DocumentVersionStatus;
  searchRegex?: string | undefined;
  version: string;
  autoMapStatus?:
    | {
        __typename?: "DocumentVersionAutoMapStatusObject";
        state: DocumentVersionAutoMapState;
        queuedAt?: any | undefined;
        completedAt?: any | undefined;
        failedAt?: any | undefined;
      }
    | undefined;
  document?: {
    __typename?: "DocumentObject";
    id: string;
    documentType: DocumentType;
    documentCategory?: DocumentCategory | undefined;
    name: string;
    description: string;
    form: string;
    usState: UsState;
    includeInOfferIngestion: boolean;
    llmExtraction: boolean;
    updatedAt?: any | undefined;
  };
  documentVersionFields?: Array<{
    __typename?: "DocumentVersionFieldObject";
    id: string;
    align: FieldAlign;
    pageNumber: number;
    fontFamily: string;
    fontSize: string;
    label: string;
    readOnly?: boolean | undefined;
    width: number;
    height: number;
    x: number;
    y: number;
    mappingKey: string;
    fieldType: FieldType;
    autofill?:
      | {
          __typename?: "AutofillObject";
          id: string;
          variableSources: Array<VariableSource>;
          formula?: string | undefined;
          variableField?:
            | {
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }
            | undefined;
          formulaVariableFields: Array<{
            __typename?: "VariableFieldObject";
            key: string;
            type: VariableDataType;
            source: VariableSource;
          }>;
          formulaTestCases: Array<{
            __typename?: "FormulaTestCaseObject";
            values: Record<
              string,
              string | number | boolean | string[] | undefined
            >;
            expected: string;
            llmOutput?: boolean | undefined;
          }>;
          documents?:
            | Array<{
                __typename?: "DocumentCompactObject";
                id: string;
                name: string;
                description: string;
                documentCategory?: DocumentCategory | undefined;
                documentType: DocumentType;
                form: string;
                usState: UsState;
              }>
            | undefined;
        }
      | undefined;
    field: {
      __typename?: "FieldObject";
      id: string;
      group: string;
      label: string;
      displayLabel?: string | undefined;
      mappingKey: string;
      fieldType: FieldType;
      isComputed?: boolean | undefined;
      isHidden?: boolean | undefined;
      readOnly?: boolean | undefined;
      aiExtract?: boolean | undefined;
      aiInterpret?: boolean | undefined;
      comparisonType?: ComparisonType | undefined;
      autofill?:
        | {
            __typename?: "AutofillObject";
            id: string;
            variableSources: Array<VariableSource>;
            formula?: string | undefined;
            variableField?:
              | {
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }
              | undefined;
            formulaVariableFields: Array<{
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }>;
            formulaTestCases: Array<{
              __typename?: "FormulaTestCaseObject";
              values: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              expected: string;
              llmOutput?: boolean | undefined;
            }>;
            documents?:
              | Array<{
                  __typename?: "DocumentCompactObject";
                  id: string;
                  name: string;
                  description: string;
                  documentCategory?: DocumentCategory | undefined;
                  documentType: DocumentType;
                  form: string;
                  usState: UsState;
                }>
              | undefined;
          }
        | undefined;
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
    };
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    boundingBox: {
      __typename?: "BoundingBoxObject";
      left: number;
      top: number;
      right: number;
      bottom: number;
    };
    labelBoundingBox?:
      | {
          __typename?: "BoundingBoxObject";
          left: number;
          top: number;
          right: number;
          bottom: number;
        }
      | undefined;
    labelField?:
      | {
          __typename?: "LabelFieldObject";
          height: number;
          width: number;
          x: number;
          y: number;
        }
      | undefined;
  }>;
  secondaryDocumentVersions?: Array<{
    __typename?: "SecondaryDocumentVersionObject";
    id: string;
    ordering: number;
    rules: Array<{
      __typename?: "RuleObject";
      id: string;
      message: string;
      errorMessageTemplate?: string | undefined;
      focusFieldMappingKeys?: Array<string> | undefined;
      contextForLLMJudge?: string | undefined;
      ruleType: RuleType;
      autofill?:
        | {
            __typename?: "AutofillObject";
            id: string;
            variableSources: Array<VariableSource>;
            formula?: string | undefined;
            variableField?:
              | {
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }
              | undefined;
            formulaVariableFields: Array<{
              __typename?: "VariableFieldObject";
              key: string;
              type: VariableDataType;
              source: VariableSource;
            }>;
            formulaTestCases: Array<{
              __typename?: "FormulaTestCaseObject";
              values: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              expected: string;
              llmOutput?: boolean | undefined;
            }>;
            documents?:
              | Array<{
                  __typename?: "DocumentCompactObject";
                  id: string;
                  name: string;
                  description: string;
                  documentCategory?: DocumentCategory | undefined;
                  documentType: DocumentType;
                  form: string;
                  usState: UsState;
                }>
              | undefined;
          }
        | undefined;
    }>;
    secondaryDocumentVersion: {
      __typename?: "DocumentVersionObject";
      id: string;
      version: string;
      status: DocumentVersionStatus;
      searchRegex?: string | undefined;
      file: { __typename?: "FileObject"; fileName: string; url: string };
      document: {
        __typename?: "DocumentObject";
        id: string;
        documentType: DocumentType;
        documentCategory?: DocumentCategory | undefined;
        name: string;
        description: string;
        form: string;
        usState: UsState;
        includeInOfferIngestion: boolean;
        llmExtraction: boolean;
        updatedAt?: any | undefined;
      };
    };
  }>;
  file: { __typename?: "FileObject"; fileName: string; url: string };
};

export type DocumentVersionListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<DocumentVersionListFilterArgs>;
  document?: InputMaybe<Scalars["Boolean"]["input"]>;
  fields?: InputMaybe<Scalars["Boolean"]["input"]>;
  secondaryDocumentVersions?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type DocumentVersionListQuery = {
  __typename?: "Query";
  documentVersionList?:
    | {
        __typename?: "DocumentVersionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentVersionObject";
              id: string;
              status: DocumentVersionStatus;
              searchRegex?: string | undefined;
              version: string;
              autoMapStatus?:
                | {
                    __typename?: "DocumentVersionAutoMapStatusObject";
                    state: DocumentVersionAutoMapState;
                    queuedAt?: any | undefined;
                    completedAt?: any | undefined;
                    failedAt?: any | undefined;
                  }
                | undefined;
              document?: {
                __typename?: "DocumentObject";
                id: string;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
                name: string;
                description: string;
                form: string;
                usState: UsState;
                includeInOfferIngestion: boolean;
                llmExtraction: boolean;
                updatedAt?: any | undefined;
              };
              documentVersionFields?: Array<{
                __typename?: "DocumentVersionFieldObject";
                id: string;
                align: FieldAlign;
                pageNumber: number;
                fontFamily: string;
                fontSize: string;
                label: string;
                readOnly?: boolean | undefined;
                width: number;
                height: number;
                x: number;
                y: number;
                mappingKey: string;
                fieldType: FieldType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  group: string;
                  label: string;
                  displayLabel?: string | undefined;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  aiExtract?: boolean | undefined;
                  aiInterpret?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                boundingBox: {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                };
                labelBoundingBox?:
                  | {
                      __typename?: "BoundingBoxObject";
                      left: number;
                      top: number;
                      right: number;
                      bottom: number;
                    }
                  | undefined;
                labelField?:
                  | {
                      __typename?: "LabelFieldObject";
                      height: number;
                      width: number;
                      x: number;
                      y: number;
                    }
                  | undefined;
              }>;
              secondaryDocumentVersions?: Array<{
                __typename?: "SecondaryDocumentVersionObject";
                id: string;
                ordering: number;
                rules: Array<{
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  errorMessageTemplate?: string | undefined;
                  focusFieldMappingKeys?: Array<string> | undefined;
                  contextForLLMJudge?: string | undefined;
                  ruleType: RuleType;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        variableSources: Array<VariableSource>;
                        formula?: string | undefined;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              type: VariableDataType;
                              source: VariableSource;
                            }
                          | undefined;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }>;
                        formulaTestCases: Array<{
                          __typename?: "FormulaTestCaseObject";
                          values: Record<
                            string,
                            string | number | boolean | string[] | undefined
                          >;
                          expected: string;
                          llmOutput?: boolean | undefined;
                        }>;
                        documents?:
                          | Array<{
                              __typename?: "DocumentCompactObject";
                              id: string;
                              name: string;
                              description: string;
                              documentCategory?: DocumentCategory | undefined;
                              documentType: DocumentType;
                              form: string;
                              usState: UsState;
                            }>
                          | undefined;
                      }
                    | undefined;
                }>;
                secondaryDocumentVersion: {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  version: string;
                  status: DocumentVersionStatus;
                  searchRegex?: string | undefined;
                  file: {
                    __typename?: "FileObject";
                    fileName: string;
                    url: string;
                  };
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                    name: string;
                    description: string;
                    form: string;
                    usState: UsState;
                    includeInOfferIngestion: boolean;
                    llmExtraction: boolean;
                    updatedAt?: any | undefined;
                  };
                };
              }>;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type PublicDocumentVersionForOfferFlowFragment = {
  __typename?: "PublicDocumentVersionObject";
  id: string;
  previewImages: Array<{
    __typename?: "AssetFileObject";
    id: string;
    ordering: number;
    file: { __typename?: "FileObject"; url: string };
  }>;
  documentVersionFields: Array<{
    __typename?: "PublicDocumentVersionFieldObject";
    id: string;
    align: FieldAlign;
    pageNumber: number;
    fontFamily: string;
    fontSize: string;
    label: string;
    readOnly?: boolean | undefined;
    width: number;
    height: number;
    x: number;
    y: number;
    mappingKey: string;
    fieldType: FieldType;
    field: {
      __typename?: "PublicFieldObject";
      id: string;
      group: string;
      label: string;
      mappingKey: string;
      fieldType: FieldType;
      isComputed?: boolean | undefined;
      isHidden?: boolean | undefined;
      readOnly?: boolean | undefined;
      comparisonType?: ComparisonType | undefined;
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
      autofill?:
        | {
            __typename?: "AutofillObject";
            id: string;
            formulaVariableFields: Array<{
              __typename?: "VariableFieldObject";
              key: string;
              source: VariableSource;
              type: VariableDataType;
            }>;
            variableField?:
              | {
                  __typename?: "VariableFieldObject";
                  key: string;
                  source: VariableSource;
                  type: VariableDataType;
                }
              | undefined;
          }
        | undefined;
    };
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    boundingBox: {
      __typename?: "BoundingBoxObject";
      left: number;
      top: number;
      right: number;
      bottom: number;
    };
  }>;
  document: { __typename?: "PublicDocumentObject"; id: string };
  secondaryVersions?: Array<{
    __typename?: "PublicDocumentVersionObject";
    id: string;
    mappingKeys: Array<string>;
    previewImages: Array<{
      __typename?: "AssetFileObject";
      id: string;
      ordering: number;
      file: { __typename?: "FileObject"; url: string };
    }>;
    documentVersionFields?: Array<{
      __typename?: "PublicDocumentVersionFieldObject";
      id: string;
      align: FieldAlign;
      pageNumber: number;
      fontFamily: string;
      fontSize: string;
      label: string;
      readOnly?: boolean | undefined;
      width: number;
      height: number;
      x: number;
      y: number;
      mappingKey: string;
      fieldType: FieldType;
      field: {
        __typename?: "PublicFieldObject";
        id: string;
        group: string;
        label: string;
        mappingKey: string;
        fieldType: FieldType;
        isComputed?: boolean | undefined;
        isHidden?: boolean | undefined;
        readOnly?: boolean | undefined;
        comparisonType?: ComparisonType | undefined;
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                source: VariableSource;
                type: VariableDataType;
              }>;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    source: VariableSource;
                    type: VariableDataType;
                  }
                | undefined;
            }
          | undefined;
      };
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
      boundingBox: {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      };
    }>;
    document: {
      __typename?: "PublicDocumentObject";
      id: string;
      name: string;
      usState: UsState;
      form: string;
    };
  }>;
};

export type DocumentVersionForOfferFlowFragment = {
  __typename?: "DocumentVersionObject";
  id: string;
  status: DocumentVersionStatus;
  version: string;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  documentVersionFields: Array<{
    __typename?: "DocumentVersionFieldObject";
    id: string;
    align: FieldAlign;
    pageNumber: number;
    fontFamily: string;
    fontSize: string;
    label: string;
    readOnly?: boolean | undefined;
    width: number;
    height: number;
    x: number;
    y: number;
    mappingKey: string;
    fieldType: FieldType;
    field: {
      __typename?: "FieldObject";
      id: string;
      group: string;
      label: string;
      displayLabel?: string | undefined;
      mappingKey: string;
      fieldType: FieldType;
      isComputed?: boolean | undefined;
      isHidden?: boolean | undefined;
      readOnly?: boolean | undefined;
      aiExtract?: boolean | undefined;
      aiInterpret?: boolean | undefined;
      comparisonType?: ComparisonType | undefined;
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
    };
    inputFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    boundingBox: {
      __typename?: "BoundingBoxObject";
      left: number;
      top: number;
      right: number;
      bottom: number;
    };
    labelBoundingBox?:
      | {
          __typename?: "BoundingBoxObject";
          left: number;
          top: number;
          right: number;
          bottom: number;
        }
      | undefined;
    labelField?:
      | {
          __typename?: "LabelFieldObject";
          height: number;
          width: number;
          x: number;
          y: number;
        }
      | undefined;
  }>;
  document: { __typename?: "DocumentObject"; id: string };
  secondaryVersions?: Array<{
    __typename?: "DocumentVersionObject";
    id: string;
    status: DocumentVersionStatus;
    version: string;
    mappingKeys: Array<string>;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    previewImages?: Array<{ __typename?: "AssetFileObject"; id: string }>;
    documentVersionFields?: Array<{
      __typename?: "DocumentVersionFieldObject";
      id: string;
      align: FieldAlign;
      pageNumber: number;
      fontFamily: string;
      fontSize: string;
      label: string;
      readOnly?: boolean | undefined;
      width: number;
      height: number;
      x: number;
      y: number;
      mappingKey: string;
      fieldType: FieldType;
      field: {
        __typename?: "FieldObject";
        id: string;
        group: string;
        label: string;
        displayLabel?: string | undefined;
        mappingKey: string;
        fieldType: FieldType;
        isComputed?: boolean | undefined;
        isHidden?: boolean | undefined;
        readOnly?: boolean | undefined;
        aiExtract?: boolean | undefined;
        aiInterpret?: boolean | undefined;
        comparisonType?: ComparisonType | undefined;
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
      };
      inputFormat?:
        | {
            __typename?: "InputFormatObject";
            type: InputFormatType;
            options: {
              __typename?: "InputFormatOptionsObject";
              precision?: number | undefined;
              formatString?: string | undefined;
              currencySymbol?: string | undefined;
            };
          }
        | undefined;
      boundingBox: {
        __typename?: "BoundingBoxObject";
        left: number;
        top: number;
        right: number;
        bottom: number;
      };
      labelBoundingBox?:
        | {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          }
        | undefined;
      labelField?:
        | {
            __typename?: "LabelFieldObject";
            height: number;
            width: number;
            x: number;
            y: number;
          }
        | undefined;
    }>;
    document: {
      __typename?: "DocumentObject";
      id: string;
      name: string;
      usState: UsState;
      form: string;
    };
  }>;
};

export type DocumentVersionListForOfferFlowQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: DocumentVersionListFilterArgs;
  isAgentVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  documentVersionFields?: InputMaybe<Scalars["Boolean"]["input"]>;
  previewImages?: InputMaybe<Scalars["Boolean"]["input"]>;
  skipSecondaryVersions?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type DocumentVersionListForOfferFlowQuery = {
  __typename?: "Query";
  publicDocumentVersionList?:
    | {
        __typename?: "PublicDocumentVersionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PublicDocumentVersionObject";
              id: string;
              previewImages: Array<{
                __typename?: "AssetFileObject";
                id: string;
                ordering: number;
                file: { __typename?: "FileObject"; url: string };
              }>;
              documentVersionFields: Array<{
                __typename?: "PublicDocumentVersionFieldObject";
                id: string;
                align: FieldAlign;
                pageNumber: number;
                fontFamily: string;
                fontSize: string;
                label: string;
                readOnly?: boolean | undefined;
                width: number;
                height: number;
                x: number;
                y: number;
                mappingKey: string;
                fieldType: FieldType;
                field: {
                  __typename?: "PublicFieldObject";
                  id: string;
                  group: string;
                  label: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        formulaVariableFields: Array<{
                          __typename?: "VariableFieldObject";
                          key: string;
                          source: VariableSource;
                          type: VariableDataType;
                        }>;
                        variableField?:
                          | {
                              __typename?: "VariableFieldObject";
                              key: string;
                              source: VariableSource;
                              type: VariableDataType;
                            }
                          | undefined;
                      }
                    | undefined;
                };
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                boundingBox: {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                };
              }>;
              document: { __typename?: "PublicDocumentObject"; id: string };
              secondaryVersions?: Array<{
                __typename?: "PublicDocumentVersionObject";
                id: string;
                mappingKeys: Array<string>;
                previewImages: Array<{
                  __typename?: "AssetFileObject";
                  id: string;
                  ordering: number;
                  file: { __typename?: "FileObject"; url: string };
                }>;
                documentVersionFields?: Array<{
                  __typename?: "PublicDocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  field: {
                    __typename?: "PublicFieldObject";
                    id: string;
                    group: string;
                    label: string;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            source: VariableSource;
                            type: VariableDataType;
                          }>;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                source: VariableSource;
                                type: VariableDataType;
                              }
                            | undefined;
                        }
                      | undefined;
                  };
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                }>;
                document: {
                  __typename?: "PublicDocumentObject";
                  id: string;
                  name: string;
                  usState: UsState;
                  form: string;
                };
              }>;
            }>
          | undefined;
      }
    | undefined;
  documentVersionList?:
    | {
        __typename?: "DocumentVersionObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "DocumentVersionObject";
              id: string;
              status: DocumentVersionStatus;
              version: string;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
              documentVersionFields: Array<{
                __typename?: "DocumentVersionFieldObject";
                id: string;
                align: FieldAlign;
                pageNumber: number;
                fontFamily: string;
                fontSize: string;
                label: string;
                readOnly?: boolean | undefined;
                width: number;
                height: number;
                x: number;
                y: number;
                mappingKey: string;
                fieldType: FieldType;
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  group: string;
                  label: string;
                  displayLabel?: string | undefined;
                  mappingKey: string;
                  fieldType: FieldType;
                  isComputed?: boolean | undefined;
                  isHidden?: boolean | undefined;
                  readOnly?: boolean | undefined;
                  aiExtract?: boolean | undefined;
                  aiInterpret?: boolean | undefined;
                  comparisonType?: ComparisonType | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                boundingBox: {
                  __typename?: "BoundingBoxObject";
                  left: number;
                  top: number;
                  right: number;
                  bottom: number;
                };
                labelBoundingBox?:
                  | {
                      __typename?: "BoundingBoxObject";
                      left: number;
                      top: number;
                      right: number;
                      bottom: number;
                    }
                  | undefined;
                labelField?:
                  | {
                      __typename?: "LabelFieldObject";
                      height: number;
                      width: number;
                      x: number;
                      y: number;
                    }
                  | undefined;
              }>;
              document: { __typename?: "DocumentObject"; id: string };
              secondaryVersions?: Array<{
                __typename?: "DocumentVersionObject";
                id: string;
                status: DocumentVersionStatus;
                version: string;
                mappingKeys: Array<string>;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
                previewImages?: Array<{
                  __typename?: "AssetFileObject";
                  id: string;
                }>;
                documentVersionFields?: Array<{
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  field: {
                    __typename?: "FieldObject";
                    id: string;
                    group: string;
                    label: string;
                    displayLabel?: string | undefined;
                    mappingKey: string;
                    fieldType: FieldType;
                    isComputed?: boolean | undefined;
                    isHidden?: boolean | undefined;
                    readOnly?: boolean | undefined;
                    aiExtract?: boolean | undefined;
                    aiInterpret?: boolean | undefined;
                    comparisonType?: ComparisonType | undefined;
                    inputFormat?:
                      | {
                          __typename?: "InputFormatObject";
                          type: InputFormatType;
                          options: {
                            __typename?: "InputFormatOptionsObject";
                            precision?: number | undefined;
                            formatString?: string | undefined;
                            currencySymbol?: string | undefined;
                          };
                        }
                      | undefined;
                  };
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                  labelBoundingBox?:
                    | {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      }
                    | undefined;
                  labelField?:
                    | {
                        __typename?: "LabelFieldObject";
                        height: number;
                        width: number;
                        x: number;
                        y: number;
                      }
                    | undefined;
                }>;
                document: {
                  __typename?: "DocumentObject";
                  id: string;
                  name: string;
                  usState: UsState;
                  form: string;
                };
              }>;
            }>
          | undefined;
      }
    | undefined;
};

export type DotloopComplianceGroupsQueryVariables = Exact<{
  filters: DotloopComplianceGroupsFilterInput;
}>;

export type DotloopComplianceGroupsQuery = {
  __typename?: "Query";
  dotloopComplianceGroups: Array<{
    __typename?: "DotloopComplianceGroupsObject";
    id?: string | undefined;
    name?: string | undefined;
    active?: boolean | undefined;
    type?: string | undefined;
    complianceStatuses?:
      | Array<Record<string, string | number | boolean | string[] | undefined>>
      | undefined;
    profileName?: string | undefined;
  }>;
};

export type EmbeddedSignatureRequestSecondaryDocumentFragment = {
  __typename?: "DocumentObject";
  id: string;
  name: string;
  activeDocumentVersion: {
    __typename?: "DocumentVersionObject";
    id: string;
    file: { __typename?: "FileObject"; fileName: string; url: string };
  };
};

export type EmbeddedSignatureRequestFragment = {
  __typename?: "ContractEmbeddedSignatureRequestPayload";
  isExpired: boolean;
  contract?:
    | {
        __typename?: "ContractObject";
        id: string;
        fieldValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }
    | undefined;
  primaryDocument?:
    | {
        __typename?: "DocumentObject";
        id: string;
        documentType: DocumentType;
        name: string;
        defaultSecondaryDocuments: Array<{
          __typename?: "DefaultSecondaryDocumentObject";
          id: string;
          secondaryDocument: {
            __typename?: "DocumentObject";
            id: string;
            name: string;
            activeDocumentVersion: {
              __typename?: "DocumentVersionObject";
              id: string;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            };
          };
        }>;
      }
    | undefined;
  signer?:
    | {
        __typename?: "SignatureRequestSignerObject";
        id: string;
        signedAt?: any | undefined;
        fullName: string;
      }
    | undefined;
  signatureRequest?:
    | {
        __typename?: "SignatureRequestObject";
        id: string;
        requester?:
          | {
              __typename?: "PublicUserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type EmbeddedSignatureRequestQueryVariables = Exact<{
  code: Scalars["String"]["input"];
}>;

export type EmbeddedSignatureRequestQuery = {
  __typename?: "Query";
  embeddedSignatureRequest: {
    __typename?: "ContractEmbeddedSignatureRequestPayload";
    isExpired: boolean;
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
        }
      | undefined;
    primaryDocument?:
      | {
          __typename?: "DocumentObject";
          id: string;
          documentType: DocumentType;
          name: string;
          defaultSecondaryDocuments: Array<{
            __typename?: "DefaultSecondaryDocumentObject";
            id: string;
            secondaryDocument: {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              activeDocumentVersion: {
                __typename?: "DocumentVersionObject";
                id: string;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              };
            };
          }>;
        }
      | undefined;
    signer?:
      | {
          __typename?: "SignatureRequestSignerObject";
          id: string;
          signedAt?: any | undefined;
          fullName: string;
        }
      | undefined;
    signatureRequest?:
      | {
          __typename?: "SignatureRequestObject";
          id: string;
          requester?:
            | {
                __typename?: "PublicUserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ExternalDarwinPropertyFieldsFragment = {
  __typename?: "DarwinPropertyObject";
  propertyId: number;
  propertyAddress: string;
  mlsNumber1: string;
  statusId: number;
  status: string;
  companyID: number;
  companyName?: string | undefined;
  ourList: boolean;
  ourSell: boolean;
  sellingPrice?: number | undefined;
  commissionPrice?: number | undefined;
  pendingDate?: any | undefined;
  estimatedClosingDate?: any | undefined;
  listingPrice?: number | undefined;
  listDate?: any | undefined;
  typeCode?: string | undefined;
  typeCodeName?: string | undefined;
  propertyUseId?: number | undefined;
  propertyTypeId?: number | undefined;
  propertyTypeName?: string | undefined;
  classificationId?: number | undefined;
  classificationName?: string | undefined;
  createdBy?: string | undefined;
  sellCommRate?: number | undefined;
  sellCommission?: number | undefined;
  isFlatCommission?: boolean | undefined;
  listCommRate?: number | undefined;
  listCommission?: number | undefined;
  cobrokeCommRate?: number | undefined;
  cobrokeCommission?: number | undefined;
  streetNumber?: string | undefined;
  streetDirection?: string | undefined;
  streetName?: string | undefined;
  streetDesignation?: string | undefined;
  streetSuffix?: string | undefined;
  suiteAptNumber?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        addressFull: string;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              originatingSystemName?: string | undefined;
              statusText: string;
              logoUrl?: string | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          full: string;
          unit?: string | undefined;
          city: string;
          state: string;
          postalCode?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              type?: MlsListingType | undefined;
              subType?: string | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type ExternalDarwinPropertiesQueryVariables = Exact<{
  input: ExternalDarwinPropertyInput;
}>;

export type ExternalDarwinPropertiesQuery = {
  __typename?: "Query";
  externalDarwinProperties: {
    __typename?: "ExternalDarwinPropertiesPayload";
    properties: Array<{
      __typename?: "DarwinPropertyObject";
      propertyId: number;
      propertyAddress: string;
      mlsNumber1: string;
      statusId: number;
      status: string;
      companyID: number;
      companyName?: string | undefined;
      ourList: boolean;
      ourSell: boolean;
      sellingPrice?: number | undefined;
      commissionPrice?: number | undefined;
      pendingDate?: any | undefined;
      estimatedClosingDate?: any | undefined;
      listingPrice?: number | undefined;
      listDate?: any | undefined;
      typeCode?: string | undefined;
      typeCodeName?: string | undefined;
      propertyUseId?: number | undefined;
      propertyTypeId?: number | undefined;
      propertyTypeName?: string | undefined;
      classificationId?: number | undefined;
      classificationName?: string | undefined;
      createdBy?: string | undefined;
      sellCommRate?: number | undefined;
      sellCommission?: number | undefined;
      isFlatCommission?: boolean | undefined;
      listCommRate?: number | undefined;
      listCommission?: number | undefined;
      cobrokeCommRate?: number | undefined;
      cobrokeCommission?: number | undefined;
      streetNumber?: string | undefined;
      streetDirection?: string | undefined;
      streetName?: string | undefined;
      streetDesignation?: string | undefined;
      streetSuffix?: string | undefined;
      suiteAptNumber?: string | undefined;
      city?: string | undefined;
      state?: string | undefined;
      zip?: string | undefined;
      mlsListing?:
        | {
            __typename?: "MLSListingObject";
            addressFull: string;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  originatingSystemName?: string | undefined;
                  statusText: string;
                  logoUrl?: string | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              full: string;
              unit?: string | undefined;
              city: string;
              state: string;
              postalCode?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  type?: MlsListingType | undefined;
                  subType?: string | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
  };
};

export type ExternalDarwinPropertyQueryVariables = Exact<{
  input: ExternalDarwinPropertyInput;
}>;

export type ExternalDarwinPropertyQuery = {
  __typename?: "Query";
  externalDarwinProperties: {
    __typename?: "ExternalDarwinPropertiesPayload";
    properties: Array<{
      __typename?: "DarwinPropertyObject";
      propertyId: number;
      propertyAddress: string;
      mlsNumber1: string;
      statusId: number;
      status: string;
      companyID: number;
      companyName?: string | undefined;
      ourList: boolean;
      ourSell: boolean;
      sellingPrice?: number | undefined;
      commissionPrice?: number | undefined;
      pendingDate?: any | undefined;
      estimatedClosingDate?: any | undefined;
      listingPrice?: number | undefined;
      listDate?: any | undefined;
      typeCode?: string | undefined;
      typeCodeName?: string | undefined;
      propertyUseId?: number | undefined;
      propertyTypeId?: number | undefined;
      propertyTypeName?: string | undefined;
      classificationId?: number | undefined;
      classificationName?: string | undefined;
      createdBy?: string | undefined;
      sellCommRate?: number | undefined;
      sellCommission?: number | undefined;
      isFlatCommission?: boolean | undefined;
      listCommRate?: number | undefined;
      listCommission?: number | undefined;
      cobrokeCommRate?: number | undefined;
      cobrokeCommission?: number | undefined;
      streetNumber?: string | undefined;
      streetDirection?: string | undefined;
      streetName?: string | undefined;
      streetDesignation?: string | undefined;
      streetSuffix?: string | undefined;
      suiteAptNumber?: string | undefined;
      city?: string | undefined;
      state?: string | undefined;
      zip?: string | undefined;
      participants?:
        | {
            __typename?: "DarwinParticipantsObject";
            buyersAgents: Array<{
              __typename?: "DarwinPersonObject";
              personName: string;
            }>;
            listingAgents: Array<{
              __typename?: "DarwinPersonObject";
              personName: string;
            }>;
            buyers: Array<{
              __typename?: "DarwinPersonObject";
              personName: string;
              leadSource?: string | undefined;
              leadGeneratedBy?: string | undefined;
            }>;
            sellers: Array<{
              __typename?: "DarwinPersonObject";
              personName: string;
              leadSource?: string | undefined;
              leadGeneratedBy?: string | undefined;
            }>;
            transactionCoordinators: Array<{
              __typename?: "DarwinPersonWithMatchObject";
              personName: string;
              isMatched: boolean;
            }>;
          }
        | undefined;
      mlsListing?:
        | {
            __typename?: "MLSListingObject";
            addressFull: string;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  originatingSystemName?: string | undefined;
                  statusText: string;
                  logoUrl?: string | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              full: string;
              unit?: string | undefined;
              city: string;
              state: string;
              postalCode?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  type?: MlsListingType | undefined;
                  subType?: string | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
  };
};

export type ExternalGetComplianceMessageHistoryQueryVariables = Exact<{
  input: ExternalGetComplianceMessageHistoryInput;
}>;

export type ExternalGetComplianceMessageHistoryQuery = {
  __typename?: "Query";
  externalGetComplianceMessageHistory: Array<{
    __typename?: "ComplianceMessageHistoryObject";
    id: string;
    recipientType: ComplianceMessageRecipientType;
    recipientValue: string;
    messageContent: string;
    workflowRunId: string;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type ExternalGetDarwinCompaniesQueryVariables = Exact<{
  organizationUuid: Scalars["ID"]["input"];
  sandbox: Scalars["Boolean"]["input"];
}>;

export type ExternalGetDarwinCompaniesQuery = {
  __typename?: "Query";
  externalGetDarwinCompanies: Array<{
    __typename?: "ExternalDarwinCompanyObject";
    companyId: number;
    companyName: string;
  }>;
};

export type ExternalGetDarwinCompanyOfficeMappingsQueryVariables = Exact<{
  organizationUuid: Scalars["ID"]["input"];
}>;

export type ExternalGetDarwinCompanyOfficeMappingsQuery = {
  __typename?: "Query";
  externalGetDarwinCompanyOfficeMappings: Array<{
    __typename?: "DarwinCompanyOfficeMappingObject";
    id: string;
    organizationUuid: string;
    platform: IngestionPlatform;
    platformProfileId: string;
    officeId: string;
    darwinCompanyId: number;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type ExternalGetDarwinPropertyClassificationQueryVariables = Exact<{
  input: ExternalGetDarwinPropertyClassificationInput;
}>;

export type ExternalGetDarwinPropertyClassificationQuery = {
  __typename?: "Query";
  externalGetDarwinPropertyClassification?:
    | {
        __typename?: "DarwinPropertyClassificationObject";
        typeCode?: string | undefined;
        typeCodeName?: string | undefined;
        propertyTypeId?: number | undefined;
        propertyTypeName?: string | undefined;
        classificationId?: number | undefined;
        classificationName?: string | undefined;
      }
    | undefined;
};

export type ExternalGetDarwinSyncPreviewQueryVariables = Exact<{
  input: ExternalGetDarwinSyncPreviewInput;
}>;

export type ExternalGetDarwinSyncPreviewQuery = {
  __typename?: "Query";
  externalGetDarwinSyncPreview: {
    __typename?: "DarwinSyncPreviewPayload";
    previewVersion: string;
    generatedAt: any;
    sections: Array<{
      __typename?: "DarwinSyncPreviewSection";
      sectionType: DarwinSyncPreviewSectionType;
      fields: Array<{
        __typename?: "DarwinSyncPreviewField";
        rowId?: string | undefined;
        label: DarwinPropertyDetailFieldLabel;
        hasChange: boolean;
        currentValue?:
          | {
              __typename?: "SyncPreviewCurrentValue";
              value?: string | undefined;
            }
          | undefined;
        proposedValue: {
          __typename?: "SyncPreviewProposedValue";
          value?: string | undefined;
          disabledReason?: string | undefined;
          warningMessage?: string | undefined;
          sourceLabel?: string | undefined;
          disabledOptions?:
            | {
                __typename?: "SyncPreviewDisabledOptions";
                isDisabled: boolean;
                isDisabledByDefault?: boolean | undefined;
                isRequired?: boolean | undefined;
              }
            | undefined;
        };
      }>;
    }>;
    companySection?:
      | {
          __typename?: "DarwinCompanyPreviewSection";
          resolutionStatus: DarwinCompanyResolutionStatus;
          currentValue?:
            | {
                __typename?: "DarwinCompanyValue";
                companyId: number;
                companyName?: string | undefined;
                officeNames: Array<string>;
                officeMlsIds: Array<string>;
              }
            | undefined;
          proposedValue?:
            | {
                __typename?: "DarwinCompanyValue";
                companyId: number;
                companyName?: string | undefined;
                officeNames: Array<string>;
                officeMlsIds: Array<string>;
              }
            | undefined;
          candidates: Array<{
            __typename?: "DarwinCompanyValue";
            companyId: number;
            companyName?: string | undefined;
            officeNames: Array<string>;
            officeMlsIds: Array<string>;
          }>;
        }
      | undefined;
    keyTermsSection?:
      | {
          __typename?: "DarwinSyncKeyTermsSection";
          sectionType: DarwinSyncPreviewSectionType;
          fields: Array<{
            __typename?: "DarwinSyncKeyTermField";
            rowId: string;
            keyTerm: string;
            darwinFieldKey: string;
            label: string;
            hasChange: boolean;
            currentValue?:
              | {
                  __typename?: "SyncPreviewCurrentValue";
                  value?: string | undefined;
                }
              | undefined;
            proposedValue: {
              __typename?: "SyncPreviewProposedValue";
              value?: string | undefined;
              sourceLabel?: string | undefined;
              disabledReason?: string | undefined;
              disabledOptions?:
                | {
                    __typename?: "SyncPreviewDisabledOptions";
                    isDisabled: boolean;
                    isDisabledByDefault?: boolean | undefined;
                  }
                | undefined;
            };
          }>;
        }
      | undefined;
    vendorsSection?:
      | {
          __typename?: "DarwinSyncPersonSection";
          sectionType: DarwinSyncPreviewSectionType;
          fields: Array<{
            __typename?: "DarwinSyncPersonField";
            rowId: string;
            label: string;
            vendorType?: DarwinVendorType | undefined;
            hasChange: boolean;
            currentValue?:
              | {
                  __typename?: "DarwinSyncPersonCurrentValue";
                  propertyPeopleId?: number | undefined;
                  personId?: number | undefined;
                  personName?: string | undefined;
                  side?: string | undefined;
                }
              | undefined;
            proposedValue: {
              __typename?: "DarwinSyncPersonProposedValue";
              value?: string | undefined;
              sourceLabel?: string | undefined;
              disabledReason?: string | undefined;
              changeType: DarwinPersonChangeType;
              matchedPersonId?: number | undefined;
              matchedPersonName?: string | undefined;
              confidence?: DarwinPersonMatchConfidence | undefined;
              side?: string | undefined;
              alternatives?:
                | Array<{
                    __typename?: "DarwinPersonCandidate";
                    personId: number;
                    personName: string;
                    matchScore: number;
                    confidence: DarwinPersonMatchConfidence;
                  }>
                | undefined;
              disabledOptions?:
                | {
                    __typename?: "SyncPreviewDisabledOptions";
                    isDisabled: boolean;
                    isDisabledByDefault?: boolean | undefined;
                  }
                | undefined;
            };
          }>;
        }
      | undefined;
    feesSection?:
      | {
          __typename?: "DarwinSyncFeeSection";
          fields: Array<{
            __typename?: "DarwinSyncFeeField";
            rowId: string;
            feeType: DarwinFeeType;
            label: string;
            hasChange: boolean;
            currentValue?:
              | {
                  __typename?: "DarwinSyncFeeCurrentValue";
                  amount?: number | undefined;
                }
              | undefined;
            proposedValue: {
              __typename?: "DarwinSyncFeeProposedValue";
              amount?: number | undefined;
              payer?: string | undefined;
              sourceLabel?: string | undefined;
              disabledReason?: string | undefined;
              disabledOptions?:
                | {
                    __typename?: "SyncPreviewDisabledOptions";
                    isDisabled: boolean;
                    isDisabledByDefault?: boolean | undefined;
                  }
                | undefined;
            };
          }>;
        }
      | undefined;
    participantsSection?:
      | {
          __typename?: "DarwinParticipantsSection";
          leadSource?:
            | {
                __typename?: "DarwinParticipantLeadSource";
                sourceOfBusiness?: string | undefined;
                leadSourceName?: string | undefined;
                leadGeneratedByName?: string | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ExternalGetMlsListingSelectionQueryVariables = Exact<{
  input: ExternalGetMlsListingSelectionInput;
}>;

export type ExternalGetMlsListingSelectionQuery = {
  __typename?: "Query";
  externalGetMLSListingSelection: {
    __typename?: "MLSListingSelectionPayload";
    isAmbiguous: boolean;
    selectionReason: string;
    totalListingsFound: number;
    selectedListing?:
      | {
          __typename?: "MLSListingObject";
          addressFull: string;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                originatingSystemName?: string | undefined;
                statusText: string;
                logoUrl?: string | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            full: string;
            unit?: string | undefined;
            city: string;
            state: string;
            postalCode?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                type?: MlsListingType | undefined;
                subType?: string | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    rankedListings: Array<{
      __typename?: "RankedMLSListingObject";
      score: number;
      disqualified: boolean;
      disqualificationReason?: string | undefined;
      listing: {
        __typename?: "MLSListingObject";
        addressFull: string;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              originatingSystemName?: string | undefined;
              statusText: string;
              logoUrl?: string | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          full: string;
          unit?: string | undefined;
          city: string;
          state: string;
          postalCode?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              type?: MlsListingType | undefined;
              subType?: string | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
      };
      rankingFactors: {
        __typename?: "MLSListingRankingFactorsObject";
        statusScore: number;
        recencyScore: number;
        propertyTypeMatch: number;
        osnPreferenceMatch: number;
        documentRelevanceScore: number;
      };
    }>;
  };
};

export type ExternalGetObservedDotloopOfficesQueryVariables = Exact<{
  organizationUuid: Scalars["ID"]["input"];
}>;

export type ExternalGetObservedDotloopOfficesQuery = {
  __typename?: "Query";
  externalGetObservedDotloopOffices: Array<{
    __typename?: "ObservedDotloopOfficeObject";
    platformProfileId: string;
    officeId: string;
    officeNameSnapshot?: string | undefined;
  }>;
};

export type ExternalKeyTermsListQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ExternalKeyTermsListQuery = {
  __typename?: "Query";
  externalKeyTermsList: Array<{
    __typename?: "ExternalKeyTermsObject";
    id: string;
    columnName: string;
    fieldType: FieldType;
  }>;
};

export type FieldListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<FieldListFilterArgs>;
  fieldDetail?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FieldListQuery = {
  __typename?: "Query";
  fieldList?:
    | {
        __typename?: "FieldObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "FieldObject";
              id: string;
              group: string;
              label: string;
              displayLabel?: string | undefined;
              mappingKey: string;
              fieldType: FieldType;
              isComputed?: boolean | undefined;
              isHidden?: boolean | undefined;
              readOnly?: boolean | undefined;
              aiExtract?: boolean | undefined;
              aiInterpret?: boolean | undefined;
              comparisonType?: ComparisonType | undefined;
              includedDocumentVersions?:
                | Array<{
                    __typename?: "DocumentVersionObject";
                    id: string;
                    version: string;
                    document: {
                      __typename?: "DocumentObject";
                      id: string;
                      form: string;
                      usState: UsState;
                    };
                  }>
                | undefined;
              inputFormat?:
                | {
                    __typename?: "InputFormatObject";
                    type: InputFormatType;
                    options: {
                      __typename?: "InputFormatOptionsObject";
                      precision?: number | undefined;
                      formatString?: string | undefined;
                      currencySymbol?: string | undefined;
                    };
                  }
                | undefined;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              optionsAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              helpTextAutofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    errorMessageTemplate?: string | undefined;
                    focusFieldMappingKeys?: Array<string> | undefined;
                    contextForLLMJudge?: string | undefined;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          variableSources: Array<VariableSource>;
                          formula?: string | undefined;
                          variableField?:
                            | {
                                __typename?: "VariableFieldObject";
                                key: string;
                                type: VariableDataType;
                                source: VariableSource;
                              }
                            | undefined;
                          formulaVariableFields: Array<{
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }>;
                          formulaTestCases: Array<{
                            __typename?: "FormulaTestCaseObject";
                            values: Record<
                              string,
                              string | number | boolean | string[] | undefined
                            >;
                            expected: string;
                            llmOutput?: boolean | undefined;
                          }>;
                          documents?:
                            | Array<{
                                __typename?: "DocumentCompactObject";
                                id: string;
                                name: string;
                                description: string;
                                documentCategory?: DocumentCategory | undefined;
                                documentType: DocumentType;
                                form: string;
                                usState: UsState;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type GenerateValidationReportQueryVariables = Exact<{
  folderUuid: Scalars["String"]["input"];
}>;

export type GenerateValidationReportQuery = {
  __typename?: "Query";
  generateValidationReport?: string | undefined;
};

export type GetComplianceGroupTransactionStagesQueryVariables = Exact<{
  organizationUuid: Scalars["ID"]["input"];
}>;

export type GetComplianceGroupTransactionStagesQuery = {
  __typename?: "Query";
  getComplianceGroupTransactionStages: Array<{
    __typename?: "ComplianceGroupTransactionStageObject";
    id: string;
    organizationUuid: string;
    complianceGroupId: string;
    complianceGroupName: string;
    transactionStageType: TransactionStageType;
  }>;
};

export type GetDocumentVersionFieldQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type GetDocumentVersionFieldQuery = {
  __typename?: "Query";
  getDocumentVersionField?:
    | {
        __typename?: "DocumentVersionFieldObject";
        id: string;
        align: FieldAlign;
        pageNumber: number;
        fontFamily: string;
        fontSize: string;
        label: string;
        readOnly?: boolean | undefined;
        width: number;
        height: number;
        x: number;
        y: number;
        mappingKey: string;
        fieldType: FieldType;
        field: {
          __typename?: "FieldObject";
          id: string;
          group: string;
          label: string;
          displayLabel?: string | undefined;
          mappingKey: string;
          fieldType: FieldType;
          isComputed?: boolean | undefined;
          isHidden?: boolean | undefined;
          readOnly?: boolean | undefined;
          aiExtract?: boolean | undefined;
          aiInterpret?: boolean | undefined;
          comparisonType?: ComparisonType | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          optionsAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          helpTextAutofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
          defaultRules?:
            | Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                errorMessageTemplate?: string | undefined;
                focusFieldMappingKeys?: Array<string> | undefined;
                contextForLLMJudge?: string | undefined;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      variableSources: Array<VariableSource>;
                      formula?: string | undefined;
                      variableField?:
                        | {
                            __typename?: "VariableFieldObject";
                            key: string;
                            type: VariableDataType;
                            source: VariableSource;
                          }
                        | undefined;
                      formulaVariableFields: Array<{
                        __typename?: "VariableFieldObject";
                        key: string;
                        type: VariableDataType;
                        source: VariableSource;
                      }>;
                      formulaTestCases: Array<{
                        __typename?: "FormulaTestCaseObject";
                        values: Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >;
                        expected: string;
                        llmOutput?: boolean | undefined;
                      }>;
                      documents?:
                        | Array<{
                            __typename?: "DocumentCompactObject";
                            id: string;
                            name: string;
                            description: string;
                            documentCategory?: DocumentCategory | undefined;
                            documentType: DocumentType;
                            form: string;
                            usState: UsState;
                          }>
                        | undefined;
                    }
                  | undefined;
              }>
            | undefined;
        };
        rules: Array<{
          __typename?: "RuleObject";
          id: string;
          message: string;
          errorMessageTemplate?: string | undefined;
          focusFieldMappingKeys?: Array<string> | undefined;
          contextForLLMJudge?: string | undefined;
          ruleType: RuleType;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        }>;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        optionsAutofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        helpTextAutofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
        boundingBox: {
          __typename?: "BoundingBoxObject";
          left: number;
          top: number;
          right: number;
          bottom: number;
        };
        labelBoundingBox?:
          | {
              __typename?: "BoundingBoxObject";
              left: number;
              top: number;
              right: number;
              bottom: number;
            }
          | undefined;
        labelField?:
          | {
              __typename?: "LabelFieldObject";
              height: number;
              width: number;
              x: number;
              y: number;
            }
          | undefined;
      }
    | undefined;
};

export type GetDocumentVersionInfoQueryVariables = Exact<{
  input: GetDocumentVersionInfoInput;
}>;

export type GetDocumentVersionInfoQuery = {
  __typename?: "Query";
  getDocumentVersionInfo: {
    __typename?: "GetDocumentVersionInfoPayload";
    id: string;
    usState: UsState;
    documentType: DocumentType;
    name: string;
    form: string;
    version: string;
    searchRegex?: string | undefined;
  };
};

export type GetOrganizationFolderNameValidationStageOverrideQueryVariables =
  Exact<{
    organizationUuid: Scalars["ID"]["input"];
  }>;

export type GetOrganizationFolderNameValidationStageOverrideQuery = {
  __typename?: "Query";
  getOrganizationFolderNameValidationStageOverride: {
    __typename?: "OrganizationFolderNameValidationStageOverrideObject";
    organizationUuid: string;
    isEnabled: boolean;
    keywordMappings: Array<{
      __typename?: "FolderNameValidationStageKeywordMappingObject";
      keyword: string;
      action: FolderNameValidationStageOverrideAction;
      transactionStageType?: TransactionStageType | undefined;
    }>;
  };
};

export type GetSignedUrlsQueryVariables = Exact<{
  input: GetSignedUrlsInput;
}>;

export type GetSignedUrlsQuery = {
  __typename?: "Query";
  getSignedUrls: {
    __typename?: "GetSignedUrlsPayload";
    urls: Array<{
      __typename?: "SignedUrlPayload";
      key: string;
      signedUrl: string;
    }>;
  };
};

export type IngestionDocumentListWithFieldsQueryVariables = Exact<{
  ingestionFolderId: Scalars["String"]["input"];
}>;

export type IngestionDocumentListWithFieldsQuery = {
  __typename?: "Query";
  ingestionDocumentList?:
    | Array<{
        __typename?: "IngestionDocumentObject";
        id: string;
        fields?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }>
    | undefined;
};

export type IngestionFolderCountsByPipelineQueryVariables = Exact<{
  filters: IngestionFolderCountsByPipelineFilterArgs;
}>;

export type IngestionFolderCountsByPipelineQuery = {
  __typename?: "Query";
  ingestionFolderCountsByPipeline: {
    __typename?: "IngestionFolderCountsByPipelineResult";
    pipelineCounts: Array<{
      __typename?: "IngestionFolderPipelineCount";
      transactionPipelineId?: string | undefined;
      count: number;
    }>;
  };
};

export type IngestionFolderCountsByStageQueryVariables = Exact<{
  filters: IngestionFolderCountsByStageFilterArgs;
}>;

export type IngestionFolderCountsByStageQuery = {
  __typename?: "Query";
  ingestionFolderCountsByStage: {
    __typename?: "IngestionFolderCountsByStageResult";
    stageCounts: Array<{
      __typename?: "IngestionFolderStageCount";
      stage?: TransactionStageType | undefined;
      count: number;
    }>;
  };
};

export type IngestionFolderListFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  platform: IngestionPlatform;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  activeMlsListingId?: string | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  createdAt: any;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        clientType: ClientType;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
      }
    | undefined;
  ingestionDocuments?: Array<{
    __typename?: "IngestionDocumentObject";
    fields?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    contractDocumentPages?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    id: string;
    documentId: string;
    documentName: string;
    documentCreatedAt: any;
    documentUpdatedAt: any;
    isBlank: boolean;
    s3Bucket: string;
    s3Key: string;
    fileUrl?: string | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      order: number;
      externalDocumentType?: ExternalDocumentType | undefined;
      externalDocumentName?: string | undefined;
      documentCategory?: string | undefined;
      file: { __typename?: "FileObject"; fileName: string; url: string };
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            version: string;
            document: {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              form: string;
              documentType: DocumentType;
            };
          }
        | undefined;
    }>;
  }>;
  organization?:
    | { __typename?: "OrganizationObject"; id: string; name: string }
    | undefined;
};

export type IngestionFolderListQueryVariables = Exact<{
  filters: IngestionFolderListFilterArgs;
  includeTransactionPipeline?: Scalars["Boolean"]["input"];
  includeIngestionDocuments?: Scalars["Boolean"]["input"];
  includeRepositionedFields?: Scalars["Boolean"]["input"];
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type IngestionFolderListQuery = {
  __typename?: "Query";
  ingestionFolderList?:
    | {
        __typename?: "IngestionFolderObjectPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              id: string;
              platform: IngestionPlatform;
              organizationUuid: string;
              folderId: string;
              folderName: string;
              transactionSide: TransactionSide;
              status: string;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              activeMlsListingId?: string | undefined;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              createdAt: any;
              transactionPipeline?:
                | {
                    __typename?: "TransactionPipelineObject";
                    id: string;
                    clientType: ClientType;
                    usState: UsState;
                    transactionPropertyType: TransactionPropertyType;
                  }
                | undefined;
              ingestionDocuments?: Array<{
                __typename?: "IngestionDocumentObject";
                fields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                contractDocumentPages?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                id: string;
                documentId: string;
                documentName: string;
                documentCreatedAt: any;
                documentUpdatedAt: any;
                isBlank: boolean;
                s3Bucket: string;
                s3Key: string;
                fileUrl?: string | undefined;
                contractDocuments: Array<{
                  __typename?: "ContractDocumentObject";
                  id: string;
                  order: number;
                  externalDocumentType?: ExternalDocumentType | undefined;
                  externalDocumentName?: string | undefined;
                  documentCategory?: string | undefined;
                  file: {
                    __typename?: "FileObject";
                    fileName: string;
                    url: string;
                  };
                  documentVersion?:
                    | {
                        __typename?: "DocumentVersionObject";
                        id: string;
                        version: string;
                        document: {
                          __typename?: "DocumentObject";
                          id: string;
                          name: string;
                          form: string;
                          documentType: DocumentType;
                        };
                      }
                    | undefined;
                }>;
              }>;
              organization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type IngestionFolderListForEssentialsFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  organizationUuid: string;
  activeMlsListingId?: string | undefined;
  normalizedFieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  folderName: string;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  validationErrorCount?: number | undefined;
  platform: IngestionPlatform;
  status: string;
  transactionSide: TransactionSide;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        clientType: ClientType;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
      }
    | undefined;
  participants?:
    | {
        __typename?: "Participants";
        buyers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        sellers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        listingAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        buyersAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        transactionCoordinators: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
      }
    | undefined;
};

export type IngestionFolderListForEssentialsQueryVariables = Exact<{
  filters: IngestionFolderListFilterArgs;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type IngestionFolderListForEssentialsQuery = {
  __typename?: "Query";
  ingestionFolderList?:
    | {
        __typename?: "IngestionFolderObjectPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              id: string;
              organizationUuid: string;
              activeMlsListingId?: string | undefined;
              normalizedFieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              folderName: string;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              validationErrorCount?: number | undefined;
              platform: IngestionPlatform;
              status: string;
              transactionSide: TransactionSide;
              transactionPipeline?:
                | {
                    __typename?: "TransactionPipelineObject";
                    id: string;
                    clientType: ClientType;
                    usState: UsState;
                    transactionPropertyType: TransactionPropertyType;
                  }
                | undefined;
              participants?:
                | {
                    __typename?: "Participants";
                    buyers: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                    sellers: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                    listingAgents: Array<{
                      __typename?: "AgentParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                      officeName?: string | undefined;
                      officeId?: string | undefined;
                      mlsAgentId?: string | undefined;
                    }>;
                    buyersAgents: Array<{
                      __typename?: "AgentParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                      officeName?: string | undefined;
                      officeId?: string | undefined;
                      mlsAgentId?: string | undefined;
                    }>;
                    transactionCoordinators: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type IngestionFolderForPipelineViewFragment = {
  __typename?: "IngestionFolderObject";
  txPipelineNeedsInvestigationReason?: TxPipelineNeedsInvestigationReason;
  id: string;
  platform: IngestionPlatform;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  activeMlsListingId?: string | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  createdAt: any;
  organization?:
    | { __typename?: "OrganizationObject"; id: string; name: string }
    | undefined;
};

export type IngestionFolderListForOrganizationPipelineViewQueryVariables =
  Exact<{
    filters: IngestionFolderListFilterArgs;
    includeInvestigationReason?: Scalars["Boolean"]["input"];
    orderBy?: Scalars["String"]["input"];
    perPage?: Scalars["Int"]["input"];
    cursor?: InputMaybe<Scalars["String"]["input"]>;
  }>;

export type IngestionFolderListForOrganizationPipelineViewQuery = {
  __typename?: "Query";
  ingestionFolderList?:
    | {
        __typename?: "IngestionFolderObjectPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              txPipelineNeedsInvestigationReason?: TxPipelineNeedsInvestigationReason;
              id: string;
              platform: IngestionPlatform;
              organizationUuid: string;
              folderId: string;
              folderName: string;
              transactionSide: TransactionSide;
              status: string;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              activeMlsListingId?: string | undefined;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              createdAt: any;
              organization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type IngestionFolderPlatformUrlQueryVariables = Exact<{
  ingestionFolderId: Scalars["String"]["input"];
}>;

export type IngestionFolderPlatformUrlQuery = {
  __typename?: "Query";
  ingestionFolderPlatformUrl?: string | undefined;
};

export type InternalContractVariableValuesQueryVariables = Exact<{
  input: Array<ContractVariableValuesInput> | ContractVariableValuesInput;
}>;

export type InternalContractVariableValuesQuery = {
  __typename?: "Query";
  internalContractVariableValues: Array<{
    __typename?: "ContractVariableValuesPayload";
    contractId?: string | undefined;
    contractVariableValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    variableSource?: VariableSource | undefined;
    state?: UsState | undefined;
  }>;
};

export type InternalDarwinSyncRunQueryVariables = Exact<{
  input: InternalDarwinSyncRunInput;
}>;

export type InternalDarwinSyncRunQuery = {
  __typename?: "Query";
  internalDarwinSyncRun?:
    | {
        __typename?: "InternalDarwinSyncRunDetailPayload";
        syncRunId: string;
        initiatedByLabel: string;
        context: {
          __typename?: "DarwinSyncRunContextPayload";
          syncRunId: string;
          organizationUuid: string;
          ingestionFolderUuid?: string | undefined;
          externalFolderId: string;
          darwinPropertyId?: number | undefined;
          transactionSide?: string | undefined;
          useSandbox: boolean;
          source: string;
          cause: string;
          attempt: number;
          parentRunId?: string | undefined;
          triggerId: string;
        };
        initiatedByUser?:
          | {
              __typename?: "DarwinSyncRunInitiatedByUserPayload";
              uuid: string;
              fullName?: string | undefined;
              primaryEmail?: string | undefined;
            }
          | undefined;
        sourceSnapshot?:
          | {
              __typename?: "DarwinSyncRunSourceSnapshotPayload";
              previewVersion?: string | undefined;
              previewTimestamp?: string | undefined;
              oldestSourceUpdatedAt?: string | undefined;
              newestSourceUpdatedAt?: string | undefined;
              previewStale?: boolean | undefined;
            }
          | undefined;
        selectionIntent?:
          | {
              __typename?: "DarwinSyncRunSelectionIntentPayload";
              totalCount?: number | undefined;
              categoryCounts?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
            }
          | undefined;
        decisionTrace?:
          | {
              __typename?: "DarwinSyncRunDecisionTracePayload";
              decisions: Array<{
                __typename?: "DarwinSyncRunDecisionEntryPayload";
                domain: string;
                outcome: string;
                reasonCode?: string | undefined;
                summary?: string | undefined;
                details?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
              }>;
            }
          | undefined;
        outcomes: {
          __typename?: "DarwinSyncRunOutcomesPayload";
          status: DarwinSyncRunStatus;
          selectedCount?: number | undefined;
          appliedCount?: number | undefined;
          skippedCount?: number | undefined;
          disabledCount?: number | undefined;
          failedCount?: number | undefined;
          rootCauseCategory?: string | undefined;
          rootCauseSubcategory?: string | undefined;
          needsDownstreamJoin?: boolean | undefined;
          skippedReasonCounts?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          skipCode?: string | undefined;
          failureCode?: string | undefined;
          errorMessage?: string | undefined;
          failingStep?: string | undefined;
          retryable?: boolean | undefined;
          rowOutcomes?:
            | Array<{
                __typename?: "DarwinSyncRunRowOutcomePayload";
                rowId: string;
                category: string;
                status: string;
                reasonCode?: string | undefined;
                summary?: string | undefined;
              }>
            | undefined;
        };
        joinHints?:
          | {
              __typename?: "DarwinSyncRunJoinHintsPayload";
              darwinPropertyId?: number | undefined;
              darwinVendorIds?: Array<number> | undefined;
              darwinParticipantIds?: Array<number> | undefined;
              referencedIngestionDocumentUuids?: Array<string> | undefined;
              referencedContractDocumentUuids?: Array<string> | undefined;
              sentryWindowStart?: string | undefined;
              sentryWindowEnd?: string | undefined;
              posthogWindowStart?: string | undefined;
              posthogWindowEnd?: string | undefined;
              posthogActorId?: string | undefined;
            }
          | undefined;
        timeline: {
          __typename?: "DarwinSyncRunTimelinePayload";
          startedAt: any;
          completedAt?: any | undefined;
          durationMs?: number | undefined;
          createdAt: any;
          updatedAt: any;
          timelineStatus: string;
          timelineUnavailableReason?: string | undefined;
          timelineEvents?:
            | Array<{
                __typename?: "DarwinSyncTimelineEventPayload";
                eventType: string;
                timestamp: string;
                payload?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
              }>
            | undefined;
        };
      }
    | undefined;
};

export type InternalDarwinSyncRunsQueryVariables = Exact<{
  input: InternalDarwinSyncRunsInput;
}>;

export type InternalDarwinSyncRunsQuery = {
  __typename?: "Query";
  internalDarwinSyncRuns: {
    __typename?: "InternalDarwinSyncRunsPayload";
    items: Array<{
      __typename?: "InternalDarwinSyncRunListItem";
      syncRunId: string;
      organizationUuid: string;
      ingestionFolderUuid?: string | undefined;
      folderName?: string | undefined;
      status: DarwinSyncRunStatus;
      source: string;
      cause: string;
      initiatedByUserUuid?: string | undefined;
      startedAt: any;
      completedAt?: any | undefined;
      durationMs?: number | undefined;
      selectedCount?: number | undefined;
      appliedCount?: number | undefined;
      skippedCount?: number | undefined;
      rootCauseCategory?: string | undefined;
      needsDownstreamJoin?: boolean | undefined;
      skipCode?: string | undefined;
      failureCode?: string | undefined;
    }>;
  };
};

export type InternalGetIngestionDocumentValidationErrorReviewsQueryVariables =
  Exact<{
    input: GetIngestionDocumentValidationErrorReviewsInput;
  }>;

export type InternalGetIngestionDocumentValidationErrorReviewsQuery = {
  __typename?: "Query";
  internalGetIngestionDocumentValidationErrorReviews: Array<{
    __typename?: "IngestionDocumentValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    contractDocumentUuid?: string | undefined;
    ruleUuid?: string | undefined;
    pageNumber?: number | undefined;
    ingestionDocument?:
      | {
          __typename?: "IngestionDocumentObject";
          id: string;
          documentId: string;
          documentName: string;
        }
      | undefined;
    ingestionDocumentValidation?:
      | {
          __typename?: "IngestionDocumentValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  }>;
};

export type InternalGetIngestionDocumentValidationFeedbackQueryVariables =
  Exact<{
    input: GetIngestionDocumentValidationFeedbackInput;
  }>;

export type InternalGetIngestionDocumentValidationFeedbackQuery = {
  __typename?: "Query";
  internalGetIngestionDocumentValidationFeedback: Array<{
    __typename?: "IngestionDocumentValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ruleUuid?: string | undefined;
    contractDocumentUuid?: string | undefined;
    ingestionDocumentValidation?:
      | { __typename?: "IngestionDocumentValidationObject"; id: string }
      | undefined;
  }>;
};

export type InternalGetIngestionFolderDetailQueryVariables = Exact<{
  input: InternalIngestionFolderListForOrganizationInput;
  includeTransactionPipeline?: Scalars["Boolean"]["input"];
  includeKeyTerms?: Scalars["Boolean"]["input"];
  sortKeyTermsByDatetime?: Scalars["Boolean"]["input"];
}>;

export type InternalGetIngestionFolderDetailQuery = {
  __typename?: "Query";
  internalIngestionFolderListForOrganization?:
    | {
        __typename?: "IngestionFolderObjectInternalPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              aiValidationErrorCount?: number | undefined;
              regularValidationErrorCount?: number | undefined;
              fullyReprocessedAt?: any | undefined;
              txPipelineMatchedBy?: TxPipelineMatchedBy | undefined;
              txPipelineUpdatedAt?: any | undefined;
              txPipelineNeedsInvestigationReason: TxPipelineNeedsInvestigationReason;
              id: string;
              organizationUuid: string;
              folderId: string;
              folderName: string;
              transactionSide: TransactionSide;
              status: string;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              activeMlsListingId?: string | undefined;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              platform: IngestionPlatform;
              folderUpdatedAt?: any | undefined;
              normalizedFieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              validationErrorCount?: number | undefined;
              dotloopProfileId?: string | undefined;
              transactionPipeline?:
                | {
                    __typename?: "TransactionPipelineObject";
                    id: string;
                    clientType: ClientType;
                    usState: UsState;
                    transactionPropertyType: TransactionPropertyType;
                    stages: Array<{
                      __typename?: "TransactionStageObject";
                      id: string;
                      stage: TransactionStageType;
                      sortOrder: number;
                      validationRules?:
                        | Array<{
                            __typename?: "TransactionRuleObject";
                            id: string;
                            isRequiredDocument: boolean;
                            targetDocument?:
                              | {
                                  __typename?: "DocumentObject";
                                  id: string;
                                  form: string;
                                }
                              | undefined;
                            rules: Array<{
                              __typename?: "RuleObject";
                              id: string;
                              ruleType: RuleType;
                            }>;
                            children: Array<{
                              __typename?: "TransactionRuleObject";
                              id: string;
                              isRequiredDocument: boolean;
                              targetDocument?:
                                | {
                                    __typename?: "DocumentObject";
                                    id: string;
                                    form: string;
                                  }
                                | undefined;
                              rules: Array<{
                                __typename?: "RuleObject";
                                id: string;
                                ruleType: RuleType;
                              }>;
                            }>;
                          }>
                        | undefined;
                    }>;
                  }
                | undefined;
              txPipelineCandidates: Array<{
                __typename?: "TxPipelineCandidateObject";
                pipelineUuid: string;
                pipelineName?: string | undefined;
                clientType?: string | undefined;
                usState?: string | undefined;
                transactionPropertyType?: string | undefined;
                matchedBy: Array<TxPipelineMatchedBy>;
                ruleMatchFormula?: string | undefined;
              }>;
              keyTerms?:
                | Array<{
                    __typename?: "KeyTermSection";
                    title: string;
                    description: string;
                    fields: Array<{
                      __typename?: "KeyTermField";
                      fieldLabel: string;
                      fieldType: string;
                      key: string;
                      isEditable: boolean;
                      value?: any | undefined;
                      fieldFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                      values: Array<{
                        __typename?: "KeyTermValue";
                        value?: any | undefined;
                        timestamp: any;
                        source: KeyTermSourceType;
                        sourceLabel: string;
                        validationError?: string | undefined;
                        isCurrent: boolean;
                        metadata?:
                          | {
                              __typename?: "KeyTermCalculatedMetadata";
                              ingestionDocumentId: string;
                              contractDocumentId: string;
                            }
                          | {
                              __typename?: "KeyTermUserOverrideMetadata";
                              overriddenBy: {
                                __typename?: "PublicUserObject";
                                id: string;
                                email?: string | undefined;
                                firstName: string;
                                lastName: string;
                              };
                            }
                          | undefined;
                      }>;
                    }>;
                    children?:
                      | Array<{
                          __typename?: "KeyTermSection";
                          title: string;
                          description: string;
                          fields: Array<{
                            __typename?: "KeyTermField";
                            fieldLabel: string;
                            fieldType: string;
                            key: string;
                            isEditable: boolean;
                            value?: any | undefined;
                            fieldFormat?:
                              | {
                                  __typename?: "InputFormatObject";
                                  type: InputFormatType;
                                  options: {
                                    __typename?: "InputFormatOptionsObject";
                                    precision?: number | undefined;
                                    formatString?: string | undefined;
                                    currencySymbol?: string | undefined;
                                  };
                                }
                              | undefined;
                            values: Array<{
                              __typename?: "KeyTermValue";
                              value?: any | undefined;
                              timestamp: any;
                              source: KeyTermSourceType;
                              sourceLabel: string;
                              validationError?: string | undefined;
                              isCurrent: boolean;
                              metadata?:
                                | {
                                    __typename?: "KeyTermCalculatedMetadata";
                                    ingestionDocumentId: string;
                                    contractDocumentId: string;
                                  }
                                | {
                                    __typename?: "KeyTermUserOverrideMetadata";
                                    overriddenBy: {
                                      __typename?: "PublicUserObject";
                                      id: string;
                                      email?: string | undefined;
                                      firstName: string;
                                      lastName: string;
                                    };
                                  }
                                | undefined;
                            }>;
                          }>;
                        }>
                      | undefined;
                  }>
                | undefined;
              participants?:
                | {
                    __typename?: "Participants";
                    buyers: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                    sellers: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                    buyersAgents: Array<{
                      __typename?: "AgentParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                      officeName?: string | undefined;
                      officeId?: string | undefined;
                      mlsAgentId?: string | undefined;
                    }>;
                    listingAgents: Array<{
                      __typename?: "AgentParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                      officeName?: string | undefined;
                      officeId?: string | undefined;
                      mlsAgentId?: string | undefined;
                    }>;
                    transactionCoordinators: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                    loanOfficers: Array<{
                      __typename?: "ClientParticipant";
                      email?: string | undefined;
                      name: string;
                      phoneNumber?: string | undefined;
                    }>;
                  }
                | undefined;
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          originatingSystemName?: string | undefined;
                          statusText: string;
                          logoUrl?: string | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      full: string;
                      unit?: string | undefined;
                      city: string;
                      state: string;
                      postalCode?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          type?: MlsListingType | undefined;
                          subType?: string | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type InternalGetIngestionFolderValidationErrorReviewsQueryVariables =
  Exact<{
    input: GetIngestionFolderValidationErrorReviewsInput;
  }>;

export type InternalGetIngestionFolderValidationErrorReviewsQuery = {
  __typename?: "Query";
  internalGetIngestionFolderValidationErrorReviews: Array<{
    __typename?: "IngestionFolderValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    documentCategory?: string | undefined;
    documentForm?: string | undefined;
    documentName?: string | undefined;
    ruleUuid?: string | undefined;
    ingestionFolderValidation?:
      | {
          __typename?: "IngestionFolderValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  }>;
};

export type InternalGetIngestionFolderValidationFeedbackQueryVariables = Exact<{
  input: GetIngestionFolderValidationFeedbackInput;
}>;

export type InternalGetIngestionFolderValidationFeedbackQuery = {
  __typename?: "Query";
  internalGetIngestionFolderValidationFeedback: Array<{
    __typename?: "IngestionFolderValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ingestionFolderValidation?:
      | { __typename?: "IngestionFolderValidationObject"; id: string }
      | undefined;
  }>;
};

export type InternalGetValidationReportDataQueryVariables = Exact<{
  input: InternalGetValidationReportDataInput;
}>;

export type InternalGetValidationReportDataQuery = {
  __typename?: "Query";
  internalGetValidationReportData?:
    | {
        __typename?: "ValidationReportDataObject";
        keyTerms?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        documentValidations: Array<{
          __typename?: "IngestionDocumentValidationObject";
          id: string;
          isCurrent: boolean;
          version: string;
          errorCount: number;
          warningCount: number;
          aiErrorCount: number;
          aiWarningCount: number;
          validationResults: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          aiValidationResults: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          aiAnalysis: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          createdAt: any;
          updatedAt: any;
          transactionStage?:
            | {
                __typename?: "TransactionStageObject";
                id: string;
                stage: TransactionStageType;
              }
            | undefined;
          ingestionDocument: {
            __typename?: "IngestionDocumentObject";
            id: string;
          };
        }>;
        folderValidation?:
          | {
              __typename?: "IngestionFolderValidationObject";
              id: string;
              isCurrent: boolean;
              version: string;
              errorCount: number;
              validationResults?:
                | Array<
                    Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  >
                | undefined;
              createdAt: any;
              validatedAt: any;
              updatedAt: any;
              ingestionFolder?:
                | { __typename?: "IngestionFolderObject"; id: string }
                | undefined;
            }
          | undefined;
        property?:
          | {
              __typename?: "DocumentPropertyObject";
              id: string;
              slug: string;
              streetAddress: string;
              unit?: string | undefined;
              city: string;
              state: UsState;
              zipCode: string;
              zipCodePlus4?: string | undefined;
              county: string;
              countyFips: string;
              msa?: string | undefined;
              lot: string;
              block: string;
              platBook: string;
              platBookPage: string;
              subdivision: string;
              parcelId: string;
              yearBuilt?: number | undefined;
              otherLegalDescription: string;
              geo?:
                | { __typename?: "DocumentGeoObject"; lat: number; lng: number }
                | undefined;
            }
          | undefined;
        autofillData?:
          | {
              __typename?: "OfferIngestionAutofillObject";
              ingestion: {
                __typename?: "OfferIngestionFolderObject";
                transactionSide: TransactionSide;
                metadata: {
                  __typename?: "OfferIngestionMetadataObject";
                  agent_name?: string | undefined;
                  folder_name?: string | undefined;
                  folder_id?: string | undefined;
                  office_id?: string | undefined;
                  office_name?: string | undefined;
                  transaction_closing_date?: string | undefined;
                  participants: {
                    __typename?: "OfferIngestionParticipantsObject";
                    buyerAgentNames?: Array<string> | undefined;
                    listingAgentNames?: Array<string> | undefined;
                    buyerNames?: Array<string> | undefined;
                    sellerNames?: Array<string> | undefined;
                    otherTeamMemberNames?: Array<string> | undefined;
                  };
                };
              };
            }
          | undefined;
      }
    | undefined;
};

export type InternalIngestionDocumentsForFolderQueryVariables = Exact<{
  input: InternalIngestionDocumentsForFolderInput;
}>;

export type InternalIngestionDocumentsForFolderQuery = {
  __typename?: "Query";
  internalIngestionDocumentsForFolder: Array<{
    __typename?: "IngestionDocumentObject";
    id: string;
    documentId: string;
    documentName: string;
    documentCreatedAt: any;
    documentUpdatedAt: any;
    fileUrl?: string | undefined;
    isBlank: boolean;
    needsReview?: boolean | undefined;
    isArchived: boolean;
    isClassified: boolean;
    version: string;
    complianceStatus?: string | undefined;
    complianceGroupId?: string | undefined;
    complianceStatusId?: string | undefined;
    folderName?: string | undefined;
    folderId?: string | undefined;
    wasAutoApproved: boolean;
    contractDocumentPages?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      order: number;
      documentCategory?: string | undefined;
      externalDocumentName?: string | undefined;
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            document: {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              form: string;
              documentType: DocumentType;
            };
          }
        | undefined;
      file: { __typename?: "FileObject"; url: string };
    }>;
  }>;
};

export type InternalIngestionFolderListForOrganizationQueryVariables = Exact<{
  input: InternalIngestionFolderListForOrganizationInput;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  includeTransactionPipeline?: Scalars["Boolean"]["input"];
}>;

export type InternalIngestionFolderListForOrganizationQuery = {
  __typename?: "Query";
  internalIngestionFolderListForOrganization?:
    | {
        __typename?: "IngestionFolderObjectInternalPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              id: string;
              folderName: string;
              transactionSide: TransactionSide;
              status: string;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              folderUpdatedAt?: any | undefined;
              keyTermColumns?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              regularValidationErrorCount?: number | undefined;
              aiValidationErrorCount?: number | undefined;
              txPipelineNeedsInvestigationReason: TxPipelineNeedsInvestigationReason;
              transactionPipeline?:
                | {
                    __typename?: "TransactionPipelineObject";
                    id: string;
                    usState: UsState;
                    transactionPropertyType: TransactionPropertyType;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type InternalIngestionFolderValidationStatusQueryVariables = Exact<{
  input: InternalIngestionFolderValidationStatusInput;
}>;

export type InternalIngestionFolderValidationStatusQuery = {
  __typename?: "Query";
  internalIngestionFolderValidationStatus: {
    __typename?: "IngestionFolderValidationStatusObject";
    status: string;
    waiting: number;
    active: number;
    failed: number;
    delayed: number;
    total: number;
    latestValidatedAt?: any | undefined;
  };
};

export type InternalOrganizationListQueryVariables = Exact<{
  prodOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type InternalOrganizationListQuery = {
  __typename?: "Query";
  internalOrganizationList: Array<{
    __typename?: "OrganizationObject";
    id: string;
    name: string;
  }>;
};

export type RulesOverviewRuleFragment = {
  __typename?: "RuleObject";
  id: string;
  message: string;
  ruleType: RuleType;
  autofill?:
    | {
        __typename?: "AutofillObject";
        id: string;
        formula?: string | undefined;
      }
    | undefined;
};

export type InternalRulesOverviewQueryVariables = Exact<{
  filters?: InputMaybe<RulesOverviewFiltersInput>;
}>;

export type InternalRulesOverviewQuery = {
  __typename?: "Query";
  internalRulesOverview: {
    __typename?: "RulesOverviewPayload";
    pipelines: Array<{
      __typename?: "RulesOverviewPipelineObject";
      clientType: ClientType;
      usState: UsState;
      transactionPropertyType: TransactionPropertyType;
      stages: Array<{
        __typename?: "RulesOverviewStageObject";
        stage: TransactionStageType;
        stageRequirementRules: Array<{
          __typename?: "RulesOverviewTransactionRuleObject";
          id: string;
          isRequiredDocument: boolean;
          logicalOperator: LogicalOperator;
          targetDocumentCategory?: DocumentCategory | undefined;
          targetDocument?:
            | {
                __typename?: "DocumentObject";
                id: string;
                name: string;
                form: string;
                usState: UsState;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
              }
            | undefined;
          offerIngestionRule?:
            | {
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      formula?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            ruleType: RuleType;
            autofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  formula?: string | undefined;
                }
              | undefined;
          }>;
          children: Array<{
            __typename?: "RulesOverviewTransactionRuleObject";
            id: string;
            isRequiredDocument: boolean;
            logicalOperator: LogicalOperator;
            targetDocumentCategory?: DocumentCategory | undefined;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  name: string;
                  form: string;
                  usState: UsState;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                }
              | undefined;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        formula?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    formula?: string | undefined;
                  }
                | undefined;
            }>;
            children: Array<{
              __typename?: "RulesOverviewTransactionRuleObject";
              id: string;
              isRequiredDocument: boolean;
              logicalOperator: LogicalOperator;
              targetDocumentCategory?: DocumentCategory | undefined;
              targetDocument?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    usState: UsState;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                  }
                | undefined;
              offerIngestionRule?:
                | {
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          formula?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              rules: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      formula?: string | undefined;
                    }
                  | undefined;
              }>;
            }>;
          }>;
        }>;
        validationRules: Array<{
          __typename?: "RulesOverviewTransactionRuleObject";
          id: string;
          isRequiredDocument: boolean;
          logicalOperator: LogicalOperator;
          targetDocumentCategory?: DocumentCategory | undefined;
          targetDocument?:
            | {
                __typename?: "DocumentObject";
                id: string;
                name: string;
                form: string;
                usState: UsState;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
              }
            | undefined;
          offerIngestionRule?:
            | {
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      formula?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            ruleType: RuleType;
            autofill?:
              | {
                  __typename?: "AutofillObject";
                  id: string;
                  formula?: string | undefined;
                }
              | undefined;
          }>;
          children: Array<{
            __typename?: "RulesOverviewTransactionRuleObject";
            id: string;
            isRequiredDocument: boolean;
            logicalOperator: LogicalOperator;
            targetDocumentCategory?: DocumentCategory | undefined;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  name: string;
                  form: string;
                  usState: UsState;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                }
              | undefined;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                  autofill?:
                    | {
                        __typename?: "AutofillObject";
                        id: string;
                        formula?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    formula?: string | undefined;
                  }
                | undefined;
            }>;
            children: Array<{
              __typename?: "RulesOverviewTransactionRuleObject";
              id: string;
              isRequiredDocument: boolean;
              logicalOperator: LogicalOperator;
              targetDocumentCategory?: DocumentCategory | undefined;
              targetDocument?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    usState: UsState;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                  }
                | undefined;
              offerIngestionRule?:
                | {
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    ruleType: RuleType;
                    autofill?:
                      | {
                          __typename?: "AutofillObject";
                          id: string;
                          formula?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              rules: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
                autofill?:
                  | {
                      __typename?: "AutofillObject";
                      id: string;
                      formula?: string | undefined;
                    }
                  | undefined;
              }>;
            }>;
          }>;
        }>;
      }>;
    }>;
    documents: Array<{
      __typename?: "RulesOverviewDocumentRuleGroupObject";
      document: {
        __typename?: "DocumentObject";
        id: string;
        name: string;
        form: string;
        usState: UsState;
        documentType: DocumentType;
        documentCategory?: DocumentCategory | undefined;
      };
      fieldRules: Array<{
        __typename?: "RulesOverviewDocumentFieldRuleObject";
        documentVersionFieldId: string;
        mappingKey: string;
        field?:
          | {
              __typename?: "FieldObject";
              id: string;
              label: string;
              mappingKey: string;
            }
          | undefined;
        rule: {
          __typename?: "RuleObject";
          id: string;
          message: string;
          ruleType: RuleType;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                formula?: string | undefined;
              }
            | undefined;
        };
      }>;
    }>;
  };
};

export type LoadPipelineInvestigationReasonsForValidationQueryVariables =
  Exact<{
    input: LoadPipelineInvestigationReasonsForValidationInput;
  }>;

export type LoadPipelineInvestigationReasonsForValidationQuery = {
  __typename?: "Query";
  loadPipelineInvestigationReasonsForValidation: {
    __typename?: "LoadPipelineInvestigationReasonsForValidationResponse";
    processedCount: number;
    failedCount: number;
    results: Array<{
      __typename?: "PipelineInvestigationReasonResult";
      folderUuid: string;
      txPipelineNeedsInvestigationReason?:
        | TxPipelineNeedsInvestigationReason
        | undefined;
      failed: boolean;
    }>;
  };
};

export type MlQueueJobStatusQueryVariables = Exact<{
  jobId: Scalars["String"]["input"];
}>;

export type MlQueueJobStatusQuery = {
  __typename?: "Query";
  mlQueueJobStatus?:
    | {
        __typename?: "MLQueueJobStatusPayload";
        isFailed?: boolean | undefined;
        isCompleted?: boolean | undefined;
        isInProgress?: boolean | undefined;
      }
    | undefined;
};

export type OfferIngestionAutofillVariablesSchemaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OfferIngestionAutofillVariablesSchemaQuery = {
  __typename?: "Query";
  offerIngestionAutofillVariablesSchema: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
};

export type OfferIngestionDocumentAutofillVariablesSchemaQueryVariables =
  Exact<{ [key: string]: never }>;

export type OfferIngestionDocumentAutofillVariablesSchemaQuery = {
  __typename?: "Query";
  offerIngestionDocumentAutofillVariablesSchema: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
};

export type OrganizationValidationSettingsQueryVariables = Exact<{
  transactionPipelineId: Scalars["String"]["input"];
  transactionStageId: Scalars["String"]["input"];
  organizationId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type OrganizationValidationSettingsQuery = {
  __typename?: "Query";
  organizationValidationSettings: {
    __typename?: "OrganizationValidationSettingsObject";
    stageIgnoredRuleIds: Array<string>;
    documentIgnoredRuleIds: Array<string>;
    configuredOrganizations: Array<{
      __typename?: "OrganizationValidationSettingsConfiguredOrganizationObject";
      organizationId: string;
      stageIgnoredRuleIds: Array<string>;
      documentIgnoredRuleIds: Array<string>;
    }>;
  };
};

export type PreviewFieldsToColumnQueryVariables = Exact<{
  contractId: Scalars["ID"]["input"];
}>;

export type PreviewFieldsToColumnQuery = {
  __typename?: "Query";
  previewFieldsToColumn?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
};

export type PreviewReassignIngestionFolderPipelinesQueryVariables = Exact<{
  input: PreviewReassignIngestionFolderPipelinesInput;
}>;

export type PreviewReassignIngestionFolderPipelinesQuery = {
  __typename?: "Query";
  previewReassignIngestionFolderPipelines: {
    __typename?: "PreviewReassignIngestionFolderPipelinesPayload";
    results: Array<{
      __typename?: "PipelinePreviewResult";
      ingestionFolderUuid: string;
      currentPipelineUuid?: string | undefined;
      currentPipelineName?: string | undefined;
      currentMatchedBy?: TxPipelineMatchedBy | undefined;
      currentStage?: TransactionStageType | undefined;
      proposedPipelineUuid?: string | undefined;
      proposedPipelineName?: string | undefined;
      proposedStage?: TransactionStageType | undefined;
      proposedMatchedBy?: TxPipelineMatchedBy | undefined;
      needsInvestigationReason?: TxPipelineNeedsInvestigationReason | undefined;
      error?: string | undefined;
      candidates: Array<{
        __typename?: "TxPipelineCandidateObject";
        pipelineUuid: string;
        pipelineName?: string | undefined;
        clientType?: string | undefined;
        usState?: string | undefined;
        transactionPropertyType?: string | undefined;
        matchedBy: Array<TxPipelineMatchedBy>;
        ruleMatchFormula?: string | undefined;
      }>;
    }>;
  };
};

export type RuleListQueryVariables = Exact<{
  filters: RuleListFilterArgs;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RuleListQuery = {
  __typename?: "Query";
  ruleList?:
    | {
        __typename?: "RuleObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              errorMessageTemplate?: string | undefined;
              focusFieldMappingKeys?: Array<string> | undefined;
              contextForLLMJudge?: string | undefined;
              ruleType: RuleType;
              autofill?:
                | {
                    __typename?: "AutofillObject";
                    id: string;
                    variableSources: Array<VariableSource>;
                    formula?: string | undefined;
                    variableField?:
                      | {
                          __typename?: "VariableFieldObject";
                          key: string;
                          type: VariableDataType;
                          source: VariableSource;
                        }
                      | undefined;
                    formulaVariableFields: Array<{
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }>;
                    formulaTestCases: Array<{
                      __typename?: "FormulaTestCaseObject";
                      values: Record<
                        string,
                        string | number | boolean | string[] | undefined
                      >;
                      expected: string;
                      llmOutput?: boolean | undefined;
                    }>;
                    documents?:
                      | Array<{
                          __typename?: "DocumentCompactObject";
                          id: string;
                          name: string;
                          description: string;
                          documentCategory?: DocumentCategory | undefined;
                          documentType: DocumentType;
                          form: string;
                          usState: UsState;
                        }>
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type RuleMissingKeysQueryVariables = Exact<{
  transactionRuleId: Scalars["ID"]["input"];
  ruleId: Scalars["ID"]["input"];
}>;

export type RuleMissingKeysQuery = {
  __typename?: "Query";
  ruleMissingKeys?:
    | {
        __typename?: "RuleMissingKeysPayload";
        ruleId: string;
        documentVersionsMissingKeys: Array<{
          __typename?: "DocumentVersionMissingKey";
          documentId: string;
          documentVersionId: string;
          version: string;
          searchRegex?: string | undefined;
          missingMappingKeys: Array<string>;
        }>;
      }
    | undefined;
};

export type SearchIngestionFoldersForValidationQueryVariables = Exact<{
  filters: IngestionFolderValidationFiltersInput;
}>;

export type SearchIngestionFoldersForValidationQuery = {
  __typename?: "Query";
  searchIngestionFoldersForValidation: {
    __typename?: "IngestionFolderValidationSearchResponse";
    totalCount: number;
    cappedToLimit?: number | undefined;
    folders: Array<{
      __typename?: "IngestionFolderValidationSearchResult";
      uuid: string;
      folderName: string;
      organizationId: string;
      organizationName: string;
      transactionPipelineId?: string | undefined;
      transactionPipelineName: string;
      platform: string;
      metadataFolderId?: string | undefined;
      lastValidationDate?: any | undefined;
      lastUpdatedAt?: any | undefined;
      createdAt: any;
      stage?: TransactionStageType | undefined;
      normalizedStatus?: NormalizedTransactionStatus | undefined;
      transactionSide?: TransactionSide | undefined;
    }>;
  };
};

export type SignatureInitialDatasetFilesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type SignatureInitialDatasetFilesQuery = {
  __typename?: "Query";
  signatureInitialDatasetFiles: {
    __typename?: "SignatureInitialDatasetFilesPayload";
    draft: Array<{
      __typename?: "SignatureInitialDatasetFilePayload";
      key: string;
    }>;
    active: Array<{
      __typename?: "SignatureInitialDatasetFilePayload";
      key: string;
    }>;
    original: Array<{
      __typename?: "SignatureInitialDatasetFilePayload";
      key: string;
    }>;
    invalid: Array<{
      __typename?: "SignatureInitialDatasetFilePayload";
      key: string;
    }>;
    validations: Array<{
      __typename?: "SignatureInitialDatasetFilePayload";
      key: string;
    }>;
  };
};

export type SignatureInitialsDatasetMetricsQueryVariables = Exact<{
  input: SignatureInitialsDatasetMetricsInput;
}>;

export type SignatureInitialsDatasetMetricsQuery = {
  __typename?: "Query";
  signatureInitialsDatasetMetrics: {
    __typename?: "SignatureInitialsDatasetMetricsPayload";
    draft: Array<{
      __typename?: "SignatureInitialsDatasetMetricsEntryPayload";
      usState?: UsState | undefined;
      formName?: string | undefined;
      count: number;
    }>;
    final: Array<{
      __typename?: "SignatureInitialsDatasetMetricsEntryPayload";
      usState?: UsState | undefined;
      formName?: string | undefined;
      count: number;
    }>;
  };
};

export type TransactionPipelineListFragment = {
  __typename?: "TransactionPipelineObject";
  id: string;
  clientType: ClientType;
  usState: UsState;
  transactionPropertyType: TransactionPropertyType;
  rule?:
    | {
        __typename?: "RuleObject";
        id: string;
        message: string;
        errorMessageTemplate?: string | undefined;
        focusFieldMappingKeys?: Array<string> | undefined;
        contextForLLMJudge?: string | undefined;
        ruleType: RuleType;
        autofill?:
          | {
              __typename?: "AutofillObject";
              id: string;
              variableSources: Array<VariableSource>;
              formula?: string | undefined;
              variableField?:
                | {
                    __typename?: "VariableFieldObject";
                    key: string;
                    type: VariableDataType;
                    source: VariableSource;
                  }
                | undefined;
              formulaVariableFields: Array<{
                __typename?: "VariableFieldObject";
                key: string;
                type: VariableDataType;
                source: VariableSource;
              }>;
              formulaTestCases: Array<{
                __typename?: "FormulaTestCaseObject";
                values: Record<
                  string,
                  string | number | boolean | string[] | undefined
                >;
                expected: string;
                llmOutput?: boolean | undefined;
              }>;
              documents?:
                | Array<{
                    __typename?: "DocumentCompactObject";
                    id: string;
                    name: string;
                    description: string;
                    documentCategory?: DocumentCategory | undefined;
                    documentType: DocumentType;
                    form: string;
                    usState: UsState;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
  stages?: Array<{
    __typename?: "TransactionStageObject";
    id: string;
    stage: TransactionStageType;
    sortOrder: number;
    stageRequirementRules?:
      | Array<{
          __typename?: "TransactionRuleObject";
          id: string;
          organizationUuid?: string | undefined;
          targetDocumentCategory?: DocumentCategory | undefined;
          isRequiredDocument: boolean;
          logicalOperator: LogicalOperator;
          updatedAt: any;
          targetDocument?:
            | {
                __typename?: "DocumentObject";
                id: string;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
                name: string;
                description: string;
                form: string;
                usState: UsState;
                includeInOfferIngestion: boolean;
                llmExtraction: boolean;
                updatedAt?: any | undefined;
              }
            | undefined;
          parent?:
            | { __typename?: "TransactionRuleObject"; id: string }
            | undefined;
          offerIngestionRule?:
            | {
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }
            | undefined;
          children: Array<{
            __typename?: "TransactionRuleObject";
            organizationUuid?: string | undefined;
            id: string;
            targetDocumentCategory?: DocumentCategory | undefined;
            logicalOperator: LogicalOperator;
            updatedAt: any;
            isRequiredDocument: boolean;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                }
              | undefined;
            parent?:
              | { __typename?: "TransactionRuleObject"; id: string }
              | undefined;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                  name: string;
                  description: string;
                  form: string;
                  usState: UsState;
                  includeInOfferIngestion: boolean;
                  llmExtraction: boolean;
                  updatedAt?: any | undefined;
                }
              | undefined;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }>;
          }>;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            ruleType: RuleType;
          }>;
        }>
      | undefined;
    validationRules?:
      | Array<{
          __typename?: "TransactionRuleObject";
          id: string;
          organizationUuid?: string | undefined;
          targetDocumentCategory?: DocumentCategory | undefined;
          isRequiredDocument: boolean;
          logicalOperator: LogicalOperator;
          updatedAt: any;
          targetDocument?:
            | {
                __typename?: "DocumentObject";
                id: string;
                documentType: DocumentType;
                documentCategory?: DocumentCategory | undefined;
                name: string;
                description: string;
                form: string;
                usState: UsState;
                includeInOfferIngestion: boolean;
                llmExtraction: boolean;
                updatedAt?: any | undefined;
              }
            | undefined;
          parent?:
            | { __typename?: "TransactionRuleObject"; id: string }
            | undefined;
          offerIngestionRule?:
            | {
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }
            | undefined;
          children: Array<{
            __typename?: "TransactionRuleObject";
            organizationUuid?: string | undefined;
            id: string;
            targetDocumentCategory?: DocumentCategory | undefined;
            logicalOperator: LogicalOperator;
            updatedAt: any;
            isRequiredDocument: boolean;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                }
              | undefined;
            parent?:
              | { __typename?: "TransactionRuleObject"; id: string }
              | undefined;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                  name: string;
                  description: string;
                  form: string;
                  usState: UsState;
                  includeInOfferIngestion: boolean;
                  llmExtraction: boolean;
                  updatedAt?: any | undefined;
                }
              | undefined;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }>;
          }>;
          rules: Array<{
            __typename?: "RuleObject";
            id: string;
            message: string;
            ruleType: RuleType;
          }>;
        }>
      | undefined;
  }>;
};

export type TransactionPipelineListQueryVariables = Exact<{
  filters: TransactionPipelineListFilterArgs;
  includeRule?: Scalars["Boolean"]["input"];
  includeStages?: Scalars["Boolean"]["input"];
  includeTransactionRules?: Scalars["Boolean"]["input"];
}>;

export type TransactionPipelineListQuery = {
  __typename?: "Query";
  transactionPipelineList: Array<{
    __typename?: "TransactionPipelineObject";
    id: string;
    clientType: ClientType;
    usState: UsState;
    transactionPropertyType: TransactionPropertyType;
    rule?:
      | {
          __typename?: "RuleObject";
          id: string;
          message: string;
          errorMessageTemplate?: string | undefined;
          focusFieldMappingKeys?: Array<string> | undefined;
          contextForLLMJudge?: string | undefined;
          ruleType: RuleType;
          autofill?:
            | {
                __typename?: "AutofillObject";
                id: string;
                variableSources: Array<VariableSource>;
                formula?: string | undefined;
                variableField?:
                  | {
                      __typename?: "VariableFieldObject";
                      key: string;
                      type: VariableDataType;
                      source: VariableSource;
                    }
                  | undefined;
                formulaVariableFields: Array<{
                  __typename?: "VariableFieldObject";
                  key: string;
                  type: VariableDataType;
                  source: VariableSource;
                }>;
                formulaTestCases: Array<{
                  __typename?: "FormulaTestCaseObject";
                  values: Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >;
                  expected: string;
                  llmOutput?: boolean | undefined;
                }>;
                documents?:
                  | Array<{
                      __typename?: "DocumentCompactObject";
                      id: string;
                      name: string;
                      description: string;
                      documentCategory?: DocumentCategory | undefined;
                      documentType: DocumentType;
                      form: string;
                      usState: UsState;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    stages?: Array<{
      __typename?: "TransactionStageObject";
      id: string;
      stage: TransactionStageType;
      sortOrder: number;
      stageRequirementRules?:
        | Array<{
            __typename?: "TransactionRuleObject";
            id: string;
            organizationUuid?: string | undefined;
            targetDocumentCategory?: DocumentCategory | undefined;
            isRequiredDocument: boolean;
            logicalOperator: LogicalOperator;
            updatedAt: any;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                  name: string;
                  description: string;
                  form: string;
                  usState: UsState;
                  includeInOfferIngestion: boolean;
                  llmExtraction: boolean;
                  updatedAt?: any | undefined;
                }
              | undefined;
            parent?:
              | { __typename?: "TransactionRuleObject"; id: string }
              | undefined;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                }
              | undefined;
            children: Array<{
              __typename?: "TransactionRuleObject";
              organizationUuid?: string | undefined;
              id: string;
              targetDocumentCategory?: DocumentCategory | undefined;
              logicalOperator: LogicalOperator;
              updatedAt: any;
              isRequiredDocument: boolean;
              offerIngestionRule?:
                | {
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    ruleType: RuleType;
                  }
                | undefined;
              parent?:
                | { __typename?: "TransactionRuleObject"; id: string }
                | undefined;
              targetDocument?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                    name: string;
                    description: string;
                    form: string;
                    usState: UsState;
                    includeInOfferIngestion: boolean;
                    llmExtraction: boolean;
                    updatedAt?: any | undefined;
                  }
                | undefined;
              rules: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }>;
            }>;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }>;
          }>
        | undefined;
      validationRules?:
        | Array<{
            __typename?: "TransactionRuleObject";
            id: string;
            organizationUuid?: string | undefined;
            targetDocumentCategory?: DocumentCategory | undefined;
            isRequiredDocument: boolean;
            logicalOperator: LogicalOperator;
            updatedAt: any;
            targetDocument?:
              | {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                  documentCategory?: DocumentCategory | undefined;
                  name: string;
                  description: string;
                  form: string;
                  usState: UsState;
                  includeInOfferIngestion: boolean;
                  llmExtraction: boolean;
                  updatedAt?: any | undefined;
                }
              | undefined;
            parent?:
              | { __typename?: "TransactionRuleObject"; id: string }
              | undefined;
            offerIngestionRule?:
              | {
                  __typename?: "RuleObject";
                  id: string;
                  message: string;
                  ruleType: RuleType;
                }
              | undefined;
            children: Array<{
              __typename?: "TransactionRuleObject";
              organizationUuid?: string | undefined;
              id: string;
              targetDocumentCategory?: DocumentCategory | undefined;
              logicalOperator: LogicalOperator;
              updatedAt: any;
              isRequiredDocument: boolean;
              offerIngestionRule?:
                | {
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    ruleType: RuleType;
                  }
                | undefined;
              parent?:
                | { __typename?: "TransactionRuleObject"; id: string }
                | undefined;
              targetDocument?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                    documentCategory?: DocumentCategory | undefined;
                    name: string;
                    description: string;
                    form: string;
                    usState: UsState;
                    includeInOfferIngestion: boolean;
                    llmExtraction: boolean;
                    updatedAt?: any | undefined;
                  }
                | undefined;
              rules: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }>;
            }>;
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }>;
          }>
        | undefined;
    }>;
  }>;
};

export type TransactionPipelineUsStatesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TransactionPipelineUsStatesQuery = {
  __typename?: "Query";
  transactionPipelineUsStates?: Array<UsState> | undefined;
};

export type TransactionRuleMissingKeysQueryVariables = Exact<{
  transactionRuleId: Scalars["ID"]["input"];
}>;

export type TransactionRuleMissingKeysQuery = {
  __typename?: "Query";
  transactionRuleMissingKeys?:
    | {
        __typename?: "TransactionRuleMissingKeysPayload";
        transactionRuleId: string;
        documentVersionsMissingKeys: Array<{
          __typename?: "DocumentVersionMissingKey";
          documentId: string;
          documentVersionId: string;
          version: string;
          searchRegex?: string | undefined;
          missingMappingKeys: Array<string>;
        }>;
      }
    | undefined;
};

export type AiConversationFragment = {
  __typename?: "AIConversationObject";
  id: string;
  title: string;
  lastAIMessage?: string | undefined;
  conversationType: AiConversationType;
  createdAt: any;
  updatedAt: any;
  deletedAt?: any | undefined;
};

export type AccessControlFragment = {
  __typename?: "AccessControlObject";
  id: string;
  accessRole: AccessRole;
  accessUser: {
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ActivityFragment = {
  __typename?: "ActivityObject";
  id: string;
  type: ActivityType;
  createdAt: any;
  metadata: Record<
    string,
    | string
    | number
    | boolean
    | string[]
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined
  >;
  user?:
    | {
        __typename?: "PublicUserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        phoneNumber: string;
        email?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }
    | undefined;
  listing?:
    | {
        __typename?: "ListingObject";
        id: string;
        property: { __typename?: "PropertyObject"; id: string; slug: string };
        mlsListing?:
          | {
              __typename?: "MLSListingObject";
              id: string;
              address: {
                __typename?: "MLSListingAddressObject";
                city: string;
                country?: string | undefined;
                crossStreet?: string | undefined;
                full: string;
                postalCode?: string | undefined;
                state: string;
                streetName: string;
                streetNumber?: number | undefined;
                streetNumberText: string;
                unit?: string | undefined;
              };
            }
          | undefined;
      }
    | undefined;
};

export type AppEventFragment = {
  __typename?: "AppEventObject";
  id: string;
  name: string;
  doneBy?: { __typename?: "UserObject"; id: string } | undefined;
  offer?: { __typename?: "OfferObject"; id: string } | undefined;
};

export type BusinessOverviewStatFragment = {
  __typename?: "BusinessOverviewStat";
  metric: BusinessOverviewMetric;
  estimatedDealValue?: number | undefined;
  current: {
    __typename?: "BusinessOverviewMetricValue";
    value: number;
    from: string;
    to: string;
  };
  previous: {
    __typename?: "BusinessOverviewMetricValue";
    value: number;
    from: string;
    to: string;
  };
  chart: {
    __typename?: "ChartData";
    type: ListingReportChartType;
    title: string;
    valueUnit: ChartUnit;
    labelUnit: ChartUnit;
    styleConfig: { __typename?: "ChartStyleConfig"; showLegend: boolean };
    mainMetric: {
      __typename?: "ChartMetric";
      value?: number | undefined;
      description: string;
      unit: ChartUnit;
      trend?:
        | {
            __typename?: "ChartTrend";
            value?: number | undefined;
            period: string;
          }
        | undefined;
    };
    data: Array<{
      __typename?: "ChartDataPoint";
      label: string;
      value?: number | undefined;
    }>;
    verticalReferenceLine?:
      | {
          __typename?: "ChartDataPoint";
          label: string;
          value?: number | undefined;
        }
      | undefined;
  };
};

export type BizOverviewOfferFragment = {
  __typename?: "BizOverviewOfferObject";
  id: string;
  createdAt: any;
  status: BusinessOverviewOfferStatus;
  buyerNames: Array<string>;
  purchasePrice: number;
  agent?:
    | {
        __typename?: "OfferAgentObject";
        fullName: string;
        profilePicture?:
          | { __typename?: "FileObject"; url: string; fileName: string }
          | undefined;
      }
    | undefined;
  property: {
    __typename?: "OfferPropertyObject";
    coverPhotoUrl?: string | undefined;
    address: {
      __typename?: "AddressObject";
      streetAddress: string;
      city: string;
      state: UsState;
      zipCode: string;
      unit?: string | undefined;
    };
  };
};

export type GetOfferMetadataFragment = {
  __typename?: "GetOfferMetadataObject";
  buyer_name: string;
  buyer_signed: boolean;
  buyer_signed_date?: string | undefined;
  close_date?: string | undefined;
  co_buyer_name: string;
  co_seller_name: string;
  created_at?: string | undefined;
  due_diligence_end_date?: string | undefined;
  due_diligence_fee: number;
  due_diligence_period_in_days: number;
  earnest_money_deposit: number;
  financing_type: string;
  has_financing_contingency: boolean;
  has_home_sale_contingency: boolean;
  id: string;
  indigo_offer_status: string;
  is_entity_buyer: boolean;
  is_entity_seller: boolean;
  listing_agent_email: string;
  listing_agent_name: string;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  metadata_s3_key: string;
  mls_listing_id: string;
  organization_id: string;
  participants: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
  property_city: string;
  property_full_address: string;
  property_state: string;
  property_street_address: string;
  property_tax_id: string;
  property_unit: string;
  property_zip_code: string;
  purchase_price: number;
  seller_concessions: number;
  seller_name: string;
  seller_signed: boolean;
  seller_signed_date?: string | undefined;
  selling_agent_email: string;
  selling_agent_name: string;
  team_name: string;
  termination_fee: number;
  transaction_side: string;
  updated_at: number;
};

export type AgentContingencyOfferRecFragment = {
  __typename?: "AgentContingencyOfferRec";
  value?: boolean | undefined;
  notes?: string | undefined;
  type: ContingencyType;
};

export type AgentKeyTermsOfferRecFragment = {
  __typename?: "AgentKeyTermsOfferRec";
  value?: number | undefined;
  notes?: string | undefined;
  type: KeyTermType;
};

export type CompetitivenessAdjustmentFragment = {
  __typename?: "CompetitivenessAdjustment";
  adjustedLevel: CompetitivenessLevel;
  reason: string;
};

export type AgentOfferRecsFragment = {
  __typename?: "AgentOfferRecsPayload";
  contingencies?:
    | Array<{
        __typename?: "AgentContingencyOfferRec";
        value?: boolean | undefined;
        notes?: string | undefined;
        type: ContingencyType;
      }>
    | undefined;
  keyTerms?:
    | Array<{
        __typename?: "AgentKeyTermsOfferRec";
        value?: number | undefined;
        notes?: string | undefined;
        type: KeyTermType;
      }>
    | undefined;
  competitivenessAdjustment?:
    | {
        __typename?: "CompetitivenessAdjustment";
        adjustedLevel: CompetitivenessLevel;
        reason: string;
      }
    | undefined;
};

export type BuyerOfferAnalysisFragment = {
  __typename?: "BuyerOfferAnalysisObject";
  id: string;
  createdAt: any;
  hideOfferScore?: boolean | undefined;
  agentNotes?: string | undefined;
  title?: string | undefined;
  isShared?: boolean | undefined;
  buyersAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  listing?:
    | {
        __typename?: "ListingObject";
        id: string;
        isOwner?: boolean | undefined;
        listDate?: any | undefined;
        offersCountDisplay: string;
        submittedOffersCount: number;
        followerCount?: number | undefined;
        isPremium: boolean;
        status: MlsListingStatus;
        deletedFromRetsFeedAt?: string | undefined;
        property: {
          __typename?: "PropertyObject";
          id: string;
          slug: string;
          state: UsState;
        };
        offersSubmitted?:
          | Array<{
              __typename?: "OfferObject";
              id: string;
              status: OfferStatus;
            }>
          | undefined;
        listingAgent?:
          | {
              __typename?: "AgentObject";
              id: string;
              inboundEmail: string;
              user?:
                | {
                    __typename?: "UserObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                    fullName: string;
                    userName?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
        coListingAgent?:
          | {
              __typename?: "AgentObject";
              id: string;
              inboundEmail: string;
              user?:
                | {
                    __typename?: "UserObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                    fullName: string;
                    phoneNumber: string;
                    email?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
        mlsListing?:
          | {
              __typename?: "MLSListingObject";
              id: string;
              mlsId?: number | undefined;
              listingId?: string | undefined;
              listDate?: string | undefined;
              listPrice?: number | undefined;
              originalListPrice?: number | undefined;
              terms?: string | undefined;
              photos: Array<string>;
              remarks?: string | undefined;
              modified?: string | undefined;
              mlsName?: string | undefined;
              deleted_at?: string | undefined;
              addressFull: string;
              agent?:
                | {
                    __typename?: "MLSListingAgentObject";
                    id?: string | undefined;
                    mlsId?: string | undefined;
                    firstName?: string | undefined;
                    lastName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              coAgent?:
                | {
                    __typename?: "MLSListingAgentObject";
                    id?: string | undefined;
                    mlsId?: string | undefined;
                    firstName?: string | undefined;
                    lastName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              address: {
                __typename?: "MLSListingAddressObject";
                city: string;
                country?: string | undefined;
                crossStreet?: string | undefined;
                full: string;
                postalCode?: string | undefined;
                state: string;
                streetName: string;
                streetNumber?: number | undefined;
                streetNumberText: string;
                unit?: string | undefined;
              };
              property?:
                | {
                    __typename?: "MLSListingPropertyObject";
                    roof?: string | undefined;
                    cooling?: string | undefined;
                    style?: string | undefined;
                    area?: number | undefined;
                    bathsFull?: number | undefined;
                    bathsHalf?: number | undefined;
                    stories?: number | undefined;
                    fireplaces?: number | undefined;
                    flooring?: string | undefined;
                    heating?: string | undefined;
                    bathrooms?: string | undefined;
                    foundation?: string | undefined;
                    poolFeatures?: string | undefined;
                    laundryFeatures?: string | undefined;
                    occupantName?: string | undefined;
                    ownerName?: string | undefined;
                    lotDescription?: string | undefined;
                    acres?: number | undefined;
                    subType?: string | undefined;
                    bedrooms?: number | undefined;
                    interiorFeatures?: string | undefined;
                    lotSize?: string | undefined;
                    areaSource?: string | undefined;
                    maintenanceExpense?: number | undefined;
                    additionalRooms?: string | undefined;
                    exteriorFeatures?: string | undefined;
                    water?: string | undefined;
                    view?: string | undefined;
                    lotSizeArea?: number | undefined;
                    lotSizeAreaUnits?: string | undefined;
                    subdivision?: string | undefined;
                    construction?: string | undefined;
                    type?: MlsListingType | undefined;
                    garageSpaces?: number | undefined;
                    bathsThreeQuarter?: number | undefined;
                    accessibility?: string | undefined;
                    occupantType?: string | undefined;
                    yearBuilt?: number | undefined;
                    subTypeText?: string | undefined;
                  }
                | undefined;
              office?:
                | {
                    __typename?: "MLSListingOfficeObject";
                    brokerid?: string | undefined;
                    name?: string | undefined;
                    servingName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              mls?:
                | {
                    __typename?: "MLSListingMLSObject";
                    statusText: string;
                    status?: MlsListingStatus | undefined;
                    daysOnMarket?: number | undefined;
                    originalEntryTimestamp?: string | undefined;
                    originatingSystemName?: string | undefined;
                    logoUrl?: string | undefined;
                    disclaimer?: string | undefined;
                  }
                | undefined;
              association?:
                | {
                    __typename?: "MLSListingAssociationObject";
                    fee?: number | undefined;
                    frequency?: string | undefined;
                    name?: string | undefined;
                    amenities?: string | undefined;
                  }
                | undefined;
              compliance?:
                | {
                    __typename?: "MLSListingComplianceObject";
                    buyerAgencyCompensation?: number | undefined;
                    buyerAgencyCompensationType?: string | undefined;
                    subAgencyCompensation?: number | undefined;
                    subAgencyCompensationType?: string | undefined;
                    attributionContact?: string | undefined;
                  }
                | undefined;
              sales?:
                | {
                    __typename?: "MLSListingSalesObject";
                    closeDate?: string | undefined;
                    closePrice?: number | undefined;
                    contractDate?: string | undefined;
                  }
                | undefined;
              geo: {
                __typename?: "MLSListingGeoObject";
                location: {
                  __typename?: "GeoPointObject";
                  lat: number;
                  lon: number;
                };
              };
            }
          | undefined;
        listingPreferences?: Array<{
          __typename?: "PreferenceValueObject";
          numberValue?: number | undefined;
          textValue?: string | undefined;
          stringValue?: string | undefined;
          stringArray?: Array<string> | undefined;
          booleanValue?: boolean | undefined;
          dateTimeValue?: any | undefined;
          readOnly?: boolean | undefined;
          preference: {
            __typename?: "PreferenceObject";
            id: string;
            name: string;
            slug: string;
            usStates: Array<UsState>;
            fieldId?: string | undefined;
            valueType: PreferenceValueType;
          };
        }>;
        storefrontSetup?:
          | {
              __typename?: "StorefrontSetupObject";
              continueStep?: StorefrontSetupStep | undefined;
              listingPackage: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
        setupDetails: {
          __typename?: "StorefrontConfigurationStatusObject";
          hasSetup?: boolean | undefined;
          configuredCount: number;
          progressTotal: number;
          sellerPreferences: boolean;
          comparables: boolean;
          documents: boolean;
        };
      }
    | undefined;
  party?:
    | {
        __typename?: "PartyObject";
        id: string;
        createdAt: any;
        purchaseOffers?:
          | Array<{
              __typename?: "OfferObject";
              id: string;
              updatedAt?: any | undefined;
              listing?:
                | {
                    __typename?: "ListingObject";
                    id: string;
                    isPremium: boolean;
                    property: {
                      __typename?: "PropertyObject";
                      id: string;
                      slug: string;
                      state: UsState;
                    };
                    mlsListing?:
                      | {
                          __typename?: "MLSListingObject";
                          id: string;
                          mlsId?: number | undefined;
                          listingId?: string | undefined;
                          listDate?: string | undefined;
                          listPrice?: number | undefined;
                          originalListPrice?: number | undefined;
                          terms?: string | undefined;
                          photos: Array<string>;
                          remarks?: string | undefined;
                          modified?: string | undefined;
                          mlsName?: string | undefined;
                          deleted_at?: string | undefined;
                          addressFull: string;
                          agent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          coAgent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          address: {
                            __typename?: "MLSListingAddressObject";
                            city: string;
                            country?: string | undefined;
                            crossStreet?: string | undefined;
                            full: string;
                            postalCode?: string | undefined;
                            state: string;
                            streetName: string;
                            streetNumber?: number | undefined;
                            streetNumberText: string;
                            unit?: string | undefined;
                          };
                          property?:
                            | {
                                __typename?: "MLSListingPropertyObject";
                                roof?: string | undefined;
                                cooling?: string | undefined;
                                style?: string | undefined;
                                area?: number | undefined;
                                bathsFull?: number | undefined;
                                bathsHalf?: number | undefined;
                                stories?: number | undefined;
                                fireplaces?: number | undefined;
                                flooring?: string | undefined;
                                heating?: string | undefined;
                                bathrooms?: string | undefined;
                                foundation?: string | undefined;
                                poolFeatures?: string | undefined;
                                laundryFeatures?: string | undefined;
                                occupantName?: string | undefined;
                                ownerName?: string | undefined;
                                lotDescription?: string | undefined;
                                acres?: number | undefined;
                                subType?: string | undefined;
                                bedrooms?: number | undefined;
                                interiorFeatures?: string | undefined;
                                lotSize?: string | undefined;
                                areaSource?: string | undefined;
                                maintenanceExpense?: number | undefined;
                                additionalRooms?: string | undefined;
                                exteriorFeatures?: string | undefined;
                                water?: string | undefined;
                                view?: string | undefined;
                                lotSizeArea?: number | undefined;
                                lotSizeAreaUnits?: string | undefined;
                                subdivision?: string | undefined;
                                construction?: string | undefined;
                                type?: MlsListingType | undefined;
                                garageSpaces?: number | undefined;
                                bathsThreeQuarter?: number | undefined;
                                accessibility?: string | undefined;
                                occupantType?: string | undefined;
                                yearBuilt?: number | undefined;
                                subTypeText?: string | undefined;
                              }
                            | undefined;
                          office?:
                            | {
                                __typename?: "MLSListingOfficeObject";
                                brokerid?: string | undefined;
                                name?: string | undefined;
                                servingName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          mls?:
                            | {
                                __typename?: "MLSListingMLSObject";
                                statusText: string;
                                status?: MlsListingStatus | undefined;
                                daysOnMarket?: number | undefined;
                                originalEntryTimestamp?: string | undefined;
                                originatingSystemName?: string | undefined;
                                logoUrl?: string | undefined;
                                disclaimer?: string | undefined;
                              }
                            | undefined;
                          association?:
                            | {
                                __typename?: "MLSListingAssociationObject";
                                fee?: number | undefined;
                                frequency?: string | undefined;
                                name?: string | undefined;
                                amenities?: string | undefined;
                              }
                            | undefined;
                          compliance?:
                            | {
                                __typename?: "MLSListingComplianceObject";
                                buyerAgencyCompensation?: number | undefined;
                                buyerAgencyCompensationType?:
                                  | string
                                  | undefined;
                                subAgencyCompensation?: number | undefined;
                                subAgencyCompensationType?: string | undefined;
                                attributionContact?: string | undefined;
                              }
                            | undefined;
                          sales?:
                            | {
                                __typename?: "MLSListingSalesObject";
                                closeDate?: string | undefined;
                                closePrice?: number | undefined;
                                contractDate?: string | undefined;
                              }
                            | undefined;
                          geo: {
                            __typename?: "MLSListingGeoObject";
                            location: {
                              __typename?: "GeoPointObject";
                              lat: number;
                              lon: number;
                            };
                          };
                        }
                      | undefined;
                    listingAgent?:
                      | {
                          __typename?: "AgentObject";
                          id: string;
                          user?:
                            | { __typename?: "UserObject"; id: string }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
        primaryConsumer: {
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        };
        secondaryConsumers: Array<{
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>;
        partyFinancing?:
          | {
              __typename?: "PartyFinancingObject";
              id: string;
              financingType?: FinancingType | undefined;
              loanAmount?: number | undefined;
              percentDownPayment?: number | undefined;
              cashReserves?: number | undefined;
              preapprovalFile?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  indigoOfferRecs?:
    | {
        __typename?: "OfferRecsPayload";
        keyTerms: Array<
          | {
              __typename: "KeyTerm";
              label?: string | undefined;
              type: KeyTermType;
              unit: KeyTermUnit;
              recommendation: number;
              context: {
                __typename?: "KeyTermRecommendationContext";
                marketData: {
                  __typename?: "MarketDataRange";
                  low: number;
                  high: number;
                };
                marketDataPercentages?:
                  | {
                      __typename?: "MarketDataPercentages";
                      yes: number;
                      no: number;
                    }
                  | undefined;
                source:
                  | { __typename: "CompsSource"; type: MarketDataSourceType }
                  | {
                      __typename: "IndigoOffersSource";
                      type: MarketDataSourceType;
                      metadata: {
                        __typename?: "IndigoOffersMetadata";
                        confidence: ConfidenceLevel;
                        distanceMiles: number;
                        timePeriodMonths: number;
                      };
                    }
                  | { __typename: "MLSSource"; type: MarketDataSourceType };
              };
            }
          | {
              __typename: "KeyTermError";
              label?: string | undefined;
              type: KeyTermType;
              unit: KeyTermUnit;
              reason: string;
              sourceType: MarketDataSourceType;
            }
        >;
        contingencies: Array<
          | {
              __typename: "Contingency";
              type: ContingencyType;
              recommendation: boolean;
              context: {
                __typename?: "ContingencyRecommendationContext";
                marketData: {
                  __typename?: "MarketDataPercentages";
                  yes: number;
                  no: number;
                };
                source:
                  | { __typename: "CompsSource"; type: MarketDataSourceType }
                  | {
                      __typename: "IndigoOffersSource";
                      type: MarketDataSourceType;
                      metadata: {
                        __typename?: "IndigoOffersMetadata";
                        confidence: ConfidenceLevel;
                        distanceMiles: number;
                        timePeriodMonths: number;
                      };
                    }
                  | { __typename: "MLSSource"; type: MarketDataSourceType };
              };
            }
          | {
              __typename: "ContingencyError";
              type: ContingencyType;
              reason: string;
            }
        >;
        competitiveness: {
          __typename?: "CompetitivenessScore";
          error?: string | undefined;
          rating: CompetitivenessLevel;
          score: number;
          metrics: {
            __typename?: "CompetitivenessMetrics";
            bidAsk: number;
            bidAskScore: number;
            daysOnMarket: number;
            daysOnMarketScore: number;
            minMarketBidAskRatio?: number | undefined;
            maxMarketBidAskRatio?: number | undefined;
            priceAnalysis: {
              __typename?: "PriceAnalysis";
              avgCompBidAskRatio: number;
              isPotentiallyOverpriced: boolean;
              isPotentiallyUnderpriced: boolean;
              pricePositioning: number;
            };
          };
        };
      }
    | undefined;
  agentOfferRecs?:
    | {
        __typename?: "AgentOfferRecsPayload";
        contingencies?:
          | Array<{
              __typename?: "AgentContingencyOfferRec";
              value?: boolean | undefined;
              notes?: string | undefined;
              type: ContingencyType;
            }>
          | undefined;
        keyTerms?:
          | Array<{
              __typename?: "AgentKeyTermsOfferRec";
              value?: number | undefined;
              notes?: string | undefined;
              type: KeyTermType;
            }>
          | undefined;
        competitivenessAdjustment?:
          | {
              __typename?: "CompetitivenessAdjustment";
              adjustedLevel: CompetitivenessLevel;
              reason: string;
            }
          | undefined;
      }
    | undefined;
  prevAgentOfferRecs?:
    | {
        __typename?: "AgentOfferRecsPayload";
        contingencies?:
          | Array<{
              __typename?: "AgentContingencyOfferRec";
              value?: boolean | undefined;
              notes?: string | undefined;
              type: ContingencyType;
            }>
          | undefined;
        keyTerms?:
          | Array<{
              __typename?: "AgentKeyTermsOfferRec";
              value?: number | undefined;
              notes?: string | undefined;
              type: KeyTermType;
            }>
          | undefined;
        competitivenessAdjustment?:
          | {
              __typename?: "CompetitivenessAdjustment";
              adjustedLevel: CompetitivenessLevel;
              reason: string;
            }
          | undefined;
      }
    | undefined;
  offerScore?:
    | {
        __typename?: "OfferScore";
        reason: string;
        value: number;
        offerScoreExplanation?: string | undefined;
      }
    | { __typename?: "OfferScoreNotCalculated"; reason: string }
    | undefined;
};

export type TeamLeadOfferScorecardRowFragment = {
  __typename?: "BuyerOfferAnalysisObject";
  id: string;
  createdAt: any;
  agentNotes?: string | undefined;
  title?: string | undefined;
  isShared?: boolean | undefined;
  buyersAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  listing?:
    | {
        __typename?: "ListingObject";
        id: string;
        property: {
          __typename?: "PropertyObject";
          id: string;
          slug: string;
          state: UsState;
        };
        mlsListing?:
          | {
              __typename?: "MLSListingObject";
              id: string;
              mlsId?: number | undefined;
              listingId?: string | undefined;
              listDate?: string | undefined;
              listPrice?: number | undefined;
              originalListPrice?: number | undefined;
              terms?: string | undefined;
              photos: Array<string>;
              remarks?: string | undefined;
              modified?: string | undefined;
              mlsName?: string | undefined;
              deleted_at?: string | undefined;
              addressFull: string;
              agent?:
                | {
                    __typename?: "MLSListingAgentObject";
                    id?: string | undefined;
                    mlsId?: string | undefined;
                    firstName?: string | undefined;
                    lastName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              coAgent?:
                | {
                    __typename?: "MLSListingAgentObject";
                    id?: string | undefined;
                    mlsId?: string | undefined;
                    firstName?: string | undefined;
                    lastName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              address: {
                __typename?: "MLSListingAddressObject";
                city: string;
                country?: string | undefined;
                crossStreet?: string | undefined;
                full: string;
                postalCode?: string | undefined;
                state: string;
                streetName: string;
                streetNumber?: number | undefined;
                streetNumberText: string;
                unit?: string | undefined;
              };
              property?:
                | {
                    __typename?: "MLSListingPropertyObject";
                    roof?: string | undefined;
                    cooling?: string | undefined;
                    style?: string | undefined;
                    area?: number | undefined;
                    bathsFull?: number | undefined;
                    bathsHalf?: number | undefined;
                    stories?: number | undefined;
                    fireplaces?: number | undefined;
                    flooring?: string | undefined;
                    heating?: string | undefined;
                    bathrooms?: string | undefined;
                    foundation?: string | undefined;
                    poolFeatures?: string | undefined;
                    laundryFeatures?: string | undefined;
                    occupantName?: string | undefined;
                    ownerName?: string | undefined;
                    lotDescription?: string | undefined;
                    acres?: number | undefined;
                    subType?: string | undefined;
                    bedrooms?: number | undefined;
                    interiorFeatures?: string | undefined;
                    lotSize?: string | undefined;
                    areaSource?: string | undefined;
                    maintenanceExpense?: number | undefined;
                    additionalRooms?: string | undefined;
                    exteriorFeatures?: string | undefined;
                    water?: string | undefined;
                    view?: string | undefined;
                    lotSizeArea?: number | undefined;
                    lotSizeAreaUnits?: string | undefined;
                    subdivision?: string | undefined;
                    construction?: string | undefined;
                    type?: MlsListingType | undefined;
                    garageSpaces?: number | undefined;
                    bathsThreeQuarter?: number | undefined;
                    accessibility?: string | undefined;
                    occupantType?: string | undefined;
                    yearBuilt?: number | undefined;
                    subTypeText?: string | undefined;
                  }
                | undefined;
              office?:
                | {
                    __typename?: "MLSListingOfficeObject";
                    brokerid?: string | undefined;
                    name?: string | undefined;
                    servingName?: string | undefined;
                    contact?:
                      | {
                          __typename?: "MLSListingContactObject";
                          email?: string | undefined;
                          office?: string | undefined;
                          cell?: string | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              mls?:
                | {
                    __typename?: "MLSListingMLSObject";
                    statusText: string;
                    status?: MlsListingStatus | undefined;
                    daysOnMarket?: number | undefined;
                    originalEntryTimestamp?: string | undefined;
                    originatingSystemName?: string | undefined;
                    logoUrl?: string | undefined;
                    disclaimer?: string | undefined;
                  }
                | undefined;
              association?:
                | {
                    __typename?: "MLSListingAssociationObject";
                    fee?: number | undefined;
                    frequency?: string | undefined;
                    name?: string | undefined;
                    amenities?: string | undefined;
                  }
                | undefined;
              compliance?:
                | {
                    __typename?: "MLSListingComplianceObject";
                    buyerAgencyCompensation?: number | undefined;
                    buyerAgencyCompensationType?: string | undefined;
                    subAgencyCompensation?: number | undefined;
                    subAgencyCompensationType?: string | undefined;
                    attributionContact?: string | undefined;
                  }
                | undefined;
              sales?:
                | {
                    __typename?: "MLSListingSalesObject";
                    closeDate?: string | undefined;
                    closePrice?: number | undefined;
                    contractDate?: string | undefined;
                  }
                | undefined;
              geo: {
                __typename?: "MLSListingGeoObject";
                location: {
                  __typename?: "GeoPointObject";
                  lat: number;
                  lon: number;
                };
              };
            }
          | undefined;
      }
    | undefined;
  party?:
    | {
        __typename?: "PartyObject";
        id: string;
        primaryConsumer: {
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        };
        secondaryConsumers: Array<{
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>;
      }
    | undefined;
  indigoOfferRecs?:
    | {
        __typename?: "OfferRecsPayload";
        keyTerms: Array<
          | {
              __typename: "KeyTerm";
              label?: string | undefined;
              type: KeyTermType;
              unit: KeyTermUnit;
              recommendation: number;
              context: {
                __typename?: "KeyTermRecommendationContext";
                marketData: {
                  __typename?: "MarketDataRange";
                  low: number;
                  high: number;
                };
                marketDataPercentages?:
                  | {
                      __typename?: "MarketDataPercentages";
                      yes: number;
                      no: number;
                    }
                  | undefined;
                source:
                  | { __typename: "CompsSource"; type: MarketDataSourceType }
                  | {
                      __typename: "IndigoOffersSource";
                      type: MarketDataSourceType;
                      metadata: {
                        __typename?: "IndigoOffersMetadata";
                        confidence: ConfidenceLevel;
                        distanceMiles: number;
                        timePeriodMonths: number;
                      };
                    }
                  | { __typename: "MLSSource"; type: MarketDataSourceType };
              };
            }
          | {
              __typename: "KeyTermError";
              label?: string | undefined;
              type: KeyTermType;
              unit: KeyTermUnit;
              reason: string;
              sourceType: MarketDataSourceType;
            }
        >;
        contingencies: Array<
          | {
              __typename: "Contingency";
              type: ContingencyType;
              recommendation: boolean;
              context: {
                __typename?: "ContingencyRecommendationContext";
                marketData: {
                  __typename?: "MarketDataPercentages";
                  yes: number;
                  no: number;
                };
                source:
                  | { __typename: "CompsSource"; type: MarketDataSourceType }
                  | {
                      __typename: "IndigoOffersSource";
                      type: MarketDataSourceType;
                      metadata: {
                        __typename?: "IndigoOffersMetadata";
                        confidence: ConfidenceLevel;
                        distanceMiles: number;
                        timePeriodMonths: number;
                      };
                    }
                  | { __typename: "MLSSource"; type: MarketDataSourceType };
              };
            }
          | {
              __typename: "ContingencyError";
              type: ContingencyType;
              reason: string;
            }
        >;
        competitiveness: {
          __typename?: "CompetitivenessScore";
          error?: string | undefined;
          rating: CompetitivenessLevel;
          score: number;
          metrics: {
            __typename?: "CompetitivenessMetrics";
            bidAsk: number;
            bidAskScore: number;
            daysOnMarket: number;
            daysOnMarketScore: number;
            minMarketBidAskRatio?: number | undefined;
            maxMarketBidAskRatio?: number | undefined;
            priceAnalysis: {
              __typename?: "PriceAnalysis";
              avgCompBidAskRatio: number;
              isPotentiallyOverpriced: boolean;
              isPotentiallyUnderpriced: boolean;
              pricePositioning: number;
            };
          };
        };
      }
    | undefined;
  agentOfferRecs?:
    | {
        __typename?: "AgentOfferRecsPayload";
        contingencies?:
          | Array<{
              __typename?: "AgentContingencyOfferRec";
              value?: boolean | undefined;
              notes?: string | undefined;
              type: ContingencyType;
            }>
          | undefined;
        keyTerms?:
          | Array<{
              __typename?: "AgentKeyTermsOfferRec";
              value?: number | undefined;
              notes?: string | undefined;
              type: KeyTermType;
            }>
          | undefined;
        competitivenessAdjustment?:
          | {
              __typename?: "CompetitivenessAdjustment";
              adjustedLevel: CompetitivenessLevel;
              reason: string;
            }
          | undefined;
      }
    | undefined;
  offerScore?:
    | {
        __typename?: "OfferScore";
        reason: string;
        value: number;
        offerScoreExplanation?: string | undefined;
      }
    | { __typename?: "OfferScoreNotCalculated"; reason: string }
    | undefined;
};

export type ConsumerFragment = {
  __typename?: "ConsumerObject";
  id: string;
  email?: string | undefined;
  fullName: string;
  phoneNumber?: string | undefined;
  isEntity: boolean;
  entityName?: string | undefined;
  entityTitle?: string | undefined;
  profilePicture?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
};

export type ContactFragment = {
  __typename?: "ContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
};

export type ContractDocumentFragment = {
  __typename?: "ContractDocumentObject";
  id: string;
  order: number;
  externalDocumentType?: ExternalDocumentType | undefined;
  externalDocumentName?: string | undefined;
  documentVersion?:
    | {
        __typename?: "DocumentVersionObject";
        id: string;
        mappingKeys: Array<string>;
        version: string;
        document: {
          __typename?: "DocumentObject";
          id: string;
          name: string;
          form: string;
          documentType: DocumentType;
        };
      }
    | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  fields?:
    | Array<{
        __typename?: "DocumentVersionFieldObject";
        id: string;
        align: FieldAlign;
        pageNumber: number;
        fontFamily: string;
        fontSize: string;
        label: string;
        readOnly?: boolean | undefined;
        width: number;
        height: number;
        x: number;
        y: number;
        mappingKey: string;
        fieldType: FieldType;
        inputFormat?:
          | {
              __typename?: "InputFormatObject";
              type: InputFormatType;
              options: {
                __typename?: "InputFormatOptionsObject";
                precision?: number | undefined;
                formatString?: string | undefined;
                currencySymbol?: string | undefined;
              };
            }
          | undefined;
        boundingBox: {
          __typename?: "BoundingBoxObject";
          left: number;
          top: number;
          right: number;
          bottom: number;
        };
        labelBoundingBox?:
          | {
              __typename?: "BoundingBoxObject";
              left: number;
              top: number;
              right: number;
              bottom: number;
            }
          | undefined;
        labelField?:
          | {
              __typename?: "LabelFieldObject";
              height: number;
              width: number;
              x: number;
              y: number;
            }
          | undefined;
      }>
    | undefined;
};

export type ExternalIngestionFolderListRowFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  platform: IngestionPlatform;
  folderUpdatedAt?: any | undefined;
  folderCreatedAt?: any | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  validationErrorCount?: number | undefined;
  keyTermColumns?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
      }
    | undefined;
};

export type GuestbookSignerFragment = {
  __typename?: "GuestbookSignerObject";
  signedAt: any;
  isSubscribed: boolean;
  openHouseId?: string | undefined;
  isWorkingWithAgent?: boolean | undefined;
  user: {
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
  office?:
    | {
        __typename?: "RESOOfficeObject";
        OfficeName?: string | undefined;
        OfficeEmail?: string | undefined;
        OfficeKey?: string | undefined;
        OfficeMlsId?: string | undefined;
        OfficeStatus?: string | undefined;
        OriginatingSystemName?: string | undefined;
      }
    | undefined;
};

export type IngestionDocumentReviewFragment = {
  __typename?: "IngestionDocumentReviewObject";
  id: string;
  createdAt: any;
  updatedAt: any;
  status: IngestionDocumentReviewStatus;
  version: string;
  reviewedAt: any;
  reviewedByUserUuid: string;
  reason?: string | undefined;
  ingestionDocument: {
    __typename?: "IngestionDocumentObject";
    id: string;
    documentId: string;
    documentName: string;
    version: string;
  };
  submission?:
    | {
        __typename?: "ValidationReviewSubmissionObject";
        id: string;
        submittedAt: any;
        submittedByUserUuid: string;
      }
    | undefined;
};

export type DebugLogIdentityFragment = {
  __typename?: "DebugLogIdentity";
  logId: number;
  logUuid: string;
  organizationUuid: string;
  organizationName?: string | undefined;
  partnerUuid?: string | undefined;
  partnerName?: string | undefined;
  folderId?: string | undefined;
  templateUuid?: string | undefined;
  templateTitle?: string | undefined;
  notificationKind: NotificationLogKind;
  stage?: TransactionStageType | undefined;
  side?: TransactionSide | undefined;
  notificationType?: NotificationType | undefined;
};

export type DebugLogLifecycleFragment = {
  __typename?: "DebugLogLifecycle";
  createdAt: any;
  scheduledAt?: any | undefined;
  pausedAt?: any | undefined;
  addedToQueueAt?: any | undefined;
  sentAt?: any | undefined;
  undeliverableAt?: any | undefined;
  isDryRun: boolean;
  displayStatus: DebugLogDisplayStatus;
};

export type DebugTemplateSourceFragment = {
  __typename?: "DebugTemplateSource";
  templateUuid?: string | undefined;
  title?: string | undefined;
  eventType?: TransactionStageType | undefined;
  side?: TransactionSide | undefined;
  recipientTypes?: Array<string> | undefined;
  delayMinutes?: number | undefined;
  dataToShare?: Array<string> | undefined;
  messageContent?: string | undefined;
  hasAssignedPartner?: boolean | undefined;
  isAttachedToPartner?: boolean | undefined;
  status?: NotificationTemplateStatus | undefined;
  orderIndex?: number | undefined;
};

export type DebugStageIntroSourceFragment = {
  __typename?: "DebugStageIntroSource";
  side: TransactionSide;
  stage: TransactionStageType;
  newRelationshipMessageContent?: string | undefined;
  existingRelationshipMessageContent?: string | undefined;
  allowPartnerContactAssignment: boolean;
};

export type DebugPartnerConfigFragment = {
  __typename?: "DebugPartnerConfig";
  partnerUuid: string;
  partnerName: string;
  isActive: boolean;
  dryRunNotifications: boolean;
  contactCount: number;
  adminContactCount: number;
};

export type DebugRecipientContactFragment = {
  __typename?: "DebugRecipientContact";
  uuid: string;
  fullName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  contactType: ContactType;
};

export type DebugRawRecipientFragment = {
  __typename?: "DebugRawRecipient";
  id: string;
  fullName?: string | undefined;
  email?: string | undefined;
  phoneNumber?: string | undefined;
  contactType?: string | undefined;
};

export type DebugRecipientResolutionFragment = {
  __typename?: "DebugRecipientResolution";
  requestedRecipientTypes: Array<string>;
  agentContactUuid?: string | undefined;
  rosterUsed?: boolean | undefined;
  isPaused: boolean;
  isFirstAssignment?: boolean | undefined;
  pauseReason?: string | undefined;
  resolvedContacts: Array<{
    __typename?: "DebugRecipientContact";
    uuid: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    contactType: ContactType;
  }>;
  resolvedRawRecipients: Array<{
    __typename?: "DebugRawRecipient";
    id: string;
    fullName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    contactType?: string | undefined;
  }>;
};

export type DebugRoutingDecisionFragment = {
  __typename?: "DebugRoutingDecision";
  key: string;
  outcome: string;
  reason?: string | undefined;
};

export type DebugRoutingDecisionsFragment = {
  __typename?: "DebugRoutingDecisions";
  decisions: Array<{
    __typename?: "DebugRoutingDecision";
    key: string;
    outcome: string;
    reason?: string | undefined;
  }>;
};

export type DebugAutofillRenderingFragment = {
  __typename?: "DebugAutofillRendering";
  computedAutofillValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  renderedTitle?: string | undefined;
  renderedBody?: string | undefined;
  templateVariables?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
};

export type DebugDeliveryFragment = {
  __typename?: "DebugDelivery";
  workflowId?: string | undefined;
  isDryRunSkipped: boolean;
  isNoRecipientSkipped: boolean;
  preSanitizationRecipients?:
    | Array<{
        __typename?: "DebugRawRecipient";
        id: string;
        fullName?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        contactType?: string | undefined;
      }>
    | undefined;
  postSanitizationRecipients?:
    | Array<{
        __typename?: "DebugRawRecipient";
        id: string;
        fullName?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        contactType?: string | undefined;
      }>
    | undefined;
};

export type InternalEssentialsNotificationLogDebugFragment = {
  __typename?: "InternalEssentialsNotificationLogDebugObject";
  rawLog?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  normalizedFieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  identity: {
    __typename?: "DebugLogIdentity";
    logId: number;
    logUuid: string;
    organizationUuid: string;
    organizationName?: string | undefined;
    partnerUuid?: string | undefined;
    partnerName?: string | undefined;
    folderId?: string | undefined;
    templateUuid?: string | undefined;
    templateTitle?: string | undefined;
    notificationKind: NotificationLogKind;
    stage?: TransactionStageType | undefined;
    side?: TransactionSide | undefined;
    notificationType?: NotificationType | undefined;
  };
  lifecycle: {
    __typename?: "DebugLogLifecycle";
    createdAt: any;
    scheduledAt?: any | undefined;
    pausedAt?: any | undefined;
    addedToQueueAt?: any | undefined;
    sentAt?: any | undefined;
    undeliverableAt?: any | undefined;
    isDryRun: boolean;
    displayStatus: DebugLogDisplayStatus;
  };
  templateSource?:
    | {
        __typename?: "DebugTemplateSource";
        templateUuid?: string | undefined;
        title?: string | undefined;
        eventType?: TransactionStageType | undefined;
        side?: TransactionSide | undefined;
        recipientTypes?: Array<string> | undefined;
        delayMinutes?: number | undefined;
        dataToShare?: Array<string> | undefined;
        messageContent?: string | undefined;
        hasAssignedPartner?: boolean | undefined;
        isAttachedToPartner?: boolean | undefined;
        status?: NotificationTemplateStatus | undefined;
        orderIndex?: number | undefined;
      }
    | undefined;
  stageIntroSource?:
    | {
        __typename?: "DebugStageIntroSource";
        side: TransactionSide;
        stage: TransactionStageType;
        newRelationshipMessageContent?: string | undefined;
        existingRelationshipMessageContent?: string | undefined;
        allowPartnerContactAssignment: boolean;
      }
    | undefined;
  partnerConfig?:
    | {
        __typename?: "DebugPartnerConfig";
        partnerUuid: string;
        partnerName: string;
        isActive: boolean;
        dryRunNotifications: boolean;
        contactCount: number;
        adminContactCount: number;
      }
    | undefined;
  recipientResolution: {
    __typename?: "DebugRecipientResolution";
    requestedRecipientTypes: Array<string>;
    agentContactUuid?: string | undefined;
    rosterUsed?: boolean | undefined;
    isPaused: boolean;
    isFirstAssignment?: boolean | undefined;
    pauseReason?: string | undefined;
    resolvedContacts: Array<{
      __typename?: "DebugRecipientContact";
      uuid: string;
      fullName?: string | undefined;
      email?: string | undefined;
      phoneNumber?: string | undefined;
      contactType: ContactType;
    }>;
    resolvedRawRecipients: Array<{
      __typename?: "DebugRawRecipient";
      id: string;
      fullName?: string | undefined;
      email?: string | undefined;
      phoneNumber?: string | undefined;
      contactType?: string | undefined;
    }>;
  };
  routingDecisions: {
    __typename?: "DebugRoutingDecisions";
    decisions: Array<{
      __typename?: "DebugRoutingDecision";
      key: string;
      outcome: string;
      reason?: string | undefined;
    }>;
  };
  autofillRendering?:
    | {
        __typename?: "DebugAutofillRendering";
        computedAutofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        renderedTitle?: string | undefined;
        renderedBody?: string | undefined;
        templateVariables?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }
    | undefined;
  delivery?:
    | {
        __typename?: "DebugDelivery";
        workflowId?: string | undefined;
        isDryRunSkipped: boolean;
        isNoRecipientSkipped: boolean;
        preSanitizationRecipients?:
          | Array<{
              __typename?: "DebugRawRecipient";
              id: string;
              fullName?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              contactType?: string | undefined;
            }>
          | undefined;
        postSanitizationRecipients?:
          | Array<{
              __typename?: "DebugRawRecipient";
              id: string;
              fullName?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              contactType?: string | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type SimulationCandidateResultFragment = {
  __typename?: "SimulationCandidateResult";
  outcome: SimulationOutcome;
  reason?: string | undefined;
  templateSource?:
    | {
        __typename?: "DebugTemplateSource";
        templateUuid?: string | undefined;
        title?: string | undefined;
        eventType?: TransactionStageType | undefined;
        side?: TransactionSide | undefined;
        recipientTypes?: Array<string> | undefined;
        delayMinutes?: number | undefined;
        dataToShare?: Array<string> | undefined;
        messageContent?: string | undefined;
        hasAssignedPartner?: boolean | undefined;
        isAttachedToPartner?: boolean | undefined;
        status?: NotificationTemplateStatus | undefined;
        orderIndex?: number | undefined;
      }
    | undefined;
  stageIntroSource?:
    | {
        __typename?: "DebugStageIntroSource";
        side: TransactionSide;
        stage: TransactionStageType;
        newRelationshipMessageContent?: string | undefined;
        existingRelationshipMessageContent?: string | undefined;
        allowPartnerContactAssignment: boolean;
      }
    | undefined;
  recipientResolution?:
    | {
        __typename?: "DebugRecipientResolution";
        requestedRecipientTypes: Array<string>;
        agentContactUuid?: string | undefined;
        rosterUsed?: boolean | undefined;
        isPaused: boolean;
        isFirstAssignment?: boolean | undefined;
        pauseReason?: string | undefined;
        resolvedContacts: Array<{
          __typename?: "DebugRecipientContact";
          uuid: string;
          fullName?: string | undefined;
          email?: string | undefined;
          phoneNumber?: string | undefined;
          contactType: ContactType;
        }>;
        resolvedRawRecipients: Array<{
          __typename?: "DebugRawRecipient";
          id: string;
          fullName?: string | undefined;
          email?: string | undefined;
          phoneNumber?: string | undefined;
          contactType?: string | undefined;
        }>;
      }
    | undefined;
  routingDecisions?:
    | {
        __typename?: "DebugRoutingDecisions";
        decisions: Array<{
          __typename?: "DebugRoutingDecision";
          key: string;
          outcome: string;
          reason?: string | undefined;
        }>;
      }
    | undefined;
  autofillRendering?:
    | {
        __typename?: "DebugAutofillRendering";
        computedAutofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        renderedTitle?: string | undefined;
        renderedBody?: string | undefined;
        templateVariables?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }
    | undefined;
};

export type InternalEssentialsNotificationLogItemFragment = {
  __typename?: "InternalEssentialsNotificationLogItem";
  id: string;
  logId: number;
  logUuid: string;
  title: string;
  notificationKind: NotificationLogKind;
  displayStatus: DebugLogDisplayStatus;
  partnerName?: string | undefined;
  notificationType?: NotificationType | undefined;
  createdAt: any;
  sentAt?: any | undefined;
  isDryRun: boolean;
};

export type InvitationFragment = {
  __typename?: "InvitationObject";
  id: string;
  acceptedAt?: any | undefined;
  revokedAt?: any | undefined;
  expiresAt: any;
  notificationMeta?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  invitee: {
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
  inviter: {
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ListingFragment = {
  __typename?: "ListingObject";
  id: string;
  isOwner?: boolean | undefined;
  listDate?: any | undefined;
  offersCountDisplay: string;
  submittedOffersCount: number;
  followerCount?: number | undefined;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: {
    __typename?: "PropertyObject";
    id: string;
    slug: string;
    state: UsState;
  };
  offersSubmitted?:
    | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
    | undefined;
  listingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  coListingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              phoneNumber: string;
              email?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
  listingPreferences?: Array<{
    __typename?: "PreferenceValueObject";
    numberValue?: number | undefined;
    textValue?: string | undefined;
    stringValue?: string | undefined;
    stringArray?: Array<string> | undefined;
    booleanValue?: boolean | undefined;
    dateTimeValue?: any | undefined;
    readOnly?: boolean | undefined;
    preference: {
      __typename?: "PreferenceObject";
      id: string;
      name: string;
      slug: string;
      usStates: Array<UsState>;
      fieldId?: string | undefined;
      valueType: PreferenceValueType;
    };
  }>;
  storefrontSetup?:
    | {
        __typename?: "StorefrontSetupObject";
        continueStep?: StorefrontSetupStep | undefined;
        listingPackage: {
          __typename?: "FileObject";
          fileName: string;
          url: string;
        };
      }
    | undefined;
  setupDetails: {
    __typename?: "StorefrontConfigurationStatusObject";
    hasSetup?: boolean | undefined;
    configuredCount: number;
    progressTotal: number;
    sellerPreferences: boolean;
    comparables: boolean;
    documents: boolean;
  };
};

export type ListingStatusFragment = {
  __typename?: "ListingObject";
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
};

export type ListingAnnouncementFragment = {
  __typename?: "ListingAnnouncementObject";
  id: string;
  message: string;
  type: ListingAnnouncementType;
  bestAndFinalDate?: any | undefined;
  createdAt: any;
};

export type ListingComparableAdjustmentsFragment = {
  __typename?: "ListingComparableAdjustmentsObject";
  id: string;
  priceAdjustmentsPerFields?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  totalAdjustmentPrice?: number | undefined;
  notes?: string | undefined;
};

export type ListingComparableFragment = {
  __typename?: "ListingComparableObject";
  id: string;
  source: ListingComparableSetSource;
  order: number;
  mlsListing: {
    __typename?: "MLSListingObject";
    id: string;
    mlsId?: number | undefined;
    listingId?: string | undefined;
    listDate?: string | undefined;
    listPrice?: number | undefined;
    originalListPrice?: number | undefined;
    terms?: string | undefined;
    photos: Array<string>;
    remarks?: string | undefined;
    modified?: string | undefined;
    mlsName?: string | undefined;
    deleted_at?: string | undefined;
    addressFull: string;
    agent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    coAgent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    address: {
      __typename?: "MLSListingAddressObject";
      city: string;
      country?: string | undefined;
      crossStreet?: string | undefined;
      full: string;
      postalCode?: string | undefined;
      state: string;
      streetName: string;
      streetNumber?: number | undefined;
      streetNumberText: string;
      unit?: string | undefined;
    };
    property?:
      | {
          __typename?: "MLSListingPropertyObject";
          roof?: string | undefined;
          cooling?: string | undefined;
          style?: string | undefined;
          area?: number | undefined;
          bathsFull?: number | undefined;
          bathsHalf?: number | undefined;
          stories?: number | undefined;
          fireplaces?: number | undefined;
          flooring?: string | undefined;
          heating?: string | undefined;
          bathrooms?: string | undefined;
          foundation?: string | undefined;
          poolFeatures?: string | undefined;
          laundryFeatures?: string | undefined;
          occupantName?: string | undefined;
          ownerName?: string | undefined;
          lotDescription?: string | undefined;
          acres?: number | undefined;
          subType?: string | undefined;
          bedrooms?: number | undefined;
          interiorFeatures?: string | undefined;
          lotSize?: string | undefined;
          areaSource?: string | undefined;
          maintenanceExpense?: number | undefined;
          additionalRooms?: string | undefined;
          exteriorFeatures?: string | undefined;
          water?: string | undefined;
          view?: string | undefined;
          lotSizeArea?: number | undefined;
          lotSizeAreaUnits?: string | undefined;
          subdivision?: string | undefined;
          construction?: string | undefined;
          type?: MlsListingType | undefined;
          garageSpaces?: number | undefined;
          bathsThreeQuarter?: number | undefined;
          accessibility?: string | undefined;
          occupantType?: string | undefined;
          yearBuilt?: number | undefined;
          subTypeText?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "MLSListingOfficeObject";
          brokerid?: string | undefined;
          name?: string | undefined;
          servingName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSListingMLSObject";
          statusText: string;
          status?: MlsListingStatus | undefined;
          daysOnMarket?: number | undefined;
          originalEntryTimestamp?: string | undefined;
          originatingSystemName?: string | undefined;
          logoUrl?: string | undefined;
          disclaimer?: string | undefined;
        }
      | undefined;
    association?:
      | {
          __typename?: "MLSListingAssociationObject";
          fee?: number | undefined;
          frequency?: string | undefined;
          name?: string | undefined;
          amenities?: string | undefined;
        }
      | undefined;
    compliance?:
      | {
          __typename?: "MLSListingComplianceObject";
          buyerAgencyCompensation?: number | undefined;
          buyerAgencyCompensationType?: string | undefined;
          subAgencyCompensation?: number | undefined;
          subAgencyCompensationType?: string | undefined;
          attributionContact?: string | undefined;
        }
      | undefined;
    sales?:
      | {
          __typename?: "MLSListingSalesObject";
          closeDate?: string | undefined;
          closePrice?: number | undefined;
          contractDate?: string | undefined;
        }
      | undefined;
    geo: {
      __typename?: "MLSListingGeoObject";
      location: { __typename?: "GeoPointObject"; lat: number; lon: number };
    };
  };
  adjustments?:
    | {
        __typename?: "ListingComparableAdjustmentsObject";
        id: string;
        priceAdjustmentsPerFields?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        totalAdjustmentPrice?: number | undefined;
        notes?: string | undefined;
      }
    | undefined;
};

export type ListingComparableSetFragment = {
  __typename?: "ListingComparableSetObject";
  id: string;
  agentNotes?: string | undefined;
  listingComparables: Array<{
    __typename?: "ListingComparableObject";
    id: string;
    source: ListingComparableSetSource;
    order: number;
    mlsListing: {
      __typename?: "MLSListingObject";
      id: string;
      mlsId?: number | undefined;
      listingId?: string | undefined;
      listDate?: string | undefined;
      listPrice?: number | undefined;
      originalListPrice?: number | undefined;
      terms?: string | undefined;
      photos: Array<string>;
      remarks?: string | undefined;
      modified?: string | undefined;
      mlsName?: string | undefined;
      deleted_at?: string | undefined;
      addressFull: string;
      agent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      coAgent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      address: {
        __typename?: "MLSListingAddressObject";
        city: string;
        country?: string | undefined;
        crossStreet?: string | undefined;
        full: string;
        postalCode?: string | undefined;
        state: string;
        streetName: string;
        streetNumber?: number | undefined;
        streetNumberText: string;
        unit?: string | undefined;
      };
      property?:
        | {
            __typename?: "MLSListingPropertyObject";
            roof?: string | undefined;
            cooling?: string | undefined;
            style?: string | undefined;
            area?: number | undefined;
            bathsFull?: number | undefined;
            bathsHalf?: number | undefined;
            stories?: number | undefined;
            fireplaces?: number | undefined;
            flooring?: string | undefined;
            heating?: string | undefined;
            bathrooms?: string | undefined;
            foundation?: string | undefined;
            poolFeatures?: string | undefined;
            laundryFeatures?: string | undefined;
            occupantName?: string | undefined;
            ownerName?: string | undefined;
            lotDescription?: string | undefined;
            acres?: number | undefined;
            subType?: string | undefined;
            bedrooms?: number | undefined;
            interiorFeatures?: string | undefined;
            lotSize?: string | undefined;
            areaSource?: string | undefined;
            maintenanceExpense?: number | undefined;
            additionalRooms?: string | undefined;
            exteriorFeatures?: string | undefined;
            water?: string | undefined;
            view?: string | undefined;
            lotSizeArea?: number | undefined;
            lotSizeAreaUnits?: string | undefined;
            subdivision?: string | undefined;
            construction?: string | undefined;
            type?: MlsListingType | undefined;
            garageSpaces?: number | undefined;
            bathsThreeQuarter?: number | undefined;
            accessibility?: string | undefined;
            occupantType?: string | undefined;
            yearBuilt?: number | undefined;
            subTypeText?: string | undefined;
          }
        | undefined;
      office?:
        | {
            __typename?: "MLSListingOfficeObject";
            brokerid?: string | undefined;
            name?: string | undefined;
            servingName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      mls?:
        | {
            __typename?: "MLSListingMLSObject";
            statusText: string;
            status?: MlsListingStatus | undefined;
            daysOnMarket?: number | undefined;
            originalEntryTimestamp?: string | undefined;
            originatingSystemName?: string | undefined;
            logoUrl?: string | undefined;
            disclaimer?: string | undefined;
          }
        | undefined;
      association?:
        | {
            __typename?: "MLSListingAssociationObject";
            fee?: number | undefined;
            frequency?: string | undefined;
            name?: string | undefined;
            amenities?: string | undefined;
          }
        | undefined;
      compliance?:
        | {
            __typename?: "MLSListingComplianceObject";
            buyerAgencyCompensation?: number | undefined;
            buyerAgencyCompensationType?: string | undefined;
            subAgencyCompensation?: number | undefined;
            subAgencyCompensationType?: string | undefined;
            attributionContact?: string | undefined;
          }
        | undefined;
      sales?:
        | {
            __typename?: "MLSListingSalesObject";
            closeDate?: string | undefined;
            closePrice?: number | undefined;
            contractDate?: string | undefined;
          }
        | undefined;
      geo: {
        __typename?: "MLSListingGeoObject";
        location: { __typename?: "GeoPointObject"; lat: number; lon: number };
      };
    };
    adjustments?:
      | {
          __typename?: "ListingComparableAdjustmentsObject";
          id: string;
          priceAdjustmentsPerFields?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          totalAdjustmentPrice?: number | undefined;
          notes?: string | undefined;
        }
      | undefined;
  }>;
  agent?: { __typename?: "AgentObject"; id: string } | undefined;
  listing?: { __typename?: "ListingObject"; id: string } | undefined;
  propertyDetails?:
    | { __typename?: "PropertyDetailsObject"; id: string }
    | undefined;
  buyerOfferAnalysis?:
    | { __typename?: "BuyerOfferAnalysisObject"; id: string }
    | undefined;
};

export type ListingDocumentUploadFragment = {
  __typename?: "ListingDocumentUploadObject";
  id: string;
  customDocumentType?: ListingDocumentTypeEnum | undefined;
  customDocumentName?: string | undefined;
  file?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
  listingDocumentType?:
    | {
        __typename?: "ListingDocumentTypeObject";
        id: string;
        slug: string;
        usState: UsState;
        name: string;
        formName: string;
        type: ListingDocumentTypeEnum;
      }
    | undefined;
};

export type ListingDocumentTypeFragment = {
  __typename?: "ListingDocumentTypeObject";
  id: string;
  slug: string;
  usState: UsState;
  name: string;
  formName: string;
  type: ListingDocumentTypeEnum;
};

export type ListingDocumentTypeWithDocumentsFragment = {
  __typename?: "ListingDocumentTypeObject";
  id: string;
  document?:
    | {
        __typename?: "DocumentObject";
        id: string;
        form: string;
        name: string;
        description: string;
        activeDocumentVersion: {
          __typename?: "DocumentVersionObject";
          id: string;
          mappingKeys: Array<string>;
          previewImages: Array<{
            __typename?: "AssetFileObject";
            id: string;
            ordering: number;
            file: { __typename?: "FileObject"; url: string };
          }>;
        };
      }
    | undefined;
};

export type ListingFollowerFragment = {
  __typename?: "ListingFollowerObject";
  followedAt: any;
  user: {
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ChartTrendFragment = {
  __typename?: "ChartTrend";
  value?: number | undefined;
  period: string;
};

export type ChartMetricFragment = {
  __typename?: "ChartMetric";
  value?: number | undefined;
  description: string;
  unit: ChartUnit;
  trend?:
    | { __typename?: "ChartTrend"; value?: number | undefined; period: string }
    | undefined;
};

export type ChartDataPointFragment = {
  __typename?: "ChartDataPoint";
  label: string;
  value?: number | undefined;
};

export type ChartDataFragment = {
  __typename?: "ChartData";
  type: ListingReportChartType;
  title: string;
  valueUnit: ChartUnit;
  labelUnit: ChartUnit;
  styleConfig: { __typename?: "ChartStyleConfig"; showLegend: boolean };
  mainMetric: {
    __typename?: "ChartMetric";
    value?: number | undefined;
    description: string;
    unit: ChartUnit;
    trend?:
      | {
          __typename?: "ChartTrend";
          value?: number | undefined;
          period: string;
        }
      | undefined;
  };
  data: Array<{
    __typename?: "ChartDataPoint";
    label: string;
    value?: number | undefined;
  }>;
  verticalReferenceLine?:
    | {
        __typename?: "ChartDataPoint";
        label: string;
        value?: number | undefined;
      }
    | undefined;
};

export type ChartCardFragment = {
  __typename?: "ChartCard";
  title: string;
  chart?:
    | {
        __typename?: "ChartData";
        type: ListingReportChartType;
        title: string;
        valueUnit: ChartUnit;
        labelUnit: ChartUnit;
        styleConfig: { __typename?: "ChartStyleConfig"; showLegend: boolean };
        mainMetric: {
          __typename?: "ChartMetric";
          value?: number | undefined;
          description: string;
          unit: ChartUnit;
          trend?:
            | {
                __typename?: "ChartTrend";
                value?: number | undefined;
                period: string;
              }
            | undefined;
        };
        data: Array<{
          __typename?: "ChartDataPoint";
          label: string;
          value?: number | undefined;
        }>;
        verticalReferenceLine?:
          | {
              __typename?: "ChartDataPoint";
              label: string;
              value?: number | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TableColumnFragment = {
  __typename?: "TableColumn";
  title: string;
  summary?: string | undefined;
  key: string;
  isHighlighted: boolean;
};

export type OffersByFinancingTypeTableRowFragment = {
  __typename?: "OffersByFinancingTypeTableRow";
  allTypes: {
    __typename?: "TableRowDataValue";
    value: string;
    subValue?: string | undefined;
  };
  cash?:
    | {
        __typename?: "TableRowDataValue";
        value: string;
        subValue?: string | undefined;
      }
    | undefined;
  conventional?:
    | {
        __typename?: "TableRowDataValue";
        value: string;
        subValue?: string | undefined;
      }
    | undefined;
  fhaVaUsda?:
    | {
        __typename?: "TableRowDataValue";
        value: string;
        subValue?: string | undefined;
      }
    | undefined;
  other?:
    | {
        __typename?: "TableRowDataValue";
        value: string;
        subValue?: string | undefined;
      }
    | undefined;
};

export type TableRowFragment = {
  __typename?: "TableRow";
  title: string;
  data?:
    | {
        __typename?: "OffersByFinancingTypeTableRow";
        allTypes: {
          __typename?: "TableRowDataValue";
          value: string;
          subValue?: string | undefined;
        };
        cash?:
          | {
              __typename?: "TableRowDataValue";
              value: string;
              subValue?: string | undefined;
            }
          | undefined;
        conventional?:
          | {
              __typename?: "TableRowDataValue";
              value: string;
              subValue?: string | undefined;
            }
          | undefined;
        fhaVaUsda?:
          | {
              __typename?: "TableRowDataValue";
              value: string;
              subValue?: string | undefined;
            }
          | undefined;
        other?:
          | {
              __typename?: "TableRowDataValue";
              value: string;
              subValue?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type TableDataFragment = {
  __typename?: "TableData";
  title: string;
  columns: Array<{
    __typename?: "TableColumn";
    title: string;
    summary?: string | undefined;
    key: string;
    isHighlighted: boolean;
  }>;
  rows: Array<{
    __typename?: "TableRow";
    title: string;
    data?:
      | {
          __typename?: "OffersByFinancingTypeTableRow";
          allTypes: {
            __typename?: "TableRowDataValue";
            value: string;
            subValue?: string | undefined;
          };
          cash?:
            | {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              }
            | undefined;
          conventional?:
            | {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              }
            | undefined;
          fhaVaUsda?:
            | {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              }
            | undefined;
          other?:
            | {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              }
            | undefined;
        }
      | undefined;
  }>;
};

export type ReportConfidenceFragment = {
  __typename?: "ReportConfidence";
  confidence: ConfidenceLevel;
  maxDistanceMiles: number;
  maxTimePeriodMonths: number;
  maxClosePrice: number;
  minClosePrice: number;
  zipCode?: string | undefined;
  subType?: string | undefined;
  subTypes?: Array<string> | undefined;
};

export type ListingReportResponseFragment = {
  __typename?: "ListingReportResponse";
  confidence: {
    __typename?: "ReportConfidence";
    confidence: ConfidenceLevel;
    maxDistanceMiles: number;
    maxTimePeriodMonths: number;
    maxClosePrice: number;
    minClosePrice: number;
    zipCode?: string | undefined;
    subType?: string | undefined;
    subTypes?: Array<string> | undefined;
  };
  charts: Array<{
    __typename?: "ChartCard";
    title: string;
    chart?:
      | {
          __typename?: "ChartData";
          type: ListingReportChartType;
          title: string;
          valueUnit: ChartUnit;
          labelUnit: ChartUnit;
          styleConfig: { __typename?: "ChartStyleConfig"; showLegend: boolean };
          mainMetric: {
            __typename?: "ChartMetric";
            value?: number | undefined;
            description: string;
            unit: ChartUnit;
            trend?:
              | {
                  __typename?: "ChartTrend";
                  value?: number | undefined;
                  period: string;
                }
              | undefined;
          };
          data: Array<{
            __typename?: "ChartDataPoint";
            label: string;
            value?: number | undefined;
          }>;
          verticalReferenceLine?:
            | {
                __typename?: "ChartDataPoint";
                label: string;
                value?: number | undefined;
              }
            | undefined;
        }
      | undefined;
  }>;
  tables: Array<{
    __typename?: "TableData";
    title: string;
    columns: Array<{
      __typename?: "TableColumn";
      title: string;
      summary?: string | undefined;
      key: string;
      isHighlighted: boolean;
    }>;
    rows: Array<{
      __typename?: "TableRow";
      title: string;
      data?:
        | {
            __typename?: "OffersByFinancingTypeTableRow";
            allTypes: {
              __typename?: "TableRowDataValue";
              value: string;
              subValue?: string | undefined;
            };
            cash?:
              | {
                  __typename?: "TableRowDataValue";
                  value: string;
                  subValue?: string | undefined;
                }
              | undefined;
            conventional?:
              | {
                  __typename?: "TableRowDataValue";
                  value: string;
                  subValue?: string | undefined;
                }
              | undefined;
            fhaVaUsda?:
              | {
                  __typename?: "TableRowDataValue";
                  value: string;
                  subValue?: string | undefined;
                }
              | undefined;
            other?:
              | {
                  __typename?: "TableRowDataValue";
                  value: string;
                  subValue?: string | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
  }>;
};

export type NotificationTemplateFragment = {
  __typename?: "NotificationTemplateObject";
  id: string;
  title: string;
  eventType: TransactionStageType;
  side?: TransactionSide | undefined;
  notificationType: NotificationType;
  recipients: Array<ContactType>;
  hasAssignedPartner?: boolean | undefined;
  delayMinutes: number;
  dataToShare: Array<string>;
  messageContent: string;
  status: NotificationTemplateStatus;
  orderIndex: number;
  createdAt: any;
  updatedAt: any;
  messageContentTemplates: {
    __typename?: "NotificationTemplateMessageContentTemplates";
    html: string;
    text: string;
  };
};

export type NotificationTemplateDetailsFragment = {
  __typename?: "NotificationTemplateObject";
  id: string;
  title: string;
  eventType: TransactionStageType;
  side?: TransactionSide | undefined;
  notificationType: NotificationType;
  recipients: Array<ContactType>;
  hasAssignedPartner?: boolean | undefined;
  isAttachedToPartner?: boolean | undefined;
  delayMinutes: number;
  dataToShare: Array<string>;
  messageContent: string;
  status: NotificationTemplateStatus;
  orderIndex: number;
  messageContentTemplates: {
    __typename?: "NotificationTemplateMessageContentTemplates";
    html: string;
    text: string;
  };
};

export type NotificationTemplateListItemFragment = {
  __typename?: "NotificationTemplateObject";
  id: string;
  title: string;
  eventType: TransactionStageType;
  side?: TransactionSide | undefined;
  notificationType: NotificationType;
  recipients: Array<ContactType>;
  status: NotificationTemplateStatus;
  messageContent: string;
  delayMinutes: number;
  orderIndex: number;
  messageContentTemplates: {
    __typename?: "NotificationTemplateMessageContentTemplates";
    html: string;
    text: string;
  };
  partner?:
    | {
        __typename?: "OrganizationPartnerObject";
        id: string;
        name: string;
        isActive: boolean;
        logo?: { __typename?: "FileObject"; url: string } | undefined;
      }
    | undefined;
};

export type OfferFragment = {
  __typename?: "OfferObject";
  id: string;
  status: OfferStatus;
  source?: OfferSource | undefined;
  isUploaded: boolean;
  submittedAt?: any | undefined;
  noteToListingAgent?: string | undefined;
  primaryBuyer?:
    | {
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }
    | undefined;
  secondaryBuyers?:
    | Array<{
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  events?:
    | Array<{
        __typename?: "AppEventObject";
        id: string;
        name: string;
        createdAt: any;
      }>
    | undefined;
  buyersAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        fullName: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  party?: { __typename?: "PartyObject"; id: string } | undefined;
};

export type IndigoOffersSourceFragment = {
  __typename?: "IndigoOffersSource";
  type: MarketDataSourceType;
  metadata: {
    __typename?: "IndigoOffersMetadata";
    confidence: ConfidenceLevel;
    distanceMiles: number;
    timePeriodMonths: number;
  };
};

export type CompsSourceFragment = {
  __typename?: "CompsSource";
  type: MarketDataSourceType;
};

export type MlsSourceFragment = {
  __typename?: "MLSSource";
  type: MarketDataSourceType;
};

type MarketDataSource_CompsSource_Fragment = {
  __typename: "CompsSource";
  type: MarketDataSourceType;
};

type MarketDataSource_IndigoOffersSource_Fragment = {
  __typename: "IndigoOffersSource";
  type: MarketDataSourceType;
  metadata: {
    __typename?: "IndigoOffersMetadata";
    confidence: ConfidenceLevel;
    distanceMiles: number;
    timePeriodMonths: number;
  };
};

type MarketDataSource_MlsSource_Fragment = {
  __typename: "MLSSource";
  type: MarketDataSourceType;
};

export type MarketDataSourceFragment =
  | MarketDataSource_CompsSource_Fragment
  | MarketDataSource_IndigoOffersSource_Fragment
  | MarketDataSource_MlsSource_Fragment;

export type KeyTermFragment = {
  __typename?: "KeyTerm";
  label?: string | undefined;
  type: KeyTermType;
  unit: KeyTermUnit;
  recommendation: number;
  context: {
    __typename?: "KeyTermRecommendationContext";
    marketData: { __typename?: "MarketDataRange"; low: number; high: number };
    marketDataPercentages?:
      | { __typename?: "MarketDataPercentages"; yes: number; no: number }
      | undefined;
    source:
      | { __typename: "CompsSource"; type: MarketDataSourceType }
      | {
          __typename: "IndigoOffersSource";
          type: MarketDataSourceType;
          metadata: {
            __typename?: "IndigoOffersMetadata";
            confidence: ConfidenceLevel;
            distanceMiles: number;
            timePeriodMonths: number;
          };
        }
      | { __typename: "MLSSource"; type: MarketDataSourceType };
  };
};

export type KeyTermErrorFragment = {
  __typename?: "KeyTermError";
  label?: string | undefined;
  type: KeyTermType;
  unit: KeyTermUnit;
  reason: string;
  sourceType: MarketDataSourceType;
};

type KeyTermResult_KeyTerm_Fragment = {
  __typename: "KeyTerm";
  label?: string | undefined;
  type: KeyTermType;
  unit: KeyTermUnit;
  recommendation: number;
  context: {
    __typename?: "KeyTermRecommendationContext";
    marketData: { __typename?: "MarketDataRange"; low: number; high: number };
    marketDataPercentages?:
      | { __typename?: "MarketDataPercentages"; yes: number; no: number }
      | undefined;
    source:
      | { __typename: "CompsSource"; type: MarketDataSourceType }
      | {
          __typename: "IndigoOffersSource";
          type: MarketDataSourceType;
          metadata: {
            __typename?: "IndigoOffersMetadata";
            confidence: ConfidenceLevel;
            distanceMiles: number;
            timePeriodMonths: number;
          };
        }
      | { __typename: "MLSSource"; type: MarketDataSourceType };
  };
};

type KeyTermResult_KeyTermError_Fragment = {
  __typename: "KeyTermError";
  label?: string | undefined;
  type: KeyTermType;
  unit: KeyTermUnit;
  reason: string;
  sourceType: MarketDataSourceType;
};

export type KeyTermResultFragment =
  | KeyTermResult_KeyTerm_Fragment
  | KeyTermResult_KeyTermError_Fragment;

export type ContingencyErrorFragment = {
  __typename?: "ContingencyError";
  type: ContingencyType;
  reason: string;
};

export type ContingencyFragment = {
  __typename?: "Contingency";
  type: ContingencyType;
  recommendation: boolean;
  context: {
    __typename?: "ContingencyRecommendationContext";
    marketData: {
      __typename?: "MarketDataPercentages";
      yes: number;
      no: number;
    };
    source:
      | { __typename: "CompsSource"; type: MarketDataSourceType }
      | {
          __typename: "IndigoOffersSource";
          type: MarketDataSourceType;
          metadata: {
            __typename?: "IndigoOffersMetadata";
            confidence: ConfidenceLevel;
            distanceMiles: number;
            timePeriodMonths: number;
          };
        }
      | { __typename: "MLSSource"; type: MarketDataSourceType };
  };
};

type ContingencyResult_Contingency_Fragment = {
  __typename: "Contingency";
  type: ContingencyType;
  recommendation: boolean;
  context: {
    __typename?: "ContingencyRecommendationContext";
    marketData: {
      __typename?: "MarketDataPercentages";
      yes: number;
      no: number;
    };
    source:
      | { __typename: "CompsSource"; type: MarketDataSourceType }
      | {
          __typename: "IndigoOffersSource";
          type: MarketDataSourceType;
          metadata: {
            __typename?: "IndigoOffersMetadata";
            confidence: ConfidenceLevel;
            distanceMiles: number;
            timePeriodMonths: number;
          };
        }
      | { __typename: "MLSSource"; type: MarketDataSourceType };
  };
};

type ContingencyResult_ContingencyError_Fragment = {
  __typename: "ContingencyError";
  type: ContingencyType;
  reason: string;
};

export type ContingencyResultFragment =
  | ContingencyResult_Contingency_Fragment
  | ContingencyResult_ContingencyError_Fragment;

export type PriceAnalysisFragment = {
  __typename?: "PriceAnalysis";
  avgCompBidAskRatio: number;
  isPotentiallyOverpriced: boolean;
  isPotentiallyUnderpriced: boolean;
  pricePositioning: number;
};

export type CompetitivenessMetricsFragment = {
  __typename?: "CompetitivenessMetrics";
  bidAsk: number;
  bidAskScore: number;
  daysOnMarket: number;
  daysOnMarketScore: number;
  minMarketBidAskRatio?: number | undefined;
  maxMarketBidAskRatio?: number | undefined;
  priceAnalysis: {
    __typename?: "PriceAnalysis";
    avgCompBidAskRatio: number;
    isPotentiallyOverpriced: boolean;
    isPotentiallyUnderpriced: boolean;
    pricePositioning: number;
  };
};

export type CompetitivenessScoreFragment = {
  __typename?: "CompetitivenessScore";
  error?: string | undefined;
  rating: CompetitivenessLevel;
  score: number;
  metrics: {
    __typename?: "CompetitivenessMetrics";
    bidAsk: number;
    bidAskScore: number;
    daysOnMarket: number;
    daysOnMarketScore: number;
    minMarketBidAskRatio?: number | undefined;
    maxMarketBidAskRatio?: number | undefined;
    priceAnalysis: {
      __typename?: "PriceAnalysis";
      avgCompBidAskRatio: number;
      isPotentiallyOverpriced: boolean;
      isPotentiallyUnderpriced: boolean;
      pricePositioning: number;
    };
  };
};

export type OfferScoreFragment = {
  __typename?: "OfferScore";
  reason: string;
  value: number;
  offerScoreExplanation?: string | undefined;
};

type OfferScoreResult_OfferScore_Fragment = {
  __typename?: "OfferScore";
  reason: string;
  value: number;
  offerScoreExplanation?: string | undefined;
};

type OfferScoreResult_OfferScoreNotCalculated_Fragment = {
  __typename?: "OfferScoreNotCalculated";
  reason: string;
};

export type OfferScoreResultFragment =
  | OfferScoreResult_OfferScore_Fragment
  | OfferScoreResult_OfferScoreNotCalculated_Fragment;

export type OfferRecsFragment = {
  __typename?: "OfferRecsPayload";
  keyTerms: Array<
    | {
        __typename: "KeyTerm";
        label?: string | undefined;
        type: KeyTermType;
        unit: KeyTermUnit;
        recommendation: number;
        context: {
          __typename?: "KeyTermRecommendationContext";
          marketData: {
            __typename?: "MarketDataRange";
            low: number;
            high: number;
          };
          marketDataPercentages?:
            | { __typename?: "MarketDataPercentages"; yes: number; no: number }
            | undefined;
          source:
            | { __typename: "CompsSource"; type: MarketDataSourceType }
            | {
                __typename: "IndigoOffersSource";
                type: MarketDataSourceType;
                metadata: {
                  __typename?: "IndigoOffersMetadata";
                  confidence: ConfidenceLevel;
                  distanceMiles: number;
                  timePeriodMonths: number;
                };
              }
            | { __typename: "MLSSource"; type: MarketDataSourceType };
        };
      }
    | {
        __typename: "KeyTermError";
        label?: string | undefined;
        type: KeyTermType;
        unit: KeyTermUnit;
        reason: string;
        sourceType: MarketDataSourceType;
      }
  >;
  contingencies: Array<
    | {
        __typename: "Contingency";
        type: ContingencyType;
        recommendation: boolean;
        context: {
          __typename?: "ContingencyRecommendationContext";
          marketData: {
            __typename?: "MarketDataPercentages";
            yes: number;
            no: number;
          };
          source:
            | { __typename: "CompsSource"; type: MarketDataSourceType }
            | {
                __typename: "IndigoOffersSource";
                type: MarketDataSourceType;
                metadata: {
                  __typename?: "IndigoOffersMetadata";
                  confidence: ConfidenceLevel;
                  distanceMiles: number;
                  timePeriodMonths: number;
                };
              }
            | { __typename: "MLSSource"; type: MarketDataSourceType };
        };
      }
    | { __typename: "ContingencyError"; type: ContingencyType; reason: string }
  >;
  competitiveness: {
    __typename?: "CompetitivenessScore";
    error?: string | undefined;
    rating: CompetitivenessLevel;
    score: number;
    metrics: {
      __typename?: "CompetitivenessMetrics";
      bidAsk: number;
      bidAskScore: number;
      daysOnMarket: number;
      daysOnMarketScore: number;
      minMarketBidAskRatio?: number | undefined;
      maxMarketBidAskRatio?: number | undefined;
      priceAnalysis: {
        __typename?: "PriceAnalysis";
        avgCompBidAskRatio: number;
        isPotentiallyOverpriced: boolean;
        isPotentiallyUnderpriced: boolean;
        pricePositioning: number;
      };
    };
  };
};

export type OrganizationPartnerItemFragment = {
  __typename?: "OrganizationPartnerObject";
  id: string;
  name: string;
  partnerType: PartnerType;
  isActive: boolean;
  dryRunNotifications: boolean;
  existingRelationshipIntroMessage: string;
  newRelationshipIntroMessage: string;
  hasDrafts: boolean;
  createdAt: any;
  updatedAt: any;
  adminContacts?:
    | Array<{
        __typename?: "ContactObject";
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        phoneNumber?: string | undefined;
        contactType: ContactType;
      }>
    | undefined;
  logo?: { __typename?: "FileObject"; url: string } | undefined;
  contacts?:
    | Array<{
        __typename?: "ContactObject";
        id: string;
        firstName: string;
        lastName: string;
      }>
    | undefined;
};

export type OrganizationPartnerStageIntroItemFragment = {
  __typename?: "OrganizationPartnerStageIntroObject";
  id: string;
  side: TransactionSide;
  stage: TransactionStageType;
  newRelationshipMessageContent: string;
  existingRelationshipMessageContent: string;
  allowPartnerContactAssignment: boolean;
};

export type OrganizationRosterItemFragment = {
  __typename?: "OrganizationRosterObject";
  id: string;
  isContactable: boolean;
  createdAt: any;
  contact: {
    __typename?: "ContactObject";
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber?: string | undefined;
    contactType: ContactType;
  };
  preferences: Array<{
    __typename?: "OrganizationRosterPreferenceObject";
    id: string;
    partnerType: PartnerType;
    preferenceType: PartnerPreferenceType;
    partner?:
      | { __typename?: "OrganizationPartnerObject"; id: string; name: string }
      | undefined;
    partnerContact?:
      | {
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
          partner?:
            | {
                __typename?: "OrganizationPartnerObject";
                id: string;
                name: string;
              }
            | undefined;
        }
      | undefined;
  }>;
};

type PartnerContactBase_InsuranceAgentContactObject_Fragment = {
  __typename?: "InsuranceAgentContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
};

type PartnerContactBase_LoanOfficerContactObject_Fragment = {
  __typename?: "LoanOfficerContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
};

type PartnerContactBase_TitleAgentContactObject_Fragment = {
  __typename?: "TitleAgentContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
};

export type PartnerContactBaseFragment =
  | PartnerContactBase_InsuranceAgentContactObject_Fragment
  | PartnerContactBase_LoanOfficerContactObject_Fragment
  | PartnerContactBase_TitleAgentContactObject_Fragment;

type PartnerContact_InsuranceAgentContactObject_Fragment = {
  __typename?: "InsuranceAgentContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
};

type PartnerContact_LoanOfficerContactObject_Fragment = {
  __typename?: "LoanOfficerContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
  loanOfficerConfig?:
    | {
        __typename?: "LoanOfficerContactConfigObject";
        preApprovalAppUrl?: string | undefined;
        calendarSchedulingUrl?: string | undefined;
      }
    | undefined;
};

type PartnerContact_TitleAgentContactObject_Fragment = {
  __typename?: "TitleAgentContactObject";
  id: string;
  firstName: string;
  lastName: string;
  contactType: ContactType;
  email: string;
  phoneNumber?: string | undefined;
  createdAt: any;
  updatedAt: any;
};

export type PartnerContactFragment =
  | PartnerContact_InsuranceAgentContactObject_Fragment
  | PartnerContact_LoanOfficerContactObject_Fragment
  | PartnerContact_TitleAgentContactObject_Fragment;

export type PartyFragment = {
  __typename?: "PartyObject";
  id: string;
  createdAt: any;
  purchaseOffers?:
    | Array<{
        __typename?: "OfferObject";
        id: string;
        updatedAt?: any | undefined;
        listing?:
          | {
              __typename?: "ListingObject";
              id: string;
              isPremium: boolean;
              property: {
                __typename?: "PropertyObject";
                id: string;
                slug: string;
                state: UsState;
              };
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
              listingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | { __typename?: "UserObject"; id: string }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>
    | undefined;
  primaryConsumer: {
    __typename?: "ConsumerObject";
    id: string;
    email?: string | undefined;
    fullName: string;
    phoneNumber?: string | undefined;
    isEntity: boolean;
    entityName?: string | undefined;
    entityTitle?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
  };
  secondaryConsumers: Array<{
    __typename?: "ConsumerObject";
    id: string;
    email?: string | undefined;
    fullName: string;
    phoneNumber?: string | undefined;
    isEntity: boolean;
    entityName?: string | undefined;
    entityTitle?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
  }>;
  partyFinancing?:
    | {
        __typename?: "PartyFinancingObject";
        id: string;
        financingType?: FinancingType | undefined;
        loanAmount?: number | undefined;
        percentDownPayment?: number | undefined;
        cashReserves?: number | undefined;
        preapprovalFile?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }
    | undefined;
};

export type PreferenceValueFragment = {
  __typename?: "PreferenceValueObject";
  numberValue?: number | undefined;
  textValue?: string | undefined;
  stringValue?: string | undefined;
  stringArray?: Array<string> | undefined;
  booleanValue?: boolean | undefined;
  dateTimeValue?: any | undefined;
  readOnly?: boolean | undefined;
  preference: {
    __typename?: "PreferenceObject";
    id: string;
    name: string;
    slug: string;
    usStates: Array<UsState>;
    fieldId?: string | undefined;
    valueType: PreferenceValueType;
  };
};

export type PreferenceFragment = {
  __typename?: "PreferenceObject";
  id: string;
  name: string;
  slug: string;
  usStates: Array<UsState>;
  fieldId?: string | undefined;
  valueType: PreferenceValueType;
};

export type PropertyFragment = {
  __typename?: "PropertyObject";
  id: string;
  streetAddress: string;
  unit?: string | undefined;
  city: string;
  state: UsState;
  zipCode: string;
  zipCodePlus4?: string | undefined;
  county: string;
  lot: string;
  block: string;
  platBook: string;
  platBookPage: string;
  subdivision: string;
  parcelId: string;
  yearBuilt?: number | undefined;
  assessorParcelNumber?: string | undefined;
  otherLegalDescription: string;
};

export type GetPropertyDetailsSuccessFragment = {
  __typename?: "GetPropertyDetailsSuccess";
  areaSqFt?: number | undefined;
  yearBuilt?: number | undefined;
  bedrooms?: number | undefined;
  bathsFull?: number | undefined;
  bathsHalf?: number | undefined;
  propertyType?: MlsListingType | undefined;
  propertySubtype?: MlsListingSubType | undefined;
  subdivision?: string | undefined;
  schoolDistrict?: string | undefined;
};

export type GetPropertyDetailsFailedFragment = {
  __typename?: "GetPropertyDetailsFailed";
  error: string;
};

type GetPropertyDetailsResult_GetPropertyDetailsFailed_Fragment = {
  __typename?: "GetPropertyDetailsFailed";
  error: string;
};

type GetPropertyDetailsResult_GetPropertyDetailsSuccess_Fragment = {
  __typename?: "GetPropertyDetailsSuccess";
  areaSqFt?: number | undefined;
  yearBuilt?: number | undefined;
  bedrooms?: number | undefined;
  bathsFull?: number | undefined;
  bathsHalf?: number | undefined;
  propertyType?: MlsListingType | undefined;
  propertySubtype?: MlsListingSubType | undefined;
  subdivision?: string | undefined;
  schoolDistrict?: string | undefined;
};

export type GetPropertyDetailsResultFragment =
  | GetPropertyDetailsResult_GetPropertyDetailsFailed_Fragment
  | GetPropertyDetailsResult_GetPropertyDetailsSuccess_Fragment;

export type AddressFragment = {
  __typename?: "AddressObject";
  streetAddress: string;
  city: string;
  state: UsState;
  zipCode: string;
  unit?: string | undefined;
};

export type GeoFragment = {
  __typename?: "GeoObject";
  lat: number;
  lng: number;
};

export type LocationFragment = {
  __typename?: "Location";
  address: {
    __typename?: "AddressObject";
    streetAddress: string;
    city: string;
    state: UsState;
    zipCode: string;
    unit?: string | undefined;
  };
  coords?: { __typename?: "GeoObject"; lat: number; lng: number } | undefined;
};

export type PropertyDetailsFragment = {
  __typename?: "PropertyDetailsObject";
  id: string;
  streetAddress: string;
  city: string;
  state: UsState;
  zipCode: string;
  unit?: string | undefined;
  targetPrice: number;
  areaSqFt: number;
  yearBuilt: number;
  bedrooms: number;
  bathsFull: number;
  bathsHalf?: number | undefined;
  propertyType: MlsListingType;
  propertySubtype: MlsListingSubType;
  subdivision?: string | undefined;
  schoolDistrict?: string | undefined;
  geo: { __typename?: "GeoObject"; lat: number; lng: number };
};

export type ResoMemberFragment = {
  __typename?: "RESOMemberObject";
  MemberFirstName?: string | undefined;
  MemberLastName?: string | undefined;
  MemberFullName?: string | undefined;
  MemberMiddleName?: string | undefined;
  MemberEmail?: string | undefined;
  MemberDirectPhone?: string | undefined;
  MemberMobilePhone?: string | undefined;
  MemberMlsId?: string | undefined;
  MemberNationalAssociationId?: string | undefined;
  OfficeMlsId?: string | undefined;
  MemberStatus?: string | undefined;
  OriginatingSystemName?: string | undefined;
  Media?:
    | Array<{
        __typename?: "MediaObject";
        MediaKey?: string | undefined;
        MediaURL?: string | undefined;
        ImageWidth?: number | undefined;
        ImageHeight?: number | undefined;
        ImageSizeDescription?: string | undefined;
        MediaModificationTimestamp?: string | undefined;
      }>
    | undefined;
};

export type ResoOfficeFragment = {
  __typename?: "RESOOfficeObject";
  OfficeName?: string | undefined;
  OfficeEmail?: string | undefined;
  OfficeKey?: string | undefined;
  OfficeMlsId?: string | undefined;
  OfficeStatus?: string | undefined;
  OriginatingSystemName?: string | undefined;
};

export type ShareLinkFragment = {
  __typename?: "ShareLinkObject";
  id: string;
  token: string;
  expiresAt?: any | undefined;
  accessType: ShareLinkAccessType;
  status: ShareLinkStatus;
  recipientEmail?: string | undefined;
  recipientPhoneNumber?: string | undefined;
  isForPdf: boolean;
};

export type StorefrontActivitySummaryFragment = {
  __typename?: "StorefrontActivitySummaryObject";
  count: number;
  activityType: ActivityType;
  users: Array<{
    __typename?: "UserObject";
    id: string;
    firstName: string;
    lastName: string;
    fullName: string;
    userName?: string | undefined;
    phoneNumber: string;
    roles: Array<Roles>;
    email?: string | undefined;
    profileBio?: string | undefined;
    offerCollectionEmail?: string | undefined;
    profilePicture?:
      | { __typename?: "FileObject"; fileName: string; url: string }
      | undefined;
    settings?:
      | {
          __typename?: "UserSettingsObject";
          id: string;
          selectedOrganization?:
            | {
                __typename?: "OrganizationObject";
                id: string;
                name: string;
                hasDescendants?: boolean | undefined;
                contractSystemCredentials?:
                  | Array<{
                      __typename?: "ContractSystemCredentialsObject";
                      id: string;
                      hasInvalidCredentials?: boolean | undefined;
                      isReady: boolean;
                      type?: ContractSystemType | undefined;
                      username?: string | undefined;
                      dotloopProfileId?: string | undefined;
                      dotloopTeamName?: string | undefined;
                    }>
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  }>;
  activities: Array<{
    __typename?: "ActivityObject";
    id: string;
    type: ActivityType;
    createdAt: any;
    user?: { __typename?: "PublicUserObject"; id: string } | undefined;
  }>;
};

export type TransactionNotificationLogFragment = {
  __typename?: "TransactionNotificationLogObject";
  id: string;
  title: string;
  messageContent: string;
  scheduledAt?: any | undefined;
  sentAt?: any | undefined;
  createdAt: any;
  notificationTemplate?:
    | {
        __typename?: "NotificationTemplateObject";
        id: string;
        title: string;
        eventType: TransactionStageType;
        side?: TransactionSide | undefined;
        notificationType: NotificationType;
        recipients: Array<ContactType>;
        hasAssignedPartner?: boolean | undefined;
        delayMinutes: number;
        dataToShare: Array<string>;
        messageContent: string;
        status: NotificationTemplateStatus;
        orderIndex: number;
        createdAt: any;
        updatedAt: any;
        messageContentTemplates: {
          __typename?: "NotificationTemplateMessageContentTemplates";
          html: string;
          text: string;
        };
      }
    | undefined;
  recipients: Array<{
    __typename?: "ContactObject";
    id: string;
    firstName: string;
    lastName: string;
    contactType: ContactType;
    email: string;
    phoneNumber?: string | undefined;
  }>;
  rawRecipients?:
    | Array<{
        __typename?: "NotificationUserObject";
        id: string;
        fullName: string;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        contactType?: ContactType | undefined;
      }>
    | undefined;
};

export type UserFragment = {
  __typename?: "UserObject";
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  userName?: string | undefined;
  phoneNumber: string;
  roles: Array<Roles>;
  email?: string | undefined;
  profileBio?: string | undefined;
  offerCollectionEmail?: string | undefined;
  profilePicture?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
  settings?:
    | {
        __typename?: "UserSettingsObject";
        id: string;
        selectedOrganization?:
          | {
              __typename?: "OrganizationObject";
              id: string;
              name: string;
              hasDescendants?: boolean | undefined;
              contractSystemCredentials?:
                | Array<{
                    __typename?: "ContractSystemCredentialsObject";
                    id: string;
                    hasInvalidCredentials?: boolean | undefined;
                    isReady: boolean;
                    type?: ContractSystemType | undefined;
                    username?: string | undefined;
                    dotloopProfileId?: string | undefined;
                    dotloopTeamName?: string | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UserSettingsFragment = {
  __typename?: "UserSettingsObject";
  id: string;
  selectedOrganization?:
    | {
        __typename?: "OrganizationObject";
        id: string;
        name: string;
        hasDescendants?: boolean | undefined;
        contractSystemCredentials?:
          | Array<{
              __typename?: "ContractSystemCredentialsObject";
              id: string;
              hasInvalidCredentials?: boolean | undefined;
              isReady: boolean;
              type?: ContractSystemType | undefined;
              username?: string | undefined;
              dotloopProfileId?: string | undefined;
              dotloopTeamName?: string | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type ValidationReviewSubmissionFragment = {
  __typename?: "ValidationReviewSubmissionObject";
  id: string;
  submittedAt: any;
  submittedByUserUuid: string;
  totalErrorCount?: number | undefined;
  hiddenErrorCount?: number | undefined;
  documentErrorCount?: number | undefined;
  folderErrorCount?: number | undefined;
  createdAt: any;
  updatedAt: any;
};

export type MlsListingContactFragment = {
  __typename?: "MLSListingContactObject";
  email?: string | undefined;
  office?: string | undefined;
  cell?: string | undefined;
};

export type MlsListingAgentObjectFragment = {
  __typename?: "MLSListingAgentObject";
  id?: string | undefined;
  mlsId?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  contact?:
    | {
        __typename?: "MLSListingContactObject";
        email?: string | undefined;
        office?: string | undefined;
        cell?: string | undefined;
      }
    | undefined;
};

export type MlsListingPropertyFragment = {
  __typename?: "MLSListingPropertyObject";
  roof?: string | undefined;
  cooling?: string | undefined;
  style?: string | undefined;
  area?: number | undefined;
  bathsFull?: number | undefined;
  bathsHalf?: number | undefined;
  stories?: number | undefined;
  fireplaces?: number | undefined;
  flooring?: string | undefined;
  heating?: string | undefined;
  bathrooms?: string | undefined;
  foundation?: string | undefined;
  poolFeatures?: string | undefined;
  laundryFeatures?: string | undefined;
  occupantName?: string | undefined;
  ownerName?: string | undefined;
  lotDescription?: string | undefined;
  acres?: number | undefined;
  subType?: string | undefined;
  bedrooms?: number | undefined;
  interiorFeatures?: string | undefined;
  lotSize?: string | undefined;
  areaSource?: string | undefined;
  maintenanceExpense?: number | undefined;
  additionalRooms?: string | undefined;
  exteriorFeatures?: string | undefined;
  water?: string | undefined;
  view?: string | undefined;
  lotSizeArea?: number | undefined;
  lotSizeAreaUnits?: string | undefined;
  subdivision?: string | undefined;
  construction?: string | undefined;
  type?: MlsListingType | undefined;
  garageSpaces?: number | undefined;
  bathsThreeQuarter?: number | undefined;
  accessibility?: string | undefined;
  occupantType?: string | undefined;
  yearBuilt?: number | undefined;
  subTypeText?: string | undefined;
};

export type MlsListingMlsFragment = {
  __typename?: "MLSListingMLSObject";
  statusText: string;
  status?: MlsListingStatus | undefined;
  daysOnMarket?: number | undefined;
  originalEntryTimestamp?: string | undefined;
  originatingSystemName?: string | undefined;
  logoUrl?: string | undefined;
  disclaimer?: string | undefined;
};

export type MlsListingAssociationFragment = {
  __typename?: "MLSListingAssociationObject";
  fee?: number | undefined;
  frequency?: string | undefined;
  name?: string | undefined;
  amenities?: string | undefined;
};

export type MlsListingComplianceFragment = {
  __typename?: "MLSListingComplianceObject";
  buyerAgencyCompensation?: number | undefined;
  buyerAgencyCompensationType?: string | undefined;
  subAgencyCompensation?: number | undefined;
  subAgencyCompensationType?: string | undefined;
  attributionContact?: string | undefined;
};

export type MlsListingAddressFragment = {
  __typename?: "MLSListingAddressObject";
  city: string;
  country?: string | undefined;
  crossStreet?: string | undefined;
  full: string;
  postalCode?: string | undefined;
  state: string;
  streetName: string;
  streetNumber?: number | undefined;
  streetNumberText: string;
  unit?: string | undefined;
};

export type MlsListingSalesFragment = {
  __typename?: "MLSListingSalesObject";
  closeDate?: string | undefined;
  closePrice?: number | undefined;
  contractDate?: string | undefined;
};

export type MlsListingGeoFragment = {
  __typename?: "MLSListingGeoObject";
  location: { __typename?: "GeoPointObject"; lat: number; lon: number };
};

export type MlsListingOfficeFragment = {
  __typename?: "MLSListingOfficeObject";
  brokerid?: string | undefined;
  name?: string | undefined;
  servingName?: string | undefined;
  contact?:
    | {
        __typename?: "MLSListingContactObject";
        email?: string | undefined;
        office?: string | undefined;
        cell?: string | undefined;
      }
    | undefined;
};

export type MlsListingSearchResultFragment = {
  __typename?: "MLSListingObject";
  id: string;
  mlsId?: number | undefined;
  listingId?: string | undefined;
  listDate?: string | undefined;
  listPrice?: number | undefined;
  originalListPrice?: number | undefined;
  terms?: string | undefined;
  photos: Array<string>;
  remarks?: string | undefined;
  modified?: string | undefined;
  mlsName?: string | undefined;
  deleted_at?: string | undefined;
  addressFull: string;
  address: {
    __typename?: "MLSListingAddressObject";
    city: string;
    country?: string | undefined;
    crossStreet?: string | undefined;
    full: string;
    postalCode?: string | undefined;
    state: string;
    streetName: string;
    streetNumber?: number | undefined;
    streetNumberText: string;
    unit?: string | undefined;
  };
  property?:
    | {
        __typename?: "MLSListingPropertyObject";
        roof?: string | undefined;
        cooling?: string | undefined;
        style?: string | undefined;
        area?: number | undefined;
        bathsFull?: number | undefined;
        bathsHalf?: number | undefined;
        stories?: number | undefined;
        fireplaces?: number | undefined;
        flooring?: string | undefined;
        heating?: string | undefined;
        bathrooms?: string | undefined;
        foundation?: string | undefined;
        poolFeatures?: string | undefined;
        laundryFeatures?: string | undefined;
        occupantName?: string | undefined;
        ownerName?: string | undefined;
        lotDescription?: string | undefined;
        acres?: number | undefined;
        subType?: string | undefined;
        bedrooms?: number | undefined;
        interiorFeatures?: string | undefined;
        lotSize?: string | undefined;
        areaSource?: string | undefined;
        maintenanceExpense?: number | undefined;
        additionalRooms?: string | undefined;
        exteriorFeatures?: string | undefined;
        water?: string | undefined;
        view?: string | undefined;
        lotSizeArea?: number | undefined;
        lotSizeAreaUnits?: string | undefined;
        subdivision?: string | undefined;
        construction?: string | undefined;
        type?: MlsListingType | undefined;
        garageSpaces?: number | undefined;
        bathsThreeQuarter?: number | undefined;
        accessibility?: string | undefined;
        occupantType?: string | undefined;
        yearBuilt?: number | undefined;
        subTypeText?: string | undefined;
      }
    | undefined;
  office?:
    | {
        __typename?: "MLSListingOfficeObject";
        brokerid?: string | undefined;
        name?: string | undefined;
        servingName?: string | undefined;
        contact?:
          | {
              __typename?: "MLSListingContactObject";
              email?: string | undefined;
              office?: string | undefined;
              cell?: string | undefined;
            }
          | undefined;
      }
    | undefined;
  mls?:
    | {
        __typename?: "MLSListingMLSObject";
        statusText: string;
        status?: MlsListingStatus | undefined;
        daysOnMarket?: number | undefined;
        originalEntryTimestamp?: string | undefined;
        originatingSystemName?: string | undefined;
        logoUrl?: string | undefined;
        disclaimer?: string | undefined;
      }
    | undefined;
  association?:
    | {
        __typename?: "MLSListingAssociationObject";
        fee?: number | undefined;
        frequency?: string | undefined;
        name?: string | undefined;
        amenities?: string | undefined;
      }
    | undefined;
  compliance?:
    | {
        __typename?: "MLSListingComplianceObject";
        buyerAgencyCompensation?: number | undefined;
        buyerAgencyCompensationType?: string | undefined;
        subAgencyCompensation?: number | undefined;
        subAgencyCompensationType?: string | undefined;
        attributionContact?: string | undefined;
      }
    | undefined;
  sales?:
    | {
        __typename?: "MLSListingSalesObject";
        closeDate?: string | undefined;
        closePrice?: number | undefined;
        contractDate?: string | undefined;
      }
    | undefined;
  geo: {
    __typename?: "MLSListingGeoObject";
    location: { __typename?: "GeoPointObject"; lat: number; lon: number };
  };
};

export type MlsListingFragment = {
  __typename?: "MLSListingObject";
  id: string;
  mlsId?: number | undefined;
  listingId?: string | undefined;
  listDate?: string | undefined;
  listPrice?: number | undefined;
  originalListPrice?: number | undefined;
  terms?: string | undefined;
  photos: Array<string>;
  remarks?: string | undefined;
  modified?: string | undefined;
  mlsName?: string | undefined;
  deleted_at?: string | undefined;
  addressFull: string;
  agent?:
    | {
        __typename?: "MLSListingAgentObject";
        id?: string | undefined;
        mlsId?: string | undefined;
        firstName?: string | undefined;
        lastName?: string | undefined;
        contact?:
          | {
              __typename?: "MLSListingContactObject";
              email?: string | undefined;
              office?: string | undefined;
              cell?: string | undefined;
            }
          | undefined;
      }
    | undefined;
  coAgent?:
    | {
        __typename?: "MLSListingAgentObject";
        id?: string | undefined;
        mlsId?: string | undefined;
        firstName?: string | undefined;
        lastName?: string | undefined;
        contact?:
          | {
              __typename?: "MLSListingContactObject";
              email?: string | undefined;
              office?: string | undefined;
              cell?: string | undefined;
            }
          | undefined;
      }
    | undefined;
  address: {
    __typename?: "MLSListingAddressObject";
    city: string;
    country?: string | undefined;
    crossStreet?: string | undefined;
    full: string;
    postalCode?: string | undefined;
    state: string;
    streetName: string;
    streetNumber?: number | undefined;
    streetNumberText: string;
    unit?: string | undefined;
  };
  property?:
    | {
        __typename?: "MLSListingPropertyObject";
        roof?: string | undefined;
        cooling?: string | undefined;
        style?: string | undefined;
        area?: number | undefined;
        bathsFull?: number | undefined;
        bathsHalf?: number | undefined;
        stories?: number | undefined;
        fireplaces?: number | undefined;
        flooring?: string | undefined;
        heating?: string | undefined;
        bathrooms?: string | undefined;
        foundation?: string | undefined;
        poolFeatures?: string | undefined;
        laundryFeatures?: string | undefined;
        occupantName?: string | undefined;
        ownerName?: string | undefined;
        lotDescription?: string | undefined;
        acres?: number | undefined;
        subType?: string | undefined;
        bedrooms?: number | undefined;
        interiorFeatures?: string | undefined;
        lotSize?: string | undefined;
        areaSource?: string | undefined;
        maintenanceExpense?: number | undefined;
        additionalRooms?: string | undefined;
        exteriorFeatures?: string | undefined;
        water?: string | undefined;
        view?: string | undefined;
        lotSizeArea?: number | undefined;
        lotSizeAreaUnits?: string | undefined;
        subdivision?: string | undefined;
        construction?: string | undefined;
        type?: MlsListingType | undefined;
        garageSpaces?: number | undefined;
        bathsThreeQuarter?: number | undefined;
        accessibility?: string | undefined;
        occupantType?: string | undefined;
        yearBuilt?: number | undefined;
        subTypeText?: string | undefined;
      }
    | undefined;
  office?:
    | {
        __typename?: "MLSListingOfficeObject";
        brokerid?: string | undefined;
        name?: string | undefined;
        servingName?: string | undefined;
        contact?:
          | {
              __typename?: "MLSListingContactObject";
              email?: string | undefined;
              office?: string | undefined;
              cell?: string | undefined;
            }
          | undefined;
      }
    | undefined;
  mls?:
    | {
        __typename?: "MLSListingMLSObject";
        statusText: string;
        status?: MlsListingStatus | undefined;
        daysOnMarket?: number | undefined;
        originalEntryTimestamp?: string | undefined;
        originatingSystemName?: string | undefined;
        logoUrl?: string | undefined;
        disclaimer?: string | undefined;
      }
    | undefined;
  association?:
    | {
        __typename?: "MLSListingAssociationObject";
        fee?: number | undefined;
        frequency?: string | undefined;
        name?: string | undefined;
        amenities?: string | undefined;
      }
    | undefined;
  compliance?:
    | {
        __typename?: "MLSListingComplianceObject";
        buyerAgencyCompensation?: number | undefined;
        buyerAgencyCompensationType?: string | undefined;
        subAgencyCompensation?: number | undefined;
        subAgencyCompensationType?: string | undefined;
        attributionContact?: string | undefined;
      }
    | undefined;
  sales?:
    | {
        __typename?: "MLSListingSalesObject";
        closeDate?: string | undefined;
        closePrice?: number | undefined;
        contractDate?: string | undefined;
      }
    | undefined;
  geo: {
    __typename?: "MLSListingGeoObject";
    location: { __typename?: "GeoPointObject"; lat: number; lon: number };
  };
};

export type OpenHouseCardFragment = {
  __typename?: "OpenHouseObject";
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  numGuestbookSigners: number;
  source: OpenHouseSource;
};

export type PublicOpenHouseFragment = {
  __typename?: "PublicOpenHouseObject";
  id: string;
  date: string;
  startTime: string;
  endTime: string;
};

export type PublicListingFragment = {
  __typename?: "PublicListingObject";
  id: string;
  offersCountDisplay: string;
  listDate?: any | undefined;
  followerCount?: number | undefined;
  guestbookSignersCount: number;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: {
    __typename?: "PublicPropertyObject";
    id: string;
    slug: string;
    state: UsState;
    otherLegalDescription: string;
    county: string;
  };
  currentAndUpcomingOpenHouses?:
    | Array<{
        __typename?: "PublicOpenHouseObject";
        id: string;
        date: string;
        startTime: string;
        endTime: string;
      }>
    | undefined;
  listingAgent?:
    | {
        __typename?: "PublicAgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "PublicUserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              phoneNumber: string;
              email?: string | undefined;
              userName?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  coListingAgent?:
    | {
        __typename?: "PublicAgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "PublicUserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              phoneNumber: string;
              email?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
  listingPreferences: Array<{
    __typename?: "PublicPreferenceValueObject";
    numberValue?: number | undefined;
    textValue?: string | undefined;
    stringValue?: string | undefined;
    stringArray?: Array<string> | undefined;
    booleanValue?: boolean | undefined;
    dateTimeValue?: any | undefined;
    readOnly?: boolean | undefined;
    preference: {
      __typename?: "PublicPreferenceObject";
      id: string;
      name: string;
      slug: string;
      usStates: Array<UsState>;
      valueType: PreferenceValueType;
    };
  }>;
  priceHistories?:
    | Array<{
        __typename?: "ListingPriceHistoryObject";
        listDate: string;
        mlsStatus: string;
        listPrice: number;
        closePrice: number;
        closeDate: string;
        modified: string;
      }>
    | undefined;
  setupDetails: {
    __typename?: "StorefrontConfigurationStatusObject";
    hasSetup?: boolean | undefined;
    configuredCount: number;
    progressTotal: number;
    sellerPreferences: boolean;
    comparables: boolean;
    documents: boolean;
  };
};

export type PublicListingPriceHistoryFragment = {
  __typename?: "ListingPriceHistoryObject";
  listDate: string;
  mlsStatus: string;
  listPrice: number;
  closePrice: number;
  closeDate: string;
  modified: string;
};

export type PublicListingStatusFragment = {
  __typename?: "PublicListingObject";
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
};

export type PublicListingAnnouncementFragment = {
  __typename?: "PublicListingAnnouncementObject";
  id: string;
  message: string;
  createdAt: any;
};

export type PublicListingComparableFragment = {
  __typename?: "PublicListingComparableObject";
  id: string;
  source: ListingComparableSetSource;
  order: number;
  mlsListing: {
    __typename?: "MLSListingObject";
    id: string;
    mlsId?: number | undefined;
    listingId?: string | undefined;
    listDate?: string | undefined;
    listPrice?: number | undefined;
    originalListPrice?: number | undefined;
    terms?: string | undefined;
    photos: Array<string>;
    remarks?: string | undefined;
    modified?: string | undefined;
    mlsName?: string | undefined;
    deleted_at?: string | undefined;
    addressFull: string;
    agent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    coAgent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    address: {
      __typename?: "MLSListingAddressObject";
      city: string;
      country?: string | undefined;
      crossStreet?: string | undefined;
      full: string;
      postalCode?: string | undefined;
      state: string;
      streetName: string;
      streetNumber?: number | undefined;
      streetNumberText: string;
      unit?: string | undefined;
    };
    property?:
      | {
          __typename?: "MLSListingPropertyObject";
          roof?: string | undefined;
          cooling?: string | undefined;
          style?: string | undefined;
          area?: number | undefined;
          bathsFull?: number | undefined;
          bathsHalf?: number | undefined;
          stories?: number | undefined;
          fireplaces?: number | undefined;
          flooring?: string | undefined;
          heating?: string | undefined;
          bathrooms?: string | undefined;
          foundation?: string | undefined;
          poolFeatures?: string | undefined;
          laundryFeatures?: string | undefined;
          occupantName?: string | undefined;
          ownerName?: string | undefined;
          lotDescription?: string | undefined;
          acres?: number | undefined;
          subType?: string | undefined;
          bedrooms?: number | undefined;
          interiorFeatures?: string | undefined;
          lotSize?: string | undefined;
          areaSource?: string | undefined;
          maintenanceExpense?: number | undefined;
          additionalRooms?: string | undefined;
          exteriorFeatures?: string | undefined;
          water?: string | undefined;
          view?: string | undefined;
          lotSizeArea?: number | undefined;
          lotSizeAreaUnits?: string | undefined;
          subdivision?: string | undefined;
          construction?: string | undefined;
          type?: MlsListingType | undefined;
          garageSpaces?: number | undefined;
          bathsThreeQuarter?: number | undefined;
          accessibility?: string | undefined;
          occupantType?: string | undefined;
          yearBuilt?: number | undefined;
          subTypeText?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "MLSListingOfficeObject";
          brokerid?: string | undefined;
          name?: string | undefined;
          servingName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSListingMLSObject";
          statusText: string;
          status?: MlsListingStatus | undefined;
          daysOnMarket?: number | undefined;
          originalEntryTimestamp?: string | undefined;
          originatingSystemName?: string | undefined;
          logoUrl?: string | undefined;
          disclaimer?: string | undefined;
        }
      | undefined;
    association?:
      | {
          __typename?: "MLSListingAssociationObject";
          fee?: number | undefined;
          frequency?: string | undefined;
          name?: string | undefined;
          amenities?: string | undefined;
        }
      | undefined;
    compliance?:
      | {
          __typename?: "MLSListingComplianceObject";
          buyerAgencyCompensation?: number | undefined;
          buyerAgencyCompensationType?: string | undefined;
          subAgencyCompensation?: number | undefined;
          subAgencyCompensationType?: string | undefined;
          attributionContact?: string | undefined;
        }
      | undefined;
    sales?:
      | {
          __typename?: "MLSListingSalesObject";
          closeDate?: string | undefined;
          closePrice?: number | undefined;
          contractDate?: string | undefined;
        }
      | undefined;
    geo: {
      __typename?: "MLSListingGeoObject";
      location: { __typename?: "GeoPointObject"; lat: number; lon: number };
    };
  };
};

export type PublicListingComparableSetFragment = {
  __typename?: "PublicListingComparableSetObject";
  agentNotes?: string | undefined;
  listingComparables: Array<{
    __typename?: "PublicListingComparableObject";
    id: string;
    source: ListingComparableSetSource;
    order: number;
    mlsListing: {
      __typename?: "MLSListingObject";
      id: string;
      mlsId?: number | undefined;
      listingId?: string | undefined;
      listDate?: string | undefined;
      listPrice?: number | undefined;
      originalListPrice?: number | undefined;
      terms?: string | undefined;
      photos: Array<string>;
      remarks?: string | undefined;
      modified?: string | undefined;
      mlsName?: string | undefined;
      deleted_at?: string | undefined;
      addressFull: string;
      agent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      coAgent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      address: {
        __typename?: "MLSListingAddressObject";
        city: string;
        country?: string | undefined;
        crossStreet?: string | undefined;
        full: string;
        postalCode?: string | undefined;
        state: string;
        streetName: string;
        streetNumber?: number | undefined;
        streetNumberText: string;
        unit?: string | undefined;
      };
      property?:
        | {
            __typename?: "MLSListingPropertyObject";
            roof?: string | undefined;
            cooling?: string | undefined;
            style?: string | undefined;
            area?: number | undefined;
            bathsFull?: number | undefined;
            bathsHalf?: number | undefined;
            stories?: number | undefined;
            fireplaces?: number | undefined;
            flooring?: string | undefined;
            heating?: string | undefined;
            bathrooms?: string | undefined;
            foundation?: string | undefined;
            poolFeatures?: string | undefined;
            laundryFeatures?: string | undefined;
            occupantName?: string | undefined;
            ownerName?: string | undefined;
            lotDescription?: string | undefined;
            acres?: number | undefined;
            subType?: string | undefined;
            bedrooms?: number | undefined;
            interiorFeatures?: string | undefined;
            lotSize?: string | undefined;
            areaSource?: string | undefined;
            maintenanceExpense?: number | undefined;
            additionalRooms?: string | undefined;
            exteriorFeatures?: string | undefined;
            water?: string | undefined;
            view?: string | undefined;
            lotSizeArea?: number | undefined;
            lotSizeAreaUnits?: string | undefined;
            subdivision?: string | undefined;
            construction?: string | undefined;
            type?: MlsListingType | undefined;
            garageSpaces?: number | undefined;
            bathsThreeQuarter?: number | undefined;
            accessibility?: string | undefined;
            occupantType?: string | undefined;
            yearBuilt?: number | undefined;
            subTypeText?: string | undefined;
          }
        | undefined;
      office?:
        | {
            __typename?: "MLSListingOfficeObject";
            brokerid?: string | undefined;
            name?: string | undefined;
            servingName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      mls?:
        | {
            __typename?: "MLSListingMLSObject";
            statusText: string;
            status?: MlsListingStatus | undefined;
            daysOnMarket?: number | undefined;
            originalEntryTimestamp?: string | undefined;
            originatingSystemName?: string | undefined;
            logoUrl?: string | undefined;
            disclaimer?: string | undefined;
          }
        | undefined;
      association?:
        | {
            __typename?: "MLSListingAssociationObject";
            fee?: number | undefined;
            frequency?: string | undefined;
            name?: string | undefined;
            amenities?: string | undefined;
          }
        | undefined;
      compliance?:
        | {
            __typename?: "MLSListingComplianceObject";
            buyerAgencyCompensation?: number | undefined;
            buyerAgencyCompensationType?: string | undefined;
            subAgencyCompensation?: number | undefined;
            subAgencyCompensationType?: string | undefined;
            attributionContact?: string | undefined;
          }
        | undefined;
      sales?:
        | {
            __typename?: "MLSListingSalesObject";
            closeDate?: string | undefined;
            closePrice?: number | undefined;
            contractDate?: string | undefined;
          }
        | undefined;
      geo: {
        __typename?: "MLSListingGeoObject";
        location: { __typename?: "GeoPointObject"; lat: number; lon: number };
      };
    };
  }>;
  agent: { __typename?: "PublicAgentObject"; id: string };
  listing: { __typename?: "PublicListingObject"; id: string };
};

export type PublicListingDocumentUploadFragment = {
  __typename?: "PublicListingDocumentUploadObject";
  id: string;
  customDocumentName?: string | undefined;
  customDocumentType?: ListingDocumentTypeEnum | undefined;
  listingDocumentType?:
    | {
        __typename?: "PublicListingDocumentTypeObject";
        id: string;
        slug: string;
        usState: UsState;
        name: string;
        formName: string;
        type: ListingDocumentTypeEnum;
      }
    | undefined;
  file?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
};

export type PublicListingDocumentTypeFragment = {
  __typename?: "PublicListingDocumentTypeObject";
  id: string;
  slug: string;
  usState: UsState;
  name: string;
  formName: string;
  type: ListingDocumentTypeEnum;
};

export type PublicListingDocumentTypeWithDocumentsFragment = {
  __typename?: "PublicListingDocumentTypeObject";
  id: string;
  document?:
    | {
        __typename?: "PublicDocumentObject";
        id: string;
        form: string;
        name: string;
        description: string;
        activeDocumentVersion?:
          | {
              __typename?: "PublicDocumentVersionObject";
              id: string;
              mappingKeys: Array<string>;
              previewImages: Array<{
                __typename?: "AssetFileObject";
                id: string;
                ordering: number;
                file: { __typename?: "FileObject"; url: string };
              }>;
            }
          | undefined;
      }
    | undefined;
};

export type PublicPreferenceValueFragment = {
  __typename?: "PublicPreferenceValueObject";
  numberValue?: number | undefined;
  textValue?: string | undefined;
  stringValue?: string | undefined;
  stringArray?: Array<string> | undefined;
  booleanValue?: boolean | undefined;
  dateTimeValue?: any | undefined;
  readOnly?: boolean | undefined;
  preference: {
    __typename?: "PublicPreferenceObject";
    id: string;
    name: string;
    slug: string;
    usStates: Array<UsState>;
    valueType: PreferenceValueType;
  };
};

export type PublicPreferenceFragment = {
  __typename?: "PublicPreferenceObject";
  id: string;
  name: string;
  slug: string;
  usStates: Array<UsState>;
  valueType: PreferenceValueType;
};

export type PublicStorefrontConfigurationStatusObjectFragment = {
  __typename?: "StorefrontConfigurationStatusObject";
  hasSetup?: boolean | undefined;
  configuredCount: number;
  progressTotal: number;
  sellerPreferences: boolean;
  comparables: boolean;
  documents: boolean;
};

export type PublicUserFragment = {
  __typename?: "PublicUserObject";
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  userName?: string | undefined;
  phoneNumber: string;
  email?: string | undefined;
  offerCollectionEmail?: string | undefined;
  profilePicture?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
};

export type PublicUserListingFragment = {
  __typename?: "PublicListingObject";
  id: string;
  listDate?: any | undefined;
  offersCountDisplay: string;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: { __typename?: "PublicPropertyObject"; id: string; slug: string };
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
};

export type PublicUserWithLicensesFragment = {
  __typename?: "PublicUserWithLicensesObject";
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  phoneNumber: string;
  email?: string | undefined;
  profileBio?: string | undefined;
  hasListings?: boolean | undefined;
  profilePicture?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
  licenses?:
    | Array<{
        __typename?: "UserLicenseObject";
        id: string;
        licenseType: LicenseType;
        licenseNumber: string;
        mls?:
          | {
              __typename?: "MLSObject";
              id: string;
              name: string;
              originatingSystemName?: string | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export type UpdateOfferWithPartyMutationVariables = Exact<{
  input: UpdateOfferWithPartyInput;
}>;

export type UpdateOfferWithPartyMutation = {
  __typename?: "Mutation";
  updateOfferWithParty?:
    | {
        __typename?: "UpdateOfferPayload";
        offer?: { __typename?: "OfferObject"; id: string } | undefined;
      }
    | undefined;
};

export type AcceptAccessControlInviteMutationVariables = Exact<{
  input: AcceptAccessControlInviteInput;
}>;

export type AcceptAccessControlInviteMutation = {
  __typename?: "Mutation";
  acceptAccessControlInvite: {
    __typename?: "AcceptInvitationForAccessControlPayload";
    targetId?: string | undefined;
    targetEntityName?: string | undefined;
    user?:
      | {
          __typename?: "UserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          roles: Array<Roles>;
          email?: string | undefined;
          profileBio?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
          settings?:
            | {
                __typename?: "UserSettingsObject";
                id: string;
                selectedOrganization?:
                  | {
                      __typename?: "OrganizationObject";
                      id: string;
                      name: string;
                      hasDescendants?: boolean | undefined;
                      contractSystemCredentials?:
                        | Array<{
                            __typename?: "ContractSystemCredentialsObject";
                            id: string;
                            hasInvalidCredentials?: boolean | undefined;
                            isReady: boolean;
                            type?: ContractSystemType | undefined;
                            username?: string | undefined;
                            dotloopProfileId?: string | undefined;
                            dotloopTeamName?: string | undefined;
                          }>
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type AccessControlInviteMutationVariables = Exact<{
  input: AccessControlInviteInput;
}>;

export type AccessControlInviteMutation = {
  __typename?: "Mutation";
  accessControlInvite: {
    __typename?: "AccessControlInvitePayload";
    invitation?: { __typename?: "InvitationObject"; id: string } | undefined;
  };
};

export type CalculateOfferScoreMutationVariables = Exact<{
  buyerOfferAnalysisId: Scalars["String"]["input"];
}>;

export type CalculateOfferScoreMutation = {
  __typename?: "Mutation";
  calculateOfferScore: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
    agentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
        }
      | undefined;
    offerScore?:
      | {
          __typename?: "OfferScore";
          reason: string;
          value: number;
          offerScoreExplanation?: string | undefined;
        }
      | { __typename?: "OfferScoreNotCalculated"; reason: string }
      | undefined;
    prevAgentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
        }
      | undefined;
  };
};

export type CapturePropertyDetailsMutationVariables = Exact<{
  input: CapturePropertyDetailsInput;
}>;

export type CapturePropertyDetailsMutation = {
  __typename?: "Mutation";
  capturePropertyDetails: {
    __typename?: "CapturePropertyDetailsPayload";
    success: boolean;
    propertyDetails?:
      | {
          __typename?: "PropertyDetailsObject";
          id: string;
          streetAddress: string;
          city: string;
          state: UsState;
          zipCode: string;
          unit?: string | undefined;
          targetPrice: number;
          areaSqFt: number;
          yearBuilt: number;
          bedrooms: number;
          bathsFull: number;
          bathsHalf?: number | undefined;
          propertyType: MlsListingType;
          propertySubtype: MlsListingSubType;
          subdivision?: string | undefined;
          schoolDistrict?: string | undefined;
          geo: { __typename?: "GeoObject"; lat: number; lng: number };
        }
      | undefined;
  };
};

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;

export type CreateContactMutation = {
  __typename?: "Mutation";
  createContact: {
    __typename?: "ContactObject";
    id: string;
    firstName: string;
    lastName: string;
    contactType: ContactType;
    email: string;
    phoneNumber?: string | undefined;
  };
};

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;

export type UpdateContactMutation = {
  __typename?: "Mutation";
  updateContact: {
    __typename?: "ContactObject";
    id: string;
    firstName: string;
    lastName: string;
    contactType: ContactType;
    email: string;
    phoneNumber?: string | undefined;
  };
};

export type CreateAiConversationMutationVariables = Exact<{
  input: CreateAiConversationInput;
}>;

export type CreateAiConversationMutation = {
  __typename?: "Mutation";
  createAIConversation: {
    __typename?: "AIConversationObject";
    id: string;
    title: string;
    lastAIMessage?: string | undefined;
    conversationType: AiConversationType;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | undefined;
  };
};

export type CreateBuyerOfferAnalysisMutationVariables = Exact<{
  input: CreateBuyerOfferAnalysisInput;
}>;

export type CreateBuyerOfferAnalysisMutation = {
  __typename?: "Mutation";
  createBuyerOfferAnalysis: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
  };
};

export type CreateBuyerOfferAnalysisForUserMutationVariables = Exact<{
  input: CreateBuyerOfferAnalysisForUserInput;
}>;

export type CreateBuyerOfferAnalysisForUserMutation = {
  __typename?: "Mutation";
  createBuyerOfferAnalysisForUser: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
  };
};

export type CreateEmbeddedSignatureRequestMutationVariables = Exact<{
  input: CreateEmbeddedSignatureRequestInput;
}>;

export type CreateEmbeddedSignatureRequestMutation = {
  __typename?: "Mutation";
  createEmbeddedSignatureRequest?:
    | {
        __typename?: "EmbeddedSignatureRequestPayload";
        embeddedSignUrl: string;
      }
    | undefined;
};

export type CreateEventForOfferMutationVariables = Exact<{
  input: CreateEventForOfferInput;
}>;

export type CreateEventForOfferMutation = {
  __typename?: "Mutation";
  createEventForOffer: {
    __typename?: "AppEventObject";
    id: string;
    name: string;
    doneBy?: { __typename?: "UserObject"; id: string } | undefined;
    offer?: { __typename?: "OfferObject"; id: string } | undefined;
  };
};

export type CreateIndigoContractMutationVariables = Exact<{
  input: CreateIndigoContractInput;
}>;

export type CreateIndigoContractMutation = {
  __typename?: "Mutation";
  createIndigoContract?:
    | { __typename?: "IndigoContractObject"; id: string }
    | undefined;
};

export type CreateNotificationTemplateMutationVariables = Exact<{
  input: CreateNotificationTemplateInput;
}>;

export type CreateNotificationTemplateMutation = {
  __typename?: "Mutation";
  createNotificationTemplate: {
    __typename?: "NotificationTemplateObject";
    id: string;
    title: string;
    eventType: TransactionStageType;
    side?: TransactionSide | undefined;
    notificationType: NotificationType;
    recipients: Array<ContactType>;
    hasAssignedPartner?: boolean | undefined;
    isAttachedToPartner?: boolean | undefined;
    delayMinutes: number;
    dataToShare: Array<string>;
    messageContent: string;
    status: NotificationTemplateStatus;
    orderIndex: number;
    messageContentTemplates: {
      __typename?: "NotificationTemplateMessageContentTemplates";
      html: string;
      text: string;
    };
  };
};

export type CreateOfferMutationVariables = Exact<{
  input: CreateOfferInput;
  isAgentVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type CreateOfferMutation = {
  __typename?: "Mutation";
  createOfferForBuyersAgent?:
    | {
        __typename?: "CreateOfferPayload";
        offer: { __typename?: "OfferObject"; id: string; contractId: string };
      }
    | undefined;
  createOfferForUnauthenticatedBuyersAgent?:
    | {
        __typename?: "CreateOfferPayload";
        offer: { __typename?: "OfferObject"; id: string; contractId: string };
      }
    | undefined;
};

export type CreateOrUpdateIngestionDocumentReviewMutationVariables = Exact<{
  input: ExternalCreateOrUpdateIngestionDocumentReviewInput;
}>;

export type CreateOrUpdateIngestionDocumentReviewMutation = {
  __typename?: "Mutation";
  externalCreateOrUpdateIngestionDocumentReview: {
    __typename?: "IngestionDocumentReviewObject";
    id: string;
    createdAt: any;
    updatedAt: any;
    status: IngestionDocumentReviewStatus;
    version: string;
    reviewedAt: any;
    reviewedByUserUuid: string;
    reason?: string | undefined;
    ingestionDocument: {
      __typename?: "IngestionDocumentObject";
      id: string;
      documentId: string;
      documentName: string;
      version: string;
    };
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
  };
};

export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutationVariables =
  Exact<{
    input: ExternalCreateOrUpdateIngestionDocumentValidationErrorReviewInput;
  }>;

export type CreateOrUpdateIngestionDocumentValidationErrorReviewMutation = {
  __typename?: "Mutation";
  externalCreateOrUpdateIngestionDocumentValidationErrorReview: {
    __typename?: "IngestionDocumentValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    contractDocumentUuid?: string | undefined;
    ruleUuid?: string | undefined;
    pageNumber?: number | undefined;
    ingestionDocument?:
      | {
          __typename?: "IngestionDocumentObject";
          id: string;
          documentId: string;
          documentName: string;
        }
      | undefined;
    ingestionDocumentValidation?:
      | {
          __typename?: "IngestionDocumentValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  };
};

export type CreateOrUpdateIngestionFolderValidationErrorReviewMutationVariables =
  Exact<{
    input: ExternalCreateOrUpdateIngestionFolderValidationErrorReviewInput;
  }>;

export type CreateOrUpdateIngestionFolderValidationErrorReviewMutation = {
  __typename?: "Mutation";
  externalCreateOrUpdateIngestionFolderValidationErrorReview: {
    __typename?: "IngestionFolderValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    documentCategory?: string | undefined;
    documentForm?: string | undefined;
    documentName?: string | undefined;
    ruleUuid?: string | undefined;
    ingestionFolderValidation?:
      | {
          __typename?: "IngestionFolderValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  };
};

export type CreateOrUpdateListingAnnouncementMutationVariables = Exact<{
  input: CreateOrUpdateListingAnnouncementInput;
}>;

export type CreateOrUpdateListingAnnouncementMutation = {
  __typename?: "Mutation";
  createOrUpdateListingAnnouncement?:
    | {
        __typename?: "ListingAnnouncementObject";
        id: string;
        message: string;
        type: ListingAnnouncementType;
        bestAndFinalDate?: any | undefined;
        createdAt: any;
      }
    | undefined;
};

export type CreateOrUpdateListingComparableAdjustmentMutationVariables = Exact<{
  input: CreateOrUpdateListingComparableAdjustmentInput;
}>;

export type CreateOrUpdateListingComparableAdjustmentMutation = {
  __typename?: "Mutation";
  createOrUpdateListingComparableAdjustment: {
    __typename?: "ListingComparableObject";
    id: string;
    source: ListingComparableSetSource;
    order: number;
    mlsListing: {
      __typename?: "MLSListingObject";
      id: string;
      mlsId?: number | undefined;
      listingId?: string | undefined;
      listDate?: string | undefined;
      listPrice?: number | undefined;
      originalListPrice?: number | undefined;
      terms?: string | undefined;
      photos: Array<string>;
      remarks?: string | undefined;
      modified?: string | undefined;
      mlsName?: string | undefined;
      deleted_at?: string | undefined;
      addressFull: string;
      agent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      coAgent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      address: {
        __typename?: "MLSListingAddressObject";
        city: string;
        country?: string | undefined;
        crossStreet?: string | undefined;
        full: string;
        postalCode?: string | undefined;
        state: string;
        streetName: string;
        streetNumber?: number | undefined;
        streetNumberText: string;
        unit?: string | undefined;
      };
      property?:
        | {
            __typename?: "MLSListingPropertyObject";
            roof?: string | undefined;
            cooling?: string | undefined;
            style?: string | undefined;
            area?: number | undefined;
            bathsFull?: number | undefined;
            bathsHalf?: number | undefined;
            stories?: number | undefined;
            fireplaces?: number | undefined;
            flooring?: string | undefined;
            heating?: string | undefined;
            bathrooms?: string | undefined;
            foundation?: string | undefined;
            poolFeatures?: string | undefined;
            laundryFeatures?: string | undefined;
            occupantName?: string | undefined;
            ownerName?: string | undefined;
            lotDescription?: string | undefined;
            acres?: number | undefined;
            subType?: string | undefined;
            bedrooms?: number | undefined;
            interiorFeatures?: string | undefined;
            lotSize?: string | undefined;
            areaSource?: string | undefined;
            maintenanceExpense?: number | undefined;
            additionalRooms?: string | undefined;
            exteriorFeatures?: string | undefined;
            water?: string | undefined;
            view?: string | undefined;
            lotSizeArea?: number | undefined;
            lotSizeAreaUnits?: string | undefined;
            subdivision?: string | undefined;
            construction?: string | undefined;
            type?: MlsListingType | undefined;
            garageSpaces?: number | undefined;
            bathsThreeQuarter?: number | undefined;
            accessibility?: string | undefined;
            occupantType?: string | undefined;
            yearBuilt?: number | undefined;
            subTypeText?: string | undefined;
          }
        | undefined;
      office?:
        | {
            __typename?: "MLSListingOfficeObject";
            brokerid?: string | undefined;
            name?: string | undefined;
            servingName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      mls?:
        | {
            __typename?: "MLSListingMLSObject";
            statusText: string;
            status?: MlsListingStatus | undefined;
            daysOnMarket?: number | undefined;
            originalEntryTimestamp?: string | undefined;
            originatingSystemName?: string | undefined;
            logoUrl?: string | undefined;
            disclaimer?: string | undefined;
          }
        | undefined;
      association?:
        | {
            __typename?: "MLSListingAssociationObject";
            fee?: number | undefined;
            frequency?: string | undefined;
            name?: string | undefined;
            amenities?: string | undefined;
          }
        | undefined;
      compliance?:
        | {
            __typename?: "MLSListingComplianceObject";
            buyerAgencyCompensation?: number | undefined;
            buyerAgencyCompensationType?: string | undefined;
            subAgencyCompensation?: number | undefined;
            subAgencyCompensationType?: string | undefined;
            attributionContact?: string | undefined;
          }
        | undefined;
      sales?:
        | {
            __typename?: "MLSListingSalesObject";
            closeDate?: string | undefined;
            closePrice?: number | undefined;
            contractDate?: string | undefined;
          }
        | undefined;
      geo: {
        __typename?: "MLSListingGeoObject";
        location: { __typename?: "GeoPointObject"; lat: number; lon: number };
      };
    };
    adjustments?:
      | {
          __typename?: "ListingComparableAdjustmentsObject";
          id: string;
          priceAdjustmentsPerFields?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          totalAdjustmentPrice?: number | undefined;
          notes?: string | undefined;
        }
      | undefined;
  };
};

export type CreateOrUpdateListingComparableAdjustmentV2MutationVariables =
  Exact<{
    input: CreateOrUpdateListingComparableAdjustmentInputV2;
  }>;

export type CreateOrUpdateListingComparableAdjustmentV2Mutation = {
  __typename?: "Mutation";
  createOrUpdateListingComparableAdjustmentV2: {
    __typename?: "ListingComparableObject";
    id: string;
    source: ListingComparableSetSource;
    order: number;
    mlsListing: {
      __typename?: "MLSListingObject";
      id: string;
      mlsId?: number | undefined;
      listingId?: string | undefined;
      listDate?: string | undefined;
      listPrice?: number | undefined;
      originalListPrice?: number | undefined;
      terms?: string | undefined;
      photos: Array<string>;
      remarks?: string | undefined;
      modified?: string | undefined;
      mlsName?: string | undefined;
      deleted_at?: string | undefined;
      addressFull: string;
      agent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      coAgent?:
        | {
            __typename?: "MLSListingAgentObject";
            id?: string | undefined;
            mlsId?: string | undefined;
            firstName?: string | undefined;
            lastName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      address: {
        __typename?: "MLSListingAddressObject";
        city: string;
        country?: string | undefined;
        crossStreet?: string | undefined;
        full: string;
        postalCode?: string | undefined;
        state: string;
        streetName: string;
        streetNumber?: number | undefined;
        streetNumberText: string;
        unit?: string | undefined;
      };
      property?:
        | {
            __typename?: "MLSListingPropertyObject";
            roof?: string | undefined;
            cooling?: string | undefined;
            style?: string | undefined;
            area?: number | undefined;
            bathsFull?: number | undefined;
            bathsHalf?: number | undefined;
            stories?: number | undefined;
            fireplaces?: number | undefined;
            flooring?: string | undefined;
            heating?: string | undefined;
            bathrooms?: string | undefined;
            foundation?: string | undefined;
            poolFeatures?: string | undefined;
            laundryFeatures?: string | undefined;
            occupantName?: string | undefined;
            ownerName?: string | undefined;
            lotDescription?: string | undefined;
            acres?: number | undefined;
            subType?: string | undefined;
            bedrooms?: number | undefined;
            interiorFeatures?: string | undefined;
            lotSize?: string | undefined;
            areaSource?: string | undefined;
            maintenanceExpense?: number | undefined;
            additionalRooms?: string | undefined;
            exteriorFeatures?: string | undefined;
            water?: string | undefined;
            view?: string | undefined;
            lotSizeArea?: number | undefined;
            lotSizeAreaUnits?: string | undefined;
            subdivision?: string | undefined;
            construction?: string | undefined;
            type?: MlsListingType | undefined;
            garageSpaces?: number | undefined;
            bathsThreeQuarter?: number | undefined;
            accessibility?: string | undefined;
            occupantType?: string | undefined;
            yearBuilt?: number | undefined;
            subTypeText?: string | undefined;
          }
        | undefined;
      office?:
        | {
            __typename?: "MLSListingOfficeObject";
            brokerid?: string | undefined;
            name?: string | undefined;
            servingName?: string | undefined;
            contact?:
              | {
                  __typename?: "MLSListingContactObject";
                  email?: string | undefined;
                  office?: string | undefined;
                  cell?: string | undefined;
                }
              | undefined;
          }
        | undefined;
      mls?:
        | {
            __typename?: "MLSListingMLSObject";
            statusText: string;
            status?: MlsListingStatus | undefined;
            daysOnMarket?: number | undefined;
            originalEntryTimestamp?: string | undefined;
            originatingSystemName?: string | undefined;
            logoUrl?: string | undefined;
            disclaimer?: string | undefined;
          }
        | undefined;
      association?:
        | {
            __typename?: "MLSListingAssociationObject";
            fee?: number | undefined;
            frequency?: string | undefined;
            name?: string | undefined;
            amenities?: string | undefined;
          }
        | undefined;
      compliance?:
        | {
            __typename?: "MLSListingComplianceObject";
            buyerAgencyCompensation?: number | undefined;
            buyerAgencyCompensationType?: string | undefined;
            subAgencyCompensation?: number | undefined;
            subAgencyCompensationType?: string | undefined;
            attributionContact?: string | undefined;
          }
        | undefined;
      sales?:
        | {
            __typename?: "MLSListingSalesObject";
            closeDate?: string | undefined;
            closePrice?: number | undefined;
            contractDate?: string | undefined;
          }
        | undefined;
      geo: {
        __typename?: "MLSListingGeoObject";
        location: { __typename?: "GeoPointObject"; lat: number; lon: number };
      };
    };
    adjustments?:
      | {
          __typename?: "ListingComparableAdjustmentsObject";
          id: string;
          priceAdjustmentsPerFields?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          totalAdjustmentPrice?: number | undefined;
          notes?: string | undefined;
        }
      | undefined;
  };
};

export type CreateOrganizationForAgentMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationForAgentMutation = {
  __typename?: "Mutation";
  createOrganizationForAgent: {
    __typename?: "CreateOrganizationForAgentPayload";
    organization: {
      __typename?: "OrganizationObject";
      id: string;
      name: string;
    };
    user: {
      __typename?: "UserObject";
      id: string;
      settings?:
        | {
            __typename?: "UserSettingsObject";
            selectedOrganization?:
              | { __typename?: "OrganizationObject"; id: string; name: string }
              | undefined;
          }
        | undefined;
    };
  };
};

export type CreateOrganizationForTeamLeadMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;

export type CreateOrganizationForTeamLeadMutation = {
  __typename?: "Mutation";
  createOrganizationForTeamLead: {
    __typename?: "CreateOrganizationForTeamLeadPayload";
    organization: {
      __typename?: "OrganizationObject";
      id: string;
      name: string;
    };
    user: {
      __typename?: "UserObject";
      id: string;
      settings?:
        | {
            __typename?: "UserSettingsObject";
            selectedOrganization?:
              | { __typename?: "OrganizationObject"; id: string; name: string }
              | undefined;
          }
        | undefined;
    };
  };
};

export type CreatePartyForBuyersAgentMutationVariables = Exact<{
  input: CreatePartyForBuyersAgentInput;
}>;

export type CreatePartyForBuyersAgentMutation = {
  __typename?: "Mutation";
  createPartyForBuyersAgent: { __typename?: "PartyObject"; id: string };
};

export type CreateUserTourMutationVariables = Exact<{
  tourNames: Array<TourType> | TourType;
}>;

export type CreateUserTourMutation = {
  __typename?: "Mutation";
  createUserTour: Array<{
    __typename?: "UserTourObject";
    id: string;
    tourName: TourType;
  }>;
};

export type DeleteAiConversationMutationVariables = Exact<{
  input: DeleteAiConversationInput;
}>;

export type DeleteAiConversationMutation = {
  __typename?: "Mutation";
  deleteAIConversation: boolean;
};

export type DeleteAccessControlMutationVariables = Exact<{
  input: DeleteAccessControlInput;
}>;

export type DeleteAccessControlMutation = {
  __typename?: "Mutation";
  deleteAccessControl: {
    __typename?: "DeleteAccessControlPayload";
    deleted?: boolean | undefined;
  };
};

export type DeleteContractSystemCredentialsMutationVariables = Exact<{
  input: DeleteContractSystemCredentialsInput;
}>;

export type DeleteContractSystemCredentialsMutation = {
  __typename?: "Mutation";
  deleteContractSystemCredentials: boolean;
};

export type DeleteIngestionDocumentValidationErrorReviewMutationVariables =
  Exact<{
    input: ExternalDeleteIngestionDocumentValidationErrorReviewInput;
  }>;

export type DeleteIngestionDocumentValidationErrorReviewMutation = {
  __typename?: "Mutation";
  externalDeleteIngestionDocumentValidationErrorReview: boolean;
};

export type DeleteIngestionFolderValidationErrorReviewMutationVariables =
  Exact<{
    input: ExternalDeleteIngestionFolderValidationErrorReviewInput;
  }>;

export type DeleteIngestionFolderValidationErrorReviewMutation = {
  __typename?: "Mutation";
  externalDeleteIngestionFolderValidationErrorReview: boolean;
};

export type DeleteIntegrationConnectionMutationVariables = Exact<{
  input: DeleteIntegrationConnectionInput;
}>;

export type DeleteIntegrationConnectionMutation = {
  __typename?: "Mutation";
  deleteIntegrationConnection: {
    __typename?: "DeleteIntegrationConnectionPayload";
    deleted?: boolean | undefined;
  };
};

export type DeleteListingDocumentsMutationVariables = Exact<{
  input: DeleteListingDocumentsInput;
}>;

export type DeleteListingDocumentsMutation = {
  __typename?: "Mutation";
  deleteListingDocuments?:
    | { __typename?: "ListingObject"; id: string }
    | undefined;
};

export type DeleteNotificationTemplateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteNotificationTemplateMutation = {
  __typename?: "Mutation";
  deleteNotificationTemplate: boolean;
};

export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables =
  Exact<{
    input: ExternalCreateIngestionDocumentValidationFeedbackInput;
  }>;

export type ExternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation =
  {
    __typename?: "Mutation";
    externalCreateOrUpdateIngestionDocumentValidationFeedback: {
      __typename?: "IngestionDocumentValidationFeedbackObject";
      id: string;
      feedbackType: FeedbackType;
      source: FeedbackSource;
      comment?: string | undefined;
      createdByUserUuid: string;
      updatedByUserUuid: string;
      createdAt: any;
      updatedAt: any;
      ruleUuid?: string | undefined;
      contractDocumentUuid?: string | undefined;
      ingestionDocumentValidation?:
        | { __typename?: "IngestionDocumentValidationObject"; id: string }
        | undefined;
    };
  };

export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables =
  Exact<{
    input: ExternalCreateIngestionFolderValidationFeedbackInput;
  }>;

export type ExternalCreateOrUpdateIngestionFolderValidationFeedbackMutation = {
  __typename?: "Mutation";
  externalCreateOrUpdateIngestionFolderValidationFeedback: {
    __typename?: "IngestionFolderValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ingestionFolderValidation?:
      | { __typename?: "IngestionFolderValidationObject"; id: string }
      | undefined;
  };
};

export type ExternalSubmitValidationReviewsMutationVariables = Exact<{
  input: ExternalSubmitValidationReviewsInput;
}>;

export type ExternalSubmitValidationReviewsMutation = {
  __typename?: "Mutation";
  externalSubmitValidationReviews: {
    __typename?: "ValidationReviewSubmissionObject";
    id: string;
    submittedByUserUuid: string;
    totalErrorCount?: number | undefined;
    hiddenErrorCount?: number | undefined;
    documentErrorCount?: number | undefined;
    folderErrorCount?: number | undefined;
    submittedAt: any;
  };
};

export type ExternalSyncKeyTermsMutationVariables = Exact<{
  input: ExternalSyncKeyTermsInput;
}>;

export type ExternalSyncKeyTermsMutation = {
  __typename?: "Mutation";
  externalSyncKeyTerms: {
    __typename?: "ExternalSyncKeyTermsPayload";
    success: boolean;
    externalEntityId?: string | undefined;
  };
};

export type FollowListingMutationVariables = Exact<{
  input: FollowListingInput;
}>;

export type FollowListingMutation = {
  __typename?: "Mutation";
  followListing: {
    __typename?: "IsFollowingListingObject";
    isFollowingListing: boolean;
  };
};

export type GenerateListingPackagePdfMutationVariables = Exact<{
  input: ListingInput;
}>;

export type GenerateListingPackagePdfMutation = {
  __typename?: "Mutation";
  generateListingPackagePdf: {
    __typename?: "FileObject";
    fileName: string;
    url: string;
  };
};

export type GetOrCreateAgentByPhoneNumberMutationVariables = Exact<{
  input: GetOrCreateAgentByPhoneNumberInput;
}>;

export type GetOrCreateAgentByPhoneNumberMutation = {
  __typename?: "Mutation";
  getOrCreateAgentByPhoneNumber?:
    | {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        phoneNumber: string;
        roles: Array<Roles>;
        email?: string | undefined;
        profileBio?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        settings?:
          | {
              __typename?: "UserSettingsObject";
              id: string;
              selectedOrganization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                    hasDescendants?: boolean | undefined;
                    contractSystemCredentials?:
                      | Array<{
                          __typename?: "ContractSystemCredentialsObject";
                          id: string;
                          hasInvalidCredentials?: boolean | undefined;
                          isReady: boolean;
                          type?: ContractSystemType | undefined;
                          username?: string | undefined;
                          dotloopProfileId?: string | undefined;
                          dotloopTeamName?: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type GetOrCreateConsumerByPhoneNumberMutationVariables = Exact<{
  input: CreateOrUpdateConsumerByPhoneNumberInput;
}>;

export type GetOrCreateConsumerByPhoneNumberMutation = {
  __typename?: "Mutation";
  getOrCreateConsumerByPhoneNumber?:
    | {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        phoneNumber: string;
        roles: Array<Roles>;
        email?: string | undefined;
        profileBio?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        settings?:
          | {
              __typename?: "UserSettingsObject";
              id: string;
              selectedOrganization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                    hasDescendants?: boolean | undefined;
                    contractSystemCredentials?:
                      | Array<{
                          __typename?: "ContractSystemCredentialsObject";
                          id: string;
                          hasInvalidCredentials?: boolean | undefined;
                          isReady: boolean;
                          type?: ContractSystemType | undefined;
                          username?: string | undefined;
                          dotloopProfileId?: string | undefined;
                          dotloopTeamName?: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type InternalBatchAddUsersToOrganizationMutationVariables = Exact<{
  input: InternalBatchAddUsersToOrganizationInput;
}>;

export type InternalBatchAddUsersToOrganizationMutation = {
  __typename?: "Mutation";
  internalBatchAddUsersToOrganization: {
    __typename?: "InternalBatchAddUsersResult";
    successCount: number;
    failureCount: number;
    results: Array<{
      __typename?: "InternalBatchAddUserResult";
      clientRowId: string;
      success: boolean;
      error?: string | undefined;
      user?:
        | {
            __typename?: "InternalOrgUserObject";
            id: string;
            userUuid: string;
            firstName?: string | undefined;
            lastName?: string | undefined;
            email?: string | undefined;
            phoneNumber?: string | undefined;
            accessRole: AccessRole;
          }
        | undefined;
    }>;
  };
};

export type InternalEssentialsNotificationActionExecuteMutationVariables =
  Exact<{
    input: InternalEssentialsNotificationActionExecuteInput;
  }>;

export type InternalEssentialsNotificationActionExecuteMutation = {
  __typename?: "Mutation";
  internalEssentialsNotificationActionExecute: {
    __typename?: "DebugActionExecuteResult";
    success: boolean;
    message?: string | undefined;
    postActionSummary?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
  };
};

export type InternalEssentialsNotificationActionPreviewMutationVariables =
  Exact<{
    input: InternalEssentialsNotificationActionPreviewInput;
  }>;

export type InternalEssentialsNotificationActionPreviewMutation = {
  __typename?: "Mutation";
  internalEssentialsNotificationActionPreview: {
    __typename?: "DebugActionPreviewResult";
    previewToken: string;
    actionKind: DebugActionKind;
    targetIds: Array<string>;
    currentState?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    proposedState?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    warnings: Array<string>;
  };
};

export type JoinOrganizationMutationVariables = Exact<{
  input: JoinOrganizationInput;
}>;

export type JoinOrganizationMutation = {
  __typename?: "Mutation";
  joinOrganization: boolean;
};

export type UpdateUserNotificationSettingsMutationVariables = Exact<{
  input: NotificationSettingsInput;
}>;

export type UpdateUserNotificationSettingsMutation = {
  __typename?: "Mutation";
  updateUserNotificationSettings: {
    __typename?: "UserNotificationSettingsObject";
    email: boolean;
    sms: boolean;
  };
};

export type CreateOpenHouseMutationVariables = Exact<{
  input: CreateOpenHouseInput;
}>;

export type CreateOpenHouseMutation = {
  __typename?: "Mutation";
  createOpenHouse: {
    __typename?: "CreateOpenHousePayload";
    openHouse: {
      __typename?: "OpenHouseObject";
      id: string;
      date: string;
      startTime: string;
      endTime: string;
      numGuestbookSigners: number;
      source: OpenHouseSource;
    };
  };
};

export type UpdateOpenHouseMutationVariables = Exact<{
  input: UpdateOpenHouseInput;
}>;

export type UpdateOpenHouseMutation = {
  __typename?: "Mutation";
  updateOpenHouse: {
    __typename?: "UpdateOpenHousePayload";
    openHouse: {
      __typename?: "OpenHouseObject";
      id: string;
      date: string;
      startTime: string;
      endTime: string;
      numGuestbookSigners: number;
      source: OpenHouseSource;
    };
  };
};

export type DeleteOpenHouseMutationVariables = Exact<{
  input: DeleteOpenHouseInput;
}>;

export type DeleteOpenHouseMutation = {
  __typename?: "Mutation";
  deleteOpenHouse: { __typename?: "DeleteOpenHousePayload"; success: boolean };
};

export type CreateOrganizationPartnerMutationVariables = Exact<{
  input: CreateOrganizationPartnerInput;
}>;

export type CreateOrganizationPartnerMutation = {
  __typename?: "Mutation";
  createOrganizationPartner: {
    __typename?: "OrganizationPartnerObject";
    id: string;
    name: string;
    partnerType: PartnerType;
    isActive: boolean;
    dryRunNotifications: boolean;
    existingRelationshipIntroMessage: string;
    newRelationshipIntroMessage: string;
    hasDrafts: boolean;
    createdAt: any;
    updatedAt: any;
    adminContacts?:
      | Array<{
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          phoneNumber?: string | undefined;
          contactType: ContactType;
        }>
      | undefined;
    logo?: { __typename?: "FileObject"; url: string } | undefined;
    contacts?:
      | Array<{
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
        }>
      | undefined;
  };
};

export type UpdateOrganizationPartnerMutationVariables = Exact<{
  input: UpdateOrganizationPartnerInput;
}>;

export type UpdateOrganizationPartnerMutation = {
  __typename?: "Mutation";
  updateOrganizationPartner: {
    __typename?: "OrganizationPartnerObject";
    id: string;
    name: string;
    partnerType: PartnerType;
    isActive: boolean;
    dryRunNotifications: boolean;
    existingRelationshipIntroMessage: string;
    newRelationshipIntroMessage: string;
    hasDrafts: boolean;
    createdAt: any;
    updatedAt: any;
    adminContacts?:
      | Array<{
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          phoneNumber?: string | undefined;
          contactType: ContactType;
        }>
      | undefined;
    logo?: { __typename?: "FileObject"; url: string } | undefined;
    contacts?:
      | Array<{
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
        }>
      | undefined;
  };
};

export type UpsertOrganizationPartnerStageIntroMutationVariables = Exact<{
  input: UpsertOrganizationPartnerStageIntroInput;
}>;

export type UpsertOrganizationPartnerStageIntroMutation = {
  __typename?: "Mutation";
  upsertOrganizationPartnerStageIntro: {
    __typename?: "OrganizationPartnerStageIntroObject";
    id: string;
    side: TransactionSide;
    stage: TransactionStageType;
    newRelationshipMessageContent: string;
    existingRelationshipMessageContent: string;
    allowPartnerContactAssignment: boolean;
  };
};

export type DeleteOrganizationPartnerStageIntroMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteOrganizationPartnerStageIntroMutation = {
  __typename?: "Mutation";
  deleteOrganizationPartnerStageIntro: boolean;
};

export type UpdateOrCreateOrganizationRosterPreferenceMutationVariables =
  Exact<{
    input: UpdateOrCreateOrganizationRosterPreferenceInput;
  }>;

export type UpdateOrCreateOrganizationRosterPreferenceMutation = {
  __typename?: "Mutation";
  updateOrCreateOrganizationRosterPreference: {
    __typename?: "OrganizationRosterPreferenceObject";
    id: string;
    partnerType: PartnerType;
    preferenceType: PartnerPreferenceType;
    partner?:
      | { __typename?: "OrganizationPartnerObject"; id: string; name: string }
      | undefined;
    partnerContact?:
      | {
          __typename?: "ContactObject";
          id: string;
          firstName: string;
          lastName: string;
          partner?:
            | {
                __typename?: "OrganizationPartnerObject";
                id: string;
                name: string;
              }
            | undefined;
        }
      | undefined;
    roster: {
      __typename?: "OrganizationRosterObject";
      id: string;
      preferences: Array<{
        __typename?: "OrganizationRosterPreferenceObject";
        id: string;
        partnerType: PartnerType;
        preferenceType: PartnerPreferenceType;
        partner?:
          | {
              __typename?: "OrganizationPartnerObject";
              id: string;
              name: string;
            }
          | undefined;
        partnerContact?:
          | {
              __typename?: "ContactObject";
              id: string;
              firstName: string;
              lastName: string;
            }
          | undefined;
      }>;
    };
  };
};

export type UpdateOrganizationRosterEntryMutationVariables = Exact<{
  input: UpdateOrganizationRosterEntryInput;
}>;

export type UpdateOrganizationRosterEntryMutation = {
  __typename?: "Mutation";
  updateOrganizationRosterEntry: {
    __typename?: "OrganizationRosterObject";
    id: string;
    isContactable: boolean;
  };
};

export type CreateOrganizationRosterEntryMutationVariables = Exact<{
  input: CreateOrganizationRosterEntryInput;
}>;

export type CreateOrganizationRosterEntryMutation = {
  __typename?: "Mutation";
  createOrganizationRosterEntry: {
    __typename?: "OrganizationRosterObject";
    id: string;
    isContactable: boolean;
    createdAt: any;
    contact: {
      __typename?: "ContactObject";
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      phoneNumber?: string | undefined;
      contactType: ContactType;
    };
    preferences: Array<{
      __typename?: "OrganizationRosterPreferenceObject";
      id: string;
      partnerType: PartnerType;
      preferenceType: PartnerPreferenceType;
      partner?:
        | { __typename?: "OrganizationPartnerObject"; id: string; name: string }
        | undefined;
      partnerContact?:
        | {
            __typename?: "ContactObject";
            id: string;
            firstName: string;
            lastName: string;
            partner?:
              | {
                  __typename?: "OrganizationPartnerObject";
                  id: string;
                  name: string;
                }
              | undefined;
          }
        | undefined;
    }>;
  };
};

export type AddLoanOfficerContactMutationVariables = Exact<{
  input: AddLoanOfficerContactInput;
}>;

export type AddLoanOfficerContactMutation = {
  __typename?: "Mutation";
  addLoanOfficerContact:
    | {
        __typename?: "InsuranceAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
    | {
        __typename?: "LoanOfficerContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
        loanOfficerConfig?:
          | {
              __typename?: "LoanOfficerContactConfigObject";
              preApprovalAppUrl?: string | undefined;
              calendarSchedulingUrl?: string | undefined;
            }
          | undefined;
      }
    | {
        __typename?: "TitleAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      };
};

export type AddTitleAgentContactMutationVariables = Exact<{
  input: AddTitleAgentContactInput;
}>;

export type AddTitleAgentContactMutation = {
  __typename?: "Mutation";
  addTitleAgentContact:
    | {
        __typename?: "InsuranceAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
    | {
        __typename?: "LoanOfficerContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
        loanOfficerConfig?:
          | {
              __typename?: "LoanOfficerContactConfigObject";
              preApprovalAppUrl?: string | undefined;
              calendarSchedulingUrl?: string | undefined;
            }
          | undefined;
      }
    | {
        __typename?: "TitleAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      };
};

export type AddInsuranceAgentContactMutationVariables = Exact<{
  input: AddInsuranceAgentContactInput;
}>;

export type AddInsuranceAgentContactMutation = {
  __typename?: "Mutation";
  addInsuranceAgentContact:
    | {
        __typename?: "InsuranceAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
    | {
        __typename?: "LoanOfficerContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
        loanOfficerConfig?:
          | {
              __typename?: "LoanOfficerContactConfigObject";
              preApprovalAppUrl?: string | undefined;
              calendarSchedulingUrl?: string | undefined;
            }
          | undefined;
      }
    | {
        __typename?: "TitleAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      };
};

export type UpdatePartnerContactMutationVariables = Exact<{
  input: UpdatePartnerContactInput;
}>;

export type UpdatePartnerContactMutation = {
  __typename?: "Mutation";
  updatePartnerContact:
    | {
        __typename?: "InsuranceAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
    | {
        __typename?: "LoanOfficerContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
        loanOfficerConfig?:
          | {
              __typename?: "LoanOfficerContactConfigObject";
              preApprovalAppUrl?: string | undefined;
              calendarSchedulingUrl?: string | undefined;
            }
          | undefined;
      }
    | {
        __typename?: "TitleAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      };
};

export type DeleteContactMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteContactMutation = {
  __typename?: "Mutation";
  deleteContact: boolean;
};

export type PublishNotificationTemplatesMutationVariables = Exact<{
  partnerId: Scalars["ID"]["input"];
}>;

export type PublishNotificationTemplatesMutation = {
  __typename?: "Mutation";
  publishNotificationTemplates: Array<{
    __typename?: "NotificationTemplateObject";
    id: string;
    title: string;
    eventType: TransactionStageType;
    side?: TransactionSide | undefined;
    notificationType: NotificationType;
    recipients: Array<ContactType>;
    status: NotificationTemplateStatus;
    messageContent: string;
    delayMinutes: number;
    orderIndex: number;
    messageContentTemplates: {
      __typename?: "NotificationTemplateMessageContentTemplates";
      html: string;
      text: string;
    };
    partner?:
      | {
          __typename?: "OrganizationPartnerObject";
          id: string;
          name: string;
          isActive: boolean;
          logo?: { __typename?: "FileObject"; url: string } | undefined;
        }
      | undefined;
  }>;
};

export type QueueAnalyzeForOfferIngestionJobMutationVariables = Exact<{
  input: QueueAnalyzeForOfferIngestionJobInput;
}>;

export type QueueAnalyzeForOfferIngestionJobMutation = {
  __typename?: "Mutation";
  queueAnalyzeForOfferIngestionJob: {
    __typename?: "QueueAnalyzeJobPayload";
    queuedJobsCount: number;
  };
};

export type RemoveDryRunNotificationLogsMutationVariables = Exact<{
  input: RemoveDryRunNotificationLogsInput;
}>;

export type RemoveDryRunNotificationLogsMutation = {
  __typename?: "Mutation";
  removeDryRunNotificationLogs: {
    __typename?: "RemoveDryRunNotificationLogsPayload";
    deletedCount: number;
    success: boolean;
  };
};

export type ReorderNotificationTemplatesMutationVariables = Exact<{
  input:
    | Array<ReorderNotificationTemplateInput>
    | ReorderNotificationTemplateInput;
}>;

export type ReorderNotificationTemplatesMutation = {
  __typename?: "Mutation";
  reorderNotificationTemplates: boolean;
};

export type ResendBoaShareLinkMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type ResendBoaShareLinkMutation = {
  __typename?: "Mutation";
  resendBOAShareLink: string;
};

export type ResendListingReportShareLinkMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type ResendListingReportShareLinkMutation = {
  __typename?: "Mutation";
  resendListingReportShareLink: string;
};

export type RevokeBoaShareLinkMutationVariables = Exact<{
  input: RevokeBoaShareLinkInput;
}>;

export type RevokeBoaShareLinkMutation = {
  __typename?: "Mutation";
  revokeBOAShareLink: {
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  };
};

export type RevokeInvitationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type RevokeInvitationMutation = {
  __typename?: "Mutation";
  revokeInvitation: boolean;
};

export type RevokeListingReportShareLinkMutationVariables = Exact<{
  input: RevokeListingReportShareLinkInput;
}>;

export type RevokeListingReportShareLinkMutation = {
  __typename?: "Mutation";
  revokeListingReportShareLink: {
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  };
};

export type SendBoaShareLinkMutationVariables = Exact<{
  input: SendBoaShareLinkInput;
}>;

export type SendBoaShareLinkMutation = {
  __typename?: "Mutation";
  sendBOAShareLink: {
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  };
};

export type SendComplianceSummaryNotificationMutationVariables = Exact<{
  input: SendComplianceSummaryNotificationInput;
}>;

export type SendComplianceSummaryNotificationMutation = {
  __typename?: "Mutation";
  sendComplianceSummaryNotification: {
    __typename?: "SendComplianceSummaryNotificationResponse";
    workflowRunId: string;
    success: boolean;
  };
};

export type SendListingReportShareLinkMutationVariables = Exact<{
  input: SendListingReportShareLinkInput;
}>;

export type SendListingReportShareLinkMutation = {
  __typename?: "Mutation";
  sendListingReportShareLink: {
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  };
};

export type SendOtpFromInvitationLinkMutationVariables = Exact<{
  input: SendOtpFromInvitationLinkInput;
}>;

export type SendOtpFromInvitationLinkMutation = {
  __typename?: "Mutation";
  sendOTPFromInvitationLink?:
    | {
        __typename?: "SendOTPFromInvitationLinkPayload";
        agentName: string;
        invitationId: string;
        methodId: string;
        name: string;
        phoneNumberLast4: string;
        listingId: string;
      }
    | undefined;
};

export type SendSellerInvitationMutationVariables = Exact<{
  input: SendSellerInvitationInput;
}>;

export type SendSellerInvitationMutation = {
  __typename?: "Mutation";
  sendSellerInvitation?:
    | {
        __typename?: "SendSellerInvitationPayload";
        invitation?:
          | {
              __typename?: "InvitationObject";
              id: string;
              acceptedAt?: any | undefined;
              revokedAt?: any | undefined;
              expiresAt: any;
              notificationMeta?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              invitee: {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              };
              inviter: {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              };
            }
          | undefined;
      }
    | undefined;
};

export type SendSignatureRequestToBuyersForOfferMutationVariables = Exact<{
  input: SendSignatureRequestToBuyersForOfferInput;
}>;

export type SendSignatureRequestToBuyersForOfferMutation = {
  __typename?: "Mutation";
  sendSignatureRequestToBuyersForOffer?:
    | {
        __typename?: "SendSignatureRequestForOfferPayload";
        offer?:
          | { __typename?: "OfferObject"; id: string; status: OfferStatus }
          | undefined;
      }
    | undefined;
};

export type SendTestNotificationMutationVariables = Exact<{
  input: SendTestNotificationInput;
}>;

export type SendTestNotificationMutation = {
  __typename?: "Mutation";
  sendTestNotification: {
    __typename?: "SendTestNotificationResponse";
    success: boolean;
    notificationLogId?: string | undefined;
  };
};

export type ShareStorefrontWithBuyerMutationVariables = Exact<{
  input: ShareStorefrontWithBuyerInput;
}>;

export type ShareStorefrontWithBuyerMutation = {
  __typename?: "Mutation";
  shareStorefrontWithBuyer: boolean;
};

export type SignListingGuestbookMutationVariables = Exact<{
  listingId: Scalars["String"]["input"];
  followListingReason: StorefrontSubscriptionReason;
}>;

export type SignListingGuestbookMutation = {
  __typename?: "Mutation";
  signListingGuestbook: boolean;
  followListing: {
    __typename?: "IsFollowingListingObject";
    isFollowingListing: boolean;
  };
};

export type SignOpenHouseGuestbookMutationVariables = Exact<{
  input: OpenHouseGuestbookInput;
}>;

export type SignOpenHouseGuestbookMutation = {
  __typename?: "Mutation";
  signOpenHouseGuestbook: boolean;
};

export type SignUpConsumerMutationVariables = Exact<{
  input: SignUpInput;
}>;

export type SignUpConsumerMutation = {
  __typename?: "Mutation";
  signUpConsumer?:
    | {
        __typename?: "SignUpUserPayload";
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type SignUpAgentMutationVariables = Exact<{
  input: SignUpAgentInput;
}>;

export type SignUpAgentMutation = {
  __typename?: "Mutation";
  signUpAgent?:
    | {
        __typename?: "SignUpUserPayload";
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              licenses?:
                | Array<{ __typename?: "UserLicenseObject"; id: string }>
                | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type SignUpAgentV2MutationVariables = Exact<{
  input: SignUpAgentV2Input;
}>;

export type SignUpAgentV2Mutation = {
  __typename?: "Mutation";
  signUpAgentV2?:
    | {
        __typename?: "SignUpUserPayload";
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              licenses?:
                | Array<{ __typename?: "UserLicenseObject"; id: string }>
                | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type SubmitOfferForBuyersAgentMutationVariables = Exact<{
  input: SubmitOfferInput;
}>;

export type SubmitOfferForBuyersAgentMutation = {
  __typename?: "Mutation";
  submitOfferForBuyersAgent?:
    | {
        __typename?: "SubmitOfferPayload";
        offer?:
          | {
              __typename?: "OfferObject";
              id: string;
              noteToListingAgent?: string | undefined;
              submittedAt?: any | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type SubmitOfferToNonIndigoListingAgentMutationVariables = Exact<{
  input: SubmitOfferToNonIndigoListingAgentInput;
}>;

export type SubmitOfferToNonIndigoListingAgentMutation = {
  __typename?: "Mutation";
  submitOfferToNonIndigoListingAgent?:
    | {
        __typename?: "SubmitOfferPayload";
        offer?: { __typename?: "OfferObject"; id: string } | undefined;
      }
    | undefined;
};

export type TrackListingDocumentActionMutationVariables = Exact<{
  input: TrackListingDocumentActionInput;
}>;

export type TrackListingDocumentActionMutation = {
  __typename?: "Mutation";
  trackListingDocumentAction: {
    __typename?: "TrackListingDocumentActionPayload";
    success: boolean;
  };
};

export type UnfollowListingMutationVariables = Exact<{
  input: ListingInput;
}>;

export type UnfollowListingMutation = {
  __typename?: "Mutation";
  unfollowListing: {
    __typename?: "IsFollowingListingObject";
    isFollowingListing: boolean;
  };
};

export type UpdateAiConversationMutationVariables = Exact<{
  input: UpdateAiConversationInput;
}>;

export type UpdateAiConversationMutation = {
  __typename?: "Mutation";
  updateAIConversation: {
    __typename?: "AIConversationObject";
    id: string;
    title: string;
    lastAIMessage?: string | undefined;
    conversationType: AiConversationType;
    createdAt: any;
    updatedAt: any;
    deletedAt?: any | undefined;
  };
};

export type UpdateBuyerOfferAnalysisMutationVariables = Exact<{
  input: UpdateBuyerOfferAnalysisInput;
}>;

export type UpdateBuyerOfferAnalysisMutation = {
  __typename?: "Mutation";
  updateBuyerOfferAnalysis: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
  };
};

export type UpdateIndigoContractMutationVariables = Exact<{
  input: UpdateIndigoContractInput;
  includeFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeContractDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateIndigoContractMutation = {
  __typename?: "Mutation";
  updateIndigoContract?:
    | {
        __typename?: "IndigoContractObject";
        id: string;
        createdAt: any;
        contract?:
          | {
              __typename?: "ContractObject";
              id: string;
              autofillValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              fieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              contractDocuments?: Array<{
                __typename?: "ContractDocumentObject";
                id: string;
                order: number;
                documentVersion?:
                  | {
                      __typename?: "DocumentVersionObject";
                      id: string;
                      document: { __typename?: "DocumentObject"; id: string };
                    }
                  | undefined;
              }>;
              signatureRequests?:
                | Array<{
                    __typename?: "SignatureRequestObject";
                    id: string;
                    events: Array<{
                      __typename?: "SignatureRequestEventObject";
                      id: string;
                      createdAt: any;
                      eventType: SignatureRequestEventType;
                    }>;
                    allSignedDocument?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
        party: {
          __typename?: "PartyObject";
          id: string;
          createdAt: any;
          buyersAgent?:
            | {
                __typename?: "AgentObject";
                user?:
                  | {
                      __typename?: "UserObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      fullName: string;
                      userName?: string | undefined;
                      phoneNumber: string;
                      roles: Array<Roles>;
                      email?: string | undefined;
                      profileBio?: string | undefined;
                      offerCollectionEmail?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                      settings?:
                        | {
                            __typename?: "UserSettingsObject";
                            id: string;
                            selectedOrganization?:
                              | {
                                  __typename?: "OrganizationObject";
                                  id: string;
                                  name: string;
                                  hasDescendants?: boolean | undefined;
                                  contractSystemCredentials?:
                                    | Array<{
                                        __typename?: "ContractSystemCredentialsObject";
                                        id: string;
                                        hasInvalidCredentials?:
                                          | boolean
                                          | undefined;
                                        isReady: boolean;
                                        type?: ContractSystemType | undefined;
                                        username?: string | undefined;
                                        dotloopProfileId?: string | undefined;
                                        dotloopTeamName?: string | undefined;
                                      }>
                                    | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
          primaryConsumer: {
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          };
          secondaryConsumers: Array<{
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          }>;
        };
      }
    | undefined;
};

export type UpdateListingComparableSetMutationVariables = Exact<{
  input: UpdateListingComparableSetInput;
}>;

export type UpdateListingComparableSetMutation = {
  __typename?: "Mutation";
  updateListingComparableSet: {
    __typename?: "ListingComparableSetObject";
    id: string;
    agentNotes?: string | undefined;
    listingComparables: Array<{
      __typename?: "ListingComparableObject";
      id: string;
      source: ListingComparableSetSource;
      order: number;
      mlsListing: {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      };
      adjustments?:
        | {
            __typename?: "ListingComparableAdjustmentsObject";
            id: string;
            priceAdjustmentsPerFields?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
            totalAdjustmentPrice?: number | undefined;
            notes?: string | undefined;
          }
        | undefined;
    }>;
    agent?: { __typename?: "AgentObject"; id: string } | undefined;
    listing?: { __typename?: "ListingObject"; id: string } | undefined;
    propertyDetails?:
      | { __typename?: "PropertyDetailsObject"; id: string }
      | undefined;
    buyerOfferAnalysis?:
      | { __typename?: "BuyerOfferAnalysisObject"; id: string }
      | undefined;
  };
};

export type UpdateListingComparableSetForAgentMutationVariables = Exact<{
  input: UpdateListingComparableSetForAgentInput;
}>;

export type UpdateListingComparableSetForAgentMutation = {
  __typename?: "Mutation";
  updateListingComparableSetForAgent: {
    __typename?: "ListingComparableSetObject";
    id: string;
    agentNotes?: string | undefined;
    listingComparables: Array<{
      __typename?: "ListingComparableObject";
      id: string;
      source: ListingComparableSetSource;
      order: number;
      mlsListing: {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      };
      adjustments?:
        | {
            __typename?: "ListingComparableAdjustmentsObject";
            id: string;
            priceAdjustmentsPerFields?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
            totalAdjustmentPrice?: number | undefined;
            notes?: string | undefined;
          }
        | undefined;
    }>;
    agent?: { __typename?: "AgentObject"; id: string } | undefined;
    listing?: { __typename?: "ListingObject"; id: string } | undefined;
    propertyDetails?:
      | { __typename?: "PropertyDetailsObject"; id: string }
      | undefined;
    buyerOfferAnalysis?:
      | { __typename?: "BuyerOfferAnalysisObject"; id: string }
      | undefined;
  };
};

export type UpdateListingComparableSetForBuyerOfferAnalysisMutationVariables =
  Exact<{
    input: UpdateListingComparableSetForBuyerOfferAnalysisInput;
  }>;

export type UpdateListingComparableSetForBuyerOfferAnalysisMutation = {
  __typename?: "Mutation";
  updateListingComparableSetForBuyerOfferAnalysis: {
    __typename?: "ListingComparableSetObject";
    id: string;
    agentNotes?: string | undefined;
    listingComparables: Array<{
      __typename?: "ListingComparableObject";
      id: string;
      source: ListingComparableSetSource;
      order: number;
      mlsListing: {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      };
      adjustments?:
        | {
            __typename?: "ListingComparableAdjustmentsObject";
            id: string;
            priceAdjustmentsPerFields?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
            totalAdjustmentPrice?: number | undefined;
            notes?: string | undefined;
          }
        | undefined;
    }>;
    agent?: { __typename?: "AgentObject"; id: string } | undefined;
    listing?: { __typename?: "ListingObject"; id: string } | undefined;
    propertyDetails?:
      | { __typename?: "PropertyDetailsObject"; id: string }
      | undefined;
    buyerOfferAnalysis?:
      | { __typename?: "BuyerOfferAnalysisObject"; id: string }
      | undefined;
  };
};

export type UpdateListingPreferenceMutationVariables = Exact<{
  input: UpdateListingPreferenceValueInput;
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UpdateListingPreferenceMutation = {
  __typename?: "Mutation";
  updateListingPreference: {
    __typename?: "ListingObject";
    id: string;
    isOwner?: boolean | undefined;
    listDate?: any | undefined;
    offersCountDisplay: string;
    submittedOffersCount: number;
    followerCount?: number | undefined;
    isPremium: boolean;
    status: MlsListingStatus;
    deletedFromRetsFeedAt?: string | undefined;
    property: {
      __typename?: "PropertyObject";
      id: string;
      slug: string;
      state: UsState;
    };
    offersSubmitted?:
      | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
      | undefined;
    listingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    coListingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    listingPreferences?: Array<{
      __typename?: "PreferenceValueObject";
      numberValue?: number | undefined;
      textValue?: string | undefined;
      stringValue?: string | undefined;
      stringArray?: Array<string> | undefined;
      booleanValue?: boolean | undefined;
      dateTimeValue?: any | undefined;
      readOnly?: boolean | undefined;
      preference: {
        __typename?: "PreferenceObject";
        id: string;
        name: string;
        slug: string;
        usStates: Array<UsState>;
        fieldId?: string | undefined;
        valueType: PreferenceValueType;
      };
    }>;
    storefrontSetup?:
      | {
          __typename?: "StorefrontSetupObject";
          continueStep?: StorefrontSetupStep | undefined;
          listingPackage: {
            __typename?: "FileObject";
            fileName: string;
            url: string;
          };
        }
      | undefined;
    setupDetails: {
      __typename?: "StorefrontConfigurationStatusObject";
      hasSetup?: boolean | undefined;
      configuredCount: number;
      progressTotal: number;
      sellerPreferences: boolean;
      comparables: boolean;
      documents: boolean;
    };
  };
};

export type UpdateNotificationTemplateMutationVariables = Exact<{
  input: UpdateNotificationTemplateInput;
}>;

export type UpdateNotificationTemplateMutation = {
  __typename?: "Mutation";
  updateNotificationTemplate: {
    __typename?: "NotificationTemplateObject";
    id: string;
    title: string;
    eventType: TransactionStageType;
    side?: TransactionSide | undefined;
    notificationType: NotificationType;
    recipients: Array<ContactType>;
    hasAssignedPartner?: boolean | undefined;
    isAttachedToPartner?: boolean | undefined;
    delayMinutes: number;
    dataToShare: Array<string>;
    messageContent: string;
    status: NotificationTemplateStatus;
    orderIndex: number;
    messageContentTemplates: {
      __typename?: "NotificationTemplateMessageContentTemplates";
      html: string;
      text: string;
    };
  };
};

export type UpdateOfferForBuyersAgentMutationVariables = Exact<{
  input: UpdateOfferForBuyersAgentInput;
}>;

export type UpdateOfferForBuyersAgentMutation = {
  __typename?: "Mutation";
  updateOfferForBuyersAgent?:
    | {
        __typename?: "UpdateOfferPayload";
        offer?:
          | {
              __typename?: "OfferObject";
              id: string;
              contract?:
                | {
                    __typename?: "ContractObject";
                    id: string;
                    fieldValues?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    validations?:
                      | Array<{
                          __typename?: "ContractValidationObject";
                          field: {
                            __typename?: "FieldObject";
                            id: string;
                            mappingKey: string;
                            fieldType: FieldType;
                            label: string;
                            displayLabel?: string | undefined;
                            group: string;
                            inputFormat?:
                              | {
                                  __typename?: "InputFormatObject";
                                  type: InputFormatType;
                                  options: {
                                    __typename?: "InputFormatOptionsObject";
                                    precision?: number | undefined;
                                    formatString?: string | undefined;
                                    currencySymbol?: string | undefined;
                                  };
                                }
                              | undefined;
                          };
                          documentVersionField: {
                            __typename?: "DocumentVersionFieldObject";
                            id: string;
                            mappingKey: string;
                            fieldType: FieldType;
                            label: string;
                            displayLabel?: string | undefined;
                            inputFormat?:
                              | {
                                  __typename?: "InputFormatObject";
                                  type: InputFormatType;
                                  options: {
                                    __typename?: "InputFormatOptionsObject";
                                    precision?: number | undefined;
                                    formatString?: string | undefined;
                                    currencySymbol?: string | undefined;
                                  };
                                }
                              | undefined;
                          };
                          results: Array<{
                            __typename?: "RuleValidationObject";
                            inputValue?: string | undefined;
                            message: string;
                            validationValue?: string | undefined;
                            rule: {
                              __typename?: "RuleObject";
                              id: string;
                              ruleType: RuleType;
                            };
                          }>;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateOrCreateContractSystemCredentialsMutationVariables = Exact<{
  input: UpdateContractSystemCredentialsInput;
}>;

export type UpdateOrCreateContractSystemCredentialsMutation = {
  __typename?: "Mutation";
  updateOrCreateContractSystemCredentials: {
    __typename?: "OrganizationObject";
    id: string;
    name: string;
    contractSystemCredentials?:
      | Array<{
          __typename?: "ContractSystemCredentialsObject";
          id: string;
          type?: ContractSystemType | undefined;
          username?: string | undefined;
          hasInvalidCredentials?: boolean | undefined;
        }>
      | undefined;
  };
};

export type UpdatePartyForBuyersAgentMutationVariables = Exact<{
  input: UpdatePartyForBuyersAgentInput;
}>;

export type UpdatePartyForBuyersAgentMutation = {
  __typename?: "Mutation";
  updatePartyForBuyersAgent: {
    __typename?: "PartyObject";
    id: string;
    createdAt: any;
    purchaseOffers?:
      | Array<{
          __typename?: "OfferObject";
          id: string;
          updatedAt?: any | undefined;
          listing?:
            | {
                __typename?: "ListingObject";
                id: string;
                isPremium: boolean;
                property: {
                  __typename?: "PropertyObject";
                  id: string;
                  slug: string;
                  state: UsState;
                };
                mlsListing?:
                  | {
                      __typename?: "MLSListingObject";
                      id: string;
                      mlsId?: number | undefined;
                      listingId?: string | undefined;
                      listDate?: string | undefined;
                      listPrice?: number | undefined;
                      originalListPrice?: number | undefined;
                      terms?: string | undefined;
                      photos: Array<string>;
                      remarks?: string | undefined;
                      modified?: string | undefined;
                      mlsName?: string | undefined;
                      deleted_at?: string | undefined;
                      addressFull: string;
                      agent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      coAgent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      address: {
                        __typename?: "MLSListingAddressObject";
                        city: string;
                        country?: string | undefined;
                        crossStreet?: string | undefined;
                        full: string;
                        postalCode?: string | undefined;
                        state: string;
                        streetName: string;
                        streetNumber?: number | undefined;
                        streetNumberText: string;
                        unit?: string | undefined;
                      };
                      property?:
                        | {
                            __typename?: "MLSListingPropertyObject";
                            roof?: string | undefined;
                            cooling?: string | undefined;
                            style?: string | undefined;
                            area?: number | undefined;
                            bathsFull?: number | undefined;
                            bathsHalf?: number | undefined;
                            stories?: number | undefined;
                            fireplaces?: number | undefined;
                            flooring?: string | undefined;
                            heating?: string | undefined;
                            bathrooms?: string | undefined;
                            foundation?: string | undefined;
                            poolFeatures?: string | undefined;
                            laundryFeatures?: string | undefined;
                            occupantName?: string | undefined;
                            ownerName?: string | undefined;
                            lotDescription?: string | undefined;
                            acres?: number | undefined;
                            subType?: string | undefined;
                            bedrooms?: number | undefined;
                            interiorFeatures?: string | undefined;
                            lotSize?: string | undefined;
                            areaSource?: string | undefined;
                            maintenanceExpense?: number | undefined;
                            additionalRooms?: string | undefined;
                            exteriorFeatures?: string | undefined;
                            water?: string | undefined;
                            view?: string | undefined;
                            lotSizeArea?: number | undefined;
                            lotSizeAreaUnits?: string | undefined;
                            subdivision?: string | undefined;
                            construction?: string | undefined;
                            type?: MlsListingType | undefined;
                            garageSpaces?: number | undefined;
                            bathsThreeQuarter?: number | undefined;
                            accessibility?: string | undefined;
                            occupantType?: string | undefined;
                            yearBuilt?: number | undefined;
                            subTypeText?: string | undefined;
                          }
                        | undefined;
                      office?:
                        | {
                            __typename?: "MLSListingOfficeObject";
                            brokerid?: string | undefined;
                            name?: string | undefined;
                            servingName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      mls?:
                        | {
                            __typename?: "MLSListingMLSObject";
                            statusText: string;
                            status?: MlsListingStatus | undefined;
                            daysOnMarket?: number | undefined;
                            originalEntryTimestamp?: string | undefined;
                            originatingSystemName?: string | undefined;
                            logoUrl?: string | undefined;
                            disclaimer?: string | undefined;
                          }
                        | undefined;
                      association?:
                        | {
                            __typename?: "MLSListingAssociationObject";
                            fee?: number | undefined;
                            frequency?: string | undefined;
                            name?: string | undefined;
                            amenities?: string | undefined;
                          }
                        | undefined;
                      compliance?:
                        | {
                            __typename?: "MLSListingComplianceObject";
                            buyerAgencyCompensation?: number | undefined;
                            buyerAgencyCompensationType?: string | undefined;
                            subAgencyCompensation?: number | undefined;
                            subAgencyCompensationType?: string | undefined;
                            attributionContact?: string | undefined;
                          }
                        | undefined;
                      sales?:
                        | {
                            __typename?: "MLSListingSalesObject";
                            closeDate?: string | undefined;
                            closePrice?: number | undefined;
                            contractDate?: string | undefined;
                          }
                        | undefined;
                      geo: {
                        __typename?: "MLSListingGeoObject";
                        location: {
                          __typename?: "GeoPointObject";
                          lat: number;
                          lon: number;
                        };
                      };
                    }
                  | undefined;
                listingAgent?:
                  | {
                      __typename?: "AgentObject";
                      id: string;
                      user?:
                        | { __typename?: "UserObject"; id: string }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }>
      | undefined;
    primaryConsumer: {
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    };
    secondaryConsumers: Array<{
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    }>;
    partyFinancing?:
      | {
          __typename?: "PartyFinancingObject";
          id: string;
          financingType?: FinancingType | undefined;
          loanAmount?: number | undefined;
          percentDownPayment?: number | undefined;
          cashReserves?: number | undefined;
          preapprovalFile?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
  };
};

export type UpdatePropertyDetailsMutationVariables = Exact<{
  input: UpdatePropertyDetailsInput;
}>;

export type UpdatePropertyDetailsMutation = {
  __typename?: "Mutation";
  updatePropertyDetails: {
    __typename?: "UpdatePropertyDetailsPayload";
    success: boolean;
    propertyDetails?:
      | {
          __typename?: "PropertyDetailsObject";
          id: string;
          streetAddress: string;
          city: string;
          state: UsState;
          zipCode: string;
          unit?: string | undefined;
          targetPrice: number;
          areaSqFt: number;
          yearBuilt: number;
          bedrooms: number;
          bathsFull: number;
          bathsHalf?: number | undefined;
          propertyType: MlsListingType;
          propertySubtype: MlsListingSubType;
          subdivision?: string | undefined;
          schoolDistrict?: string | undefined;
          geo: { __typename?: "GeoObject"; lat: number; lng: number };
        }
      | undefined;
  };
};

export type UpdateStorefrontSetupMutationVariables = Exact<{
  input: UpdateStorefrontSetupInput;
}>;

export type UpdateStorefrontSetupMutation = {
  __typename?: "Mutation";
  updateStorefrontSetup: { __typename?: "ListingObject"; id: string };
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;

export type UpdateUserMutation = {
  __typename?: "Mutation";
  updateUser?:
    | {
        __typename?: "UpdateUserPayload";
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UpdateUserSettingsInput;
}>;

export type UpdateUserSettingsMutation = {
  __typename?: "Mutation";
  updateUserSettings?:
    | {
        __typename?: "UpdateUserSettingsPayload";
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UploadAndExtractAgentNegotiationDocumentsMutationVariables = Exact<{
  input: UploadListingDocumentInput;
}>;

export type UploadAndExtractAgentNegotiationDocumentsMutation = {
  __typename?: "Mutation";
  uploadAndExtractAgentNegotiationDocuments?:
    | {
        __typename?: "UploadAndExtractAgentNegotiationDocumentsPayload";
        listingDocumentUploads: Array<{
          __typename?: "ListingDocumentUploadObject";
          id: string;
          file?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>;
        agentCompensationFields?:
          | {
              __typename?: "AutofillAgentCompensationObject";
              flatFee?: number | undefined;
              isListingFirmPaying?: boolean | undefined;
              isSellerPaying?: boolean | undefined;
              percentOfGrossSalesPrice?: number | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type UploadListingDocumentMutationVariables = Exact<{
  input: UploadListingDocumentInput;
}>;

export type UploadListingDocumentMutation = {
  __typename?: "Mutation";
  uploadListingDocument?:
    | Array<{
        __typename?: "ListingDocumentUploadObject";
        id: string;
        file?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
};

export type UploadOfferAsListingAgentMutationVariables = Exact<{
  input: UploadOfferInput;
}>;

export type UploadOfferAsListingAgentMutation = {
  __typename?: "Mutation";
  uploadOfferAsListingAgent?:
    | {
        __typename?: "UploadOfferPayload";
        offer?:
          | {
              __typename?: "OfferObject";
              id: string;
              contractId: string;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
      }
    | undefined;
};

export type UploadOfferForBuyersAgentMutationVariables = Exact<{
  input: UploadOfferInput;
  isAgentVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type UploadOfferForBuyersAgentMutation = {
  __typename?: "Mutation";
  uploadOfferForBuyersAgent?:
    | {
        __typename?: "UploadOfferPayload";
        offer?:
          | {
              __typename?: "OfferObject";
              id: string;
              contractId: string;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
      }
    | undefined;
  uploadOfferForUnauthenticatedBuyersAgent?:
    | {
        __typename?: "UploadOfferPayload";
        offer?:
          | {
              __typename?: "OfferObject";
              id: string;
              contractId: string;
              file: {
                __typename?: "FileObject";
                fileName: string;
                url: string;
              };
            }
          | undefined;
      }
    | undefined;
};

export type VerifyShareLinkMutationVariables = Exact<{
  token: Scalars["String"]["input"];
}>;

export type VerifyShareLinkMutation = {
  __typename?: "Mutation";
  verifyShareLink: {
    __typename?: "VerifyShareLinkPayload";
    isValid: boolean;
    isExpired: boolean;
    accessType: ShareLinkAccessType;
    isForPdf: boolean;
    sharedBy?:
      | {
          __typename?: "PublicUserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          email?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
  };
};

export type AccessControlsListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters: AccessControlsListFilters;
}>;

export type AccessControlsListQuery = {
  __typename?: "Query";
  accessControlsList?:
    | {
        __typename?: "AccessControlObjectPaginated";
        results?:
          | Array<{
              __typename?: "AccessControlObject";
              id: string;
              accessRole: AccessRole;
              accessUser: {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type ActiveIntegrationClientFragment = {
  __typename?: "IntegrationClientObject";
  id: string;
  provider: IntegrationProvider;
  clientType: IntegrationClientType;
  isActive: boolean;
  logoFile?: { __typename?: "FileObject"; url: string } | undefined;
};

export type ActiveIntegrationClientsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ActiveIntegrationClientsQuery = {
  __typename?: "Query";
  activeIntegrationClients: Array<{
    __typename?: "IntegrationClientObject";
    id: string;
    provider: IntegrationProvider;
    clientType: IntegrationClientType;
    isActive: boolean;
    logoFile?: { __typename?: "FileObject"; url: string } | undefined;
  }>;
};

export type AiConversationSessionFileSignedUrlQueryVariables = Exact<{
  input: GetAiConversationSessionFileSignedUrlInput;
}>;

export type AiConversationSessionFileSignedUrlQuery = {
  __typename?: "Query";
  aiConversationSessionFileSignedUrl: {
    __typename?: "AIConversationSessionFileSignedUrlPayload";
    key: string;
    file: string;
    signedUrl: string;
  };
};

export type AiConversationSessionFilesQueryVariables = Exact<{
  input: ListAiConversationSessionFilesInput;
}>;

export type AiConversationSessionFilesQuery = {
  __typename?: "Query";
  aiConversationSessionFiles: {
    __typename?: "AIConversationSessionFilesPayload";
    files: Array<{
      __typename?: "AIConversationSessionFileObject";
      key: string;
      file: string;
    }>;
  };
};

export type AiConversationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<ListAiConversationsInput>;
}>;

export type AiConversationsQuery = {
  __typename?: "Query";
  aiConversations?:
    | {
        __typename?: "AIConversationObjectPaginated";
        results?:
          | Array<{
              __typename?: "AIConversationObject";
              id: string;
              title: string;
              lastAIMessage?: string | undefined;
              conversationType: AiConversationType;
              createdAt: any;
              updatedAt: any;
              deletedAt?: any | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              nextCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type AllListingActivitiesForCurrentUserQueryVariables = Exact<{
  includeListing?: Scalars["Boolean"]["input"];
  limit?: InputMaybe<Scalars["Float"]["input"]>;
  offset?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type AllListingActivitiesForCurrentUserQuery = {
  __typename?: "Query";
  allListingActivitiesForCurrentUser: {
    __typename?: "AllListingActivitiesForCurrentUserPayload";
    hasNext: boolean;
    results: Array<{
      __typename?: "ActivityObject";
      id: string;
      type: ActivityType;
      createdAt: any;
      metadata: Record<
        string,
        | string
        | number
        | boolean
        | string[]
        | Record<string, string | number | boolean | string[] | undefined>
        | undefined
      >;
      user?:
        | {
            __typename?: "PublicUserObject";
            id: string;
            firstName: string;
            lastName: string;
            fullName: string;
            userName?: string | undefined;
            phoneNumber: string;
            email?: string | undefined;
            offerCollectionEmail?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          }
        | undefined;
      listing?:
        | {
            __typename?: "ListingObject";
            id: string;
            property: {
              __typename?: "PropertyObject";
              id: string;
              slug: string;
            };
            mlsListing?:
              | {
                  __typename?: "MLSListingObject";
                  id: string;
                  address: {
                    __typename?: "MLSListingAddressObject";
                    city: string;
                    country?: string | undefined;
                    crossStreet?: string | undefined;
                    full: string;
                    postalCode?: string | undefined;
                    state: string;
                    streetName: string;
                    streetNumber?: number | undefined;
                    streetNumberText: string;
                    unit?: string | undefined;
                  };
                }
              | undefined;
          }
        | undefined;
    }>;
  };
};

export type AllMlSesQueryVariables = Exact<{ [key: string]: never }>;

export type AllMlSesQuery = {
  __typename?: "Query";
  allMLSes: {
    __typename?: "AllMLSesPayload";
    mls: Array<{
      __typename?: "MLSObject";
      id: string;
      name: string;
      originatingSystemName?: string | undefined;
    }>;
  };
};

export type MlsObjectForAllMlSesFragment = {
  __typename?: "MLSObject";
  id: string;
  name: string;
  originatingSystemName?: string | undefined;
};

export type AuditEssentialsNotificationFragment = {
  __typename?: "AuditEssentialsNotificationsObject";
  auditSnapshot: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
  eventType: string;
  notificationLogUuid: string;
  notificationTemplateUuid: string;
  occurredAt: string;
  organizationPartnerUuid: string;
  organizationUuid: string;
  ingestionFolderUuid: string;
  pausedNotificationLogUuids: Array<string>;
  stage: string;
  twilioConversationSid: string;
  aiConversationUuid: string;
};

export type AuditEssentialsNotificationsQueryVariables = Exact<{
  filters: AuditEssentialsNotificationsFilters;
}>;

export type AuditEssentialsNotificationsQuery = {
  __typename?: "Query";
  auditEssentialsNotifications: Array<{
    __typename?: "AuditEssentialsNotificationsObject";
    auditSnapshot: Record<
      string,
      string | number | boolean | string[] | undefined
    >;
    eventType: string;
    notificationLogUuid: string;
    notificationTemplateUuid: string;
    occurredAt: string;
    organizationPartnerUuid: string;
    organizationUuid: string;
    ingestionFolderUuid: string;
    pausedNotificationLogUuids: Array<string>;
    stage: string;
    twilioConversationSid: string;
    aiConversationUuid: string;
  }>;
};

export type AutofillConsumerFragment = {
  __typename?: "AutofillConsumerObject";
  email?: string | undefined;
  name?: string | undefined;
  phoneNumber?: string | undefined;
  isEntity?: boolean | undefined;
  entityName?: string | undefined;
  entityTitle?: string | undefined;
  id?: string | undefined;
};

export type OfferAutofillVariablesSchemaQueryVariables = Exact<{
  usState: UsState;
}>;

export type OfferAutofillVariablesSchemaQuery = {
  __typename?: "Query";
  offerAutofillVariablesSchema: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
};

export type OfferAutofillVariableValuesQueryVariables = Exact<{
  offerId: Scalars["ID"]["input"];
}>;

export type OfferAutofillVariableValuesQuery = {
  __typename?: "Query";
  offerAutofillVariableValues: Array<{
    __typename?: "OfferAutofillObject";
    preference?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    property?:
      | {
          __typename?: "PropertyObject";
          id: string;
          streetAddress: string;
          unit?: string | undefined;
          city: string;
          state: UsState;
          zipCode: string;
          zipCodePlus4?: string | undefined;
          county: string;
          lot: string;
          block: string;
          platBook: string;
          platBookPage: string;
          subdivision: string;
          parcelId: string;
          yearBuilt?: number | undefined;
          assessorParcelNumber?: string | undefined;
          otherLegalDescription: string;
        }
      | undefined;
    seller?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    buyer?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    coBuyer?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    coSeller?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    latestSale?:
      | {
          __typename?: "AutofillSaleObject";
          closedDate?: string | undefined;
          deedBook?: string | undefined;
          deedPage?: string | undefined;
          salePrice?: number | undefined;
          assessorParcelNumber?: string | undefined;
        }
      | undefined;
    listingAgent?:
      | {
          __typename?: "UserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          roles: Array<Roles>;
          email?: string | undefined;
          profileBio?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
          settings?:
            | {
                __typename?: "UserSettingsObject";
                id: string;
                selectedOrganization?:
                  | {
                      __typename?: "OrganizationObject";
                      id: string;
                      name: string;
                      hasDescendants?: boolean | undefined;
                      contractSystemCredentials?:
                        | Array<{
                            __typename?: "ContractSystemCredentialsObject";
                            id: string;
                            hasInvalidCredentials?: boolean | undefined;
                            isReady: boolean;
                            type?: ContractSystemType | undefined;
                            username?: string | undefined;
                            dotloopProfileId?: string | undefined;
                            dotloopTeamName?: string | undefined;
                          }>
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    buyersAgent?:
      | {
          __typename?: "UserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          roles: Array<Roles>;
          email?: string | undefined;
          profileBio?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
          settings?:
            | {
                __typename?: "UserSettingsObject";
                id: string;
                selectedOrganization?:
                  | {
                      __typename?: "OrganizationObject";
                      id: string;
                      name: string;
                      hasDescendants?: boolean | undefined;
                      contractSystemCredentials?:
                        | Array<{
                            __typename?: "ContractSystemCredentialsObject";
                            id: string;
                            hasInvalidCredentials?: boolean | undefined;
                            isReady: boolean;
                            type?: ContractSystemType | undefined;
                            username?: string | undefined;
                            dotloopProfileId?: string | undefined;
                            dotloopTeamName?: string | undefined;
                          }>
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
  }>;
};

export type ListingAutofillVariableValuesQueryVariables = Exact<{
  listingIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type ListingAutofillVariableValuesQuery = {
  __typename?: "Query";
  listingAutofillVariableValues: Array<{
    __typename?: "OfferAutofillObject";
    preference?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
  }>;
};

export type OfferAutofillValuesFromContractQueryVariables = Exact<{
  offerId: Scalars["ID"]["input"];
}>;

export type OfferAutofillValuesFromContractQuery = {
  __typename?: "Query";
  offerAutofillVariableValuesFromContract: {
    __typename?: "OfferAutofillVariableValuesFromContractPayload";
    extractedBuyerInfos?:
      | {
          __typename?: "ExtractedContractBuyerInfos";
          primary?:
            | {
                __typename?: "ExtractedContractBuyerInfo";
                fullName: string;
                entity?:
                  | {
                      __typename?: "ExtractedContractEntityInfo";
                      name?: string | undefined;
                      title?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          secondary: Array<{
            __typename?: "ExtractedContractBuyerInfo";
            fullName: string;
            entity?:
              | {
                  __typename?: "ExtractedContractEntityInfo";
                  name?: string | undefined;
                  title?: string | undefined;
                }
              | undefined;
          }>;
        }
      | undefined;
  };
};

export type BusinessOverviewOffersQueryVariables = Exact<{
  filters: BusinessOverviewOffersFilterInput;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type BusinessOverviewOffersQuery = {
  __typename?: "Query";
  businessOverviewOffers?:
    | {
        __typename?: "BizOverviewOfferObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "BizOverviewOfferObject";
              id: string;
              createdAt: any;
              status: BusinessOverviewOfferStatus;
              buyerNames: Array<string>;
              purchasePrice: number;
              agent?:
                | {
                    __typename?: "OfferAgentObject";
                    fullName: string;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          url: string;
                          fileName: string;
                        }
                      | undefined;
                  }
                | undefined;
              property: {
                __typename?: "OfferPropertyObject";
                coverPhotoUrl?: string | undefined;
                address: {
                  __typename?: "AddressObject";
                  streetAddress: string;
                  city: string;
                  state: UsState;
                  zipCode: string;
                  unit?: string | undefined;
                };
              };
            }>
          | undefined;
      }
    | undefined;
};

export type BusinessOverviewStatsQueryVariables = Exact<{
  input: BusinessOverviewStatsInput;
}>;

export type BusinessOverviewStatsQuery = {
  __typename?: "Query";
  businessOverviewStats: {
    __typename?: "BusinessOverviewStatsPayload";
    stats: Array<{
      __typename?: "BusinessOverviewStat";
      metric: BusinessOverviewMetric;
      estimatedDealValue?: number | undefined;
      current: {
        __typename?: "BusinessOverviewMetricValue";
        value: number;
        from: string;
        to: string;
      };
      previous: {
        __typename?: "BusinessOverviewMetricValue";
        value: number;
        from: string;
        to: string;
      };
      chart: {
        __typename?: "ChartData";
        type: ListingReportChartType;
        title: string;
        valueUnit: ChartUnit;
        labelUnit: ChartUnit;
        styleConfig: { __typename?: "ChartStyleConfig"; showLegend: boolean };
        mainMetric: {
          __typename?: "ChartMetric";
          value?: number | undefined;
          description: string;
          unit: ChartUnit;
          trend?:
            | {
                __typename?: "ChartTrend";
                value?: number | undefined;
                period: string;
              }
            | undefined;
        };
        data: Array<{
          __typename?: "ChartDataPoint";
          label: string;
          value?: number | undefined;
        }>;
        verticalReferenceLine?:
          | {
              __typename?: "ChartDataPoint";
              label: string;
              value?: number | undefined;
            }
          | undefined;
      };
    }>;
  };
};

export type BuyerClientsForCurrentAgentUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type BuyerClientsForCurrentAgentUserQuery = {
  __typename?: "Query";
  buyerClientsForCurrentAgentUser: Array<{
    __typename?: "PartyObject";
    id: string;
    createdAt: any;
    purchaseOffers?:
      | Array<{
          __typename?: "OfferObject";
          id: string;
          updatedAt?: any | undefined;
          listing?:
            | {
                __typename?: "ListingObject";
                id: string;
                isPremium: boolean;
                property: {
                  __typename?: "PropertyObject";
                  id: string;
                  slug: string;
                  state: UsState;
                };
                mlsListing?:
                  | {
                      __typename?: "MLSListingObject";
                      id: string;
                      mlsId?: number | undefined;
                      listingId?: string | undefined;
                      listDate?: string | undefined;
                      listPrice?: number | undefined;
                      originalListPrice?: number | undefined;
                      terms?: string | undefined;
                      photos: Array<string>;
                      remarks?: string | undefined;
                      modified?: string | undefined;
                      mlsName?: string | undefined;
                      deleted_at?: string | undefined;
                      addressFull: string;
                      agent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      coAgent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      address: {
                        __typename?: "MLSListingAddressObject";
                        city: string;
                        country?: string | undefined;
                        crossStreet?: string | undefined;
                        full: string;
                        postalCode?: string | undefined;
                        state: string;
                        streetName: string;
                        streetNumber?: number | undefined;
                        streetNumberText: string;
                        unit?: string | undefined;
                      };
                      property?:
                        | {
                            __typename?: "MLSListingPropertyObject";
                            roof?: string | undefined;
                            cooling?: string | undefined;
                            style?: string | undefined;
                            area?: number | undefined;
                            bathsFull?: number | undefined;
                            bathsHalf?: number | undefined;
                            stories?: number | undefined;
                            fireplaces?: number | undefined;
                            flooring?: string | undefined;
                            heating?: string | undefined;
                            bathrooms?: string | undefined;
                            foundation?: string | undefined;
                            poolFeatures?: string | undefined;
                            laundryFeatures?: string | undefined;
                            occupantName?: string | undefined;
                            ownerName?: string | undefined;
                            lotDescription?: string | undefined;
                            acres?: number | undefined;
                            subType?: string | undefined;
                            bedrooms?: number | undefined;
                            interiorFeatures?: string | undefined;
                            lotSize?: string | undefined;
                            areaSource?: string | undefined;
                            maintenanceExpense?: number | undefined;
                            additionalRooms?: string | undefined;
                            exteriorFeatures?: string | undefined;
                            water?: string | undefined;
                            view?: string | undefined;
                            lotSizeArea?: number | undefined;
                            lotSizeAreaUnits?: string | undefined;
                            subdivision?: string | undefined;
                            construction?: string | undefined;
                            type?: MlsListingType | undefined;
                            garageSpaces?: number | undefined;
                            bathsThreeQuarter?: number | undefined;
                            accessibility?: string | undefined;
                            occupantType?: string | undefined;
                            yearBuilt?: number | undefined;
                            subTypeText?: string | undefined;
                          }
                        | undefined;
                      office?:
                        | {
                            __typename?: "MLSListingOfficeObject";
                            brokerid?: string | undefined;
                            name?: string | undefined;
                            servingName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      mls?:
                        | {
                            __typename?: "MLSListingMLSObject";
                            statusText: string;
                            status?: MlsListingStatus | undefined;
                            daysOnMarket?: number | undefined;
                            originalEntryTimestamp?: string | undefined;
                            originatingSystemName?: string | undefined;
                            logoUrl?: string | undefined;
                            disclaimer?: string | undefined;
                          }
                        | undefined;
                      association?:
                        | {
                            __typename?: "MLSListingAssociationObject";
                            fee?: number | undefined;
                            frequency?: string | undefined;
                            name?: string | undefined;
                            amenities?: string | undefined;
                          }
                        | undefined;
                      compliance?:
                        | {
                            __typename?: "MLSListingComplianceObject";
                            buyerAgencyCompensation?: number | undefined;
                            buyerAgencyCompensationType?: string | undefined;
                            subAgencyCompensation?: number | undefined;
                            subAgencyCompensationType?: string | undefined;
                            attributionContact?: string | undefined;
                          }
                        | undefined;
                      sales?:
                        | {
                            __typename?: "MLSListingSalesObject";
                            closeDate?: string | undefined;
                            closePrice?: number | undefined;
                            contractDate?: string | undefined;
                          }
                        | undefined;
                      geo: {
                        __typename?: "MLSListingGeoObject";
                        location: {
                          __typename?: "GeoPointObject";
                          lat: number;
                          lon: number;
                        };
                      };
                    }
                  | undefined;
                listingAgent?:
                  | {
                      __typename?: "AgentObject";
                      id: string;
                      user?:
                        | { __typename?: "UserObject"; id: string }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }>
      | undefined;
    primaryConsumer: {
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    };
    secondaryConsumers: Array<{
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    }>;
    partyFinancing?:
      | {
          __typename?: "PartyFinancingObject";
          id: string;
          financingType?: FinancingType | undefined;
          loanAmount?: number | undefined;
          percentDownPayment?: number | undefined;
          cashReserves?: number | undefined;
          preapprovalFile?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
  }>;
};

export type BuyersForCurrentAgentPaginatedQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
}>;

export type BuyersForCurrentAgentPaginatedQuery = {
  __typename?: "Query";
  buyersForCurrentAgentPaginated?:
    | {
        __typename?: "PartyObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PartyObject";
              id: string;
              createdAt: any;
              latestBuyerOfferAnalysis?:
                | {
                    __typename?: "BuyerOfferAnalysisObject";
                    id: string;
                    createdAt: any;
                    listing?:
                      | {
                          __typename?: "ListingObject";
                          id: string;
                          property: {
                            __typename?: "PropertyObject";
                            id: string;
                            streetAddress: string;
                            unit?: string | undefined;
                            city: string;
                            state: UsState;
                            zipCode: string;
                            zipCodePlus4?: string | undefined;
                            county: string;
                            lot: string;
                            block: string;
                            platBook: string;
                            platBookPage: string;
                            subdivision: string;
                            parcelId: string;
                            yearBuilt?: number | undefined;
                            assessorParcelNumber?: string | undefined;
                            otherLegalDescription: string;
                          };
                        }
                      | undefined;
                  }
                | undefined;
              purchaseOffers?:
                | Array<{
                    __typename?: "OfferObject";
                    id: string;
                    updatedAt?: any | undefined;
                    listing?:
                      | {
                          __typename?: "ListingObject";
                          id: string;
                          isPremium: boolean;
                          property: {
                            __typename?: "PropertyObject";
                            id: string;
                            slug: string;
                            state: UsState;
                          };
                          mlsListing?:
                            | {
                                __typename?: "MLSListingObject";
                                id: string;
                                mlsId?: number | undefined;
                                listingId?: string | undefined;
                                listDate?: string | undefined;
                                listPrice?: number | undefined;
                                originalListPrice?: number | undefined;
                                terms?: string | undefined;
                                photos: Array<string>;
                                remarks?: string | undefined;
                                modified?: string | undefined;
                                mlsName?: string | undefined;
                                deleted_at?: string | undefined;
                                addressFull: string;
                                agent?:
                                  | {
                                      __typename?: "MLSListingAgentObject";
                                      id?: string | undefined;
                                      mlsId?: string | undefined;
                                      firstName?: string | undefined;
                                      lastName?: string | undefined;
                                      contact?:
                                        | {
                                            __typename?: "MLSListingContactObject";
                                            email?: string | undefined;
                                            office?: string | undefined;
                                            cell?: string | undefined;
                                          }
                                        | undefined;
                                    }
                                  | undefined;
                                coAgent?:
                                  | {
                                      __typename?: "MLSListingAgentObject";
                                      id?: string | undefined;
                                      mlsId?: string | undefined;
                                      firstName?: string | undefined;
                                      lastName?: string | undefined;
                                      contact?:
                                        | {
                                            __typename?: "MLSListingContactObject";
                                            email?: string | undefined;
                                            office?: string | undefined;
                                            cell?: string | undefined;
                                          }
                                        | undefined;
                                    }
                                  | undefined;
                                address: {
                                  __typename?: "MLSListingAddressObject";
                                  city: string;
                                  country?: string | undefined;
                                  crossStreet?: string | undefined;
                                  full: string;
                                  postalCode?: string | undefined;
                                  state: string;
                                  streetName: string;
                                  streetNumber?: number | undefined;
                                  streetNumberText: string;
                                  unit?: string | undefined;
                                };
                                property?:
                                  | {
                                      __typename?: "MLSListingPropertyObject";
                                      roof?: string | undefined;
                                      cooling?: string | undefined;
                                      style?: string | undefined;
                                      area?: number | undefined;
                                      bathsFull?: number | undefined;
                                      bathsHalf?: number | undefined;
                                      stories?: number | undefined;
                                      fireplaces?: number | undefined;
                                      flooring?: string | undefined;
                                      heating?: string | undefined;
                                      bathrooms?: string | undefined;
                                      foundation?: string | undefined;
                                      poolFeatures?: string | undefined;
                                      laundryFeatures?: string | undefined;
                                      occupantName?: string | undefined;
                                      ownerName?: string | undefined;
                                      lotDescription?: string | undefined;
                                      acres?: number | undefined;
                                      subType?: string | undefined;
                                      bedrooms?: number | undefined;
                                      interiorFeatures?: string | undefined;
                                      lotSize?: string | undefined;
                                      areaSource?: string | undefined;
                                      maintenanceExpense?: number | undefined;
                                      additionalRooms?: string | undefined;
                                      exteriorFeatures?: string | undefined;
                                      water?: string | undefined;
                                      view?: string | undefined;
                                      lotSizeArea?: number | undefined;
                                      lotSizeAreaUnits?: string | undefined;
                                      subdivision?: string | undefined;
                                      construction?: string | undefined;
                                      type?: MlsListingType | undefined;
                                      garageSpaces?: number | undefined;
                                      bathsThreeQuarter?: number | undefined;
                                      accessibility?: string | undefined;
                                      occupantType?: string | undefined;
                                      yearBuilt?: number | undefined;
                                      subTypeText?: string | undefined;
                                    }
                                  | undefined;
                                office?:
                                  | {
                                      __typename?: "MLSListingOfficeObject";
                                      brokerid?: string | undefined;
                                      name?: string | undefined;
                                      servingName?: string | undefined;
                                      contact?:
                                        | {
                                            __typename?: "MLSListingContactObject";
                                            email?: string | undefined;
                                            office?: string | undefined;
                                            cell?: string | undefined;
                                          }
                                        | undefined;
                                    }
                                  | undefined;
                                mls?:
                                  | {
                                      __typename?: "MLSListingMLSObject";
                                      statusText: string;
                                      status?: MlsListingStatus | undefined;
                                      daysOnMarket?: number | undefined;
                                      originalEntryTimestamp?:
                                        | string
                                        | undefined;
                                      originatingSystemName?:
                                        | string
                                        | undefined;
                                      logoUrl?: string | undefined;
                                      disclaimer?: string | undefined;
                                    }
                                  | undefined;
                                association?:
                                  | {
                                      __typename?: "MLSListingAssociationObject";
                                      fee?: number | undefined;
                                      frequency?: string | undefined;
                                      name?: string | undefined;
                                      amenities?: string | undefined;
                                    }
                                  | undefined;
                                compliance?:
                                  | {
                                      __typename?: "MLSListingComplianceObject";
                                      buyerAgencyCompensation?:
                                        | number
                                        | undefined;
                                      buyerAgencyCompensationType?:
                                        | string
                                        | undefined;
                                      subAgencyCompensation?:
                                        | number
                                        | undefined;
                                      subAgencyCompensationType?:
                                        | string
                                        | undefined;
                                      attributionContact?: string | undefined;
                                    }
                                  | undefined;
                                sales?:
                                  | {
                                      __typename?: "MLSListingSalesObject";
                                      closeDate?: string | undefined;
                                      closePrice?: number | undefined;
                                      contractDate?: string | undefined;
                                    }
                                  | undefined;
                                geo: {
                                  __typename?: "MLSListingGeoObject";
                                  location: {
                                    __typename?: "GeoPointObject";
                                    lat: number;
                                    lon: number;
                                  };
                                };
                              }
                            | undefined;
                          listingAgent?:
                            | {
                                __typename?: "AgentObject";
                                id: string;
                                user?:
                                  | { __typename?: "UserObject"; id: string }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }>
                | undefined;
              primaryConsumer: {
                __typename?: "ConsumerObject";
                id: string;
                email?: string | undefined;
                fullName: string;
                phoneNumber?: string | undefined;
                isEntity: boolean;
                entityName?: string | undefined;
                entityTitle?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              };
              secondaryConsumers: Array<{
                __typename?: "ConsumerObject";
                id: string;
                email?: string | undefined;
                fullName: string;
                phoneNumber?: string | undefined;
                isEntity: boolean;
                entityName?: string | undefined;
                entityTitle?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }>;
              partyFinancing?:
                | {
                    __typename?: "PartyFinancingObject";
                    id: string;
                    financingType?: FinancingType | undefined;
                    loanAmount?: number | undefined;
                    percentDownPayment?: number | undefined;
                    cashReserves?: number | undefined;
                    preapprovalFile?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type CheckPermissionQueryVariables = Exact<{
  input: CheckPermissionInput;
}>;

export type CheckPermissionQuery = {
  __typename?: "Query";
  checkPermission: {
    __typename?: "PermissionObject";
    isAuthorized: boolean;
    message?: string | undefined;
  };
};

export type CurrentUserFragment = {
  __typename?: "UserObject";
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  userName?: string | undefined;
  email?: string | undefined;
  phoneNumber: string;
  roles: Array<Roles>;
  hasListings?: boolean | undefined;
  profileBio?: string | undefined;
  offerCollectionEmail?: string | undefined;
  profilePicture?:
    | { __typename?: "FileObject"; fileName: string; url: string }
    | undefined;
  settings?:
    | {
        __typename?: "UserSettingsObject";
        id: string;
        selectedOrganization?:
          | {
              __typename?: "OrganizationObject";
              id: string;
              name: string;
              hasDescendants?: boolean | undefined;
              contractSystemCredentials?:
                | Array<{
                    __typename?: "ContractSystemCredentialsObject";
                    id: string;
                    hasInvalidCredentials?: boolean | undefined;
                    isReady: boolean;
                    type?: ContractSystemType | undefined;
                    username?: string | undefined;
                    dotloopProfileId?: string | undefined;
                    dotloopTeamName?: string | undefined;
                  }>
                | undefined;
            }
          | undefined;
      }
    | undefined;
  licenses?:
    | Array<{
        __typename?: "UserLicenseObject";
        id: string;
        licenseNumber: string;
        licenseType: LicenseType;
        states: Array<UsState>;
        mls?:
          | {
              __typename?: "MLSObject";
              id: string;
              shortName: string;
              name: string;
              originatingSystemName?: string | undefined;
              states: Array<UsState>;
              supportedFeatures?: Array<ProductFeatures> | undefined;
              agentSignUpEnabled?: boolean | undefined;
            }
          | undefined;
      }>
    | undefined;
  tours?:
    | Array<{ __typename?: "UserTourObject"; id: string; tourName: TourType }>
    | undefined;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: "Query";
  currentUser?:
    | {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        email?: string | undefined;
        phoneNumber: string;
        roles: Array<Roles>;
        hasListings?: boolean | undefined;
        profileBio?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        settings?:
          | {
              __typename?: "UserSettingsObject";
              id: string;
              selectedOrganization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                    hasDescendants?: boolean | undefined;
                    contractSystemCredentials?:
                      | Array<{
                          __typename?: "ContractSystemCredentialsObject";
                          id: string;
                          hasInvalidCredentials?: boolean | undefined;
                          isReady: boolean;
                          type?: ContractSystemType | undefined;
                          username?: string | undefined;
                          dotloopProfileId?: string | undefined;
                          dotloopTeamName?: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
        licenses?:
          | Array<{
              __typename?: "UserLicenseObject";
              id: string;
              licenseNumber: string;
              licenseType: LicenseType;
              states: Array<UsState>;
              mls?:
                | {
                    __typename?: "MLSObject";
                    id: string;
                    shortName: string;
                    name: string;
                    originatingSystemName?: string | undefined;
                    states: Array<UsState>;
                    supportedFeatures?: Array<ProductFeatures> | undefined;
                    agentSignUpEnabled?: boolean | undefined;
                  }
                | undefined;
            }>
          | undefined;
        tours?:
          | Array<{
              __typename?: "UserTourObject";
              id: string;
              tourName: TourType;
            }>
          | undefined;
      }
    | undefined;
};

export type EventsForOfferQueryVariables = Exact<{
  input: EventsForOfferInput;
}>;

export type EventsForOfferQuery = {
  __typename?: "Query";
  eventsForOffer: Array<{
    __typename?: "EventListObject";
    name: EventTypes;
    isDone?: boolean | undefined;
    doneAt?: any | undefined;
    label: string;
  }>;
};

export type ExternalGetDistinctOfficeNamesQueryVariables = Exact<{
  input: ExternalGetDistinctOfficeNamesInput;
}>;

export type ExternalGetDistinctOfficeNamesQuery = {
  __typename?: "Query";
  externalGetDistinctOfficeNames: Array<string>;
};

export type ExternalGetDistinctStatusesQueryVariables = Exact<{
  input: ExternalGetDistinctStatusesInput;
}>;

export type ExternalGetDistinctStatusesQuery = {
  __typename?: "Query";
  externalGetDistinctStatuses: Array<string>;
};

export type ExternalGetIngestionDocumentQueryVariables = Exact<{
  input: ExternalIngestionDocumentArgs;
}>;

export type ExternalGetIngestionDocumentQuery = {
  __typename?: "Query";
  externalGetIngestionDocument: {
    __typename?: "IngestionDocumentObject";
    id: string;
    fields?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    fileUrl?: string | undefined;
    documentName: string;
    documentId: string;
    documentUpdatedAt: any;
    s3Bucket: string;
    s3Key: string;
    isArchived: boolean;
    isBlank: boolean;
    isClassified: boolean;
    needsReview?: boolean | undefined;
    version: string;
    complianceStatus?: string | undefined;
    complianceGroupId?: string | undefined;
    complianceStatusId?: string | undefined;
    folderName?: string | undefined;
    docPageErrorMessage?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      documentCategory?: string | undefined;
      file: { __typename?: "FileObject"; url: string; fileName: string };
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            documentVersionFields: Array<{
              __typename?: "DocumentVersionFieldObject";
              id: string;
              boundingBox: {
                __typename?: "BoundingBoxObject";
                top: number;
                left: number;
                bottom: number;
                right: number;
              };
              field: {
                __typename?: "FieldObject";
                id: string;
                label: string;
                mappingKey: string;
              };
            }>;
            document: {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              form: string;
            };
          }
        | undefined;
    }>;
  };
};

export type ExternalGetIngestionDocumentValidationFeedbackQueryVariables =
  Exact<{
    input: ExternalGetIngestionDocumentValidationFeedbackInput;
  }>;

export type ExternalGetIngestionDocumentValidationFeedbackQuery = {
  __typename?: "Query";
  externalGetIngestionDocumentValidationFeedback: Array<{
    __typename?: "IngestionDocumentValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ruleUuid?: string | undefined;
    contractDocumentUuid?: string | undefined;
    ingestionDocumentValidation?:
      | { __typename?: "IngestionDocumentValidationObject"; id: string }
      | undefined;
  }>;
};

export type ExternalGetIngestionFolderQueryVariables = Exact<{
  input: ExternalGetIngestionFolderInput;
  includeTransactionPipeline?: Scalars["Boolean"]["input"];
  includeKeyTerms?: Scalars["Boolean"]["input"];
  sortKeyTermsByDatetime?: Scalars["Boolean"]["input"];
}>;

export type ExternalGetIngestionFolderQuery = {
  __typename?: "Query";
  externalGetIngestionFolder: {
    __typename?: "IngestionFolderObject";
    id: string;
    organizationUuid: string;
    folderId: string;
    folderName: string;
    transactionSide: TransactionSide;
    status: string;
    normalizedStatus?: NormalizedTransactionStatus | undefined;
    stage?: TransactionStageType | undefined;
    activeMlsListingId?: string | undefined;
    metadata: Record<string, string | number | boolean | string[] | undefined>;
    platform: IngestionPlatform;
    folderUpdatedAt?: any | undefined;
    normalizedFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    validationErrorCount?: number | undefined;
    dotloopProfileId?: string | undefined;
    keyTerms?:
      | Array<{
          __typename?: "KeyTermSection";
          title: string;
          description: string;
          fields: Array<{
            __typename?: "KeyTermField";
            fieldLabel: string;
            fieldType: string;
            key: string;
            isEditable: boolean;
            value?: any | undefined;
            fieldFormat?:
              | {
                  __typename?: "InputFormatObject";
                  type: InputFormatType;
                  options: {
                    __typename?: "InputFormatOptionsObject";
                    precision?: number | undefined;
                    formatString?: string | undefined;
                    currencySymbol?: string | undefined;
                  };
                }
              | undefined;
            values: Array<{
              __typename?: "KeyTermValue";
              value?: any | undefined;
              timestamp: any;
              source: KeyTermSourceType;
              sourceLabel: string;
              validationError?: string | undefined;
              isCurrent: boolean;
              metadata?:
                | {
                    __typename?: "KeyTermCalculatedMetadata";
                    ingestionDocumentId: string;
                    contractDocumentId: string;
                  }
                | {
                    __typename?: "KeyTermUserOverrideMetadata";
                    overriddenBy: {
                      __typename?: "PublicUserObject";
                      id: string;
                      email?: string | undefined;
                      firstName: string;
                      lastName: string;
                    };
                  }
                | undefined;
            }>;
          }>;
          children?:
            | Array<{
                __typename?: "KeyTermSection";
                title: string;
                description: string;
                fields: Array<{
                  __typename?: "KeyTermField";
                  fieldLabel: string;
                  fieldType: string;
                  key: string;
                  isEditable: boolean;
                  value?: any | undefined;
                  fieldFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  values: Array<{
                    __typename?: "KeyTermValue";
                    value?: any | undefined;
                    timestamp: any;
                    source: KeyTermSourceType;
                    sourceLabel: string;
                    validationError?: string | undefined;
                    isCurrent: boolean;
                    metadata?:
                      | {
                          __typename?: "KeyTermCalculatedMetadata";
                          ingestionDocumentId: string;
                          contractDocumentId: string;
                        }
                      | {
                          __typename?: "KeyTermUserOverrideMetadata";
                          overriddenBy: {
                            __typename?: "PublicUserObject";
                            id: string;
                            email?: string | undefined;
                            firstName: string;
                            lastName: string;
                          };
                        }
                      | undefined;
                  }>;
                }>;
              }>
            | undefined;
        }>
      | undefined;
    participants?:
      | {
          __typename?: "Participants";
          buyers: Array<{
            __typename?: "ClientParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
          }>;
          sellers: Array<{
            __typename?: "ClientParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
          }>;
          buyersAgents: Array<{
            __typename?: "AgentParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
            officeName?: string | undefined;
            officeId?: string | undefined;
            mlsAgentId?: string | undefined;
          }>;
          listingAgents: Array<{
            __typename?: "AgentParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
            officeName?: string | undefined;
            officeId?: string | undefined;
            mlsAgentId?: string | undefined;
          }>;
          transactionCoordinators: Array<{
            __typename?: "ClientParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
          }>;
          loanOfficers: Array<{
            __typename?: "ClientParticipant";
            email?: string | undefined;
            name: string;
            phoneNumber?: string | undefined;
          }>;
        }
      | undefined;
    transactionPipeline?:
      | {
          __typename?: "TransactionPipelineObject";
          id: string;
          clientType: ClientType;
          usState: UsState;
          transactionPropertyType: TransactionPropertyType;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                originatingSystemName?: string | undefined;
                statusText: string;
                logoUrl?: string | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            full: string;
            unit?: string | undefined;
            city: string;
            state: string;
            postalCode?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                type?: MlsListingType | undefined;
                subType?: string | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type ExternalGetIngestionFolderValidationFeedbackQueryVariables = Exact<{
  input: ExternalGetIngestionFolderValidationFeedbackInput;
}>;

export type ExternalGetIngestionFolderValidationFeedbackQuery = {
  __typename?: "Query";
  externalGetIngestionFolderValidationFeedback: Array<{
    __typename?: "IngestionFolderValidationFeedbackObject";
    id: string;
    feedbackType: FeedbackType;
    source: FeedbackSource;
    comment?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    ingestionFolderValidation?:
      | { __typename?: "IngestionFolderValidationObject"; id: string }
      | undefined;
  }>;
};

export type ExternalGetValidationReportDataQueryVariables = Exact<{
  input: ExternalGetValidationReportDataInput;
}>;

export type ExternalGetValidationReportDataQuery = {
  __typename?: "Query";
  externalGetValidationReportData?:
    | {
        __typename?: "ValidationReportDataObject";
        keyTerms?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        documentValidations: Array<{
          __typename?: "IngestionDocumentValidationObject";
          id: string;
          isCurrent: boolean;
          version: string;
          errorCount: number;
          warningCount: number;
          aiErrorCount: number;
          aiWarningCount: number;
          validationResults: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          aiValidationResults: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          aiAnalysis: Array<
            Record<string, string | number | boolean | string[] | undefined>
          >;
          createdAt: any;
          updatedAt: any;
          transactionStage?:
            | {
                __typename?: "TransactionStageObject";
                id: string;
                stage: TransactionStageType;
              }
            | undefined;
          ingestionDocument: {
            __typename?: "IngestionDocumentObject";
            id: string;
          };
        }>;
        folderValidation?:
          | {
              __typename?: "IngestionFolderValidationObject";
              id: string;
              isCurrent: boolean;
              version: string;
              errorCount: number;
              validationResults?:
                | Array<
                    Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  >
                | undefined;
              createdAt: any;
              validatedAt: any;
              updatedAt: any;
              ingestionFolder?:
                | { __typename?: "IngestionFolderObject"; id: string }
                | undefined;
            }
          | undefined;
        property?:
          | {
              __typename?: "DocumentPropertyObject";
              id: string;
              slug: string;
              streetAddress: string;
              unit?: string | undefined;
              city: string;
              state: UsState;
              zipCode: string;
              zipCodePlus4?: string | undefined;
              county: string;
              countyFips: string;
              msa?: string | undefined;
              lot: string;
              block: string;
              platBook: string;
              platBookPage: string;
              subdivision: string;
              parcelId: string;
              yearBuilt?: number | undefined;
              otherLegalDescription: string;
              geo?:
                | { __typename?: "DocumentGeoObject"; lat: number; lng: number }
                | undefined;
            }
          | undefined;
        autofillData?:
          | {
              __typename?: "OfferIngestionAutofillObject";
              ingestion: {
                __typename?: "OfferIngestionFolderObject";
                transactionSide: TransactionSide;
                metadata: {
                  __typename?: "OfferIngestionMetadataObject";
                  agent_name?: string | undefined;
                  folder_name?: string | undefined;
                  folder_id?: string | undefined;
                  office_id?: string | undefined;
                  office_name?: string | undefined;
                  transaction_closing_date?: string | undefined;
                  participants: {
                    __typename?: "OfferIngestionParticipantsObject";
                    buyerAgentNames?: Array<string> | undefined;
                    listingAgentNames?: Array<string> | undefined;
                    buyerNames?: Array<string> | undefined;
                    sellerNames?: Array<string> | undefined;
                    otherTeamMemberNames?: Array<string> | undefined;
                  };
                };
              };
            }
          | undefined;
      }
    | undefined;
};

export type ExternalIngestionDocumentsForFolderQueryVariables = Exact<{
  input: ExternalIngestionDocumentsForFolderInput;
}>;

export type ExternalIngestionDocumentsForFolderQuery = {
  __typename?: "Query";
  externalIngestionDocumentsForFolder: Array<{
    __typename?: "IngestionDocumentObject";
    id: string;
    documentId: string;
    documentName: string;
    documentCreatedAt: any;
    documentUpdatedAt: any;
    fileUrl?: string | undefined;
    isBlank: boolean;
    needsReview?: boolean | undefined;
    isArchived: boolean;
    isClassified: boolean;
    version: string;
    complianceStatus?: string | undefined;
    complianceGroupId?: string | undefined;
    complianceStatusId?: string | undefined;
    folderName?: string | undefined;
    folderId?: string | undefined;
    wasAutoApproved: boolean;
    contractDocumentPages?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      order: number;
      documentCategory?: string | undefined;
      externalDocumentName?: string | undefined;
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            document: {
              __typename?: "DocumentObject";
              id: string;
              name: string;
              form: string;
              documentType: DocumentType;
            };
          }
        | undefined;
      file: { __typename?: "FileObject"; url: string };
    }>;
  }>;
};

export type ExternalIngestionFolderListForOrganizationQueryVariables = Exact<{
  input: ExternalIngestionFolderListForOrganizationInput;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  includeTransactionPipeline?: Scalars["Boolean"]["input"];
}>;

export type ExternalIngestionFolderListForOrganizationQuery = {
  __typename?: "Query";
  externalIngestionFolderListForOrganization?:
    | {
        __typename?: "IngestionFolderObjectExternalPaginated";
        results?:
          | Array<{
              __typename?: "IngestionFolderObject";
              id: string;
              organizationUuid: string;
              folderId: string;
              folderName: string;
              transactionSide: TransactionSide;
              status: string;
              normalizedStatus?: NormalizedTransactionStatus | undefined;
              stage?: TransactionStageType | undefined;
              platform: IngestionPlatform;
              folderUpdatedAt?: any | undefined;
              folderCreatedAt?: any | undefined;
              metadata: Record<
                string,
                string | number | boolean | string[] | undefined
              >;
              validationErrorCount?: number | undefined;
              keyTermColumns?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              transactionPipeline?:
                | {
                    __typename?: "TransactionPipelineObject";
                    id: string;
                    usState: UsState;
                    transactionPropertyType: TransactionPropertyType;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
            }
          | undefined;
      }
    | undefined;
};

export type ExternalIngestionFolderPlatformUrlQueryVariables = Exact<{
  input: ExternalIngestionFolderPlatformUrlInput;
}>;

export type ExternalIngestionFolderPlatformUrlQuery = {
  __typename?: "Query";
  externalIngestionFolderPlatformUrl?: string | undefined;
};

export type FindMlsAgentFragment = {
  __typename?: "FindMLSAgentPayload";
  mlsAgent?:
    | {
        __typename?: "RESOMemberObject";
        MemberFirstName?: string | undefined;
        MemberLastName?: string | undefined;
        MemberFullName?: string | undefined;
        MemberMiddleName?: string | undefined;
        MemberEmail?: string | undefined;
        MemberDirectPhone?: string | undefined;
        MemberMobilePhone?: string | undefined;
        MemberMlsId?: string | undefined;
        MemberNationalAssociationId?: string | undefined;
        OfficeMlsId?: string | undefined;
        MemberStatus?: string | undefined;
        OriginatingSystemName?: string | undefined;
        Media?:
          | Array<{
              __typename?: "MediaObject";
              MediaKey?: string | undefined;
              MediaURL?: string | undefined;
              ImageWidth?: number | undefined;
              ImageHeight?: number | undefined;
              ImageSizeDescription?: string | undefined;
              MediaModificationTimestamp?: string | undefined;
            }>
          | undefined;
      }
    | undefined;
  mls?:
    | {
        __typename?: "MLSObject";
        id: string;
        name: string;
        memberIdPrefix?: string | undefined;
        originatingSystemName?: string | undefined;
      }
    | undefined;
  office?:
    | {
        __typename?: "RESOOfficeObject";
        OfficeName?: string | undefined;
        OfficeEmail?: string | undefined;
        OfficeKey?: string | undefined;
        OfficeMlsId?: string | undefined;
        OfficeStatus?: string | undefined;
        OriginatingSystemName?: string | undefined;
      }
    | undefined;
};

export type FindMlsAgentQueryVariables = Exact<{
  input: FindMlsAgentInput;
}>;

export type FindMlsAgentQuery = {
  __typename?: "Query";
  findMLSAgent: {
    __typename?: "FindMLSAgentPayload";
    mlsAgent?:
      | {
          __typename?: "RESOMemberObject";
          MemberFirstName?: string | undefined;
          MemberLastName?: string | undefined;
          MemberFullName?: string | undefined;
          MemberMiddleName?: string | undefined;
          MemberEmail?: string | undefined;
          MemberDirectPhone?: string | undefined;
          MemberMobilePhone?: string | undefined;
          MemberMlsId?: string | undefined;
          MemberNationalAssociationId?: string | undefined;
          OfficeMlsId?: string | undefined;
          MemberStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
          Media?:
            | Array<{
                __typename?: "MediaObject";
                MediaKey?: string | undefined;
                MediaURL?: string | undefined;
                ImageWidth?: number | undefined;
                ImageHeight?: number | undefined;
                ImageSizeDescription?: string | undefined;
                MediaModificationTimestamp?: string | undefined;
              }>
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSObject";
          id: string;
          name: string;
          memberIdPrefix?: string | undefined;
          originatingSystemName?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "RESOOfficeObject";
          OfficeName?: string | undefined;
          OfficeEmail?: string | undefined;
          OfficeKey?: string | undefined;
          OfficeMlsId?: string | undefined;
          OfficeStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
        }
      | undefined;
  };
};

export type FindMlsAgentByEmailQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type FindMlsAgentByEmailQuery = {
  __typename?: "Query";
  findMLSAgentByEmail?:
    | {
        __typename?: "FindMLSAgentPayload";
        mlsAgent?:
          | {
              __typename?: "RESOMemberObject";
              MemberFirstName?: string | undefined;
              MemberLastName?: string | undefined;
              MemberMobilePhone?: string | undefined;
              MemberEmail?: string | undefined;
              OriginatingSystemName?: string | undefined;
              OfficeMlsId?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "RESOOfficeObject";
              OfficeName?: string | undefined;
              OfficeMlsId?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type FindMlsAgentByMlsIdQueryVariables = Exact<{
  input: FindMlsAgentByMlsIdInput;
}>;

export type FindMlsAgentByMlsIdQuery = {
  __typename?: "Query";
  findMLSAgentByMlsId: {
    __typename?: "FindMLSAgentPayload";
    mlsAgent?:
      | {
          __typename?: "RESOMemberObject";
          MemberFirstName?: string | undefined;
          MemberLastName?: string | undefined;
          MemberFullName?: string | undefined;
          MemberMiddleName?: string | undefined;
          MemberEmail?: string | undefined;
          MemberDirectPhone?: string | undefined;
          MemberMobilePhone?: string | undefined;
          MemberMlsId?: string | undefined;
          MemberNationalAssociationId?: string | undefined;
          OfficeMlsId?: string | undefined;
          MemberStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
          Media?:
            | Array<{
                __typename?: "MediaObject";
                MediaKey?: string | undefined;
                MediaURL?: string | undefined;
                ImageWidth?: number | undefined;
                ImageHeight?: number | undefined;
                ImageSizeDescription?: string | undefined;
                MediaModificationTimestamp?: string | undefined;
              }>
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSObject";
          id: string;
          name: string;
          memberIdPrefix?: string | undefined;
          originatingSystemName?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "RESOOfficeObject";
          OfficeName?: string | undefined;
          OfficeEmail?: string | undefined;
          OfficeKey?: string | undefined;
          OfficeMlsId?: string | undefined;
          OfficeStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
        }
      | undefined;
  };
};

export type FindMlsAgentsByNameQueryVariables = Exact<{
  input: FindMlsAgentsByNameInput;
}>;

export type FindMlsAgentsByNameQuery = {
  __typename?: "Query";
  findMLSAgentsByName: Array<{
    __typename?: "FindMLSAgentPayload";
    mlsAgent?:
      | {
          __typename?: "RESOMemberObject";
          MemberFirstName?: string | undefined;
          MemberLastName?: string | undefined;
          MemberMobilePhone?: string | undefined;
          OriginatingSystemName?: string | undefined;
          OfficeMlsId?: string | undefined;
          MemberMlsId?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "RESOOfficeObject";
          OfficeName?: string | undefined;
          OfficeMlsId?: string | undefined;
        }
      | undefined;
    mls?:
      | { __typename?: "MLSObject"; originatingSystemName?: string | undefined }
      | undefined;
  }>;
};

export type FindMlsAgentsByPhoneNumberQueryVariables = Exact<{
  input: FindMlsAgentsByPhoneNumberInput;
}>;

export type FindMlsAgentsByPhoneNumberQuery = {
  __typename?: "Query";
  findMLSAgentsByPhoneNumber: Array<{
    __typename?: "FindMLSAgentPayload";
    mlsAgent?:
      | {
          __typename?: "RESOMemberObject";
          MemberFirstName?: string | undefined;
          MemberLastName?: string | undefined;
          MemberFullName?: string | undefined;
          MemberMiddleName?: string | undefined;
          MemberEmail?: string | undefined;
          MemberDirectPhone?: string | undefined;
          MemberMobilePhone?: string | undefined;
          MemberMlsId?: string | undefined;
          MemberNationalAssociationId?: string | undefined;
          OfficeMlsId?: string | undefined;
          MemberStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
          Media?:
            | Array<{
                __typename?: "MediaObject";
                MediaKey?: string | undefined;
                MediaURL?: string | undefined;
                ImageWidth?: number | undefined;
                ImageHeight?: number | undefined;
                ImageSizeDescription?: string | undefined;
                MediaModificationTimestamp?: string | undefined;
              }>
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSObject";
          id: string;
          name: string;
          memberIdPrefix?: string | undefined;
          originatingSystemName?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "RESOOfficeObject";
          OfficeName?: string | undefined;
          OfficeEmail?: string | undefined;
          OfficeKey?: string | undefined;
          OfficeMlsId?: string | undefined;
          OfficeStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
        }
      | undefined;
  }>;
};

export type FindMlsListingByAddressQueryVariables = Exact<{
  input: FindMlsListingByAddressInput;
}>;

export type FindMlsListingByAddressQuery = {
  __typename?: "Query";
  findMLSListingByAddress?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
};

export type FindUserCapturedPropertyDetailsByAddressQueryVariables = Exact<{
  input: FindUserCapturedPropertyDetailsByAddressInput;
}>;

export type FindUserCapturedPropertyDetailsByAddressQuery = {
  __typename?: "Query";
  findUserCapturedPropertyDetailsByAddress?:
    | {
        __typename?: "PropertyDetailsObject";
        id: string;
        streetAddress: string;
        city: string;
        state: UsState;
        zipCode: string;
        unit?: string | undefined;
        targetPrice: number;
        areaSqFt: number;
        yearBuilt: number;
        bedrooms: number;
        bathsFull: number;
        bathsHalf?: number | undefined;
        propertyType: MlsListingType;
        propertySubtype: MlsListingSubType;
        subdivision?: string | undefined;
        schoolDistrict?: string | undefined;
        geo: { __typename?: "GeoObject"; lat: number; lng: number };
      }
    | undefined;
};

export type FollowedListingsQueryVariables = Exact<{
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type FollowedListingsQuery = {
  __typename?: "Query";
  followedListings: Array<{
    __typename?: "ListingObject";
    id: string;
    isOwner?: boolean | undefined;
    listDate?: any | undefined;
    offersCountDisplay: string;
    submittedOffersCount: number;
    followerCount?: number | undefined;
    isPremium: boolean;
    status: MlsListingStatus;
    deletedFromRetsFeedAt?: string | undefined;
    property: {
      __typename?: "PropertyObject";
      id: string;
      slug: string;
      state: UsState;
    };
    offersSubmitted?:
      | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
      | undefined;
    listingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    coListingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    listingPreferences?: Array<{
      __typename?: "PreferenceValueObject";
      numberValue?: number | undefined;
      textValue?: string | undefined;
      stringValue?: string | undefined;
      stringArray?: Array<string> | undefined;
      booleanValue?: boolean | undefined;
      dateTimeValue?: any | undefined;
      readOnly?: boolean | undefined;
      preference: {
        __typename?: "PreferenceObject";
        id: string;
        name: string;
        slug: string;
        usStates: Array<UsState>;
        fieldId?: string | undefined;
        valueType: PreferenceValueType;
      };
    }>;
    storefrontSetup?:
      | {
          __typename?: "StorefrontSetupObject";
          continueStep?: StorefrontSetupStep | undefined;
          listingPackage: {
            __typename?: "FileObject";
            fileName: string;
            url: string;
          };
        }
      | undefined;
    setupDetails: {
      __typename?: "StorefrontConfigurationStatusObject";
      hasSetup?: boolean | undefined;
      configuredCount: number;
      progressTotal: number;
      sellerPreferences: boolean;
      comparables: boolean;
      documents: boolean;
    };
  }>;
};

export type GetBoaByShareLinkTokenQueryVariables = Exact<{
  input: GetBoaByShareLinkTokenInput;
  preferenceValues?: Scalars["Boolean"]["input"];
}>;

export type GetBoaByShareLinkTokenQuery = {
  __typename?: "Query";
  getBOAByShareLinkToken: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
    createdAt: any;
    hideOfferScore?: boolean | undefined;
    agentNotes?: string | undefined;
    title?: string | undefined;
    isShared?: boolean | undefined;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    listing?:
      | {
          __typename?: "ListingObject";
          id: string;
          isOwner?: boolean | undefined;
          listDate?: any | undefined;
          offersCountDisplay: string;
          submittedOffersCount: number;
          followerCount?: number | undefined;
          isPremium: boolean;
          status: MlsListingStatus;
          deletedFromRetsFeedAt?: string | undefined;
          property: {
            __typename?: "PropertyObject";
            id: string;
            slug: string;
            state: UsState;
          };
          offersSubmitted?:
            | Array<{
                __typename?: "OfferObject";
                id: string;
                status: OfferStatus;
              }>
            | undefined;
          listingAgent?:
            | {
                __typename?: "AgentObject";
                id: string;
                inboundEmail: string;
                user?:
                  | {
                      __typename?: "UserObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      fullName: string;
                      userName?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coListingAgent?:
            | {
                __typename?: "AgentObject";
                id: string;
                inboundEmail: string;
                user?:
                  | {
                      __typename?: "UserObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      fullName: string;
                      phoneNumber: string;
                      email?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mlsListing?:
            | {
                __typename?: "MLSListingObject";
                id: string;
                mlsId?: number | undefined;
                listingId?: string | undefined;
                listDate?: string | undefined;
                listPrice?: number | undefined;
                originalListPrice?: number | undefined;
                terms?: string | undefined;
                photos: Array<string>;
                remarks?: string | undefined;
                modified?: string | undefined;
                mlsName?: string | undefined;
                deleted_at?: string | undefined;
                addressFull: string;
                agent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                coAgent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                address: {
                  __typename?: "MLSListingAddressObject";
                  city: string;
                  country?: string | undefined;
                  crossStreet?: string | undefined;
                  full: string;
                  postalCode?: string | undefined;
                  state: string;
                  streetName: string;
                  streetNumber?: number | undefined;
                  streetNumberText: string;
                  unit?: string | undefined;
                };
                property?:
                  | {
                      __typename?: "MLSListingPropertyObject";
                      roof?: string | undefined;
                      cooling?: string | undefined;
                      style?: string | undefined;
                      area?: number | undefined;
                      bathsFull?: number | undefined;
                      bathsHalf?: number | undefined;
                      stories?: number | undefined;
                      fireplaces?: number | undefined;
                      flooring?: string | undefined;
                      heating?: string | undefined;
                      bathrooms?: string | undefined;
                      foundation?: string | undefined;
                      poolFeatures?: string | undefined;
                      laundryFeatures?: string | undefined;
                      occupantName?: string | undefined;
                      ownerName?: string | undefined;
                      lotDescription?: string | undefined;
                      acres?: number | undefined;
                      subType?: string | undefined;
                      bedrooms?: number | undefined;
                      interiorFeatures?: string | undefined;
                      lotSize?: string | undefined;
                      areaSource?: string | undefined;
                      maintenanceExpense?: number | undefined;
                      additionalRooms?: string | undefined;
                      exteriorFeatures?: string | undefined;
                      water?: string | undefined;
                      view?: string | undefined;
                      lotSizeArea?: number | undefined;
                      lotSizeAreaUnits?: string | undefined;
                      subdivision?: string | undefined;
                      construction?: string | undefined;
                      type?: MlsListingType | undefined;
                      garageSpaces?: number | undefined;
                      bathsThreeQuarter?: number | undefined;
                      accessibility?: string | undefined;
                      occupantType?: string | undefined;
                      yearBuilt?: number | undefined;
                      subTypeText?: string | undefined;
                    }
                  | undefined;
                office?:
                  | {
                      __typename?: "MLSListingOfficeObject";
                      brokerid?: string | undefined;
                      name?: string | undefined;
                      servingName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                mls?:
                  | {
                      __typename?: "MLSListingMLSObject";
                      statusText: string;
                      status?: MlsListingStatus | undefined;
                      daysOnMarket?: number | undefined;
                      originalEntryTimestamp?: string | undefined;
                      originatingSystemName?: string | undefined;
                      logoUrl?: string | undefined;
                      disclaimer?: string | undefined;
                    }
                  | undefined;
                association?:
                  | {
                      __typename?: "MLSListingAssociationObject";
                      fee?: number | undefined;
                      frequency?: string | undefined;
                      name?: string | undefined;
                      amenities?: string | undefined;
                    }
                  | undefined;
                compliance?:
                  | {
                      __typename?: "MLSListingComplianceObject";
                      buyerAgencyCompensation?: number | undefined;
                      buyerAgencyCompensationType?: string | undefined;
                      subAgencyCompensation?: number | undefined;
                      subAgencyCompensationType?: string | undefined;
                      attributionContact?: string | undefined;
                    }
                  | undefined;
                sales?:
                  | {
                      __typename?: "MLSListingSalesObject";
                      closeDate?: string | undefined;
                      closePrice?: number | undefined;
                      contractDate?: string | undefined;
                    }
                  | undefined;
                geo: {
                  __typename?: "MLSListingGeoObject";
                  location: {
                    __typename?: "GeoPointObject";
                    lat: number;
                    lon: number;
                  };
                };
              }
            | undefined;
          listingPreferences?: Array<{
            __typename?: "PreferenceValueObject";
            numberValue?: number | undefined;
            textValue?: string | undefined;
            stringValue?: string | undefined;
            stringArray?: Array<string> | undefined;
            booleanValue?: boolean | undefined;
            dateTimeValue?: any | undefined;
            readOnly?: boolean | undefined;
            preference: {
              __typename?: "PreferenceObject";
              id: string;
              name: string;
              slug: string;
              usStates: Array<UsState>;
              fieldId?: string | undefined;
              valueType: PreferenceValueType;
            };
          }>;
          storefrontSetup?:
            | {
                __typename?: "StorefrontSetupObject";
                continueStep?: StorefrontSetupStep | undefined;
                listingPackage: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              }
            | undefined;
          setupDetails: {
            __typename?: "StorefrontConfigurationStatusObject";
            hasSetup?: boolean | undefined;
            configuredCount: number;
            progressTotal: number;
            sellerPreferences: boolean;
            comparables: boolean;
            documents: boolean;
          };
        }
      | undefined;
    party?:
      | {
          __typename?: "PartyObject";
          id: string;
          createdAt: any;
          purchaseOffers?:
            | Array<{
                __typename?: "OfferObject";
                id: string;
                updatedAt?: any | undefined;
                listing?:
                  | {
                      __typename?: "ListingObject";
                      id: string;
                      isPremium: boolean;
                      property: {
                        __typename?: "PropertyObject";
                        id: string;
                        slug: string;
                        state: UsState;
                      };
                      mlsListing?:
                        | {
                            __typename?: "MLSListingObject";
                            id: string;
                            mlsId?: number | undefined;
                            listingId?: string | undefined;
                            listDate?: string | undefined;
                            listPrice?: number | undefined;
                            originalListPrice?: number | undefined;
                            terms?: string | undefined;
                            photos: Array<string>;
                            remarks?: string | undefined;
                            modified?: string | undefined;
                            mlsName?: string | undefined;
                            deleted_at?: string | undefined;
                            addressFull: string;
                            agent?:
                              | {
                                  __typename?: "MLSListingAgentObject";
                                  id?: string | undefined;
                                  mlsId?: string | undefined;
                                  firstName?: string | undefined;
                                  lastName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            coAgent?:
                              | {
                                  __typename?: "MLSListingAgentObject";
                                  id?: string | undefined;
                                  mlsId?: string | undefined;
                                  firstName?: string | undefined;
                                  lastName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            address: {
                              __typename?: "MLSListingAddressObject";
                              city: string;
                              country?: string | undefined;
                              crossStreet?: string | undefined;
                              full: string;
                              postalCode?: string | undefined;
                              state: string;
                              streetName: string;
                              streetNumber?: number | undefined;
                              streetNumberText: string;
                              unit?: string | undefined;
                            };
                            property?:
                              | {
                                  __typename?: "MLSListingPropertyObject";
                                  roof?: string | undefined;
                                  cooling?: string | undefined;
                                  style?: string | undefined;
                                  area?: number | undefined;
                                  bathsFull?: number | undefined;
                                  bathsHalf?: number | undefined;
                                  stories?: number | undefined;
                                  fireplaces?: number | undefined;
                                  flooring?: string | undefined;
                                  heating?: string | undefined;
                                  bathrooms?: string | undefined;
                                  foundation?: string | undefined;
                                  poolFeatures?: string | undefined;
                                  laundryFeatures?: string | undefined;
                                  occupantName?: string | undefined;
                                  ownerName?: string | undefined;
                                  lotDescription?: string | undefined;
                                  acres?: number | undefined;
                                  subType?: string | undefined;
                                  bedrooms?: number | undefined;
                                  interiorFeatures?: string | undefined;
                                  lotSize?: string | undefined;
                                  areaSource?: string | undefined;
                                  maintenanceExpense?: number | undefined;
                                  additionalRooms?: string | undefined;
                                  exteriorFeatures?: string | undefined;
                                  water?: string | undefined;
                                  view?: string | undefined;
                                  lotSizeArea?: number | undefined;
                                  lotSizeAreaUnits?: string | undefined;
                                  subdivision?: string | undefined;
                                  construction?: string | undefined;
                                  type?: MlsListingType | undefined;
                                  garageSpaces?: number | undefined;
                                  bathsThreeQuarter?: number | undefined;
                                  accessibility?: string | undefined;
                                  occupantType?: string | undefined;
                                  yearBuilt?: number | undefined;
                                  subTypeText?: string | undefined;
                                }
                              | undefined;
                            office?:
                              | {
                                  __typename?: "MLSListingOfficeObject";
                                  brokerid?: string | undefined;
                                  name?: string | undefined;
                                  servingName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            mls?:
                              | {
                                  __typename?: "MLSListingMLSObject";
                                  statusText: string;
                                  status?: MlsListingStatus | undefined;
                                  daysOnMarket?: number | undefined;
                                  originalEntryTimestamp?: string | undefined;
                                  originatingSystemName?: string | undefined;
                                  logoUrl?: string | undefined;
                                  disclaimer?: string | undefined;
                                }
                              | undefined;
                            association?:
                              | {
                                  __typename?: "MLSListingAssociationObject";
                                  fee?: number | undefined;
                                  frequency?: string | undefined;
                                  name?: string | undefined;
                                  amenities?: string | undefined;
                                }
                              | undefined;
                            compliance?:
                              | {
                                  __typename?: "MLSListingComplianceObject";
                                  buyerAgencyCompensation?: number | undefined;
                                  buyerAgencyCompensationType?:
                                    | string
                                    | undefined;
                                  subAgencyCompensation?: number | undefined;
                                  subAgencyCompensationType?:
                                    | string
                                    | undefined;
                                  attributionContact?: string | undefined;
                                }
                              | undefined;
                            sales?:
                              | {
                                  __typename?: "MLSListingSalesObject";
                                  closeDate?: string | undefined;
                                  closePrice?: number | undefined;
                                  contractDate?: string | undefined;
                                }
                              | undefined;
                            geo: {
                              __typename?: "MLSListingGeoObject";
                              location: {
                                __typename?: "GeoPointObject";
                                lat: number;
                                lon: number;
                              };
                            };
                          }
                        | undefined;
                      listingAgent?:
                        | {
                            __typename?: "AgentObject";
                            id: string;
                            user?:
                              | { __typename?: "UserObject"; id: string }
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }>
            | undefined;
          primaryConsumer: {
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          };
          secondaryConsumers: Array<{
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          }>;
          partyFinancing?:
            | {
                __typename?: "PartyFinancingObject";
                id: string;
                financingType?: FinancingType | undefined;
                loanAmount?: number | undefined;
                percentDownPayment?: number | undefined;
                cashReserves?: number | undefined;
                preapprovalFile?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    indigoOfferRecs?:
      | {
          __typename?: "OfferRecsPayload";
          keyTerms: Array<
            | {
                __typename: "KeyTerm";
                label?: string | undefined;
                type: KeyTermType;
                unit: KeyTermUnit;
                recommendation: number;
                context: {
                  __typename?: "KeyTermRecommendationContext";
                  marketData: {
                    __typename?: "MarketDataRange";
                    low: number;
                    high: number;
                  };
                  marketDataPercentages?:
                    | {
                        __typename?: "MarketDataPercentages";
                        yes: number;
                        no: number;
                      }
                    | undefined;
                  source:
                    | { __typename: "CompsSource"; type: MarketDataSourceType }
                    | {
                        __typename: "IndigoOffersSource";
                        type: MarketDataSourceType;
                        metadata: {
                          __typename?: "IndigoOffersMetadata";
                          confidence: ConfidenceLevel;
                          distanceMiles: number;
                          timePeriodMonths: number;
                        };
                      }
                    | { __typename: "MLSSource"; type: MarketDataSourceType };
                };
              }
            | {
                __typename: "KeyTermError";
                label?: string | undefined;
                type: KeyTermType;
                unit: KeyTermUnit;
                reason: string;
                sourceType: MarketDataSourceType;
              }
          >;
          contingencies: Array<
            | {
                __typename: "Contingency";
                type: ContingencyType;
                recommendation: boolean;
                context: {
                  __typename?: "ContingencyRecommendationContext";
                  marketData: {
                    __typename?: "MarketDataPercentages";
                    yes: number;
                    no: number;
                  };
                  source:
                    | { __typename: "CompsSource"; type: MarketDataSourceType }
                    | {
                        __typename: "IndigoOffersSource";
                        type: MarketDataSourceType;
                        metadata: {
                          __typename?: "IndigoOffersMetadata";
                          confidence: ConfidenceLevel;
                          distanceMiles: number;
                          timePeriodMonths: number;
                        };
                      }
                    | { __typename: "MLSSource"; type: MarketDataSourceType };
                };
              }
            | {
                __typename: "ContingencyError";
                type: ContingencyType;
                reason: string;
              }
          >;
          competitiveness: {
            __typename?: "CompetitivenessScore";
            error?: string | undefined;
            rating: CompetitivenessLevel;
            score: number;
            metrics: {
              __typename?: "CompetitivenessMetrics";
              bidAsk: number;
              bidAskScore: number;
              daysOnMarket: number;
              daysOnMarketScore: number;
              minMarketBidAskRatio?: number | undefined;
              maxMarketBidAskRatio?: number | undefined;
              priceAnalysis: {
                __typename?: "PriceAnalysis";
                avgCompBidAskRatio: number;
                isPotentiallyOverpriced: boolean;
                isPotentiallyUnderpriced: boolean;
                pricePositioning: number;
              };
            };
          };
        }
      | undefined;
    agentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
          competitivenessAdjustment?:
            | {
                __typename?: "CompetitivenessAdjustment";
                adjustedLevel: CompetitivenessLevel;
                reason: string;
              }
            | undefined;
        }
      | undefined;
    prevAgentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
          competitivenessAdjustment?:
            | {
                __typename?: "CompetitivenessAdjustment";
                adjustedLevel: CompetitivenessLevel;
                reason: string;
              }
            | undefined;
        }
      | undefined;
    offerScore?:
      | {
          __typename?: "OfferScore";
          reason: string;
          value: number;
          offerScoreExplanation?: string | undefined;
        }
      | { __typename?: "OfferScoreNotCalculated"; reason: string }
      | undefined;
  };
};

export type GetBoaShareLinksQueryVariables = Exact<{
  buyerOfferAnalysisId: Scalars["String"]["input"];
}>;

export type GetBoaShareLinksQuery = {
  __typename?: "Query";
  getBOAShareLinks: Array<{
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  }>;
};

export type GetBusinessOverviewOfferDetailsQueryVariables = Exact<{
  offerId: Scalars["String"]["input"];
}>;

export type GetBusinessOverviewOfferDetailsQuery = {
  __typename?: "Query";
  getBusinessOverviewOfferDetails: {
    __typename?: "BusinessOverviewOfferDetailsPayload";
    offerToPurchaseUrl: string;
    metadata: {
      __typename?: "GetOfferMetadataObject";
      buyer_name: string;
      buyer_signed: boolean;
      buyer_signed_date?: string | undefined;
      close_date?: string | undefined;
      co_buyer_name: string;
      co_seller_name: string;
      created_at?: string | undefined;
      due_diligence_end_date?: string | undefined;
      due_diligence_fee: number;
      due_diligence_period_in_days: number;
      earnest_money_deposit: number;
      financing_type: string;
      has_financing_contingency: boolean;
      has_home_sale_contingency: boolean;
      id: string;
      indigo_offer_status: string;
      is_entity_buyer: boolean;
      is_entity_seller: boolean;
      listing_agent_email: string;
      listing_agent_name: string;
      metadata: Record<
        string,
        string | number | boolean | string[] | undefined
      >;
      metadata_s3_key: string;
      mls_listing_id: string;
      organization_id: string;
      participants: Record<
        string,
        string | number | boolean | string[] | undefined
      >;
      property_city: string;
      property_full_address: string;
      property_state: string;
      property_street_address: string;
      property_tax_id: string;
      property_unit: string;
      property_zip_code: string;
      purchase_price: number;
      seller_concessions: number;
      seller_name: string;
      seller_signed: boolean;
      seller_signed_date?: string | undefined;
      selling_agent_email: string;
      selling_agent_name: string;
      team_name: string;
      termination_fee: number;
      transaction_side: string;
      updated_at: number;
    };
  };
};

export type GetBuyerOfferAnalysisQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
  preferenceValues?: Scalars["Boolean"]["input"];
}>;

export type GetBuyerOfferAnalysisQuery = {
  __typename?: "Query";
  getBuyerOfferAnalysis: {
    __typename?: "BuyerOfferAnalysisObject";
    id: string;
    createdAt: any;
    hideOfferScore?: boolean | undefined;
    agentNotes?: string | undefined;
    title?: string | undefined;
    isShared?: boolean | undefined;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    listing?:
      | {
          __typename?: "ListingObject";
          id: string;
          isOwner?: boolean | undefined;
          listDate?: any | undefined;
          offersCountDisplay: string;
          submittedOffersCount: number;
          followerCount?: number | undefined;
          isPremium: boolean;
          status: MlsListingStatus;
          deletedFromRetsFeedAt?: string | undefined;
          property: {
            __typename?: "PropertyObject";
            id: string;
            slug: string;
            state: UsState;
          };
          offersSubmitted?:
            | Array<{
                __typename?: "OfferObject";
                id: string;
                status: OfferStatus;
              }>
            | undefined;
          listingAgent?:
            | {
                __typename?: "AgentObject";
                id: string;
                inboundEmail: string;
                user?:
                  | {
                      __typename?: "UserObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      fullName: string;
                      userName?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coListingAgent?:
            | {
                __typename?: "AgentObject";
                id: string;
                inboundEmail: string;
                user?:
                  | {
                      __typename?: "UserObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      fullName: string;
                      phoneNumber: string;
                      email?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mlsListing?:
            | {
                __typename?: "MLSListingObject";
                id: string;
                mlsId?: number | undefined;
                listingId?: string | undefined;
                listDate?: string | undefined;
                listPrice?: number | undefined;
                originalListPrice?: number | undefined;
                terms?: string | undefined;
                photos: Array<string>;
                remarks?: string | undefined;
                modified?: string | undefined;
                mlsName?: string | undefined;
                deleted_at?: string | undefined;
                addressFull: string;
                agent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                coAgent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                address: {
                  __typename?: "MLSListingAddressObject";
                  city: string;
                  country?: string | undefined;
                  crossStreet?: string | undefined;
                  full: string;
                  postalCode?: string | undefined;
                  state: string;
                  streetName: string;
                  streetNumber?: number | undefined;
                  streetNumberText: string;
                  unit?: string | undefined;
                };
                property?:
                  | {
                      __typename?: "MLSListingPropertyObject";
                      roof?: string | undefined;
                      cooling?: string | undefined;
                      style?: string | undefined;
                      area?: number | undefined;
                      bathsFull?: number | undefined;
                      bathsHalf?: number | undefined;
                      stories?: number | undefined;
                      fireplaces?: number | undefined;
                      flooring?: string | undefined;
                      heating?: string | undefined;
                      bathrooms?: string | undefined;
                      foundation?: string | undefined;
                      poolFeatures?: string | undefined;
                      laundryFeatures?: string | undefined;
                      occupantName?: string | undefined;
                      ownerName?: string | undefined;
                      lotDescription?: string | undefined;
                      acres?: number | undefined;
                      subType?: string | undefined;
                      bedrooms?: number | undefined;
                      interiorFeatures?: string | undefined;
                      lotSize?: string | undefined;
                      areaSource?: string | undefined;
                      maintenanceExpense?: number | undefined;
                      additionalRooms?: string | undefined;
                      exteriorFeatures?: string | undefined;
                      water?: string | undefined;
                      view?: string | undefined;
                      lotSizeArea?: number | undefined;
                      lotSizeAreaUnits?: string | undefined;
                      subdivision?: string | undefined;
                      construction?: string | undefined;
                      type?: MlsListingType | undefined;
                      garageSpaces?: number | undefined;
                      bathsThreeQuarter?: number | undefined;
                      accessibility?: string | undefined;
                      occupantType?: string | undefined;
                      yearBuilt?: number | undefined;
                      subTypeText?: string | undefined;
                    }
                  | undefined;
                office?:
                  | {
                      __typename?: "MLSListingOfficeObject";
                      brokerid?: string | undefined;
                      name?: string | undefined;
                      servingName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                mls?:
                  | {
                      __typename?: "MLSListingMLSObject";
                      statusText: string;
                      status?: MlsListingStatus | undefined;
                      daysOnMarket?: number | undefined;
                      originalEntryTimestamp?: string | undefined;
                      originatingSystemName?: string | undefined;
                      logoUrl?: string | undefined;
                      disclaimer?: string | undefined;
                    }
                  | undefined;
                association?:
                  | {
                      __typename?: "MLSListingAssociationObject";
                      fee?: number | undefined;
                      frequency?: string | undefined;
                      name?: string | undefined;
                      amenities?: string | undefined;
                    }
                  | undefined;
                compliance?:
                  | {
                      __typename?: "MLSListingComplianceObject";
                      buyerAgencyCompensation?: number | undefined;
                      buyerAgencyCompensationType?: string | undefined;
                      subAgencyCompensation?: number | undefined;
                      subAgencyCompensationType?: string | undefined;
                      attributionContact?: string | undefined;
                    }
                  | undefined;
                sales?:
                  | {
                      __typename?: "MLSListingSalesObject";
                      closeDate?: string | undefined;
                      closePrice?: number | undefined;
                      contractDate?: string | undefined;
                    }
                  | undefined;
                geo: {
                  __typename?: "MLSListingGeoObject";
                  location: {
                    __typename?: "GeoPointObject";
                    lat: number;
                    lon: number;
                  };
                };
              }
            | undefined;
          listingPreferences?: Array<{
            __typename?: "PreferenceValueObject";
            numberValue?: number | undefined;
            textValue?: string | undefined;
            stringValue?: string | undefined;
            stringArray?: Array<string> | undefined;
            booleanValue?: boolean | undefined;
            dateTimeValue?: any | undefined;
            readOnly?: boolean | undefined;
            preference: {
              __typename?: "PreferenceObject";
              id: string;
              name: string;
              slug: string;
              usStates: Array<UsState>;
              fieldId?: string | undefined;
              valueType: PreferenceValueType;
            };
          }>;
          storefrontSetup?:
            | {
                __typename?: "StorefrontSetupObject";
                continueStep?: StorefrontSetupStep | undefined;
                listingPackage: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
              }
            | undefined;
          setupDetails: {
            __typename?: "StorefrontConfigurationStatusObject";
            hasSetup?: boolean | undefined;
            configuredCount: number;
            progressTotal: number;
            sellerPreferences: boolean;
            comparables: boolean;
            documents: boolean;
          };
        }
      | undefined;
    party?:
      | {
          __typename?: "PartyObject";
          id: string;
          createdAt: any;
          purchaseOffers?:
            | Array<{
                __typename?: "OfferObject";
                id: string;
                updatedAt?: any | undefined;
                listing?:
                  | {
                      __typename?: "ListingObject";
                      id: string;
                      isPremium: boolean;
                      property: {
                        __typename?: "PropertyObject";
                        id: string;
                        slug: string;
                        state: UsState;
                      };
                      mlsListing?:
                        | {
                            __typename?: "MLSListingObject";
                            id: string;
                            mlsId?: number | undefined;
                            listingId?: string | undefined;
                            listDate?: string | undefined;
                            listPrice?: number | undefined;
                            originalListPrice?: number | undefined;
                            terms?: string | undefined;
                            photos: Array<string>;
                            remarks?: string | undefined;
                            modified?: string | undefined;
                            mlsName?: string | undefined;
                            deleted_at?: string | undefined;
                            addressFull: string;
                            agent?:
                              | {
                                  __typename?: "MLSListingAgentObject";
                                  id?: string | undefined;
                                  mlsId?: string | undefined;
                                  firstName?: string | undefined;
                                  lastName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            coAgent?:
                              | {
                                  __typename?: "MLSListingAgentObject";
                                  id?: string | undefined;
                                  mlsId?: string | undefined;
                                  firstName?: string | undefined;
                                  lastName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            address: {
                              __typename?: "MLSListingAddressObject";
                              city: string;
                              country?: string | undefined;
                              crossStreet?: string | undefined;
                              full: string;
                              postalCode?: string | undefined;
                              state: string;
                              streetName: string;
                              streetNumber?: number | undefined;
                              streetNumberText: string;
                              unit?: string | undefined;
                            };
                            property?:
                              | {
                                  __typename?: "MLSListingPropertyObject";
                                  roof?: string | undefined;
                                  cooling?: string | undefined;
                                  style?: string | undefined;
                                  area?: number | undefined;
                                  bathsFull?: number | undefined;
                                  bathsHalf?: number | undefined;
                                  stories?: number | undefined;
                                  fireplaces?: number | undefined;
                                  flooring?: string | undefined;
                                  heating?: string | undefined;
                                  bathrooms?: string | undefined;
                                  foundation?: string | undefined;
                                  poolFeatures?: string | undefined;
                                  laundryFeatures?: string | undefined;
                                  occupantName?: string | undefined;
                                  ownerName?: string | undefined;
                                  lotDescription?: string | undefined;
                                  acres?: number | undefined;
                                  subType?: string | undefined;
                                  bedrooms?: number | undefined;
                                  interiorFeatures?: string | undefined;
                                  lotSize?: string | undefined;
                                  areaSource?: string | undefined;
                                  maintenanceExpense?: number | undefined;
                                  additionalRooms?: string | undefined;
                                  exteriorFeatures?: string | undefined;
                                  water?: string | undefined;
                                  view?: string | undefined;
                                  lotSizeArea?: number | undefined;
                                  lotSizeAreaUnits?: string | undefined;
                                  subdivision?: string | undefined;
                                  construction?: string | undefined;
                                  type?: MlsListingType | undefined;
                                  garageSpaces?: number | undefined;
                                  bathsThreeQuarter?: number | undefined;
                                  accessibility?: string | undefined;
                                  occupantType?: string | undefined;
                                  yearBuilt?: number | undefined;
                                  subTypeText?: string | undefined;
                                }
                              | undefined;
                            office?:
                              | {
                                  __typename?: "MLSListingOfficeObject";
                                  brokerid?: string | undefined;
                                  name?: string | undefined;
                                  servingName?: string | undefined;
                                  contact?:
                                    | {
                                        __typename?: "MLSListingContactObject";
                                        email?: string | undefined;
                                        office?: string | undefined;
                                        cell?: string | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                            mls?:
                              | {
                                  __typename?: "MLSListingMLSObject";
                                  statusText: string;
                                  status?: MlsListingStatus | undefined;
                                  daysOnMarket?: number | undefined;
                                  originalEntryTimestamp?: string | undefined;
                                  originatingSystemName?: string | undefined;
                                  logoUrl?: string | undefined;
                                  disclaimer?: string | undefined;
                                }
                              | undefined;
                            association?:
                              | {
                                  __typename?: "MLSListingAssociationObject";
                                  fee?: number | undefined;
                                  frequency?: string | undefined;
                                  name?: string | undefined;
                                  amenities?: string | undefined;
                                }
                              | undefined;
                            compliance?:
                              | {
                                  __typename?: "MLSListingComplianceObject";
                                  buyerAgencyCompensation?: number | undefined;
                                  buyerAgencyCompensationType?:
                                    | string
                                    | undefined;
                                  subAgencyCompensation?: number | undefined;
                                  subAgencyCompensationType?:
                                    | string
                                    | undefined;
                                  attributionContact?: string | undefined;
                                }
                              | undefined;
                            sales?:
                              | {
                                  __typename?: "MLSListingSalesObject";
                                  closeDate?: string | undefined;
                                  closePrice?: number | undefined;
                                  contractDate?: string | undefined;
                                }
                              | undefined;
                            geo: {
                              __typename?: "MLSListingGeoObject";
                              location: {
                                __typename?: "GeoPointObject";
                                lat: number;
                                lon: number;
                              };
                            };
                          }
                        | undefined;
                      listingAgent?:
                        | {
                            __typename?: "AgentObject";
                            id: string;
                            user?:
                              | { __typename?: "UserObject"; id: string }
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }>
            | undefined;
          primaryConsumer: {
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          };
          secondaryConsumers: Array<{
            __typename?: "ConsumerObject";
            id: string;
            email?: string | undefined;
            fullName: string;
            phoneNumber?: string | undefined;
            isEntity: boolean;
            entityName?: string | undefined;
            entityTitle?: string | undefined;
            profilePicture?:
              | { __typename?: "FileObject"; fileName: string; url: string }
              | undefined;
          }>;
          partyFinancing?:
            | {
                __typename?: "PartyFinancingObject";
                id: string;
                financingType?: FinancingType | undefined;
                loanAmount?: number | undefined;
                percentDownPayment?: number | undefined;
                cashReserves?: number | undefined;
                preapprovalFile?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    indigoOfferRecs?:
      | {
          __typename?: "OfferRecsPayload";
          keyTerms: Array<
            | {
                __typename: "KeyTerm";
                label?: string | undefined;
                type: KeyTermType;
                unit: KeyTermUnit;
                recommendation: number;
                context: {
                  __typename?: "KeyTermRecommendationContext";
                  marketData: {
                    __typename?: "MarketDataRange";
                    low: number;
                    high: number;
                  };
                  marketDataPercentages?:
                    | {
                        __typename?: "MarketDataPercentages";
                        yes: number;
                        no: number;
                      }
                    | undefined;
                  source:
                    | { __typename: "CompsSource"; type: MarketDataSourceType }
                    | {
                        __typename: "IndigoOffersSource";
                        type: MarketDataSourceType;
                        metadata: {
                          __typename?: "IndigoOffersMetadata";
                          confidence: ConfidenceLevel;
                          distanceMiles: number;
                          timePeriodMonths: number;
                        };
                      }
                    | { __typename: "MLSSource"; type: MarketDataSourceType };
                };
              }
            | {
                __typename: "KeyTermError";
                label?: string | undefined;
                type: KeyTermType;
                unit: KeyTermUnit;
                reason: string;
                sourceType: MarketDataSourceType;
              }
          >;
          contingencies: Array<
            | {
                __typename: "Contingency";
                type: ContingencyType;
                recommendation: boolean;
                context: {
                  __typename?: "ContingencyRecommendationContext";
                  marketData: {
                    __typename?: "MarketDataPercentages";
                    yes: number;
                    no: number;
                  };
                  source:
                    | { __typename: "CompsSource"; type: MarketDataSourceType }
                    | {
                        __typename: "IndigoOffersSource";
                        type: MarketDataSourceType;
                        metadata: {
                          __typename?: "IndigoOffersMetadata";
                          confidence: ConfidenceLevel;
                          distanceMiles: number;
                          timePeriodMonths: number;
                        };
                      }
                    | { __typename: "MLSSource"; type: MarketDataSourceType };
                };
              }
            | {
                __typename: "ContingencyError";
                type: ContingencyType;
                reason: string;
              }
          >;
          competitiveness: {
            __typename?: "CompetitivenessScore";
            error?: string | undefined;
            rating: CompetitivenessLevel;
            score: number;
            metrics: {
              __typename?: "CompetitivenessMetrics";
              bidAsk: number;
              bidAskScore: number;
              daysOnMarket: number;
              daysOnMarketScore: number;
              minMarketBidAskRatio?: number | undefined;
              maxMarketBidAskRatio?: number | undefined;
              priceAnalysis: {
                __typename?: "PriceAnalysis";
                avgCompBidAskRatio: number;
                isPotentiallyOverpriced: boolean;
                isPotentiallyUnderpriced: boolean;
                pricePositioning: number;
              };
            };
          };
        }
      | undefined;
    agentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
          competitivenessAdjustment?:
            | {
                __typename?: "CompetitivenessAdjustment";
                adjustedLevel: CompetitivenessLevel;
                reason: string;
              }
            | undefined;
        }
      | undefined;
    prevAgentOfferRecs?:
      | {
          __typename?: "AgentOfferRecsPayload";
          contingencies?:
            | Array<{
                __typename?: "AgentContingencyOfferRec";
                value?: boolean | undefined;
                notes?: string | undefined;
                type: ContingencyType;
              }>
            | undefined;
          keyTerms?:
            | Array<{
                __typename?: "AgentKeyTermsOfferRec";
                value?: number | undefined;
                notes?: string | undefined;
                type: KeyTermType;
              }>
            | undefined;
          competitivenessAdjustment?:
            | {
                __typename?: "CompetitivenessAdjustment";
                adjustedLevel: CompetitivenessLevel;
                reason: string;
              }
            | undefined;
        }
      | undefined;
    offerScore?:
      | {
          __typename?: "OfferScore";
          reason: string;
          value: number;
          offerScoreExplanation?: string | undefined;
        }
      | { __typename?: "OfferScoreNotCalculated"; reason: string }
      | undefined;
  };
};

export type GetIngestionDocumentReviewsQueryVariables = Exact<{
  input: ExternalGetIngestionDocumentReviewsInput;
}>;

export type GetIngestionDocumentReviewsQuery = {
  __typename?: "Query";
  externalGetIngestionDocumentReviews: Array<{
    __typename?: "IngestionDocumentReviewObject";
    id: string;
    createdAt: any;
    updatedAt: any;
    status: IngestionDocumentReviewStatus;
    version: string;
    reviewedAt: any;
    reviewedByUserUuid: string;
    reason?: string | undefined;
    ingestionDocument: {
      __typename?: "IngestionDocumentObject";
      id: string;
      documentId: string;
      documentName: string;
      version: string;
    };
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
  }>;
};

export type GetIngestionDocumentValidationErrorReviewsQueryVariables = Exact<{
  input: ExternalGetIngestionDocumentValidationErrorReviewsInput;
}>;

export type GetIngestionDocumentValidationErrorReviewsQuery = {
  __typename?: "Query";
  externalGetIngestionDocumentValidationErrorReviews: Array<{
    __typename?: "IngestionDocumentValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    contractDocumentUuid?: string | undefined;
    ruleUuid?: string | undefined;
    pageNumber?: number | undefined;
    ingestionDocument?:
      | {
          __typename?: "IngestionDocumentObject";
          id: string;
          documentId: string;
          documentName: string;
        }
      | undefined;
    ingestionDocumentValidation?:
      | {
          __typename?: "IngestionDocumentValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  }>;
};

export type GetIngestionFolderValidationErrorReviewsQueryVariables = Exact<{
  input: ExternalGetIngestionFolderValidationErrorReviewsInput;
}>;

export type GetIngestionFolderValidationErrorReviewsQuery = {
  __typename?: "Query";
  externalGetIngestionFolderValidationErrorReviews: Array<{
    __typename?: "IngestionFolderValidationErrorReviewObject";
    id: string;
    isHidden: boolean;
    isAddedByUser: boolean;
    message?: string | undefined;
    createdByUserUuid: string;
    updatedByUserUuid: string;
    createdAt: any;
    updatedAt: any;
    documentCategory?: string | undefined;
    documentForm?: string | undefined;
    documentName?: string | undefined;
    ruleUuid?: string | undefined;
    ingestionFolderValidation?:
      | {
          __typename?: "IngestionFolderValidationObject";
          id: string;
          version: string;
        }
      | undefined;
    submission?:
      | {
          __typename?: "ValidationReviewSubmissionObject";
          id: string;
          submittedAt: any;
          submittedByUserUuid: string;
        }
      | undefined;
    validationIssueGroup?:
      | {
          __typename?: "ValidationIssueGroupObject";
          id: string;
          kind: string;
          platform: string;
          normalizedStatus?: NormalizedTransactionStatus | undefined;
          ruleUuid?: string | undefined;
          primaryForm?: string | undefined;
          documentCategory?: string | undefined;
          documentForm?: string | undefined;
          documentName?: string | undefined;
          normalizedMessage: string;
          linearIssueId?: string | undefined;
          linearTicketUrl?: string | undefined;
          status: string;
          firstSeenAt: any;
          lastSeenAt: any;
          totalReviewCount: number;
          activeReviewCount: number;
          uniqueOrgCount: number;
          uniqueFolderCount: number;
          uniqueUserCount: number;
        }
      | undefined;
  }>;
};

export type GetInviteeDetailByCodeQueryVariables = Exact<{
  input: SendOtpFromInvitationLinkInput;
}>;

export type GetInviteeDetailByCodeQuery = {
  __typename?: "Query";
  getInviteeDetailByCode?:
    | {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        email?: string | undefined;
        phoneNumber: string;
      }
    | undefined;
};

export type ListingPricingEvaluationFragment = {
  __typename?: "ListingPricingEvaluationObject";
  analysis: string;
  adjustedComps: Array<{
    __typename?: "AdjustedComp";
    address: string;
    closePrice: number;
    adjustmentReason: string;
    finalAdjustedPrice: number;
  }>;
};

export type GetListingPricingEvaluationStatusQueryVariables = Exact<{
  input: ListingPricingEvaluationInput;
}>;

export type GetListingPricingEvaluationStatusQuery = {
  __typename?: "Query";
  getListingPricingEvaluationStatus?:
    | {
        __typename?: "PricingEvaluationJobObject";
        status: PricingEvaluationJobStatus;
        errorMessage?: string | undefined;
        processingStep?: PricingEvaluationStep | undefined;
        evaluation?:
          | {
              __typename?: "ListingPricingEvaluationObject";
              analysis: string;
              adjustedComps: Array<{
                __typename?: "AdjustedComp";
                address: string;
                closePrice: number;
                adjustmentReason: string;
                finalAdjustedPrice: number;
              }>;
            }
          | undefined;
      }
    | undefined;
};

export type GetListingReportQueryVariables = Exact<{
  input: ListingReportInput;
}>;

export type GetListingReportQuery = {
  __typename?: "Query";
  getListingReport: {
    __typename?: "ListingReportResponse";
    confidence: {
      __typename?: "ReportConfidence";
      confidence: ConfidenceLevel;
      maxDistanceMiles: number;
      maxTimePeriodMonths: number;
      maxClosePrice: number;
      minClosePrice: number;
      zipCode?: string | undefined;
      subType?: string | undefined;
      subTypes?: Array<string> | undefined;
    };
    charts: Array<{
      __typename?: "ChartCard";
      title: string;
      chart?:
        | {
            __typename?: "ChartData";
            type: ListingReportChartType;
            title: string;
            valueUnit: ChartUnit;
            labelUnit: ChartUnit;
            styleConfig: {
              __typename?: "ChartStyleConfig";
              showLegend: boolean;
            };
            mainMetric: {
              __typename?: "ChartMetric";
              value?: number | undefined;
              description: string;
              unit: ChartUnit;
              trend?:
                | {
                    __typename?: "ChartTrend";
                    value?: number | undefined;
                    period: string;
                  }
                | undefined;
            };
            data: Array<{
              __typename?: "ChartDataPoint";
              label: string;
              value?: number | undefined;
            }>;
            verticalReferenceLine?:
              | {
                  __typename?: "ChartDataPoint";
                  label: string;
                  value?: number | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
    tables: Array<{
      __typename?: "TableData";
      title: string;
      columns: Array<{
        __typename?: "TableColumn";
        title: string;
        summary?: string | undefined;
        key: string;
        isHighlighted: boolean;
      }>;
      rows: Array<{
        __typename?: "TableRow";
        title: string;
        data?:
          | {
              __typename?: "OffersByFinancingTypeTableRow";
              allTypes: {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              };
              cash?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              conventional?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              fhaVaUsda?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              other?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>;
    }>;
  };
};

export type GetListingReportByShareLinkTokenQueryVariables = Exact<{
  input: GetListingReportByShareLinkTokenInput;
}>;

export type GetListingReportByShareLinkTokenQuery = {
  __typename?: "Query";
  getListingReportByShareLinkToken: {
    __typename?: "ListingReportResponse";
    confidence: {
      __typename?: "ReportConfidence";
      confidence: ConfidenceLevel;
      maxDistanceMiles: number;
      maxTimePeriodMonths: number;
      maxClosePrice: number;
      minClosePrice: number;
      zipCode?: string | undefined;
      subType?: string | undefined;
      subTypes?: Array<string> | undefined;
    };
    charts: Array<{
      __typename?: "ChartCard";
      title: string;
      chart?:
        | {
            __typename?: "ChartData";
            type: ListingReportChartType;
            title: string;
            valueUnit: ChartUnit;
            labelUnit: ChartUnit;
            styleConfig: {
              __typename?: "ChartStyleConfig";
              showLegend: boolean;
            };
            mainMetric: {
              __typename?: "ChartMetric";
              value?: number | undefined;
              description: string;
              unit: ChartUnit;
              trend?:
                | {
                    __typename?: "ChartTrend";
                    value?: number | undefined;
                    period: string;
                  }
                | undefined;
            };
            data: Array<{
              __typename?: "ChartDataPoint";
              label: string;
              value?: number | undefined;
            }>;
            verticalReferenceLine?:
              | {
                  __typename?: "ChartDataPoint";
                  label: string;
                  value?: number | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
    tables: Array<{
      __typename?: "TableData";
      title: string;
      columns: Array<{
        __typename?: "TableColumn";
        title: string;
        summary?: string | undefined;
        key: string;
        isHighlighted: boolean;
      }>;
      rows: Array<{
        __typename?: "TableRow";
        title: string;
        data?:
          | {
              __typename?: "OffersByFinancingTypeTableRow";
              allTypes: {
                __typename?: "TableRowDataValue";
                value: string;
                subValue?: string | undefined;
              };
              cash?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              conventional?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              fhaVaUsda?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
              other?:
                | {
                    __typename?: "TableRowDataValue";
                    value: string;
                    subValue?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
      }>;
    }>;
  };
};

export type GetListingReportPdfQueryVariables = Exact<{
  input: GetListingReportPdfInput;
}>;

export type GetListingReportPdfQuery = {
  __typename?: "Query";
  getListingReportPdf: {
    __typename?: "ListingReportPdfResponse";
    file: { __typename?: "FileObject"; url: string; fileName: string };
  };
};

export type GetListingReportShareLinksQueryVariables = Exact<{
  input: GetListingReportShareLinksInput;
}>;

export type GetListingReportShareLinksQuery = {
  __typename?: "Query";
  getListingReportShareLinks: Array<{
    __typename?: "ShareLinkObject";
    id: string;
    token: string;
    expiresAt?: any | undefined;
    accessType: ShareLinkAccessType;
    status: ShareLinkStatus;
    recipientEmail?: string | undefined;
    recipientPhoneNumber?: string | undefined;
    isForPdf: boolean;
  }>;
};

export type GetOfferForBuyersAgentQueryVariables = Exact<{
  input: GetOfferForBuyersAgentInput;
}>;

export type GetOfferForBuyersAgentQuery = {
  __typename?: "Query";
  getOfferForBuyersAgent: {
    __typename?: "OfferObject";
    id: string;
    status: OfferStatus;
    source?: OfferSource | undefined;
    isUploaded: boolean;
    submittedAt?: any | undefined;
    noteToListingAgent?: string | undefined;
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          enabledSecondaryDocumentVersionsFromRules?: Array<string> | undefined;
          validations?:
            | Array<{
                __typename?: "ContractValidationObject";
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  group: string;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                documentVersionField: {
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                results: Array<{
                  __typename?: "RuleValidationObject";
                  inputValue?: string | undefined;
                  message: string;
                  validationValue?: string | undefined;
                  rule: {
                    __typename?: "RuleObject";
                    id: string;
                    ruleType: RuleType;
                  };
                }>;
              }>
            | undefined;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            order: number;
            externalDocumentType?: ExternalDocumentType | undefined;
            externalDocumentName?: string | undefined;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  mappingKeys: Array<string>;
                  version: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
            fields?:
              | Array<{
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                  labelBoundingBox?:
                    | {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      }
                    | undefined;
                  labelField?:
                    | {
                        __typename?: "LabelFieldObject";
                        height: number;
                        width: number;
                        x: number;
                        y: number;
                      }
                    | undefined;
                }>
              | undefined;
          }>;
          signatureRequests?:
            | Array<{
                __typename?: "SignatureRequestObject";
                id: string;
                provider: SignatureProvider;
                externalId: string;
                allSignedDocument?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }>
            | undefined;
        }
      | undefined;
    listing?:
      | {
          __typename?: "ListingObject";
          id: string;
          property: {
            __typename?: "PropertyObject";
            id: string;
            slug: string;
            state: UsState;
          };
          mlsListing?:
            | {
                __typename?: "MLSListingObject";
                id: string;
                mlsId?: number | undefined;
                listingId?: string | undefined;
                listDate?: string | undefined;
                listPrice?: number | undefined;
                originalListPrice?: number | undefined;
                terms?: string | undefined;
                photos: Array<string>;
                remarks?: string | undefined;
                modified?: string | undefined;
                mlsName?: string | undefined;
                deleted_at?: string | undefined;
                addressFull: string;
                agent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                coAgent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                address: {
                  __typename?: "MLSListingAddressObject";
                  city: string;
                  country?: string | undefined;
                  crossStreet?: string | undefined;
                  full: string;
                  postalCode?: string | undefined;
                  state: string;
                  streetName: string;
                  streetNumber?: number | undefined;
                  streetNumberText: string;
                  unit?: string | undefined;
                };
                property?:
                  | {
                      __typename?: "MLSListingPropertyObject";
                      roof?: string | undefined;
                      cooling?: string | undefined;
                      style?: string | undefined;
                      area?: number | undefined;
                      bathsFull?: number | undefined;
                      bathsHalf?: number | undefined;
                      stories?: number | undefined;
                      fireplaces?: number | undefined;
                      flooring?: string | undefined;
                      heating?: string | undefined;
                      bathrooms?: string | undefined;
                      foundation?: string | undefined;
                      poolFeatures?: string | undefined;
                      laundryFeatures?: string | undefined;
                      occupantName?: string | undefined;
                      ownerName?: string | undefined;
                      lotDescription?: string | undefined;
                      acres?: number | undefined;
                      subType?: string | undefined;
                      bedrooms?: number | undefined;
                      interiorFeatures?: string | undefined;
                      lotSize?: string | undefined;
                      areaSource?: string | undefined;
                      maintenanceExpense?: number | undefined;
                      additionalRooms?: string | undefined;
                      exteriorFeatures?: string | undefined;
                      water?: string | undefined;
                      view?: string | undefined;
                      lotSizeArea?: number | undefined;
                      lotSizeAreaUnits?: string | undefined;
                      subdivision?: string | undefined;
                      construction?: string | undefined;
                      type?: MlsListingType | undefined;
                      garageSpaces?: number | undefined;
                      bathsThreeQuarter?: number | undefined;
                      accessibility?: string | undefined;
                      occupantType?: string | undefined;
                      yearBuilt?: number | undefined;
                      subTypeText?: string | undefined;
                    }
                  | undefined;
                office?:
                  | {
                      __typename?: "MLSListingOfficeObject";
                      brokerid?: string | undefined;
                      name?: string | undefined;
                      servingName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                mls?:
                  | {
                      __typename?: "MLSListingMLSObject";
                      statusText: string;
                      status?: MlsListingStatus | undefined;
                      daysOnMarket?: number | undefined;
                      originalEntryTimestamp?: string | undefined;
                      originatingSystemName?: string | undefined;
                      logoUrl?: string | undefined;
                      disclaimer?: string | undefined;
                    }
                  | undefined;
                association?:
                  | {
                      __typename?: "MLSListingAssociationObject";
                      fee?: number | undefined;
                      frequency?: string | undefined;
                      name?: string | undefined;
                      amenities?: string | undefined;
                    }
                  | undefined;
                compliance?:
                  | {
                      __typename?: "MLSListingComplianceObject";
                      buyerAgencyCompensation?: number | undefined;
                      buyerAgencyCompensationType?: string | undefined;
                      subAgencyCompensation?: number | undefined;
                      subAgencyCompensationType?: string | undefined;
                      attributionContact?: string | undefined;
                    }
                  | undefined;
                sales?:
                  | {
                      __typename?: "MLSListingSalesObject";
                      closeDate?: string | undefined;
                      closePrice?: number | undefined;
                      contractDate?: string | undefined;
                    }
                  | undefined;
                geo: {
                  __typename?: "MLSListingGeoObject";
                  location: {
                    __typename?: "GeoPointObject";
                    lat: number;
                    lon: number;
                  };
                };
              }
            | undefined;
        }
      | undefined;
    primaryBuyer?:
      | {
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
    secondaryBuyers?:
      | Array<{
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>
      | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    events?:
      | Array<{
          __typename?: "AppEventObject";
          id: string;
          name: string;
          createdAt: any;
        }>
      | undefined;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          fullName: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    party?: { __typename?: "PartyObject"; id: string } | undefined;
  };
};

export type GetOfferForListingAgentQueryVariables = Exact<{
  input: GetOfferForListingAgentInput;
}>;

export type GetOfferForListingAgentQuery = {
  __typename?: "Query";
  getOfferForListingAgent: {
    __typename?: "OfferObject";
    id: string;
    status: OfferStatus;
    source?: OfferSource | undefined;
    isUploaded: boolean;
    submittedAt?: any | undefined;
    noteToListingAgent?: string | undefined;
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          enabledSecondaryDocumentVersionsFromRules?: Array<string> | undefined;
          validations?:
            | Array<{
                __typename?: "ContractValidationObject";
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  group: string;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                documentVersionField: {
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                results: Array<{
                  __typename?: "RuleValidationObject";
                  inputValue?: string | undefined;
                  message: string;
                  validationValue?: string | undefined;
                  rule: {
                    __typename?: "RuleObject";
                    id: string;
                    ruleType: RuleType;
                  };
                }>;
              }>
            | undefined;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            order: number;
            externalDocumentType?: ExternalDocumentType | undefined;
            externalDocumentName?: string | undefined;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  mappingKeys: Array<string>;
                  version: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    name: string;
                    form: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
            fields?:
              | Array<{
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  align: FieldAlign;
                  pageNumber: number;
                  fontFamily: string;
                  fontSize: string;
                  label: string;
                  readOnly?: boolean | undefined;
                  width: number;
                  height: number;
                  x: number;
                  y: number;
                  mappingKey: string;
                  fieldType: FieldType;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                  boundingBox: {
                    __typename?: "BoundingBoxObject";
                    left: number;
                    top: number;
                    right: number;
                    bottom: number;
                  };
                  labelBoundingBox?:
                    | {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      }
                    | undefined;
                  labelField?:
                    | {
                        __typename?: "LabelFieldObject";
                        height: number;
                        width: number;
                        x: number;
                        y: number;
                      }
                    | undefined;
                }>
              | undefined;
          }>;
          signatureRequests?:
            | Array<{
                __typename?: "SignatureRequestObject";
                id: string;
                provider: SignatureProvider;
                externalId: string;
                allSignedDocument?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }>
            | undefined;
        }
      | undefined;
    listing?:
      | {
          __typename?: "ListingObject";
          id: string;
          property: {
            __typename?: "PropertyObject";
            id: string;
            slug: string;
            state: UsState;
          };
          mlsListing?:
            | {
                __typename?: "MLSListingObject";
                id: string;
                mlsId?: number | undefined;
                listingId?: string | undefined;
                listDate?: string | undefined;
                listPrice?: number | undefined;
                originalListPrice?: number | undefined;
                terms?: string | undefined;
                photos: Array<string>;
                remarks?: string | undefined;
                modified?: string | undefined;
                mlsName?: string | undefined;
                deleted_at?: string | undefined;
                addressFull: string;
                agent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                coAgent?:
                  | {
                      __typename?: "MLSListingAgentObject";
                      id?: string | undefined;
                      mlsId?: string | undefined;
                      firstName?: string | undefined;
                      lastName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                address: {
                  __typename?: "MLSListingAddressObject";
                  city: string;
                  country?: string | undefined;
                  crossStreet?: string | undefined;
                  full: string;
                  postalCode?: string | undefined;
                  state: string;
                  streetName: string;
                  streetNumber?: number | undefined;
                  streetNumberText: string;
                  unit?: string | undefined;
                };
                property?:
                  | {
                      __typename?: "MLSListingPropertyObject";
                      roof?: string | undefined;
                      cooling?: string | undefined;
                      style?: string | undefined;
                      area?: number | undefined;
                      bathsFull?: number | undefined;
                      bathsHalf?: number | undefined;
                      stories?: number | undefined;
                      fireplaces?: number | undefined;
                      flooring?: string | undefined;
                      heating?: string | undefined;
                      bathrooms?: string | undefined;
                      foundation?: string | undefined;
                      poolFeatures?: string | undefined;
                      laundryFeatures?: string | undefined;
                      occupantName?: string | undefined;
                      ownerName?: string | undefined;
                      lotDescription?: string | undefined;
                      acres?: number | undefined;
                      subType?: string | undefined;
                      bedrooms?: number | undefined;
                      interiorFeatures?: string | undefined;
                      lotSize?: string | undefined;
                      areaSource?: string | undefined;
                      maintenanceExpense?: number | undefined;
                      additionalRooms?: string | undefined;
                      exteriorFeatures?: string | undefined;
                      water?: string | undefined;
                      view?: string | undefined;
                      lotSizeArea?: number | undefined;
                      lotSizeAreaUnits?: string | undefined;
                      subdivision?: string | undefined;
                      construction?: string | undefined;
                      type?: MlsListingType | undefined;
                      garageSpaces?: number | undefined;
                      bathsThreeQuarter?: number | undefined;
                      accessibility?: string | undefined;
                      occupantType?: string | undefined;
                      yearBuilt?: number | undefined;
                      subTypeText?: string | undefined;
                    }
                  | undefined;
                office?:
                  | {
                      __typename?: "MLSListingOfficeObject";
                      brokerid?: string | undefined;
                      name?: string | undefined;
                      servingName?: string | undefined;
                      contact?:
                        | {
                            __typename?: "MLSListingContactObject";
                            email?: string | undefined;
                            office?: string | undefined;
                            cell?: string | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                mls?:
                  | {
                      __typename?: "MLSListingMLSObject";
                      statusText: string;
                      status?: MlsListingStatus | undefined;
                      daysOnMarket?: number | undefined;
                      originalEntryTimestamp?: string | undefined;
                      originatingSystemName?: string | undefined;
                      logoUrl?: string | undefined;
                      disclaimer?: string | undefined;
                    }
                  | undefined;
                association?:
                  | {
                      __typename?: "MLSListingAssociationObject";
                      fee?: number | undefined;
                      frequency?: string | undefined;
                      name?: string | undefined;
                      amenities?: string | undefined;
                    }
                  | undefined;
                compliance?:
                  | {
                      __typename?: "MLSListingComplianceObject";
                      buyerAgencyCompensation?: number | undefined;
                      buyerAgencyCompensationType?: string | undefined;
                      subAgencyCompensation?: number | undefined;
                      subAgencyCompensationType?: string | undefined;
                      attributionContact?: string | undefined;
                    }
                  | undefined;
                sales?:
                  | {
                      __typename?: "MLSListingSalesObject";
                      closeDate?: string | undefined;
                      closePrice?: number | undefined;
                      contractDate?: string | undefined;
                    }
                  | undefined;
                geo: {
                  __typename?: "MLSListingGeoObject";
                  location: {
                    __typename?: "GeoPointObject";
                    lat: number;
                    lon: number;
                  };
                };
              }
            | undefined;
        }
      | undefined;
    primaryBuyer?:
      | {
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
    secondaryBuyers?:
      | Array<{
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>
      | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    events?:
      | Array<{
          __typename?: "AppEventObject";
          id: string;
          name: string;
          createdAt: any;
        }>
      | undefined;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          fullName: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    party?: { __typename?: "PartyObject"; id: string } | undefined;
  };
};

export type GetOfferRecsQueryVariables = Exact<{
  input: GetOfferRecsInput;
}>;

export type GetOfferRecsQuery = {
  __typename?: "Query";
  getOfferRecs: {
    __typename?: "OfferRecsPayload";
    keyTerms: Array<
      | {
          __typename: "KeyTerm";
          label?: string | undefined;
          type: KeyTermType;
          unit: KeyTermUnit;
          recommendation: number;
          context: {
            __typename?: "KeyTermRecommendationContext";
            marketData: {
              __typename?: "MarketDataRange";
              low: number;
              high: number;
            };
            marketDataPercentages?:
              | {
                  __typename?: "MarketDataPercentages";
                  yes: number;
                  no: number;
                }
              | undefined;
            source:
              | { __typename: "CompsSource"; type: MarketDataSourceType }
              | {
                  __typename: "IndigoOffersSource";
                  type: MarketDataSourceType;
                  metadata: {
                    __typename?: "IndigoOffersMetadata";
                    confidence: ConfidenceLevel;
                    distanceMiles: number;
                    timePeriodMonths: number;
                  };
                }
              | { __typename: "MLSSource"; type: MarketDataSourceType };
          };
        }
      | {
          __typename: "KeyTermError";
          label?: string | undefined;
          type: KeyTermType;
          unit: KeyTermUnit;
          reason: string;
          sourceType: MarketDataSourceType;
        }
    >;
    contingencies: Array<
      | {
          __typename: "Contingency";
          type: ContingencyType;
          recommendation: boolean;
          context: {
            __typename?: "ContingencyRecommendationContext";
            marketData: {
              __typename?: "MarketDataPercentages";
              yes: number;
              no: number;
            };
            source:
              | { __typename: "CompsSource"; type: MarketDataSourceType }
              | {
                  __typename: "IndigoOffersSource";
                  type: MarketDataSourceType;
                  metadata: {
                    __typename?: "IndigoOffersMetadata";
                    confidence: ConfidenceLevel;
                    distanceMiles: number;
                    timePeriodMonths: number;
                  };
                }
              | { __typename: "MLSSource"; type: MarketDataSourceType };
          };
        }
      | {
          __typename: "ContingencyError";
          type: ContingencyType;
          reason: string;
        }
    >;
    competitiveness: {
      __typename?: "CompetitivenessScore";
      error?: string | undefined;
      rating: CompetitivenessLevel;
      score: number;
      metrics: {
        __typename?: "CompetitivenessMetrics";
        bidAsk: number;
        bidAskScore: number;
        daysOnMarket: number;
        daysOnMarketScore: number;
        minMarketBidAskRatio?: number | undefined;
        maxMarketBidAskRatio?: number | undefined;
        priceAnalysis: {
          __typename?: "PriceAnalysis";
          avgCompBidAskRatio: number;
          isPotentiallyOverpriced: boolean;
          isPotentiallyUnderpriced: boolean;
          pricePositioning: number;
        };
      };
    };
  };
};

export type GetOfferScorecardsForAgentQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  filters: OfferScorecardsFilterInput;
  preferenceValues?: Scalars["Boolean"]["input"];
}>;

export type GetOfferScorecardsForAgentQuery = {
  __typename?: "Query";
  offerScorecardsForAgent?:
    | {
        __typename?: "BuyerOfferAnalysisObjectofferScorecardsForAgentPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "BuyerOfferAnalysisObject";
              id: string;
              createdAt: any;
              hideOfferScore?: boolean | undefined;
              agentNotes?: string | undefined;
              title?: string | undefined;
              isShared?: boolean | undefined;
              buyersAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          phoneNumber: string;
                          roles: Array<Roles>;
                          email?: string | undefined;
                          profileBio?: string | undefined;
                          offerCollectionEmail?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                          settings?:
                            | {
                                __typename?: "UserSettingsObject";
                                id: string;
                                selectedOrganization?:
                                  | {
                                      __typename?: "OrganizationObject";
                                      id: string;
                                      name: string;
                                      hasDescendants?: boolean | undefined;
                                      contractSystemCredentials?:
                                        | Array<{
                                            __typename?: "ContractSystemCredentialsObject";
                                            id: string;
                                            hasInvalidCredentials?:
                                              | boolean
                                              | undefined;
                                            isReady: boolean;
                                            type?:
                                              | ContractSystemType
                                              | undefined;
                                            username?: string | undefined;
                                            dotloopProfileId?:
                                              | string
                                              | undefined;
                                            dotloopTeamName?:
                                              | string
                                              | undefined;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              listing?:
                | {
                    __typename?: "ListingObject";
                    id: string;
                    isOwner?: boolean | undefined;
                    listDate?: any | undefined;
                    offersCountDisplay: string;
                    submittedOffersCount: number;
                    followerCount?: number | undefined;
                    isPremium: boolean;
                    status: MlsListingStatus;
                    deletedFromRetsFeedAt?: string | undefined;
                    property: {
                      __typename?: "PropertyObject";
                      id: string;
                      slug: string;
                      state: UsState;
                    };
                    offersSubmitted?:
                      | Array<{
                          __typename?: "OfferObject";
                          id: string;
                          status: OfferStatus;
                        }>
                      | undefined;
                    listingAgent?:
                      | {
                          __typename?: "AgentObject";
                          id: string;
                          inboundEmail: string;
                          user?:
                            | {
                                __typename?: "UserObject";
                                id: string;
                                firstName: string;
                                lastName: string;
                                fullName: string;
                                userName?: string | undefined;
                                profilePicture?:
                                  | {
                                      __typename?: "FileObject";
                                      fileName: string;
                                      url: string;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coListingAgent?:
                      | {
                          __typename?: "AgentObject";
                          id: string;
                          inboundEmail: string;
                          user?:
                            | {
                                __typename?: "UserObject";
                                id: string;
                                firstName: string;
                                lastName: string;
                                fullName: string;
                                phoneNumber: string;
                                email?: string | undefined;
                                profilePicture?:
                                  | {
                                      __typename?: "FileObject";
                                      fileName: string;
                                      url: string;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mlsListing?:
                      | {
                          __typename?: "MLSListingObject";
                          id: string;
                          mlsId?: number | undefined;
                          listingId?: string | undefined;
                          listDate?: string | undefined;
                          listPrice?: number | undefined;
                          originalListPrice?: number | undefined;
                          terms?: string | undefined;
                          photos: Array<string>;
                          remarks?: string | undefined;
                          modified?: string | undefined;
                          mlsName?: string | undefined;
                          deleted_at?: string | undefined;
                          addressFull: string;
                          agent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          coAgent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          address: {
                            __typename?: "MLSListingAddressObject";
                            city: string;
                            country?: string | undefined;
                            crossStreet?: string | undefined;
                            full: string;
                            postalCode?: string | undefined;
                            state: string;
                            streetName: string;
                            streetNumber?: number | undefined;
                            streetNumberText: string;
                            unit?: string | undefined;
                          };
                          property?:
                            | {
                                __typename?: "MLSListingPropertyObject";
                                roof?: string | undefined;
                                cooling?: string | undefined;
                                style?: string | undefined;
                                area?: number | undefined;
                                bathsFull?: number | undefined;
                                bathsHalf?: number | undefined;
                                stories?: number | undefined;
                                fireplaces?: number | undefined;
                                flooring?: string | undefined;
                                heating?: string | undefined;
                                bathrooms?: string | undefined;
                                foundation?: string | undefined;
                                poolFeatures?: string | undefined;
                                laundryFeatures?: string | undefined;
                                occupantName?: string | undefined;
                                ownerName?: string | undefined;
                                lotDescription?: string | undefined;
                                acres?: number | undefined;
                                subType?: string | undefined;
                                bedrooms?: number | undefined;
                                interiorFeatures?: string | undefined;
                                lotSize?: string | undefined;
                                areaSource?: string | undefined;
                                maintenanceExpense?: number | undefined;
                                additionalRooms?: string | undefined;
                                exteriorFeatures?: string | undefined;
                                water?: string | undefined;
                                view?: string | undefined;
                                lotSizeArea?: number | undefined;
                                lotSizeAreaUnits?: string | undefined;
                                subdivision?: string | undefined;
                                construction?: string | undefined;
                                type?: MlsListingType | undefined;
                                garageSpaces?: number | undefined;
                                bathsThreeQuarter?: number | undefined;
                                accessibility?: string | undefined;
                                occupantType?: string | undefined;
                                yearBuilt?: number | undefined;
                                subTypeText?: string | undefined;
                              }
                            | undefined;
                          office?:
                            | {
                                __typename?: "MLSListingOfficeObject";
                                brokerid?: string | undefined;
                                name?: string | undefined;
                                servingName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          mls?:
                            | {
                                __typename?: "MLSListingMLSObject";
                                statusText: string;
                                status?: MlsListingStatus | undefined;
                                daysOnMarket?: number | undefined;
                                originalEntryTimestamp?: string | undefined;
                                originatingSystemName?: string | undefined;
                                logoUrl?: string | undefined;
                                disclaimer?: string | undefined;
                              }
                            | undefined;
                          association?:
                            | {
                                __typename?: "MLSListingAssociationObject";
                                fee?: number | undefined;
                                frequency?: string | undefined;
                                name?: string | undefined;
                                amenities?: string | undefined;
                              }
                            | undefined;
                          compliance?:
                            | {
                                __typename?: "MLSListingComplianceObject";
                                buyerAgencyCompensation?: number | undefined;
                                buyerAgencyCompensationType?:
                                  | string
                                  | undefined;
                                subAgencyCompensation?: number | undefined;
                                subAgencyCompensationType?: string | undefined;
                                attributionContact?: string | undefined;
                              }
                            | undefined;
                          sales?:
                            | {
                                __typename?: "MLSListingSalesObject";
                                closeDate?: string | undefined;
                                closePrice?: number | undefined;
                                contractDate?: string | undefined;
                              }
                            | undefined;
                          geo: {
                            __typename?: "MLSListingGeoObject";
                            location: {
                              __typename?: "GeoPointObject";
                              lat: number;
                              lon: number;
                            };
                          };
                        }
                      | undefined;
                    listingPreferences?: Array<{
                      __typename?: "PreferenceValueObject";
                      numberValue?: number | undefined;
                      textValue?: string | undefined;
                      stringValue?: string | undefined;
                      stringArray?: Array<string> | undefined;
                      booleanValue?: boolean | undefined;
                      dateTimeValue?: any | undefined;
                      readOnly?: boolean | undefined;
                      preference: {
                        __typename?: "PreferenceObject";
                        id: string;
                        name: string;
                        slug: string;
                        usStates: Array<UsState>;
                        fieldId?: string | undefined;
                        valueType: PreferenceValueType;
                      };
                    }>;
                    storefrontSetup?:
                      | {
                          __typename?: "StorefrontSetupObject";
                          continueStep?: StorefrontSetupStep | undefined;
                          listingPackage: {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          };
                        }
                      | undefined;
                    setupDetails: {
                      __typename?: "StorefrontConfigurationStatusObject";
                      hasSetup?: boolean | undefined;
                      configuredCount: number;
                      progressTotal: number;
                      sellerPreferences: boolean;
                      comparables: boolean;
                      documents: boolean;
                    };
                  }
                | undefined;
              party?:
                | {
                    __typename?: "PartyObject";
                    id: string;
                    createdAt: any;
                    purchaseOffers?:
                      | Array<{
                          __typename?: "OfferObject";
                          id: string;
                          updatedAt?: any | undefined;
                          listing?:
                            | {
                                __typename?: "ListingObject";
                                id: string;
                                isPremium: boolean;
                                property: {
                                  __typename?: "PropertyObject";
                                  id: string;
                                  slug: string;
                                  state: UsState;
                                };
                                mlsListing?:
                                  | {
                                      __typename?: "MLSListingObject";
                                      id: string;
                                      mlsId?: number | undefined;
                                      listingId?: string | undefined;
                                      listDate?: string | undefined;
                                      listPrice?: number | undefined;
                                      originalListPrice?: number | undefined;
                                      terms?: string | undefined;
                                      photos: Array<string>;
                                      remarks?: string | undefined;
                                      modified?: string | undefined;
                                      mlsName?: string | undefined;
                                      deleted_at?: string | undefined;
                                      addressFull: string;
                                      agent?:
                                        | {
                                            __typename?: "MLSListingAgentObject";
                                            id?: string | undefined;
                                            mlsId?: string | undefined;
                                            firstName?: string | undefined;
                                            lastName?: string | undefined;
                                            contact?:
                                              | {
                                                  __typename?: "MLSListingContactObject";
                                                  email?: string | undefined;
                                                  office?: string | undefined;
                                                  cell?: string | undefined;
                                                }
                                              | undefined;
                                          }
                                        | undefined;
                                      coAgent?:
                                        | {
                                            __typename?: "MLSListingAgentObject";
                                            id?: string | undefined;
                                            mlsId?: string | undefined;
                                            firstName?: string | undefined;
                                            lastName?: string | undefined;
                                            contact?:
                                              | {
                                                  __typename?: "MLSListingContactObject";
                                                  email?: string | undefined;
                                                  office?: string | undefined;
                                                  cell?: string | undefined;
                                                }
                                              | undefined;
                                          }
                                        | undefined;
                                      address: {
                                        __typename?: "MLSListingAddressObject";
                                        city: string;
                                        country?: string | undefined;
                                        crossStreet?: string | undefined;
                                        full: string;
                                        postalCode?: string | undefined;
                                        state: string;
                                        streetName: string;
                                        streetNumber?: number | undefined;
                                        streetNumberText: string;
                                        unit?: string | undefined;
                                      };
                                      property?:
                                        | {
                                            __typename?: "MLSListingPropertyObject";
                                            roof?: string | undefined;
                                            cooling?: string | undefined;
                                            style?: string | undefined;
                                            area?: number | undefined;
                                            bathsFull?: number | undefined;
                                            bathsHalf?: number | undefined;
                                            stories?: number | undefined;
                                            fireplaces?: number | undefined;
                                            flooring?: string | undefined;
                                            heating?: string | undefined;
                                            bathrooms?: string | undefined;
                                            foundation?: string | undefined;
                                            poolFeatures?: string | undefined;
                                            laundryFeatures?:
                                              | string
                                              | undefined;
                                            occupantName?: string | undefined;
                                            ownerName?: string | undefined;
                                            lotDescription?: string | undefined;
                                            acres?: number | undefined;
                                            subType?: string | undefined;
                                            bedrooms?: number | undefined;
                                            interiorFeatures?:
                                              | string
                                              | undefined;
                                            lotSize?: string | undefined;
                                            areaSource?: string | undefined;
                                            maintenanceExpense?:
                                              | number
                                              | undefined;
                                            additionalRooms?:
                                              | string
                                              | undefined;
                                            exteriorFeatures?:
                                              | string
                                              | undefined;
                                            water?: string | undefined;
                                            view?: string | undefined;
                                            lotSizeArea?: number | undefined;
                                            lotSizeAreaUnits?:
                                              | string
                                              | undefined;
                                            subdivision?: string | undefined;
                                            construction?: string | undefined;
                                            type?: MlsListingType | undefined;
                                            garageSpaces?: number | undefined;
                                            bathsThreeQuarter?:
                                              | number
                                              | undefined;
                                            accessibility?: string | undefined;
                                            occupantType?: string | undefined;
                                            yearBuilt?: number | undefined;
                                            subTypeText?: string | undefined;
                                          }
                                        | undefined;
                                      office?:
                                        | {
                                            __typename?: "MLSListingOfficeObject";
                                            brokerid?: string | undefined;
                                            name?: string | undefined;
                                            servingName?: string | undefined;
                                            contact?:
                                              | {
                                                  __typename?: "MLSListingContactObject";
                                                  email?: string | undefined;
                                                  office?: string | undefined;
                                                  cell?: string | undefined;
                                                }
                                              | undefined;
                                          }
                                        | undefined;
                                      mls?:
                                        | {
                                            __typename?: "MLSListingMLSObject";
                                            statusText: string;
                                            status?:
                                              | MlsListingStatus
                                              | undefined;
                                            daysOnMarket?: number | undefined;
                                            originalEntryTimestamp?:
                                              | string
                                              | undefined;
                                            originatingSystemName?:
                                              | string
                                              | undefined;
                                            logoUrl?: string | undefined;
                                            disclaimer?: string | undefined;
                                          }
                                        | undefined;
                                      association?:
                                        | {
                                            __typename?: "MLSListingAssociationObject";
                                            fee?: number | undefined;
                                            frequency?: string | undefined;
                                            name?: string | undefined;
                                            amenities?: string | undefined;
                                          }
                                        | undefined;
                                      compliance?:
                                        | {
                                            __typename?: "MLSListingComplianceObject";
                                            buyerAgencyCompensation?:
                                              | number
                                              | undefined;
                                            buyerAgencyCompensationType?:
                                              | string
                                              | undefined;
                                            subAgencyCompensation?:
                                              | number
                                              | undefined;
                                            subAgencyCompensationType?:
                                              | string
                                              | undefined;
                                            attributionContact?:
                                              | string
                                              | undefined;
                                          }
                                        | undefined;
                                      sales?:
                                        | {
                                            __typename?: "MLSListingSalesObject";
                                            closeDate?: string | undefined;
                                            closePrice?: number | undefined;
                                            contractDate?: string | undefined;
                                          }
                                        | undefined;
                                      geo: {
                                        __typename?: "MLSListingGeoObject";
                                        location: {
                                          __typename?: "GeoPointObject";
                                          lat: number;
                                          lon: number;
                                        };
                                      };
                                    }
                                  | undefined;
                                listingAgent?:
                                  | {
                                      __typename?: "AgentObject";
                                      id: string;
                                      user?:
                                        | {
                                            __typename?: "UserObject";
                                            id: string;
                                          }
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }>
                      | undefined;
                    primaryConsumer: {
                      __typename?: "ConsumerObject";
                      id: string;
                      email?: string | undefined;
                      fullName: string;
                      phoneNumber?: string | undefined;
                      isEntity: boolean;
                      entityName?: string | undefined;
                      entityTitle?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    };
                    secondaryConsumers: Array<{
                      __typename?: "ConsumerObject";
                      id: string;
                      email?: string | undefined;
                      fullName: string;
                      phoneNumber?: string | undefined;
                      isEntity: boolean;
                      entityName?: string | undefined;
                      entityTitle?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }>;
                    partyFinancing?:
                      | {
                          __typename?: "PartyFinancingObject";
                          id: string;
                          financingType?: FinancingType | undefined;
                          loanAmount?: number | undefined;
                          percentDownPayment?: number | undefined;
                          cashReserves?: number | undefined;
                          preapprovalFile?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              indigoOfferRecs?:
                | {
                    __typename?: "OfferRecsPayload";
                    keyTerms: Array<
                      | {
                          __typename: "KeyTerm";
                          label?: string | undefined;
                          type: KeyTermType;
                          unit: KeyTermUnit;
                          recommendation: number;
                          context: {
                            __typename?: "KeyTermRecommendationContext";
                            marketData: {
                              __typename?: "MarketDataRange";
                              low: number;
                              high: number;
                            };
                            marketDataPercentages?:
                              | {
                                  __typename?: "MarketDataPercentages";
                                  yes: number;
                                  no: number;
                                }
                              | undefined;
                            source:
                              | {
                                  __typename: "CompsSource";
                                  type: MarketDataSourceType;
                                }
                              | {
                                  __typename: "IndigoOffersSource";
                                  type: MarketDataSourceType;
                                  metadata: {
                                    __typename?: "IndigoOffersMetadata";
                                    confidence: ConfidenceLevel;
                                    distanceMiles: number;
                                    timePeriodMonths: number;
                                  };
                                }
                              | {
                                  __typename: "MLSSource";
                                  type: MarketDataSourceType;
                                };
                          };
                        }
                      | {
                          __typename: "KeyTermError";
                          label?: string | undefined;
                          type: KeyTermType;
                          unit: KeyTermUnit;
                          reason: string;
                          sourceType: MarketDataSourceType;
                        }
                    >;
                    contingencies: Array<
                      | {
                          __typename: "Contingency";
                          type: ContingencyType;
                          recommendation: boolean;
                          context: {
                            __typename?: "ContingencyRecommendationContext";
                            marketData: {
                              __typename?: "MarketDataPercentages";
                              yes: number;
                              no: number;
                            };
                            source:
                              | {
                                  __typename: "CompsSource";
                                  type: MarketDataSourceType;
                                }
                              | {
                                  __typename: "IndigoOffersSource";
                                  type: MarketDataSourceType;
                                  metadata: {
                                    __typename?: "IndigoOffersMetadata";
                                    confidence: ConfidenceLevel;
                                    distanceMiles: number;
                                    timePeriodMonths: number;
                                  };
                                }
                              | {
                                  __typename: "MLSSource";
                                  type: MarketDataSourceType;
                                };
                          };
                        }
                      | {
                          __typename: "ContingencyError";
                          type: ContingencyType;
                          reason: string;
                        }
                    >;
                    competitiveness: {
                      __typename?: "CompetitivenessScore";
                      error?: string | undefined;
                      rating: CompetitivenessLevel;
                      score: number;
                      metrics: {
                        __typename?: "CompetitivenessMetrics";
                        bidAsk: number;
                        bidAskScore: number;
                        daysOnMarket: number;
                        daysOnMarketScore: number;
                        minMarketBidAskRatio?: number | undefined;
                        maxMarketBidAskRatio?: number | undefined;
                        priceAnalysis: {
                          __typename?: "PriceAnalysis";
                          avgCompBidAskRatio: number;
                          isPotentiallyOverpriced: boolean;
                          isPotentiallyUnderpriced: boolean;
                          pricePositioning: number;
                        };
                      };
                    };
                  }
                | undefined;
              agentOfferRecs?:
                | {
                    __typename?: "AgentOfferRecsPayload";
                    contingencies?:
                      | Array<{
                          __typename?: "AgentContingencyOfferRec";
                          value?: boolean | undefined;
                          notes?: string | undefined;
                          type: ContingencyType;
                        }>
                      | undefined;
                    keyTerms?:
                      | Array<{
                          __typename?: "AgentKeyTermsOfferRec";
                          value?: number | undefined;
                          notes?: string | undefined;
                          type: KeyTermType;
                        }>
                      | undefined;
                    competitivenessAdjustment?:
                      | {
                          __typename?: "CompetitivenessAdjustment";
                          adjustedLevel: CompetitivenessLevel;
                          reason: string;
                        }
                      | undefined;
                  }
                | undefined;
              prevAgentOfferRecs?:
                | {
                    __typename?: "AgentOfferRecsPayload";
                    contingencies?:
                      | Array<{
                          __typename?: "AgentContingencyOfferRec";
                          value?: boolean | undefined;
                          notes?: string | undefined;
                          type: ContingencyType;
                        }>
                      | undefined;
                    keyTerms?:
                      | Array<{
                          __typename?: "AgentKeyTermsOfferRec";
                          value?: number | undefined;
                          notes?: string | undefined;
                          type: KeyTermType;
                        }>
                      | undefined;
                    competitivenessAdjustment?:
                      | {
                          __typename?: "CompetitivenessAdjustment";
                          adjustedLevel: CompetitivenessLevel;
                          reason: string;
                        }
                      | undefined;
                  }
                | undefined;
              offerScore?:
                | {
                    __typename?: "OfferScore";
                    reason: string;
                    value: number;
                    offerScoreExplanation?: string | undefined;
                  }
                | { __typename?: "OfferScoreNotCalculated"; reason: string }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type GetOfferScorecardsForOrgQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  filters: OfferScorecardsFilterInput;
}>;

export type GetOfferScorecardsForOrgQuery = {
  __typename?: "Query";
  offerScorecardsForOrg?:
    | {
        __typename?: "BuyerOfferAnalysisObjectofferScorecardsForOrgPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "BuyerOfferAnalysisObject";
              id: string;
              createdAt: any;
              agentNotes?: string | undefined;
              title?: string | undefined;
              isShared?: boolean | undefined;
              buyersAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          phoneNumber: string;
                          roles: Array<Roles>;
                          email?: string | undefined;
                          profileBio?: string | undefined;
                          offerCollectionEmail?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                          settings?:
                            | {
                                __typename?: "UserSettingsObject";
                                id: string;
                                selectedOrganization?:
                                  | {
                                      __typename?: "OrganizationObject";
                                      id: string;
                                      name: string;
                                      hasDescendants?: boolean | undefined;
                                      contractSystemCredentials?:
                                        | Array<{
                                            __typename?: "ContractSystemCredentialsObject";
                                            id: string;
                                            hasInvalidCredentials?:
                                              | boolean
                                              | undefined;
                                            isReady: boolean;
                                            type?:
                                              | ContractSystemType
                                              | undefined;
                                            username?: string | undefined;
                                            dotloopProfileId?:
                                              | string
                                              | undefined;
                                            dotloopTeamName?:
                                              | string
                                              | undefined;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              listing?:
                | {
                    __typename?: "ListingObject";
                    id: string;
                    property: {
                      __typename?: "PropertyObject";
                      id: string;
                      slug: string;
                      state: UsState;
                    };
                    mlsListing?:
                      | {
                          __typename?: "MLSListingObject";
                          id: string;
                          mlsId?: number | undefined;
                          listingId?: string | undefined;
                          listDate?: string | undefined;
                          listPrice?: number | undefined;
                          originalListPrice?: number | undefined;
                          terms?: string | undefined;
                          photos: Array<string>;
                          remarks?: string | undefined;
                          modified?: string | undefined;
                          mlsName?: string | undefined;
                          deleted_at?: string | undefined;
                          addressFull: string;
                          agent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          coAgent?:
                            | {
                                __typename?: "MLSListingAgentObject";
                                id?: string | undefined;
                                mlsId?: string | undefined;
                                firstName?: string | undefined;
                                lastName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          address: {
                            __typename?: "MLSListingAddressObject";
                            city: string;
                            country?: string | undefined;
                            crossStreet?: string | undefined;
                            full: string;
                            postalCode?: string | undefined;
                            state: string;
                            streetName: string;
                            streetNumber?: number | undefined;
                            streetNumberText: string;
                            unit?: string | undefined;
                          };
                          property?:
                            | {
                                __typename?: "MLSListingPropertyObject";
                                roof?: string | undefined;
                                cooling?: string | undefined;
                                style?: string | undefined;
                                area?: number | undefined;
                                bathsFull?: number | undefined;
                                bathsHalf?: number | undefined;
                                stories?: number | undefined;
                                fireplaces?: number | undefined;
                                flooring?: string | undefined;
                                heating?: string | undefined;
                                bathrooms?: string | undefined;
                                foundation?: string | undefined;
                                poolFeatures?: string | undefined;
                                laundryFeatures?: string | undefined;
                                occupantName?: string | undefined;
                                ownerName?: string | undefined;
                                lotDescription?: string | undefined;
                                acres?: number | undefined;
                                subType?: string | undefined;
                                bedrooms?: number | undefined;
                                interiorFeatures?: string | undefined;
                                lotSize?: string | undefined;
                                areaSource?: string | undefined;
                                maintenanceExpense?: number | undefined;
                                additionalRooms?: string | undefined;
                                exteriorFeatures?: string | undefined;
                                water?: string | undefined;
                                view?: string | undefined;
                                lotSizeArea?: number | undefined;
                                lotSizeAreaUnits?: string | undefined;
                                subdivision?: string | undefined;
                                construction?: string | undefined;
                                type?: MlsListingType | undefined;
                                garageSpaces?: number | undefined;
                                bathsThreeQuarter?: number | undefined;
                                accessibility?: string | undefined;
                                occupantType?: string | undefined;
                                yearBuilt?: number | undefined;
                                subTypeText?: string | undefined;
                              }
                            | undefined;
                          office?:
                            | {
                                __typename?: "MLSListingOfficeObject";
                                brokerid?: string | undefined;
                                name?: string | undefined;
                                servingName?: string | undefined;
                                contact?:
                                  | {
                                      __typename?: "MLSListingContactObject";
                                      email?: string | undefined;
                                      office?: string | undefined;
                                      cell?: string | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                          mls?:
                            | {
                                __typename?: "MLSListingMLSObject";
                                statusText: string;
                                status?: MlsListingStatus | undefined;
                                daysOnMarket?: number | undefined;
                                originalEntryTimestamp?: string | undefined;
                                originatingSystemName?: string | undefined;
                                logoUrl?: string | undefined;
                                disclaimer?: string | undefined;
                              }
                            | undefined;
                          association?:
                            | {
                                __typename?: "MLSListingAssociationObject";
                                fee?: number | undefined;
                                frequency?: string | undefined;
                                name?: string | undefined;
                                amenities?: string | undefined;
                              }
                            | undefined;
                          compliance?:
                            | {
                                __typename?: "MLSListingComplianceObject";
                                buyerAgencyCompensation?: number | undefined;
                                buyerAgencyCompensationType?:
                                  | string
                                  | undefined;
                                subAgencyCompensation?: number | undefined;
                                subAgencyCompensationType?: string | undefined;
                                attributionContact?: string | undefined;
                              }
                            | undefined;
                          sales?:
                            | {
                                __typename?: "MLSListingSalesObject";
                                closeDate?: string | undefined;
                                closePrice?: number | undefined;
                                contractDate?: string | undefined;
                              }
                            | undefined;
                          geo: {
                            __typename?: "MLSListingGeoObject";
                            location: {
                              __typename?: "GeoPointObject";
                              lat: number;
                              lon: number;
                            };
                          };
                        }
                      | undefined;
                  }
                | undefined;
              party?:
                | {
                    __typename?: "PartyObject";
                    id: string;
                    primaryConsumer: {
                      __typename?: "ConsumerObject";
                      id: string;
                      email?: string | undefined;
                      fullName: string;
                      phoneNumber?: string | undefined;
                      isEntity: boolean;
                      entityName?: string | undefined;
                      entityTitle?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    };
                    secondaryConsumers: Array<{
                      __typename?: "ConsumerObject";
                      id: string;
                      email?: string | undefined;
                      fullName: string;
                      phoneNumber?: string | undefined;
                      isEntity: boolean;
                      entityName?: string | undefined;
                      entityTitle?: string | undefined;
                      profilePicture?:
                        | {
                            __typename?: "FileObject";
                            fileName: string;
                            url: string;
                          }
                        | undefined;
                    }>;
                  }
                | undefined;
              indigoOfferRecs?:
                | {
                    __typename?: "OfferRecsPayload";
                    keyTerms: Array<
                      | {
                          __typename: "KeyTerm";
                          label?: string | undefined;
                          type: KeyTermType;
                          unit: KeyTermUnit;
                          recommendation: number;
                          context: {
                            __typename?: "KeyTermRecommendationContext";
                            marketData: {
                              __typename?: "MarketDataRange";
                              low: number;
                              high: number;
                            };
                            marketDataPercentages?:
                              | {
                                  __typename?: "MarketDataPercentages";
                                  yes: number;
                                  no: number;
                                }
                              | undefined;
                            source:
                              | {
                                  __typename: "CompsSource";
                                  type: MarketDataSourceType;
                                }
                              | {
                                  __typename: "IndigoOffersSource";
                                  type: MarketDataSourceType;
                                  metadata: {
                                    __typename?: "IndigoOffersMetadata";
                                    confidence: ConfidenceLevel;
                                    distanceMiles: number;
                                    timePeriodMonths: number;
                                  };
                                }
                              | {
                                  __typename: "MLSSource";
                                  type: MarketDataSourceType;
                                };
                          };
                        }
                      | {
                          __typename: "KeyTermError";
                          label?: string | undefined;
                          type: KeyTermType;
                          unit: KeyTermUnit;
                          reason: string;
                          sourceType: MarketDataSourceType;
                        }
                    >;
                    contingencies: Array<
                      | {
                          __typename: "Contingency";
                          type: ContingencyType;
                          recommendation: boolean;
                          context: {
                            __typename?: "ContingencyRecommendationContext";
                            marketData: {
                              __typename?: "MarketDataPercentages";
                              yes: number;
                              no: number;
                            };
                            source:
                              | {
                                  __typename: "CompsSource";
                                  type: MarketDataSourceType;
                                }
                              | {
                                  __typename: "IndigoOffersSource";
                                  type: MarketDataSourceType;
                                  metadata: {
                                    __typename?: "IndigoOffersMetadata";
                                    confidence: ConfidenceLevel;
                                    distanceMiles: number;
                                    timePeriodMonths: number;
                                  };
                                }
                              | {
                                  __typename: "MLSSource";
                                  type: MarketDataSourceType;
                                };
                          };
                        }
                      | {
                          __typename: "ContingencyError";
                          type: ContingencyType;
                          reason: string;
                        }
                    >;
                    competitiveness: {
                      __typename?: "CompetitivenessScore";
                      error?: string | undefined;
                      rating: CompetitivenessLevel;
                      score: number;
                      metrics: {
                        __typename?: "CompetitivenessMetrics";
                        bidAsk: number;
                        bidAskScore: number;
                        daysOnMarket: number;
                        daysOnMarketScore: number;
                        minMarketBidAskRatio?: number | undefined;
                        maxMarketBidAskRatio?: number | undefined;
                        priceAnalysis: {
                          __typename?: "PriceAnalysis";
                          avgCompBidAskRatio: number;
                          isPotentiallyOverpriced: boolean;
                          isPotentiallyUnderpriced: boolean;
                          pricePositioning: number;
                        };
                      };
                    };
                  }
                | undefined;
              agentOfferRecs?:
                | {
                    __typename?: "AgentOfferRecsPayload";
                    contingencies?:
                      | Array<{
                          __typename?: "AgentContingencyOfferRec";
                          value?: boolean | undefined;
                          notes?: string | undefined;
                          type: ContingencyType;
                        }>
                      | undefined;
                    keyTerms?:
                      | Array<{
                          __typename?: "AgentKeyTermsOfferRec";
                          value?: number | undefined;
                          notes?: string | undefined;
                          type: KeyTermType;
                        }>
                      | undefined;
                    competitivenessAdjustment?:
                      | {
                          __typename?: "CompetitivenessAdjustment";
                          adjustedLevel: CompetitivenessLevel;
                          reason: string;
                        }
                      | undefined;
                  }
                | undefined;
              offerScore?:
                | {
                    __typename?: "OfferScore";
                    reason: string;
                    value: number;
                    offerScoreExplanation?: string | undefined;
                  }
                | { __typename?: "OfferScoreNotCalculated"; reason: string }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type GetOfferScorecardsMetricsForOrgQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOfferScorecardsMetricsForOrgQuery = {
  __typename?: "Query";
  offerScorecardsMetricsForOrg: {
    __typename?: "OfferScorecardsMetrics";
    created: {
      __typename?: "OfferScorecardsMetricValue";
      value: number;
      delta: number;
    };
    shared: {
      __typename?: "OfferScorecardsMetricValue";
      value: number;
      delta: number;
    };
    averageScore: {
      __typename?: "OfferScorecardsMetricValue";
      value: number;
      delta: number;
    };
  };
};

export type GetPropertyDetailsQueryVariables = Exact<{
  input: GetPropertyDetailsInput;
}>;

export type GetPropertyDetailsQuery = {
  __typename?: "Query";
  getPropertyDetails: {
    __typename?: "GetPropertyDetailsPayload";
    result:
      | { __typename?: "GetPropertyDetailsFailed"; error: string }
      | {
          __typename?: "GetPropertyDetailsSuccess";
          areaSqFt?: number | undefined;
          yearBuilt?: number | undefined;
          bedrooms?: number | undefined;
          bathsFull?: number | undefined;
          bathsHalf?: number | undefined;
          propertyType?: MlsListingType | undefined;
          propertySubtype?: MlsListingSubType | undefined;
          subdivision?: string | undefined;
          schoolDistrict?: string | undefined;
        };
    location: {
      __typename?: "Location";
      address: {
        __typename?: "AddressObject";
        streetAddress: string;
        city: string;
        state: UsState;
        zipCode: string;
        unit?: string | undefined;
      };
      coords?:
        | { __typename?: "GeoObject"; lat: number; lng: number }
        | undefined;
    };
  };
};

export type GetSingleUserCapturedPropertyDetailsQueryVariables = Exact<{
  propertyDetailsId: Scalars["String"]["input"];
}>;

export type GetSingleUserCapturedPropertyDetailsQuery = {
  __typename?: "Query";
  getSingleUserCapturedPropertyDetails: {
    __typename?: "PropertyDetailsObject";
    id: string;
    streetAddress: string;
    city: string;
    state: UsState;
    zipCode: string;
    unit?: string | undefined;
    targetPrice: number;
    areaSqFt: number;
    yearBuilt: number;
    bedrooms: number;
    bathsFull: number;
    bathsHalf?: number | undefined;
    propertyType: MlsListingType;
    propertySubtype: MlsListingSubType;
    subdivision?: string | undefined;
    schoolDistrict?: string | undefined;
    geo: { __typename?: "GeoObject"; lat: number; lng: number };
  };
};

export type GetUserCapturedPropertyDetailsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserCapturedPropertyDetailsQuery = {
  __typename?: "Query";
  getUserCapturedPropertyDetails: Array<{
    __typename?: "PropertyDetailsObject";
    id: string;
    streetAddress: string;
    city: string;
    state: UsState;
    zipCode: string;
    unit?: string | undefined;
    targetPrice: number;
    areaSqFt: number;
    yearBuilt: number;
    bedrooms: number;
    bathsFull: number;
    bathsHalf?: number | undefined;
    propertyType: MlsListingType;
    propertySubtype: MlsListingSubType;
    subdivision?: string | undefined;
    schoolDistrict?: string | undefined;
    geo: { __typename?: "GeoObject"; lat: number; lng: number };
  }>;
};

export type GetUserCapturedPropertyDetailsByTokenQueryVariables = Exact<{
  input: GetUserCapturedPropertyDetailsByTokenInput;
}>;

export type GetUserCapturedPropertyDetailsByTokenQuery = {
  __typename?: "Query";
  getUserCapturedPropertyDetailsByToken: {
    __typename?: "PropertyDetailsObject";
    id: string;
    streetAddress: string;
    city: string;
    state: UsState;
    zipCode: string;
    unit?: string | undefined;
    targetPrice: number;
    areaSqFt: number;
    yearBuilt: number;
    bedrooms: number;
    bathsFull: number;
    bathsHalf?: number | undefined;
    propertyType: MlsListingType;
    propertySubtype: MlsListingSubType;
    subdivision?: string | undefined;
    schoolDistrict?: string | undefined;
    geo: { __typename?: "GeoObject"; lat: number; lng: number };
  };
};

export type GetUserToursQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserToursQuery = {
  __typename?: "Query";
  getUserTours: Array<{
    __typename?: "UserTourObject";
    id: string;
    tourName: TourType;
  }>;
};

export type HasSignedListingGuestbookQueryVariables = Exact<{
  input: ListingInput;
}>;

export type HasSignedListingGuestbookQuery = {
  __typename?: "Query";
  hasSignedListingGuestbook: {
    __typename?: "HasSignedListingGuestbookObject";
    hasSigned: boolean;
  };
};

export type IndigoContractsForCurrentUserFragment = {
  __typename?: "IndigoContractObject";
  id: string;
  createdAt: any;
  contract?:
    | {
        __typename?: "ContractObject";
        id: string;
        autofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        fieldValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        contractDocuments?: Array<{
          __typename?: "ContractDocumentObject";
          id: string;
          order: number;
          documentVersion?:
            | {
                __typename?: "DocumentVersionObject";
                id: string;
                document: { __typename?: "DocumentObject"; id: string };
              }
            | undefined;
        }>;
        signatureRequests?:
          | Array<{
              __typename?: "SignatureRequestObject";
              id: string;
              events: Array<{
                __typename?: "SignatureRequestEventObject";
                id: string;
                createdAt: any;
                eventType: SignatureRequestEventType;
              }>;
              allSignedDocument?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
  party: {
    __typename?: "PartyObject";
    id: string;
    createdAt: any;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    primaryConsumer: {
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    };
    secondaryConsumers: Array<{
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    }>;
  };
};

export type IndigoContractsForCurrentUserQueryVariables = Exact<{
  filters?: InputMaybe<IndigoContractsForCurrentUserFilters>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
  includeFieldValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeContractDocuments?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type IndigoContractsForCurrentUserQuery = {
  __typename?: "Query";
  indigoContractsForCurrentUser?:
    | {
        __typename?: "IndigoContractObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "IndigoContractObject";
              id: string;
              createdAt: any;
              contract?:
                | {
                    __typename?: "ContractObject";
                    id: string;
                    autofillValues?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    fieldValues?:
                      | Record<
                          string,
                          string | number | boolean | string[] | undefined
                        >
                      | undefined;
                    contractDocuments?: Array<{
                      __typename?: "ContractDocumentObject";
                      id: string;
                      order: number;
                      documentVersion?:
                        | {
                            __typename?: "DocumentVersionObject";
                            id: string;
                            document: {
                              __typename?: "DocumentObject";
                              id: string;
                            };
                          }
                        | undefined;
                    }>;
                    signatureRequests?:
                      | Array<{
                          __typename?: "SignatureRequestObject";
                          id: string;
                          events: Array<{
                            __typename?: "SignatureRequestEventObject";
                            id: string;
                            createdAt: any;
                            eventType: SignatureRequestEventType;
                          }>;
                          allSignedDocument?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
              party: {
                __typename?: "PartyObject";
                id: string;
                createdAt: any;
                buyersAgent?:
                  | {
                      __typename?: "AgentObject";
                      user?:
                        | {
                            __typename?: "UserObject";
                            id: string;
                            firstName: string;
                            lastName: string;
                            fullName: string;
                            userName?: string | undefined;
                            phoneNumber: string;
                            roles: Array<Roles>;
                            email?: string | undefined;
                            profileBio?: string | undefined;
                            offerCollectionEmail?: string | undefined;
                            profilePicture?:
                              | {
                                  __typename?: "FileObject";
                                  fileName: string;
                                  url: string;
                                }
                              | undefined;
                            settings?:
                              | {
                                  __typename?: "UserSettingsObject";
                                  id: string;
                                  selectedOrganization?:
                                    | {
                                        __typename?: "OrganizationObject";
                                        id: string;
                                        name: string;
                                        hasDescendants?: boolean | undefined;
                                        contractSystemCredentials?:
                                          | Array<{
                                              __typename?: "ContractSystemCredentialsObject";
                                              id: string;
                                              hasInvalidCredentials?:
                                                | boolean
                                                | undefined;
                                              isReady: boolean;
                                              type?:
                                                | ContractSystemType
                                                | undefined;
                                              username?: string | undefined;
                                              dotloopProfileId?:
                                                | string
                                                | undefined;
                                              dotloopTeamName?:
                                                | string
                                                | undefined;
                                            }>
                                          | undefined;
                                      }
                                    | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
                primaryConsumer: {
                  __typename?: "ConsumerObject";
                  id: string;
                  email?: string | undefined;
                  fullName: string;
                  phoneNumber?: string | undefined;
                  isEntity: boolean;
                  entityName?: string | undefined;
                  entityTitle?: string | undefined;
                  profilePicture?:
                    | {
                        __typename?: "FileObject";
                        fileName: string;
                        url: string;
                      }
                    | undefined;
                };
                secondaryConsumers: Array<{
                  __typename?: "ConsumerObject";
                  id: string;
                  email?: string | undefined;
                  fullName: string;
                  phoneNumber?: string | undefined;
                  isEntity: boolean;
                  entityName?: string | undefined;
                  entityTitle?: string | undefined;
                  profilePicture?:
                    | {
                        __typename?: "FileObject";
                        fileName: string;
                        url: string;
                      }
                    | undefined;
                }>;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type InitiateListingPricingEvaluationQueryVariables = Exact<{
  input: ListingPricingEvaluationInput;
}>;

export type InitiateListingPricingEvaluationQuery = {
  __typename?: "Query";
  initiateListingPricingEvaluation?:
    | {
        __typename?: "PricingEvaluationJobStatusObject";
        status: PricingEvaluationJobStatus;
        errorMessage?: string | undefined;
        jobId?: string | undefined;
      }
    | undefined;
};

export type IntegrationConnectionsForOrganizationQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
}>;

export type IntegrationConnectionsForOrganizationQuery = {
  __typename?: "Query";
  integrationConnectionsForOrganization: Array<{
    __typename?: "IntegrationConnectionObject";
    id: string;
    providerAccountName: string;
    user?:
      | {
          __typename?: "PublicUserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
        }
      | undefined;
    integrationClient?:
      | { __typename?: "IntegrationClientObject"; id: string }
      | undefined;
  }>;
};

export type InternalEssentialsNotificationFolderDebugQueryVariables = Exact<{
  input: InternalEssentialsNotificationFolderDebugInput;
}>;

export type InternalEssentialsNotificationFolderDebugQuery = {
  __typename?: "Query";
  internalEssentialsNotificationFolderDebug: {
    __typename?: "InternalEssentialsNotificationFolderDebugObject";
    organizationUuid: string;
    folderId: string;
    transactionSide?: TransactionSide | undefined;
    stage?: TransactionStageType | undefined;
    candidates: Array<{
      __typename?: "SimulationCandidateResult";
      outcome: SimulationOutcome;
      reason?: string | undefined;
      templateSource?:
        | {
            __typename?: "DebugTemplateSource";
            templateUuid?: string | undefined;
            title?: string | undefined;
            eventType?: TransactionStageType | undefined;
            side?: TransactionSide | undefined;
            recipientTypes?: Array<string> | undefined;
            delayMinutes?: number | undefined;
            dataToShare?: Array<string> | undefined;
            messageContent?: string | undefined;
            hasAssignedPartner?: boolean | undefined;
            isAttachedToPartner?: boolean | undefined;
            status?: NotificationTemplateStatus | undefined;
            orderIndex?: number | undefined;
          }
        | undefined;
      stageIntroSource?:
        | {
            __typename?: "DebugStageIntroSource";
            side: TransactionSide;
            stage: TransactionStageType;
            newRelationshipMessageContent?: string | undefined;
            existingRelationshipMessageContent?: string | undefined;
            allowPartnerContactAssignment: boolean;
          }
        | undefined;
      recipientResolution?:
        | {
            __typename?: "DebugRecipientResolution";
            requestedRecipientTypes: Array<string>;
            agentContactUuid?: string | undefined;
            rosterUsed?: boolean | undefined;
            isPaused: boolean;
            isFirstAssignment?: boolean | undefined;
            pauseReason?: string | undefined;
            resolvedContacts: Array<{
              __typename?: "DebugRecipientContact";
              uuid: string;
              fullName?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              contactType: ContactType;
            }>;
            resolvedRawRecipients: Array<{
              __typename?: "DebugRawRecipient";
              id: string;
              fullName?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              contactType?: string | undefined;
            }>;
          }
        | undefined;
      routingDecisions?:
        | {
            __typename?: "DebugRoutingDecisions";
            decisions: Array<{
              __typename?: "DebugRoutingDecision";
              key: string;
              outcome: string;
              reason?: string | undefined;
            }>;
          }
        | undefined;
      autofillRendering?:
        | {
            __typename?: "DebugAutofillRendering";
            computedAutofillValues?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
            renderedTitle?: string | undefined;
            renderedBody?: string | undefined;
            templateVariables?:
              | Record<string, string | number | boolean | string[] | undefined>
              | undefined;
          }
        | undefined;
    }>;
    excludedTemplates: Array<{
      __typename?: "DebugTemplateSource";
      templateUuid?: string | undefined;
      title?: string | undefined;
      eventType?: TransactionStageType | undefined;
      side?: TransactionSide | undefined;
      recipientTypes?: Array<string> | undefined;
      delayMinutes?: number | undefined;
      dataToShare?: Array<string> | undefined;
      messageContent?: string | undefined;
      hasAssignedPartner?: boolean | undefined;
      isAttachedToPartner?: boolean | undefined;
      status?: NotificationTemplateStatus | undefined;
      orderIndex?: number | undefined;
    }>;
  };
};

export type InternalEssentialsNotificationLogDebugQueryVariables = Exact<{
  logId: Scalars["ID"]["input"];
}>;

export type InternalEssentialsNotificationLogDebugQuery = {
  __typename?: "Query";
  internalEssentialsNotificationLogDebug: {
    __typename?: "InternalEssentialsNotificationLogDebugObject";
    rawLog?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    normalizedFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    identity: {
      __typename?: "DebugLogIdentity";
      logId: number;
      logUuid: string;
      organizationUuid: string;
      organizationName?: string | undefined;
      partnerUuid?: string | undefined;
      partnerName?: string | undefined;
      folderId?: string | undefined;
      templateUuid?: string | undefined;
      templateTitle?: string | undefined;
      notificationKind: NotificationLogKind;
      stage?: TransactionStageType | undefined;
      side?: TransactionSide | undefined;
      notificationType?: NotificationType | undefined;
    };
    lifecycle: {
      __typename?: "DebugLogLifecycle";
      createdAt: any;
      scheduledAt?: any | undefined;
      pausedAt?: any | undefined;
      addedToQueueAt?: any | undefined;
      sentAt?: any | undefined;
      undeliverableAt?: any | undefined;
      isDryRun: boolean;
      displayStatus: DebugLogDisplayStatus;
    };
    templateSource?:
      | {
          __typename?: "DebugTemplateSource";
          templateUuid?: string | undefined;
          title?: string | undefined;
          eventType?: TransactionStageType | undefined;
          side?: TransactionSide | undefined;
          recipientTypes?: Array<string> | undefined;
          delayMinutes?: number | undefined;
          dataToShare?: Array<string> | undefined;
          messageContent?: string | undefined;
          hasAssignedPartner?: boolean | undefined;
          isAttachedToPartner?: boolean | undefined;
          status?: NotificationTemplateStatus | undefined;
          orderIndex?: number | undefined;
        }
      | undefined;
    stageIntroSource?:
      | {
          __typename?: "DebugStageIntroSource";
          side: TransactionSide;
          stage: TransactionStageType;
          newRelationshipMessageContent?: string | undefined;
          existingRelationshipMessageContent?: string | undefined;
          allowPartnerContactAssignment: boolean;
        }
      | undefined;
    partnerConfig?:
      | {
          __typename?: "DebugPartnerConfig";
          partnerUuid: string;
          partnerName: string;
          isActive: boolean;
          dryRunNotifications: boolean;
          contactCount: number;
          adminContactCount: number;
        }
      | undefined;
    recipientResolution: {
      __typename?: "DebugRecipientResolution";
      requestedRecipientTypes: Array<string>;
      agentContactUuid?: string | undefined;
      rosterUsed?: boolean | undefined;
      isPaused: boolean;
      isFirstAssignment?: boolean | undefined;
      pauseReason?: string | undefined;
      resolvedContacts: Array<{
        __typename?: "DebugRecipientContact";
        uuid: string;
        fullName?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        contactType: ContactType;
      }>;
      resolvedRawRecipients: Array<{
        __typename?: "DebugRawRecipient";
        id: string;
        fullName?: string | undefined;
        email?: string | undefined;
        phoneNumber?: string | undefined;
        contactType?: string | undefined;
      }>;
    };
    routingDecisions: {
      __typename?: "DebugRoutingDecisions";
      decisions: Array<{
        __typename?: "DebugRoutingDecision";
        key: string;
        outcome: string;
        reason?: string | undefined;
      }>;
    };
    autofillRendering?:
      | {
          __typename?: "DebugAutofillRendering";
          computedAutofillValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          renderedTitle?: string | undefined;
          renderedBody?: string | undefined;
          templateVariables?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
        }
      | undefined;
    delivery?:
      | {
          __typename?: "DebugDelivery";
          workflowId?: string | undefined;
          isDryRunSkipped: boolean;
          isNoRecipientSkipped: boolean;
          preSanitizationRecipients?:
            | Array<{
                __typename?: "DebugRawRecipient";
                id: string;
                fullName?: string | undefined;
                email?: string | undefined;
                phoneNumber?: string | undefined;
                contactType?: string | undefined;
              }>
            | undefined;
          postSanitizationRecipients?:
            | Array<{
                __typename?: "DebugRawRecipient";
                id: string;
                fullName?: string | undefined;
                email?: string | undefined;
                phoneNumber?: string | undefined;
                contactType?: string | undefined;
              }>
            | undefined;
        }
      | undefined;
  };
};

export type InternalEssentialsNotificationLogsQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  partnerId?: InputMaybe<Scalars["ID"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InternalEssentialsNotificationLogsQuery = {
  __typename?: "Query";
  internalEssentialsNotificationLogs?:
    | {
        __typename?: "InternalEssentialsNotificationLogItemPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "InternalEssentialsNotificationLogItem";
              id: string;
              logId: number;
              logUuid: string;
              title: string;
              notificationKind: NotificationLogKind;
              displayStatus: DebugLogDisplayStatus;
              partnerName?: string | undefined;
              notificationType?: NotificationType | undefined;
              createdAt: any;
              sentAt?: any | undefined;
              isDryRun: boolean;
            }>
          | undefined;
      }
    | undefined;
};

export type InternalGetIngestionDocumentQueryVariables = Exact<{
  ingestionDocumentId: Scalars["ID"]["input"];
}>;

export type InternalGetIngestionDocumentQuery = {
  __typename?: "Query";
  getIngestionDocument: {
    __typename?: "IngestionDocumentObject";
    isValidDocumentMessageForExtraction?: string | undefined;
    id: string;
    fields?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    fileUrl?: string | undefined;
    documentName: string;
    documentId: string;
    documentUpdatedAt: any;
    s3Bucket: string;
    s3Key: string;
    isArchived: boolean;
    isBlank: boolean;
    isClassified: boolean;
    needsReview?: boolean | undefined;
    version: string;
    complianceStatus?: string | undefined;
    complianceGroupId?: string | undefined;
    complianceStatusId?: string | undefined;
    folderName?: string | undefined;
    docPageErrorMessage?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    documentML?:
      | {
          __typename?: "DocumentMLObject";
          id: string;
          documentClassification: Record<
            string,
            string | number | boolean | string[] | undefined
          >;
          updatedAt: any;
        }
      | undefined;
    contractDocuments: Array<{
      __typename?: "ContractDocumentObject";
      id: string;
      documentCategory?: string | undefined;
      ingestionFieldValues?:
        | Record<string, string | number | boolean | string[] | undefined>
        | undefined;
      aiIngestionFieldValues?:
        | Record<string, string | number | boolean | string[] | undefined>
        | undefined;
      interpretedFieldValues?:
        | Record<string, string | number | boolean | string[] | undefined>
        | undefined;
      interpretedFieldValuesExplanation?: string | undefined;
      mergedFieldValues?:
        | Record<string, string | number | boolean | string[] | undefined>
        | undefined;
      file: { __typename?: "FileObject"; url: string; fileName: string };
      documentVersion?:
        | {
            __typename?: "DocumentVersionObject";
            id: string;
            status: DocumentVersionStatus;
            version: string;
            searchRegex?: string | undefined;
            document: {
              __typename?: "DocumentObject";
              id: string;
              documentType: DocumentType;
              documentCategory?: DocumentCategory | undefined;
              name: string;
              form: string;
              usState: UsState;
            };
            documentVersionFields: Array<{
              __typename?: "DocumentVersionFieldObject";
              id: string;
              boundingBox: {
                __typename?: "BoundingBoxObject";
                top: number;
                left: number;
                bottom: number;
                right: number;
              };
              field: {
                __typename?: "FieldObject";
                id: string;
                label: string;
                mappingKey: string;
                aiInterpret?: boolean | undefined;
                defaultRules?:
                  | Array<{
                      __typename?: "RuleObject";
                      id: string;
                      message: string;
                      ruleType: RuleType;
                    }>
                  | undefined;
              };
              rules: Array<{
                __typename?: "RuleObject";
                id: string;
                message: string;
                ruleType: RuleType;
              }>;
            }>;
          }
        | undefined;
    }>;
    complianceGroupMetadata?:
      | {
          __typename?: "ComplianceGroupMetadataObject";
          id?: string | undefined;
          name?: string | undefined;
          type?: string | undefined;
          active?: boolean | undefined;
          transactionStageType?: TransactionStageType | undefined;
        }
      | undefined;
    validationRoutingDebug?:
      | {
          __typename?: "IngestionDocumentValidationRoutingDebugObject";
          source: DocumentValidationStageSelectionSource;
          transactionStageType?: TransactionStageType | undefined;
          shouldIgnore: boolean;
          isFolderNameOverrideEnabled: boolean;
          matchedFolderNameKeywordMapping?:
            | {
                __typename?: "FolderNameValidationStageKeywordMappingObject";
                keyword: string;
                action: FolderNameValidationStageOverrideAction;
                transactionStageType?: TransactionStageType | undefined;
              }
            | undefined;
        }
      | undefined;
  };
};

export type InternalOrganizationUsersQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InternalOrganizationUsersQuery = {
  __typename?: "Query";
  internalOrganizationUsers?:
    | {
        __typename?: "InternalOrgUserObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "InternalOrgUserObject";
              id: string;
              userUuid: string;
              firstName?: string | undefined;
              lastName?: string | undefined;
              email?: string | undefined;
              phoneNumber?: string | undefined;
              roles: Array<Roles>;
              accessRole: AccessRole;
            }>
          | undefined;
      }
    | undefined;
};

export type InvitationsListQueryVariables = Exact<{
  filters: AccessControlsListFilters;
}>;

export type InvitationsListQuery = {
  __typename?: "Query";
  invitationsList?:
    | {
        __typename?: "InvitationObjectPaginated";
        results?:
          | Array<{
              __typename?: "InvitationObject";
              inviteeAccessRole?: AccessRole | undefined;
              id: string;
              acceptedAt?: any | undefined;
              revokedAt?: any | undefined;
              expiresAt: any;
              notificationMeta?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              invitee: {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              };
              inviter: {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type IsFollowingListingQueryVariables = Exact<{
  input: ListingInput;
}>;

export type IsFollowingListingQuery = {
  __typename?: "Query";
  isFollowingListing: {
    __typename?: "IsFollowingListingObject";
    isFollowingListing: boolean;
  };
};

export type IsOpenHouseGuestBookSignedQueryVariables = Exact<{
  input: GetOpenHouseGuestbookStatusInput;
}>;

export type IsOpenHouseGuestBookSignedQuery = {
  __typename?: "Query";
  isOpenHouseGuestbookSigned: boolean;
};

export type OfferContractFragment = {
  __typename?: "ContractObject";
  id: string;
  fieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  enabledSecondaryDocumentVersionsFromRules?: Array<string> | undefined;
  validations?:
    | Array<{
        __typename?: "ContractValidationObject";
        field: {
          __typename?: "FieldObject";
          id: string;
          mappingKey: string;
          fieldType: FieldType;
          label: string;
          displayLabel?: string | undefined;
          group: string;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
        };
        documentVersionField: {
          __typename?: "DocumentVersionFieldObject";
          id: string;
          mappingKey: string;
          fieldType: FieldType;
          label: string;
          displayLabel?: string | undefined;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
        };
        results: Array<{
          __typename?: "RuleValidationObject";
          inputValue?: string | undefined;
          message: string;
          validationValue?: string | undefined;
          rule: { __typename?: "RuleObject"; id: string; ruleType: RuleType };
        }>;
      }>
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    order: number;
    externalDocumentType?: ExternalDocumentType | undefined;
    externalDocumentName?: string | undefined;
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          mappingKeys: Array<string>;
          version: string;
          document: {
            __typename?: "DocumentObject";
            id: string;
            name: string;
            form: string;
            documentType: DocumentType;
          };
        }
      | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    fields?:
      | Array<{
          __typename?: "DocumentVersionFieldObject";
          id: string;
          align: FieldAlign;
          pageNumber: number;
          fontFamily: string;
          fontSize: string;
          label: string;
          readOnly?: boolean | undefined;
          width: number;
          height: number;
          x: number;
          y: number;
          mappingKey: string;
          fieldType: FieldType;
          inputFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          boundingBox: {
            __typename?: "BoundingBoxObject";
            left: number;
            top: number;
            right: number;
            bottom: number;
          };
          labelBoundingBox?:
            | {
                __typename?: "BoundingBoxObject";
                left: number;
                top: number;
                right: number;
                bottom: number;
              }
            | undefined;
          labelField?:
            | {
                __typename?: "LabelFieldObject";
                height: number;
                width: number;
                x: number;
                y: number;
              }
            | undefined;
        }>
      | undefined;
  }>;
  signatureRequests?:
    | Array<{
        __typename?: "SignatureRequestObject";
        id: string;
        provider: SignatureProvider;
        externalId: string;
        allSignedDocument?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
};

export type LatestUnsubmittedOfferForBuyersAgentQueryVariables = Exact<{
  input: OffersForListingInput;
  isAgentVerified?: InputMaybe<Scalars["Boolean"]["input"]>;
  onlyId?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type LatestUnsubmittedOfferForBuyersAgentQuery = {
  __typename?: "Query";
  latestUnsubmittedOfferForBuyersAgent?:
    | {
        __typename?: "OfferObject";
        id: string;
        status: OfferStatus;
        source?: OfferSource | undefined;
        isUploaded: boolean;
        submittedAt?: any | undefined;
        noteToListingAgent?: string | undefined;
        contract?:
          | {
              __typename?: "ContractObject";
              id: string;
              fieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              enabledSecondaryDocumentVersionsFromRules?:
                | Array<string>
                | undefined;
              validations?:
                | Array<{
                    __typename?: "ContractValidationObject";
                    field: {
                      __typename?: "FieldObject";
                      id: string;
                      mappingKey: string;
                      fieldType: FieldType;
                      label: string;
                      displayLabel?: string | undefined;
                      group: string;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                    };
                    documentVersionField: {
                      __typename?: "DocumentVersionFieldObject";
                      id: string;
                      mappingKey: string;
                      fieldType: FieldType;
                      label: string;
                      displayLabel?: string | undefined;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                    };
                    results: Array<{
                      __typename?: "RuleValidationObject";
                      inputValue?: string | undefined;
                      message: string;
                      validationValue?: string | undefined;
                      rule: {
                        __typename?: "RuleObject";
                        id: string;
                        ruleType: RuleType;
                      };
                    }>;
                  }>
                | undefined;
              contractDocuments: Array<{
                __typename?: "ContractDocumentObject";
                id: string;
                order: number;
                externalDocumentType?: ExternalDocumentType | undefined;
                externalDocumentName?: string | undefined;
                documentVersion?:
                  | {
                      __typename?: "DocumentVersionObject";
                      id: string;
                      mappingKeys: Array<string>;
                      version: string;
                      document: {
                        __typename?: "DocumentObject";
                        id: string;
                        name: string;
                        form: string;
                        documentType: DocumentType;
                      };
                    }
                  | undefined;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
                fields?:
                  | Array<{
                      __typename?: "DocumentVersionFieldObject";
                      id: string;
                      align: FieldAlign;
                      pageNumber: number;
                      fontFamily: string;
                      fontSize: string;
                      label: string;
                      readOnly?: boolean | undefined;
                      width: number;
                      height: number;
                      x: number;
                      y: number;
                      mappingKey: string;
                      fieldType: FieldType;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                      boundingBox: {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      };
                      labelBoundingBox?:
                        | {
                            __typename?: "BoundingBoxObject";
                            left: number;
                            top: number;
                            right: number;
                            bottom: number;
                          }
                        | undefined;
                      labelField?:
                        | {
                            __typename?: "LabelFieldObject";
                            height: number;
                            width: number;
                            x: number;
                            y: number;
                          }
                        | undefined;
                    }>
                  | undefined;
              }>;
              signatureRequests?:
                | Array<{
                    __typename?: "SignatureRequestObject";
                    id: string;
                    provider: SignatureProvider;
                    externalId: string;
                    allSignedDocument?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
        party?: { __typename?: "PartyObject"; id: string } | undefined;
        primaryBuyer?:
          | {
              __typename?: "ConsumerObject";
              id: string;
              email?: string | undefined;
              fullName: string;
              phoneNumber?: string | undefined;
              isEntity: boolean;
              entityName?: string | undefined;
              entityTitle?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
        secondaryBuyers?:
          | Array<{
              __typename?: "ConsumerObject";
              id: string;
              email?: string | undefined;
              fullName: string;
              phoneNumber?: string | undefined;
              isEntity: boolean;
              entityName?: string | undefined;
              entityTitle?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }>
          | undefined;
        file: { __typename?: "FileObject"; fileName: string; url: string };
        events?:
          | Array<{
              __typename?: "AppEventObject";
              id: string;
              name: string;
              createdAt: any;
            }>
          | undefined;
        buyersAgent?:
          | {
              __typename?: "AgentObject";
              id: string;
              fullName: string;
              user?:
                | {
                    __typename?: "UserObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                    fullName: string;
                    userName?: string | undefined;
                    phoneNumber: string;
                    roles: Array<Roles>;
                    email?: string | undefined;
                    profileBio?: string | undefined;
                    offerCollectionEmail?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                    settings?:
                      | {
                          __typename?: "UserSettingsObject";
                          id: string;
                          selectedOrganization?:
                            | {
                                __typename?: "OrganizationObject";
                                id: string;
                                name: string;
                                hasDescendants?: boolean | undefined;
                                contractSystemCredentials?:
                                  | Array<{
                                      __typename?: "ContractSystemCredentialsObject";
                                      id: string;
                                      hasInvalidCredentials?:
                                        | boolean
                                        | undefined;
                                      isReady: boolean;
                                      type?: ContractSystemType | undefined;
                                      username?: string | undefined;
                                      dotloopProfileId?: string | undefined;
                                      dotloopTeamName?: string | undefined;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  latestUnsubmittedOfferForUnauthenticatedBuyersAgent?:
    | {
        __typename?: "OfferObject";
        id: string;
        status: OfferStatus;
        source?: OfferSource | undefined;
        isUploaded: boolean;
        submittedAt?: any | undefined;
        noteToListingAgent?: string | undefined;
        contract?:
          | {
              __typename?: "ContractObject";
              id: string;
              fieldValues?:
                | Record<
                    string,
                    string | number | boolean | string[] | undefined
                  >
                | undefined;
              enabledSecondaryDocumentVersionsFromRules?:
                | Array<string>
                | undefined;
              validations?:
                | Array<{
                    __typename?: "ContractValidationObject";
                    field: {
                      __typename?: "FieldObject";
                      id: string;
                      mappingKey: string;
                      fieldType: FieldType;
                      label: string;
                      displayLabel?: string | undefined;
                      group: string;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                    };
                    documentVersionField: {
                      __typename?: "DocumentVersionFieldObject";
                      id: string;
                      mappingKey: string;
                      fieldType: FieldType;
                      label: string;
                      displayLabel?: string | undefined;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                    };
                    results: Array<{
                      __typename?: "RuleValidationObject";
                      inputValue?: string | undefined;
                      message: string;
                      validationValue?: string | undefined;
                      rule: {
                        __typename?: "RuleObject";
                        id: string;
                        ruleType: RuleType;
                      };
                    }>;
                  }>
                | undefined;
              contractDocuments: Array<{
                __typename?: "ContractDocumentObject";
                id: string;
                order: number;
                externalDocumentType?: ExternalDocumentType | undefined;
                externalDocumentName?: string | undefined;
                documentVersion?:
                  | {
                      __typename?: "DocumentVersionObject";
                      id: string;
                      mappingKeys: Array<string>;
                      version: string;
                      document: {
                        __typename?: "DocumentObject";
                        id: string;
                        name: string;
                        form: string;
                        documentType: DocumentType;
                      };
                    }
                  | undefined;
                file: {
                  __typename?: "FileObject";
                  fileName: string;
                  url: string;
                };
                fields?:
                  | Array<{
                      __typename?: "DocumentVersionFieldObject";
                      id: string;
                      align: FieldAlign;
                      pageNumber: number;
                      fontFamily: string;
                      fontSize: string;
                      label: string;
                      readOnly?: boolean | undefined;
                      width: number;
                      height: number;
                      x: number;
                      y: number;
                      mappingKey: string;
                      fieldType: FieldType;
                      inputFormat?:
                        | {
                            __typename?: "InputFormatObject";
                            type: InputFormatType;
                            options: {
                              __typename?: "InputFormatOptionsObject";
                              precision?: number | undefined;
                              formatString?: string | undefined;
                              currencySymbol?: string | undefined;
                            };
                          }
                        | undefined;
                      boundingBox: {
                        __typename?: "BoundingBoxObject";
                        left: number;
                        top: number;
                        right: number;
                        bottom: number;
                      };
                      labelBoundingBox?:
                        | {
                            __typename?: "BoundingBoxObject";
                            left: number;
                            top: number;
                            right: number;
                            bottom: number;
                          }
                        | undefined;
                      labelField?:
                        | {
                            __typename?: "LabelFieldObject";
                            height: number;
                            width: number;
                            x: number;
                            y: number;
                          }
                        | undefined;
                    }>
                  | undefined;
              }>;
              signatureRequests?:
                | Array<{
                    __typename?: "SignatureRequestObject";
                    id: string;
                    provider: SignatureProvider;
                    externalId: string;
                    allSignedDocument?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }>
                | undefined;
            }
          | undefined;
        primaryBuyer?:
          | {
              __typename?: "ConsumerObject";
              id: string;
              email?: string | undefined;
              fullName: string;
              phoneNumber?: string | undefined;
              isEntity: boolean;
              entityName?: string | undefined;
              entityTitle?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
        secondaryBuyers?:
          | Array<{
              __typename?: "ConsumerObject";
              id: string;
              email?: string | undefined;
              fullName: string;
              phoneNumber?: string | undefined;
              isEntity: boolean;
              entityName?: string | undefined;
              entityTitle?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }>
          | undefined;
        file: { __typename?: "FileObject"; fileName: string; url: string };
        events?:
          | Array<{
              __typename?: "AppEventObject";
              id: string;
              name: string;
              createdAt: any;
            }>
          | undefined;
        buyersAgent?:
          | {
              __typename?: "AgentObject";
              id: string;
              fullName: string;
              user?:
                | {
                    __typename?: "UserObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                    fullName: string;
                    userName?: string | undefined;
                    phoneNumber: string;
                    roles: Array<Roles>;
                    email?: string | undefined;
                    profileBio?: string | undefined;
                    offerCollectionEmail?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                    settings?:
                      | {
                          __typename?: "UserSettingsObject";
                          id: string;
                          selectedOrganization?:
                            | {
                                __typename?: "OrganizationObject";
                                id: string;
                                name: string;
                                hasDescendants?: boolean | undefined;
                                contractSystemCredentials?:
                                  | Array<{
                                      __typename?: "ContractSystemCredentialsObject";
                                      id: string;
                                      hasInvalidCredentials?:
                                        | boolean
                                        | undefined;
                                      isReady: boolean;
                                      type?: ContractSystemType | undefined;
                                      username?: string | undefined;
                                      dotloopProfileId?: string | undefined;
                                      dotloopTeamName?: string | undefined;
                                    }>
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
        party?: { __typename?: "PartyObject"; id: string } | undefined;
      }
    | undefined;
};

export type ListingQueryVariables = Exact<{
  input: ListingInput;
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListingQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "ListingObject";
    id: string;
    isOwner?: boolean | undefined;
    listDate?: any | undefined;
    offersCountDisplay: string;
    submittedOffersCount: number;
    followerCount?: number | undefined;
    isPremium: boolean;
    status: MlsListingStatus;
    deletedFromRetsFeedAt?: string | undefined;
    property: {
      __typename?: "PropertyObject";
      id: string;
      slug: string;
      state: UsState;
    };
    offersSubmitted?:
      | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
      | undefined;
    listingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    coListingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    listingPreferences?: Array<{
      __typename?: "PreferenceValueObject";
      numberValue?: number | undefined;
      textValue?: string | undefined;
      stringValue?: string | undefined;
      stringArray?: Array<string> | undefined;
      booleanValue?: boolean | undefined;
      dateTimeValue?: any | undefined;
      readOnly?: boolean | undefined;
      preference: {
        __typename?: "PreferenceObject";
        id: string;
        name: string;
        slug: string;
        usStates: Array<UsState>;
        fieldId?: string | undefined;
        valueType: PreferenceValueType;
      };
    }>;
    storefrontSetup?:
      | {
          __typename?: "StorefrontSetupObject";
          continueStep?: StorefrontSetupStep | undefined;
          listingPackage: {
            __typename?: "FileObject";
            fileName: string;
            url: string;
          };
        }
      | undefined;
    setupDetails: {
      __typename?: "StorefrontConfigurationStatusObject";
      hasSetup?: boolean | undefined;
      configuredCount: number;
      progressTotal: number;
      sellerPreferences: boolean;
      comparables: boolean;
      documents: boolean;
    };
  };
};

export type ListingActivitiesQueryVariables = Exact<{
  input: ListingInput;
}>;

export type ListingActivitiesQuery = {
  __typename?: "Query";
  listingActivities?:
    | Array<{
        __typename?: "ActivityObject";
        id: string;
        type: ActivityType;
        metadata: Record<
          string,
          | string
          | number
          | boolean
          | string[]
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined
        >;
        createdAt: any;
        user?:
          | {
              __typename?: "PublicUserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              email?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export type OffersForListingFragment = {
  __typename?: "OfferObject";
  id: string;
  status: OfferStatus;
  source?: OfferSource | undefined;
  isUploaded: boolean;
  submittedAt?: any | undefined;
  noteToListingAgent?: string | undefined;
  contract?:
    | {
        __typename?: "ContractObject";
        id: string;
        fieldValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        contractDocuments: Array<{
          __typename?: "ContractDocumentObject";
          id: string;
          documentVersion?:
            | {
                __typename?: "DocumentVersionObject";
                id: string;
                document: {
                  __typename?: "DocumentObject";
                  id: string;
                  documentType: DocumentType;
                };
              }
            | undefined;
          file: { __typename?: "FileObject"; fileName: string; url: string };
        }>;
        validations?:
          | Array<{
              __typename?: "ContractValidationObject";
              field: {
                __typename?: "FieldObject";
                id: string;
                mappingKey: string;
                fieldType: FieldType;
                label: string;
                displayLabel?: string | undefined;
                group: string;
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
              };
              documentVersionField: {
                __typename?: "DocumentVersionFieldObject";
                id: string;
                mappingKey: string;
                fieldType: FieldType;
                label: string;
                displayLabel?: string | undefined;
                inputFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
              };
              results: Array<{
                __typename?: "RuleValidationObject";
                inputValue?: string | undefined;
                message: string;
                validationValue?: string | undefined;
                rule: {
                  __typename?: "RuleObject";
                  id: string;
                  ruleType: RuleType;
                };
              }>;
            }>
          | undefined;
        signatureRequests?:
          | Array<{
              __typename?: "SignatureRequestObject";
              id: string;
              provider: SignatureProvider;
              externalId: string;
              allSignedDocument?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
  primaryBuyer?:
    | {
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }
    | undefined;
  secondaryBuyers?:
    | Array<{
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
  file: { __typename?: "FileObject"; fileName: string; url: string };
  events?:
    | Array<{
        __typename?: "AppEventObject";
        id: string;
        name: string;
        createdAt: any;
      }>
    | undefined;
  buyersAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        fullName: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  party?: { __typename?: "PartyObject"; id: string } | undefined;
};

export type ListingAndOffersQueryVariables = Exact<{
  listingId: Scalars["String"]["input"];
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type ListingAndOffersQuery = {
  __typename?: "Query";
  listing: {
    __typename?: "ListingObject";
    id: string;
    isOwner?: boolean | undefined;
    listDate?: any | undefined;
    offersCountDisplay: string;
    submittedOffersCount: number;
    followerCount?: number | undefined;
    isPremium: boolean;
    status: MlsListingStatus;
    deletedFromRetsFeedAt?: string | undefined;
    property: {
      __typename?: "PropertyObject";
      id: string;
      slug: string;
      state: UsState;
    };
    offersSubmitted?:
      | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
      | undefined;
    listingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    coListingAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    listingPreferences?: Array<{
      __typename?: "PreferenceValueObject";
      numberValue?: number | undefined;
      textValue?: string | undefined;
      stringValue?: string | undefined;
      stringArray?: Array<string> | undefined;
      booleanValue?: boolean | undefined;
      dateTimeValue?: any | undefined;
      readOnly?: boolean | undefined;
      preference: {
        __typename?: "PreferenceObject";
        id: string;
        name: string;
        slug: string;
        usStates: Array<UsState>;
        fieldId?: string | undefined;
        valueType: PreferenceValueType;
      };
    }>;
    storefrontSetup?:
      | {
          __typename?: "StorefrontSetupObject";
          continueStep?: StorefrontSetupStep | undefined;
          listingPackage: {
            __typename?: "FileObject";
            fileName: string;
            url: string;
          };
        }
      | undefined;
    setupDetails: {
      __typename?: "StorefrontConfigurationStatusObject";
      hasSetup?: boolean | undefined;
      configuredCount: number;
      progressTotal: number;
      sellerPreferences: boolean;
      comparables: boolean;
      documents: boolean;
    };
  };
  offersForListing: Array<{
    __typename?: "OfferObject";
    id: string;
    status: OfferStatus;
    source?: OfferSource | undefined;
    isUploaded: boolean;
    submittedAt?: any | undefined;
    noteToListingAgent?: string | undefined;
    contract?:
      | {
          __typename?: "ContractObject";
          id: string;
          fieldValues?:
            | Record<string, string | number | boolean | string[] | undefined>
            | undefined;
          contractDocuments: Array<{
            __typename?: "ContractDocumentObject";
            id: string;
            documentVersion?:
              | {
                  __typename?: "DocumentVersionObject";
                  id: string;
                  document: {
                    __typename?: "DocumentObject";
                    id: string;
                    documentType: DocumentType;
                  };
                }
              | undefined;
            file: { __typename?: "FileObject"; fileName: string; url: string };
          }>;
          validations?:
            | Array<{
                __typename?: "ContractValidationObject";
                field: {
                  __typename?: "FieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  group: string;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                documentVersionField: {
                  __typename?: "DocumentVersionFieldObject";
                  id: string;
                  mappingKey: string;
                  fieldType: FieldType;
                  label: string;
                  displayLabel?: string | undefined;
                  inputFormat?:
                    | {
                        __typename?: "InputFormatObject";
                        type: InputFormatType;
                        options: {
                          __typename?: "InputFormatOptionsObject";
                          precision?: number | undefined;
                          formatString?: string | undefined;
                          currencySymbol?: string | undefined;
                        };
                      }
                    | undefined;
                };
                results: Array<{
                  __typename?: "RuleValidationObject";
                  inputValue?: string | undefined;
                  message: string;
                  validationValue?: string | undefined;
                  rule: {
                    __typename?: "RuleObject";
                    id: string;
                    ruleType: RuleType;
                  };
                }>;
              }>
            | undefined;
          signatureRequests?:
            | Array<{
                __typename?: "SignatureRequestObject";
                id: string;
                provider: SignatureProvider;
                externalId: string;
                allSignedDocument?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }>
            | undefined;
        }
      | undefined;
    primaryBuyer?:
      | {
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
    secondaryBuyers?:
      | Array<{
          __typename?: "ConsumerObject";
          id: string;
          email?: string | undefined;
          fullName: string;
          phoneNumber?: string | undefined;
          isEntity: boolean;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }>
      | undefined;
    file: { __typename?: "FileObject"; fileName: string; url: string };
    events?:
      | Array<{
          __typename?: "AppEventObject";
          id: string;
          name: string;
          createdAt: any;
        }>
      | undefined;
    buyersAgent?:
      | {
          __typename?: "AgentObject";
          id: string;
          fullName: string;
          user?:
            | {
                __typename?: "UserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                userName?: string | undefined;
                phoneNumber: string;
                roles: Array<Roles>;
                email?: string | undefined;
                profileBio?: string | undefined;
                offerCollectionEmail?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
                settings?:
                  | {
                      __typename?: "UserSettingsObject";
                      id: string;
                      selectedOrganization?:
                        | {
                            __typename?: "OrganizationObject";
                            id: string;
                            name: string;
                            hasDescendants?: boolean | undefined;
                            contractSystemCredentials?:
                              | Array<{
                                  __typename?: "ContractSystemCredentialsObject";
                                  id: string;
                                  hasInvalidCredentials?: boolean | undefined;
                                  isReady: boolean;
                                  type?: ContractSystemType | undefined;
                                  username?: string | undefined;
                                  dotloopProfileId?: string | undefined;
                                  dotloopTeamName?: string | undefined;
                                }>
                              | undefined;
                          }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    party?: { __typename?: "PartyObject"; id: string } | undefined;
  }>;
};

export type ListingAnnouncementsQueryVariables = Exact<{
  input: ListingAnnouncementInput;
}>;

export type ListingAnnouncementsQuery = {
  __typename?: "Query";
  listingAnnouncements: Array<{
    __typename?: "ListingAnnouncementObject";
    id: string;
    message: string;
    type: ListingAnnouncementType;
    bestAndFinalDate?: any | undefined;
    createdAt: any;
  }>;
};

export type ListingAnnouncementsCountQueryVariables = Exact<{
  input: ListingAnnouncementInput;
}>;

export type ListingAnnouncementsCountQuery = {
  __typename?: "Query";
  listingAnnouncementsCount: number;
};

export type ListingComparableSetQueryVariables = Exact<{
  input: ListingComparableSetInput;
}>;

export type ListingComparableSetQuery = {
  __typename?: "Query";
  listingComparableSet?:
    | {
        __typename?: "ListingComparableSetObject";
        id: string;
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "ListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
          adjustments?:
            | {
                __typename?: "ListingComparableAdjustmentsObject";
                id: string;
                priceAdjustmentsPerFields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                totalAdjustmentPrice?: number | undefined;
                notes?: string | undefined;
              }
            | undefined;
        }>;
        agent?: { __typename?: "AgentObject"; id: string } | undefined;
        listing?: { __typename?: "ListingObject"; id: string } | undefined;
        propertyDetails?:
          | { __typename?: "PropertyDetailsObject"; id: string }
          | undefined;
        buyerOfferAnalysis?:
          | { __typename?: "BuyerOfferAnalysisObject"; id: string }
          | undefined;
      }
    | undefined;
};

export type ListingComparableSetForAgentQueryVariables = Exact<{
  input: ListingComparableSetForAgentInput;
}>;

export type ListingComparableSetForAgentQuery = {
  __typename?: "Query";
  listingComparableSetForAgent?:
    | {
        __typename?: "ListingComparableSetObject";
        id: string;
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "ListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
          adjustments?:
            | {
                __typename?: "ListingComparableAdjustmentsObject";
                id: string;
                priceAdjustmentsPerFields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                totalAdjustmentPrice?: number | undefined;
                notes?: string | undefined;
              }
            | undefined;
        }>;
        agent?: { __typename?: "AgentObject"; id: string } | undefined;
        listing?: { __typename?: "ListingObject"; id: string } | undefined;
        propertyDetails?:
          | { __typename?: "PropertyDetailsObject"; id: string }
          | undefined;
        buyerOfferAnalysis?:
          | { __typename?: "BuyerOfferAnalysisObject"; id: string }
          | undefined;
      }
    | undefined;
};

export type ListingComparableSetForBoaTokenQueryVariables = Exact<{
  input: ListingComparableSetForBoaTokenInput;
}>;

export type ListingComparableSetForBoaTokenQuery = {
  __typename?: "Query";
  listingComparableSetForBOAToken?:
    | {
        __typename?: "ListingComparableSetObject";
        id: string;
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "ListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
          adjustments?:
            | {
                __typename?: "ListingComparableAdjustmentsObject";
                id: string;
                priceAdjustmentsPerFields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                totalAdjustmentPrice?: number | undefined;
                notes?: string | undefined;
              }
            | undefined;
        }>;
        agent?: { __typename?: "AgentObject"; id: string } | undefined;
        listing?: { __typename?: "ListingObject"; id: string } | undefined;
        propertyDetails?:
          | { __typename?: "PropertyDetailsObject"; id: string }
          | undefined;
        buyerOfferAnalysis?:
          | { __typename?: "BuyerOfferAnalysisObject"; id: string }
          | undefined;
      }
    | undefined;
};

export type ListingComparableSetForBuyerOfferAnalysisQueryVariables = Exact<{
  input: ListingComparableSetForBuyerOfferAnalysisInput;
}>;

export type ListingComparableSetForBuyerOfferAnalysisQuery = {
  __typename?: "Query";
  listingComparableSetForBuyerOfferAnalysis?:
    | {
        __typename?: "ListingComparableSetObject";
        id: string;
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "ListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
          adjustments?:
            | {
                __typename?: "ListingComparableAdjustmentsObject";
                id: string;
                priceAdjustmentsPerFields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                totalAdjustmentPrice?: number | undefined;
                notes?: string | undefined;
              }
            | undefined;
        }>;
        agent?: { __typename?: "AgentObject"; id: string } | undefined;
        listing?: { __typename?: "ListingObject"; id: string } | undefined;
        propertyDetails?:
          | { __typename?: "PropertyDetailsObject"; id: string }
          | undefined;
        buyerOfferAnalysis?:
          | { __typename?: "BuyerOfferAnalysisObject"; id: string }
          | undefined;
      }
    | undefined;
};

export type ListingComparableSetForReportTokenQueryVariables = Exact<{
  input: ListingComparableSetForReportTokenInput;
}>;

export type ListingComparableSetForReportTokenQuery = {
  __typename?: "Query";
  listingComparableSetForReportToken?:
    | {
        __typename?: "ListingComparableSetObject";
        id: string;
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "ListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
          adjustments?:
            | {
                __typename?: "ListingComparableAdjustmentsObject";
                id: string;
                priceAdjustmentsPerFields?:
                  | Record<
                      string,
                      string | number | boolean | string[] | undefined
                    >
                  | undefined;
                totalAdjustmentPrice?: number | undefined;
                notes?: string | undefined;
              }
            | undefined;
        }>;
        agent?: { __typename?: "AgentObject"; id: string } | undefined;
        listing?: { __typename?: "ListingObject"; id: string } | undefined;
        propertyDetails?:
          | { __typename?: "PropertyDetailsObject"; id: string }
          | undefined;
        buyerOfferAnalysis?:
          | { __typename?: "BuyerOfferAnalysisObject"; id: string }
          | undefined;
      }
    | undefined;
};

export type ListingDocumentTypesQueryVariables = Exact<{
  input: ListingDocumentTypesInput;
}>;

export type ListingDocumentTypesQuery = {
  __typename?: "Query";
  listingDocumentTypes: Array<{
    __typename?: "ListingDocumentTypeObject";
    id: string;
    slug: string;
    usState: UsState;
    name: string;
    formName: string;
    type: ListingDocumentTypeEnum;
  }>;
};

export type ListingDocumentUploadsQueryVariables = Exact<{
  input: ListingDocumentUploadsInput;
}>;

export type ListingDocumentUploadsQuery = {
  __typename?: "Query";
  listingDocumentUploads?:
    | Array<{
        __typename?: "ListingDocumentUploadObject";
        id: string;
        customDocumentType?: ListingDocumentTypeEnum | undefined;
        customDocumentName?: string | undefined;
        listingDocumentType?:
          | {
              __typename?: "ListingDocumentTypeObject";
              id: string;
              slug: string;
              usState: UsState;
              name: string;
              formName: string;
              type: ListingDocumentTypeEnum;
              document?:
                | {
                    __typename?: "DocumentObject";
                    id: string;
                    form: string;
                    name: string;
                    description: string;
                    activeDocumentVersion: {
                      __typename?: "DocumentVersionObject";
                      id: string;
                      mappingKeys: Array<string>;
                      previewImages: Array<{
                        __typename?: "AssetFileObject";
                        id: string;
                        ordering: number;
                        file: { __typename?: "FileObject"; url: string };
                      }>;
                    };
                  }
                | undefined;
            }
          | undefined;
        file?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
};

export type ListingFollowersQueryVariables = Exact<{
  input: ListingInput;
}>;

export type ListingFollowersQuery = {
  __typename?: "Query";
  listingFollowers: {
    __typename?: "ListingFollowersObject";
    listingFollowers: Array<{
      __typename?: "ListingFollowerObject";
      followedAt: any;
      user: {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        phoneNumber: string;
        roles: Array<Roles>;
        email?: string | undefined;
        profileBio?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        settings?:
          | {
              __typename?: "UserSettingsObject";
              id: string;
              selectedOrganization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                    hasDescendants?: boolean | undefined;
                    contractSystemCredentials?:
                      | Array<{
                          __typename?: "ContractSystemCredentialsObject";
                          id: string;
                          hasInvalidCredentials?: boolean | undefined;
                          isReady: boolean;
                          type?: ContractSystemType | undefined;
                          username?: string | undefined;
                          dotloopProfileId?: string | undefined;
                          dotloopTeamName?: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      };
    }>;
  };
};

export type ListingforMlsListingQueryVariables = Exact<{
  input: MlsListingInput;
}>;

export type ListingforMlsListingQuery = {
  __typename?: "Query";
  syncListingFromMLS: {
    __typename?: "PublicListingObject";
    id: string;
    property: { __typename?: "PublicPropertyObject"; id: string; slug: string };
  };
};

export type ListingOpenHousesQueryVariables = Exact<{
  input: ListingOpenHousesInput;
}>;

export type ListingOpenHousesQuery = {
  __typename?: "Query";
  listingOpenHouses: {
    __typename?: "ListingOpenHousesPayload";
    results: Array<{
      __typename?: "OpenHouseObject";
      id: string;
      date: string;
      startTime: string;
      endTime: string;
      numGuestbookSigners: number;
      source: OpenHouseSource;
    }>;
  };
};

export type ListingsForCurrentUserQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  filters: ListingsFilterArgs;
}>;

export type ListingsForCurrentUserQuery = {
  __typename?: "Query";
  listingsForCurrentUser?:
    | {
        __typename?: "ListingObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              perPage: number;
              prevCursor?: string | undefined;
              totalCount: number;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "ListingObject";
              isSharedListing?: boolean | undefined;
              id: string;
              isOwner?: boolean | undefined;
              listDate?: any | undefined;
              offersCountDisplay: string;
              submittedOffersCount: number;
              followerCount?: number | undefined;
              isPremium: boolean;
              status: MlsListingStatus;
              deletedFromRetsFeedAt?: string | undefined;
              property: {
                __typename?: "PropertyObject";
                id: string;
                slug: string;
                state: UsState;
              };
              offersSubmitted?:
                | Array<{
                    __typename?: "OfferObject";
                    id: string;
                    status: OfferStatus;
                  }>
                | undefined;
              listingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    inboundEmail: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              coListingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    inboundEmail: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          phoneNumber: string;
                          email?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
              listingPreferences?: Array<{
                __typename?: "PreferenceValueObject";
                numberValue?: number | undefined;
                textValue?: string | undefined;
                stringValue?: string | undefined;
                stringArray?: Array<string> | undefined;
                booleanValue?: boolean | undefined;
                dateTimeValue?: any | undefined;
                readOnly?: boolean | undefined;
                preference: {
                  __typename?: "PreferenceObject";
                  id: string;
                  name: string;
                  slug: string;
                  usStates: Array<UsState>;
                  fieldId?: string | undefined;
                  valueType: PreferenceValueType;
                };
              }>;
              storefrontSetup?:
                | {
                    __typename?: "StorefrontSetupObject";
                    continueStep?: StorefrontSetupStep | undefined;
                    listingPackage: {
                      __typename?: "FileObject";
                      fileName: string;
                      url: string;
                    };
                  }
                | undefined;
              setupDetails: {
                __typename?: "StorefrontConfigurationStatusObject";
                hasSetup?: boolean | undefined;
                configuredCount: number;
                progressTotal: number;
                sellerPreferences: boolean;
                comparables: boolean;
                documents: boolean;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type ListingsForOrganizationQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  filters: ListingsForOrganizationFilterArgs;
}>;

export type ListingsForOrganizationQuery = {
  __typename?: "Query";
  listingsForOrganization?:
    | {
        __typename?: "ListingObjectListingsForOrganizationPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              perPage: number;
              prevCursor?: string | undefined;
              totalCount: number;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "ListingObject";
              id: string;
              offersCountDisplay: string;
              guestbookSignersCount: number;
              submittedOffersCount: number;
              listDate?: any | undefined;
              isPremium: boolean;
              isSharedListing?: boolean | undefined;
              status: MlsListingStatus;
              deletedFromRetsFeedAt?: string | undefined;
              property: {
                __typename?: "PropertyObject";
                id: string;
                slug: string;
                state: UsState;
                geo?:
                  | { __typename?: "GeoObject"; lat: number; lng: number }
                  | undefined;
              };
              currentAndUpcomingOpenHouses?:
                | Array<{
                    __typename?: "PublicOpenHouseObject";
                    id: string;
                    date: string;
                    startTime: string;
                    endTime: string;
                  }>
                | undefined;
              listingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          phoneNumber: string;
                          roles: Array<Roles>;
                          email?: string | undefined;
                          profileBio?: string | undefined;
                          offerCollectionEmail?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                          settings?:
                            | {
                                __typename?: "UserSettingsObject";
                                id: string;
                                selectedOrganization?:
                                  | {
                                      __typename?: "OrganizationObject";
                                      id: string;
                                      name: string;
                                      hasDescendants?: boolean | undefined;
                                      contractSystemCredentials?:
                                        | Array<{
                                            __typename?: "ContractSystemCredentialsObject";
                                            id: string;
                                            hasInvalidCredentials?:
                                              | boolean
                                              | undefined;
                                            isReady: boolean;
                                            type?:
                                              | ContractSystemType
                                              | undefined;
                                            username?: string | undefined;
                                            dotloopProfileId?:
                                              | string
                                              | undefined;
                                            dotloopTeamName?:
                                              | string
                                              | undefined;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              coListingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          phoneNumber: string;
                          roles: Array<Roles>;
                          email?: string | undefined;
                          profileBio?: string | undefined;
                          offerCollectionEmail?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                          settings?:
                            | {
                                __typename?: "UserSettingsObject";
                                id: string;
                                selectedOrganization?:
                                  | {
                                      __typename?: "OrganizationObject";
                                      id: string;
                                      name: string;
                                      hasDescendants?: boolean | undefined;
                                      contractSystemCredentials?:
                                        | Array<{
                                            __typename?: "ContractSystemCredentialsObject";
                                            id: string;
                                            hasInvalidCredentials?:
                                              | boolean
                                              | undefined;
                                            isReady: boolean;
                                            type?:
                                              | ContractSystemType
                                              | undefined;
                                            username?: string | undefined;
                                            dotloopProfileId?:
                                              | string
                                              | undefined;
                                            dotloopTeamName?:
                                              | string
                                              | undefined;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
              organizations?:
                | Array<{ __typename?: "OrganizationObject"; id: string }>
                | undefined;
              setupDetails: {
                __typename?: "StorefrontConfigurationStatusObject";
                configuredCount: number;
                documents: boolean;
                progressTotal: number;
                sellerPreferences: boolean;
                comparables: boolean;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type ListingForOrganizationFragment = {
  __typename?: "ListingObject";
  id: string;
  offersCountDisplay: string;
  guestbookSignersCount: number;
  submittedOffersCount: number;
  listDate?: any | undefined;
  isPremium: boolean;
  isSharedListing?: boolean | undefined;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: {
    __typename?: "PropertyObject";
    id: string;
    slug: string;
    state: UsState;
    geo?: { __typename?: "GeoObject"; lat: number; lng: number } | undefined;
  };
  currentAndUpcomingOpenHouses?:
    | Array<{
        __typename?: "PublicOpenHouseObject";
        id: string;
        date: string;
        startTime: string;
        endTime: string;
      }>
    | undefined;
  listingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  coListingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
  organizations?:
    | Array<{ __typename?: "OrganizationObject"; id: string }>
    | undefined;
  setupDetails: {
    __typename?: "StorefrontConfigurationStatusObject";
    configuredCount: number;
    documents: boolean;
    progressTotal: number;
    sellerPreferences: boolean;
    comparables: boolean;
  };
};

export type NotificationLogAutofillVariablesSchemaQueryVariables = Exact<{
  [key: string]: never;
}>;

export type NotificationLogAutofillVariablesSchemaQuery = {
  __typename?: "Query";
  notificationLogAutofillVariablesSchema: Record<
    string,
    string | number | boolean | string[] | undefined
  >;
};

export type NotificationLogAutofillValuesQueryVariables = Exact<{
  notificationLogId?: InputMaybe<Scalars["ID"]["input"]>;
  notificationTemplateId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type NotificationLogAutofillValuesQuery = {
  __typename?: "Query";
  notificationLogAutofillValues: {
    __typename?: "NotificationLogAutofillObject";
    normalizedFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    assignedAgentFirstName?: string | undefined;
    assignedAgentName?: string | undefined;
    assignedPartnerCalendarSchedulingUrl?: string | undefined;
    assignedPartnerEmail?: string | undefined;
    assignedPartnerFirstName?: string | undefined;
    assignedPartnerName?: string | undefined;
    assignedPartnerPhoneNumber?: string | undefined;
    assignedPartnerPreApprovalAppUrl?: string | undefined;
    buyerAgentFirstName?: string | undefined;
    buyersFirstNames?: string | undefined;
    listingAgentFirstName?: string | undefined;
    partnerCompanyName?: string | undefined;
    sellersFirstNames?: string | undefined;
  };
};

export type GetUserNotificationSettingsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserNotificationSettingsQuery = {
  __typename?: "Query";
  userNotificationSettings: {
    __typename?: "UserNotificationSettingsObject";
    email: boolean;
    sms: boolean;
  };
};

export type NotificationTemplateQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type NotificationTemplateQuery = {
  __typename?: "Query";
  notificationTemplate?:
    | {
        __typename?: "NotificationTemplateObject";
        id: string;
        title: string;
        eventType: TransactionStageType;
        side?: TransactionSide | undefined;
        notificationType: NotificationType;
        recipients: Array<ContactType>;
        hasAssignedPartner?: boolean | undefined;
        isAttachedToPartner?: boolean | undefined;
        delayMinutes: number;
        dataToShare: Array<string>;
        messageContent: string;
        status: NotificationTemplateStatus;
        orderIndex: number;
        messageContentTemplates: {
          __typename?: "NotificationTemplateMessageContentTemplates";
          html: string;
          text: string;
        };
      }
    | undefined;
};

export type NotificationTemplatesListQueryVariables = Exact<{
  partnerId: Scalars["ID"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<NotificationTemplateFilters>;
}>;

export type NotificationTemplatesListQuery = {
  __typename?: "Query";
  notificationTemplatesList?:
    | {
        __typename?: "NotificationTemplateObjectNotificationTemplateListPaginatedPaginated";
        results?:
          | Array<{
              __typename?: "NotificationTemplateObject";
              id: string;
              title: string;
              eventType: TransactionStageType;
              side?: TransactionSide | undefined;
              notificationType: NotificationType;
              recipients: Array<ContactType>;
              status: NotificationTemplateStatus;
              messageContent: string;
              delayMinutes: number;
              orderIndex: number;
              messageContentTemplates: {
                __typename?: "NotificationTemplateMessageContentTemplates";
                html: string;
                text: string;
              };
              partner?:
                | {
                    __typename?: "OrganizationPartnerObject";
                    id: string;
                    name: string;
                    isActive: boolean;
                    logo?:
                      | { __typename?: "FileObject"; url: string }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
              perPage: number;
            }
          | undefined;
      }
    | undefined;
};

export type OfferAutofillValuesQueryVariables = Exact<{
  listingId?: InputMaybe<Scalars["ID"]["input"]>;
  offerId?: InputMaybe<Scalars["ID"]["input"]>;
  documentVersionIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
  fieldValues: Scalars["JSONObject"]["input"];
}>;

export type OfferAutofillValuesQuery = {
  __typename?: "Query";
  offerAutofillValues?:
    | {
        __typename?: "OfferAutofillValuesPayload";
        readOnlyAutofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        autofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        helpTextAutofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
        optionsAutofillValues?:
          | Record<string, string | number | boolean | string[] | undefined>
          | undefined;
      }
    | undefined;
};

export type OfferMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type OfferMetricsQuery = {
  __typename?: "Query";
  offerMetrics: Array<{
    __typename?: "OfferMetricsObject";
    accepted_bid_ask: number;
    not_accepted_earnest_money_deposit: number;
    property_city: string;
    property_state: string;
    purchase_price_range: string;
    not_accepted_due_diligence_fee: number;
    not_accepted_due_diligence_and_deposit: number;
    not_accepted_bid_ask: number;
    interval_start: string;
    accepted_earnest_money_deposit: number;
    accepted_due_diligence_fee: number;
    accepted_due_diligence_and_deposit: number;
  }>;
};

export type OffersForCurrentUserFragment = {
  __typename?: "OfferObject";
  id: string;
  updatedAt?: any | undefined;
  status: OfferStatus;
  buyersAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              phoneNumber: string;
              roles: Array<Roles>;
              email?: string | undefined;
              profileBio?: string | undefined;
              offerCollectionEmail?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
              settings?:
                | {
                    __typename?: "UserSettingsObject";
                    id: string;
                    selectedOrganization?:
                      | {
                          __typename?: "OrganizationObject";
                          id: string;
                          name: string;
                          hasDescendants?: boolean | undefined;
                          contractSystemCredentials?:
                            | Array<{
                                __typename?: "ContractSystemCredentialsObject";
                                id: string;
                                hasInvalidCredentials?: boolean | undefined;
                                isReady: boolean;
                                type?: ContractSystemType | undefined;
                                username?: string | undefined;
                                dotloopProfileId?: string | undefined;
                                dotloopTeamName?: string | undefined;
                              }>
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  party?: { __typename?: "PartyObject"; id: string } | undefined;
  primaryBuyer?:
    | {
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }
    | undefined;
  secondaryBuyers?:
    | Array<{
        __typename?: "ConsumerObject";
        id: string;
        email?: string | undefined;
        fullName: string;
        phoneNumber?: string | undefined;
        isEntity: boolean;
        entityName?: string | undefined;
        entityTitle?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
  listing?:
    | {
        __typename?: "ListingObject";
        id: string;
        listingAgent?:
          | {
              __typename?: "AgentObject";
              id: string;
              user?: { __typename?: "UserObject"; id: string } | undefined;
            }
          | undefined;
        mlsListing?:
          | {
              __typename?: "MLSListingObject";
              id: string;
              photos: Array<string>;
              address: {
                __typename?: "MLSListingAddressObject";
                city: string;
                country?: string | undefined;
                crossStreet?: string | undefined;
                full: string;
                postalCode?: string | undefined;
                state: string;
                streetName: string;
                streetNumber?: number | undefined;
                streetNumberText: string;
                unit?: string | undefined;
              };
            }
          | undefined;
      }
    | undefined;
};

export type OffersForCurentUserQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: Scalars["String"]["input"];
  perPage?: Scalars["Int"]["input"];
  filters?: InputMaybe<OffersForCurrentUserFilters>;
}>;

export type OffersForCurentUserQuery = {
  __typename?: "Query";
  offersForCurrentUser?:
    | {
        __typename?: "OfferObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "OfferObject";
              id: string;
              updatedAt?: any | undefined;
              status: OfferStatus;
              buyersAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          phoneNumber: string;
                          roles: Array<Roles>;
                          email?: string | undefined;
                          profileBio?: string | undefined;
                          offerCollectionEmail?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                          settings?:
                            | {
                                __typename?: "UserSettingsObject";
                                id: string;
                                selectedOrganization?:
                                  | {
                                      __typename?: "OrganizationObject";
                                      id: string;
                                      name: string;
                                      hasDescendants?: boolean | undefined;
                                      contractSystemCredentials?:
                                        | Array<{
                                            __typename?: "ContractSystemCredentialsObject";
                                            id: string;
                                            hasInvalidCredentials?:
                                              | boolean
                                              | undefined;
                                            isReady: boolean;
                                            type?:
                                              | ContractSystemType
                                              | undefined;
                                            username?: string | undefined;
                                            dotloopProfileId?:
                                              | string
                                              | undefined;
                                            dotloopTeamName?:
                                              | string
                                              | undefined;
                                          }>
                                        | undefined;
                                    }
                                  | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              party?: { __typename?: "PartyObject"; id: string } | undefined;
              primaryBuyer?:
                | {
                    __typename?: "ConsumerObject";
                    id: string;
                    email?: string | undefined;
                    fullName: string;
                    phoneNumber?: string | undefined;
                    isEntity: boolean;
                    entityName?: string | undefined;
                    entityTitle?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }
                | undefined;
              secondaryBuyers?:
                | Array<{
                    __typename?: "ConsumerObject";
                    id: string;
                    email?: string | undefined;
                    fullName: string;
                    phoneNumber?: string | undefined;
                    isEntity: boolean;
                    entityName?: string | undefined;
                    entityTitle?: string | undefined;
                    profilePicture?:
                      | {
                          __typename?: "FileObject";
                          fileName: string;
                          url: string;
                        }
                      | undefined;
                  }>
                | undefined;
              listing?:
                | {
                    __typename?: "ListingObject";
                    id: string;
                    listingAgent?:
                      | {
                          __typename?: "AgentObject";
                          id: string;
                          user?:
                            | { __typename?: "UserObject"; id: string }
                            | undefined;
                        }
                      | undefined;
                    mlsListing?:
                      | {
                          __typename?: "MLSListingObject";
                          id: string;
                          photos: Array<string>;
                          address: {
                            __typename?: "MLSListingAddressObject";
                            city: string;
                            country?: string | undefined;
                            crossStreet?: string | undefined;
                            full: string;
                            postalCode?: string | undefined;
                            state: string;
                            streetName: string;
                            streetNumber?: number | undefined;
                            streetNumberText: string;
                            unit?: string | undefined;
                          };
                        }
                      | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type OpenHousesForCurrentUserQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  filters?: InputMaybe<OpenHousesFilterArgs>;
}>;

export type OpenHousesForCurrentUserQuery = {
  __typename?: "Query";
  openHousesForCurrentUser?:
    | {
        __typename?: "OpenHouseObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "OpenHouseObject";
              id: string;
              date: string;
              startTime: string;
              endTime: string;
              listing: {
                __typename?: "ListingObject";
                id: string;
                followerCount?: number | undefined;
                mlsListing?:
                  | {
                      __typename?: "MLSListingObject";
                      id: string;
                      mlsId?: number | undefined;
                      listingId?: string | undefined;
                      listDate?: string | undefined;
                      listPrice?: number | undefined;
                      originalListPrice?: number | undefined;
                      terms?: string | undefined;
                      photos: Array<string>;
                      remarks?: string | undefined;
                      modified?: string | undefined;
                      mlsName?: string | undefined;
                      deleted_at?: string | undefined;
                      addressFull: string;
                      agent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      coAgent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      address: {
                        __typename?: "MLSListingAddressObject";
                        city: string;
                        country?: string | undefined;
                        crossStreet?: string | undefined;
                        full: string;
                        postalCode?: string | undefined;
                        state: string;
                        streetName: string;
                        streetNumber?: number | undefined;
                        streetNumberText: string;
                        unit?: string | undefined;
                      };
                      property?:
                        | {
                            __typename?: "MLSListingPropertyObject";
                            roof?: string | undefined;
                            cooling?: string | undefined;
                            style?: string | undefined;
                            area?: number | undefined;
                            bathsFull?: number | undefined;
                            bathsHalf?: number | undefined;
                            stories?: number | undefined;
                            fireplaces?: number | undefined;
                            flooring?: string | undefined;
                            heating?: string | undefined;
                            bathrooms?: string | undefined;
                            foundation?: string | undefined;
                            poolFeatures?: string | undefined;
                            laundryFeatures?: string | undefined;
                            occupantName?: string | undefined;
                            ownerName?: string | undefined;
                            lotDescription?: string | undefined;
                            acres?: number | undefined;
                            subType?: string | undefined;
                            bedrooms?: number | undefined;
                            interiorFeatures?: string | undefined;
                            lotSize?: string | undefined;
                            areaSource?: string | undefined;
                            maintenanceExpense?: number | undefined;
                            additionalRooms?: string | undefined;
                            exteriorFeatures?: string | undefined;
                            water?: string | undefined;
                            view?: string | undefined;
                            lotSizeArea?: number | undefined;
                            lotSizeAreaUnits?: string | undefined;
                            subdivision?: string | undefined;
                            construction?: string | undefined;
                            type?: MlsListingType | undefined;
                            garageSpaces?: number | undefined;
                            bathsThreeQuarter?: number | undefined;
                            accessibility?: string | undefined;
                            occupantType?: string | undefined;
                            yearBuilt?: number | undefined;
                            subTypeText?: string | undefined;
                          }
                        | undefined;
                      office?:
                        | {
                            __typename?: "MLSListingOfficeObject";
                            brokerid?: string | undefined;
                            name?: string | undefined;
                            servingName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      mls?:
                        | {
                            __typename?: "MLSListingMLSObject";
                            statusText: string;
                            status?: MlsListingStatus | undefined;
                            daysOnMarket?: number | undefined;
                            originalEntryTimestamp?: string | undefined;
                            originatingSystemName?: string | undefined;
                            logoUrl?: string | undefined;
                            disclaimer?: string | undefined;
                          }
                        | undefined;
                      association?:
                        | {
                            __typename?: "MLSListingAssociationObject";
                            fee?: number | undefined;
                            frequency?: string | undefined;
                            name?: string | undefined;
                            amenities?: string | undefined;
                          }
                        | undefined;
                      compliance?:
                        | {
                            __typename?: "MLSListingComplianceObject";
                            buyerAgencyCompensation?: number | undefined;
                            buyerAgencyCompensationType?: string | undefined;
                            subAgencyCompensation?: number | undefined;
                            subAgencyCompensationType?: string | undefined;
                            attributionContact?: string | undefined;
                          }
                        | undefined;
                      sales?:
                        | {
                            __typename?: "MLSListingSalesObject";
                            closeDate?: string | undefined;
                            closePrice?: number | undefined;
                            contractDate?: string | undefined;
                          }
                        | undefined;
                      geo: {
                        __typename?: "MLSListingGeoObject";
                        location: {
                          __typename?: "GeoPointObject";
                          lat: number;
                          lon: number;
                        };
                      };
                    }
                  | undefined;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type OpenHouseForCurrentUserFragment = {
  __typename?: "OpenHouseObject";
  id: string;
  date: string;
  startTime: string;
  endTime: string;
  listing: {
    __typename?: "ListingObject";
    id: string;
    followerCount?: number | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
  };
};

export type OpenHouseQueryVariables = Exact<{
  input: OpenHouseInput;
}>;

export type OpenHouseQuery = {
  __typename?: "Query";
  openHouse: {
    __typename?: "OpenHouseObject";
    id: string;
    date: string;
    startTime: string;
    endTime: string;
    listing: {
      __typename?: "ListingObject";
      id: string;
      property: { __typename?: "PropertyObject"; slug: string };
      mlsListing?:
        | {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            photos: Array<string>;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  originatingSystemName?: string | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              full: string;
              state: string;
              city: string;
              postalCode?: string | undefined;
            };
          }
        | undefined;
    };
  };
};

export type OrgListingAggDeltaByStatusQueryVariables = Exact<{
  input: OrgListingAggDeltaByStatusInput;
}>;

export type OrgListingAggDeltaByStatusQuery = {
  __typename?: "Query";
  orgListingAggDeltaByStatus: {
    __typename?: "OrgListingAggDeltaByStatusPayload";
    organization: {
      __typename?: "OrganizationObject";
      id: string;
      name: string;
      hasDescendants?: boolean | undefined;
      contractSystemCredentials?:
        | Array<{
            __typename?: "ContractSystemCredentialsObject";
            id: string;
            isReady: boolean;
            type?: ContractSystemType | undefined;
            hasInvalidCredentials?: boolean | undefined;
            username?: string | undefined;
            dotloopProfileId?: string | undefined;
            dotloopTeamName?: string | undefined;
          }>
        | undefined;
      mainMLS?:
        | {
            __typename?: "MLSObject";
            id: string;
            name: string;
            originatingSystemName?: string | undefined;
          }
        | undefined;
    };
    differences: Array<{
      __typename?: "ListingAggDeltaByStatus";
      status: MlsListingStatus;
      countDifference: number;
      sumListPriceDifference?: number | undefined;
    }>;
  };
};

export type OrgTransactionStatsByZipCodeQueryVariables = Exact<{
  filters: AgentPerformanceFilters;
}>;

export type OrgTransactionStatsByZipCodeQuery = {
  __typename?: "Query";
  orgTransactionStatsByZipCode: Array<{
    __typename?: "OrgTransactionStatsByZipCodeObject";
    buy_side_homes_count: number;
    unknown_homes_count: number;
    zip_code: string;
    buy_side_volume: number;
    closed_homes_count: number;
    closed_volume: number;
    pending_homes_count: number;
    pending_volume: number;
    sell_side_homes_count: number;
    sell_side_volume: number;
    total_homes_count: number;
    total_volume: number;
  }>;
};

export type OrganizationCrawlerInfoQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type OrganizationCrawlerInfoQuery = {
  __typename?: "Query";
  organization: {
    __typename?: "OrganizationObject";
    id: string;
    contractSystemCredentials?:
      | Array<{
          __typename?: "ContractSystemCredentialsObject";
          id: string;
          isHourly?: boolean | undefined;
          isLive?: boolean | undefined;
        }>
      | undefined;
  };
};

export type OrganizationCrawlerInfoFragment = {
  __typename?: "OrganizationObject";
  id: string;
  contractSystemCredentials?:
    | Array<{
        __typename?: "ContractSystemCredentialsObject";
        id: string;
        isHourly?: boolean | undefined;
        isLive?: boolean | undefined;
      }>
    | undefined;
};

export type OrganizationListingAggregatesByStatusQueryVariables = Exact<{
  organizationId: Scalars["String"]["input"];
}>;

export type OrganizationListingAggregatesByStatusQuery = {
  __typename?: "Query";
  organizationListingAggregatesByStatus: {
    __typename?: "OrganizationListingCountsByStatusPayload";
    organization: {
      __typename?: "OrganizationObject";
      id: string;
      name: string;
      hasDescendants?: boolean | undefined;
      contractSystemCredentials?:
        | Array<{
            __typename?: "ContractSystemCredentialsObject";
            id: string;
            isReady: boolean;
            type?: ContractSystemType | undefined;
            hasInvalidCredentials?: boolean | undefined;
            username?: string | undefined;
            dotloopProfileId?: string | undefined;
            dotloopTeamName?: string | undefined;
          }>
        | undefined;
      mainMLS?:
        | {
            __typename?: "MLSObject";
            id: string;
            name: string;
            originatingSystemName?: string | undefined;
          }
        | undefined;
    };
    aggregates: Array<{
      __typename?: "ListingCountsByStatus";
      status: MlsListingStatus;
      count: number;
      sumListPrice?: number | undefined;
      sumClosePrice?: number | undefined;
    }>;
  };
};

export type OrganizationOfficesAndTeamsQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
}>;

export type OrganizationOfficesAndTeamsQuery = {
  __typename?: "Query";
  organizationOfficesAndTeams: {
    __typename?: "OrganizationOfficesAndTeamsPayload";
    offices: Array<{
      __typename?: "OrganizationObject";
      id: string;
      name: string;
    }>;
    teams: Array<{
      __typename?: "OrganizationObject";
      id: string;
      name: string;
    }>;
  };
};

export type OrganizationPartnerStageIntrosQueryVariables = Exact<{
  partnerId: Scalars["ID"]["input"];
  side: TransactionSide;
}>;

export type OrganizationPartnerStageIntrosQuery = {
  __typename?: "Query";
  organizationPartnerStageIntros: Array<{
    __typename?: "OrganizationPartnerStageIntroObject";
    id: string;
    side: TransactionSide;
    stage: TransactionStageType;
    newRelationshipMessageContent: string;
    existingRelationshipMessageContent: string;
    allowPartnerContactAssignment: boolean;
  }>;
};

export type OrganizationPartnersQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  filters?: InputMaybe<OrganizationPartnerFilters>;
}>;

export type OrganizationPartnersQuery = {
  __typename?: "Query";
  organizationPartners?:
    | {
        __typename?: "OrganizationPartnerObjectPaginated";
        results?:
          | Array<{
              __typename?: "OrganizationPartnerObject";
              id: string;
              name: string;
              partnerType: PartnerType;
              isActive: boolean;
              dryRunNotifications: boolean;
              existingRelationshipIntroMessage: string;
              newRelationshipIntroMessage: string;
              hasDrafts: boolean;
              createdAt: any;
              updatedAt: any;
              adminContacts?:
                | Array<{
                    __typename?: "ContactObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                    email: string;
                    phoneNumber?: string | undefined;
                    contactType: ContactType;
                  }>
                | undefined;
              logo?: { __typename?: "FileObject"; url: string } | undefined;
              contacts?:
                | Array<{
                    __typename?: "ContactObject";
                    id: string;
                    firstName: string;
                    lastName: string;
                  }>
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
              perPage: number;
            }
          | undefined;
      }
    | undefined;
};

export type OrganizationRosterListQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  filters?: InputMaybe<OrganizationRosterFilters>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type OrganizationRosterListQuery = {
  __typename?: "Query";
  organizationRosterList?:
    | {
        __typename?: "OrganizationRosterObjectOrganizationRosterListPaginatedPaginated";
        results?:
          | Array<{
              __typename?: "OrganizationRosterObject";
              id: string;
              isContactable: boolean;
              createdAt: any;
              contact: {
                __typename?: "ContactObject";
                id: string;
                firstName: string;
                lastName: string;
                email: string;
                phoneNumber?: string | undefined;
                contactType: ContactType;
              };
              preferences: Array<{
                __typename?: "OrganizationRosterPreferenceObject";
                id: string;
                partnerType: PartnerType;
                preferenceType: PartnerPreferenceType;
                partner?:
                  | {
                      __typename?: "OrganizationPartnerObject";
                      id: string;
                      name: string;
                    }
                  | undefined;
                partnerContact?:
                  | {
                      __typename?: "ContactObject";
                      id: string;
                      firstName: string;
                      lastName: string;
                      partner?:
                        | {
                            __typename?: "OrganizationPartnerObject";
                            id: string;
                            name: string;
                          }
                        | undefined;
                    }
                  | undefined;
              }>;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
              totalCount: number;
              perPage: number;
            }
          | undefined;
      }
    | undefined;
};

export type OrganizationsForCurrentUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type OrganizationsForCurrentUserQuery = {
  __typename?: "Query";
  organizationsForCurrentUser?:
    | Array<{
        __typename?: "OrganizationObject";
        id: string;
        name: string;
        hasDescendants?: boolean | undefined;
        contractSystemCredentials?:
          | Array<{
              __typename?: "ContractSystemCredentialsObject";
              id: string;
              isReady: boolean;
              type?: ContractSystemType | undefined;
              hasInvalidCredentials?: boolean | undefined;
              username?: string | undefined;
              dotloopProfileId?: string | undefined;
              dotloopTeamName?: string | undefined;
            }>
          | undefined;
        mainMLS?:
          | {
              __typename?: "MLSObject";
              id: string;
              name: string;
              originatingSystemName?: string | undefined;
            }
          | undefined;
      }>
    | undefined;
};

export type OrganizationFragment = {
  __typename?: "OrganizationObject";
  id: string;
  name: string;
  hasDescendants?: boolean | undefined;
  contractSystemCredentials?:
    | Array<{
        __typename?: "ContractSystemCredentialsObject";
        id: string;
        isReady: boolean;
        type?: ContractSystemType | undefined;
        hasInvalidCredentials?: boolean | undefined;
        username?: string | undefined;
        dotloopProfileId?: string | undefined;
        dotloopTeamName?: string | undefined;
      }>
    | undefined;
  mainMLS?:
    | {
        __typename?: "MLSObject";
        id: string;
        name: string;
        originatingSystemName?: string | undefined;
      }
    | undefined;
};

export type PartnerContactsListQueryVariables = Exact<{
  filters: ContactFilters;
}>;

export type PartnerContactsListQuery = {
  __typename?: "Query";
  partnerContactsList: Array<
    | {
        __typename?: "InsuranceAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
    | {
        __typename?: "LoanOfficerContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
        loanOfficerConfig?:
          | {
              __typename?: "LoanOfficerContactConfigObject";
              preApprovalAppUrl?: string | undefined;
              calendarSchedulingUrl?: string | undefined;
            }
          | undefined;
      }
    | {
        __typename?: "TitleAgentContactObject";
        id: string;
        firstName: string;
        lastName: string;
        contactType: ContactType;
        email: string;
        phoneNumber?: string | undefined;
        createdAt: any;
        updatedAt: any;
      }
  >;
};

export type PartyAndBuyerInfoQueryVariables = Exact<{
  input: PartyAndBuyerInfoInput;
}>;

export type PartyAndBuyerInfoQuery = {
  __typename?: "Query";
  partyAndBuyerInfo: {
    __typename?: "PartyObject";
    id: string;
    createdAt: any;
    purchaseOffers?:
      | Array<{
          __typename?: "OfferObject";
          id: string;
          updatedAt?: any | undefined;
          listing?:
            | {
                __typename?: "ListingObject";
                id: string;
                isPremium: boolean;
                property: {
                  __typename?: "PropertyObject";
                  id: string;
                  slug: string;
                  state: UsState;
                };
                mlsListing?:
                  | {
                      __typename?: "MLSListingObject";
                      id: string;
                      mlsId?: number | undefined;
                      listingId?: string | undefined;
                      listDate?: string | undefined;
                      listPrice?: number | undefined;
                      originalListPrice?: number | undefined;
                      terms?: string | undefined;
                      photos: Array<string>;
                      remarks?: string | undefined;
                      modified?: string | undefined;
                      mlsName?: string | undefined;
                      deleted_at?: string | undefined;
                      addressFull: string;
                      agent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      coAgent?:
                        | {
                            __typename?: "MLSListingAgentObject";
                            id?: string | undefined;
                            mlsId?: string | undefined;
                            firstName?: string | undefined;
                            lastName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      address: {
                        __typename?: "MLSListingAddressObject";
                        city: string;
                        country?: string | undefined;
                        crossStreet?: string | undefined;
                        full: string;
                        postalCode?: string | undefined;
                        state: string;
                        streetName: string;
                        streetNumber?: number | undefined;
                        streetNumberText: string;
                        unit?: string | undefined;
                      };
                      property?:
                        | {
                            __typename?: "MLSListingPropertyObject";
                            roof?: string | undefined;
                            cooling?: string | undefined;
                            style?: string | undefined;
                            area?: number | undefined;
                            bathsFull?: number | undefined;
                            bathsHalf?: number | undefined;
                            stories?: number | undefined;
                            fireplaces?: number | undefined;
                            flooring?: string | undefined;
                            heating?: string | undefined;
                            bathrooms?: string | undefined;
                            foundation?: string | undefined;
                            poolFeatures?: string | undefined;
                            laundryFeatures?: string | undefined;
                            occupantName?: string | undefined;
                            ownerName?: string | undefined;
                            lotDescription?: string | undefined;
                            acres?: number | undefined;
                            subType?: string | undefined;
                            bedrooms?: number | undefined;
                            interiorFeatures?: string | undefined;
                            lotSize?: string | undefined;
                            areaSource?: string | undefined;
                            maintenanceExpense?: number | undefined;
                            additionalRooms?: string | undefined;
                            exteriorFeatures?: string | undefined;
                            water?: string | undefined;
                            view?: string | undefined;
                            lotSizeArea?: number | undefined;
                            lotSizeAreaUnits?: string | undefined;
                            subdivision?: string | undefined;
                            construction?: string | undefined;
                            type?: MlsListingType | undefined;
                            garageSpaces?: number | undefined;
                            bathsThreeQuarter?: number | undefined;
                            accessibility?: string | undefined;
                            occupantType?: string | undefined;
                            yearBuilt?: number | undefined;
                            subTypeText?: string | undefined;
                          }
                        | undefined;
                      office?:
                        | {
                            __typename?: "MLSListingOfficeObject";
                            brokerid?: string | undefined;
                            name?: string | undefined;
                            servingName?: string | undefined;
                            contact?:
                              | {
                                  __typename?: "MLSListingContactObject";
                                  email?: string | undefined;
                                  office?: string | undefined;
                                  cell?: string | undefined;
                                }
                              | undefined;
                          }
                        | undefined;
                      mls?:
                        | {
                            __typename?: "MLSListingMLSObject";
                            statusText: string;
                            status?: MlsListingStatus | undefined;
                            daysOnMarket?: number | undefined;
                            originalEntryTimestamp?: string | undefined;
                            originatingSystemName?: string | undefined;
                            logoUrl?: string | undefined;
                            disclaimer?: string | undefined;
                          }
                        | undefined;
                      association?:
                        | {
                            __typename?: "MLSListingAssociationObject";
                            fee?: number | undefined;
                            frequency?: string | undefined;
                            name?: string | undefined;
                            amenities?: string | undefined;
                          }
                        | undefined;
                      compliance?:
                        | {
                            __typename?: "MLSListingComplianceObject";
                            buyerAgencyCompensation?: number | undefined;
                            buyerAgencyCompensationType?: string | undefined;
                            subAgencyCompensation?: number | undefined;
                            subAgencyCompensationType?: string | undefined;
                            attributionContact?: string | undefined;
                          }
                        | undefined;
                      sales?:
                        | {
                            __typename?: "MLSListingSalesObject";
                            closeDate?: string | undefined;
                            closePrice?: number | undefined;
                            contractDate?: string | undefined;
                          }
                        | undefined;
                      geo: {
                        __typename?: "MLSListingGeoObject";
                        location: {
                          __typename?: "GeoPointObject";
                          lat: number;
                          lon: number;
                        };
                      };
                    }
                  | undefined;
                listingAgent?:
                  | {
                      __typename?: "AgentObject";
                      id: string;
                      user?:
                        | { __typename?: "UserObject"; id: string }
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }>
      | undefined;
    primaryConsumer: {
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    };
    secondaryConsumers: Array<{
      __typename?: "ConsumerObject";
      id: string;
      email?: string | undefined;
      fullName: string;
      phoneNumber?: string | undefined;
      isEntity: boolean;
      entityName?: string | undefined;
      entityTitle?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
    }>;
    partyFinancing?:
      | {
          __typename?: "PartyFinancingObject";
          id: string;
          financingType?: FinancingType | undefined;
          loanAmount?: number | undefined;
          percentDownPayment?: number | undefined;
          cashReserves?: number | undefined;
          preapprovalFile?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
  };
};

export type PartyVariableValuesQueryVariables = Exact<{
  partyIds: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type PartyVariableValuesQuery = {
  __typename?: "Query";
  partyAutofillVariableValues: Array<{
    __typename?: "OfferAutofillObject";
    buyerSignatures?: boolean | undefined;
    buyersAgentSignatures?: boolean | undefined;
    buyer?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    coBuyer?:
      | {
          __typename?: "AutofillConsumerObject";
          email?: string | undefined;
          name?: string | undefined;
          phoneNumber?: string | undefined;
          isEntity?: boolean | undefined;
          entityName?: string | undefined;
          entityTitle?: string | undefined;
          id?: string | undefined;
        }
      | undefined;
    buyersAgent?:
      | {
          __typename?: "UserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          roles: Array<Roles>;
          email?: string | undefined;
          profileBio?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
          settings?:
            | {
                __typename?: "UserSettingsObject";
                id: string;
                selectedOrganization?:
                  | {
                      __typename?: "OrganizationObject";
                      id: string;
                      name: string;
                      hasDescendants?: boolean | undefined;
                      contractSystemCredentials?:
                        | Array<{
                            __typename?: "ContractSystemCredentialsObject";
                            id: string;
                            hasInvalidCredentials?: boolean | undefined;
                            isReady: boolean;
                            type?: ContractSystemType | undefined;
                            username?: string | undefined;
                            dotloopProfileId?: string | undefined;
                            dotloopTeamName?: string | undefined;
                          }>
                        | undefined;
                    }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    buyersAgentRESOMemberData?:
      | {
          __typename?: "RESOMemberObject";
          MemberFirstName?: string | undefined;
          MemberLastName?: string | undefined;
          MemberFullName?: string | undefined;
          MemberMiddleName?: string | undefined;
          MemberEmail?: string | undefined;
          MemberDirectPhone?: string | undefined;
          MemberMobilePhone?: string | undefined;
          MemberMlsId?: string | undefined;
          MemberNationalAssociationId?: string | undefined;
          OfficeMlsId?: string | undefined;
          MemberStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
          Media?:
            | Array<{
                __typename?: "MediaObject";
                MediaKey?: string | undefined;
                MediaURL?: string | undefined;
                ImageWidth?: number | undefined;
                ImageHeight?: number | undefined;
                ImageSizeDescription?: string | undefined;
                MediaModificationTimestamp?: string | undefined;
              }>
            | undefined;
        }
      | undefined;
    buyersAgentRESOOfficeData?:
      | {
          __typename?: "RESOOfficeObject";
          OfficeName?: string | undefined;
          OfficeEmail?: string | undefined;
          OfficeKey?: string | undefined;
          OfficeMlsId?: string | undefined;
          OfficeStatus?: string | undefined;
          OriginatingSystemName?: string | undefined;
        }
      | undefined;
    partyFinancing?:
      | {
          __typename?: "PartyFinancingObject";
          id: string;
          financingType?: FinancingType | undefined;
          loanAmount?: number | undefined;
        }
      | undefined;
  }>;
};

export type PerAgentOfferAcceptRateFragment = {
  __typename?: "PerAgentOfferAcceptRateObject";
  name: string;
  accepted_offers: number;
  offer_accept_rate?: number | undefined;
  submitted_offers: number;
  total_offers: number;
  average_bid_ask?: number | undefined;
  average_dd_days?: number | undefined;
  average_ddf_ratio?: number | undefined;
  average_termination_fee_ratio?: number | undefined;
  average_offer_to_close_days: number;
  average_purchase_price: number;
  closed_volume: number;
  pending_volume: number;
  total_volume: number;
};

export type PerAgentOfferAcceptRateQueryVariables = Exact<{
  filters: AgentPerformanceFilters;
}>;

export type PerAgentOfferAcceptRateQuery = {
  __typename?: "Query";
  perAgentOfferAcceptRate: Array<{
    __typename?: "PerAgentOfferAcceptRateObject";
    name: string;
    accepted_offers: number;
    offer_accept_rate?: number | undefined;
    submitted_offers: number;
    total_offers: number;
    average_bid_ask?: number | undefined;
    average_dd_days?: number | undefined;
    average_ddf_ratio?: number | undefined;
    average_termination_fee_ratio?: number | undefined;
    average_offer_to_close_days: number;
    average_purchase_price: number;
    closed_volume: number;
    pending_volume: number;
    total_volume: number;
  }>;
};

export type PerAgentTransactionStatsFragment = {
  __typename?: "PerAgentTransactionStatsObject";
  name: string;
  buy_side_homes_count: number;
  sell_side_homes_count: number;
  closed_homes_count: number;
  pending_homes_count: number;
  total_homes_count: number;
  unknown_homes_count: number;
  terminated_homes_count: number;
  buy_side_volume: number;
  closed_volume: number;
  pending_volume: number;
  sell_side_volume: number;
  total_volume: number;
};

export type PerAgentTransactionStatsQueryVariables = Exact<{
  filters: AgentPerformanceFilters;
}>;

export type PerAgentTransactionStatsQuery = {
  __typename?: "Query";
  perAgentTransactionStats: Array<{
    __typename?: "PerAgentTransactionStatsObject";
    name: string;
    buy_side_homes_count: number;
    sell_side_homes_count: number;
    closed_homes_count: number;
    pending_homes_count: number;
    total_homes_count: number;
    unknown_homes_count: number;
    terminated_homes_count: number;
    buy_side_volume: number;
    closed_volume: number;
    pending_volume: number;
    sell_side_volume: number;
    total_volume: number;
  }>;
};

export type PerOfficeOfferAcceptRateFragment = {
  __typename?: "PerOfficeOfferAcceptRateObject";
  name: string;
  accepted_offers: number;
  offer_accept_rate?: number | undefined;
  submitted_offers: number;
  total_offers: number;
  average_bid_ask?: number | undefined;
  average_dd_days?: number | undefined;
  average_ddf_ratio?: number | undefined;
  average_termination_fee_ratio?: number | undefined;
  average_offer_to_close_days: number;
  average_purchase_price: number;
  closed_volume: number;
  pending_volume: number;
  total_volume: number;
};

export type PerOfficeOfferAcceptRateQueryVariables = Exact<{
  filters: AgentPerformanceFilters;
}>;

export type PerOfficeOfferAcceptRateQuery = {
  __typename?: "Query";
  perOfficeOfferAcceptRate: Array<{
    __typename?: "PerOfficeOfferAcceptRateObject";
    name: string;
    accepted_offers: number;
    offer_accept_rate?: number | undefined;
    submitted_offers: number;
    total_offers: number;
    average_bid_ask?: number | undefined;
    average_dd_days?: number | undefined;
    average_ddf_ratio?: number | undefined;
    average_termination_fee_ratio?: number | undefined;
    average_offer_to_close_days: number;
    average_purchase_price: number;
    closed_volume: number;
    pending_volume: number;
    total_volume: number;
  }>;
};

export type PerOfficeTransactionStatsFragment = {
  __typename?: "PerOfficeTransactionStatsObject";
  name: string;
  buy_side_homes_count: number;
  sell_side_homes_count: number;
  closed_homes_count: number;
  pending_homes_count: number;
  total_homes_count: number;
  unknown_homes_count: number;
  terminated_homes_count: number;
  buy_side_volume: number;
  closed_volume: number;
  pending_volume: number;
  sell_side_volume: number;
  total_volume: number;
};

export type PerOfficeTransactionStatsQueryVariables = Exact<{
  filters: AgentPerformanceFilters;
}>;

export type PerOfficeTransactionStatsQuery = {
  __typename?: "Query";
  perOfficeTransactionStats: Array<{
    __typename?: "PerOfficeTransactionStatsObject";
    name: string;
    buy_side_homes_count: number;
    sell_side_homes_count: number;
    closed_homes_count: number;
    pending_homes_count: number;
    total_homes_count: number;
    unknown_homes_count: number;
    terminated_homes_count: number;
    buy_side_volume: number;
    closed_volume: number;
    pending_volume: number;
    sell_side_volume: number;
    total_volume: number;
  }>;
};

export type PreferencesQueryVariables = Exact<{
  input: PreferencesInput;
}>;

export type PreferencesQuery = {
  __typename?: "Query";
  preferences: Array<{
    __typename?: "PreferenceObject";
    id: string;
    name: string;
    slug: string;
    usStates: Array<UsState>;
    fieldId?: string | undefined;
    valueType: PreferenceValueType;
  }>;
};

export type PrioritizedListingsForCurrentUserQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  preferenceValues?: InputMaybe<Scalars["Boolean"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
}>;

export type PrioritizedListingsForCurrentUserQuery = {
  __typename?: "Query";
  prioritizedListingsForCurrentUser?:
    | {
        __typename?: "ListingObjectPrioritizedListingsForCurrentUserPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "ListingObject";
              lastActivityDate?: any | undefined;
              id: string;
              isOwner?: boolean | undefined;
              listDate?: any | undefined;
              offersCountDisplay: string;
              submittedOffersCount: number;
              followerCount?: number | undefined;
              isPremium: boolean;
              status: MlsListingStatus;
              deletedFromRetsFeedAt?: string | undefined;
              currentAndUpcomingOpenHouses?:
                | Array<{
                    __typename?: "PublicOpenHouseObject";
                    id: string;
                    date: string;
                    startTime: string;
                    endTime: string;
                  }>
                | undefined;
              property: {
                __typename?: "PropertyObject";
                id: string;
                slug: string;
                state: UsState;
              };
              offersSubmitted?:
                | Array<{
                    __typename?: "OfferObject";
                    id: string;
                    status: OfferStatus;
                  }>
                | undefined;
              listingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    inboundEmail: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          userName?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              coListingAgent?:
                | {
                    __typename?: "AgentObject";
                    id: string;
                    inboundEmail: string;
                    user?:
                      | {
                          __typename?: "UserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                          fullName: string;
                          phoneNumber: string;
                          email?: string | undefined;
                          profilePicture?:
                            | {
                                __typename?: "FileObject";
                                fileName: string;
                                url: string;
                              }
                            | undefined;
                        }
                      | undefined;
                  }
                | undefined;
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
              listingPreferences?: Array<{
                __typename?: "PreferenceValueObject";
                numberValue?: number | undefined;
                textValue?: string | undefined;
                stringValue?: string | undefined;
                stringArray?: Array<string> | undefined;
                booleanValue?: boolean | undefined;
                dateTimeValue?: any | undefined;
                readOnly?: boolean | undefined;
                preference: {
                  __typename?: "PreferenceObject";
                  id: string;
                  name: string;
                  slug: string;
                  usStates: Array<UsState>;
                  fieldId?: string | undefined;
                  valueType: PreferenceValueType;
                };
              }>;
              storefrontSetup?:
                | {
                    __typename?: "StorefrontSetupObject";
                    continueStep?: StorefrontSetupStep | undefined;
                    listingPackage: {
                      __typename?: "FileObject";
                      fileName: string;
                      url: string;
                    };
                  }
                | undefined;
              setupDetails: {
                __typename?: "StorefrontConfigurationStatusObject";
                hasSetup?: boolean | undefined;
                configuredCount: number;
                progressTotal: number;
                sellerPreferences: boolean;
                comparables: boolean;
                documents: boolean;
              };
            }>
          | undefined;
      }
    | undefined;
};

export type PrioritizedListingFragment = {
  __typename?: "ListingObject";
  lastActivityDate?: any | undefined;
  id: string;
  isOwner?: boolean | undefined;
  listDate?: any | undefined;
  offersCountDisplay: string;
  submittedOffersCount: number;
  followerCount?: number | undefined;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  currentAndUpcomingOpenHouses?:
    | Array<{
        __typename?: "PublicOpenHouseObject";
        id: string;
        date: string;
        startTime: string;
        endTime: string;
      }>
    | undefined;
  property: {
    __typename?: "PropertyObject";
    id: string;
    slug: string;
    state: UsState;
  };
  offersSubmitted?:
    | Array<{ __typename?: "OfferObject"; id: string; status: OfferStatus }>
    | undefined;
  listingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              userName?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  coListingAgent?:
    | {
        __typename?: "AgentObject";
        id: string;
        inboundEmail: string;
        user?:
          | {
              __typename?: "UserObject";
              id: string;
              firstName: string;
              lastName: string;
              fullName: string;
              phoneNumber: string;
              email?: string | undefined;
              profilePicture?:
                | { __typename?: "FileObject"; fileName: string; url: string }
                | undefined;
            }
          | undefined;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
  listingPreferences?: Array<{
    __typename?: "PreferenceValueObject";
    numberValue?: number | undefined;
    textValue?: string | undefined;
    stringValue?: string | undefined;
    stringArray?: Array<string> | undefined;
    booleanValue?: boolean | undefined;
    dateTimeValue?: any | undefined;
    readOnly?: boolean | undefined;
    preference: {
      __typename?: "PreferenceObject";
      id: string;
      name: string;
      slug: string;
      usStates: Array<UsState>;
      fieldId?: string | undefined;
      valueType: PreferenceValueType;
    };
  }>;
  storefrontSetup?:
    | {
        __typename?: "StorefrontSetupObject";
        continueStep?: StorefrontSetupStep | undefined;
        listingPackage: {
          __typename?: "FileObject";
          fileName: string;
          url: string;
        };
      }
    | undefined;
  setupDetails: {
    __typename?: "StorefrontConfigurationStatusObject";
    hasSetup?: boolean | undefined;
    configuredCount: number;
    progressTotal: number;
    sellerPreferences: boolean;
    comparables: boolean;
    documents: boolean;
  };
};

export type PublicFeaturedStorefrontFragment = {
  __typename?: "PublicListingObject";
  id: string;
  offersCountDisplay: string;
  listDate?: any | undefined;
  followerCount?: number | undefined;
  guestbookSignersCount: number;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: {
    __typename?: "PublicPropertyObject";
    id: string;
    slug: string;
    state: UsState;
    otherLegalDescription: string;
    county: string;
  };
  listingAgent?:
    | {
        __typename?: "PublicAgentObject";
        id: string;
        user?:
          | {
              __typename?: "PublicUserObject";
              id: string;
              firstName: string;
              lastName: string;
            }
          | undefined;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        agent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        coAgent?:
          | {
              __typename?: "MLSListingAgentObject";
              id?: string | undefined;
              mlsId?: string | undefined;
              firstName?: string | undefined;
              lastName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      }
    | undefined;
};

export type PublicFeaturedStorefrontsQueryVariables = Exact<{
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PublicFeaturedStorefrontsQuery = {
  __typename?: "Query";
  featuredStorefronts?:
    | {
        __typename?: "PublicListingObjectPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PublicListingObject";
              id: string;
              offersCountDisplay: string;
              listDate?: any | undefined;
              followerCount?: number | undefined;
              guestbookSignersCount: number;
              isPremium: boolean;
              status: MlsListingStatus;
              deletedFromRetsFeedAt?: string | undefined;
              property: {
                __typename?: "PublicPropertyObject";
                id: string;
                slug: string;
                state: UsState;
                otherLegalDescription: string;
                county: string;
              };
              listingAgent?:
                | {
                    __typename?: "PublicAgentObject";
                    id: string;
                    user?:
                      | {
                          __typename?: "PublicUserObject";
                          id: string;
                          firstName: string;
                          lastName: string;
                        }
                      | undefined;
                  }
                | undefined;
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type PublicListingQueryVariables = Exact<{
  input: PublicListingInput;
}>;

export type PublicListingQuery = {
  __typename?: "Query";
  publicListing: {
    __typename?: "PublicListingObject";
    id: string;
    offersCountDisplay: string;
    listDate?: any | undefined;
    followerCount?: number | undefined;
    guestbookSignersCount: number;
    isPremium: boolean;
    status: MlsListingStatus;
    deletedFromRetsFeedAt?: string | undefined;
    property: {
      __typename?: "PublicPropertyObject";
      id: string;
      slug: string;
      state: UsState;
      otherLegalDescription: string;
      county: string;
    };
    currentAndUpcomingOpenHouses?:
      | Array<{
          __typename?: "PublicOpenHouseObject";
          id: string;
          date: string;
          startTime: string;
          endTime: string;
        }>
      | undefined;
    listingAgent?:
      | {
          __typename?: "PublicAgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "PublicUserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                userName?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    coListingAgent?:
      | {
          __typename?: "PublicAgentObject";
          id: string;
          inboundEmail: string;
          user?:
            | {
                __typename?: "PublicUserObject";
                id: string;
                firstName: string;
                lastName: string;
                fullName: string;
                phoneNumber: string;
                email?: string | undefined;
                profilePicture?:
                  | { __typename?: "FileObject"; fileName: string; url: string }
                  | undefined;
              }
            | undefined;
        }
      | undefined;
    mlsListing?:
      | {
          __typename?: "MLSListingObject";
          id: string;
          mlsId?: number | undefined;
          listingId?: string | undefined;
          listDate?: string | undefined;
          listPrice?: number | undefined;
          originalListPrice?: number | undefined;
          terms?: string | undefined;
          photos: Array<string>;
          remarks?: string | undefined;
          modified?: string | undefined;
          mlsName?: string | undefined;
          deleted_at?: string | undefined;
          addressFull: string;
          agent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          coAgent?:
            | {
                __typename?: "MLSListingAgentObject";
                id?: string | undefined;
                mlsId?: string | undefined;
                firstName?: string | undefined;
                lastName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          address: {
            __typename?: "MLSListingAddressObject";
            city: string;
            country?: string | undefined;
            crossStreet?: string | undefined;
            full: string;
            postalCode?: string | undefined;
            state: string;
            streetName: string;
            streetNumber?: number | undefined;
            streetNumberText: string;
            unit?: string | undefined;
          };
          property?:
            | {
                __typename?: "MLSListingPropertyObject";
                roof?: string | undefined;
                cooling?: string | undefined;
                style?: string | undefined;
                area?: number | undefined;
                bathsFull?: number | undefined;
                bathsHalf?: number | undefined;
                stories?: number | undefined;
                fireplaces?: number | undefined;
                flooring?: string | undefined;
                heating?: string | undefined;
                bathrooms?: string | undefined;
                foundation?: string | undefined;
                poolFeatures?: string | undefined;
                laundryFeatures?: string | undefined;
                occupantName?: string | undefined;
                ownerName?: string | undefined;
                lotDescription?: string | undefined;
                acres?: number | undefined;
                subType?: string | undefined;
                bedrooms?: number | undefined;
                interiorFeatures?: string | undefined;
                lotSize?: string | undefined;
                areaSource?: string | undefined;
                maintenanceExpense?: number | undefined;
                additionalRooms?: string | undefined;
                exteriorFeatures?: string | undefined;
                water?: string | undefined;
                view?: string | undefined;
                lotSizeArea?: number | undefined;
                lotSizeAreaUnits?: string | undefined;
                subdivision?: string | undefined;
                construction?: string | undefined;
                type?: MlsListingType | undefined;
                garageSpaces?: number | undefined;
                bathsThreeQuarter?: number | undefined;
                accessibility?: string | undefined;
                occupantType?: string | undefined;
                yearBuilt?: number | undefined;
                subTypeText?: string | undefined;
              }
            | undefined;
          office?:
            | {
                __typename?: "MLSListingOfficeObject";
                brokerid?: string | undefined;
                name?: string | undefined;
                servingName?: string | undefined;
                contact?:
                  | {
                      __typename?: "MLSListingContactObject";
                      email?: string | undefined;
                      office?: string | undefined;
                      cell?: string | undefined;
                    }
                  | undefined;
              }
            | undefined;
          mls?:
            | {
                __typename?: "MLSListingMLSObject";
                statusText: string;
                status?: MlsListingStatus | undefined;
                daysOnMarket?: number | undefined;
                originalEntryTimestamp?: string | undefined;
                originatingSystemName?: string | undefined;
                logoUrl?: string | undefined;
                disclaimer?: string | undefined;
              }
            | undefined;
          association?:
            | {
                __typename?: "MLSListingAssociationObject";
                fee?: number | undefined;
                frequency?: string | undefined;
                name?: string | undefined;
                amenities?: string | undefined;
              }
            | undefined;
          compliance?:
            | {
                __typename?: "MLSListingComplianceObject";
                buyerAgencyCompensation?: number | undefined;
                buyerAgencyCompensationType?: string | undefined;
                subAgencyCompensation?: number | undefined;
                subAgencyCompensationType?: string | undefined;
                attributionContact?: string | undefined;
              }
            | undefined;
          sales?:
            | {
                __typename?: "MLSListingSalesObject";
                closeDate?: string | undefined;
                closePrice?: number | undefined;
                contractDate?: string | undefined;
              }
            | undefined;
          geo: {
            __typename?: "MLSListingGeoObject";
            location: {
              __typename?: "GeoPointObject";
              lat: number;
              lon: number;
            };
          };
        }
      | undefined;
    listingPreferences: Array<{
      __typename?: "PublicPreferenceValueObject";
      numberValue?: number | undefined;
      textValue?: string | undefined;
      stringValue?: string | undefined;
      stringArray?: Array<string> | undefined;
      booleanValue?: boolean | undefined;
      dateTimeValue?: any | undefined;
      readOnly?: boolean | undefined;
      preference: {
        __typename?: "PublicPreferenceObject";
        id: string;
        name: string;
        slug: string;
        usStates: Array<UsState>;
        valueType: PreferenceValueType;
      };
    }>;
    priceHistories?:
      | Array<{
          __typename?: "ListingPriceHistoryObject";
          listDate: string;
          mlsStatus: string;
          listPrice: number;
          closePrice: number;
          closeDate: string;
          modified: string;
        }>
      | undefined;
    setupDetails: {
      __typename?: "StorefrontConfigurationStatusObject";
      hasSetup?: boolean | undefined;
      configuredCount: number;
      progressTotal: number;
      sellerPreferences: boolean;
      comparables: boolean;
      documents: boolean;
    };
  };
};

export type PublicListingAnnouncementsQueryVariables = Exact<{
  input: PublicListingAnnouncementInput;
}>;

export type PublicListingAnnouncementsQuery = {
  __typename?: "Query";
  publicListingAnnouncements: Array<{
    __typename?: "PublicListingAnnouncementObject";
    id: string;
    message: string;
    createdAt: any;
  }>;
};

export type PublicListingComparableSetQueryVariables = Exact<{
  input: PublicListingComparableSetInput;
}>;

export type PublicListingComparableSetQuery = {
  __typename?: "Query";
  publicListingComparableSet?:
    | {
        __typename?: "PublicListingComparableSetObject";
        agentNotes?: string | undefined;
        listingComparables: Array<{
          __typename?: "PublicListingComparableObject";
          id: string;
          source: ListingComparableSetSource;
          order: number;
          mlsListing: {
            __typename?: "MLSListingObject";
            id: string;
            mlsId?: number | undefined;
            listingId?: string | undefined;
            listDate?: string | undefined;
            listPrice?: number | undefined;
            originalListPrice?: number | undefined;
            terms?: string | undefined;
            photos: Array<string>;
            remarks?: string | undefined;
            modified?: string | undefined;
            mlsName?: string | undefined;
            deleted_at?: string | undefined;
            addressFull: string;
            agent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            coAgent?:
              | {
                  __typename?: "MLSListingAgentObject";
                  id?: string | undefined;
                  mlsId?: string | undefined;
                  firstName?: string | undefined;
                  lastName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            address: {
              __typename?: "MLSListingAddressObject";
              city: string;
              country?: string | undefined;
              crossStreet?: string | undefined;
              full: string;
              postalCode?: string | undefined;
              state: string;
              streetName: string;
              streetNumber?: number | undefined;
              streetNumberText: string;
              unit?: string | undefined;
            };
            property?:
              | {
                  __typename?: "MLSListingPropertyObject";
                  roof?: string | undefined;
                  cooling?: string | undefined;
                  style?: string | undefined;
                  area?: number | undefined;
                  bathsFull?: number | undefined;
                  bathsHalf?: number | undefined;
                  stories?: number | undefined;
                  fireplaces?: number | undefined;
                  flooring?: string | undefined;
                  heating?: string | undefined;
                  bathrooms?: string | undefined;
                  foundation?: string | undefined;
                  poolFeatures?: string | undefined;
                  laundryFeatures?: string | undefined;
                  occupantName?: string | undefined;
                  ownerName?: string | undefined;
                  lotDescription?: string | undefined;
                  acres?: number | undefined;
                  subType?: string | undefined;
                  bedrooms?: number | undefined;
                  interiorFeatures?: string | undefined;
                  lotSize?: string | undefined;
                  areaSource?: string | undefined;
                  maintenanceExpense?: number | undefined;
                  additionalRooms?: string | undefined;
                  exteriorFeatures?: string | undefined;
                  water?: string | undefined;
                  view?: string | undefined;
                  lotSizeArea?: number | undefined;
                  lotSizeAreaUnits?: string | undefined;
                  subdivision?: string | undefined;
                  construction?: string | undefined;
                  type?: MlsListingType | undefined;
                  garageSpaces?: number | undefined;
                  bathsThreeQuarter?: number | undefined;
                  accessibility?: string | undefined;
                  occupantType?: string | undefined;
                  yearBuilt?: number | undefined;
                  subTypeText?: string | undefined;
                }
              | undefined;
            office?:
              | {
                  __typename?: "MLSListingOfficeObject";
                  brokerid?: string | undefined;
                  name?: string | undefined;
                  servingName?: string | undefined;
                  contact?:
                    | {
                        __typename?: "MLSListingContactObject";
                        email?: string | undefined;
                        office?: string | undefined;
                        cell?: string | undefined;
                      }
                    | undefined;
                }
              | undefined;
            mls?:
              | {
                  __typename?: "MLSListingMLSObject";
                  statusText: string;
                  status?: MlsListingStatus | undefined;
                  daysOnMarket?: number | undefined;
                  originalEntryTimestamp?: string | undefined;
                  originatingSystemName?: string | undefined;
                  logoUrl?: string | undefined;
                  disclaimer?: string | undefined;
                }
              | undefined;
            association?:
              | {
                  __typename?: "MLSListingAssociationObject";
                  fee?: number | undefined;
                  frequency?: string | undefined;
                  name?: string | undefined;
                  amenities?: string | undefined;
                }
              | undefined;
            compliance?:
              | {
                  __typename?: "MLSListingComplianceObject";
                  buyerAgencyCompensation?: number | undefined;
                  buyerAgencyCompensationType?: string | undefined;
                  subAgencyCompensation?: number | undefined;
                  subAgencyCompensationType?: string | undefined;
                  attributionContact?: string | undefined;
                }
              | undefined;
            sales?:
              | {
                  __typename?: "MLSListingSalesObject";
                  closeDate?: string | undefined;
                  closePrice?: number | undefined;
                  contractDate?: string | undefined;
                }
              | undefined;
            geo: {
              __typename?: "MLSListingGeoObject";
              location: {
                __typename?: "GeoPointObject";
                lat: number;
                lon: number;
              };
            };
          };
        }>;
        agent: { __typename?: "PublicAgentObject"; id: string };
        listing: { __typename?: "PublicListingObject"; id: string };
      }
    | undefined;
};

export type PublicListingDocumentTypesQueryVariables = Exact<{
  input: PublicListingDocumentTypesInput;
}>;

export type PublicListingDocumentTypesQuery = {
  __typename?: "Query";
  publicListingDocumentTypes: Array<{
    __typename?: "PublicListingDocumentTypeObject";
    id: string;
    slug: string;
    usState: UsState;
    name: string;
    formName: string;
    type: ListingDocumentTypeEnum;
  }>;
};

export type PublicListingDocumentUploadsQueryVariables = Exact<{
  input: PublicListingDocumentUploadsInput;
}>;

export type PublicListingDocumentUploadsQuery = {
  __typename?: "Query";
  publicListingDocumentUploads?:
    | Array<{
        __typename?: "PublicListingDocumentUploadObject";
        id: string;
        customDocumentName?: string | undefined;
        customDocumentType?: ListingDocumentTypeEnum | undefined;
        listingDocumentType?:
          | {
              __typename?: "PublicListingDocumentTypeObject";
              id: string;
              slug: string;
              usState: UsState;
              name: string;
              formName: string;
              type: ListingDocumentTypeEnum;
              document?:
                | {
                    __typename?: "PublicDocumentObject";
                    id: string;
                    form: string;
                    name: string;
                    description: string;
                    activeDocumentVersion?:
                      | {
                          __typename?: "PublicDocumentVersionObject";
                          id: string;
                          mappingKeys: Array<string>;
                          previewImages: Array<{
                            __typename?: "AssetFileObject";
                            id: string;
                            ordering: number;
                            file: { __typename?: "FileObject"; url: string };
                          }>;
                        }
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
        file?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
      }>
    | undefined;
};

export type PublicPreferencesQueryVariables = Exact<{
  input: PublicPreferencesInput;
}>;

export type PublicPreferencesQuery = {
  __typename?: "Query";
  publicPreferences: Array<{
    __typename?: "PublicPreferenceObject";
    id: string;
    name: string;
    slug: string;
    usStates: Array<UsState>;
    valueType: PreferenceValueType;
  }>;
};

export type PublicAgentUserListingsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: Scalars["Int"]["input"];
  orderBy?: Scalars["String"]["input"];
  input: PublicAgentUserListingsInput;
}>;

export type PublicAgentUserListingsQuery = {
  __typename?: "Query";
  publicAgentUserListings?:
    | {
        __typename?: "PublicListingObjectAgentUserListingsPaginated";
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              totalCount: number;
              hasNextPage: boolean;
              hasPrevPage: boolean;
              nextCursor?: string | undefined;
              prevCursor?: string | undefined;
            }
          | undefined;
        results?:
          | Array<{
              __typename?: "PublicListingObject";
              id: string;
              listDate?: any | undefined;
              offersCountDisplay: string;
              isPremium: boolean;
              status: MlsListingStatus;
              deletedFromRetsFeedAt?: string | undefined;
              property: {
                __typename?: "PublicPropertyObject";
                id: string;
                slug: string;
              };
              mlsListing?:
                | {
                    __typename?: "MLSListingObject";
                    id: string;
                    mlsId?: number | undefined;
                    listingId?: string | undefined;
                    listDate?: string | undefined;
                    listPrice?: number | undefined;
                    originalListPrice?: number | undefined;
                    terms?: string | undefined;
                    photos: Array<string>;
                    remarks?: string | undefined;
                    modified?: string | undefined;
                    mlsName?: string | undefined;
                    deleted_at?: string | undefined;
                    addressFull: string;
                    agent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    coAgent?:
                      | {
                          __typename?: "MLSListingAgentObject";
                          id?: string | undefined;
                          mlsId?: string | undefined;
                          firstName?: string | undefined;
                          lastName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    address: {
                      __typename?: "MLSListingAddressObject";
                      city: string;
                      country?: string | undefined;
                      crossStreet?: string | undefined;
                      full: string;
                      postalCode?: string | undefined;
                      state: string;
                      streetName: string;
                      streetNumber?: number | undefined;
                      streetNumberText: string;
                      unit?: string | undefined;
                    };
                    property?:
                      | {
                          __typename?: "MLSListingPropertyObject";
                          roof?: string | undefined;
                          cooling?: string | undefined;
                          style?: string | undefined;
                          area?: number | undefined;
                          bathsFull?: number | undefined;
                          bathsHalf?: number | undefined;
                          stories?: number | undefined;
                          fireplaces?: number | undefined;
                          flooring?: string | undefined;
                          heating?: string | undefined;
                          bathrooms?: string | undefined;
                          foundation?: string | undefined;
                          poolFeatures?: string | undefined;
                          laundryFeatures?: string | undefined;
                          occupantName?: string | undefined;
                          ownerName?: string | undefined;
                          lotDescription?: string | undefined;
                          acres?: number | undefined;
                          subType?: string | undefined;
                          bedrooms?: number | undefined;
                          interiorFeatures?: string | undefined;
                          lotSize?: string | undefined;
                          areaSource?: string | undefined;
                          maintenanceExpense?: number | undefined;
                          additionalRooms?: string | undefined;
                          exteriorFeatures?: string | undefined;
                          water?: string | undefined;
                          view?: string | undefined;
                          lotSizeArea?: number | undefined;
                          lotSizeAreaUnits?: string | undefined;
                          subdivision?: string | undefined;
                          construction?: string | undefined;
                          type?: MlsListingType | undefined;
                          garageSpaces?: number | undefined;
                          bathsThreeQuarter?: number | undefined;
                          accessibility?: string | undefined;
                          occupantType?: string | undefined;
                          yearBuilt?: number | undefined;
                          subTypeText?: string | undefined;
                        }
                      | undefined;
                    office?:
                      | {
                          __typename?: "MLSListingOfficeObject";
                          brokerid?: string | undefined;
                          name?: string | undefined;
                          servingName?: string | undefined;
                          contact?:
                            | {
                                __typename?: "MLSListingContactObject";
                                email?: string | undefined;
                                office?: string | undefined;
                                cell?: string | undefined;
                              }
                            | undefined;
                        }
                      | undefined;
                    mls?:
                      | {
                          __typename?: "MLSListingMLSObject";
                          statusText: string;
                          status?: MlsListingStatus | undefined;
                          daysOnMarket?: number | undefined;
                          originalEntryTimestamp?: string | undefined;
                          originatingSystemName?: string | undefined;
                          logoUrl?: string | undefined;
                          disclaimer?: string | undefined;
                        }
                      | undefined;
                    association?:
                      | {
                          __typename?: "MLSListingAssociationObject";
                          fee?: number | undefined;
                          frequency?: string | undefined;
                          name?: string | undefined;
                          amenities?: string | undefined;
                        }
                      | undefined;
                    compliance?:
                      | {
                          __typename?: "MLSListingComplianceObject";
                          buyerAgencyCompensation?: number | undefined;
                          buyerAgencyCompensationType?: string | undefined;
                          subAgencyCompensation?: number | undefined;
                          subAgencyCompensationType?: string | undefined;
                          attributionContact?: string | undefined;
                        }
                      | undefined;
                    sales?:
                      | {
                          __typename?: "MLSListingSalesObject";
                          closeDate?: string | undefined;
                          closePrice?: number | undefined;
                          contractDate?: string | undefined;
                        }
                      | undefined;
                    geo: {
                      __typename?: "MLSListingGeoObject";
                      location: {
                        __typename?: "GeoPointObject";
                        lat: number;
                        lon: number;
                      };
                    };
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type PublicUserWithLicensesQueryVariables = Exact<{
  input: GetUserInput;
}>;

export type PublicUserWithLicensesQuery = {
  __typename?: "Query";
  getPublicUserWithLicenses?:
    | {
        __typename?: "PublicUserWithLicensesObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        phoneNumber: string;
        email?: string | undefined;
        profileBio?: string | undefined;
        hasListings?: boolean | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        licenses?:
          | Array<{
              __typename?: "UserLicenseObject";
              id: string;
              licenseType: LicenseType;
              licenseNumber: string;
              mls?:
                | {
                    __typename?: "MLSObject";
                    id: string;
                    name: string;
                    originatingSystemName?: string | undefined;
                  }
                | undefined;
            }>
          | undefined;
      }
    | undefined;
};

export type SearchMlsListingsByAddressQueryVariables = Exact<{
  input: SearchMlsListingsByAddressInput;
}>;

export type SearchMlsListingsByAddressQuery = {
  __typename?: "Query";
  searchMlsListingsByAddress: Array<{
    __typename?: "MLSListingObject";
    id: string;
    mlsId?: number | undefined;
    listingId?: string | undefined;
    listDate?: string | undefined;
    listPrice?: number | undefined;
    originalListPrice?: number | undefined;
    terms?: string | undefined;
    photos: Array<string>;
    remarks?: string | undefined;
    modified?: string | undefined;
    mlsName?: string | undefined;
    deleted_at?: string | undefined;
    addressFull: string;
    agent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    coAgent?:
      | {
          __typename?: "MLSListingAgentObject";
          id?: string | undefined;
          mlsId?: string | undefined;
          firstName?: string | undefined;
          lastName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    address: {
      __typename?: "MLSListingAddressObject";
      city: string;
      country?: string | undefined;
      crossStreet?: string | undefined;
      full: string;
      postalCode?: string | undefined;
      state: string;
      streetName: string;
      streetNumber?: number | undefined;
      streetNumberText: string;
      unit?: string | undefined;
    };
    property?:
      | {
          __typename?: "MLSListingPropertyObject";
          roof?: string | undefined;
          cooling?: string | undefined;
          style?: string | undefined;
          area?: number | undefined;
          bathsFull?: number | undefined;
          bathsHalf?: number | undefined;
          stories?: number | undefined;
          fireplaces?: number | undefined;
          flooring?: string | undefined;
          heating?: string | undefined;
          bathrooms?: string | undefined;
          foundation?: string | undefined;
          poolFeatures?: string | undefined;
          laundryFeatures?: string | undefined;
          occupantName?: string | undefined;
          ownerName?: string | undefined;
          lotDescription?: string | undefined;
          acres?: number | undefined;
          subType?: string | undefined;
          bedrooms?: number | undefined;
          interiorFeatures?: string | undefined;
          lotSize?: string | undefined;
          areaSource?: string | undefined;
          maintenanceExpense?: number | undefined;
          additionalRooms?: string | undefined;
          exteriorFeatures?: string | undefined;
          water?: string | undefined;
          view?: string | undefined;
          lotSizeArea?: number | undefined;
          lotSizeAreaUnits?: string | undefined;
          subdivision?: string | undefined;
          construction?: string | undefined;
          type?: MlsListingType | undefined;
          garageSpaces?: number | undefined;
          bathsThreeQuarter?: number | undefined;
          accessibility?: string | undefined;
          occupantType?: string | undefined;
          yearBuilt?: number | undefined;
          subTypeText?: string | undefined;
        }
      | undefined;
    office?:
      | {
          __typename?: "MLSListingOfficeObject";
          brokerid?: string | undefined;
          name?: string | undefined;
          servingName?: string | undefined;
          contact?:
            | {
                __typename?: "MLSListingContactObject";
                email?: string | undefined;
                office?: string | undefined;
                cell?: string | undefined;
              }
            | undefined;
        }
      | undefined;
    mls?:
      | {
          __typename?: "MLSListingMLSObject";
          statusText: string;
          status?: MlsListingStatus | undefined;
          daysOnMarket?: number | undefined;
          originalEntryTimestamp?: string | undefined;
          originatingSystemName?: string | undefined;
          logoUrl?: string | undefined;
          disclaimer?: string | undefined;
        }
      | undefined;
    association?:
      | {
          __typename?: "MLSListingAssociationObject";
          fee?: number | undefined;
          frequency?: string | undefined;
          name?: string | undefined;
          amenities?: string | undefined;
        }
      | undefined;
    compliance?:
      | {
          __typename?: "MLSListingComplianceObject";
          buyerAgencyCompensation?: number | undefined;
          buyerAgencyCompensationType?: string | undefined;
          subAgencyCompensation?: number | undefined;
          subAgencyCompensationType?: string | undefined;
          attributionContact?: string | undefined;
        }
      | undefined;
    sales?:
      | {
          __typename?: "MLSListingSalesObject";
          closeDate?: string | undefined;
          closePrice?: number | undefined;
          contractDate?: string | undefined;
        }
      | undefined;
    geo: {
      __typename?: "MLSListingGeoObject";
      location: { __typename?: "GeoPointObject"; lat: number; lon: number };
    };
  }>;
};

export type SearchMlsListingsWithFiltersQueryVariables = Exact<{
  input: SearchMlsListingsWithFiltersInput;
}>;

export type SearchMlsListingsWithFiltersQuery = {
  __typename?: "Query";
  searchMlsListingsWithFilters: {
    __typename?: "SearchMLSListingsWithFiltersPayload";
    totalCount: number;
    mlsListings: Array<{
      __typename?: "MLSListingWithListingPayload";
      mlsListing: {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        listDate?: string | undefined;
        listPrice?: number | undefined;
        originalListPrice?: number | undefined;
        terms?: string | undefined;
        photos: Array<string>;
        remarks?: string | undefined;
        modified?: string | undefined;
        mlsName?: string | undefined;
        deleted_at?: string | undefined;
        addressFull: string;
        address: {
          __typename?: "MLSListingAddressObject";
          city: string;
          country?: string | undefined;
          crossStreet?: string | undefined;
          full: string;
          postalCode?: string | undefined;
          state: string;
          streetName: string;
          streetNumber?: number | undefined;
          streetNumberText: string;
          unit?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              roof?: string | undefined;
              cooling?: string | undefined;
              style?: string | undefined;
              area?: number | undefined;
              bathsFull?: number | undefined;
              bathsHalf?: number | undefined;
              stories?: number | undefined;
              fireplaces?: number | undefined;
              flooring?: string | undefined;
              heating?: string | undefined;
              bathrooms?: string | undefined;
              foundation?: string | undefined;
              poolFeatures?: string | undefined;
              laundryFeatures?: string | undefined;
              occupantName?: string | undefined;
              ownerName?: string | undefined;
              lotDescription?: string | undefined;
              acres?: number | undefined;
              subType?: string | undefined;
              bedrooms?: number | undefined;
              interiorFeatures?: string | undefined;
              lotSize?: string | undefined;
              areaSource?: string | undefined;
              maintenanceExpense?: number | undefined;
              additionalRooms?: string | undefined;
              exteriorFeatures?: string | undefined;
              water?: string | undefined;
              view?: string | undefined;
              lotSizeArea?: number | undefined;
              lotSizeAreaUnits?: string | undefined;
              subdivision?: string | undefined;
              construction?: string | undefined;
              type?: MlsListingType | undefined;
              garageSpaces?: number | undefined;
              bathsThreeQuarter?: number | undefined;
              accessibility?: string | undefined;
              occupantType?: string | undefined;
              yearBuilt?: number | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
        office?:
          | {
              __typename?: "MLSListingOfficeObject";
              brokerid?: string | undefined;
              name?: string | undefined;
              servingName?: string | undefined;
              contact?:
                | {
                    __typename?: "MLSListingContactObject";
                    email?: string | undefined;
                    office?: string | undefined;
                    cell?: string | undefined;
                  }
                | undefined;
            }
          | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              statusText: string;
              status?: MlsListingStatus | undefined;
              daysOnMarket?: number | undefined;
              originalEntryTimestamp?: string | undefined;
              originatingSystemName?: string | undefined;
              logoUrl?: string | undefined;
              disclaimer?: string | undefined;
            }
          | undefined;
        association?:
          | {
              __typename?: "MLSListingAssociationObject";
              fee?: number | undefined;
              frequency?: string | undefined;
              name?: string | undefined;
              amenities?: string | undefined;
            }
          | undefined;
        compliance?:
          | {
              __typename?: "MLSListingComplianceObject";
              buyerAgencyCompensation?: number | undefined;
              buyerAgencyCompensationType?: string | undefined;
              subAgencyCompensation?: number | undefined;
              subAgencyCompensationType?: string | undefined;
              attributionContact?: string | undefined;
            }
          | undefined;
        sales?:
          | {
              __typename?: "MLSListingSalesObject";
              closeDate?: string | undefined;
              closePrice?: number | undefined;
              contractDate?: string | undefined;
            }
          | undefined;
        geo: {
          __typename?: "MLSListingGeoObject";
          location: { __typename?: "GeoPointObject"; lat: number; lon: number };
        };
      };
      listing?:
        | {
            __typename?: "PublicListingObject";
            id: string;
            offersCountDisplay: string;
            listDate?: any | undefined;
            isPremium: boolean;
            status: MlsListingStatus;
            deletedFromRetsFeedAt?: string | undefined;
            property: {
              __typename?: "PublicPropertyObject";
              id: string;
              slug: string;
            };
            listingAgent?:
              | {
                  __typename?: "PublicAgentObject";
                  user?:
                    | { __typename?: "PublicUserObject"; id: string }
                    | undefined;
                }
              | undefined;
            coListingAgent?:
              | {
                  __typename?: "PublicAgentObject";
                  user?:
                    | { __typename?: "PublicUserObject"; id: string }
                    | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
  };
};

export type ListingForSearchMlsListingFragment = {
  __typename?: "PublicListingObject";
  id: string;
  offersCountDisplay: string;
  listDate?: any | undefined;
  isPremium: boolean;
  status: MlsListingStatus;
  deletedFromRetsFeedAt?: string | undefined;
  property: { __typename?: "PublicPropertyObject"; id: string; slug: string };
  listingAgent?:
    | {
        __typename?: "PublicAgentObject";
        user?: { __typename?: "PublicUserObject"; id: string } | undefined;
      }
    | undefined;
  coListingAgent?:
    | {
        __typename?: "PublicAgentObject";
        user?: { __typename?: "PublicUserObject"; id: string } | undefined;
      }
    | undefined;
};

export type StorefrontActivitiesQueryVariables = Exact<{
  input: StorefrontActivitiesInput;
}>;

export type StorefrontActivitiesQuery = {
  __typename?: "Query";
  storefrontActivities: Array<{
    __typename?: "ActivityObject";
    id: string;
    type: ActivityType;
    metadata: Record<
      string,
      | string
      | number
      | boolean
      | string[]
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined
    >;
    createdAt: any;
    user?:
      | {
          __typename?: "PublicUserObject";
          id: string;
          firstName: string;
          lastName: string;
          fullName: string;
          userName?: string | undefined;
          phoneNumber: string;
          email?: string | undefined;
          offerCollectionEmail?: string | undefined;
          profilePicture?:
            | { __typename?: "FileObject"; fileName: string; url: string }
            | undefined;
        }
      | undefined;
  }>;
};

export type StorefrontActivitiesSummaryQueryVariables = Exact<{
  input: StorefrontActivitiesSummaryInput;
}>;

export type StorefrontActivitiesSummaryQuery = {
  __typename?: "Query";
  storefrontActivitiesSummary: Array<{
    __typename?: "StorefrontActivitySummaryObject";
    count: number;
    activityType: ActivityType;
    users: Array<{
      __typename?: "UserObject";
      id: string;
      firstName: string;
      lastName: string;
      fullName: string;
      userName?: string | undefined;
      phoneNumber: string;
      roles: Array<Roles>;
      email?: string | undefined;
      profileBio?: string | undefined;
      offerCollectionEmail?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
      settings?:
        | {
            __typename?: "UserSettingsObject";
            id: string;
            selectedOrganization?:
              | {
                  __typename?: "OrganizationObject";
                  id: string;
                  name: string;
                  hasDescendants?: boolean | undefined;
                  contractSystemCredentials?:
                    | Array<{
                        __typename?: "ContractSystemCredentialsObject";
                        id: string;
                        hasInvalidCredentials?: boolean | undefined;
                        isReady: boolean;
                        type?: ContractSystemType | undefined;
                        username?: string | undefined;
                        dotloopProfileId?: string | undefined;
                        dotloopTeamName?: string | undefined;
                      }>
                    | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
    activities: Array<{
      __typename?: "ActivityObject";
      id: string;
      type: ActivityType;
      createdAt: any;
      user?: { __typename?: "PublicUserObject"; id: string } | undefined;
    }>;
  }>;
};

export type StorefrontDocViewsSummaryQueryVariables = Exact<{
  input: StorefrontActivitySummaryInput;
}>;

export type StorefrontDocViewsSummaryQuery = {
  __typename?: "Query";
  storefrontActivitySummary: {
    __typename?: "StorefrontActivitySummaryObject";
    count: number;
    users: Array<{
      __typename?: "UserObject";
      id: string;
      firstName: string;
      lastName: string;
      fullName: string;
      userName?: string | undefined;
      phoneNumber: string;
      roles: Array<Roles>;
      email?: string | undefined;
      profileBio?: string | undefined;
      offerCollectionEmail?: string | undefined;
      profilePicture?:
        | { __typename?: "FileObject"; fileName: string; url: string }
        | undefined;
      settings?:
        | {
            __typename?: "UserSettingsObject";
            id: string;
            selectedOrganization?:
              | {
                  __typename?: "OrganizationObject";
                  id: string;
                  name: string;
                  hasDescendants?: boolean | undefined;
                  contractSystemCredentials?:
                    | Array<{
                        __typename?: "ContractSystemCredentialsObject";
                        id: string;
                        hasInvalidCredentials?: boolean | undefined;
                        isReady: boolean;
                        type?: ContractSystemType | undefined;
                        username?: string | undefined;
                        dotloopProfileId?: string | undefined;
                        dotloopTeamName?: string | undefined;
                      }>
                    | undefined;
                }
              | undefined;
          }
        | undefined;
    }>;
    activities: Array<{
      __typename?: "ActivityObject";
      id: string;
      type: ActivityType;
      createdAt: any;
      user?: { __typename?: "PublicUserObject"; id: string } | undefined;
    }>;
  };
};

export type GuestbookSignersQueryVariables = Exact<{
  input: ListingInput;
}>;

export type GuestbookSignersQuery = {
  __typename?: "Query";
  guestbookSigners: {
    __typename?: "GuestbookSignersObject";
    signers: Array<{
      __typename?: "GuestbookSignerObject";
      signedAt: any;
      isSubscribed: boolean;
      openHouseId?: string | undefined;
      isWorkingWithAgent?: boolean | undefined;
      user: {
        __typename?: "UserObject";
        id: string;
        firstName: string;
        lastName: string;
        fullName: string;
        userName?: string | undefined;
        phoneNumber: string;
        roles: Array<Roles>;
        email?: string | undefined;
        profileBio?: string | undefined;
        offerCollectionEmail?: string | undefined;
        profilePicture?:
          | { __typename?: "FileObject"; fileName: string; url: string }
          | undefined;
        settings?:
          | {
              __typename?: "UserSettingsObject";
              id: string;
              selectedOrganization?:
                | {
                    __typename?: "OrganizationObject";
                    id: string;
                    name: string;
                    hasDescendants?: boolean | undefined;
                    contractSystemCredentials?:
                      | Array<{
                          __typename?: "ContractSystemCredentialsObject";
                          id: string;
                          hasInvalidCredentials?: boolean | undefined;
                          isReady: boolean;
                          type?: ContractSystemType | undefined;
                          username?: string | undefined;
                          dotloopProfileId?: string | undefined;
                          dotloopTeamName?: string | undefined;
                        }>
                      | undefined;
                  }
                | undefined;
            }
          | undefined;
      };
      office?:
        | {
            __typename?: "RESOOfficeObject";
            OfficeName?: string | undefined;
            OfficeEmail?: string | undefined;
            OfficeKey?: string | undefined;
            OfficeMlsId?: string | undefined;
            OfficeStatus?: string | undefined;
            OriginatingSystemName?: string | undefined;
          }
        | undefined;
    }>;
  };
};

export type TransactionNotificationLogQueryVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type TransactionNotificationLogQuery = {
  __typename?: "Query";
  transactionNotificationLog: {
    __typename?: "TransactionNotificationLogObject";
    id: string;
    title: string;
    messageContent: string;
    scheduledAt?: any | undefined;
    sentAt?: any | undefined;
    createdAt: any;
    notificationTemplate?:
      | {
          __typename?: "NotificationTemplateObject";
          id: string;
          title: string;
          eventType: TransactionStageType;
          side?: TransactionSide | undefined;
          notificationType: NotificationType;
          recipients: Array<ContactType>;
          hasAssignedPartner?: boolean | undefined;
          delayMinutes: number;
          dataToShare: Array<string>;
          messageContent: string;
          status: NotificationTemplateStatus;
          orderIndex: number;
          createdAt: any;
          updatedAt: any;
          messageContentTemplates: {
            __typename?: "NotificationTemplateMessageContentTemplates";
            html: string;
            text: string;
          };
        }
      | undefined;
    recipients: Array<{
      __typename?: "ContactObject";
      id: string;
      firstName: string;
      lastName: string;
      contactType: ContactType;
      email: string;
      phoneNumber?: string | undefined;
    }>;
    rawRecipients?:
      | Array<{
          __typename?: "NotificationUserObject";
          id: string;
          fullName: string;
          email?: string | undefined;
          phoneNumber?: string | undefined;
          contactType?: ContactType | undefined;
        }>
      | undefined;
  };
};

export type TransactionNotificationLogsQueryVariables = Exact<{
  organizationId: Scalars["ID"]["input"];
  cursor?: InputMaybe<Scalars["String"]["input"]>;
  orderBy?: InputMaybe<Scalars["String"]["input"]>;
  perPage?: InputMaybe<Scalars["Int"]["input"]>;
  filters?: InputMaybe<NotificationLogFilters>;
}>;

export type TransactionNotificationLogsQuery = {
  __typename?: "Query";
  transactionNotificationLogs?:
    | {
        __typename?: "TransactionNotificationLogObjectPaginated";
        results?:
          | Array<{
              __typename?: "TransactionNotificationLogObject";
              id: string;
              title: string;
              messageContent: string;
              scheduledAt?: any | undefined;
              sentAt?: any | undefined;
              createdAt: any;
              notificationTemplate?:
                | {
                    __typename?: "NotificationTemplateObject";
                    id: string;
                    title: string;
                    eventType: TransactionStageType;
                    side?: TransactionSide | undefined;
                    notificationType: NotificationType;
                    recipients: Array<ContactType>;
                    hasAssignedPartner?: boolean | undefined;
                    delayMinutes: number;
                    dataToShare: Array<string>;
                    messageContent: string;
                    status: NotificationTemplateStatus;
                    orderIndex: number;
                    createdAt: any;
                    updatedAt: any;
                    messageContentTemplates: {
                      __typename?: "NotificationTemplateMessageContentTemplates";
                      html: string;
                      text: string;
                    };
                  }
                | undefined;
              recipients: Array<{
                __typename?: "ContactObject";
                id: string;
                firstName: string;
                lastName: string;
                contactType: ContactType;
                email: string;
                phoneNumber?: string | undefined;
              }>;
              rawRecipients?:
                | Array<{
                    __typename?: "NotificationUserObject";
                    id: string;
                    fullName: string;
                    email?: string | undefined;
                    phoneNumber?: string | undefined;
                    contactType?: ContactType | undefined;
                  }>
                | undefined;
            }>
          | undefined;
        pageInfo?:
          | {
              __typename?: "PageInfoObject";
              hasNextPage: boolean;
              hasPrevPage: boolean;
              perPage: number;
              totalCount: number;
              prevCursor?: string | undefined;
              nextCursor?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type ZipCodesGeoQueryVariables = Exact<{
  filters: ZipCodesGeoFilters;
}>;

export type ZipCodesGeoQuery = {
  __typename?: "Query";
  zipCodesGeo: Array<{
    __typename?: "ZipCodesGeoObject";
    zip_code: string;
    city: string;
    county_names: Array<string>;
    geo_shape: Array<Array<Array<Array<number>>>>;
  }>;
};

export type IngestionFolderPropertyFragment = {
  __typename?: "DocumentPropertyObject";
  id: string;
  slug: string;
  streetAddress: string;
  unit?: string | undefined;
  city: string;
  state: UsState;
  zipCode: string;
  zipCodePlus4?: string | undefined;
  county: string;
  countyFips: string;
  msa?: string | undefined;
  lot: string;
  block: string;
  platBook: string;
  platBookPage: string;
  subdivision: string;
  parcelId: string;
  yearBuilt?: number | undefined;
  otherLegalDescription: string;
  geo?:
    | { __typename?: "DocumentGeoObject"; lat: number; lng: number }
    | undefined;
};

export type IngestionFolderAutofillDataFragment = {
  __typename?: "OfferIngestionAutofillObject";
  ingestion: {
    __typename?: "OfferIngestionFolderObject";
    transactionSide: TransactionSide;
    metadata: {
      __typename?: "OfferIngestionMetadataObject";
      agent_name?: string | undefined;
      folder_name?: string | undefined;
      folder_id?: string | undefined;
      office_id?: string | undefined;
      office_name?: string | undefined;
      transaction_closing_date?: string | undefined;
      participants: {
        __typename?: "OfferIngestionParticipantsObject";
        buyerAgentNames?: Array<string> | undefined;
        listingAgentNames?: Array<string> | undefined;
        buyerNames?: Array<string> | undefined;
        sellerNames?: Array<string> | undefined;
        otherTeamMemberNames?: Array<string> | undefined;
      };
    };
  };
};

export type IngestionDocumentValidationFragment = {
  __typename?: "IngestionDocumentValidationObject";
  id: string;
  isCurrent: boolean;
  version: string;
  errorCount: number;
  warningCount: number;
  aiErrorCount: number;
  aiWarningCount: number;
  validationResults: Array<
    Record<string, string | number | boolean | string[] | undefined>
  >;
  aiValidationResults: Array<
    Record<string, string | number | boolean | string[] | undefined>
  >;
  aiAnalysis: Array<
    Record<string, string | number | boolean | string[] | undefined>
  >;
  createdAt: any;
  updatedAt: any;
  transactionStage?:
    | {
        __typename?: "TransactionStageObject";
        id: string;
        stage: TransactionStageType;
      }
    | undefined;
  ingestionDocument: { __typename?: "IngestionDocumentObject"; id: string };
};

export type IngestionFolderValidationFragment = {
  __typename?: "IngestionFolderValidationObject";
  id: string;
  isCurrent: boolean;
  version: string;
  errorCount: number;
  validationResults?:
    | Array<Record<string, string | number | boolean | string[] | undefined>>
    | undefined;
  createdAt: any;
  validatedAt: any;
  updatedAt: any;
  ingestionFolder?:
    | { __typename?: "IngestionFolderObject"; id: string }
    | undefined;
};

export type KeyTermFieldFragment = {
  __typename?: "KeyTermField";
  fieldLabel: string;
  fieldType: string;
  key: string;
  isEditable: boolean;
  value?: any | undefined;
  fieldFormat?:
    | {
        __typename?: "InputFormatObject";
        type: InputFormatType;
        options: {
          __typename?: "InputFormatOptionsObject";
          precision?: number | undefined;
          formatString?: string | undefined;
          currencySymbol?: string | undefined;
        };
      }
    | undefined;
  values: Array<{
    __typename?: "KeyTermValue";
    value?: any | undefined;
    timestamp: any;
    source: KeyTermSourceType;
    sourceLabel: string;
    validationError?: string | undefined;
    isCurrent: boolean;
    metadata?:
      | {
          __typename?: "KeyTermCalculatedMetadata";
          ingestionDocumentId: string;
          contractDocumentId: string;
        }
      | {
          __typename?: "KeyTermUserOverrideMetadata";
          overriddenBy: {
            __typename?: "PublicUserObject";
            id: string;
            email?: string | undefined;
            firstName: string;
            lastName: string;
          };
        }
      | undefined;
  }>;
};

export type KeyTermChildSectionFragment = {
  __typename?: "KeyTermSection";
  title: string;
  description: string;
  fields: Array<{
    __typename?: "KeyTermField";
    fieldLabel: string;
    fieldType: string;
    key: string;
    isEditable: boolean;
    value?: any | undefined;
    fieldFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    values: Array<{
      __typename?: "KeyTermValue";
      value?: any | undefined;
      timestamp: any;
      source: KeyTermSourceType;
      sourceLabel: string;
      validationError?: string | undefined;
      isCurrent: boolean;
      metadata?:
        | {
            __typename?: "KeyTermCalculatedMetadata";
            ingestionDocumentId: string;
            contractDocumentId: string;
          }
        | {
            __typename?: "KeyTermUserOverrideMetadata";
            overriddenBy: {
              __typename?: "PublicUserObject";
              id: string;
              email?: string | undefined;
              firstName: string;
              lastName: string;
            };
          }
        | undefined;
    }>;
  }>;
};

export type KeyTermsSectionFragment = {
  __typename?: "KeyTermSection";
  title: string;
  description: string;
  fields: Array<{
    __typename?: "KeyTermField";
    fieldLabel: string;
    fieldType: string;
    key: string;
    isEditable: boolean;
    value?: any | undefined;
    fieldFormat?:
      | {
          __typename?: "InputFormatObject";
          type: InputFormatType;
          options: {
            __typename?: "InputFormatOptionsObject";
            precision?: number | undefined;
            formatString?: string | undefined;
            currencySymbol?: string | undefined;
          };
        }
      | undefined;
    values: Array<{
      __typename?: "KeyTermValue";
      value?: any | undefined;
      timestamp: any;
      source: KeyTermSourceType;
      sourceLabel: string;
      validationError?: string | undefined;
      isCurrent: boolean;
      metadata?:
        | {
            __typename?: "KeyTermCalculatedMetadata";
            ingestionDocumentId: string;
            contractDocumentId: string;
          }
        | {
            __typename?: "KeyTermUserOverrideMetadata";
            overriddenBy: {
              __typename?: "PublicUserObject";
              id: string;
              email?: string | undefined;
              firstName: string;
              lastName: string;
            };
          }
        | undefined;
    }>;
  }>;
  children?:
    | Array<{
        __typename?: "KeyTermSection";
        title: string;
        description: string;
        fields: Array<{
          __typename?: "KeyTermField";
          fieldLabel: string;
          fieldType: string;
          key: string;
          isEditable: boolean;
          value?: any | undefined;
          fieldFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          values: Array<{
            __typename?: "KeyTermValue";
            value?: any | undefined;
            timestamp: any;
            source: KeyTermSourceType;
            sourceLabel: string;
            validationError?: string | undefined;
            isCurrent: boolean;
            metadata?:
              | {
                  __typename?: "KeyTermCalculatedMetadata";
                  ingestionDocumentId: string;
                  contractDocumentId: string;
                }
              | {
                  __typename?: "KeyTermUserOverrideMetadata";
                  overriddenBy: {
                    __typename?: "PublicUserObject";
                    id: string;
                    email?: string | undefined;
                    firstName: string;
                    lastName: string;
                  };
                }
              | undefined;
          }>;
        }>;
      }>
    | undefined;
};

export type ExternalValidationReportDataFragment = {
  __typename?: "ValidationReportDataObject";
  keyTerms?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  documentValidations: Array<{
    __typename?: "IngestionDocumentValidationObject";
    id: string;
    isCurrent: boolean;
    version: string;
    errorCount: number;
    warningCount: number;
    aiErrorCount: number;
    aiWarningCount: number;
    validationResults: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    aiValidationResults: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    aiAnalysis: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    createdAt: any;
    updatedAt: any;
    transactionStage?:
      | {
          __typename?: "TransactionStageObject";
          id: string;
          stage: TransactionStageType;
        }
      | undefined;
    ingestionDocument: { __typename?: "IngestionDocumentObject"; id: string };
  }>;
  folderValidation?:
    | {
        __typename?: "IngestionFolderValidationObject";
        id: string;
        isCurrent: boolean;
        version: string;
        errorCount: number;
        validationResults?:
          | Array<
              Record<string, string | number | boolean | string[] | undefined>
            >
          | undefined;
        createdAt: any;
        validatedAt: any;
        updatedAt: any;
        ingestionFolder?:
          | { __typename?: "IngestionFolderObject"; id: string }
          | undefined;
      }
    | undefined;
  property?:
    | {
        __typename?: "DocumentPropertyObject";
        id: string;
        slug: string;
        streetAddress: string;
        unit?: string | undefined;
        city: string;
        state: UsState;
        zipCode: string;
        zipCodePlus4?: string | undefined;
        county: string;
        countyFips: string;
        msa?: string | undefined;
        lot: string;
        block: string;
        platBook: string;
        platBookPage: string;
        subdivision: string;
        parcelId: string;
        yearBuilt?: number | undefined;
        otherLegalDescription: string;
        geo?:
          | { __typename?: "DocumentGeoObject"; lat: number; lng: number }
          | undefined;
      }
    | undefined;
  autofillData?:
    | {
        __typename?: "OfferIngestionAutofillObject";
        ingestion: {
          __typename?: "OfferIngestionFolderObject";
          transactionSide: TransactionSide;
          metadata: {
            __typename?: "OfferIngestionMetadataObject";
            agent_name?: string | undefined;
            folder_name?: string | undefined;
            folder_id?: string | undefined;
            office_id?: string | undefined;
            office_name?: string | undefined;
            transaction_closing_date?: string | undefined;
            participants: {
              __typename?: "OfferIngestionParticipantsObject";
              buyerAgentNames?: Array<string> | undefined;
              listingAgentNames?: Array<string> | undefined;
              buyerNames?: Array<string> | undefined;
              sellerNames?: Array<string> | undefined;
              otherTeamMemberNames?: Array<string> | undefined;
            };
          };
        };
      }
    | undefined;
};

export type ExternalIngestionDocumentFragment = {
  __typename?: "IngestionDocumentObject";
  id: string;
  documentId: string;
  documentName: string;
  documentCreatedAt: any;
  documentUpdatedAt: any;
  fileUrl?: string | undefined;
  isBlank: boolean;
  needsReview?: boolean | undefined;
  isArchived: boolean;
  isClassified: boolean;
  version: string;
  complianceStatus?: string | undefined;
  complianceGroupId?: string | undefined;
  complianceStatusId?: string | undefined;
  folderName?: string | undefined;
  folderId?: string | undefined;
  wasAutoApproved: boolean;
  contractDocumentPages?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    order: number;
    documentCategory?: string | undefined;
    externalDocumentName?: string | undefined;
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          document: {
            __typename?: "DocumentObject";
            id: string;
            name: string;
            form: string;
            documentType: DocumentType;
          };
        }
      | undefined;
    file: { __typename?: "FileObject"; url: string };
  }>;
};

export type ExternalIngestionFolderMlsListingFragment = {
  __typename?: "MLSListingObject";
  id: string;
  mlsId?: number | undefined;
  listingId?: string | undefined;
  mls?:
    | {
        __typename?: "MLSListingMLSObject";
        originatingSystemName?: string | undefined;
        statusText: string;
        logoUrl?: string | undefined;
      }
    | undefined;
  address: {
    __typename?: "MLSListingAddressObject";
    full: string;
    unit?: string | undefined;
    city: string;
    state: string;
    postalCode?: string | undefined;
  };
  property?:
    | {
        __typename?: "MLSListingPropertyObject";
        type?: MlsListingType | undefined;
        subType?: string | undefined;
        subTypeText?: string | undefined;
      }
    | undefined;
};

export type AgentParticipantFragment = {
  __typename?: "AgentParticipant";
  email?: string | undefined;
  name: string;
  phoneNumber?: string | undefined;
  officeName?: string | undefined;
  officeId?: string | undefined;
  mlsAgentId?: string | undefined;
};

export type ClientParticipantFragment = {
  __typename?: "ClientParticipant";
  email?: string | undefined;
  name: string;
  phoneNumber?: string | undefined;
};

export type ParticipantsFragment = {
  __typename?: "Participants";
  buyers: Array<{
    __typename?: "ClientParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
  }>;
  sellers: Array<{
    __typename?: "ClientParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
  }>;
  buyersAgents: Array<{
    __typename?: "AgentParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    officeName?: string | undefined;
    officeId?: string | undefined;
    mlsAgentId?: string | undefined;
  }>;
  listingAgents: Array<{
    __typename?: "AgentParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
    officeName?: string | undefined;
    officeId?: string | undefined;
    mlsAgentId?: string | undefined;
  }>;
  transactionCoordinators: Array<{
    __typename?: "ClientParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
  }>;
  loanOfficers: Array<{
    __typename?: "ClientParticipant";
    email?: string | undefined;
    name: string;
    phoneNumber?: string | undefined;
  }>;
};

export type ExternalIngestionFolderFragment = {
  __typename?: "IngestionFolderObject";
  id: string;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  activeMlsListingId?: string | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  platform: IngestionPlatform;
  folderUpdatedAt?: any | undefined;
  normalizedFieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  validationErrorCount?: number | undefined;
  dotloopProfileId?: string | undefined;
  keyTerms?:
    | Array<{
        __typename?: "KeyTermSection";
        title: string;
        description: string;
        fields: Array<{
          __typename?: "KeyTermField";
          fieldLabel: string;
          fieldType: string;
          key: string;
          isEditable: boolean;
          value?: any | undefined;
          fieldFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          values: Array<{
            __typename?: "KeyTermValue";
            value?: any | undefined;
            timestamp: any;
            source: KeyTermSourceType;
            sourceLabel: string;
            validationError?: string | undefined;
            isCurrent: boolean;
            metadata?:
              | {
                  __typename?: "KeyTermCalculatedMetadata";
                  ingestionDocumentId: string;
                  contractDocumentId: string;
                }
              | {
                  __typename?: "KeyTermUserOverrideMetadata";
                  overriddenBy: {
                    __typename?: "PublicUserObject";
                    id: string;
                    email?: string | undefined;
                    firstName: string;
                    lastName: string;
                  };
                }
              | undefined;
          }>;
        }>;
        children?:
          | Array<{
              __typename?: "KeyTermSection";
              title: string;
              description: string;
              fields: Array<{
                __typename?: "KeyTermField";
                fieldLabel: string;
                fieldType: string;
                key: string;
                isEditable: boolean;
                value?: any | undefined;
                fieldFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                values: Array<{
                  __typename?: "KeyTermValue";
                  value?: any | undefined;
                  timestamp: any;
                  source: KeyTermSourceType;
                  sourceLabel: string;
                  validationError?: string | undefined;
                  isCurrent: boolean;
                  metadata?:
                    | {
                        __typename?: "KeyTermCalculatedMetadata";
                        ingestionDocumentId: string;
                        contractDocumentId: string;
                      }
                    | {
                        __typename?: "KeyTermUserOverrideMetadata";
                        overriddenBy: {
                          __typename?: "PublicUserObject";
                          id: string;
                          email?: string | undefined;
                          firstName: string;
                          lastName: string;
                        };
                      }
                    | undefined;
                }>;
              }>;
            }>
          | undefined;
      }>
    | undefined;
  participants?:
    | {
        __typename?: "Participants";
        buyers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        sellers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        buyersAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        listingAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        transactionCoordinators: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        loanOfficers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
      }
    | undefined;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        clientType: ClientType;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              originatingSystemName?: string | undefined;
              statusText: string;
              logoUrl?: string | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          full: string;
          unit?: string | undefined;
          city: string;
          state: string;
          postalCode?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              type?: MlsListingType | undefined;
              subType?: string | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type GetIngestionDocumentFragment = {
  __typename?: "IngestionDocumentObject";
  id: string;
  fields?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  fileUrl?: string | undefined;
  documentName: string;
  documentId: string;
  documentUpdatedAt: any;
  s3Bucket: string;
  s3Key: string;
  isArchived: boolean;
  isBlank: boolean;
  isClassified: boolean;
  needsReview?: boolean | undefined;
  version: string;
  complianceStatus?: string | undefined;
  complianceGroupId?: string | undefined;
  complianceStatusId?: string | undefined;
  folderName?: string | undefined;
  docPageErrorMessage?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    documentCategory?: string | undefined;
    file: { __typename?: "FileObject"; url: string; fileName: string };
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          documentVersionFields: Array<{
            __typename?: "DocumentVersionFieldObject";
            id: string;
            boundingBox: {
              __typename?: "BoundingBoxObject";
              top: number;
              left: number;
              bottom: number;
              right: number;
            };
            field: {
              __typename?: "FieldObject";
              id: string;
              label: string;
              mappingKey: string;
            };
          }>;
          document: {
            __typename?: "DocumentObject";
            id: string;
            documentType: DocumentType;
            documentCategory?: DocumentCategory | undefined;
            name: string;
            form: string;
          };
        }
      | undefined;
  }>;
};

export type InternalValidationReportDataFragment = {
  __typename?: "ValidationReportDataObject";
  keyTerms?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  documentValidations: Array<{
    __typename?: "IngestionDocumentValidationObject";
    id: string;
    isCurrent: boolean;
    version: string;
    errorCount: number;
    warningCount: number;
    aiErrorCount: number;
    aiWarningCount: number;
    validationResults: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    aiValidationResults: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    aiAnalysis: Array<
      Record<string, string | number | boolean | string[] | undefined>
    >;
    createdAt: any;
    updatedAt: any;
    transactionStage?:
      | {
          __typename?: "TransactionStageObject";
          id: string;
          stage: TransactionStageType;
        }
      | undefined;
    ingestionDocument: { __typename?: "IngestionDocumentObject"; id: string };
  }>;
  folderValidation?:
    | {
        __typename?: "IngestionFolderValidationObject";
        id: string;
        isCurrent: boolean;
        version: string;
        errorCount: number;
        validationResults?:
          | Array<
              Record<string, string | number | boolean | string[] | undefined>
            >
          | undefined;
        createdAt: any;
        validatedAt: any;
        updatedAt: any;
        ingestionFolder?:
          | { __typename?: "IngestionFolderObject"; id: string }
          | undefined;
      }
    | undefined;
  property?:
    | {
        __typename?: "DocumentPropertyObject";
        id: string;
        slug: string;
        streetAddress: string;
        unit?: string | undefined;
        city: string;
        state: UsState;
        zipCode: string;
        zipCodePlus4?: string | undefined;
        county: string;
        countyFips: string;
        msa?: string | undefined;
        lot: string;
        block: string;
        platBook: string;
        platBookPage: string;
        subdivision: string;
        parcelId: string;
        yearBuilt?: number | undefined;
        otherLegalDescription: string;
        geo?:
          | { __typename?: "DocumentGeoObject"; lat: number; lng: number }
          | undefined;
      }
    | undefined;
  autofillData?:
    | {
        __typename?: "OfferIngestionAutofillObject";
        ingestion: {
          __typename?: "OfferIngestionFolderObject";
          transactionSide: TransactionSide;
          metadata: {
            __typename?: "OfferIngestionMetadataObject";
            agent_name?: string | undefined;
            folder_name?: string | undefined;
            folder_id?: string | undefined;
            office_id?: string | undefined;
            office_name?: string | undefined;
            transaction_closing_date?: string | undefined;
            participants: {
              __typename?: "OfferIngestionParticipantsObject";
              buyerAgentNames?: Array<string> | undefined;
              listingAgentNames?: Array<string> | undefined;
              buyerNames?: Array<string> | undefined;
              sellerNames?: Array<string> | undefined;
              otherTeamMemberNames?: Array<string> | undefined;
            };
          };
        };
      }
    | undefined;
};

export type InternalIngestionDocumentFragment = {
  __typename?: "IngestionDocumentObject";
  id: string;
  documentId: string;
  documentName: string;
  documentCreatedAt: any;
  documentUpdatedAt: any;
  fileUrl?: string | undefined;
  isBlank: boolean;
  needsReview?: boolean | undefined;
  isArchived: boolean;
  isClassified: boolean;
  version: string;
  complianceStatus?: string | undefined;
  complianceGroupId?: string | undefined;
  complianceStatusId?: string | undefined;
  folderName?: string | undefined;
  folderId?: string | undefined;
  wasAutoApproved: boolean;
  contractDocumentPages?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    order: number;
    documentCategory?: string | undefined;
    externalDocumentName?: string | undefined;
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          document: {
            __typename?: "DocumentObject";
            id: string;
            name: string;
            form: string;
            documentType: DocumentType;
          };
        }
      | undefined;
    file: { __typename?: "FileObject"; url: string };
  }>;
};

export type InternalGetIngestionDocumentFragment = {
  __typename?: "IngestionDocumentObject";
  isValidDocumentMessageForExtraction?: string | undefined;
  id: string;
  fields?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  fileUrl?: string | undefined;
  documentName: string;
  documentId: string;
  documentUpdatedAt: any;
  s3Bucket: string;
  s3Key: string;
  isArchived: boolean;
  isBlank: boolean;
  isClassified: boolean;
  needsReview?: boolean | undefined;
  version: string;
  complianceStatus?: string | undefined;
  complianceGroupId?: string | undefined;
  complianceStatusId?: string | undefined;
  folderName?: string | undefined;
  docPageErrorMessage?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  documentML?:
    | {
        __typename?: "DocumentMLObject";
        id: string;
        documentClassification: Record<
          string,
          string | number | boolean | string[] | undefined
        >;
        updatedAt: any;
      }
    | undefined;
  contractDocuments: Array<{
    __typename?: "ContractDocumentObject";
    id: string;
    documentCategory?: string | undefined;
    ingestionFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    aiIngestionFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    interpretedFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    interpretedFieldValuesExplanation?: string | undefined;
    mergedFieldValues?:
      | Record<string, string | number | boolean | string[] | undefined>
      | undefined;
    file: { __typename?: "FileObject"; url: string; fileName: string };
    documentVersion?:
      | {
          __typename?: "DocumentVersionObject";
          id: string;
          status: DocumentVersionStatus;
          version: string;
          searchRegex?: string | undefined;
          document: {
            __typename?: "DocumentObject";
            id: string;
            documentType: DocumentType;
            documentCategory?: DocumentCategory | undefined;
            name: string;
            form: string;
            usState: UsState;
          };
          documentVersionFields: Array<{
            __typename?: "DocumentVersionFieldObject";
            id: string;
            boundingBox: {
              __typename?: "BoundingBoxObject";
              top: number;
              left: number;
              bottom: number;
              right: number;
            };
            field: {
              __typename?: "FieldObject";
              id: string;
              label: string;
              mappingKey: string;
              aiInterpret?: boolean | undefined;
              defaultRules?:
                | Array<{
                    __typename?: "RuleObject";
                    id: string;
                    message: string;
                    ruleType: RuleType;
                  }>
                | undefined;
            };
            rules: Array<{
              __typename?: "RuleObject";
              id: string;
              message: string;
              ruleType: RuleType;
            }>;
          }>;
        }
      | undefined;
  }>;
  complianceGroupMetadata?:
    | {
        __typename?: "ComplianceGroupMetadataObject";
        id?: string | undefined;
        name?: string | undefined;
        type?: string | undefined;
        active?: boolean | undefined;
        transactionStageType?: TransactionStageType | undefined;
      }
    | undefined;
  validationRoutingDebug?:
    | {
        __typename?: "IngestionDocumentValidationRoutingDebugObject";
        source: DocumentValidationStageSelectionSource;
        transactionStageType?: TransactionStageType | undefined;
        shouldIgnore: boolean;
        isFolderNameOverrideEnabled: boolean;
        matchedFolderNameKeywordMapping?:
          | {
              __typename?: "FolderNameValidationStageKeywordMappingObject";
              keyword: string;
              action: FolderNameValidationStageOverrideAction;
              transactionStageType?: TransactionStageType | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type InternalIngestionFolderFragment = {
  __typename?: "IngestionFolderObject";
  aiValidationErrorCount?: number | undefined;
  regularValidationErrorCount?: number | undefined;
  fullyReprocessedAt?: any | undefined;
  txPipelineMatchedBy?: TxPipelineMatchedBy | undefined;
  txPipelineUpdatedAt?: any | undefined;
  txPipelineNeedsInvestigationReason: TxPipelineNeedsInvestigationReason;
  id: string;
  organizationUuid: string;
  folderId: string;
  folderName: string;
  transactionSide: TransactionSide;
  status: string;
  normalizedStatus?: NormalizedTransactionStatus | undefined;
  stage?: TransactionStageType | undefined;
  activeMlsListingId?: string | undefined;
  metadata: Record<string, string | number | boolean | string[] | undefined>;
  platform: IngestionPlatform;
  folderUpdatedAt?: any | undefined;
  normalizedFieldValues?:
    | Record<string, string | number | boolean | string[] | undefined>
    | undefined;
  validationErrorCount?: number | undefined;
  dotloopProfileId?: string | undefined;
  transactionPipeline?:
    | {
        __typename?: "TransactionPipelineObject";
        id: string;
        clientType: ClientType;
        usState: UsState;
        transactionPropertyType: TransactionPropertyType;
        stages: Array<{
          __typename?: "TransactionStageObject";
          id: string;
          stage: TransactionStageType;
          sortOrder: number;
          validationRules?:
            | Array<{
                __typename?: "TransactionRuleObject";
                id: string;
                isRequiredDocument: boolean;
                targetDocument?:
                  | { __typename?: "DocumentObject"; id: string; form: string }
                  | undefined;
                rules: Array<{
                  __typename?: "RuleObject";
                  id: string;
                  ruleType: RuleType;
                }>;
                children: Array<{
                  __typename?: "TransactionRuleObject";
                  id: string;
                  isRequiredDocument: boolean;
                  targetDocument?:
                    | {
                        __typename?: "DocumentObject";
                        id: string;
                        form: string;
                      }
                    | undefined;
                  rules: Array<{
                    __typename?: "RuleObject";
                    id: string;
                    ruleType: RuleType;
                  }>;
                }>;
              }>
            | undefined;
        }>;
      }
    | undefined;
  txPipelineCandidates: Array<{
    __typename?: "TxPipelineCandidateObject";
    pipelineUuid: string;
    pipelineName?: string | undefined;
    clientType?: string | undefined;
    usState?: string | undefined;
    transactionPropertyType?: string | undefined;
    matchedBy: Array<TxPipelineMatchedBy>;
    ruleMatchFormula?: string | undefined;
  }>;
  keyTerms?:
    | Array<{
        __typename?: "KeyTermSection";
        title: string;
        description: string;
        fields: Array<{
          __typename?: "KeyTermField";
          fieldLabel: string;
          fieldType: string;
          key: string;
          isEditable: boolean;
          value?: any | undefined;
          fieldFormat?:
            | {
                __typename?: "InputFormatObject";
                type: InputFormatType;
                options: {
                  __typename?: "InputFormatOptionsObject";
                  precision?: number | undefined;
                  formatString?: string | undefined;
                  currencySymbol?: string | undefined;
                };
              }
            | undefined;
          values: Array<{
            __typename?: "KeyTermValue";
            value?: any | undefined;
            timestamp: any;
            source: KeyTermSourceType;
            sourceLabel: string;
            validationError?: string | undefined;
            isCurrent: boolean;
            metadata?:
              | {
                  __typename?: "KeyTermCalculatedMetadata";
                  ingestionDocumentId: string;
                  contractDocumentId: string;
                }
              | {
                  __typename?: "KeyTermUserOverrideMetadata";
                  overriddenBy: {
                    __typename?: "PublicUserObject";
                    id: string;
                    email?: string | undefined;
                    firstName: string;
                    lastName: string;
                  };
                }
              | undefined;
          }>;
        }>;
        children?:
          | Array<{
              __typename?: "KeyTermSection";
              title: string;
              description: string;
              fields: Array<{
                __typename?: "KeyTermField";
                fieldLabel: string;
                fieldType: string;
                key: string;
                isEditable: boolean;
                value?: any | undefined;
                fieldFormat?:
                  | {
                      __typename?: "InputFormatObject";
                      type: InputFormatType;
                      options: {
                        __typename?: "InputFormatOptionsObject";
                        precision?: number | undefined;
                        formatString?: string | undefined;
                        currencySymbol?: string | undefined;
                      };
                    }
                  | undefined;
                values: Array<{
                  __typename?: "KeyTermValue";
                  value?: any | undefined;
                  timestamp: any;
                  source: KeyTermSourceType;
                  sourceLabel: string;
                  validationError?: string | undefined;
                  isCurrent: boolean;
                  metadata?:
                    | {
                        __typename?: "KeyTermCalculatedMetadata";
                        ingestionDocumentId: string;
                        contractDocumentId: string;
                      }
                    | {
                        __typename?: "KeyTermUserOverrideMetadata";
                        overriddenBy: {
                          __typename?: "PublicUserObject";
                          id: string;
                          email?: string | undefined;
                          firstName: string;
                          lastName: string;
                        };
                      }
                    | undefined;
                }>;
              }>;
            }>
          | undefined;
      }>
    | undefined;
  participants?:
    | {
        __typename?: "Participants";
        buyers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        sellers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        buyersAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        listingAgents: Array<{
          __typename?: "AgentParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
          officeName?: string | undefined;
          officeId?: string | undefined;
          mlsAgentId?: string | undefined;
        }>;
        transactionCoordinators: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
        loanOfficers: Array<{
          __typename?: "ClientParticipant";
          email?: string | undefined;
          name: string;
          phoneNumber?: string | undefined;
        }>;
      }
    | undefined;
  mlsListing?:
    | {
        __typename?: "MLSListingObject";
        id: string;
        mlsId?: number | undefined;
        listingId?: string | undefined;
        mls?:
          | {
              __typename?: "MLSListingMLSObject";
              originatingSystemName?: string | undefined;
              statusText: string;
              logoUrl?: string | undefined;
            }
          | undefined;
        address: {
          __typename?: "MLSListingAddressObject";
          full: string;
          unit?: string | undefined;
          city: string;
          state: string;
          postalCode?: string | undefined;
        };
        property?:
          | {
              __typename?: "MLSListingPropertyObject";
              type?: MlsListingType | undefined;
              subType?: string | undefined;
              subTypeText?: string | undefined;
            }
          | undefined;
      }
    | undefined;
};

export type IngestionDocumentValidationErrorReviewFragment = {
  __typename?: "IngestionDocumentValidationErrorReviewObject";
  id: string;
  isHidden: boolean;
  isAddedByUser: boolean;
  message?: string | undefined;
  createdByUserUuid: string;
  updatedByUserUuid: string;
  createdAt: any;
  updatedAt: any;
  contractDocumentUuid?: string | undefined;
  ruleUuid?: string | undefined;
  pageNumber?: number | undefined;
  ingestionDocument?:
    | {
        __typename?: "IngestionDocumentObject";
        id: string;
        documentId: string;
        documentName: string;
      }
    | undefined;
  ingestionDocumentValidation?:
    | {
        __typename?: "IngestionDocumentValidationObject";
        id: string;
        version: string;
      }
    | undefined;
  submission?:
    | {
        __typename?: "ValidationReviewSubmissionObject";
        id: string;
        submittedAt: any;
        submittedByUserUuid: string;
      }
    | undefined;
  validationIssueGroup?:
    | {
        __typename?: "ValidationIssueGroupObject";
        id: string;
        kind: string;
        platform: string;
        normalizedStatus?: NormalizedTransactionStatus | undefined;
        ruleUuid?: string | undefined;
        primaryForm?: string | undefined;
        documentCategory?: string | undefined;
        documentForm?: string | undefined;
        documentName?: string | undefined;
        normalizedMessage: string;
        linearIssueId?: string | undefined;
        linearTicketUrl?: string | undefined;
        status: string;
        firstSeenAt: any;
        lastSeenAt: any;
        totalReviewCount: number;
        activeReviewCount: number;
        uniqueOrgCount: number;
        uniqueFolderCount: number;
        uniqueUserCount: number;
      }
    | undefined;
};

export type IngestionFolderValidationErrorReviewFragment = {
  __typename?: "IngestionFolderValidationErrorReviewObject";
  id: string;
  isHidden: boolean;
  isAddedByUser: boolean;
  message?: string | undefined;
  createdByUserUuid: string;
  updatedByUserUuid: string;
  createdAt: any;
  updatedAt: any;
  documentCategory?: string | undefined;
  documentForm?: string | undefined;
  documentName?: string | undefined;
  ruleUuid?: string | undefined;
  ingestionFolderValidation?:
    | {
        __typename?: "IngestionFolderValidationObject";
        id: string;
        version: string;
      }
    | undefined;
  submission?:
    | {
        __typename?: "ValidationReviewSubmissionObject";
        id: string;
        submittedAt: any;
        submittedByUserUuid: string;
      }
    | undefined;
  validationIssueGroup?:
    | {
        __typename?: "ValidationIssueGroupObject";
        id: string;
        kind: string;
        platform: string;
        normalizedStatus?: NormalizedTransactionStatus | undefined;
        ruleUuid?: string | undefined;
        primaryForm?: string | undefined;
        documentCategory?: string | undefined;
        documentForm?: string | undefined;
        documentName?: string | undefined;
        normalizedMessage: string;
        linearIssueId?: string | undefined;
        linearTicketUrl?: string | undefined;
        status: string;
        firstSeenAt: any;
        lastSeenAt: any;
        totalReviewCount: number;
        activeReviewCount: number;
        uniqueOrgCount: number;
        uniqueFolderCount: number;
        uniqueUserCount: number;
      }
    | undefined;
};

export type IngestionFolderValidationFeedbackFragment = {
  __typename?: "IngestionFolderValidationFeedbackObject";
  id: string;
  feedbackType: FeedbackType;
  source: FeedbackSource;
  comment?: string | undefined;
  createdByUserUuid: string;
  updatedByUserUuid: string;
  createdAt: any;
  updatedAt: any;
  ingestionFolderValidation?:
    | { __typename?: "IngestionFolderValidationObject"; id: string }
    | undefined;
};

export type IngestionDocumentValidationFeedbackFragment = {
  __typename?: "IngestionDocumentValidationFeedbackObject";
  id: string;
  feedbackType: FeedbackType;
  source: FeedbackSource;
  comment?: string | undefined;
  createdByUserUuid: string;
  updatedByUserUuid: string;
  createdAt: any;
  updatedAt: any;
  ruleUuid?: string | undefined;
  contractDocumentUuid?: string | undefined;
  ingestionDocumentValidation?:
    | { __typename?: "IngestionDocumentValidationObject"; id: string }
    | undefined;
};
